/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor for paging through collections. */
  ConnectionCursor: { input: string; output: string; }
  /** Date custom scalar type */
  Date: { input: unknown; output: unknown; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: Date; output: Date; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** HTML content scalar type. */
  HTML: { input: string; output: string; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: string; output: string; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: string; output: string; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: unknown; output: unknown; }
  /** Taxonomy report fact value scalar type */
  TaxonomyReportFactValue: { input: unknown; output: unknown; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

/** Access level of a Speeki admin inside the admin portal. SUPER_ADMIN is unrestricted; every other role reaches only the endpoints that name it. */
export type Admin_Role_Key =
  | 'CLIENTS_READ_ONLY'
  | 'SUPER_ADMIN';

/** Enumeration of assignable permissions. */
export type Assignable_Permission =
  | 'CARBON_LENS_MODULE_ACCESS'
  | 'CASES_ADMIN'
  | 'CASES_LIMITED_USER'
  | 'CASES_MODULE_ACCESS'
  | 'CASES_REGIONAL_USER'
  | 'CASES_USER'
  | 'DISCLOSURES'
  | 'DUE_DILIGENCE_MODULE_ACCESS'
  | 'ESG_MANAGE_ESG_TOPICS'
  | 'ESG_MANAGE_PROFILE_SETTINGS'
  | 'ESG_MODULE_ACCESS'
  | 'ESG_READ'
  | 'ESG_RISK_AREA_READ'
  | 'ESG_RISK_AREA_WRITE'
  | 'ESG_USE_PERM_MATRIX'
  | 'ESG_WRITE'
  | 'METRICS'
  | 'NICOLE_GPT_MODULE_ACCESS'
  | 'REPORTING'
  | 'SUPER_ADMIN'
  | 'SURVEYS'
  | 'TASKS_MANAGEMENT'
  | 'TENANT_EDIT_COMPANY_SETTINGS';

export type Audit_Entry_Kind =
  | 'COMMENT'
  | 'FINDING';

/** Event service context. */
export type Audit_Event_Service_Context =
  | 'COLLECT'
  | 'FRAMEWORKS'
  | 'PLATFORM'
  | 'PROGRAMME'
  | 'PULSE';

/** Status of the audited action. */
export type Audit_Event_Status =
  | 'FAILED'
  | 'SUCCESS';

/** Event category. */
export type Audit_Event_Type =
  | 'ESG_ANSWER_METRIC_LINKED'
  | 'ESG_ANSWER_METRIC_UNLINKED'
  | 'ESG_ANSWER_TASK_ADDED'
  | 'ESG_ANSWER_TASK_UPDATED'
  | 'ESG_ANSWER_UPDATED'
  | 'ESG_FILE_UPLOAD'
  | 'ESG_FRAMEWORK_AUDIT_AUDITOR_ADDED'
  | 'ESG_FRAMEWORK_AUDIT_AUDITOR_REMOVED'
  | 'ESG_FRAMEWORK_AUDIT_COMPLETED'
  | 'ESG_FRAMEWORK_AUDIT_ENTRY_CREATED'
  | 'ESG_FRAMEWORK_AUDIT_GAP_RUN_STARTED'
  | 'ESG_FRAMEWORK_AUDIT_GAP_SUGGESTION_ACCEPTED'
  | 'ESG_FRAMEWORK_AUDIT_GAP_SUGGESTION_DISMISSED'
  | 'ESG_FRAMEWORK_AUDIT_REQUESTED'
  | 'ESG_FRAMEWORK_AUDIT_WITHDRAWN'
  | 'ESG_QUESTION_FILE_ASSIGNED'
  | 'ESG_QUESTION_FILE_UNASSIGNED'
  | 'ESG_QUESTION_STATUS_CHANGE';

export type Audit_Finding_Type =
  | 'MAJOR_NC'
  | 'MINOR_NC'
  | 'NOTEWORTHY'
  | 'NO_FINDING'
  | 'OBSERVATION'
  | 'OPPORTUNITY';

/** Enumeration of allowed user relationships. */
export type Auth_User_Relationship =
  | 'ALL'
  | 'ANONYMOUS'
  | 'CUSTOMER'
  | 'EMPLOYEE'
  | 'EX_EMPLOYEE'
  | 'FAMILY'
  | 'INVESTOR'
  | 'OTHER'
  | 'SUPPLIER';

/** Type of user account used for signing in. */
export type Auth_User_Type =
  | 'AUDITOR'
  | 'EMPLOYEE'
  | 'TENANT_ADMIN';

/** The next step for a framework on the available-to-add rail: ask for it where a no-fee tier exists, or pick a paid plan where only paid tiers do. */
export type Available_To_Add_Action =
  | 'CHOOSE_PLAN'
  | 'REQUEST_NO_FEE';

/** Why a framework is on the available-to-add rail: it shares a catalogue family with something the tenant already runs, or it is Speeki's own standing pick. A statement of fact in every case - never a ranking or a recommendation, and never a claim about other customers. */
export type Available_To_Add_Reason =
  | 'PAIRS_WITH'
  | 'SPEEKI_PICK';

/** Input to add year. */
export type AddYearInput = {
  /** Flag indicating if year is active. */
  isActive: Scalars['Boolean']['input'];
  /** Year value. */
  year: Scalars['Int']['input'];
};

export type AdminContextTokens = {
  /** Refresh token, used for fetching session tokens. */
  refreshToken: Scalars['String']['output'];
  /** Session token, used for accessing graphql queries and mutations. */
  sessionToken: Scalars['String']['output'];
};

export type AdminMagicLinkLoginInput = {
  /** Sign-in token received in the email message */
  token: Scalars['String']['input'];
};

/** Represents pagination input for connection of admin tenant list. */
export type AdminTenantConnectionInput = {
  /** Tenant name filter input. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<AdminTenantDataSortInput>>;
};

export type AdminTenantData = {
  /**
   * Tenant's active status.
   * @deprecated use status on subscription
   */
  adminActiveStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Tenant's GraphQl API url. */
  apiUrl: Scalars['String']['output'];
  /** Tenant IBM Watson Assistant credentials. Null for admin roles that may view a client but not hold its integration keys. */
  assistantCredentials?: Maybe<AssistantCredentials>;
  /**
   * Tenant's cluster id.
   * @deprecated use region
   */
  clusterId: ClusterIds;
  /** Tenant's company code */
  code: Scalars['String']['output'];
  /** Tenant's country */
  country: TenantsCountry;
  /** Returns tenant's custom plan if it exists. */
  customPlan?: Maybe<SubscriptionPlan>;
  /** Array of tenant's eLine numbers. */
  elineNumbers: Array<ElineNumber>;
  forwardEarthCredentials?: Maybe<ForwardEarthCredentials>;
  /**
   * Number of tenant's licenses.
   * @deprecated use subscription
   */
  licensesCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Tenant's module settings.
   * @deprecated Deprecated - use plan settings.
   */
  modules: AdminTenantModuleSettings;
  /** Tenants's name. */
  name: Scalars['String']['output'];
  primaryContact: PrimaryContact;
  /** @deprecated user primary contact */
  primaryContactEmail?: Maybe<Scalars['String']['output']>;
  /** @deprecated user primary contact */
  primaryContactFirstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated user primary contact */
  primaryContactLastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated user primary contact */
  primaryContactName?: Maybe<Scalars['String']['output']>;
  region: ClusterIds;
  /** Tenant's reporting slug. */
  reportingSlug?: Maybe<Scalars['String']['output']>;
  /** Array of tenant's standards */
  standards: Array<EsgStandard>;
  /**
   * Status of this tenant
   * @deprecated use status on subscription
   */
  status: Tenant_Status;
  subscription: AdminTenantSubscription;
  /** Tenant's validity date */
  subscriptionExpire?: Maybe<Scalars['DateTime']['output']>;
  /** Tenant's license start date */
  subscriptionStart?: Maybe<Scalars['DateTime']['output']>;
  /** Uuid of user created within tenant */
  tenantAdminUuid?: Maybe<Scalars['String']['output']>;
  /** Tenant's UUID. */
  uuid: Scalars['ID']['output'];
};


export type AdminTenantDataElineNumbersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Represents AdminTenantDataConnection connection. */
export type AdminTenantDataConnection = {
  /** Array of edges. */
  edges: Array<AdminTenantDataEdge>;
  /** Array of direct nodes. */
  nodes: Array<AdminTenantData>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents AdminTenantData connection edge. */
export type AdminTenantDataEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AdminTenantData record. */
  node: AdminTenantData;
};

export type AdminTenantDataSortFields =
  | 'COUNTRY'
  | 'LIMITED_LICENSE_COUNT'
  | 'NAME'
  | 'PLAN'
  | 'STANDARD_LICENSE_COUNT'
  | 'STATUS'
  | 'SUBSCRIPTION_END_DATE';

export type AdminTenantDataSortInput = {
  direction: SortDirection;
  field: AdminTenantDataSortFields;
};

export type AdminTenantModuleSettings = {
  /** Flag indicating if given tenant has module carbon lens enabled. */
  moduleCarbonLensEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module cases enabled. */
  moduleCasesEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module demo enabled. */
  moduleDemoEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module disclosures enabled. */
  moduleDisclosuresEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module insights enabled. */
  moduleInsightsEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module nicole gpt enabled. */
  moduleNicoleGptEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module SSO enabled. */
  moduleSsoEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module surveys enabled. */
  moduleSurveysEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module tasks enabled. */
  moduleTasksEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module teams enabled. */
  moduleTeamsEnabled: Scalars['Boolean']['output'];
  /** Flag indicating if given tenant has module trainings enabled. */
  moduleTrainingsEnabled: Scalars['Boolean']['output'];
  subscriberEmail?: Maybe<Scalars['EmailAddress']['output']>;
  /** MS Teams tenant ID */
  teamsTenantId?: Maybe<Scalars['ID']['output']>;
  /** Returns tenant for given user. */
  tenant?: Maybe<AdminTenantData>;
  /** Edited tenant's uuid. */
  tenantUuid: Scalars['ID']['output'];
};

export type AdminTenantSubscription = {
  /** Whether the term renews by itself at its end. */
  autoRenew: Scalars['Boolean']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Date of inactive state change. Tenant will be removed after some time. */
  inactiveChangeDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated use standardLicenseCount */
  licenseCount: Scalars['Int']['output'];
  limitedLicenseCount: Scalars['Int']['output'];
  /** The live notice of non-renewal, if any. */
  nonRenewalNotice?: Maybe<TenantNonRenewalNotice>;
  plan?: Maybe<SubscriptionPlan>;
  /** Length in years of the next term when this one renews. */
  renewalTermYears?: Maybe<Scalars['Int']['output']>;
  standardLicenseCount: Scalars['Int']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
  status: Tenant_Status;
  subscriberEmail?: Maybe<Scalars['EmailAddress']['output']>;
  /** When the tenant was switched off automatically at its end date. */
  switchedOffAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date after which inactive tenant will be deleted. */
  toBeDeletedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminUserData = {
  email: Scalars['EmailAddress']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** What this admin may do in the portal. SUPER_ADMIN is unrestricted. */
  role: Admin_Role_Key;
  /** Status of user */
  status: User_Status_Key;
  uuid: Scalars['ID']['output'];
};

/** Represents AdminUserDataConnection connection. */
export type AdminUserDataConnection = {
  /** Array of edges. */
  edges: Array<AdminUserDataEdge>;
  /** Array of direct nodes. */
  nodes: Array<AdminUserData>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents AdminUserData connection edge. */
export type AdminUserDataEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AdminUserData record. */
  node: AdminUserData;
};

export type AdminUserDataSortFields =
  | 'EMAIL'
  | 'FIRST_NAME'
  | 'LAST_NAME'
  | 'NAME'
  | 'STATUS';

export type AdminUserDataSortInput = {
  direction: SortDirection;
  field: AdminUserDataSortFields;
};

/** Represents input for deleting speeki admins. WARNING: this action is destructive and not easily rolled back. */
export type AdminUserDeleteInput = {
  /** Deleted user email, used to verify delete. */
  email: Scalars['String']['input'];
  /** Deleted user UUID. */
  uuid: Scalars['ID']['input'];
};

/** Input for creating new admin user */
export type AdminUserUpsertInputArgs = {
  /** User email. Requried for creating new user. */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Admin user last name. */
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** User password. Required for creating new admin. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Access level in the portal. Omit to leave an existing admin's role as it is; new admins default to SUPER_ADMIN. */
  role?: InputMaybe<Admin_Role_Key>;
  /** User status. Active by default. */
  status?: InputMaybe<User_Status_Key>;
  /** Admin user uuid. Omit to create new user. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents pagination input for connection of admin tenant list. */
export type AdminUsersConnectionInput = {
  /** User multifield filter input. */
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<AdminUserDataSortInput>>;
};

export type AiReport = {
  /** The default audience for the report prompt template. */
  audience?: Maybe<ReportAudience>;
  /** Year to which the report applies */
  dateApplied: Scalars['String']['output'];
  /** File containing the generated report */
  file: InsightsFile;
  /** The AI report associated with the file */
  generatedBy?: Maybe<UserType>;
  /** Number of max words in the report */
  maxWordsLength: Scalars['Int']['output'];
  /** Prompt for the report */
  prompt: Scalars['String']['output'];
  /** Purpose of the report */
  purpose: Scalars['String']['output'];
  /** Name of the report */
  reportName: Scalars['String']['output'];
  /** Selected topics for the report context */
  topics: Array<AiReportTopic>;
  /** UUID of the generated report */
  uuid: Scalars['UUID']['output'];
};

export type AiReportGenerateInput = {
  /** Audience of the report */
  audienceId: Scalars['String']['input'];
  /** Year to which the report applies */
  dateApplied?: InputMaybe<Scalars['Int']['input']>;
  /** Number of max words in the report */
  maxWordsLength?: InputMaybe<Scalars['Int']['input']>;
  /** Default prompt for the report */
  prompt: Scalars['String']['input'];
  /** Purpose of the report */
  purpose: Scalars['String']['input'];
  /** The title of the report */
  reportName: Scalars['String']['input'];
  /** Topics for the report context */
  selectedTopics?: InputMaybe<Array<AiReportTopicInput>>;
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type AiReportTopic = {
  /** Topic name to be included in the report prompt */
  name: Scalars['String']['output'];
  /** UUID of the risk area */
  riskAreaUuid: Scalars['UUID']['output'];
};

export type AiReportTopicInput = {
  /** Topic name to be included in the report prompt */
  name: Scalars['String']['input'];
  /** UUID of the risk area */
  riskAreaUuid: Scalars['UUID']['input'];
};

/** An auditor in the AMS directory. */
export type AmsAuditor = {
  amsRole: AmsRole;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  lastSignInAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: AmsAuditorStatus;
  uuid: Scalars['UUID']['output'];
};

/** Directory lifecycle. */
export type AmsAuditorStatus =
  | 'ACTIVE'
  | 'INVITED'
  | 'SUSPENDED';

export type AmsInviteAuditorInput = {
  amsRole: AmsRole;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** What an AMS user may do. */
export type AmsRole =
  | 'AMS_ADMIN'
  | 'AMS_AUDITOR';

export type AmsSessionTokens = {
  /** Exchanges for a new pair until the 12-hour session cap. */
  refreshToken: Scalars['String']['output'];
  /** Short-lived token sent as the bearer on every AMS request. */
  sessionToken: Scalars['String']['output'];
};

export type AmsUpdateAuditorInput = {
  amsRole?: InputMaybe<AmsRole>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['UUID']['input'];
};

export type AnalyticsReportChartInput = {
  /** Chart image. Accepts jpg and png files */
  file: Scalars['Upload']['input'];
  /** Applied filters. Filters can be vary, so please provide a formatted string */
  filters?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportUploadInput = {
  /** Generates analytics report pdf */
  charts: Array<AnalyticsReportChartInput>;
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** Represents input for fetching answer for question by version data. */
export type AnswerForVersionInput = {
  /** Version tag UUID. If omitted will fetch default version. */
  versionTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Year UUID. If omitted will use current active year */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssetSettings = {
  /** Date of asset settings creation. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who created tenant assets. */
  createdBy?: Maybe<UserType>;
  /** Date of last asset settings update. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated tenant assets. */
  lastUpdatedBy?: Maybe<UserType>;
  /** Returns signed URL to custom Nicole image. */
  nicoleAvatarUrl?: Maybe<Scalars['URL']['output']>;
  /** Current Nicole assistant settings. */
  nicoleSetting: Nicole_Setting;
  /** Resolves parent tenant. */
  tenant: TenantBaseDataType;
  /** UUID of settings. */
  uuid: Scalars['ID']['output'];
};

export type AssistantCredentials = {
  /** IBM Watson authentication API key. */
  apiKey: Scalars['String']['output'];
  /** IBM Watson assistant identifier. */
  assistantId: Scalars['String']['output'];
  /** IBM Watson instance URL. */
  instanceUrl: Scalars['String']['output'];
  /** Tenant data for given assistant credentials. */
  tenant: AdminTenantData;
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['output'];
  /** Unique identifier of assistant credentials. */
  uuid: Scalars['ID']['output'];
  /** IBM Watson workspace unique identifier. */
  workspaceId?: Maybe<Scalars['String']['output']>;
  /** IBM Watson workspace name. */
  workspaceName?: Maybe<Scalars['String']['output']>;
};

/** Represents AssistantCredentialsConnection connection. */
export type AssistantCredentialsConnection = {
  /** Array of edges. */
  edges: Array<AssistantCredentialsEdge>;
  /** Array of direct nodes. */
  nodes: Array<AssistantCredentials>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of tenants assistant credentials. */
export type AssistantCredentialsConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<AssistantCredentialsSortInput>>;
};

/** Represents AssistantCredentials connection edge. */
export type AssistantCredentialsEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AssistantCredentials record. */
  node: AssistantCredentials;
};

export type AssistantCredentialsSortFields =
  | 'ASSISTANT_ID'
  | 'TENANT_CODE'
  | 'TENANT_NAME'
  | 'WORKSPACE_ID'
  | 'WORKSPACE_NAME';

export type AssistantCredentialsSortInput = {
  direction: SortDirection;
  field: AssistantCredentialsSortFields;
};

export type AssistantCredentialsUpdateInput = {
  /** IBM Watson authentication API key. */
  apiKey: Scalars['String']['input'];
  /** IBM Watson assistant identifier. */
  assistantId: Scalars['String']['input'];
  /** IBM Watson instance URL. */
  instanceUrl: Scalars['String']['input'];
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['input'];
  /** IBM Watson workspace unique identifier. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  /** IBM Watson workspace name. */
  workspaceName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the assistant slot. */
export type AssistantSlot = {
  /** Numeric identifier of specific slot action. Creates unique pair with `slotId`. */
  actionId: Scalars['ID']['output'];
  /** The type of slot's data. */
  dataType?: Maybe<SlotDataType>;
  /** Indicates whether slot is of legacy type. */
  isLegacy: Scalars['Boolean']['output'];
  /** The type of slot. */
  legacyType: Slot_Type;
  /** Numeric identifier of the slot's group. Creates unique pair with `actionId`. */
  slotId: Scalars['ID']['output'];
  /** Text of the slot action. */
  text: Scalars['String']['output'];
};

/** Represents AssistantSlotConnection connection. */
export type AssistantSlotConnection = {
  /** Array of edges. */
  edges: Array<AssistantSlotEdge>;
  /** Array of direct nodes. */
  nodes: Array<AssistantSlot>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of assistant slot. */
export type AssistantSlotConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<AssistantSlotSortInput>>;
};

/** Represents the input for creation of new assistant slot. */
export type AssistantSlotCreateInput = {
  /** Numeric identifier of specific slot action. Should create unique pair with `slotId`. */
  actionId: Scalars['ID']['input'];
  /** The type of slot's data. */
  dataType?: InputMaybe<SlotDataType>;
  /** Indicates whether slot is of legacy type. */
  isLegacy: Scalars['Boolean']['input'];
  /** The type of slot. */
  legacyType: Slot_Type;
  /** Numeric identifier of the slot's group. Should create unique pair with `actionId`. */
  slotId: Scalars['ID']['input'];
  /** Text of the slot action. */
  text: Scalars['String']['input'];
};

/** Represents the input for delete of existing assistant slot. */
export type AssistantSlotDeleteInput = {
  /** Numeric identifier of specific slot action to be deleted. Should create unique pair with `slotId`. */
  actionId: Scalars['ID']['input'];
  /** Numeric identifier of slot's group to be deleted. Should create unique pair with `actionId`. */
  slotId: Scalars['ID']['input'];
};

/** Represents AssistantSlot connection edge. */
export type AssistantSlotEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AssistantSlot record. */
  node: AssistantSlot;
};

/** Represents the identifiers of assistant slot. */
export type AssistantSlotIdentifiers = {
  /** Numeric identifier of specific slot action. Creates unique pair with `slotId`. */
  actionId: Scalars['ID']['output'];
  /** Numeric identifier of the slot's group. Creates unique pair with `actionId`. */
  slotId: Scalars['ID']['output'];
};

export type AssistantSlotSortFields =
  | 'ACTION_ID'
  | 'IS_LEGACY'
  | 'LEGACY_TYPE'
  | 'SLOT_ID'
  | 'TEXT';

export type AssistantSlotSortInput = {
  direction: SortDirection;
  field: AssistantSlotSortFields;
};

/** Represents the input for update of existing assistant slot. */
export type AssistantSlotUpdateInput = {
  /** Numeric identifier of specific slot action to be changed. Should create unique pair with `slotId`. */
  actionId: Scalars['ID']['input'];
  /** The type of slot's data. */
  dataType?: InputMaybe<SlotDataType>;
  /** Indicates whether slot is of legacy type. */
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of slot. */
  legacyType?: InputMaybe<Slot_Type>;
  /** Numeric identifier of slot's group to be changed. Should create unique pair with `actionId`. */
  slotId: Scalars['ID']['input'];
  /** Text of the slot action. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** A single audit trail record describing who did what, in which tenant context, and with optional before/after values. */
export type AuditEvent = {
  /** Related answer record, when the event is scoped to one. */
  answerUuid?: Maybe<Scalars['UUID']['output']>;
  /** Event service context. */
  context: Audit_Event_Service_Context;
  /** Human-readable label for the service context. */
  contextLabel?: Maybe<Scalars['String']['output']>;
  /** Row creation time in the audit database (set on insert). */
  createdAt: Scalars['DateTime']['output'];
  /** Free-text details summarizing the change or action. */
  detailsDescription?: Maybe<Scalars['String']['output']>;
  /** Related ESG answer. */
  esgAnswer?: Maybe<EsgAnswer>;
  /** Related ESG question. */
  esgQuestion?: Maybe<EsgQuestion>;
  /** Business timestamp when the audited action was logged (from the originating service). */
  loggedAt: Scalars['DateTime']['output'];
  /** Serialized state or payload after the change. */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Serialized state or payload before the change. */
  oldValue?: Maybe<Scalars['String']['output']>;
  /** Related programme. */
  programme?: Maybe<Program>;
  /** Related programme, when the event is scoped to one. */
  programmeUuid?: Maybe<Scalars['UUID']['output']>;
  /** Related questionnaire question, when the event is scoped to one. */
  questionUuid?: Maybe<Scalars['UUID']['output']>;
  /** Identifier of the resource that was acted on (when applicable). */
  resourceId?: Maybe<Scalars['String']['output']>;
  /** Type or class of the resource that was acted on (when applicable). */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Related risk area. */
  riskArea?: Maybe<RiskArea>;
  /** Related risk area, when the event is scoped to one. */
  riskAreaUuid?: Maybe<Scalars['UUID']['output']>;
  /** Status of the audited action. */
  status: Audit_Event_Status;
  /** Event category. */
  typeKey: Audit_Event_Type;
  /** Human-readable label for the event type. */
  typeLabel: Scalars['String']['output'];
  /** User who triggered the event. */
  user?: Maybe<UserType>;
  /** HTTP User-Agent string from the triggering request. */
  userAgent?: Maybe<Scalars['String']['output']>;
  /** Client IP observed for the request that triggered the event. */
  userIp?: Maybe<Scalars['String']['output']>;
  /** User who performed the action, when known. */
  userUuid?: Maybe<Scalars['String']['output']>;
  /** UUID for this audit event. */
  uuid: Scalars['ID']['output'];
  /** Related audit year. */
  year?: Maybe<Year>;
  /** Related audit year, when the event is scoped to one. */
  yearUuid?: Maybe<Scalars['UUID']['output']>;
};

/** Represents AuditEventConnection connection. */
export type AuditEventConnection = {
  /** Array of edges. */
  edges: Array<AuditEventEdge>;
  /** Array of direct nodes. */
  nodes: Array<AuditEvent>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input for paginating audit events. */
export type AuditEventConnectionInput = {
  /** Filter by service context. */
  context?: InputMaybe<Audit_Event_Service_Context>;
  /** Filter by end date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Filter by question uuid. */
  questionUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search input for audit events. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<AuditEventSortInput>>;
  /** Filter by start date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by status. */
  statuses?: InputMaybe<Array<Audit_Event_Status>>;
  /** Filter by type. */
  types?: InputMaybe<Array<Audit_Event_Type>>;
  /** Filter by user uuid. */
  userUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by year uuid. */
  yearUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents AuditEvent connection edge. */
export type AuditEventEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AuditEvent record. */
  node: AuditEvent;
};

export type AuditEventGetInput = {
  /** UUID of the audit event to get. */
  uuid: Scalars['UUID']['input'];
};

export type AuditEventSortFields =
  | 'DETAILS'
  | 'EVENT_TYPE'
  | 'IP_DEVICE'
  | 'RESOURCE'
  | 'STATUS'
  | 'TIMESTAMP'
  | 'USER';

export type AuditEventSortInput = {
  direction: SortDirection;
  field: AuditEventSortFields;
};

/** The buyer's answers for an Audit Ready price. */
export type AuditReadyPriceInput = {
  /** The certification products to assess; at least one. */
  standards: Array<Scalars['String']['input']>;
};

export type AuditRenewalBackfillResult = {
  /** Tenants changed (or that would be, on a dry run). */
  count: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  /** Listed uuids that were unknown or already not renewing. */
  skippedTenantUuids: Array<Scalars['ID']['output']>;
  tenants: Array<AuditRenewalBackfillTenant>;
};

export type AuditRenewalBackfillTenant = {
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Represents the settings of automatic deletion of case data N days after the case is closed. */
export type AutomaticDeletionSettings = {
  automaticDeletionAfterDays: Scalars['Int']['output'];
  /** Indicates whether current user can edit the setting. */
  canEdit: Scalars['Boolean']['output'];
  isActivityDeletionEnabled: Scalars['Boolean']['output'];
  isChatHistoryDeletionEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  isFilesDeletionEnabled: Scalars['Boolean']['output'];
  isParticipantDeletionEnabled: Scalars['Boolean']['output'];
};

export type AutomaticDeletionSettingsInput = {
  /** The number of days which have to pass from closing the case to automatically delete case data. */
  automaticDeletionAfterDays: Scalars['Int']['input'];
  isActivityDeletionEnabled: Scalars['Boolean']['input'];
  isChatHistoryDeletionEnabled: Scalars['Boolean']['input'];
  /** Indicates whether automatic case data deletion should be enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFilesDeletionEnabled: Scalars['Boolean']['input'];
  isParticipantDeletionEnabled: Scalars['Boolean']['input'];
};

/** One framework the caller's tenant does not hold yet, with the fact that put it on the rail. */
export type AvailableToAddSlot = {
  /** The next step for this framework, from the same entitlement ladder the catalogue card uses: REQUEST_NO_FEE where a no-fee tier exists, CHOOSE_PLAN where only paid tiers do. */
  action: Available_To_Add_Action;
  category: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The framework the tenant already runs that this one pairs with, named as the catalogue names it. Set only on a PAIRS_WITH slot; null on SPEEKI_PICK, which is not derived from the tenant's holdings. */
  pairsWithName?: Maybe<Scalars['String']['output']>;
  reason: Available_To_Add_Reason;
  riskAreaUuid: Scalars['ID']['output'];
};

export type AvgDaysToCloseByIncidentType = {
  /** Average days to close case for given incident type. */
  avgDaysToClose: Scalars['Int']['output'];
  incidentTypeName: Scalars['String']['output'];
};

export type AvgDaysToCloseByIncidentTypeInput = {
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type AvgDaysToCloseByTimeInterval = {
  /** Average days to close case for given time interval. */
  avgDaysToClose: Scalars['Int']['output'];
  /** Aggregation interval start time. */
  date: Scalars['DateTime']['output'];
};

export type AvgDaysToCloseByTimeIntervalInput = {
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Allows determine time interval used to group data. */
  interval?: InputMaybe<Time_Interval>;
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** Input type containing data required to authenticate with azure sso */
export type AzureSsoLoginInput = {
  /** Valid Azure IdToken */
  idToken: Scalars['String']['input'];
  /** Tenant uuid to determine for each tenant authenticate user */
  tenantUuid: Scalars['ID']['input'];
  /** User type to distinguish who should be authenticated */
  userType?: InputMaybe<SsoUserType>;
};

/** Which self-enrolment door a Basic Licence acceptance came through. There is deliberately no value for a Speeki-provisioned tier: that produces no acceptance at all. */
export type Basic_Licence_Acceptance_Source =
  | 'CHECKOUT'
  | 'DOWNGRADE_ELECTION';

/** Summary of a backfillFrameworkSmartFillEntitlements sweep: how many tenants were examined, how many received a grant, how many framework-scoped grants were emitted in total, and how many tenants failed (logged loudly, not fatal to the sweep). */
export type BackfillFrameworkSmartFillEntitlementsResult = {
  /** Tenants whose facts read or grant call threw. Logged loudly; the sweep continued past them rather than aborting. */
  failures: Scalars['Int']['output'];
  /** Total framework-scoped Smart Fill grants emitted across every tenant. */
  frameworksGranted: Scalars['Int']['output'];
  /** Tenants for which EVERY qualifying order group's grant succeeded. A tenant with a partial failure is not counted here even though frameworksGranted may include some of its frameworks - read failures alongside this, and re-run to converge. */
  tenantsGranted: Scalars['Int']['output'];
  /** Distinct tenants with at least one owned order, examined by the sweep. */
  tenantsSeen: Scalars['Int']['output'];
};

export type BannedEmail = {
  /** Date when banned email was added. */
  createdAt: Scalars['DateTime']['output'];
  /** User who added the email. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Banned email address. */
  email: Scalars['String']['output'];
  /** Flag that indicates if the email is active. Inactive emails are not taken into account during validation. */
  isActive: Scalars['Boolean']['output'];
  /** Date when banned email was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who last edited the email. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Banned email UUID. */
  uuid: Scalars['ID']['output'];
};

/** Represents BannedEmailConnection connection. */
export type BannedEmailConnection = {
  /** Array of edges. */
  edges: Array<BannedEmailEdge>;
  /** Array of direct nodes. */
  nodes: Array<BannedEmail>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of banned email domains */
export type BannedEmailConnectionInput = {
  /** Multifield filter input. */
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<BannedEmailSortInput>>;
};

/** Represents BannedEmail connection edge. */
export type BannedEmailEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BannedEmail record. */
  node: BannedEmail;
};

export type BannedEmailSortFields =
  | 'CREATED_AT'
  | 'EMAIL'
  | 'IS_ACTIVE'
  | 'UPDATED_AT';

export type BannedEmailSortInput = {
  direction: SortDirection;
  field: BannedEmailSortFields;
};

/** Represents input for changing state of email domains. */
export type BannedEmailStatusChangeBatchInput = {
  /** Batch input for changing status of email domains. UUIDs must be unique within array */
  batchInput: Array<BannedEmailStatusChangeInput>;
};

/** Represents input for changing state of email domain. */
export type BannedEmailStatusChangeInput = {
  /** Flag indicating should banned email domain be banned or not. */
  isEnabled: Scalars['Boolean']['input'];
  /** UUID of email domain to change. */
  uuid: Scalars['UUID']['input'];
};

/** Type representing banned email upsert arguments. */
export type BannedEmailUpsertInput = {
  /** Banned email domain. */
  email: Scalars['String']['input'];
  /** Flag indicating if upserted email should be set as actve. */
  isActive: Scalars['Boolean']['input'];
  /** Banned email UUID. Omit to create new entry. Will throw on duplicated email. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Evidence that a tenant accepted the Basic Licence click-through terms for a framework: who ticked the box, when, and which edition they were shown. Present only where the TENANT enrolled itself - a tier Speeki provisioned carries none, because nobody accepted anything. */
export type BasicLicenceAcceptance = {
  /** When the terms were accepted. */
  acceptedAt: Scalars['DateTime']['output'];
  /** The person who accepted, as a federated user reference - select name/firstName/lastName/email on it and the gateway resolves them from the service that owns users. Null only where the acceptance carried no authenticated principal. */
  acceptedBy?: Maybe<UserType>;
  /** A snapshot of the accepter's email, set only where the acceptance was taken WITHOUT an authenticated principal (a pre-account signup door) and the typed address was the sole identity in the request. Null for every authenticated acceptance - read acceptedBy instead, which the gateway resolves live from the owning service. */
  acceptedByEmail?: Maybe<Scalars['String']['output']>;
  /** A snapshot of the accepter's name, set on the same unauthenticated door as acceptedByEmail and null for every authenticated acceptance. Read acceptedBy instead. */
  acceptedByName?: Maybe<Scalars['String']['output']>;
  /** Which self-enrolment door the acceptance came through. */
  source: Basic_Licence_Acceptance_Source;
  /** The edition of the Basic Licence terms that was on screen, e.g. "2026-08" - frozen at acceptance, so a later edition never rewrites what was accepted. */
  termsEdition: Scalars['String']['output'];
};

/** The standing Speeki Engage Basic Licence click-through terms - the exact edition a tenant taking the Basic tier today accepts. Editions are immutable: a new edition is a new document, never an edit of an existing one. */
export type BasicLicenceTerms = {
  /** Edition identifier of the terms being served, e.g. "2026-08". This is the same value recorded against an acceptance, so what a tenant read stays traceable to what they accepted. */
  edition: Scalars['String']['output'];
  /** The edition's human-readable title, naming the document, for display above the text. */
  title: Scalars['String']['output'];
  /** The full terms as TRUSTED STATIC HTML, authored in this repository and served verbatim - it is never user-supplied content. It is already markup, so a client must embed it as HTML rather than HTML-escape it; that is safe for THIS field only, and the same path must never be reused for caller-supplied text. */
  trustedHtml: Scalars['String']['output'];
};

export type BeaconDomainRule = {
  feeUsd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** The accredited ISO certificate that earns a discount on this domain, if any. */
  isoCertificate?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** What Nicole and the auditor review. */
  reviews: Scalars['String']['output'];
};

/** The buyer's scope answers for a Beacon price quote. */
export type BeaconPriceInput = {
  /** Must complete inside about 3 weeks. */
  accelerated: Scalars['Boolean']['input'];
  /** "None" | "Limited" | "Reasonable". */
  carbonAssurance: Scalars['String']['input'];
  /** Domain ids, from beaconRules. */
  domains: Array<Scalars['String']['input']>;
  highRisk: Scalars['Boolean']['input'];
  interviews: Scalars['Int']['input'];
  /** Domains for which the target holds an accredited, current ISO certificate. */
  isoHeld: Array<Scalars['String']['input']>;
  /** Countries with material operations. */
  jurisdictions: Scalars['Int']['input'];
  /** "None" | "Limited" | "Reasonable". */
  sustainabilityAssurance: Scalars['String']['input'];
  /** The TARGET's headcount. */
  targetHeadcount: Scalars['Int']['input'];
};

export type BeaconRules = {
  assuranceOptions: Array<Scalars['String']['output']>;
  domains: Array<BeaconDomainRule>;
  includedJurisdictions: Scalars['Int']['output'];
  interviewFeeUsd: Scalars['String']['output'];
  maxDomains: Scalars['Int']['output'];
  maxHeadcount: Scalars['Int']['output'];
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

/** The billing identity recorded on the tenant's most recent order that carries one - the entity name, address, buyer country, registered-office facts and invoice recipient - so the next order's Contract step can prefill it instead of asking the buyer to re-type it. Null for a caller without the company-settings permission, and null for a tenant whose orders have never recorded one, which is the honest answer on a genuine first purchase. */
export type BillingIdentity = {
  /** Billing address printed on the invoice. */
  billingAddress?: Maybe<Scalars['String']['output']>;
  /** Billing entity legal name for the invoice contact. */
  billingEntityName?: Maybe<Scalars['String']['output']>;
  /** The ISO-2 country the order's billing identity was raised in, from the same order this identity is read from. Determines tax, so a caller prefilling from it must still show and allow changing it, never lock it silently. */
  buyerCountry: Scalars['String']['output'];
  /** Invoice recipient email - an empty string when the most recent identity-carrying order predates this field. */
  invoiceRecipientEmail: Scalars['String']['output'];
  /** Invoice recipient's first name. */
  invoiceRecipientFirstName?: Maybe<Scalars['String']['output']>;
  /** Invoice recipient's last name. */
  invoiceRecipientLastName?: Maybe<Scalars['String']['output']>;
  /** The customer's registered office address - separate from billingAddress, which is where the invoice goes. */
  registeredAddress?: Maybe<Scalars['String']['output']>;
  /** The company registration number (UEN, CRN, etc.). */
  registeredNumber?: Maybe<Scalars['String']['output']>;
};

/** Input to pass device UUID and signed message by frontend */
export type BiometricsLoginInput = {
  /** Device UUID generated by frontend to verify biometrics */
  deviceId: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
  /** Signed information generated by frontend to verify biometrics */
  signedMessage: Scalars['String']['input'];
  /** UUID of a user related to device */
  userUuid: Scalars['String']['input'];
};

/** Input to setup user biometrics. */
export type BiometricsSetupInput = {
  /** Device UUID generated by frontend to verify biometrics */
  deviceId: Scalars['String']['input'];
  pin: Scalars['String']['input'];
  /** Public key generated by device to verify signed messages. */
  publicKey: Scalars['String']['input'];
};

export type BusinessUnit = {
  /** Indicates whether business unit is active. */
  isActive: Scalars['Boolean']['output'];
  /** Name of business unit. */
  name: Scalars['String']['output'];
  /** Returns reporting group of business unit. Returns `NULL` when subsidiary site feature is disabled or when business unit is not assigned to any reporting group. */
  reportingGroup?: Maybe<ReportingGroup>;
  /** Unique identifier of business unit. */
  uuid: Scalars['ID']['output'];
};

/** Represents pagination connection of business units. */
export type BusinessUnitConnection = {
  /** Returns non paginated list of business units. */
  all: Array<BusinessUnit>;
  /** Array of edges. */
  edges: Array<BusinessUnitEdge>;
  /** Array of direct nodes. */
  nodes: Array<BusinessUnit>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of business units. */
export type BusinessUnitConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<BusinessUnitSortInput>>;
  /** Input for filtering only active or inactive business units. Available for tenant admins only. If omitted will return all units for tenant admin. True will return active only, false will return inactive. Webportal or mobile user will only receive active units.  */
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents BusinessUnit connection edge. */
export type BusinessUnitEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BusinessUnit record. */
  node: BusinessUnit;
};

export type BusinessUnitSortFields =
  | 'NAME';

export type BusinessUnitSortInput = {
  direction: SortDirection;
  field: BusinessUnitSortFields;
};

/** Represents enumeration of case internal permission. */
export type Cases_Internal_Permission =
  | 'CASE_ACTIVITY_ADD'
  | 'CASE_CLOSE'
  | 'CASE_EDIT'
  | 'CASE_EDIT_ORIGINAL_REPORT'
  | 'CASE_INDIVIDUAL_EMAIL'
  | 'CASE_PRINT'
  | 'CASE_REOPEN';

/** Represents enumeration of possible case access types. */
export type Case_Access_Type =
  | 'ADMIN'
  | 'CASE_OWNER'
  | 'REGIONAL_USER'
  | 'STAKEHOLDER';

/** Represents enumeration of case activity related fields labels. */
export type Case_Activity_Related_Field_Label =
  | 'COMPLETION_DATE'
  | 'SCHEDULED_DATE';

/** Represents enumeration of case file types. */
export type Case_File_Type =
  | 'CHAT'
  | 'CM'
  | 'ELINE'
  | 'REPORT'
  | 'UNKNOWN'
  | 'WEB_EFORM';

/** Represents enumeration of case investigator type. */
export type Case_Investigator_Type =
  | 'CASE_OWNER'
  | 'STAKEHOLDER';

/** Represents enumeration of case owner exclusion configuration statuses. */
export type Case_Owner_Exclusion_Configuration_Status =
  | 'ALL_CONFIGURED'
  | 'NOT_ALL_CONFIGURED'
  | 'NO_VALID_SITES';

/** Represents enumeration of possible case statuses. */
export type Case_Status =
  | 'ACTIVATED'
  | 'CLOSED'
  | 'INACTIVE'
  | 'NEW'
  | 'OPEN'
  | 'REOPEN';

/** How the tenant came to own a product: bought through the shop, or granted/included without a shop purchase. */
export type Catalogue_Owned_Source =
  | 'INCLUDED'
  | 'PURCHASED';

/** Represents the role of a chatbot (ie. USER, ASSISTANT) */
export type Chatbot_Role =
  | 'ASSISTANT'
  | 'USER';

/** Represents enumeration of country codes. */
export type Country_Code =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'ALL'
  | 'AM'
  | 'AN'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KV'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'XK'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

/** Represents enumeration of currency. */
export type Currency_Code =
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BRL'
  | 'BSD'
  | 'BWP'
  | 'BYN'
  | 'BZD'
  | 'CAD'
  | 'CHF'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'CRC'
  | 'CUP'
  | 'CZK'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EGP'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEL'
  | 'GGP'
  | 'GHS'
  | 'GIP'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'IMP'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JEP'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KPW'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LTL'
  | 'LVL'
  | 'MKD'
  | 'MNT'
  | 'MUR'
  | 'MXN'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIO'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'SVC'
  | 'SYP'
  | 'THB'
  | 'TND'
  | 'TRY'
  | 'TTD'
  | 'TVD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'USD'
  | 'UYU'
  | 'UZS'
  | 'VEF'
  | 'VND'
  | 'XCD'
  | 'YER'
  | 'ZAR'
  | 'ZMW'
  | 'ZWD'
  | 'ZWL';

/** Represents enumeration of notification channels of custom reminder. */
export type Custom_Reminder_Channel =
  | 'CASE_PAGE'
  | 'EMAIL';

/** Represents the case object. */
export type CallsCase = {
  assignedCaseType?: Maybe<CallsIncidentType>;
  /** Case code */
  caseCode: Scalars['String']['output'];
  /** Case code readable form */
  caseCodeReadable: Scalars['String']['output'];
  /** Case types readable string */
  caseTypes: Scalars['String']['output'];
  /** Case types amount */
  caseTypesCount: Scalars['Int']['output'];
  /** Case country. Based on incoming phone number */
  country?: Maybe<Scalars['String']['output']>;
  /** Case call language */
  language: Scalars['String']['output'];
  /** Case pin code */
  pinCode: Scalars['String']['output'];
  /** Case code readable form */
  pinCodeReadable: Scalars['String']['output'];
  /** Case recording URL */
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** Tenant code */
  tenantCode: Scalars['String']['output'];
  /** Transcription update date. Null if not updated yet */
  transcriptUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Transcription from recording */
  transcription?: Maybe<Scalars['String']['output']>;
  /** Twilio CallSid */
  twilioCallSid: Scalars['String']['output'];
  /** Case unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the input type required for case creation */
export type CallsCaseCreateInput = {
  /** Twilio CallSid */
  callSid: Scalars['String']['input'];
  /** Call language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Incoming phone number */
  phoneNumber: Scalars['String']['input'];
};

/** Represents the input type required for case update */
export type CallsCaseUpdateInput = {
  /** Call language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Selected case type */
  selectedCaseType?: InputMaybe<Scalars['Float']['input']>;
  /** User input transcription */
  transcription?: InputMaybe<Scalars['String']['input']>;
  /** Case uuid */
  uuid: Scalars['String']['input'];
};

/** Represents the incident type object. */
export type CallsIncidentType = {
  order?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** The buyer's scope answers for a Carbon Lens price quote. */
export type CarbonLensPriceInput = {
  /** "API-connected" | "Mixed" | "Document-sampling". */
  accessMethod: Scalars['String']['input'];
  /** "Limited" | "Reasonable". */
  assurance: Scalars['String']['input'];
  /** "Annual" | "Quarterly". */
  billing: Scalars['String']['input'];
  cat1: Scalars['Boolean']['input'];
  cat15: Scalars['Boolean']['input'];
  entities: Scalars['Int']['input'];
  /** "Single country" | "Multi-country" | "Global". */
  geography: Scalars['String']['input'];
  /** "None" | "2-year" | "3-year". */
  multiyear: Scalars['String']['input'];
  /** Default 0. */
  platforms: Scalars['Int']['input'];
  priorYear: Scalars['Boolean']['input'];
  rush: Scalars['Boolean']['input'];
  /** One of the four exact scope3 strings. */
  scope3: Scalars['String']['input'];
  /** Default 0. */
  scopeExpansionEntities: Scalars['Int']['input'];
};

/** Represents the case. */
export type Case = {
  /** The paginated connection of case activities. */
  activities?: Maybe<CaseActivityConnection>;
  /** Business unit of reported case. */
  businessUnit?: Maybe<BusinessUnit>;
  /** Human readable unique identifier. */
  caseId: Scalars['String']['output'];
  /** Secret key for chat messages encryption/decryption. */
  chatRoomSecret?: Maybe<Scalars['String']['output']>;
  /** City where case has been reported or related situation took place. */
  city?: Maybe<Scalars['String']['output']>;
  /** Case closing date. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Conclusion type. */
  conclusionType?: Maybe<ConclusionType>;
  /** Conversation with assistant */
  conversationMessages?: Maybe<Array<ConversationMessage>>;
  /** Country where incident occurred (Case Details section, editable). */
  country: Country_Code;
  /** Creation date. */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  createdByGuest: Scalars['Boolean']['output'];
  /** Damage currency. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Custom title. */
  customTitle?: Maybe<Scalars['String']['output']>;
  /** Damage cost. */
  damageCost?: Maybe<Scalars['Float']['output']>;
  /** Case duration */
  duration?: Maybe<Scalars['String']['output']>;
  /** Entity under which case report should be investigate. */
  entity?: Maybe<Investigation_Entity>;
  /** List of users excluded from case report investigation. */
  excludedUsers: Array<UserType>;
  /** Returns uploaded file. */
  file: PresignedCaseFile;
  /** The paginated connection of case files. */
  files: CaseFileConnection;
  /** Allows to generate firebase token for case accessed by TENANT_ADMIN. Valid for 1 hour. This token will only allow access to the case-related data for which it was issued. Available only for TENANT_ADMIN. */
  firebaseToken?: Maybe<Scalars['JWT']['output']>;
  /** Resolves flag indicating if cas has original report. */
  hasOriginalReport: Scalars['Boolean']['output'];
  /** The paginated connection of case history. */
  history?: Maybe<CaseHistoryConnection>;
  /** In case user permissions. */
  inCasePermissions?: Maybe<Array<Cases_Internal_Permission>>;
  /** Incident type of reported case. */
  incidentType?: Maybe<IncidentType>;
  /** Individuals involved of reported case. */
  individualsInvolved?: Maybe<Array<IndividualInvolved>>;
  investigators: CaseInvestigators;
  /** Indicates whether case is already submitted. */
  isSubmitted: Scalars['Boolean']['output'];
  /** Language with which case has been reported. */
  language: Language_Code;
  /** Location where case has been reported or related situation took place. */
  location?: Maybe<Scalars['String']['output']>;
  /** Case opening date. */
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pin code (related to `Guest` user type). */
  pinCode?: Maybe<Scalars['String']['output']>;
  possibleBusinessUnits: Array<BusinessUnit>;
  possibleInvestigators: CaseInvestigators;
  /** Relationship of reporting user in the time of report. */
  relationship: Scalars['String']['output'];
  /** Case reopening date. */
  reopenedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Country where case has been reported (original report section, readonly). */
  reportCountry: Country_Code;
  /** Reporting source. */
  reportSource?: Maybe<ReportingSource>;
  /** Resolves reporter details. Valid for webportal, mobile and eline cases. */
  reporter?: Maybe<CaseReporter>;
  /**
   * Reporting source name.
   * @deprecated Use nested reportSource object instead.
   */
  reportingSource?: Maybe<Scalars['String']['output']>;
  /** Severity factor of triage score. */
  severity: Scalars['Int']['output'];
  /** State where case has been reported or related situation took place. */
  state?: Maybe<States_Code>;
  /** Current case status. */
  status: Case_Status;
  /** Case submission date. */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Source subsidiary site. */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Case triage score. */
  triageScore: Scalars['Float']['output'];
  /** Last update date. */
  updatedAt: Scalars['DateTime']['output'];
  /** Urgency factor of triage score. */
  urgency: Scalars['Int']['output'];
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};


/** Represents the case. */
export type CaseActivitiesArgs = {
  input: CaseActivityConnectionInput;
};


/** Represents the case. */
export type CaseFileArgs = {
  uuid: Scalars['String']['input'];
};


/** Represents the case. */
export type CaseFilesArgs = {
  input: CaseFileConnectionInput;
};


/** Represents the case. */
export type CaseHistoryArgs = {
  input: CaseHistoryConnectionInput;
};

/** Represents the activity of case. */
export type CaseActivity = {
  /** The paginated connection of case activity files. */
  activityFiles: CaseFileConnection;
  /** Case activity type. */
  activityType?: Maybe<CaseActivitySettings>;
  /** A case that the case activity belongs to. */
  case: Case;
  /** An activity conclusion type. */
  conclusionType?: Maybe<ConclusionType>;
  /** Case activity creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** A user who created activity. */
  createdBy?: Maybe<UserType>;
  /** Case activity note. */
  note?: Maybe<Scalars['String']['output']>;
  /** Case activity related field. */
  relatedField?: Maybe<CaseActivityRelatedField>;
  /** Case activity title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of case activity */
  uuid: Scalars['String']['output'];
};


/** Represents the activity of case. */
export type CaseActivityActivityFilesArgs = {
  input: CaseFileConnectionInput;
};

/** Represents pagination input for connection of case activities. */
export type CaseActivityConnection = {
  /** Array of edges. */
  edges: Array<CaseActivityEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseActivity>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case activities. */
export type CaseActivityConnectionInput = {
  /** Represents optional text filter to limit the results. It allows filtering by title or note. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseActivitySortInput>>;
};

/** Input for creating case activity */
export type CaseActivityCreateInput = {
  /** Uuid of case activity settings related to new activity */
  activityTypeUuid: Scalars['String']['input'];
  /** Uuid of case related to new activity */
  caseUuid: Scalars['String']['input'];
  /** Optional completion date related to valid activity type */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional files upload related to new activity */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Optional note of case activity */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Optional scheduled date related to valid activity type */
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents CaseActivity connection edge. */
export type CaseActivityEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseActivity record. */
  node: CaseActivity;
};

export type CaseActivityRelatedField = {
  /** Case activity related field label */
  fieldLabel: Scalars['String']['output'];
  /** Case activity related field name */
  fieldName: Scalars['String']['output'];
  /** Case activity related field type */
  fieldType: Scalars['String']['output'];
  /** Case activity related field value */
  fieldValue?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseActivitySettings = {
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Case activity related field. */
  relatedField?: Maybe<CaseActivitySettingsRelatedField>;
  /**
   * Case activity related fields.
   * @deprecated Not useful at the moment, each activity type may have only one related field.
   */
  relatedFields?: Maybe<Array<CaseActivitySettingsRelatedField>>;
  uuid: Scalars['ID']['output'];
};

/** Represents input to batch upsert case activity settings. */
export type CaseActivitySettingsBatchUpsertInput = {
  /** An array of case activities. */
  caseActivitySettings: Array<CaseActivitySettingsUpsertInput>;
};

/** Represents pagination connection of case activity settings. */
export type CaseActivitySettingsConnection = {
  /** Array of edges. */
  edges: Array<CaseActivitySettingsEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseActivitySettings>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case activity settings. */
export type CaseActivitySettingsConnectionInput = {
  /** Represents optional text filter to limit the results. It allows filtering by name. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseActivitySettingsSortInput>>;
};

/** Represents CaseActivitySettings connection edge. */
export type CaseActivitySettingsEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseActivitySettings record. */
  node: CaseActivitySettings;
};

export type CaseActivitySettingsRelatedField = {
  fieldLabel: Scalars['String']['output'];
  fieldName: Case_Activity_Related_Field_Label;
  fieldType: Scalars['String']['output'];
};

export type CaseActivitySettingsSortFields =
  | 'NAME'
  | 'STATUS';

export type CaseActivitySettingsSortInput = {
  direction: SortDirection;
  field: CaseActivitySettingsSortFields;
};

/** Represents input to upsert case activity settings. */
export type CaseActivitySettingsUpsertInput = {
  /** Indicates whether case activity settings is enabled. */
  isActive: Scalars['Boolean']['input'];
  /** Name of the case activity settings. */
  name: Scalars['String']['input'];
  /** Unique identifier of case activity settings. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CaseActivitySortFields =
  | 'CREATED_AT'
  | 'TITLE';

export type CaseActivitySortInput = {
  direction: SortDirection;
  field: CaseActivitySortFields;
};

export type CaseAnalytics = {
  /** Aggregation of average days to close case by incident type. */
  avgDaysToCloseByIncidentType: Array<AvgDaysToCloseByIncidentType>;
  /** Aggregation of average days to close case by time interval. */
  avgDaysToCloseByTimeInterval: Array<AvgDaysToCloseByTimeInterval>;
  /** Aggregation of cases by country. */
  casesByCountry: Array<CaseByCountry>;
  /** Resolve aggregation for cases by report source */
  casesByReportSource: Array<CaseByReportSource>;
  /** Aggregation of cases by status in given period of time (interval) */
  casesByStatus: CaseByStatus;
  /** Aggregation of case statuses by incident type. */
  casesStatusByIncidentType: Array<CaseStatusByIncidentType>;
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['output'];
};


export type CaseAnalyticsAvgDaysToCloseByIncidentTypeArgs = {
  input?: InputMaybe<AvgDaysToCloseByIncidentTypeInput>;
};


export type CaseAnalyticsAvgDaysToCloseByTimeIntervalArgs = {
  input?: InputMaybe<AvgDaysToCloseByTimeIntervalInput>;
};


export type CaseAnalyticsCasesByCountryArgs = {
  input?: InputMaybe<CaseByCountryInput>;
};


export type CaseAnalyticsCasesByReportSourceArgs = {
  input?: InputMaybe<CaseByReportSourceInput>;
};


export type CaseAnalyticsCasesStatusByIncidentTypeArgs = {
  input?: InputMaybe<CaseStatusByIncidentTypeInput>;
};

/** Represents pagination connection of case anonymity settings. */
export type CaseAnonymityConnection = {
  /** Array of edges. */
  edges: Array<CountryAnonymityEdge>;
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Array of direct nodes. */
  nodes: Array<CountryAnonymity>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case anonymity settings. */
export type CaseAnonymityConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CountryAnonymitySortInput>>;
};

/** Represents the restrictions for given country regarding anonymity. */
export type CaseAnonymityRestrictions = {
  /** Country code. */
  country: Country_Code;
  /** Incident type restrictions. */
  restrictions: Array<IncidentAnonymityRestriction>;
};

/** Represents the input for anonymity settings deletions. */
export type CaseAnonymitySettingsDeleteInput = {
  /** Country codes. */
  countries: Array<Country_Code>;
};

export type CaseAssignment = {
  /** List of countries for which users will be assigned to case. */
  countries: Array<Country_Code>;
  /** List of incident types for which users will be assigned to case. */
  incidentTypes: Array<IncidentType>;
  /** List of regions for which users will be assigned to cases. `NULL` when case assignment rule belongs to subsidiary site. */
  regions?: Maybe<Array<Region>>;
  /** Subsidiary site of case assignment. `NULL` when subsidiary site module is disabled. */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** List of user whose will be assigned to case that match case assignment rule criteria. */
  users: Array<UserType>;
  uuid: Scalars['ID']['output'];
};

/** Represents CaseAssignmentConnection connection. */
export type CaseAssignmentConnection = {
  /** Array of edges. */
  edges: Array<CaseAssignmentEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseAssignment>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case assignments. */
export type CaseAssignmentConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseAssignmentSortInput>>;
};

/** Represents input to delete case assignments. */
export type CaseAssignmentDeleteInput = {
  /** Unique identifiers of case assigment. */
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents CaseAssignment connection edge. */
export type CaseAssignmentEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseAssignment record. */
  node: CaseAssignment;
};

/** Represents input to fetch unique case assignment. */
export type CaseAssignmentGetInput = {
  /** Unique identifier of case assignment. */
  uuid: Scalars['UUID']['input'];
};

export type CaseAssignmentSortFields =
  | 'CREATED_AT';

export type CaseAssignmentSortInput = {
  direction: SortDirection;
  field: CaseAssignmentSortFields;
};

/** Represents input to upsert case assignment. */
export type CaseAssignmentUpsertInput = {
  /** Unique identifier of country where user will be automatically assigned as a case owner. */
  countries: Array<Country_Code>;
  /** Unique identifier of incident type for which user will be automatically assigned as a case owner. */
  incidentTypeUuids: Array<Scalars['String']['input']>;
  /** Unique identifier of region where user will be automatically assigned as a case owner. This argument will be respected only for non subsidiary sites. */
  regionUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Unique identifier of subsidiary site. This option will be respected only when subsidiary sites feature is enabled. Provide `NULL` if you want to add case assignment rule to headquarters. */
  subsidiarySiteUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Unique identifier of user which will be assigned as case owner. */
  userUuids: Array<Scalars['UUID']['input']>;
  /** Unique identifier of case assigment to update. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for updating business unit of specific case. */
export type CaseBusinessUnitAssignInput = {
  /** New business unit uuid. If null delete relation. */
  businessUnitUuid?: InputMaybe<Scalars['ID']['input']>;
  /** Uuid of case to update. */
  caseUuid: Scalars['UUID']['input'];
};

export type CaseByCountry = {
  /** Sum of cases in given country. */
  count: Scalars['Int']['output'];
  country: Country_Code;
};

export type CaseByCountryInput = {
  /** Allows narrowing cases to only those that have been closed within the specified number of days. */
  closedWithinDays?: InputMaybe<Scalars['Int']['input']>;
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Allows narrowing cases to only those that belong to the given incidents types. */
  incidentTypeUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type CaseByReportSource = {
  /** Number of cases for given source */
  count: Scalars['Int']['output'];
  /** Case source name / channel name */
  source: Scalars['String']['output'];
};

export type CaseByReportSourceInput = {
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type CaseByStatus = {
  /** Aggregation of closed cases in given period of time (range) */
  closed: Array<CaseByStatusData>;
  /** Aggregation of reported cases in given period of time (range) */
  reported: Array<CaseByStatusData>;
};


export type CaseByStatusClosedArgs = {
  input?: InputMaybe<CaseByStatusInput>;
};


export type CaseByStatusReportedArgs = {
  input?: InputMaybe<CaseByStatusInput>;
};

export type CaseByStatusData = {
  /** Count of cases in time interval */
  count: Scalars['Int']['output'];
  /** Start of time interval */
  date: Scalars['DateTime']['output'];
};

export type CaseByStatusInput = {
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Group counts by time interval */
  interval?: InputMaybe<Time_Interval>;
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** Defines input for closing case. */
export type CaseCloseInput = {
  /** Uuid of case to close. */
  caseUuid: Scalars['UUID']['input'];
  /** Uuid of case to close. */
  conclusionTypeUuid: Scalars['UUID']['input'];
  /** Files to be uploaded and attached to the case. */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Note added to case closing. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Defines input for editing answer in original report of case */
export type CaseConversationMessageUpdateInput = {
  /** Answer text */
  textEdited?: InputMaybe<Scalars['String']['input']>;
  /** Answer text translation */
  textTranslatedOverride?: InputMaybe<Scalars['String']['input']>;
  /** Answer UUID */
  uuid: Scalars['UUID']['input'];
};

/** Represents input for editing original report of case */
export type CaseConversationUpdateInput = {
  /** Case UUID to edit its original report. */
  caseUuid: Scalars['UUID']['input'];
  /** Answers to edit */
  messages: Array<CaseConversationMessageUpdateInput>;
};

/** Custom reminders for an investigation triggered by conditions like case status, countries or days of inactivity in investigation. */
export type CaseCustomReminder = {
  /** Number of days of inactivity after which the custom reminder will be triggered. */
  afterInactivityDays: Scalars['Int']['output'];
  /** Channels through which the notification will be delivered. */
  channels: Array<Custom_Reminder_Channel>;
  /** Countries where the custom reminder will be triggered. */
  countries: Array<Country_Code>;
  /** Message of custom reminder. */
  message: Scalars['String']['output'];
  /** Type of case owners which should receive reminders. */
  receivers: Array<Case_Access_Type>;
  /** Case status on which the custom reminder will be triggered. */
  status: Case_Status;
  /** Title of custom reminder. */
  title: Scalars['String']['output'];
  /** Unique identifier of custom reminder. */
  uuid: Scalars['ID']['output'];
};

/** Represents pagination connection of custom reminder settings. */
export type CaseCustomReminderConnection = {
  /** Array of edges. */
  edges: Array<CaseCustomReminderEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseCustomReminder>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of custom reminders settings. */
export type CaseCustomReminderConnectionInput = {
  /** Represents optional text filter to limit the results. It allows filtering by title and message. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseCustomReminderSortInput>>;
};

/** Represents input to delete custom reminder. */
export type CaseCustomReminderDeleteInput = {
  /** Unique identifiers of custom reminders. */
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents CaseCustomReminder connection edge. */
export type CaseCustomReminderEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseCustomReminder record. */
  node: CaseCustomReminder;
};

export type CaseCustomReminderSortFields =
  | 'CREATED_AT'
  | 'TITLE';

export type CaseCustomReminderSortInput = {
  direction: SortDirection;
  field: CaseCustomReminderSortFields;
};

/** Represents input to upsert custom reminder. */
export type CaseCustomReminderUpsertInput = {
  /** Number of days of inactivity after which the custom reminder will be triggered. */
  afterInactivityDays: Scalars['Int']['input'];
  /** Channels through which the notification will be delivered. */
  channels: Array<Custom_Reminder_Channel>;
  /** Countries where the custom reminder will be triggered. */
  countries: Array<Country_Code>;
  /** Message of custom reminder. */
  message: Scalars['String']['input'];
  /** Type of case owners which should receive reminders. */
  receivers: Array<Case_Access_Type>;
  /** Case status on which the custom reminder will be triggered. */
  status: Case_Status;
  /** Title of custom reminder. */
  title: Scalars['String']['input'];
  /** Unique identifier of custom reminder. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CaseCustomTitleUpdateInput = {
  /** Uuid of case to update. */
  caseUuid: Scalars['String']['input'];
  /** Case custom title. */
  customTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Represents input for updating case details (formerly known as Case Allegation Details). */
export type CaseDetailsUpdateInput = {
  /** Case uuid to update */
  caseUuid: Scalars['String']['input'];
  /** City where incident occurred. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where incident occurred. */
  country: Country_Code;
  /** Currency of financial loss/damages to the company. */
  currency?: InputMaybe<Currency_Code>;
  /** Financial loss/damages to the company. */
  damageCost?: InputMaybe<Scalars['Float']['input']>;
  /** Location where incident occurred. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** State where incident occurred, null when country has no states. */
  state?: InputMaybe<States_Code>;
};

/** Represents Case connection edge. */
export type CaseEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Case record. */
  node: Case;
};

/** Represents input for requesting parsed template. */
export type CaseEmailMessageParseRequestInput = {
  /** Case UUID */
  caseUuid: Scalars['String']['input'];
  /** Individual involved UUID */
  involvedUuid: Scalars['String']['input'];
};

/** Represents case owner user to be excluded from the case management. */
export type CaseExclusionOwner = {
  /** Email. */
  email: Scalars['String']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** User unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the edge container of paginated `CaseExclusionOwner` data. */
export type CaseExclusionOwnerEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: CaseExclusionOwner;
};

/** Represent the input for order of case owner exclusion users. */
export type CaseExclusionOwnerListOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<CaseExclusionOwnerOrderFieldInput>;
};

/** Represents paginated list of excluded case owner users. */
export type CaseExclusionOwnerListPaginated = {
  /** Indicates whether case owner exclusion is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Pages of data `edges` and page meta `info`. */
  page: CaseExclusionOwnerPage;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents enumeration of possible keys used to order a list of case owner users to be excluded from case management. */
export type CaseExclusionOwnerOrderField =
  | 'email'
  | 'name';

/** Represents the singular `CaseExclusionOwnerOrderFieldInput` order input object. */
export type CaseExclusionOwnerOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: CaseExclusionOwnerOrderField;
};

/** Represents the page container of paginated `CaseExclusionOwner` data. */
export type CaseExclusionOwnerPage = {
  /** List of edges. */
  edges?: Maybe<Array<CaseExclusionOwnerEdge>>;
  /** Page information. */
  info: PageInfo;
};

export type CaseExclusionOwnerSortFields =
  | 'EMAIL'
  | 'NAME';

export type CaseExclusionOwnerSortInput = {
  direction: SortDirection;
  field: CaseExclusionOwnerSortFields;
};

/** Represents the case file. */
export type CaseFile = {
  /** A case that case file belongs to */
  case: Case;
  /** A case activity that the case file belongs to. */
  caseActivity?: Maybe<CaseActivity>;
  /** Case unique identifier. */
  caseUuid: Scalars['String']['output'];
  /** File mime type. */
  mimeType: Scalars['String']['output'];
  /** File name. */
  name: Scalars['String']['output'];
  /** File S3 key. */
  s3Key: Scalars['String']['output'];
  /** File size (in bytes). */
  size?: Maybe<Scalars['Float']['output']>;
  /** Case file type. */
  type: Case_File_Type;
  /** Date when the file was uploaded. */
  uploadedAt: Scalars['DateTime']['output'];
  /** A user who uploaded the file. */
  uploadedBy?: Maybe<UserType>;
  /** Is file uploaded by reporter. */
  uploadedByReporter: Scalars['Boolean']['output'];
  /** File unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents pagination input for connection of case files. */
export type CaseFileConnection = {
  /** Array of edges. */
  edges: Array<CaseFileEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseFile>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case files. */
export type CaseFileConnectionInput = {
  /** Optional list of case file types for filtering. Empty array will be interpreted as no filtering. */
  fileTypes?: InputMaybe<Array<Case_File_Type>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseFileSortInput>>;
};

/** Represents CaseFile connection edge. */
export type CaseFileEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseFile record. */
  node: CaseFile;
};

/** Represents input for case file identification. */
export type CaseFileIdentifierInput = {
  /** File unique identifier. */
  uuid: Scalars['ID']['input'];
};

export type CaseFileSortFields =
  | 'NAME'
  | 'SIZE'
  | 'TYPE'
  | 'UPLOADED_AT'
  | 'UPLOADED_BY';

export type CaseFileSortInput = {
  direction: SortDirection;
  field: CaseFileSortFields;
};

/** Represents the input for deleting case files. */
export type CaseFilesDeleteInput = {
  /** Case unique identifier. */
  caseUuid: Scalars['ID']['input'];
  /** Case files to be deleted. */
  files: Array<CaseFileIdentifierInput>;
};

/** Represents the input for uploading case files. */
export type CaseFilesUploadInput = {
  /** Case unique identifier. */
  caseUuid: Scalars['ID']['input'];
  /** Files to be uploaded and attached to the case. */
  files: Array<NamedUpload>;
};

/** Represents the case history. */
export type CaseHistory = {
  /** A case that history belongs to */
  case: Case;
  /** Date when history were added. */
  changedAt: Scalars['DateTime']['output'];
  /** A user who did change. */
  changedBy?: Maybe<UserType>;
  /** New value of case. */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Original value of case. */
  originalValue?: Maybe<Scalars['String']['output']>;
  /** Record of case history. */
  record?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of case history */
  uuid: Scalars['UUID']['output'];
};

/** Represents pagination input for connection of case activities. */
export type CaseHistoryConnection = {
  /** Array of edges. */
  edges: Array<CaseHistoryEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseHistory>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case history. */
export type CaseHistoryConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseHistorySortInput>>;
};

/** Represents CaseHistory connection edge. */
export type CaseHistoryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseHistory record. */
  node: CaseHistory;
};

export type CaseHistorySortFields =
  | 'CHANGED_AT'
  | 'RECORD';

export type CaseHistorySortInput = {
  direction: SortDirection;
  field: CaseHistorySortFields;
};

export type CaseIncidentTypeAssignInput = {
  /** Uuid of case to update. */
  caseUuid: Scalars['UUID']['input'];
  /** New incident type uuid. If null delete relation. */
  incidentTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Represents input for listing emails sent to an individual involved. */
export type CaseIndividualInvolvedEmailsInput = {
  /** Case UUID */
  caseUuid: Scalars['UUID']['input'];
  /** Individual involved UUID */
  involvedUuid: Scalars['UUID']['input'];
};

/** Represents input for sending individual involved message */
export type CaseIndividualInvolvedMessageInput = {
  /** Email message body, may be edited by user */
  body: Scalars['String']['input'];
  /** Case UUID */
  caseUuid: Scalars['UUID']['input'];
  /** Individual involved UUID */
  involvedUuid: Scalars['UUID']['input'];
  /** Email message subject, may be edited by user */
  subject: Scalars['String']['input'];
};

/** Defines input for upserting individuals involved. */
export type CaseIndividualInvolvedUpsertInput = {
  /** Uuid of business unit to connect. */
  businessUnitUuid?: InputMaybe<Scalars['ID']['input']>;
  /** Uuid of case to connect. */
  caseUuid: Scalars['UUID']['input'];
  /** Company name of individual involved. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Email address of individual involved. */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** First name of individual involved. */
  firstName: Scalars['String']['input'];
  /** Last name of individual involved. */
  lastName: Scalars['String']['input'];
  /** Position in company of individual involved. */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to company of individual involved. */
  relationship: User_Relationship;
  /** Type of individuals involvement. */
  type: Involvement_Type;
  /** Uuid of individuals involved to update */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CaseInvestigation = {
  /** Human readable unique identifier. */
  caseId: Scalars['String']['output'];
  /** Case unique identifier. */
  caseUuid: Scalars['ID']['output'];
  /** Creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** Custom title. */
  customTitle?: Maybe<Scalars['String']['output']>;
  originalReport?: Maybe<OriginalReport>;
  /** Current case status. */
  status: Case_Status;
  /** Last update date. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents pagination connection of case investigations. */
export type CaseInvestigationConnection = {
  /** Array of edges. */
  edges: Array<CaseEdge>;
  /** Array of direct nodes. */
  nodes: Array<Case>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  statistics: CaseInvestigationStatistics;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case investigations. */
export type CaseInvestigationConnectionInput = {
  /** Narrows the result of pagination to given criteria. */
  filtering?: InputMaybe<CaseInvestigationFilterInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Narrows the result of pagination to given search criteria. */
  searching?: InputMaybe<CaseInvestigationSearchInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseSortInput>>;
};

/** Represents input for case investigations pagination filter. */
export type CaseInvestigationFilterInput = {
  /** Narrows the pagination result to the given business unit. */
  businessUnitUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Narrows the pagination result to the given countries. */
  countries?: InputMaybe<Array<Country_Code>>;
  /** Narrows the pagination result to the cases created after given date (inclusively). */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Narrows the pagination result to the cases created before given date (inclusively). */
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Narrows the pagination result to the given incident types. */
  incidentTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Narrows the pagination result by case status. */
  statuses?: InputMaybe<Array<Case_Status>>;
};

export type CaseInvestigationGetInput = {
  /** Human readable case identifier. */
  caseId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of case report. */
  caseUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type CaseInvestigationPdfReportGenerateInput = {
  caseUuid: Scalars['String']['input'];
};

export type CaseInvestigationPdfReportGenerateResponse = {
  /** A URL to PDF file uploaded to S3. */
  url: Scalars['String']['output'];
};

/** Represents input for pagination's search. */
export type CaseInvestigationSearchInput = {
  /** Narrows the pagination search result by person involved. */
  narrowByAssistantConversation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by person involved. */
  narrowByCaseActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by case ID. */
  narrowByCaseId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by case subject. */
  narrowByCaseSubject?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by person involved. */
  narrowByElineTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by person involved. */
  narrowByPersonInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result to the given keywords. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

/** The summary of investigation funnel. */
export type CaseInvestigationStatistics = {
  /** Count of closed case investigations. */
  closedCount: Scalars['Int']['output'];
  /** Count of case investigations with inactivity longer than 30 days. */
  longInactiveCount: Scalars['Int']['output'];
  /** Count of open case investigations. */
  openedCount: Scalars['Int']['output'];
  /** Total count of case investigations. */
  totalCount: Scalars['Int']['output'];
};

export type CaseInvestigationsXlsxReportGenerateInput = {
  /** Narrows the result of pagination to given criteria. */
  filtering?: InputMaybe<CaseInvestigationFilterInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseSortInput>>;
};

export type CaseInvestigatorUpdateInput = {
  caseInvestigators: Array<InvestigatorData>;
  caseUuid: Scalars['String']['input'];
};

/** Represents the case investigators (case owners and case stakeholders). */
export type CaseInvestigators = {
  /** Represents the case owners. */
  owners?: Maybe<Array<UserType>>;
  /** Represents the case stakeholders. */
  stakeholders?: Maybe<Array<UserType>>;
};

/** Represents unique case owner exclusion. */
export type CaseOwnerExclusion = {
  /** Returns users that may be excluded from case investigation. */
  excludableUsers: Array<UserType>;
  /** Returns fallback user. */
  fallbackUser: UserType;
  /** Subsidiary site of case owner exclusions. `NULL` when subsidiary site module is disabled. */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Unique identifier of case owner exclusion. */
  uuid: Scalars['ID']['output'];
};

/** Represents pagination connection of case owner exclusions. */
export type CaseOwnerExclusionConnection = {
  configurationStatus: Case_Owner_Exclusion_Configuration_Status;
  /** Array of edges. */
  edges: Array<CaseOwnerExclusionEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseOwnerExclusion>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case owner exclusions. */
export type CaseOwnerExclusionConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseOwnerExclusionSortInput>>;
};

/** Represents CaseOwnerExclusion connection edge. */
export type CaseOwnerExclusionEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseOwnerExclusion record. */
  node: CaseOwnerExclusion;
};

export type CaseOwnerExclusionGetByBusinessUnitInput = {
  businessUnitUuid?: InputMaybe<Scalars['UUID']['input']>;
  entity?: InputMaybe<Investigation_Entity>;
  subsidiarySiteUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input to fetch unique case owner exclusion. */
export type CaseOwnerExclusionGetInput = {
  /** Unique identifier of case owner exclusion to fetch. */
  uuid: Scalars['UUID']['input'];
};

export type CaseOwnerExclusionSortFields =
  | 'CREATED_AT';

export type CaseOwnerExclusionSortInput = {
  direction: SortDirection;
  field: CaseOwnerExclusionSortFields;
};

/** Represents input to upsert case owner exclusion. */
export type CaseOwnerExclusionUpsertInput = {
  /** Unique identifiers of a fallback user who will be able to investigate the case once all possible investors have been excluded. */
  fallbackUserUuid: Scalars['UUID']['input'];
  /** Unique identifier of subsidiary site. This option will be respected only when subsidiary sites feature is enabled. Provide `NULL` if you want to add case owner exclusion rule to headquarters. */
  subsidiarySiteUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** List of users for which exclusion status should be updated. */
  users: Array<CaseOwnerExclusionUserStatusInput>;
  /** Unique identifier of case owner exclusion to update. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input to update exclusion status of unique user. */
export type CaseOwnerExclusionUserStatusInput = {
  /** Indicates whether case owner can be excluded from case report investigation. */
  isExcludable: Scalars['Boolean']['input'];
  /** Unique identifier of user. */
  userUuid: Scalars['UUID']['input'];
};

/** Represents input to delete case owner exclusions. */
export type CaseOwnerExclusionsDeleteInput = {
  /** Unique identifiers of case owner exclusions to delete. */
  uuids: Array<Scalars['UUID']['input']>;
};

export type CasePrintSections = {
  assistantConversation: Scalars['Boolean']['output'];
  basicInformation: Scalars['Boolean']['output'];
  caseActivity: Scalars['Boolean']['output'];
  caseFiles: Scalars['Boolean']['output'];
  caseOwnership: Scalars['Boolean']['output'];
  chatConversation: Scalars['Boolean']['output'];
  individualsInvolved: Scalars['Boolean']['output'];
};

export type CasePrintSectionsInput = {
  /** Indicates whether user can print conversation with assistant. */
  assistantConversation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether user can print basic case information. */
  basicInformation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether user can print case activities details. */
  caseActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether user can print attached files details. */
  caseFiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether user can print case ownership details. */
  caseOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether user can print conversation from chat. */
  chatConversation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether user can print individuals involved personal details. */
  individualsInvolved?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents settings for case printing. */
export type CasePrintSettings = {
  ADMIN: CasePrintSections;
  CASE_OWNER: CasePrintSections;
  REGIONAL_USER: CasePrintSections;
  STAKEHOLDER: CasePrintSections;
};

export type CasePrintSettingsInput = {
  /** Printing settings for user how has access to case report due to being admin. */
  ADMIN?: InputMaybe<CasePrintSectionsInput>;
  /** Printing settings for user how has access to case report due to being its case owner. */
  CASE_OWNER?: InputMaybe<CasePrintSectionsInput>;
  /** Printing settings for user how has access to case report due to being regional user. */
  REGIONAL_USER?: InputMaybe<CasePrintSectionsInput>;
  /** Printing settings for user how has access to case report due to being its stakeholder. */
  STAKEHOLDER?: InputMaybe<CasePrintSectionsInput>;
};

/** Defines input for reopening case. */
export type CaseReopenInput = {
  /** Uuid of case to reopen. */
  caseUuid: Scalars['UUID']['input'];
  /** Files to be uploaded and attached to the case. */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Note added to case closing. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the identifiers and information of reported case. */
export type CaseReport = {
  /** Human readable unique identifier. */
  caseId: Scalars['String']['output'];
  /** Secret key for chat messages encryption/decryption. */
  chatRoomSecret?: Maybe<Scalars['String']['output']>;
  /** Creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** Indicates whether the last chat message was sent by the admin user. */
  isNewMessageFromAdmin: Scalars['Boolean']['output'];
  /** Indicates whether case status has changed. */
  isStatusChanged: Scalars['Boolean']['output'];
  /** Language with which case has been reported. */
  language: Language_Code;
  /** Last message from case-related chat conversation. */
  lastMessage?: Maybe<Scalars['String']['output']>;
  /** Translated last message from case manager. */
  lastMessageTranslated?: Maybe<Scalars['String']['output']>;
  /** Current case status. */
  status: Case_Status;
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};


/** Represents the identifiers and information of reported case. */
export type CaseReportLastMessageTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

/** Represents pagination connection of submitted case reports. */
export type CaseReportConnection = {
  /** Array of edges. */
  edges: Array<CaseReportEdge>;
  /** Array of direct nodes. */
  nodes: Array<CaseReport>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Returns the statistics for the cases reported by `EMPLOYEE` user type). */
  statistics: CaseReportStatistics;
};

/** Represents the input for conversation message edition. */
export type CaseReportConversationMessageInput = {
  /** New text for the message. */
  textEdited: Scalars['String']['input'];
  /** Unique identifier of conversation message. */
  uuid: Scalars['ID']['input'];
};

/** Represents input for creation of new case report. */
export type CaseReportCreateInput = {
  /** Incident type uuid of new case. */
  incidentTypeUuid: Scalars['String']['input'];
  /** Country where reporter is located. */
  reporterCountry: Country_Code;
  /** Reporter's language. */
  reporterLanguage?: InputMaybe<Language_Code>;
  /** Reporter's relationship to company. */
  reporterRelationship: User_Relationship;
  /** Reporting source. */
  reportingSourceUuid: Scalars['UUID']['input'];
};

/** Represents the input for retrieving reported case details. */
export type CaseReportDetailsInput = {
  /** Human readable case unique identifier. */
  caseId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of case report. */
  caseUuid?: InputMaybe<Scalars['String']['input']>;
  /** Case pin code (related to `Guest` user type). */
  pinCode?: InputMaybe<Scalars['String']['input']>;
};

/** Represents CaseReport connection edge. */
export type CaseReportEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseReport record. */
  node: CaseReport;
};

/** Represents the input for edition of conversation messages with chat assistant. */
export type CaseReportEditConversationInput = {
  /** Conversation message to be edited. */
  messages: Array<CaseReportConversationMessageInput>;
  /** Case unique identifier. */
  uuid: Scalars['ID']['input'];
};

/** Represents the input to identify the reported case. */
export type CaseReportIdentifierInput = {
  /** Case unique identifier. */
  uuid: Scalars['ID']['input'];
};

export type CaseReportSortFields =
  | 'CASE_ID'
  | 'CREATED_AT'
  | 'STATUS'
  | 'STATUS_CHANGED';

export type CaseReportSortInput = {
  direction: SortDirection;
  field: CaseReportSortFields;
};

/** Represents the input provided for reporting new case. */
export type CaseReportStartInput = {
  /**
   * Unique identifier of business unit where case should be investigated. @deprecated Use sourceSubsidiarySiteUuid and targetSubsidiarySiteUuid
   * @deprecated Use sourceSubsidiarySiteUuid and targetSubsidiarySiteUuid
   */
  businessUnitUuid?: InputMaybe<Scalars['ID']['input']>;
  /** Identifiers of users to be excluded from being potential case owner. */
  caseExclusionOwnerList?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Country code. */
  country: Country_Code;
  /**
   * Entity where case report should be investigated. @deprecated Use sourceSubsidiarySiteUuid and targetSubsidiarySiteUuid
   * @deprecated Use sourceSubsidiarySiteUuid and targetSubsidiarySiteUuid
   */
  entity?: InputMaybe<Investigation_Entity>;
  /** Unique identifier of incident type. */
  incidentTypeUuid: Scalars['String']['input'];
  /** Reporter personal data information.Requirements of this data is based on the anonymity settings. */
  reporterData?: InputMaybe<CaseReporterDataInput>;
  /** Unique identifier of source subsidiary site. Leave empty for headquarters. */
  sourceSubsidiarySiteUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Unique identifier of target subsidiary site. Leave empty for headquarters. */
  targetSubsidiarySiteUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents the statistics for reported cases. */
export type CaseReportStatistics = {
  /** The number of all already submitted case reports. */
  all: Scalars['Int']['output'];
  /** The number of ongoing case reports. */
  ongoing: Scalars['Int']['output'];
};

/** Represents the identifiers and information of submitted case report. */
export type CaseReportSubmit = {
  /** Human readable unique identifier. */
  caseId: Scalars['String']['output'];
  /** Creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** Language with which case has been reported. */
  language: Language_Code;
  /** Current case status. */
  status: Case_Status;
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the input to submit reported case. */
export type CaseReportSubmitInput = {
  /** Email of the reporter (related to `Guest` user type). */
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  /** Pin code (related to `Guest` user type). */
  pinCode?: InputMaybe<Scalars['String']['input']>;
  /** Case unique identifier. */
  uuid: Scalars['ID']['input'];
};

/** Represents the summary of reported case. */
export type CaseReportSummaryResponse = {
  /** Business unit of reported case. */
  businessUnit?: Maybe<BusinessUnit>;
  /** Human readable unique identifier. */
  caseId: Scalars['String']['output'];
  /** Secret key for chat messages encryption/decryption. */
  chatRoomSecret?: Maybe<Scalars['String']['output']>;
  /** Messages from the conversation with chat assistant. */
  conversationMessages: Array<ConversationMessage>;
  /** Country where incident occurred (Case Details section, editable). */
  country: Country_Code;
  /** Case eline conversation details. */
  elineConversation?: Maybe<ElineConversation>;
  /** Entity under which case report should be investigate. */
  entity?: Maybe<Investigation_Entity>;
  /** List of users excluded from case report investigation. */
  excludedUsers: Array<UserType>;
  files: Array<PresignedCaseFile>;
  /** Allows to generate firebase token for case accessed via pin code. Valid for 1 hour. This token will only allow access to the case-related data for which it was issued. Available only for GUEST and unauthenticated user. */
  firebaseToken?: Maybe<Scalars['JWT']['output']>;
  /** Incident type of reported case. */
  incidentType?: Maybe<IncidentType>;
  /** Indicates whether case status has changed. */
  isStatusChanged: Scalars['Boolean']['output'];
  /** Language with which case has been reported. */
  language: Language_Code;
  /** @deprecated Legacy chats will be replaced with new ones. As soon as new chats become available, this mutation and related inputs will be removed. */
  mobileApiToken?: Maybe<Scalars['String']['output']>;
  /** Current case status. */
  status: Case_Status;
  /** Case source subsidiary. */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};


/** Represents the summary of reported case. */
export type CaseReportSummaryResponseMobileApiTokenArgs = {
  input: MobileApiTokenInput;
};

export type CaseReporter = {
  /** Country where incident occurred (Case Details section, editable). */
  country: Country_Code;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Relationship of reporting user in the time of report. */
  relationship: Scalars['String']['output'];
};

/** Represents the input for personal information about case reporter. */
export type CaseReporterDataInput = {
  /** Email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents input for reported cases of employee. */
export type CaseReportsInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseReportSortInput>>;
};

/** Represents settings for case anonymity. */
export type CaseSettingAnonymity = {
  /** Indicates whether current user can edit the setting. */
  canEdit: Scalars['Boolean']['output'];
  /** List of countries with anonymity settings set. */
  configuredCountries: Array<Country_Code>;
  /** Countries anonymity settings. */
  countryAnonymities: Array<CountryAnonymity>;
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
};

/** Represents settings for case owner exclusion. */
export type CaseSettingExclusion = {
  /** Indicates whether current user can edit the setting. */
  canEdit: Scalars['Boolean']['output'];
  /** Exclusion fallback user uuid. */
  fallbackUserUuid?: Maybe<Scalars['ID']['output']>;
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
};

/** Tenant reporting process settings. */
export type CaseSettings = {
  anonymitySettings: CaseSettingAnonymity;
  automaticDeletionSettings: AutomaticDeletionSettings;
  caseActivity: CaseActivitySettingsConnection;
  caseActivitySetting: CaseActivitySettings;
  caseActivitySettingsAll: Array<CaseActivitySettings>;
  /** Returns the case assignment by unique identifier. */
  caseAssignment: CaseAssignment;
  /** Returns the paginated connection of case assignments. */
  caseAssignments: CaseAssignmentConnection;
  caseOwnerExclusion?: Maybe<CaseOwnerExclusion>;
  caseOwnerExclusions: CaseOwnerExclusionConnection;
  conclusionType: ConclusionType;
  conclusionTypes: ConclusionTypeConnection;
  conclusionTypesAll: Array<ConclusionType>;
  conversationEditingSettings: ConversationEditingSettings;
  customReminder: CaseCustomReminder;
  /** The paginated connection of custom reminder settings. */
  customReminders: CaseCustomReminderConnection;
  emailTemplate: EmailTemplate;
  emailTemplates: Array<EmailTemplate>;
  exclusionSetting: CaseSettingExclusion;
  notifyCaseOwnersAfterInactivityDays: Scalars['Int']['output'];
  printingSettings: CasePrintSettings;
  reportingSource: ReportingSource;
  reportingSources: ReportingSourceConnection;
  reportingSourcesAll: Array<ReportingSource>;
  /** Subsidiary reporting settings. Will return NULL if subsidiary module is disabled. */
  subsidiaryReportingSettings?: Maybe<SubsidiarySiteReportingSettings>;
  tenantUuid: Scalars['ID']['output'];
  triageScoreSettings: TriageScoreSetting;
};


/** Tenant reporting process settings. */
export type CaseSettingsCaseActivityArgs = {
  input?: InputMaybe<CaseActivitySettingsConnectionInput>;
};


/** Tenant reporting process settings. */
export type CaseSettingsCaseActivitySettingArgs = {
  input: GetCaseActivitySettingsInput;
};


/** Tenant reporting process settings. */
export type CaseSettingsCaseAssignmentArgs = {
  input: CaseAssignmentGetInput;
};


/** Tenant reporting process settings. */
export type CaseSettingsCaseAssignmentsArgs = {
  input?: InputMaybe<CaseAssignmentConnectionInput>;
};


/** Tenant reporting process settings. */
export type CaseSettingsCaseOwnerExclusionArgs = {
  input: CaseOwnerExclusionGetInput;
};


/** Tenant reporting process settings. */
export type CaseSettingsCaseOwnerExclusionsArgs = {
  input?: InputMaybe<CaseOwnerExclusionConnectionInput>;
};


/** Tenant reporting process settings. */
export type CaseSettingsConclusionTypeArgs = {
  input: GetConclusionTypeInput;
};


/** Tenant reporting process settings. */
export type CaseSettingsConclusionTypesArgs = {
  input?: InputMaybe<ConclusionTypeConnectionInput>;
};


/** Tenant reporting process settings. */
export type CaseSettingsCustomReminderArgs = {
  input: GetCaseCustomReminderInput;
};


/** Tenant reporting process settings. */
export type CaseSettingsCustomRemindersArgs = {
  input?: InputMaybe<CaseCustomReminderConnectionInput>;
};


/** Tenant reporting process settings. */
export type CaseSettingsEmailTemplateArgs = {
  type: EmailTemplateType;
};


/** Tenant reporting process settings. */
export type CaseSettingsReportingSourceArgs = {
  input: GetReportingSourceInput;
};


/** Tenant reporting process settings. */
export type CaseSettingsReportingSourcesArgs = {
  input?: InputMaybe<ReportingSourceConnectionInput>;
};

/** Represents the input for case settings changes.At least one property has to be provided. */
export type CaseSettingsUpdateInput = {
  /** Anonymity settings changes for provided unique countries. */
  anonymitySettings?: InputMaybe<Array<CountryAnonymitySettingsInput>>;
  /** Automatic case data deletion settings. */
  automaticDeletionSettings?: InputMaybe<AutomaticDeletionSettingsInput>;
  /** Assistant conversation editing settings. */
  conversationEditingSettings?: InputMaybe<ConversationEditingSettingsInput>;
  /** User exclusion settings. */
  exclusionSettings?: InputMaybe<ExclusionSettingsInput>;
  /** The number of days of inactivity after which a notification will be sent to the case owner. The message will only be sent if the corresponding email template is enabled. */
  notifyCaseOwnersAfterInactivityDays?: InputMaybe<Scalars['Int']['input']>;
  /** Case print settings. */
  printingSettings?: InputMaybe<CasePrintSettingsInput>;
  /** Input for subsidiary sites reporting settings. */
  subsidiaryReportingSettings?: InputMaybe<SubsidiaryReportingSettingsInput>;
  /** Triage score settings. */
  triageScoreSettings?: InputMaybe<TriageScoreSettingsInput>;
};

export type CaseSortFields =
  | 'BUSINESS_UNIT'
  | 'CASE_ID'
  | 'CLOSED_AT'
  | 'CONCLUSION_TYPE'
  | 'CUSTOM_TITLE'
  | 'DURATION'
  | 'INCIDENT_OWNER'
  | 'INCIDENT_TYPE'
  | 'LANGUAGE'
  | 'LAST_UPDATE_AT'
  | 'OPENED_AT'
  | 'RELATIONSHIP'
  | 'REOPENED_AT'
  | 'REPORTER_COUNTRY'
  | 'REPORTING_SOURCE'
  | 'STATUS'
  | 'SUBMITTED_AT'
  | 'TRIAGE_SCORE';

export type CaseSortInput = {
  direction: SortDirection;
  field: CaseSortFields;
};

export type CaseStatusByIncidentType = {
  /** Sum of closed cases. */
  closed: Scalars['Int']['output'];
  incidentTypeName: Scalars['String']['output'];
  /** Sum of new cases. */
  new: Scalars['Int']['output'];
  /** Sum of open cases. */
  open: Scalars['Int']['output'];
  /** Sum of reopen cases. */
  reopen: Scalars['Int']['output'];
};

export type CaseStatusByIncidentTypeInput = {
  /** Allows narrowing aggregation only to cases created before given date. Maximal date allowed is 2100-01-01T00:00:00.000Z */
  endsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to cases created after given date. Minimal date allowed is 2000-01-01T00:00:00.000Z */
  startsAt: Scalars['DateTime']['input'];
  /** Allows narrowing aggregation only to given subsidiaries. Provide `NULL` for headquarters or uuid for subsidiaries. */
  subsidiaryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type CaseTriageScoreUpdateInput = {
  /** Uuid of case to update. */
  caseUuid: Scalars['UUID']['input'];
  /** Factor of severity. */
  severity: Scalars['Int']['input'];
  /** Factor of urgency. */
  urgency: Scalars['Int']['input'];
};

export type CasesRolePermission = {
  /** Role permission name. */
  permission: Assignable_Permission;
  /** Subsidiary site to which the permission is scoped. */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Role permission UUID. */
  uuid: Scalars['UUID']['output'];
};

/** Input for changing subsidiary site of existing cases. */
export type CasesSubsidiarySiteUpdateInput = {
  /** Array of cases to be updated. Minimum 1 case, maximum 500 cases */
  caseUuids: Array<Scalars['String']['input']>;
  /** UUID of source subsidiary site. This is the subsidiary site that will be shown as source in case information page. Provide null for headquarters */
  sourceSubsidiarySite?: InputMaybe<Scalars['String']['input']>;
  /** UUID of target subsidiary site. This is the subsidiary site where the case will be accessible. Provide null for headquarters */
  targetSubsidiarySite?: InputMaybe<Scalars['String']['input']>;
};

/** A catalogue grouping (e.g. ISO management systems, reporting standards). */
export type CatalogueCategory = {
  blurb: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** A LOCKED seat-tiered pricing plan for the catalogue. */
export type CataloguePlan = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceUsd?: Maybe<Scalars['Int']['output']>;
  seats: Scalars['String']['output'];
  tagline: Scalars['String']['output'];
  withNicole: Scalars['Boolean']['output'];
};

/** A sellable Speeki Engage standard or framework. */
export type CatalogueProduct = {
  availablePlanIds: Array<Scalars['ID']['output']>;
  category: Scalars['ID']['output'];
  highlight?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owned: Scalars['Boolean']['output'];
  ownedSource?: Maybe<Catalogue_Owned_Source>;
  riskAreaUuid: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  upgradeable: Scalars['Boolean']['output'];
};

/** ESG category */
export type Category = {
  /** Name of the category */
  name: Scalars['String']['output'];
  /** List of tenant risk area settings */
  riskAreas: Array<TenantRiskAreaSetting>;
  /** UUID of the category */
  uuid: Scalars['UUID']['output'];
};

/** Correct who signs an order already sent for signature. */
export type ChangeOrderSignerInput = {
  /** The address the agreement should be re-sent to. */
  signerEmail: Scalars['String']['input'];
  /** The new signer's name, as it should appear on the agreement. */
  signerName?: InputMaybe<Scalars['String']['input']>;
};

/** Input for changing password */
export type ChangePasswordInput = {
  /** New password */
  newPassword: Scalars['String']['input'];
  /** Current password */
  password: Scalars['String']['input'];
};

/** Input to change year status. */
export type ChangeYearStatusInput = {
  /** Given year uuid. */
  uuid: Scalars['UUID']['input'];
};

export type ChatRoom = {
  /** Type of object chatroom is referring to. */
  referenceType: ChatRoomReferenceType;
  /** Unique identifier of object the chatroom is referring to. */
  referenceUuid: Scalars['ID']['output'];
  /** Secret key for chat messages encryption/decryption. */
  secret: Scalars['String']['output'];
  /** Chat room status. NEW if chat is not initialized, READY if chat is ready to use */
  status: ChatRoomStatus;
};

/** Represents type of referral object. */
export type ChatRoomReferenceType =
  | 'CASE_REPORT'
  | 'DISCLOSURE_RESPONSE';

/** Represents status of chatroom. */
export type ChatRoomStatus =
  | 'NEW'
  | 'READY';

/** A chat with the chatbot */
export type Chatbot = {
  /** Count chatbot answers in the chat */
  answersCount: Scalars['Int']['output'];
  /** Date of entry creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Returns the user who created the chat */
  createdBy?: Maybe<UserType>;
  messages: ChatbotMessageConnection;
  /** Chatbot UUID. */
  uuid: Scalars['UUID']['output'];
};


/** A chat with the chatbot */
export type ChatbotMessagesArgs = {
  input?: ChatbotMessageConnectionInput;
};

/** A message in the chat */
export type ChatbotMessage = {
  /** Content of the message. */
  content: Scalars['String']['output'];
  /** Date of entry creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Returns the user who created the message */
  createdBy?: Maybe<UserType>;
  /** Role user|assistant. To determine if message was generated or provided by user */
  role: Chatbot_Role;
  /** Message UUID. */
  uuid: Scalars['UUID']['output'];
};

/** Represents ChatbotMessageConnection connection. */
export type ChatbotMessageConnection = {
  /** Array of edges. */
  edges: Array<ChatbotMessageEdge>;
  /** Array of direct nodes. */
  nodes: Array<ChatbotMessage>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying connection of chatbot messages. */
export type ChatbotMessageConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<ChatbotMessageSortInput>>;
};

/** Represents ChatbotMessage connection edge. */
export type ChatbotMessageEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ChatbotMessage record. */
  node: ChatbotMessage;
};

export type ChatbotMessageSortFields =
  | 'CREATED_AT';

export type ChatbotMessageSortInput = {
  direction: SortDirection;
  field: ChatbotMessageSortFields;
};

/** Represents the case file object. */
export type ChatsFile = {
  /** Chatroom identifier. */
  chatRoomUuid: Scalars['String']['output'];
  /** File mime type. */
  mimeType: Scalars['String']['output'];
  /** File name. */
  name: Scalars['String']['output'];
  /** File S3 key. */
  s3Key: Scalars['String']['output'];
  /** Represents signed URL for S3 file. Valid for 1 hour. */
  signedUrl: Scalars['String']['output'];
  /** File size, represents in bytes. */
  size?: Maybe<Scalars['Float']['output']>;
  /** Chat file unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents input of chat room file upload mutation */
export type ChatsFileUploadInput = {
  chatRoomRefUuid: Scalars['ID']['input'];
  /** Files related to chat */
  uploads: Array<NamedFileUpload>;
};

/** This input represents data required to check password reset token */
export type CheckPasswordResetTokenInput = {
  token: Scalars['String']['input'];
};

export type CheckoutItemInput = {
  kind: Scalars['String']['input'];
  /** Seats. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Standard code / module key. */
  ref: Scalars['String']['input'];
};

/** The public view of a checkout session - the pre-order draft a buyer builds up before an account or order exists. Never carries the session token or any server-side tenant match. */
export type CheckoutSessionView = {
  /** Buyer-entered fields, opaque JSON encoded as a string. */
  draft?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  planId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  /** ACTIVE or EXPIRED (CHECKOUT_SESSION_STATUS). */
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  /** Set once the buyer confirms their email; null until then. */
  verifiedEmail?: Maybe<Scalars['String']['output']>;
};

/** One NEW_PERIOD term option: the committed length in years, the discount that buys, and the exact fee PER YEAR. Fees are collected annually - an option is never a lump sum for the whole term. */
export type CheckoutTermOption = {
  /** Exact fee PER YEAR for this term, discount already applied (money as a string). This is what is invoiced now and again on each anniversary - NOT the total for the term. */
  annualUsd: Scalars['String']['output'];
  /** Term discount in basis points (0, 500 or 1000), applied to the ANNUAL rate and held for every year of the term. */
  discountBps: Scalars['Int']['output'];
  /**
   * Deprecated alias of annualUsd, carrying the identical value. The name has always been wrong: it is the per-year fee, never a term total.
   * @deprecated Misleading name - the value is the per-year fee, not the total for the term. Read annualUsd instead.
   */
  totalUsd: Scalars['String']['output'];
  /** Committed term length in years. The buyer commits to this many years and is invoiced one year at a time. */
  years: Scalars['Int']['output'];
};

/** The pre-checkout subscription-terms context for a product+plan - shares the exact same branching CheckoutService.createCheckoutOrder uses, so the two can never disagree. */
export type CheckoutTermsContext = {
  /** CO_TERMINOUS only: the rate this follower actually bills at PER YEAR from renewalDate onward - listAnnualRateUsd with its inherited discount already applied (dollars, not cents). Equal to listAnnualRateUsd when no discount applies. Null for every other mode. */
  contractedAnnualRateUsd?: Maybe<Scalars['Float']['output']>;
  /** CO_TERMINOUS only: days the prorated charge covers. */
  coversDays?: Maybe<Scalars['Int']['output']>;
  /** CO_TERMINOUS only: the multi-year discount this follower inherited from its anchor purchase, in basis points. 0 when the anchor carried no discount - not the same as null, which means the mode has no discount concept at all. */
  discountBpsApplied?: Maybe<Scalars['Int']['output']>;
  /** CO_TERMINOUS only: why the discount applies, e.g. "2-year term" - the anchor order's committed term length. Null when discountBpsApplied is 0 (nothing to explain) or the mode carries no discount concept. */
  discountReason?: Maybe<Scalars['String']['output']>;
  /** Whether Sales Tax applies to this buyer, decided server-side from the buyerCountry argument by the same rule the order freezes. Null when no buyerCountry was given (nothing is known yet) - not the same as false. */
  gstApplicable?: Maybe<Scalars['Boolean']['output']>;
  /** CO_TERMINOUS only: the tier's undiscounted rate PER YEAR (dollars, not cents), before any multi-year discount is applied. Null for every other mode. */
  listAnnualRateUsd?: Maybe<Scalars['Float']['output']>;
  /** The master term in plain terms (length, expiry, how much remains) for the review page. Populated for a NEW_PERIOD purchase once a term is chosen (pass `term`) and for a CO_TERMINOUS follower whose master end is known; null for the free tier, a blocked outcome, or a NEW_PERIOD preview with no term chosen yet. */
  masterTerm?: Maybe<MasterTermSummary>;
  /** NEW_PERIOD | CO_TERMINOUS | FREE_FOREVER | BLOCKED_ALREADY_OWNED | BLOCKED_LAPSED_CONTACT_SALES */
  mode: Scalars['String']['output'];
  /** Every invoice this purchase will produce, in order, running to the end of the committed term - not just the first. Amounts are tax-EXCLUSIVE and agree with what the annual billing sweep will actually charge. Populated on the same conditions as masterTerm; null when there is no schedule to show yet. */
  paymentSchedule?: Maybe<Array<PaymentScheduleRow>>;
  /** CO_TERMINOUS only: the exact prorated FIRST payment, covering the part-year from today to renewalDate (money as a string). Billing continues annually from renewalDate at the full annual rate. */
  proratedTotalUsd?: Maybe<Scalars['String']['output']>;
  /** CO_TERMINOUS only: the tenant's current subscription anniversary this order would align to. */
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
  /** The tax rate as a percentage (e.g. 9 for 9%), for DISPLAY only - the tax amount is always computed on the invoice, never here. Null when tax does not apply, when no buyerCountry was given, or when no rate is configured; a caller must never render null as zero. */
  taxRatePercent?: Maybe<Scalars['Float']['output']>;
  /** NEW_PERIOD only: the 1/2/3-year options, each priced per year. */
  termOptions?: Maybe<Array<CheckoutTermOption>>;
};

/** Input to clear year data. */
export type ClearYearDataInput = {
  /** Given year uuid. */
  uuid: Scalars['UUID']['input'];
};

export type ClientSubsidiarySite = {
  admins: Array<ClientSubsidiarySiteAdmin>;
  /** Flag indicating if subsidiary site is active */
  isActive: Scalars['Boolean']['output'];
  /** Name of subsidiary site. */
  name: Scalars['String']['output'];
  /** Subsidiary site reporting slug. */
  reportingSlug?: Maybe<Scalars['String']['output']>;
  /** UUID of subsidiary site. */
  uuid: Scalars['ID']['output'];
};

export type ClientSubsidiarySiteAdmin = {
  /** Subsidiary site's admin first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Subsidiary site's admin last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Subsidiary site's admin UUID. */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Represents pagination input for connection of client's subsidiary sites. */
export type ClientSubsidiarySiteConnectionInput = {
  /** Name filter for client's subsidiary sites. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Client's UUID. */
  tenantUuid: Scalars['String']['input'];
};

/** Represents ClientSubsidiarySite connection edge. */
export type ClientSubsidiarySiteEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ClientSubsidiarySite record. */
  node: ClientSubsidiarySite;
};

/** Represents ClientSubsidiarySitesConnection connection. */
export type ClientSubsidiarySitesConnection = {
  /** Array of edges. */
  edges: Array<ClientSubsidiarySiteEdge>;
  /** Array of direct nodes. */
  nodes: Array<ClientSubsidiarySite>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type ClientUser = {
  /** Client user's first name. */
  firstName: Scalars['String']['output'];
  /** Client user's last name. */
  lastName: Scalars['String']['output'];
  /** Client user's uuid. */
  uuid: Scalars['String']['output'];
};

/** Input to clone year. */
export type CloneYearInput = {
  /** UUID of cloned year. */
  clonedYearUuid: Scalars['UUID']['input'];
  /** UUID of target year. */
  targetYearUuid: Scalars['UUID']['input'];
};

/** Enumeration of cluster ids. */
export type ClusterIds =
  | 'EU'
  | 'US';

export type ComposeOrderInput = {
  /** ISO-2 buyer country (e.g. SG, AU). */
  buyerCountry: Scalars['String']['input'];
  /** CRM deal reference. */
  crmDealRef?: InputMaybe<Scalars['String']['input']>;
  /** Explicit invoice-to; falls back to the tenant contact. */
  explicitInvoiceTo?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's first name. Optional - printed on the Xero contact when given. */
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's last name. Optional - printed on the Xero contact when given. */
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderItemInput>;
  /** Signer email. */
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
};

export type ConclusionType = {
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Represents input to batch upsert conclusion types. */
export type ConclusionTypeBatchUpsertInput = {
  /** An array of conclusion types. */
  conclusionTypes: Array<ConclusionTypeUpsertInput>;
};

/** Represents pagination connection of conclusion types settings. */
export type ConclusionTypeConnection = {
  /** Array of edges. */
  edges: Array<ConclusionTypeEdge>;
  /** Array of direct nodes. */
  nodes: Array<ConclusionType>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of conclusion types settings. */
export type ConclusionTypeConnectionInput = {
  /** Represents optional text filter to limit the results. It allows filtering by name. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<ConclusionTypeSortInput>>;
};

/** Represents ConclusionType connection edge. */
export type ConclusionTypeEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ConclusionType record. */
  node: ConclusionType;
};

export type ConclusionTypeSortFields =
  | 'NAME'
  | 'STATUS';

export type ConclusionTypeSortInput = {
  direction: SortDirection;
  field: ConclusionTypeSortFields;
};

/** Represents input to upsert conclusion type. */
export type ConclusionTypeUpsertInput = {
  /** Indicates whether conclusion type is enabled. */
  isActive: Scalars['Boolean']['input'];
  /** Name of the conclusion type. */
  name: Scalars['String']['input'];
  /** Unique identifier of conclusion type. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** The result of confirming a checkout email code. */
export type ConfirmCheckoutEmailVerification = {
  /** Guesses left against the outstanding code. Zero once confirmed, expired, or the guesses are used up - request a new code. */
  attemptsRemaining: Scalars['Int']['output'];
  /** Set only when the verified address's domain matches a tenant that has already verified ownership of it - the ORGANISATION name only, never a colleague's name, a tenant uuid, or any other tenant-internal detail. A non-null value is the signal to offer 'Request access'. Null when unverified, unmatched, or the match lookup failed. */
  matchedOrganisationName?: Maybe<Scalars['String']['output']>;
  /** Whether the address is now confirmed for this checkout session. */
  verified: Scalars['Boolean']['output'];
};

/** Input confirming a checkout buyer controls the email address they supplied. */
export type ConfirmCheckoutEmailVerificationInput = {
  /** Confirmation code from the email. */
  code: Scalars['String']['input'];
  /** Address the code was sent to. */
  email: Scalars['String']['input'];
  /** The checkout session's bearer token. */
  sessionToken: Scalars['String']['input'];
};

/** Represents the result of confirming a code. */
export type ConfirmReporterEmailVerification = {
  /** Guesses left against the outstanding code. Zero once it is confirmed, expired, or the guesses are used up - request a new code. */
  attemptsRemaining: Scalars['Int']['output'];
  /** Whether the address is now confirmed for this session. */
  verified: Scalars['Boolean']['output'];
};

/** Represents the input confirming a reporter controls the address they supplied. */
export type ConfirmReporterEmailVerificationInput = {
  /** Confirmation code from the email. */
  code: Scalars['String']['input'];
  /** Address the code was sent to. */
  email: Scalars['String']['input'];
};

/** Represents the action slot used in conversation with a chat assistant. */
export type ConversationActionSlot = {
  /** Identifier of that action slot. */
  actionId: Scalars['Int']['output'];
  /** Type of the action slot. */
  extraType: Slot_Type;
  /** Text of the action slot. */
  text: Scalars['String']['output'];
  /** Translated action slot text. */
  textTranslated: Scalars['String']['output'];
  /** Type of the legacy action slot. */
  type: Legacy_Slot_Type;
};


/** Represents the action slot used in conversation with a chat assistant. */
export type ConversationActionSlotTextTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

/** Represents the response from the chat assistant. */
export type ConversationAssistantResponse = {
  /** Text responses from the chat assistant. */
  assistantResponses: Array<Scalars['String']['output']>;
  /** Translated assistant responses. */
  assistantResponsesTranslated: Array<Scalars['String']['output']>;
  /** Case unique identifier related to the conversation. */
  caseUuid: Scalars['String']['output'];
  /** Indicates whether the caller has answered the accident description question. */
  isDescribed: Scalars['Boolean']['output'];
  /** Identifier of the slot that should be supplied in the next message to chat assistant. */
  nextSlotId?: Maybe<Scalars['Int']['output']>;
  /** Information about state of current conversation. */
  progress: ConversationProgress;
  /** Action slots related to slot identifier supplied in previous message to the chat assistant. */
  slotOptions?: Maybe<Array<ConversationActionSlot>>;
};


/** Represents the response from the chat assistant. */
export type ConversationAssistantResponseAssistantResponsesTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

/** Represents the case conversation editing settings. */
export type ConversationEditingSettings = {
  /** Indicates whether current user can edit the setting. */
  canEdit: Scalars['Boolean']['output'];
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
};

export type ConversationEditingSettingsInput = {
  /** Indicates whether conversation editing when case is closed should be enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the single message from the conversation with chat assistant. */
export type ConversationMessage = {
  canEdit: Scalars['Boolean']['output'];
  /** Indicates whether the message is from the assistant or reporter. */
  isAssistant: Scalars['Boolean']['output'];
  /** Order of message in the conversation (incremented with each consecutive message). */
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  /** Translated message text. */
  textTranslated: Scalars['String']['output'];
  /** Message text translation override. */
  textTranslatedOverride?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};


/** Represents the single message from the conversation with chat assistant. */
export type ConversationMessageTextTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

export type ConversationProgress = {
  conversationUuid: Scalars['UUID']['output'];
  /** Label for current step of conversation. */
  stepLabel?: Maybe<Scalars['String']['output']>;
  /** Translated step label. */
  stepLabelTranslated?: Maybe<Scalars['String']['output']>;
  /** Index of the current step of the conversation. The numbering starts from `1`, `NULL` means that step order was not set in IBM Watson context before current conversation node. */
  stepOrder?: Maybe<Scalars['Int']['output']>;
  /** Number of steps in conversation. `NULL` means that step count was not set in IBM Watson context before current conversation node. */
  stepsCount?: Maybe<Scalars['Int']['output']>;
};


export type ConversationProgressStepLabelTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

/** Represents the input for user conversation response to chat assistant. */
export type ConversationUserResponseInput = {
  /** Chosen action identifier. */
  actionId?: InputMaybe<Scalars['Int']['input']>;
  /** Case unique identifier. */
  caseUuid: Scalars['String']['input'];
  /** Next action slot identifier. */
  slotId?: InputMaybe<Scalars['Int']['input']>;
  /** List of slot actions responses. */
  slots?: InputMaybe<Array<SlotResponseInput>>;
  /** Response free text or action text. */
  text: Scalars['String']['input'];
};

/** Correct an already-placed order's billing identity. */
export type CorrectOrderBillingIdentityInput = {
  /** Billing address for the invoice. */
  billingAddress: Scalars['String']['input'];
  /** Billing entity legal name. */
  billingEntityName: Scalars['String']['input'];
  /** Invoice recipient email. */
  invoiceRecipientEmail: Scalars['String']['input'];
  /** Invoice recipient's first name. */
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's last name. */
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents case anonymity settings for a specific country. */
export type CountryAnonymity = {
  /** Country code. */
  country: Country_Code;
  /** Settings of incident types regarding anonymity in a specific country. */
  incidentAnonymities: Array<IncidentTypeAnonymity>;
};

/** Represents CountryAnonymity connection edge. */
export type CountryAnonymityEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CountryAnonymity record. */
  node: CountryAnonymity;
};

/** Represents the input for anonymity settings change for a specific country. */
export type CountryAnonymitySettingsInput = {
  /** Country code. */
  country: Country_Code;
  /** Anonymity settings changes for provided unique incident types. */
  incidentAnonymities: Array<IncidentTypeAnonymitySettingsInput>;
};

export type CountryAnonymitySortFields =
  | 'COUNTRY';

export type CountryAnonymitySortInput = {
  direction: SortDirection;
  field: CountryAnonymitySortFields;
};

/** Represents input for validation whether case report can be submited anonymously. */
export type CountryAnonymityValidateInput = {
  /** Unique country code. */
  country: Country_Code;
  /** Unique identifier of incident type. */
  incidentTypeUuid: Scalars['String']['input'];
};

export type CreateAssuranceOrderInput = {
  /** The Beacon answers the price was computed from. Required when serviceId is 'maaudit'. */
  beacon?: InputMaybe<BeaconPriceInput>;
  /** Billing address, printed on the Xero invoice. */
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Billing entity name for the Xero invoice contact; required (the service rejects an order without it). */
  billingEntityName?: InputMaybe<Scalars['String']['input']>;
  /** ISO-2 buyer country (e.g. SG, AU). */
  buyerCountry: Scalars['String']['input'];
  /** The scope answers the Carbon Lens price was computed from. Required when serviceId is 'carbonlens'. */
  carbonLens?: InputMaybe<CarbonLensPriceInput>;
  /** The GreenDesk answers the price was computed from. Required when serviceId is 'greendesk'. */
  greenDesk?: InputMaybe<GreenDeskPriceInput>;
  /** The scope answers the Guardian price was computed from. Required when serviceId is 'guardian'. */
  guardian?: InputMaybe<GuardianPriceInput>;
  /** Invoice-to; defaults to signer. */
  invoiceRecipientEmail?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** The partner audited. Partner Integrity only. */
  partnerIdentity?: InputMaybe<PartnerIdentityInput>;
  /** The Partner Integrity answers the price was computed from. Required when serviceId is 'partnerintegrity'. */
  partnerIntegrity?: InputMaybe<PartnerIntegrityPriceInput>;
  /** Purchase order number, included in the Xero invoice reference. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The RatingsReady answers the price was computed from. Required when serviceId is 'ratingsready'. */
  ratingsReady?: InputMaybe<RatingsReadyPriceInput>;
  /** The customer's registered office address, printed on the agreement. */
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company registration number, printed on the agreement. */
  registeredNumber?: InputMaybe<Scalars['String']['input']>;
  /** The assurance service id ('guardian', 'carbonlens', 'greendesk', 'ratingsready', 'partnerintegrity' or 'maaudit' for Beacon) - the same id the storefront's price query used. */
  serviceId: Scalars['String']['input'];
  /** Signer email. */
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** The company audited. Beacon only. */
  targetIdentity?: InputMaybe<TargetIdentityInput>;
};

export type CreateAuditOrderInput = {
  /** Whether the buyer accepted the Speeki Engage Basic Licence Terms shown for the included framework licence. Required (the service rejects an order without it) only when this audit purchase will actually grant that licence - i.e. the tenant does not already hold the standard. */
  basicLicenceAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The delivery answer the price was computed from: annual or quarterly. Quarterly checkpoints are invoiced quarterly, and are refused at checkout while quarterly billing is not enabled. Absent means annual. */
  billing?: InputMaybe<Scalars['String']['input']>;
  /** Billing address, printed on the Xero invoice. */
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Billing entity name for the Xero invoice contact; required (the service rejects an order without it). */
  billingEntityName?: InputMaybe<Scalars['String']['input']>;
  /** ISO-2 buyer country (e.g. SG, AU). */
  buyerCountry: Scalars['String']['input'];
  /** The Engage-evidence answer the price was computed from. Absent means false. */
  engageEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** ISO audits: the id of a held quote for these same answers. While it is live (30 days) the order is priced at the held figure instead of today's rate card; a hold for different answers is refused. */
  heldQuoteId?: InputMaybe<Scalars['String']['input']>;
  /** ISO audits: a hub proof of the buyer's verified email, needed only to order from a held quote that was bound to that address. */
  heldQuoteProof?: InputMaybe<Scalars['String']['input']>;
  /** SPK audits: the high-risk-subset answer the price was computed from. Not used for an ISO audit. */
  highRisk?: InputMaybe<Scalars['Int']['input']>;
  /** Invoice-to; defaults to signer. */
  invoiceRecipientEmail?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** ISO audits: the sites and reductions the price was computed from - the same input isoCertificationPrice and holdQuote take. Required for an ISO productId unless heldQuoteId is sent for a held quote bound to the buyer's verified address (heldQuoteProof), in which case it may be omitted and the held quote's own answers are used; ignored for an SPK one. */
  iso?: InputMaybe<IsoCertificationPriceInput>;
  /** Evidence per held certificate. Only a certificate with an issuer and an expiry in the current month or later is credited; without evidence nothing is credited. */
  isoEvidence?: InputMaybe<Array<SpkIsoEvidenceInput>>;
  /** Deprecated and ignored: it earns no credit. Send isoEvidence; kept only so a client still sending it keeps working. */
  isoHeld?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Purchase order number, included in the Xero invoice reference. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The audit product id: an SPK audit (e.g. 'csms1000', priced from the SPK scope answers), an ISO certification audit (e.g. 'iso37001', priced from `iso`), a Speeki Certification ('iso37002' or 'iso37008', a set price per year) or 'auditready' - the same id the storefront's price query used. */
  productId: Scalars['String']['input'];
  /** The customer's registered office address, printed on the agreement. */
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company registration number, printed on the agreement. */
  registeredNumber?: InputMaybe<Scalars['String']['input']>;
  /** The rush-start answer the price was computed from. Absent means false. */
  rush?: InputMaybe<Scalars['Boolean']['input']>;
  /** SPK audits: the sector answer the price was computed from. Not used for an ISO audit. */
  sector?: InputMaybe<Scalars['String']['input']>;
  /** Signer email. */
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** Audit Ready: the standards assessed. Required for 'auditready', ignored otherwise. */
  standards?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Speeki Certification: the other certification products certified at the same time (the together-with rate applies when there is one). Absent means none. */
  togetherWith?: InputMaybe<Array<Scalars['String']['input']>>;
  /** SPK audits: the volume answer the price was computed from. Not used for an ISO audit. */
  volume?: InputMaybe<Scalars['Int']['input']>;
  /** The 1, 2 or 3-year commitment answer the price was computed from. Absent means 1. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the input for creating new business unit. */
export type CreateBusinessUnitInput = {
  /** Name of business unit. */
  name: Scalars['String']['input'];
};

/** Input for creating a new chat with chatbot */
export type CreateChatbotInput = {
  /** The UUID of the answer associated with the chat. Optional, answer can be attached later */
  answerUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The related esg question */
  question: Scalars['String']['input'];
};

/** Input for updating a chat with chatbot */
export type CreateChatbotMessageInput = {
  /** The UUID of the chat associated with the message */
  chatbotUuid: Scalars['UUID']['input'];
  /** The message content */
  message: Scalars['String']['input'];
};

export type CreateCheckoutOrderInput = {
  /** Links this order to an accepted plan-approval request - the request must be APPROVED, unlinked, and belong to the caller's tenant. */
  approvalRequestUuid?: InputMaybe<Scalars['String']['input']>;
  /** True when the customer ticked "I Accept" on the Basic Licence terms. REQUIRED to be true when planId is 'limited' - the service refuses the order otherwise (BASIC_LICENCE_NOT_ACCEPTED) and records who accepted, which edition, and when. Ignored on a paid plan, which is bound by the signed Customer Agreement instead. */
  basicLicenceAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Billing address, printed on the Xero invoice. */
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Billing entity name for the Xero invoice contact; required for a paid self-serve order (the service rejects one without it). The Xero contact falls back to the invoice recipient email only for staff-composed or legacy orders. */
  billingEntityName?: InputMaybe<Scalars['String']['input']>;
  /** ISO-2 buyer country (e.g. SG, AU). */
  buyerCountry: Scalars['String']['input'];
  /** Invoice-to; defaults to signer. */
  invoiceRecipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's first name. Optional - printed on the Xero contact when given. */
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's last name. Optional - printed on the Xero contact when given. */
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
  items: Array<CheckoutItemInput>;
  /** The chosen catalogue plan id (e.g. 'limited', 'standard') - sizes seats/Nicole and gates signature on price. */
  planId: Scalars['String']['input'];
  /** Purchase order number, included in the Xero invoice reference. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The customer's registered office address, printed on the agreement. Distinct from billingAddress, which is where the invoice goes - the two are frequently different and must not be conflated. */
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company registration number (UEN, CRN or local equivalent), printed on the agreement. Free text: the format differs per jurisdiction. */
  registeredNumber?: InputMaybe<Scalars['String']['input']>;
  /** Signer email. */
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** Subscription term in years (1, 2 or 3). Required starting a NEW_PERIOD paid subscription; forbidden for a CO_TERMINOUS follower or the free tier - see the checkoutTermsContext query. */
  term?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for starting a new checkout session. */
export type CreateCheckoutSessionInput = {
  /** Buyer-entered fields, opaque JSON encoded as a string. */
  draft?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

/** The result of starting a checkout session: the bearer token (shown once) and the session's public view. */
export type CreateCheckoutSessionPayload = {
  session: CheckoutSessionView;
  /** The bearer token for this session. Store it client-side; it cannot be retrieved again. */
  token: Scalars['String']['output'];
};

export type CreateCourseOrderInput = {
  /** Billing address, printed on the Xero invoice. */
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Billing entity name for the Xero invoice contact; required (the service rejects an order without it). */
  billingEntityName?: InputMaybe<Scalars['String']['input']>;
  /** ISO-2 buyer country (e.g. SG, AU). */
  buyerCountry: Scalars['String']['input'];
  /** The course slug from the execEdCourses list. The course, its length and its fee are all read from that list on the server; nothing else about the price is accepted. */
  courseSlug: Scalars['String']['input'];
  /** 'On-site' or 'Remote'. */
  delivery?: InputMaybe<Scalars['String']['input']>;
  /** Invoice-to; defaults to signer. */
  invoiceRecipientEmail?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** Purchase order number, included in the Xero invoice reference. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** When the buyer would like the training, as YYYY-MM. */
  preferredMonth?: InputMaybe<Scalars['String']['input']>;
  /** The customer's registered office address, printed on the agreement. */
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company registration number, printed on the agreement. */
  registeredNumber?: InputMaybe<Scalars['String']['input']>;
  /** Signer email. */
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** How many people will attend (1 to 20). */
  teamSize?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePlanUpgradeOrderInput = {
  /** Billing address, printed on the Xero invoice. Falls back to the tenant's stored billing identity. */
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Billing entity name for the Xero invoice contact. Falls back to the tenant's stored billing identity. */
  billingEntityName?: InputMaybe<Scalars['String']['input']>;
  /** Invoice-to. Omitted, it falls back to the invoice recipient on the tenant's stored billing identity, and only then to signerEmail - naming a signer never redirects the invoice away from a recipient already on file. */
  invoiceRecipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's first name. Optional - printed on the Xero contact when given. */
  invoiceRecipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Invoice recipient's last name. Optional - printed on the Xero contact when given. */
  invoiceRecipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** Purchase order number for THIS upgrade, included in the Xero invoice reference. Never inherited from an earlier order. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** The customer's registered office address, printed on the Order Form. Distinct from billingAddress, which is where the invoice goes. Falls back to the tenant's stored billing identity. */
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company registration number (UEN, CRN or local equivalent), printed on the Order Form. Free text: the format differs per jurisdiction. Falls back to the tenant's stored billing identity. */
  registeredNumber?: InputMaybe<Scalars['String']['input']>;
  /** The riskAreaUuids of the owned standards the customer selected to move to the target tier. Each must currently be on a tier strictly below the target. */
  selectedRefs: Array<Scalars['ID']['input']>;
  /** Who signs the Order Form. Omitted, the agreement is sent to the invoice recipient below - the same signer-defaults-to-recipient rule the signature step already applies. */
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** The catalogue plan id to upgrade to. */
  targetTier: Scalars['ID']['input'];
};

export type CustomPlanUpdateInput = {
  /** Carbon Lens module enabled flag. */
  carbonLens?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cases module enabled flag. */
  cases?: InputMaybe<Scalars['Boolean']['input']>;
  /** Demo module enabled flag. */
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disclosures module enabled flag. */
  disclosures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Due Diligence module enabled flag. */
  dueDiligence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Esg module enabled flag. */
  esg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feature update input. */
  features?: InputMaybe<FeatureUpdateInput>;
  /** Frameworks module enabled flag. */
  frameworks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Insights module enabled flag. */
  insights?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nicole GPT module enabled flag. */
  nicoleGpt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sso module enabled flag. */
  sso?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subsidiaries module enabled flag. */
  subsidiarySites?: InputMaybe<Scalars['Boolean']['input']>;
  /** Surveys module enabled flag. */
  surveys?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tasks module enabled flag. */
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Teams module enabled flag. */
  teams?: InputMaybe<Scalars['Boolean']['input']>;
  /** Edited custom plan's tenant uuid */
  tenantUuid: Scalars['ID']['input'];
  /** Trainings module enabled flag. */
  trainings?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The standing Speeki Customer Agreement - the exact edition a buyer signing today would be bound to. Editions are immutable: a new edition is a new document, never an edit of an existing one. */
export type CustomerAgreement = {
  /** Edition identifier of the agreement being served, e.g. "2026-07". This is the same value an order freezes as its termsVersion when its envelope is sent, so what a buyer read stays traceable to what they signed. */
  edition: Scalars['String']['output'];
  /** The edition's human-readable title, naming the document and the month it took effect, for display above the text. */
  title: Scalars['String']['output'];
  /** The full agreement as TRUSTED STATIC HTML, authored in this repository and served verbatim - it is never user-supplied content. It is already markup, so a client must embed it as HTML rather than HTML-escape it; that is safe for THIS field only, and the same path must never be reused for caller-supplied text. */
  trustedHtml: Scalars['String']['output'];
};

/** One line in the customer's own invoice history: an invoice that has been raised, or a billing record this view cannot price (kind RECORD_ONLY - contact support for detail; never an amount owed). Only invoices that exist are listed - a year the signed term still owes has not been invoiced and is not a row here; the term and each year's amount are stated on Order.commitment instead. Money is a string throughout to avoid float loss, and each row states its own tax basis in `taxBasis` - the basis is frozen per order, so a history spanning several purchases can legitimately mix the two. The invoice document itself remains the tax record. */
export type CustomerInvoice = {
  /** What this period charges, on the basis stated in `taxBasis` (money as a string). Null exactly on a RECORD_ONLY row: this view could not state an amount for it, which is the entire reason it is RECORD_ONLY rather than RAISED. */
  amount?: Maybe<Scalars['String']['output']>;
  /** ISO-4217 code the amount is denominated in. Null exactly on a RECORD_ONLY row - see `amount`. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Whether Query.myInvoicePdf has a document to return for this row - true whenever an accounting-system invoice id was actually recorded for it. True on a RECORD_ONLY row whose invoice WAS raised: the document exists and is offered even though the row states no amount, because being unable to price a record here is no reason to withhold the invoice the customer was issued. False on one whose invoice was never raised. Read this before offering a download rather than reacting to myInvoicePdf's error. */
  downloadable: Scalars['Boolean']['output'];
  /** The date this period's billing is anchored to - the term anniversary the list is sorted on. It is NOT the payment term printed on the invoice: read `paymentDueDate` for the date the customer must pay by. On a RECORD_ONLY row this is the activation period's start when resolvable, else the order's own createdAt - the sort this list is returned in needs a date from every row, and createdAt is the one date every order actually has. */
  dueDate: Scalars['DateTime']['output'];
  /** Which share of a split-payment order this invoice bills, in plain words: "Start instalment: 60% of the fee" on the invoice raised at signing, "Delivery instalment: 40% of the fee" on the one raised at delivery. The same start label is on the later annual rows of a split order, which bill the start share too. Null on every row of an order that is not split, on every row of a quarterly order, and on a RECORD_ONLY row. */
  instalmentLabel?: Maybe<Scalars['String']['output']>;
  /** The human invoice number printed on the document, e.g. "INV-0041" - what a customer quotes to support or their finance team. Read live from the accounting system, so it is null whenever no number can be stated: a row with no invoice recorded (the same rows `downloadable` is false for - a RECORD_ONLY row nothing has been raised for, or a raised row whose invoice id is not recorded yet), an accounting system that could not be reached, or an invoice it has not numbered yet. Never inferred and never a row identity - use `ref` for that. Resolved lazily: selecting it costs one read per row, and nothing extra when `paymentStatus` is selected alongside it, since both share the same cached read. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** When the invoice was issued. Null on a RECORD_ONLY row, which has no issue date this view can state - and null on the activation row too, whose issue date the order does not record. */
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Either "RAISED" (an invoice exists and this view can state its money) or "RECORD_ONLY" (a billing record exists but this view cannot price it - contact support; never an amount owed). Only a RAISED row has a payment state read from the accounting system; a RECORD_ONLY row states its own, and which one it states is meaningful - UNAVAILABLE when its invoice was raised but this view could not price it, NOT_GENERATED when a period that has come around has no invoice at all. Do NOT infer downloadability from this: a RECORD_ONLY row whose invoice was in fact raised is downloadable even though it states no amount, so read `downloadable` itself. */
  kind: Scalars['String']['output'];
  /** The order this invoice belongs to, so the caller can group a history that spans several purchases. */
  orderUuid: Scalars['String']['output'];
  /** The date payment is actually due, as printed on the invoice document. Distinct from `dueDate`, which is the period's start (the list's sort anchor). Read live from the accounting system, so it is null whenever it cannot be stated: no invoice recorded for the row, the accounting system could not be reached, or the invoice carries no due date. Never inferred from the period. Resolved lazily: selecting it costs nothing extra when `paymentStatus` or `invoiceNumber` is selected alongside it, since they share the same cached read. */
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
  /** This invoice's payment state in plain language (PROCESSING, AWAITING_PAYMENT, PAID, CREDITED, VOIDED, UNKNOWN, UNAVAILABLE, NOT_GENERATED), read from the accounting system on demand for an invoice that has actually been raised. UNKNOWN means the accounting system could not be reached - never that nothing is owed. NOT_GENERATED means a period that has already come around has no invoice: the accounting system holds no document for it, which is a fact rather than a failure, and `downloadable` is false for the same reason. It never describes a year that has not arrived - no such row exists in this list. UNAVAILABLE is the answer for a RECORD_ONLY row whose invoice WAS raised but whose amount this view could not state - there is no figure to have a payment state at all, and the PDF carries it instead. Resolved lazily: selecting it costs one read per row. */
  paymentStatus: Scalars['String']['output'];
  /** The day the next period begins - exclusive of this one, UTC. The same boundary the invoice line prints. Null exactly on a RECORD_ONLY row whose period could not be resolved - see `periodStart`. */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** First covered day of the period this invoice bills, UTC. Null exactly on a RECORD_ONLY row whose period could not be resolved (e.g. a pre-anchorMode legacy order) - the row still exists, but this view has no window to state. */
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  /** Stable identifier for this row within the caller's own history. For a raised annual invoice it is the order uuid and period index; for the activation invoice (RAISED or RECORD_ONLY) it is the order uuid on its own. Not an accounting-system id. */
  ref: Scalars['String']['output'];
  /** Whether `amount` already contains Sales Tax: "INCLUSIVE" (the amount contains any tax) or "EXCLUSIVE" (the amount is a subtotal and tax is added on the invoice). Frozen per order at checkout, so one history can mix the two; amounts are never converted between bases. Null exactly on a RECORD_ONLY row, which has no amount to state a basis for. */
  taxBasis?: Maybe<Scalars['String']['output']>;
};

/** The caller's own invoice history: every invoice myInvoices can currently state, plus whether the list is truncated. Wrapped rather than a bare list so truncation - a fact about the WHOLE history, not any one row - has somewhere honest to live. */
export type CustomerInvoiceHistory = {
  /** The invoice rows themselves, newest due date first. See CustomerInvoice's own doc for what RAISED and RECORD_ONLY each mean. */
  rows: Array<CustomerInvoice>;
  /** True when the claimed-invoice read hit its cap (TENANT_INVOICES_READ_CAP), which means older invoices this tenant really was issued are missing from `rows`: the read returns the newest rows by due date, so the ones it dropped are the oldest. Stated rather than left to be inferred, because a partial invoice history reads exactly like a complete one. False well below the cap; a tenant that reaches it needs a paginated invoice history, not a bigger number. */
  truncated: Scalars['Boolean']['output'];
};

/** One raised invoice's PDF document, read live from the billing provider (see Query.myInvoicePdf). Base64-encoded rather than a URL: the shop has no public HTTP surface outside its federated GraphQL endpoint, so the document travels inline in the response instead of a link a browser could fetch directly. */
export type CustomerInvoicePdf = {
  /** The invoice PDF, base64-encoded. */
  contentBase64: Scalars['String']['output'];
  /** A suggested filename for the downloaded document, derived from the invoice's own ref - not the provider's invoice number, which this type never carries (see CustomerInvoice.xeroInvoiceId's doc). */
  filename: Scalars['String']['output'];
};

/** Disclosure respondent type */
export type Disclosure_Respondent_Type =
  | 'INDIVIDUAL'
  | 'ORGANIZATION';

export type Disclosure_Response_Approval_Status =
  | 'APPROVED'
  | 'DISAPPROVED'
  | 'NONE';

export type DataCategory = {
  category: Scalars['String']['output'];
  /** Date of category creation */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who created category. */
  createdBy?: Maybe<UserType>;
  /** Date of category last update */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated category. */
  lastUpdatedBy?: Maybe<UserType>;
  /** UUID of category */
  uuid: Scalars['ID']['output'];
};

/** Represents input for fetching data category by category name. */
export type DataCategoryByNameInput = {
  category: Scalars['String']['input'];
};

/** Represents input for fetching data category by uuid. */
export type DataCategoryByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents DataCategoryConnection connection. */
export type DataCategoryConnection = {
  /** Array of edges. */
  edges: Array<DataCategoryEdge>;
  /** Array of direct nodes. */
  nodes: Array<DataCategory>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type DataCategoryConnectionInput = {
  /** Data category name filter */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<DataCategorySortInput>>;
};

export type DataCategoryCreateInput = {
  /** Represents input for creating category. If name duplicate is detected will return existing category. */
  category: Scalars['String']['input'];
};

/** Represents input for batch create of data categories. On duplicate will return existing records. */
export type DataCategoryCreateManyInput = {
  data: Array<DataCategoryCreateInput>;
};

/** Represents DataCategory connection edge. */
export type DataCategoryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the DataCategory record. */
  node: DataCategory;
};

export type DataCategorySortFields =
  | 'CATEGORY';

export type DataCategorySortInput = {
  direction: SortDirection;
  field: DataCategorySortFields;
};

/** Represents input for deleting Metric Data. */
export type DeleteMetricDataInput = {
  /** Uuid of metric data */
  uuid: Scalars['UUID']['input'];
};

/** Represents input for deleting Metric. */
export type DeleteMetricInput = {
  /** Uuid of metric */
  uuid: Scalars['UUID']['input'];
};

/** Represents input for deleting Symbol. */
export type DeleteSymbolInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents input for task deleting task. */
export type DeleteTaskInput = {
  uuid: Scalars['UUID']['input'];
};

/** Input to delete year. */
export type DeleteYearInput = {
  /** Given year uuid. */
  uuid: Scalars['UUID']['input'];
};

export type DictionaryTranslationInput = {
  /** Type of requested dictionary. */
  dictionaryType: DictionaryType;
  /** Target translation language. */
  targetLanguage?: InputMaybe<LanguageCode>;
};

export type DictionaryType =
  | 'CASE_STATUS'
  | 'COUNTRIES'
  | 'USER_RELATIONSHIP'
  | 'USER_STATUS'
  | 'USER_TYPE';

/** Represents the disclosure object. */
export type Disclosure = StakeholderEngagementCommonData & {
  /** Number of users who have submitted response to disclosure */
  applicantsNumber?: Maybe<Scalars['Int']['output']>;
  /** Survey audience type */
  audienceType: SurveyAudienceType;
  /** Flag indicating if user can answer a given disclosure. Accessible by employees only. */
  canAnswer?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if user can edit or delete disclosure. */
  canEdit: Scalars['Boolean']['output'];
  /** List of audience countries. */
  countries?: Maybe<Array<SurveyCountry>>;
  /** Date of survey creation. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Survey/Disclosure description. */
  description?: Maybe<Scalars['String']['output']>;
  emailTargets: Array<DisclosureEmailTarget>;
  /** Flag indicating if user has answered a given disclosure. Accessible by employees only. */
  hasAnswered?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if Disclosure has any new responses */
  hasNewAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if user is the author of engagement form. */
  isAuthor: Scalars['Boolean']['output'];
  /** Survey questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['output'];
  /** Date of last disclosure submission */
  lastResponded?: Maybe<Scalars['DateTime']['output']>;
  /** Survey/Disclosure name. */
  name: Scalars['String']['output'];
  /** List of audience relationships. */
  relationships?: Maybe<Array<SurveyUserRelationship>>;
  /** Disclosure respondent type */
  respondentType: Disclosure_Respondent_Type;
  /** Number of disclosure responses. */
  responseCount?: Maybe<Scalars['Int']['output']>;
  /** Resolves disclosure responses. */
  responses: Array<DisclosureResponse>;
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Disclosure status */
  status?: Maybe<DisclosureStatus>;
  /** Last update of the survey data. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of submitted responses. Accessible by employees only. */
  userResponseCount?: Maybe<Scalars['Int']['output']>;
  /** Survey/Disclosure unique identifier. */
  uuid: Scalars['ID']['output'];
};


/** Represents the disclosure object. */
export type DisclosureEmailTargetsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents pagination input for disclosure admin list. */
export type DisclosureAdminListConnectionInput = {
  /** Additional filters for query. */
  filterInput?: InputMaybe<DisclosureFilterInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Filters response by type of respondend if provided */
  respondentTypes?: InputMaybe<Array<Disclosure_Respondent_Type>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<DisclosureSortInput>>;
  /** Text to filter results matching disclosure `name`, `description`. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the disclosure change status input type */
export type DisclosureChangeStatusInput = {
  /** Disclosure status. */
  status: DisclosureStatus;
  /** Edited disclosure unique identifier. */
  uuid: Scalars['ID']['input'];
};

export type DisclosureChatNotificationExtra = {
  disclosureUuid: Scalars['UUID']['output'];
};

/** Represents the singular `DisclosureCommentFieldInput` order input object. */
export type DisclosureCommentFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: DisclosureCommentOrderField;
};

export type DisclosureCommentOrderField =
  | 'createdAt';

/** Represents the input type for ordering the list of comment disclosures. By default, the list is ordered by creation date descending. */
export type DisclosureCommentOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<DisclosureCommentFieldInput>;
};

/** Represents the input type for the comment upsert */
export type DisclosureCommentUpsertInput = {
  content: Scalars['String']['input'];
  /** Disclosure response uuid */
  responseUuid: Scalars['ID']['input'];
  /** Disclosure response comment uuid, used for editing existing comments. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents the list of paginated disclosure response comments. */
export type DisclosureCommentsPaginated = {
  /** Pages of data `edges` and page meta `info`. */
  page: DisclosureResponseCommentPage;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents DisclosureConnection connection. */
export type DisclosureConnection = {
  /** Array of edges. */
  edges: Array<V2DisclosureEdge>;
  /** Array of direct nodes. */
  nodes: Array<Disclosure>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Represents the disclosures overall statistics. */
  statistics?: Maybe<DisclosureStatistics>;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input for deleting disclosures */
export type DisclosureDeleteInput = {
  /** Uuids of disclosures to delete */
  disclosureUuids: Array<Scalars['UUID']['input']>;
};

/** Represents the edge container of paginated `Disclosure` data. */
export type DisclosureEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: Disclosure;
};

export type DisclosureEmailTarget = {
  /** Flag indicating if given email responded. */
  answered: Scalars['Boolean']['output'];
  /** Email */
  email: Scalars['String']['output'];
  /** Flag indicating if email has been sent to given target. */
  sent: Scalars['Boolean']['output'];
  /** UUID of email target. */
  uuid: Scalars['ID']['output'];
};

/** Represents the filter input for the list of disclosures. */
export type DisclosureFilterInput = {
  /** Filter the disclosure matching given countries. */
  countries?: InputMaybe<Array<SurveyCountry>>;
  /** Filter the disclosures matching given relationships. */
  relationships?: InputMaybe<Array<SurveyUserRelationship>>;
  /**
   * Uuid of risk area to return only disclosures assigned to given risk area.
   * @deprecated use DisclosureFilterInputriskAreaUuids instead
   */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Uuid of risk area to return only disclosures assigned to given risk area. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter active, inactive or draft disclosures. */
  statuses?: InputMaybe<Array<DisclosureStatus>>;
};

export type DisclosureOrderField =
  | 'applicantsNumber'
  | 'countries'
  | 'createdAt'
  | 'lastResponded'
  | 'name'
  | 'relationships'
  | 'responseCount'
  | 'status'
  | 'updatedAt';

/** Represents the singular `DisclosureOrderFieldInput` order input object. */
export type DisclosureOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: DisclosureOrderField;
};

/** Represents the input type for ordering the list of disclosures. */
export type DisclosureOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<DisclosureOrderFieldInput>;
};

/** Represents the page container of paginated `Disclosure` data. */
export type DisclosurePage = {
  /** List of edges. */
  edges?: Maybe<Array<DisclosureEdge>>;
  /** Page information. */
  info: PageInfo;
};

/** Represents the list of paginated disclosure objects. */
export type DisclosurePaginated = {
  /** Pages of data `edges` and page meta `info`. */
  page: DisclosurePage;
  /** Represents the disclosure overall statistics. */
  statistics?: Maybe<DisclosureStatistics>;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents pagination input for disclosure reponders list */
export type DisclosureRespondersConnectionInput = {
  /** UUID of disclosure. */
  disclosureUuid: Scalars['UUID']['input'];
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Text search by first name, last name and organizationName */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<DisclosureUserSortInput>>;
};

/** Represents the disclosure response object. */
export type DisclosureResponse = {
  /** Returns reason for approval status. */
  approvalReason?: Maybe<Scalars['String']['output']>;
  /** Field indicating approval status of disclosure response. */
  approvalStatus: Disclosure_Response_Approval_Status;
  /** Secret key for chat messages encryption/decryption */
  chatRoomSecret?: Maybe<Scalars['String']['output']>;
  /** Number of disclosure responses. */
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Responders contact email. Accessible only by tenant admins. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Date when response was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Responders first name. Accessible only by tenant admins. */
  createdByFirstName?: Maybe<Scalars['String']['output']>;
  /** Responders last name. Accessible only by tenant admins. */
  createdByLastName?: Maybe<Scalars['String']['output']>;
  /** UUID of survey responder. Accessible only by tenant admins. */
  createdByUuid?: Maybe<Scalars['String']['output']>;
  /** Resolve response's disclosure. */
  disclosure: Disclosure;
  /** Original disclosure json. Accessible by tenant admins. */
  disclosureJson?: Maybe<Scalars['JSON']['output']>;
  disclosureUuid: Scalars['String']['output'];
  /** Flag indicating if Disclosure Response is new and has not been read. */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Response json object. */
  json: Scalars['JSON']['output'];
  /** Responders contact phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Source of response. Accessible only by tenant admins. */
  source?: Maybe<SurveyUserSource>;
  /** Represents the UUID of response. */
  uuid: Scalars['ID']['output'];
};

export type DisclosureResponseAdminConnectionInput = {
  disclosureUuid: Scalars['UUID']['input'];
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<DisclosureResponseSortInput>>;
  /** The UUID of the user to filter responses by */
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DisclosureResponseApproveInput = {
  /** Flag indicating if disclosure response is approved or disapproved */
  isApproved: Scalars['Boolean']['input'];
  /** Reason for approval or disapproval. */
  reason: Scalars['String']['input'];
  /** UUID of updated disclosure response. */
  responseUuid: Scalars['UUID']['input'];
};

/** Object representing disclosure response comment */
export type DisclosureResponseComment = {
  /** Field indicating if resolved comment changed the approval status of disclosure response. */
  approvalStatus: Disclosure_Response_Approval_Status;
  /** Resolves comment's author. */
  commentedBy?: Maybe<UserType>;
  /** Comment contents. */
  content: Scalars['String']['output'];
  /** Comment submission date. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Comment's author.
   * @deprecated Deprecated, use `commentedBy`
   */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if comment has been updated. */
  isEdited: Scalars['Boolean']['output'];
  isMyComment: Scalars['Boolean']['output'];
  /** Comment edit date. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Comment unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the edge container of paginated `DisclosureResponseComment` data. */
export type DisclosureResponseCommentEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: DisclosureResponseComment;
};

/** Represents the page container of paginated `DisclosureResponseComment` data. */
export type DisclosureResponseCommentPage = {
  /** List of edges. */
  edges?: Maybe<Array<DisclosureResponseCommentEdge>>;
  /** Page information. */
  info: PageInfo;
};

/** Represents DisclosureResponseConnection connection. */
export type DisclosureResponseConnection = {
  disclosureData: Disclosure;
  /** Array of edges. */
  edges: Array<V2DisclosureResponseEdge>;
  /** Array of direct nodes. */
  nodes: Array<DisclosureResponse>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type DisclosureResponseConnectionInput = {
  disclosureUuid: Scalars['UUID']['input'];
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<DisclosureResponseSortInput>>;
};

/** Represents the edge container of paginated `DisclosureResponse` data. */
export type DisclosureResponseEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: DisclosureResponse;
};

/** Represents the input type for disclosure response input */
export type DisclosureResponseInput = {
  disclosureUuid: Scalars['ID']['input'];
  /** Files related to survey template questions */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Disclosure response JSON. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['input'];
};

/** Represents the singular `DisclosureResponseOrderByInput` order input object. */
export type DisclosureResponseOrderByInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: DisclosureResponseOrderField;
};

export type DisclosureResponseOrderField =
  | 'commentCount'
  | 'createdAt'
  | 'source'
  | 'updatedAt';

/** Represents the input type for ordering the list of disclosure responses. By default, the list is ordered by creation date descending */
export type DisclosureResponseOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<DisclosureResponseOrderByInput>;
};

/** Represents the page container of paginated `DisclosureResponse` data. */
export type DisclosureResponsePage = {
  /** List of edges. */
  edges?: Maybe<Array<DisclosureResponseEdge>>;
  /** Page information. */
  info: PageInfo;
};

export type DisclosureResponseSortFields =
  | 'COMMENT_COUNT'
  | 'CREATED_AT'
  | 'SOURCE'
  | 'UPDATED_AT';

export type DisclosureResponseSortInput = {
  direction: SortDirection;
  field: DisclosureResponseSortFields;
};

/** Represents a list of paginated disclosure responses. */
export type DisclosureResponsesPaginated = {
  /** Original disclosure data */
  disclosureData: Disclosure;
  /** @deprecated This field is deprecated and will soon be removed. Please use disclosureData for original disclosure details. */
  disclosureJson: Scalars['JSON']['output'];
  /** Pages of data `edges` and page meta `info`. */
  page: DisclosureResponsePage;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents the disclosure risk areas upsert input type. */
export type DisclosureRiskAreasUpsertInput = {
  /** array of risk area uuids */
  riskAreaUuids: Array<Scalars['UUID']['input']>;
  /** disclosure uuid. */
  uuid: Scalars['UUID']['input'];
};

export type DisclosureSortFields =
  | 'APPLICANTS_NUMBER'
  | 'COUNTRIES'
  | 'CREATED_AT'
  | 'LAST_RESPONDED'
  | 'LAST_UPDATED_AT'
  | 'NAME'
  | 'RELATIONSHIPS'
  | 'RESPONDENT_TYPE'
  | 'RESPONSE_COUNT'
  | 'STATUS';

export type DisclosureSortInput = {
  direction: SortDirection;
  field: DisclosureSortFields;
};

/** Represents disclosures list statistics */
export type DisclosureStatistics = {
  /** Number of approved statistics */
  approvedCount?: Maybe<Scalars['Int']['output']>;
  /** Number of disclosures */
  disclosuresCount?: Maybe<Scalars['Int']['output']>;
  /** Number of new disclosure responses */
  newAnswersCount?: Maybe<Scalars['Int']['output']>;
  /** Number of disclosure responses */
  responsesCount?: Maybe<Scalars['Int']['output']>;
  /** Number of users who responded to disclosures */
  usersCount?: Maybe<Scalars['Int']['output']>;
};

export type DisclosureStatus =
  | 'ACTIVE'
  | 'DRAFT'
  | 'INACTIVE';

/** Represents the disclosure upsert input type. */
export type DisclosureUpsertInput = {
  /** Type of disclosure audience, by email list or by country and relationship to company */
  audienceType?: SurveyAudienceType;
  /** Edited or new disclosure countries array. */
  countries?: InputMaybe<Array<SurveyCountry>>;
  /** Edited or new disclosure description. */
  description?: InputMaybe<Scalars['String']['input']>;
  emailAudienceInput?: InputMaybe<EmailAudienceInput>;
  /** Files related to survey questions */
  files?: InputMaybe<Array<NamedUpload>>;
  json: Scalars['JSON']['input'];
  /** Edited or new disclosure name. */
  name: Scalars['String']['input'];
  /** Edited or new disclosure relationships array. */
  relationships?: InputMaybe<Array<SurveyUserRelationship>>;
  /** Disclosure respondent type. If not provided INDIVIDUAL will be used */
  respondentType?: Disclosure_Respondent_Type;
  /** Disclosure status. */
  status?: InputMaybe<DisclosureStatus>;
  /** Edited disclosure unique identifier. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents single user with responses count and last submitted response date for disclosure user list */
export type DisclosureUser = {
  /** Number of approved responses. */
  approvedCount: Scalars['Int']['output'];
  /** User email */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** User country */
  country?: Maybe<SurveyCountry>;
  /** Number of disapproved responses. */
  disapprovedCount: Scalars['Int']['output'];
  /** User first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if user has any new forms. */
  hasNewAnswers: Scalars['Boolean']['output'];
  /** User last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Last submitted date */
  lastSubmittedDate: Scalars['DateTime']['output'];
  /** Name of organization user is representing */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Users role in organization */
  organizationRole?: Maybe<Scalars['String']['output']>;
  /** User phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Resolves disclosure responses. */
  responses: Array<DisclosureResponse>;
  /** Number of submitted responses */
  submittedResponsesCount: Scalars['Float']['output'];
  /** User UUID */
  uuid: Scalars['ID']['output'];
};

/** Represents DisclosureUserConnection connection. */
export type DisclosureUserConnection = {
  /** Array of edges. */
  edges: Array<DisclosureUserEdge>;
  /** Array of direct nodes. */
  nodes: Array<DisclosureUser>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for disclosure user list. */
export type DisclosureUserConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Filters response by type of respondend if provided */
  respondentTypes?: InputMaybe<Array<Disclosure_Respondent_Type>>;
  /** Uuid of risk area to return only disclosures assigned to given risk area. When no value is provided all standard templates will be returned. */
  riskAreaUuid?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<DisclosureUserSortInputSortInput>>;
  /** Text to filter results matching disclosure `name`, `description`. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Represents DisclosureUser connection edge. */
export type DisclosureUserEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the DisclosureUser record. */
  node: DisclosureUser;
};

export type DisclosureUserOrderField =
  | 'name';

/** Represents the singular `DisclosureUserOrderFieldInput` order input object. */
export type DisclosureUserOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: DisclosureUserOrderField;
};

/** Represents the input type for ordering the list of disclosures for employee type user. */
export type DisclosureUserOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<DisclosureUserOrderFieldInput>;
};

export type DisclosureUserSortFields =
  | 'approvedCount'
  | 'country'
  | 'countryCode'
  | 'disapprovedCount'
  | 'email'
  | 'firstName'
  | 'fullPhoneNumber'
  | 'hasNewAnswers'
  | 'lastName'
  | 'lastSubmittedDate'
  | 'organizationName'
  | 'organizationRole'
  | 'phoneNumber'
  | 'submittedResponsesCount';

export type DisclosureUserSortInput = {
  direction: SortDirection;
  field: DisclosureUserSortFields;
};

export type DisclosureUserSortInputSortFields =
  | 'CREATED_AT'
  | 'LAST_UPDATED_AT'
  | 'NAME';

export type DisclosureUserSortInputSortInput = {
  direction: SortDirection;
  field: DisclosureUserSortInputSortFields;
};

export type DynamicTranslationInput = {
  /** Optional source language. If missing will google translate detection will be used. */
  sourceLanguage?: InputMaybe<LanguageCode>;
  /** Optional target language. If missing will use the one from user context data if present. */
  targetLanguage?: InputMaybe<LanguageCode>;
};

export type Entitlement_Item_Kind =
  | 'MODULE'
  | 'STANDARD';

export type Entitlement_Item_State =
  | 'AVAILABLE'
  | 'OWNED'
  | 'PENDING_ORDER';

export type Entitlement_Tier =
  | 'ENHANCED'
  | 'ENTERPRISE'
  | 'LIMITED'
  | 'STANDARD';

/** Represents GroupTag connection edge. */
export type EsgGroupTagEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the GroupTag record. */
  node: GroupTag;
};

export type Esg_Category =
  | 'ENVIRONMENTAL'
  | 'GENERAL'
  | 'GOVERNANCE'
  | 'SOCIAL'
  | 'STANDARDS';

export type Esg_Category_Type =
  | 'ENGAGE'
  | 'GENERAL'
  | 'STANDARDS';

export type Esg_Questionnaire_Filter =
  | 'QUESTION_STATUSES_ANSWERED'
  | 'QUESTION_STATUSES_UNANSWERED'
  | 'QUESTION_TASK_RELATION_WITHOUT_TASKS'
  | 'QUESTION_TASK_RELATION_WITH_TASKS'
  | 'TASK_STATUSES_COMPLETED'
  | 'TASK_STATUSES_IN_PROGRESS'
  | 'TASK_STATUSES_OPEN';

export type Esg_Question_Activity =
  | 'ACCOUNTABILITY'
  | 'ACCOUNTABILITY_IN_CORPORATE_GOVERNANCE'
  | 'ACCOUNTABILITY_OF_TOP_MANAGEMENT'
  | 'ACTIONS_TAKEN'
  | 'ADAPTING_BUSINESS_OPERATIONS'
  | 'ADJUSTMENTS_DUE_TO_SPECIFIC_CIRCUMSTANCES'
  | 'ALIGN_REMUNERATION_POLICIES_WITH_SUSTAINABILITY_GOALS'
  | 'ALLOCATE_FINANCIAL_AND_HUMAN_RESOURCES'
  | 'ASSESSMENTS'
  | 'ASSESS_FORCED_LABOUR_AND_SUPPLY_CHAIN_RISKS'
  | 'ASSESS_GOVERNANCE_CONTEXT'
  | 'ASSESS_LIKELIHOOD_AND_IMPACT_OF_RISKS'
  | 'ASSIGN_OWNERSHIP_FOR_KEY_ABAC_TASKS_AND_PROCESSES'
  | 'ASSIGN_RESOURCES_AND_RESPONSIBILITIES'
  | 'ASSIGN_RESPONSIBILITIES'
  | 'ASSIGN_ROLES_AND_RESPONSIBILITIES'
  | 'AUDITS'
  | 'AUDITS_AND_ASSESSMENTS'
  | 'AUDITS_AND_INSPECTIONS'
  | 'AWARENESS'
  | 'BENCHMARKING'
  | 'BENCHMARKING_TRANSPARENCY_PRACTICES'
  | 'BENCHMARK_AGAINST_BEST_PRACTICES'
  | 'BUDGET_PLANNING'
  | 'BUILDING_STAKEHOLDER_SUPPORT_BUY_IN'
  | 'CAPACITY_BUILDING'
  | 'CERTIFICATIONS'
  | 'COLLECT_AND_ANALYSE_DATA_ON_KPIS'
  | 'COMMUNICATE_ABAC_POLICIES_AND_AWARENESS'
  | 'COMMUNICATE_GOVERNANCE_GOALS'
  | 'COMMUNICATE_POLICIES_AND_EXPECTATIONS_TO_STAKEHOLDERS'
  | 'COMMUNICATIONS'
  | 'COMMUNICATION_AND_AWARENESS_CAMPAIGN'
  | 'COMMUNICATION_STRATEGY'
  | 'COMPANY_OVERVIEW'
  | 'COMPETENCIES'
  | 'CONDUCT_AUDITS'
  | 'CONDUCT_A_GAP_ANALYSIS_OF_CURRENT_COMPANY_PRACTICES'
  | 'CONDUCT_A_RISK_ASSESSMENT'
  | 'CONDUCT_DUE_DILIGENCE_ON_HIGH_RISK_REGIONS_AND_SUPPLIERS'
  | 'CONDUCT_RISK_BASED_AUDITS'
  | 'CONTACT_DETAILS'
  | 'CONTEXT'
  | 'CONTINUAL_IMPROVEMENT'
  | 'CONTROLS'
  | 'CREATE_APPROVAL_PROCESSES_FOR_GIFTS_AND_HOSPITALITY'
  | 'CREATE_A_SUPPORTIVE_CULTURE'
  | 'CREATE_STAKEHOLDER_ENGAGEMENT_PLANS_AND_FEEDBACK_MECHANISMS'
  | 'CRITERIA'
  | 'DASHBOARD'
  | 'DATA_COLLECTION'
  | 'DEFINE_AND_ALIGN_HUMAN_RIGHTS_GOALS'
  | 'DEFINE_CLEAR_ABAC_OBJECTIVES_AND_GOALS'
  | 'DEFINE_OBJECTIVES_AND_SCOPE'
  | 'DEFINE_ORGANISATIONAL_PURPOSE_AND_VALUES'
  | 'DEFINE_STRATEGIC_OBJECTIVES'
  | 'DEFINE_THE_SCOPE_OF_THE_ABAC_PROGRAMME'
  | 'DEFINING_THE_SCOPE_OF_SUSTAINABILITY_REPORT'
  | 'DELIVER_TARGETED_TRAINING_PROGRAMMES'
  | 'DESIGN_DUE_DILIGENCE_PROCEDURES_FOR_SUPPLIERS'
  | 'DEVELOP_ABAC_POLICIES'
  | 'DEVELOP_ACTION_PLANS'
  | 'DEVELOP_ACTION_PLANS_FOR_ACHIEVING_OBJECTIVES'
  | 'DEVELOP_AN_INTEGRATED_VALUE_GENERATION_MODEL'
  | 'DEVELOP_A_CLEAR_WHISTLEBLOWING_POLICY'
  | 'DEVELOP_A_RISK_MITIGATION_PLAN'
  | 'DEVELOP_A_STAKEHOLDER_ENGAGEMENT_PLAN'
  | 'DEVELOP_A_TIMELINE_AND_MILESTONES'
  | 'DEVELOP_COMPETENCE_IN_GOVERNANCE_TEAMS'
  | 'DEVELOP_EMPLOYMENT_DUE_DILIGENCE_PROCEDURES'
  | 'DEVELOP_GOVERNANCE_POLICIES_AND_PROCEDURES'
  | 'DEVELOP_INVESTIGATION_PROCEDURES'
  | 'DEVELOP_PROCEDURES_FOR_INTERNAL_INVESTIGATIONS_OF_BRIBERY_INCIDENTS'
  | 'DEVELOP_PROCEDURES_FOR_RISK_ASSESSMENTS'
  | 'DEVELOP_RISK_GOVERNANCE_FRAMEWORKS'
  | 'DEVELOP_RISK_MAPPING_TOOLS_FOR_ONGOING_ASSESSMENT'
  | 'DISCLOSE_PERFORMANCE_METRICS_TO_STAKEHOLDERS'
  | 'DOCUMENTATION'
  | 'EMBED_ANTI_SLAVERY_MEASURES_IN_SUPPLY_CHAIN_MANAGEMENT'
  | 'EMBED_GOVERNANCE_INTO_OPERATIONS'
  | 'EMPLOYEE_BUY_IN'
  | 'EMPLOYEE_REVIEWS'
  | 'EMPLOYEE_TRAINING_AND_ENGAGEMENT'
  | 'ENGAGEMENT_WITH_EXTERNAL_STAKEHOLDERS'
  | 'ENGAGEMENT_WITH_INTERNAL_STAKEHOLDERS'
  | 'ENGAGEMENT_WITH_SUPPLIERS_AND_PARTNERS'
  | 'ENGAGE_EXTERNAL_EXPERTISE'
  | 'ENGAGE_KEY_STAKEHOLDERS_AND_COMMUNITIES'
  | 'ENGAGE_RELEVANT_STAKEHOLDERS'
  | 'ENGAGING_SUPPLIERS_AND_PARTNERS'
  | 'ENSURE_AWARENESS_RAISING_FOR_VULNERABLE_WORKERS'
  | 'ENSURE_SENIOR_MANAGEMENT_OVERSIGHT_AND_SUPPORT'
  | 'ENSURE_TOOLS_FOR_SUPPLY_CHAIN_MONITORING_AND_REPORTING'
  | 'ESG_GOALS_AND_OBJECTIVES'
  | 'ESTABLISH_ANTI_RETALIATION_MEASURES'
  | 'ESTABLISH_ANTI_SLAVERY_POLICIES_AND_PROCEDURES'
  | 'ESTABLISH_GOVERNANCE_AND_SUSTAINABILITY_ALIGNMENT'
  | 'ESTABLISH_GUIDELINES_FOR_MANAGING_HIGH_RISK_INTERACTIONS'
  | 'ESTABLISH_KEY_PERFORMANCE_INDICATORS_KPIS'
  | 'ESTABLISH_MONITORING_MECHANISMS'
  | 'ESTABLISH_PARTNERSHIPS_WITH_NGOS_AND_INDUSTRY_GROUPS'
  | 'ESTABLISH_THIRD_PARTY_DUE_DILIGENCE_PROCEDURES'
  | 'EVALUATE_INTERNAL_CONTROLS_AND_GAPS'
  | 'EVALUATE_PROGRAMME_EFFECTIVENESS'
  | 'EVALUATE_PROGRAM_EFFECTIVENESS'
  | 'EXECUTIVE_BUY_IN'
  | 'EXTERNAL_ASSURANCE'
  | 'EXTERNAL_FILINGS'
  | 'FEEDBACK_LOOPS'
  | 'FINANCIALS'
  | 'FINANCIAL_CONTROLS'
  | 'FOSTER_A_CULTURE_OF_COMPLIANCE'
  | 'FOSTER_INNOVATION'
  | 'GOALS'
  | 'GOVERNANCE_STRUCTURE'
  | 'GOVERNING_BODY_SELECTION_PROCESS'
  | 'GOVERNING_REVIEW'
  | 'GUIDELINES'
  | 'HIGH_LEVEL_TRANSPARENCY_OBJECTIVES'
  | 'HR_CONTROLS'
  | 'HUMAN_RESOURCES'
  | 'IDENTIFY_KEY_ROLES_AND_RESPONSIBILITIES_'
  | 'IDENTIFY_KEY_STAKEHOLDERS'
  | 'IDENTIFY_RISK_AREAS'
  | 'IDENTIFY_SECTOR_AND_REGIONAL_HUMAN_RIGHTS_RISKSS'
  | 'IDENTIFY_STAKEHOLDERS'
  | 'IMPLEMENT_ABAC_CONTROL_MECHANISMS'
  | 'IMPLEMENT_AUDIT_AND_MONITORING_SYSTEMS'
  | 'IMPLEMENT_A_SECURE_AND_ANONYMOUS_WHISTLEBLOWING_SYSTEM'
  | 'IMPLEMENT_CORRECTIVE_ACTIONS'
  | 'IMPLEMENT_MODERN_SLAVERY_CONTROLS_IN_HIRING_AND_LABOUR'
  | 'IMPLEMENT_SECURE_INCIDENT_MANAGEMENT_SYSTEMS'
  | 'IMPLEMENT_TECHNOLOGY_FOR_DATA_AND_DECISIONS'
  | 'INTEGRATING_SUSTAINABILITY_INTO_MARKET_STRATEGY'
  | 'INTERNAL_AND_EXTERNAL_COMMUNICATION'
  | 'INTERNAL_STAKEHOLDER_ENGAGEMENT'
  | 'INTRODUCING_NEW_POLICIES_AND_PROCEDURES'
  | 'INVESTIGATE_REPORTS_OF_BRIBERY_OR_CORRUPTION'
  | 'INVESTIGATE_REPORTS_OF_HUMAN_RIGHTS_VIOLATIONS_OR_MODERN_SLAVERY'
  | 'INVESTIGATIONS'
  | 'ISO_37001_4_1_A_TO_H_UNDERSTANDING_THE_ORGANISATION_AND_ITS_CONTEXT'
  | 'ISO_37001_4_2_A_TO_C_UNDERSTANDING_THE_NEEDS_AND_EXPECTATIONS_OF_STAKHOLDERS'
  | 'ISO_37001_4_3_A_TO_C_DETERMINING_THE_SCOPE_OF_THE_ANTI_BRIBERY_MANAGEMENT_SYSTEM'
  | 'ISO_37001_4_3_DETERMINING_THE_SCOPE_OF_THE_ANTI_BRIBERY_MANAGEMENT_SYSTEM'
  | 'ISO_37001_4_4_ANTI_BRIBERY_MANAGEMENT_SYSTEM'
  | 'ISO_37001_4_5_1_A_TO_C_BRIBERY_RISK_ASSESSMENT'
  | 'ISO_37001_4_5_2_BRIBERY_RISK_ASSESSMENT'
  | 'ISO_37001_4_5_3_A_B_BRIBERY_RISK_ASSESSMENT'
  | 'ISO_37001_4_5_4_BRIBERY_RISK_ASSESSMENT'
  | 'ISO_37001_5_1_1_A_TO_E_LEADERSHIP_AND_COMMITMENT_GOVERNING_BODY'
  | 'ISO_37001_5_1_2_A_TO_M_LEADERSHIP_AND_COMMITMENT_TOP_MANAGEMENT'
  | 'ISO_37001_5_1_3_LEADERSHIP_AND_COMMITMENT_ANTI_BRIBERY_CULTURE'
  | 'ISO_37001_5_2_ANTI_BRIBERY_POLICY'
  | 'ISO_37001_5_2_A_TO_I_ANTI_BRIBERY_POLICY'
  | 'ISO_37001_5_3_1_ROLES_RESPONSIBILITIES_AND_AUTHORITIES_GENERAL'
  | 'ISO_37001_5_3_2_ANTI_BRIBERY_FUNCTION'
  | 'ISO_37001_5_3_2_A_TO_D_ANTI_BRIBERY_FUNCTION'
  | 'ISO_37001_5_3_3_DELEGATED_DECISION_MAKING'
  | 'ISO_37001_6_1_ACTIONS_TO_ADDRESS_RISKS_AND_OPPORTUNITIES'
  | 'ISO_37001_6_1_A_TO_D_ACTIONS_TO_ADDRESS_RISKS_AND_OPPORTUNITIES'
  | 'ISO_37001_6_2_ANTI_BRIBERY_OBJECTIVES_AND_PLANNING_OT_ACHIEVE_THEM'
  | 'ISO_37001_6_2_A_TO_H_ANTI_BRIBERY_OBJECTIVES_AND_PLANNING_TO_ACHIEVE_THEM'
  | 'ISO_37001_6_3_PLANNING_OF_CHANGES'
  | 'ISO_37001_7_1_RESOURCES'
  | 'ISO_37001_7_2_1_A_COMPETENCE_GENERAL'
  | 'ISO_37001_7_2_1_B_COMPETENCE_GENERAL'
  | 'ISO_37001_7_2_1_COMPETENCE_GENERAL'
  | 'ISO_37001_7_2_1_C_COMPETENCE_GENERAL'
  | 'ISO_37001_7_2_2_1_A_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_1_B_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_1_C_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_1_D_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_1_E_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_2_A_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_2_B_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_2_2_2_C_EMPLOYMENT_PROCESS'
  | 'ISO_37001_7_3_1_AWARENESS_AND_TRAINING_GENERAL'
  | 'ISO_37001_7_3_2_AWARENESS'
  | 'ISO_37001_7_3_2_A_TO_D_AWARENESS'
  | 'ISO_37001_7_3_3_A_TO_F_TRAINING'
  | 'ISO_37001_7_3_3_TRAINING'
  | 'ISO_37001_7_3_4_TRAINING_FOR_BUSINESS_ASSOCIATES'
  | 'ISO_37001_7_4_1_A_TO_F_COMMUNICATION'
  | 'ISO_37001_7_4_2_COMMUNICATION'
  | 'ISO_37001_7_5_1_A_B_DOCUMENTED_INFORMATION_GENERAL'
  | 'ISO_37001_7_5_2_A_CREATING_AND_UPDATING_DOCUMENTATION'
  | 'ISO_37001_7_5_2_B_CREATING_AND_UPDATING_DOCUMENTATION'
  | 'ISO_37001_7_5_2_C_CREATING_AND_UPDATING_DOCUMENTATION'
  | 'ISO_37001_7_5_3_A_B_CONTROL_OF_DOCUMENTED_INFORMATION'
  | 'ISO_37001_8_1_A_B_OPERATIONAL_PLANNING_AND_CONTROL'
  | 'ISO_37001_8_2_A_DUE_DILIGENCE'
  | 'ISO_37001_8_2_B_DUE_DILIGENCE'
  | 'ISO_37001_8_2_C_DUE_DILIGENCE'
  | 'ISO_37001_8_2_DUE_DILIGENCE'
  | 'ISO_37001_8_3_FINANCIAL_CONTROLS'
  | 'ISO_37001_8_4_NON_FINANCIAL_CONTROLS'
  | 'ISO_37001_8_5_1_A_B_IMPLEMENTATION_OF_ANTI_BRIBERY_CONTROLS_BY_CONTROLLED_ORGANISATION_AND_BY_BUSINESS_ASSOCIATES'
  | 'ISO_37001_8_5_2_A_IMPLEMENTATION_OF_ANTI_BRIBERY_CONTROLS_BY_CONTROLLED_ORGANISATION_AND_BY_BUSINESS_ASSOCIATES'
  | 'ISO_37001_8_5_2_B_IMPLEMENTATION_OF_ANTI_BRIBERY_CONTROLS_BY_CONTROLLED_ORGANISATION_AND_BY_BUSINESS_ASSOCIATES'
  | 'ISO_37001_8_6_A_ANTI_BRIBERY_COMMITMENTS'
  | 'ISO_37001_8_6_B_ANTI_BRIBERY_COMMITMENTS'
  | 'ISO_37001_8_7_GIFTS_HOSPITALITY_DONATIONS_AND_SIMILAR_BENEFITS'
  | 'ISO_37001_8_8_A_MANAGING_INADEQUACY_OF_ANTI_BRIBERY_CONTROLS'
  | 'ISO_37001_8_8_B_MANAGING_INADEQUACY_OF_ANTI_BRIBERY_CONTROLS'
  | 'ISO_37001_8_9_A_TO_E_RAISING_CONCERNS'
  | 'ISO_37001_8_9_RAISING_CONCERNS'
  | 'ISO_37001_8_10_A_TO_F_INVESTIGATING_AND_DEALING_WITH_BRIBERY'
  | 'ISO_37001_8_10_INVESTIGATING_AND_DEALING_WITH_BRIBERY'
  | 'ISO_37001_9_1_A_TO_D_MONITORING_MEASUREMENT_ANALYSIS_AND_EVALUATION'
  | 'ISO_37001_9_1_MONITORING_MEASUREMENT_ANALYSIS_AND_EVALUATION'
  | 'ISO_37001_9_2_1_A_B_INTERNAL_AUDIT_GENERAL'
  | 'ISO_37001_9_2_2_A_INTERNAL_AUDIT_PROGRAMME'
  | 'ISO_37001_9_2_2_B_INTERNAL_AUDIT_PROGRAMME'
  | 'ISO_37001_9_2_2_C_INTERNAL_AUDIT_PROGRAMME'
  | 'ISO_37001_9_2_2_INTERNAL_AUDIT'
  | 'ISO_37001_9_2_2_INTERNAL_AUDIT_PROGRAMME'
  | 'ISO_37001_9_2_3_A_TO_D_AUDIT_PROCEDURES_CONTROLS_AND_SYSTEMS'
  | 'ISO_37001_9_2_4_A_TO_E_OBJECTIVITY_AND_IMPARTIALITY'
  | 'ISO_37001_9_3_1_MANAGEMENT_REVIEW_GENERAL'
  | 'ISO_37001_9_3_2_A_MANAGEMENT_REVIEW_INPUTS'
  | 'ISO_37001_9_3_2_B_MANAGEMENT_REVIEW_INPUTS'
  | 'ISO_37001_9_3_2_C_MANAGEMENT_REVIEW_INPUTS'
  | 'ISO_37001_9_3_2_D_MANAGEMENT_REVIEW_INPUTS'
  | 'ISO_37001_9_3_2_E_MANAGEMENT_REVIEW_INPUTS'
  | 'ISO_37001_9_3_2_F_MANAGEMENT_REVIEW_INPUTS'
  | 'ISO_37001_9_3_3_MANAGEMENT_REVIEW_RESULTS'
  | 'ISO_37001_9_4_A_B_REVIEW_BY_THE_ANTI_BRIBERY_FUNCTION'
  | 'ISO_37001_9_4_REVIEW_BY_THE_ANTI_BRIBERY_FUNCTION'
  | 'ISO_37001_10_1_CONTINUAL_IMPROVEMENT'
  | 'ISO_37001_10_2_A_NONCONFORMITY_AND_CORRECTIVE_ACTION'
  | 'ISO_37001_10_2_B_NONCONFORMITY_AND_CORRECTIVE_ACTION'
  | 'ISO_37001_10_2_C_NONCONFORMITY_AND_CORRECTIVE_ACTION'
  | 'ISO_37001_10_2_D_NONCONFORMITY_AND_CORRECTIVE_ACTION'
  | 'ISO_37001_10_2_E_NONCONFORMITY_AND_CORRECTIVE_ACTION'
  | 'ISO_37001_10_2_NONCONFORMITY_AND_CORRECTIVE_ACTION'
  | 'LAUNCHING_SUSTAINABILITY_INITIATIVES'
  | 'LEADERSHIP_OR_GOVERNING_BODY_REVIEW'
  | 'MANAGEMENT_REVIEW'
  | 'MANAGEMENT_REVIEWS'
  | 'MANAGE_AND_RESOLVE_INCIDENT_REPORTS'
  | 'MARKET_AND_CUSTOMERS'
  | 'MATERIAL_TOPICS'
  | 'METRICS'
  | 'MONITORING'
  | 'MONITOR_ETHICAL_BEHAVIOUR'
  | 'NEGATIVE_IMPACTS'
  | 'NO_ACTIVITY'
  | 'OBJECTIVES'
  | 'OBLIGATIONS'
  | 'OBTAIN_LEADERSHIP_BUY_IN'
  | 'OPERATIONAL_CONTROLS'
  | 'OPERATIONS'
  | 'ORGANISATIONAL_DETAILS'
  | 'OWNERSHIP'
  | 'PARTICIPATING_ASSOCIATIONS'
  | 'PERFORMANCE_EVALUATIONS'
  | 'POLICIES'
  | 'PRICING_AND_BILLING_TRANSPRENCY'
  | 'PRINCIPLES'
  | 'PRINCIPLES_AND_GUIDELINES'
  | 'PRIORITISE_RISKS_AND_OPPORTUNITIES'
  | 'PROCEDURES'
  | 'PROCUREMENT_CONTROLS'
  | 'PROMOTE_ETHICAL_LEADERSHIP'
  | 'PROMOTE_INCLUSIVE_PARTICIPATION'
  | 'PROVIDE_TAILORED_TRAINING_ON_HUMAN_RIGHTS_AND_MODERN_SLAVERY'
  | 'PROVIDE_TRAINING_AND_SUPPORT_FOR_ASSIGNED_ROLES'
  | 'RAISE_AWARENESS_AND_PROVIDE_TRAINING'
  | 'RATINGS'
  | 'REMUNERATION_POLICIES'
  | 'REPORTING_PERIOD'
  | 'RESEARCH'
  | 'RESEARCH_RELEVANT_LEGAL_AND_REGULATORY_REQUIREMENTS'
  | 'RESOURCE_PLANNING_AND_ALLOCATION'
  | 'RESTATEMENTS_OF_INFORMATION'
  | 'REVIEW_AND_REPORTING_TO_TOP_MANAGEMENT'
  | 'REVIEW_GOVERNANCE_FRAMEWORKS'
  | 'RISK_ASSESSMENT'
  | 'RISK_MANAGEMENT_AND_INTERNAL_CONTROL_SYSTEM'
  | 'RISK_PRIORITIZATION'
  | 'ROLES_AND_RESPONSIBILITIES'
  | 'SCOPE'
  | 'SECURE_TOP_MANAGEMENTS_BUY_IN'
  | 'SET_ESG_GOALS_AND_OBJECTIVES'
  | 'SET_PROCEDURES_FOR_EXPENSE_REPORTING_IN_FINANCIAL_TRANSACTIONS'
  | 'SET_TARGETS'
  | 'STAKEHOLDER_ANALYSIS'
  | 'STAKEHOLDER_ENGAGEMENT'
  | 'STAKEHOLDER_REPORTING'
  | 'STRATEGIES'
  | 'SUPPLY_CHAIN_OPTIMIZATION'
  | 'SUSTAINABILITY_MATERIALITY_ASSESSMENT'
  | 'SUSTAINABILITY_STATEMENTS'
  | 'TECHNOLOGY'
  | 'TOP_MANAGEMENT_REVIEWS'
  | 'TRACK_CORRECTIVE_ACTIONS_AND_FOLLOW_UPS'
  | 'TRACK_KEY_PERFORMANCE_INDICATORS_KPIS'
  | 'TRAINING'
  | 'TRAINING_AND_EDUCATION'
  | 'UNDERSTANDING_STAKEHOLDER_CONCERNS'
  | 'UNDERSTAND_BUSINESS_ENVIRONMENT_AND_RISKS'
  | 'UNDERSTAND_LEGAL_AND_REGULATORY_REQUIREMENTS'
  | 'UTILISE_GRIEVANCE_MECHANISMS_AND_WHISTLEBLOWING_CHANNELS'
  | 'UTILISE_STAKEHOLDER_FEEDBACK'
  | 'VALUE_CHAIN'
  | 'VALUE_PROPOSITION';

export type Esg_Question_State =
  | 'ALL'
  | 'ANSWERED'
  | 'UNANSWERED';

export type Esg_Question_Status =
  | 'ANSWERED'
  | 'UNANSWERED';

export type Esg_Related_Tasks_Mode =
  | 'ALL'
  | 'TASKED'
  | 'UNTASKED';

export type Esg_Standard_Subcategory =
  | 'BRSR'
  | 'ENGAGE'
  | 'ESRS'
  | 'FUTURE_FIT'
  | 'GRI'
  | 'IFRS'
  | 'ISO_14001'
  | 'ISO_37001'
  | 'SASB'
  | 'SOCIAL_ACCOUNTABILITY'
  | 'SUSTAINABLE_DEVELOPMENT'
  | 'TCFD'
  | 'UNGPS';

export type Esg_Step =
  | 'ACCESS_FOR_LOW_INCOME_PATIENTS'
  | 'ACCESS_TO_COVERAGE'
  | 'ACCESS_TO_MEDICINES'
  | 'ACCIDENT_MANAGEMENT'
  | 'ACCIDENT_SAFETY_MANAGEMENT'
  | 'ADVERTISING_INTEGRITY'
  | 'AFFORDABILITY_PRICING'
  | 'AIR_EMISSIONS_FROM_REFRIGERATION'
  | 'AIR_QUALITY'
  | 'ANIMAL_CARE_WELFARE'
  | 'ANIMAL_FEED_SOURCING'
  | 'ANTIBIOTIC_USE_IN_ANIMAL_PRODUCTION'
  | 'BIODIVERSITY_IMPACTS'
  | 'BP_1'
  | 'BP_2'
  | 'BUILD'
  | 'BUSINESS_CONTEXT'
  | 'BUSINESS_ETHICS'
  | 'BUSINESS_ETHICS_PAYMENTS_TRANSPARENCY'
  | 'BUSINESS_ETHICS_TRANSPARENCY'
  | 'BUSINESS_MODEL_AND_VALUE_CHAIN'
  | 'BUSINESS_OVERVIEW'
  | 'BUY_IN'
  | 'CHEMICALS_MANAGEMENT'
  | 'CHEMICAL_SAFETY_HAZARDS_OF_PRODUCTS'
  | 'CLIMATE_CHANGE_ADAPTATION'
  | 'CLIMATE_CHANGE_IMPACTS_ON_HUMAN_HEALTH'
  | 'CLIMATE_CHANGE_IMPACTS_ON_HUMAN_HEALTH_INFRASTRUCTURE'
  | 'CLIMATE_IMPACTS_OF_BUSINESS_MIX'
  | 'CLIMATE_RELATED_METRICS'
  | 'CLIMATE_RELATED_RISKS_AND_OPPORTUNITIES'
  | 'CLIMATE_RELATED_TARGETS'
  | 'CLIMATE_RESILIENCE'
  | 'COAL_ASH_MANAGEMENT'
  | 'COMMITMENT'
  | 'COMMUNICATE'
  | 'COMMUNITY_IMPACTS_OF_NEW_DEVELOPMENTS'
  | 'COMMUNITY_RELATIONS'
  | 'COMPARATIVE_INFORMATION'
  | 'COMPETITIVE_BEHAVIOUR'
  | 'COMPETITIVE_BEHAVIOUR_OPEN_INTERNET'
  | 'CONTEXT_OF_THE_ORGANISATION'
  | 'COUNTERFEIT_DRUGS'
  | 'CRITICAL_INCIDENT_RISK_MANAGEMENT'
  | 'CSMS1000_AWARENESS_TRAINING'
  | 'CSMS1000_BUSINESS_CONTEXT'
  | 'CSMS1000_BUYIN_LEADERSHIP'
  | 'CSMS1000_IMPACTS_RISKS_OPPORTUNITIES'
  | 'CSMS1000_IMPROVEMENT'
  | 'CSMS1000_LEVERAGE'
  | 'CSMS1000_OBJECTIVES_STRATEGY'
  | 'CSMS1000_PERFORMANCE_AUDIT'
  | 'CSMS1000_POLICIES_CONTROLS'
  | 'CSMS1000_ROLES_COMPETENCE'
  | 'CUSTOMER_HEALTH_SAFETY'
  | 'CUSTOMER_PRIVACY'
  | 'CUSTOMER_PRIVACY_TECHNOLOGY_STANDARDS'
  | 'CUSTOMER_SAFETY'
  | 'DATA_PRIVACY'
  | 'DATA_PRIVACY_ADVERTISING_STANDARDS'
  | 'DATA_PRIVACY_ADVERTISING_STANDARDS_FREEDOM_OF_EXPRESSION'
  | 'DATA_PRIVACY_FREEDOM_OF_EXPRESSION'
  | 'DATA_SECURITY'
  | 'DATA_SECURITY_PRIVACY'
  | 'DDMS2000_AWARENESS_TRAINING'
  | 'DDMS2000_BUSINESS_CONTEXT'
  | 'DDMS2000_BUYIN_LEADERSHIP'
  | 'DDMS2000_DOCUMENTATION_DISCLOSURE'
  | 'DDMS2000_IMPROVEMENT'
  | 'DDMS2000_OBJECTIVES_STRATEGY'
  | 'DDMS2000_PERFORMANCE_AUDIT'
  | 'DDMS2000_POLICIES_CONTROLS'
  | 'DDMS2000_ROLES_COMPETENCE'
  | 'DDMS2000_UNDERSTANDING_RISKS'
  | 'DESIGN_FOR_FUEL_EFFICIENCY'
  | 'DESIGN_FOR_RESOURCE_EFFICIENCY'
  | 'DEVELOP_THE_WHISTLEBLOWING_POLICY'
  | 'DISCHARGE_MANAGEMENT_ECOLOGICAL_IMPACTS'
  | 'DISCLOSURE_OF_INFORMATION_ABOUT_SOURCES_OF_GUIDANCE'
  | 'DISCRIMINATORY_LENDING'
  | 'DISTRIBUTION_NETWORK_EFFICIENCY'
  | 'DRINKING_WATER_QUALITY'
  | 'DRUG_SAFETY'
  | 'DRUG_SUPPLY_CHAIN_INTEGRITY'
  | 'E1_1'
  | 'E1_2'
  | 'E1_3'
  | 'E1_4'
  | 'E1_5'
  | 'E1_6'
  | 'E1_7'
  | 'E1_8'
  | 'E1_9'
  | 'E1_GOV_3'
  | 'E1_IRO_1'
  | 'E1_SBM_3'
  | 'E2_1'
  | 'E2_2'
  | 'E2_3'
  | 'E2_4'
  | 'E2_5'
  | 'E2_6'
  | 'E2_IRO_1'
  | 'E3_1'
  | 'E3_2'
  | 'E3_3'
  | 'E3_4'
  | 'E3_5'
  | 'E3_IRO_1'
  | 'E4_1'
  | 'E4_2'
  | 'E4_3'
  | 'E4_4'
  | 'E4_5'
  | 'E4_6'
  | 'E4_IRO_1'
  | 'E4_SBM_3'
  | 'E5_1'
  | 'E5_2'
  | 'E5_3'
  | 'E5_4'
  | 'E5_5'
  | 'E5_6'
  | 'E5_IRO_1'
  | 'ECOLOGICAL_IMPACTS'
  | 'ECOLOGICAL_IMPACTS_OF_PROJECT_DEVELOPMENT'
  | 'ECOLOGICAL_IMPACT_MANAGEMENT'
  | 'ECOSYSTEM_SERVICES_IMPACTS'
  | 'EFFLUENT_QUALITY_MANAGEMENT'
  | 'EMISSIONS_REDUCTION_SERVICES_FUELS_MANAGEMENT'
  | 'EMPLOYEE_DIVERSITY_INCLUSION'
  | 'EMPLOYEE_INCENTIVES_RISK_TAKING'
  | 'EMPLOYEE_RECRUITMENT_DEVELOPMENT_RETENTION'
  | 'EMPLOYEE_RECRUITMENT_INCLUSION_PERFORMANCE'
  | 'END_USE_EFFICIENCY'
  | 'END_USE_EFFICIENCY_DEMAND'
  | 'ENERGY_AFFORDABILITY'
  | 'ENERGY_MANAGEMENT'
  | 'ENERGY_MANAGEMENT_IN_MANUFACTURING'
  | 'ENERGY_MANAGEMENT_IN_RETAIL'
  | 'ENERGY_MANAGEMENT_IN_RETAIL_DISTRIBUTION'
  | 'ENVIRONMENTAL_FOOTPRINT_OF_HARDWARE_INFRASTRUCTURE'
  | 'ENVIRONMENTAL_FOOTPRINT_OF_OPERATIONS'
  | 'ENVIRONMENTAL_IMPACTS_IN_THE_SUPPLY_CHAIN'
  | 'ENVIRONMENTAL_IMPACTS_OF_PROJECT_DEVELOPMENT'
  | 'ENVIRONMENTAL_RISK_TO_MORTGAGED_PROPERTIES'
  | 'ENVIRONMENTAL_SOCIAL_IMPACTS_OF_ANIMAL_SUPPLY_CHAIN'
  | 'ENVIRONMENTAL_SOCIAL_IMPACTS_OF_INGREDIENT_SUPPLY_CHAIN'
  | 'ENVIRONMENTAL_SOCIAL_IMPACTS_OF_PALM_OIL_SUPPLY_CHAIN'
  | 'ERRORS'
  | 'ETHICAL_MARKETING'
  | 'FINANCED_EMISSIONS'
  | 'FINANCIAL_INCLUSION_CAPACITY_BUILDING'
  | 'FINANCIAL_POSITION_FINANCIAL_PERFORMANCE_AND_CASH_FLOWS'
  | 'FLEET_FUEL_ECONOMY_UTILISATION'
  | 'FLEET_FUEL_MANAGEMENT'
  | 'FOOD_PACKAGING_WASTE_MANAGEMENT'
  | 'FOOD_SAFETY'
  | 'FOOD_WASTE_MANAGEMENT'
  | 'FRAUD_UNNECESSARY_PROCEDURES'
  | 'FUEL_ECONOMY_EMISSIONS_IN_USE_PHASE'
  | 'FUEL_ECONOMY_USE_PHASE_EMISSIONS'
  | 'G1_1'
  | 'G1_2'
  | 'G1_3'
  | 'G1_4'
  | 'G1_5'
  | 'G1_6'
  | 'G1_GOV_1'
  | 'GCMS3000_CONTEXT'
  | 'GCMS3000_IMPROVEMENT'
  | 'GCMS3000_LEADERSHIP'
  | 'GCMS3000_LEVERAGE'
  | 'GCMS3000_OPERATION'
  | 'GCMS3000_PERFORMANCE'
  | 'GCMS3000_PLANNING'
  | 'GCMS3000_SUPPORT'
  | 'GENERAL'
  | 'GENETICALLY_MODIFIED_ORGANISMS'
  | 'GMO_MANAGEMENT'
  | 'GOVERNANCE'
  | 'GOVERNANCE_STRUCTURE'
  | 'GOV_1'
  | 'GOV_2'
  | 'GOV_3'
  | 'GOV_4'
  | 'GOV_5'
  | 'GREENHOUSE_GAS_EMISSIONS'
  | 'GREENHOUSE_GAS_EMISSIONS_ENERGY_RESOURCE_PLANNING'
  | 'GRID_RESILIENCY'
  | 'HARDWARE_INFRASTRUCTURE_ENERGY_WATER_MANAGEMENT'
  | 'HAZARDOUS_MATERIALS_MANAGEMENT'
  | 'HAZARDOUS_WASTE_MANAGEMENT'
  | 'HEALTH_NUTRITION'
  | 'IDENTIFYING_APPLICABLE_DISCLOSURE_REQUIREMENTS'
  | 'IDENTIFYING_SUSTAINABILITY_RELATED_RISKS_AND_OPPORTUNITIES'
  | 'IMPROVED_OUTCOMES'
  | 'IMPROVEMENT'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_CREDIT_ANALYSIS'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_INVESTMENT_BANKING_BROKERAGE_ACTIVITIES'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_INVESTMENT_MANAGEMENT'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_INVESTMENT_MANAGEMENT_ADVISORY'
  | 'INGREDIENT_SOURCING'
  | 'INSIGHTS'
  | 'INTEGRITY_OF_GAS_DELIVERY_INFRASTRUCTURE'
  | 'INTELLECTUAL_PROPERTY_PROTECTION_COMPETITIVE_BEHAVIOUR'
  | 'INTELLECTUAL_PROPERTY_PROTECTION_MEDIA_PIRACY'
  | 'IRO_1'
  | 'IRO_2'
  | 'ISO_9001_CONTEXT'
  | 'ISO_9001_IMPROVEMENT'
  | 'ISO_9001_LEADERSHIP'
  | 'ISO_9001_OPERATION'
  | 'ISO_9001_PERFORMANCE'
  | 'ISO_9001_PLANNING'
  | 'ISO_9001_SUPPORT'
  | 'ISO_14001_CONTEXT'
  | 'ISO_14001_IMPROVEMENT'
  | 'ISO_14001_LEADERSHIP'
  | 'ISO_14001_OPERATION'
  | 'ISO_14001_PERFORMANCE'
  | 'ISO_14001_PLANNING'
  | 'ISO_14001_SUPPORT'
  | 'ISO_17298_ACTION_PLAN'
  | 'ISO_17298_COMMUNICATION'
  | 'ISO_17298_CONTEXT'
  | 'ISO_17298_IMPACTS_RISKS'
  | 'ISO_17298_IMPLEMENTATION'
  | 'ISO_17298_INTERESTED_PARTIES'
  | 'ISO_26000_CORE_SUBJECTS'
  | 'ISO_26000_INTEGRATING'
  | 'ISO_26000_PRINCIPLES'
  | 'ISO_26000_RECOGNISING_SR'
  | 'ISO_27001_CONTEXT'
  | 'ISO_27001_IMPROVEMENT'
  | 'ISO_27001_LEADERSHIP'
  | 'ISO_27001_OPERATION'
  | 'ISO_27001_ORG_CONTROLS'
  | 'ISO_27001_PEOPLE_CONTROLS'
  | 'ISO_27001_PERFORMANCE'
  | 'ISO_27001_PHYSICAL_CONTROLS'
  | 'ISO_27001_PLANNING'
  | 'ISO_27001_SUPPORT'
  | 'ISO_27001_TECH_CONTROLS'
  | 'ISO_27002_ORG_CONTROLS'
  | 'ISO_27002_PEOPLE_CONTROLS'
  | 'ISO_27002_PHYSICAL_CONTROLS'
  | 'ISO_27002_TECH_CONTROLS'
  | 'ISO_37003_CONTEXT'
  | 'ISO_37003_IMPROVEMENT'
  | 'ISO_37003_LEADERSHIP'
  | 'ISO_37003_OPERATION'
  | 'ISO_37003_PERFORMANCE'
  | 'ISO_37003_PLANNING'
  | 'ISO_37003_SUPPORT'
  | 'ISO_37008_DISCIPLINARY'
  | 'ISO_37008_POLICY'
  | 'ISO_37008_PRINCIPLES'
  | 'ISO_37008_PROCESS'
  | 'ISO_37008_REMEDIATION'
  | 'ISO_37008_SAFETY'
  | 'ISO_37008_STAKEHOLDERS'
  | 'ISO_37008_SUPPORT'
  | 'ISO_37200_CONTEXT'
  | 'ISO_37200_IMPROVEMENT'
  | 'ISO_37200_LEADERSHIP'
  | 'ISO_37200_OPERATION'
  | 'ISO_37200_PERFORMANCE'
  | 'ISO_37200_RISK_ASSESSMENT'
  | 'ISO_37200_SUPPORT'
  | 'ISO_42001_AI_POLICIES'
  | 'ISO_42001_CONTEXT'
  | 'ISO_42001_DATA'
  | 'ISO_42001_IMPACT_ASSESSMENT'
  | 'ISO_42001_IMPROVEMENT'
  | 'ISO_42001_INTERESTED_PARTIES'
  | 'ISO_42001_INTERNAL_ORG'
  | 'ISO_42001_LEADERSHIP'
  | 'ISO_42001_LIFE_CYCLE'
  | 'ISO_42001_OPERATION'
  | 'ISO_42001_PERFORMANCE'
  | 'ISO_42001_PLANNING'
  | 'ISO_42001_RESOURCES'
  | 'ISO_42001_SUPPORT'
  | 'ISO_42001_THIRD_PARTY'
  | 'ISO_42001_USE'
  | 'ISO_45001_CONTEXT'
  | 'ISO_45001_IMPROVEMENT'
  | 'ISO_45001_LEADERSHIP'
  | 'ISO_45001_OPERATION'
  | 'ISO_45001_PERFORMANCE'
  | 'ISO_45001_PLANNING'
  | 'ISO_45001_SUPPORT'
  | 'ISO_50001_CONTEXT'
  | 'ISO_50001_IMPROVEMENT'
  | 'ISO_50001_LEADERSHIP'
  | 'ISO_50001_OPERATION'
  | 'ISO_50001_PERFORMANCE'
  | 'ISO_50001_PLANNING'
  | 'ISO_50001_SUPPORT'
  | 'ISO_50002_1_COMPETENCE'
  | 'ISO_50002_1_PERFORMING'
  | 'ISO_50002_1_PRINCIPLES'
  | 'JOURNALISTIC_INTEGRITY_SPONSORSHIP_IDENTIFICATION'
  | 'JUDGEMENTS'
  | 'LABOUR_CONDITIONS_IN_THE_SUPPLY_CHAIN'
  | 'LABOUR_PRACTICES'
  | 'LABOUR_RELATIONS'
  | 'LAND_USE_ECOLOGICAL_IMPACTS'
  | 'LEADERSHIP'
  | 'LENDING_PRACTICES'
  | 'LEVERAGE'
  | 'LIFECYCLE_EMISSIONS_BALANCE'
  | 'LIFECYCLE_IMPACTS_OF_BUILDINGS_INFRASTRUCTURE'
  | 'LOCATION_OF_DISCLOSURES'
  | 'MANAGEMENT_OF_CHEMICALS_IN_PRODUCTS'
  | 'MANAGEMENT_OF_CONTROLLED_SUBSTANCES'
  | 'MANAGEMENT_OF_ENERGY_INFRASTRUCTURE_INTEGRATION_RELATED_REGULATIONS'
  | 'MANAGEMENT_OF_ENVIRONMENTAL_SOCIAL_IMPACTS_IN_THE_SUPPLY_CHAIN'
  | 'MANAGEMENT_OF_LEACHATE_HAZARDOUS_WASTE'
  | 'MANAGEMENT_OF_THE_LEGAL_REGULATORY_ENVIRONMENT'
  | 'MANAGING_BUSINESS_CONTINUITY_TECHNOLOGY_RISKS'
  | 'MANAGING_CONFLICTS_OF_INTEREST'
  | 'MANAGING_SYSTEMIC_RISKS_FROM_TECHNOLOGY_DISRUPTIONS'
  | 'MARKETING_PRACTICES'
  | 'MARKETING_RECRUITING_PRACTICES'
  | 'MATERIALITY_ASSESSMENT'
  | 'MATERIALS_EFFICIENCY'
  | 'MATERIALS_EFFICIENCY_RECYCLING'
  | 'MATERIALS_SOURCING'
  | 'MEASUREMENT_UNCERTAINTY'
  | 'MEDIA_PLURALISM'
  | 'METRICS_ADVERTISING_MARKETING'
  | 'METRICS_AEROSPACE_DEFENCE'
  | 'METRICS_AGRICULTURAL_PRODUCTS'
  | 'METRICS_AIRLINES'
  | 'METRICS_AIR_FREIGHT_LOGISTICS'
  | 'METRICS_ALCOHOLIC_BEVERAGES'
  | 'METRICS_AND_TARGETS'
  | 'METRICS_APPAREL_ACCESSORIES_FOOTWEAR'
  | 'METRICS_APPLIANCE_MANUFACTURING'
  | 'METRICS_ASSET_MANAGEMENT_CUSTODY_ACTIVITIES'
  | 'METRICS_AUTO_PARTS'
  | 'METRICS_BIOFUELS'
  | 'METRICS_BIOTECHNOLOGY_PHARMACEUTICALS'
  | 'METRICS_BUILDING_PRODUCTS_FURNISHINGS'
  | 'METRICS_CAR_RENTAL_LEASING'
  | 'METRICS_CHEMICALS'
  | 'METRICS_COAL_OPERATIONS'
  | 'METRICS_COMMERCIAL_BANKS'
  | 'METRICS_CONSTRUCTION_MATERIALS'
  | 'METRICS_CONSUMER_FINANCE'
  | 'METRICS_CONTAINERS_PACKAGING'
  | 'METRICS_CRUISE_LINES'
  | 'METRICS_DRUG_RETAILERS'
  | 'METRICS_EDUCATION'
  | 'METRICS_ELECTRICAL_ELECTRONIC_EQUIPMENT'
  | 'METRICS_ELECTRIC_UTILITIES_POWER_GENERATORS'
  | 'METRICS_ELECTRONIC_MANUFACTURING_SERVICES_ORIGINAL_DESIGN_MANUFACTURING'
  | 'METRICS_ENGINEERING_CONSTRUCTION_SERVICES'
  | 'METRICS_E_COMMERCE'
  | 'METRICS_FOOD_RETAILERS_DISTRIBUTORS'
  | 'METRICS_FORESTRY_MANAGEMENT'
  | 'METRICS_FUEL_CELLS_INDUSTRIAL_BATTERIES'
  | 'METRICS_GAS_UTILITIES_DISTRIBUTORS'
  | 'METRICS_HARDWARE'
  | 'METRICS_HEALTH_CARE_DELIVERY'
  | 'METRICS_HEALTH_CARE_DISTRIBUTORS'
  | 'METRICS_HOME_BUILDERS'
  | 'METRICS_HOTELS_LODGING'
  | 'METRICS_HOUSEHOLD_PERSONAL_PRODUCTS'
  | 'METRICS_INDUSTRIAL_MACHINERY_GOODS'
  | 'METRICS_INSURANCE'
  | 'METRICS_INTERNET_MEDIA_SERVICES'
  | 'METRICS_INVESTMENT_BANKING_BROKERAGE'
  | 'METRICS_IRON_STEEL_PRODUCERS'
  | 'METRICS_LEISURE_FACILITIES'
  | 'METRICS_MANAGED_CARE'
  | 'METRICS_MARINE_TRANSPORTATION'
  | 'METRICS_MEAT_POULTRY_DAIRY'
  | 'METRICS_MEDIA_ENTERTAINMENT'
  | 'METRICS_MEDICAL_EQUIPMENT_SUPPLIES'
  | 'METRICS_METALS_MINING'
  | 'METRICS_MORTGAGE_FINANCE'
  | 'METRICS_MULTILINE_SPECIALTY_RETAILERS_DISTRIBUTORS'
  | 'METRICS_NON_ALCOHOLIC_BEVERAGES'
  | 'METRICS_OIL_GAS_EXPLORATION_PRODUCTION'
  | 'METRICS_OIL_GAS_MIDSTREAM'
  | 'METRICS_OIL_GAS_REFINING_MARKETING'
  | 'METRICS_OIL_GAS_SERVICES'
  | 'METRICS_PROCESSED_FOODS'
  | 'METRICS_PROFESSIONAL_COMMERCIAL_SERVICES'
  | 'METRICS_PULP_PAPER_PRODUCTS'
  | 'METRICS_RAIL_TRANSPORTATION'
  | 'METRICS_REAL_ESTATE_SERVICES'
  | 'METRICS_RESTAURANTS'
  | 'METRICS_ROAD_TRANSPORTATION'
  | 'METRICS_SECURITY_COMMODITY_EXCHANGES'
  | 'METRICS_SEMICONDUCTORS'
  | 'METRICS_SOFTWARE_IT_SERVICES'
  | 'METRICS_SOLAR_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'METRICS_TELECOMMUNICATION_SERVICES'
  | 'METRICS_TOBACCO'
  | 'METRICS_TOYS_SPORTING_GOODS'
  | 'METRICS_WASTE_MANAGEMENT'
  | 'METRICS_WATER_UTILITIES_SERVICES'
  | 'METRICS_WIND_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'NETWORK_RESILIENCY_IMPACTS_OF_CLIMATE_CHANGE'
  | 'NUCLEAR_SAFETY_EMERGENCY_MANAGEMENT'
  | 'NUTRITIONAL_CONTENT'
  | 'OPERATION'
  | 'OPERATIONAL_SAFETY_EMERGENCY_PREPAREDNESS_RESPONSE'
  | 'PACKAGING_LIFECYCLE_MANAGEMENT'
  | 'PATIENT_HEALTH_OUTCOMES'
  | 'PATIENT_PRIVACY_ELECTRONIC_HEALTH_RECORDS'
  | 'PERFORMANCE_EVALUATION'
  | 'PHYSICAL_RISK_EXPOSURE'
  | 'PLANNING'
  | 'PLAN_PERFORMANCE'
  | 'POLICIES_DESIGNED_TO_INCENTIVISE_RESPONSIBLE_BEHAVIOUR'
  | 'PRICING_BILLING_TRANSPARENCY'
  | 'PRICING_INTEGRITY_TRANSPARENCY'
  | 'PRODUCT_DESIGN_FOR_USE_PHASE_EFFICIENCY'
  | 'PRODUCT_DESIGN_LIFECYCLE_MANAGEMENT'
  | 'PRODUCT_EFFICIENCY'
  | 'PRODUCT_END_OF_LIFE_MANAGEMENT'
  | 'PRODUCT_ENVIRONMENTAL_HEALTH_AND_SAFETY_PERFORMANCE'
  | 'PRODUCT_HEALTH_NUTRITION'
  | 'PRODUCT_INNOVATION'
  | 'PRODUCT_LABELLING_MARKETING'
  | 'PRODUCT_LIFECYCLE_ENVIRONMENTAL_IMPACTS'
  | 'PRODUCT_LIFECYCLE_MANAGEMENT'
  | 'PRODUCT_PACKAGING_DISTRIBUTION'
  | 'PRODUCT_SAFETY'
  | 'PRODUCT_SECURITY'
  | 'PRODUCT_SOURCING_PACKAGING_MARKETING'
  | 'PRODUCT_SPECIFICATIONS_CLEAN_FUEL_BLENDS'
  | 'PROFESSIONAL_INTEGRITY'
  | 'PROMOTING_TRANSPARENT_EFFICIENT_CAPITAL_MARKETS'
  | 'PUBLIC_HEALTH'
  | 'QUALITY_OF_CARE_PATIENT_SATISFACTION'
  | 'QUALITY_OF_EDUCATION_GAINFUL_EMPLOYMENT'
  | 'RAW_MATERIALS_SOURCING'
  | 'RECRUITING_MANAGING_A_GLOBAL_DIVERSE_SKILLED_WORKFORCE'
  | 'RECRUITING_MANAGING_A_GLOBAL_SKILLED_WORKFORCE'
  | 'RECYCLING_RESOURCE_RECOVERY'
  | 'REMANUFACTURING_DESIGN_SERVICES'
  | 'REPORTING_PREPARATION'
  | 'RESERVES_VALUATION_CAPITAL_EXPENDITURES'
  | 'RESILIENCE'
  | 'RESPONSIBLE_DRINKING_MARKETING'
  | 'RIGHTS_OF_INDIGENOUS_PEOPLES'
  | 'RISK_MANAGEMENT'
  | 'S1_1'
  | 'S1_2'
  | 'S1_3'
  | 'S1_4'
  | 'S1_5'
  | 'S1_6'
  | 'S1_7'
  | 'S1_8'
  | 'S1_9'
  | 'S1_10'
  | 'S1_11'
  | 'S1_12'
  | 'S1_13'
  | 'S1_14'
  | 'S1_15'
  | 'S1_16'
  | 'S1_17'
  | 'S1_SBM_3'
  | 'S2_1'
  | 'S2_2'
  | 'S2_3'
  | 'S2_4'
  | 'S2_5'
  | 'S2_SBM_3'
  | 'S3_1'
  | 'S3_2'
  | 'S3_3'
  | 'S3_4'
  | 'S3_5'
  | 'S3_SBM_3'
  | 'S4_1'
  | 'S4_2'
  | 'S4_3'
  | 'S4_4'
  | 'S4_5'
  | 'S4_SBM_3'
  | 'SAFETY_ENVIRONMENTAL_STEWARDSHIP_OF_CHEMICALS'
  | 'SAFETY_OF_CLINICAL_TRIAL_PARTICIPANTS'
  | 'SBM_1'
  | 'SBM_2'
  | 'SBM_3'
  | 'SECURITY_HUMAN_RIGHTS_RIGHTS_OF_INDIGENOUS_PEOPLES'
  | 'SELLING_PRACTICES'
  | 'SETTING_OBJECTIVES'
  | 'SOURCING_ENVIRONMENTAL_IMPACTS_OF_FEEDSTOCK_PRODUCTION'
  | 'STATEMENT_OF_COMPLIANCE'
  | 'STRATEGY'
  | 'STRATEGY_AND_DECISION_MAKING'
  | 'STRUCTURAL_INTEGRITY_SAFETY'
  | 'SUPPLY_CHAIN_MANAGEMENT'
  | 'SUPPLY_CHAIN_MANAGEMENT_FOOD_SOURCING'
  | 'SUPPORT'
  | 'SUSTAINABILITY_RELATED_RISKS_AND_OPPORTUNITIES'
  | 'SUSTAINABILITY_SERVICES'
  | 'SYSTEMIC_RISK_MANAGEMENT'
  | 'TAILINGS_STORAGE_FACILITIES_MANAGEMENT'
  | 'TIMING_OF_REPORTING'
  | 'TRANSPARENT_INFORMATION_FAIR_ADVICE_FOR_CUSTOMERS'
  | 'TRANSPARENT_INFORMATION_MANAGEMENT_OF_CONFLICT_OF_INTEREST'
  | 'UNDERSTANDING_RISKS'
  | 'WASTE_HAZARDOUS_MATERIALS_MANAGEMENT'
  | 'WASTE_MANAGEMENT'
  | 'WATER_AFFORDABILITY_ACCESS'
  | 'WATER_MANAGEMENT'
  | 'WATER_MANAGEMENT_IN_MANUFACTURING'
  | 'WATER_MANAGEMENT_SERVICES'
  | 'WATER_SUPPLY_RESILIENCE'
  | 'WOOD_SUPPLY_CHAIN_MANAGEMENT'
  | 'WORKFORCE_CONDITIONS_HEALTH_SAFETY'
  | 'WORKFORCE_DIVERSITY_ENGAGEMENT'
  | 'WORKFORCE_DIVERSITY_INCLUSION'
  | 'WORKFORCE_HEALTH_SAFETY';

export type Esg_Subcategory =
  | 'BIODIVERSITY'
  | 'BRIBERY_AND_CORRUPTION'
  | 'BRSR'
  | 'CLIMATE_STABILITY'
  | 'COMPLIANCE'
  | 'CONSUMERS_AND_END_USERS'
  | 'CORPORATE_GOVERNANCE'
  | 'CSMS1000_TOPIC'
  | 'CSRD_ESRS'
  | 'DATA_PRIVACY_AND_INFORMATION_SECURITY'
  | 'DDMS2000_TOPIC'
  | 'DIVERSITY_EQUITY_AND_INCLUSION'
  | 'E1'
  | 'E2'
  | 'E3'
  | 'E4'
  | 'E5'
  | 'ENERGY_INNOVATION'
  | 'ENGAGE'
  | 'ESRS'
  | 'ESRS2'
  | 'ESRS_2'
  | 'ESRS_E1'
  | 'ESRS_E2'
  | 'ESRS_E3'
  | 'ESRS_E4'
  | 'ESRS_E5'
  | 'ESRS_G1'
  | 'ESRS_S1'
  | 'ESRS_S2'
  | 'ESRS_S3'
  | 'ESRS_S4'
  | 'ETHICS_AND_INTEGRITY'
  | 'FUTURE_FIT'
  | 'FUTURE_FIT_BE01'
  | 'FUTURE_FIT_BE02'
  | 'FUTURE_FIT_BE03'
  | 'FUTURE_FIT_BE04'
  | 'FUTURE_FIT_BE05'
  | 'FUTURE_FIT_BE06'
  | 'FUTURE_FIT_BE07'
  | 'FUTURE_FIT_BE08'
  | 'FUTURE_FIT_BE09'
  | 'FUTURE_FIT_BE10'
  | 'FUTURE_FIT_BE11'
  | 'FUTURE_FIT_BE12'
  | 'FUTURE_FIT_BE13'
  | 'FUTURE_FIT_BE14'
  | 'FUTURE_FIT_BE15'
  | 'FUTURE_FIT_BE16'
  | 'FUTURE_FIT_BE17'
  | 'FUTURE_FIT_BE18'
  | 'FUTURE_FIT_BE19'
  | 'FUTURE_FIT_BE20'
  | 'FUTURE_FIT_BE21'
  | 'FUTURE_FIT_BE22'
  | 'FUTURE_FIT_BE23'
  | 'FUTURE_FIT_BENCHMARK'
  | 'G1'
  | 'GCMS3000_TOPIC'
  | 'GENERAL'
  | 'GRI'
  | 'HEALTH_AND_SAFETY'
  | 'HUMAN_CAPITAL_MANAGEMENT'
  | 'HUMAN_RIGHTS_AND_MODERN_DAY_SLAVERY'
  | 'IFRS'
  | 'IFRS_S1_GENERAL_DISCLOSURES'
  | 'IFRS_S2_CLIMATE_CHANGE'
  | 'INFORMATION_SECURITY'
  | 'ISO_9001_V2015_TOPIC'
  | 'ISO_14001'
  | 'ISO_14001_TOPIC'
  | 'ISO_14001_V2015_TOPIC'
  | 'ISO_14001_V2026_TOPIC'
  | 'ISO_17298_V2025_TOPIC'
  | 'ISO_26000_V2010_TOPIC'
  | 'ISO_27001_V2022_TOPIC'
  | 'ISO_27002_V2022_TOPIC'
  | 'ISO_37001'
  | 'ISO_37001_TOPIC'
  | 'ISO_37001_V2025_TOPIC'
  | 'ISO_37002_TOPIC'
  | 'ISO_37003_V2026_TOPIC'
  | 'ISO_37008_V2023_TOPIC'
  | 'ISO_37200_V2026_TOPIC'
  | 'ISO_37301_TOPIC'
  | 'ISO_42001_TOPIC'
  | 'ISO_45001_TOPIC'
  | 'ISO_50001_TOPIC'
  | 'ISO_50002_1_TOPIC'
  | 'NATURAL_RESOURCES'
  | 'POLLUTION_CONTROL'
  | 'RISK_MANAGEMENT'
  | 'S1'
  | 'S2'
  | 'S3'
  | 'S4'
  | 'SASB'
  | 'SHARED'
  | 'SOCIAL_ACCOUNTABILITY'
  | 'SOCIETY'
  | 'SUPPLY_CHAIN_AND_PARTNER_MANAGEMENT'
  | 'SUSTAINABILITY_GOVERNANCE'
  | 'SUSTAINABLE_DEVELOPMENT'
  | 'TCFD'
  | 'TRANSPARENCY'
  | 'UNGPS'
  | 'VOLUME_1_APPAREL_ACCESSORIES_FOOTWEAR'
  | 'VOLUME_2_APPLIANCE_MANUFACTURING'
  | 'VOLUME_3_BUILDING_PRODUCTS_FURNISHINGS'
  | 'VOLUME_4_E_COMMERCE'
  | 'VOLUME_5_HOUSEHOLD_PERSONAL_PRODUCTS'
  | 'VOLUME_6_MULTILINE_SPECIALTY_RETAILERS_DISTRIBUTORS'
  | 'VOLUME_7_TOYS_SPORTING_GOODS'
  | 'VOLUME_8_COAL_OPERATIONS'
  | 'VOLUME_9_CONSTRUCTION_MATERIALS'
  | 'VOLUME_10_IRON_STEEL_PRODUCERS'
  | 'VOLUME_11_METALS_MINING'
  | 'VOLUME_12_OIL_GAS_EXPLORATION_PRODUCTION'
  | 'VOLUME_13_OIL_GAS_MIDSTREAM'
  | 'VOLUME_14_OIL_GAS_REFINING_MARKETING'
  | 'VOLUME_15_OIL_GAS_SERVICES'
  | 'VOLUME_16_AGRICULTURAL_PRODUCTS'
  | 'VOLUME_17_ALCOHOLIC_BEVERAGES'
  | 'VOLUME_18_FOOD_RETAILERS_DISTRIBUTORS'
  | 'VOLUME_19_MEAT_POULTRY_DAIRY'
  | 'VOLUME_20_NON_ALCOHOLIC_BEVERAGES'
  | 'VOLUME_21_PROCESSED_FOODS'
  | 'VOLUME_22_RESTAURANTS'
  | 'VOLUME_23_TOBACCO'
  | 'VOLUME_24_ASSET_MANAGEMENT_CUSTODY_ACTIVITIES'
  | 'VOLUME_25_COMMERCIAL_BANKS'
  | 'VOLUME_26_CONSUMER_FINANCE'
  | 'VOLUME_27_INSURANCE'
  | 'VOLUME_28_INVESTMENT_BANKING_BROKERAGE'
  | 'VOLUME_29_MORTGAGE_FINANCE'
  | 'VOLUME_30_SECURITY_COMMODITY_EXCHANGES'
  | 'VOLUME_31_BIOTECHNOLOGY_PHARMACEUTICALS'
  | 'VOLUME_32_DRUG_RETAILERS'
  | 'VOLUME_33_HEALTH_CARE_DELIVERY'
  | 'VOLUME_34_HEALTH_CARE_DISTRIBUTORS'
  | 'VOLUME_35_MANAGED_CARE'
  | 'VOLUME_36_MEDICAL_EQUIPMENT_SUPPLIES'
  | 'VOLUME_37_CASINOS_GAMING'
  | 'VOLUME_38_ELECTRIC_UTILITIES_POWER_GENERATORS'
  | 'VOLUME_39_ENGINEERING_CONSTRUCTION_SERVICES'
  | 'VOLUME_40_GAS_UTILITIES_DISTRIBUTORS'
  | 'VOLUME_41_HOME_BUILDERS'
  | 'VOLUME_42_FUEL_CELLS_INDUSTRIAL_BATTERIES'
  | 'VOLUME_43_REAL_ESTATE_SERVICES'
  | 'VOLUME_44_WASTE_MANAGEMENT'
  | 'VOLUME_45_WATER_UTILITIES_SERVICES'
  | 'VOLUME_46_BIOFUELS'
  | 'VOLUME_47_FORESTRY_MANAGEMENT'
  | 'VOLUME_48_FUEL_CELLS_INDUSTRIAL_BATTERIES'
  | 'VOLUME_49_PULP_PAPER_PRODUCTS'
  | 'VOLUME_50_SOLAR_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'VOLUME_51_WIND_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'VOLUME_52_AEROSPACE_DEFENCE'
  | 'VOLUME_53_CHEMICALS'
  | 'VOLUME_54_CONTAINERS_PACKAGING'
  | 'VOLUME_55_ELECTRICAL_ELECTRONIC_EQUIPMENT'
  | 'VOLUME_56_INDUSTRIAL_MACHINERY_GOODS'
  | 'VOLUME_57_ADVERTISING_MARKETING'
  | 'VOLUME_58_EDUCATION'
  | 'VOLUME_59_HOTELS_LODGING'
  | 'VOLUME_60_LEISURE_FACILITIES'
  | 'VOLUME_61_MEDIA_ENTERTAINMENT'
  | 'VOLUME_62_PROFESSIONAL_COMMERCIAL_SERVICES'
  | 'VOLUME_63_ELECTRONIC_MANUFACTURING_SERVICES_ORIGINAL_DESIGN_MANUFACTURING'
  | 'VOLUME_64_HARDWARE'
  | 'VOLUME_65_INTERNET_MEDIA_SERVICES'
  | 'VOLUME_66_SEMICONDUCTORS'
  | 'VOLUME_67_SOFTWARE_IT_SERVICES'
  | 'VOLUME_68_TELECOMMUNICATION_SERVICES'
  | 'VOLUME_69_AIR_FREIGHT_LOGISTICS'
  | 'VOLUME_70_AIRLINES'
  | 'VOLUME_71_AUTO_PARTS'
  | 'VOLUME_72_AUTOMOBILES'
  | 'VOLUME_73_CAR_RENTAL_LEASING'
  | 'VOLUME_74_CRUISE_LINES'
  | 'VOLUME_75_MARINE_TRANSPORTATION'
  | 'VOLUME_76_RAIL_TRANSPORTATION'
  | 'VOLUME_77_ROAD_TRANSPORTATION'
  | 'WASTE_MANAGEMENT'
  | 'WHISTLEBLOWING';

export type Esg_Subcategory_Type =
  | 'ENGAGE'
  | 'GENERAL'
  | 'SHARED'
  | 'STANDARD';

/** Task fetch mode. */
export type Esg_Task_Fetch_Mode =
  | 'ALL'
  | 'ASSIGNED_BY_ME'
  | 'ASSIGNED_TO_ME'
  | 'ASSIGNED_TO_OR_BY_ME';

export type Esg_Year_Status =
  | 'ACTIVE'
  | 'CLOSED'
  | 'OPEN';

/** Represents the type of Excel validation operator. */
export type Excel_Validation_Operator =
  /** Between operator */
  | 'BETWEEN'
  /** Equal operator */
  | 'EQUAL'
  /** Greater than operator */
  | 'GREATER_THAN'
  /** Greater than or equal operator */
  | 'GREATER_THAN_OR_EQUAL'
  /** Less than operator */
  | 'LESS_THAN'
  /** Less than or equal operator */
  | 'LESS_THAN_OR_EQUAL'
  /** Not between operator */
  | 'NOT_BETWEEN'
  /** Not equal operator */
  | 'NOT_EQUAL';

/** Represents the type of Excel validation */
export type Excel_Validation_Type =
  /** Custom valdiation, not supported. */
  | 'CUSTOM'
  /** Date validation */
  | 'DATE'
  /** Decimal validation */
  | 'DECIMAL'
  /** List validation */
  | 'LIST'
  /** Text length validation */
  | 'TEXT_LENGTH'
  /** Time validation */
  | 'TIME'
  /** Whole number validation */
  | 'WHOLE';

export type ElectPlanDowngradeInput = {
  /** True when the customer ticked "I Accept" on the Basic Licence terms. REQUIRED to be true when targetTier is 'limited' - the election is refused otherwise (BASIC_LICENCE_NOT_ACCEPTED) and an acceptance is recorded per selected framework. Ignored for any other target tier. */
  basicLicenceAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The riskAreaUuids of the owned standards to drop to the target tier at the end of the signed term. Each must currently be on a tier strictly above the target. */
  selectedRefs: Array<Scalars['ID']['input']>;
  /** The catalogue plan id to downgrade to. */
  targetTier: Scalars['ID']['input'];
};

/** Represent the eline conversation details. */
export type ElineConversation = {
  /** Unique identifier of case. */
  caseUuid: Scalars['String']['output'];
  /** Transcript for case reported via elina. */
  transcription?: Maybe<Scalars['String']['output']>;
  /** Translated conversation transcription. */
  transcriptionTranslated: Scalars['String']['output'];
};


/** Represent the eline conversation details. */
export type ElineConversationTranscriptionTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

export type ElineNumber = {
  /** eLine number assigned country. */
  assignedCountry?: Maybe<TenantsCountry>;
  /** Date of number creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Default eLine language for number. If assigned country is null default country will be used in case. */
  defaultCountry?: Maybe<TenantsCountry>;
  /** Date of number last update. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** eLine phone number */
  number: Scalars['PhoneNumber']['output'];
  /** eLine number UUID. */
  uuid: Scalars['ID']['output'];
};

export type ElineNumberDeleteInput = {
  /** Array of number uuids to be deleted. */
  uuids: Array<Scalars['UUID']['input']>;
};

export type ElineNumberUpsertInput = {
  /** Custom assigned country for number. */
  assignedCountry?: InputMaybe<TenantsCountry>;
  /** eLine phone number. */
  number: Scalars['PhoneNumber']['input'];
  /** UUID of number's tenant. */
  tenantUuid: Scalars['UUID']['input'];
  /** UUID of updated eline number. If left blank will attempt to create a new number. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type ElinePhoneNumber = {
  number: Scalars['PhoneNumber']['output'];
};

/** Represents the input type for editing email entries. */
export type EmailAudienceEntryEditInput = {
  /** New value  */
  email: Scalars['String']['input'];
  /** UUID of audience entry to be edited. */
  uuid: Scalars['ID']['input'];
};

/** Represents the input type for survey audience by emails. */
export type EmailAudienceInput = {
  /** Array of emails that surveys should be dispatched to. */
  emailsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of audience emails UUIDs to be deleted from audience. */
  emailsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represent email lists's email entity */
export type EmailEntry = {
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  listUuid: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type EmailEntryEditInput = {
  /** New email value to be set. */
  email: Scalars['String']['input'];
  /** UUID of email entry to be updated. */
  uuid: Scalars['ID']['input'];
};

/** Represents the email entry edit result */
export type EmailEntryEditResult = {
  /** UUID of deleted entry */
  deletedEntryUuid?: Maybe<Scalars['ID']['output']>;
  /** Updated email entry. */
  entry: EmailEntry;
};

/** Represent email list. */
export type EmailList = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  entries: Array<EmailEntry>;
  entriesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};


/** Represent email list. */
export type EmailListEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents EmailListConnection connection. */
export type EmailListConnection = {
  /** Array of edges. */
  edges: Array<EmailListEdge>;
  /** Array of direct nodes. */
  nodes: Array<EmailList>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents the input type for fetching list of email lists. */
export type EmailListConnectionInput = {
  /** Flag indicating if all email lists should be returned. If left absent will return all lists. */
  fetchInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** List name to be filtered. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<EmailListSortInput>>;
};

/** Represents EmailList connection edge. */
export type EmailListEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the EmailList record. */
  node: EmailList;
};

export type EmailListSortFields =
  | 'CREATED_AT'
  | 'NAME'
  | 'UPDATED_AT';

export type EmailListSortInput = {
  direction: SortDirection;
  field: EmailListSortFields;
};

/** Represents the input type for upsert or edit of email list. */
export type EmailListUpsertInput = {
  /** Flag indicating if list should be active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of email addresses that should populate the list. */
  entriesToCreate?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Input used for deleting entries. Accepts an array of UUIDs of email entries to be deleted. */
  entriesToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Email list name. Must be present when creating new list. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List UUID. Must be present on list update. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents the response from the notifications MS. */
export type EmailMessageParsedResponse = {
  /** Message parsed body */
  body: Scalars['String']['output'];
  /** Message parsed subject */
  subject: Scalars['String']['output'];
};

/** Enumeration of allowed email receivers. */
export type EmailReceiver =
  | 'CASE_OWNER'
  | 'STAKEHOLDER'
  | 'SUPERUSER'
  | 'WHISTLEBLOWER';

export type EmailTemplate = {
  /** Email template's body. */
  body: Scalars['HTML']['output'];
  /** Indicates whether the email is sent when the corresponding event occurs. */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the email has carbon copy feature enabled. */
  isCarbonCopyEnabled: Scalars['Boolean']['output'];
  recipients: EmailTemplateRecipients;
  /** Email template's subject. */
  subject: Scalars['String']['output'];
  /** Unique type of email template. */
  type: EmailTemplateType;
  /** List of variables allowed to use within email template. */
  variables: Array<EmailTemplateVariable>;
};

export type EmailTemplateCarbonCopyUpdateInput = {
  /** Unique identifiers of users who should receive a carbon copy. */
  ccUuids: Array<Scalars['ID']['input']>;
  /** Unique type of email template. */
  type: EmailTemplateType;
};

export type EmailTemplateRecipients = {
  /** Users who should receive a carbon copy. */
  cc?: Maybe<Array<UserType>>;
  /** Recipients who should receive email message. */
  to?: Maybe<Array<EmailReceiver>>;
};

export type EmailTemplateStatusUpdateInput = {
  /** Indicates whether the email is sent when the corresponding event occurs. */
  isActive: Scalars['Boolean']['input'];
  /** Unique type of email template. */
  type: EmailTemplateType;
};

/** Enumeration of allowed email template types. */
export type EmailTemplateType =
  | 'CASE_CLOSED'
  | 'CASE_OWNER_ASSIGNMENT'
  | 'CASE_REOPENED'
  | 'CASE_REPORTER_CHAT_MESSAGE'
  | 'CASE_REPORTER_FILE_UPDATE'
  | 'CASE_STATUS_CHANGE'
  | 'CASE_TO_ALLEGATION'
  | 'CASE_TO_VICTIM'
  | 'CASE_TO_WITNESS'
  | 'COMMENT_ON_TASK'
  | 'DISCLOSURE_CHAT'
  | 'DISCLOSURE_INVITATION'
  | 'DISCLOSURE_INVITATION_REGISTER'
  | 'DISCLOSURE_RESPONSE_APPROVAL_CHANGE'
  | 'EMAIL_UPDATED'
  | 'EXTERNAL_USER_INVITE'
  | 'EXTERNAL_USER_REPEAT'
  | 'MFA_RESET'
  | 'NEW_CASE'
  | 'NEW_CASE_TO_REGISTERED_REPORTER'
  | 'NEW_CASE_TO_REPORTER'
  | 'NEW_CHAT'
  | 'NEW_CHAT_FILES'
  | 'NEW_CHAT_NO_OWNER'
  | 'NEW_DISCLOSURE'
  | 'NEW_USER_REGISTRATION'
  | 'NEW_USER_SSO'
  | 'NEW_VOICE_CASE'
  | 'NO_CASE_UPDATE'
  | 'RESPOND_PROCESSING_FINISHED'
  | 'SMART_FILL_RUN_COMPLETED'
  | 'SMART_FILL_RUN_FAILED'
  | 'SMART_FILL_RUN_HALTED'
  | 'STAKEHOLDER_ADDED'
  | 'SURVEY_INVITATION'
  | 'SURVEY_REMINDER'
  | 'TASK_COMMENT_CREATED'
  | 'TASK_DELETED'
  | 'TASK_STATUS_CHANGE'
  | 'TAXONOMY_REPORT_READY'
  | 'UNLOCK_USER_ACCOUNT';

export type EmailTemplateUpdateInput = {
  /** Email template's body. */
  body: Scalars['HTML']['input'];
  /** Indicates whether the email is sent when the corresponding event occurs. */
  isActive: Scalars['Boolean']['input'];
  /** Email template's subject. */
  subject: Scalars['String']['input'];
  /** Unique type of email template. */
  type: EmailTemplateType;
};

/** Enumeration of allowed email template variables. */
export type EmailTemplateVariable =
  | 'CASE_CONTENTS'
  | 'CASE_ID'
  | 'CASE_LINK'
  | 'CASE_OWNER_EMAIL'
  | 'CASE_PIN'
  | 'CASE_SUBJECT'
  | 'CUSTOM_TEXT'
  | 'DAYS_SINCE_UPDATE'
  | 'DUE_DATE'
  | 'INCIDENT_TYPE'
  | 'LOGO_URL'
  | 'NEW_VALUE'
  | 'OLD_VALUE'
  | 'RECIPIENT_EMAIL'
  | 'RECIPIENT_FIRST_NAME'
  | 'REFERENCE_URL'
  | 'SENDER_NAME'
  | 'SURVEY_NAME'
  | 'SYMBOLIC_ID'
  | 'TASK_LINK'
  | 'TENANT_NAME'
  | 'TITLE'
  | 'WEB_PORTAL_URL'
  | 'WHISTLEBLOWER_EMAIL';

/** Returns information about enabled login ways for tenant */
export type EnabledSsoMethodsForTenant = {
  /** @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant */
  azure: Scalars['Boolean']['output'];
  /** @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant */
  saml: Scalars['Boolean']['output'];
};

export type EngagementPrice = {
  bespoke: Scalars['Boolean']['output'];
  /** Set only when bespoke = true, a fact-stated sentence about why the scope is priced by Speeki. */
  bespokeReason?: Maybe<Scalars['String']['output']>;
  /** The build-up of the price. Empty when bespoke. */
  lines: Array<EngagementPriceLine>;
  pricingVersion: Scalars['String']['output'];
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  /** RatingsReady's Year 2+ figure per year. Null for the one-off products. */
  renewalUsd?: Maybe<Scalars['String']['output']>;
  /** The size band the headcount falls in (RatingsReady: the organisation's, Partner Integrity: the partner's, Beacon: the target's). */
  sizeBand?: Maybe<Scalars['String']['output']>;
  /** The engagement fee: RatingsReady's net Year 1 (after the multi-year commitment), the one-off total for Partner Integrity and Beacon. */
  year1Usd?: Maybe<Scalars['String']['output']>;
};

export type EngagementPriceLine = {
  /** Signed: a discount is negative. */
  amountUsd: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** A catalogue entry (standard or module) with the tenant's state on it. */
export type EntitlementItem = {
  frameworkCategory?: Maybe<Framework_Category>;
  kind: Entitlement_Item_Kind;
  refUuid?: Maybe<Scalars['ID']['output']>;
  /** Whether this framework's current tier grants Smart Fill, gated per framework rather than tenant-wide. null means unknown (the underlying module data was not available for this framework) - never treat null as false. Always null on a MODULE item. */
  smartFill?: Maybe<Scalars['Boolean']['output']>;
  standard?: Maybe<RiskArea>;
  state: Entitlement_Item_State;
};

export type EntitlementItemFilter = {
  kinds?: InputMaybe<Array<Entitlement_Item_Kind>>;
  states?: InputMaybe<Array<Entitlement_Item_State>>;
  techOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A platform module and whether the tenant has it enabled. */
export type EntitlementModule = {
  enabled: Scalars['Boolean']['output'];
  key: Service_Modules_Key;
};

/** Seat/license counts, mirror of the tenants License numbers (read-through, not stored). */
export type EntitlementSeats = {
  totalLimitedLicenses: Scalars['Int']['output'];
  totalStandardLicenses: Scalars['Int']['output'];
  usedLimitedLicenses: Scalars['Int']['output'];
  usedStandardLicenses: Scalars['Int']['output'];
};

export type EsgActivitiesForActivityReport = {
  /**
   * Name of the activity.
   * @deprecated Activities are no longer identified by their enum. Use QuestionActivity.topicsCount instead
   */
  name: Esg_Question_Activity;
  /** Number of topics (riskAreas) associated with step */
  topicsCount: Scalars['Int']['output'];
};

/** Represents AUDIT report generation input */
export type EsgActivityReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Report custom name. Max length: 85. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating should only answers to questions marked as answered be considered in report. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional array of riskArea UUIDs. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of steps */
  steps?: InputMaybe<Array<Esg_Step>>;
  /** Optional array of tag UUIDs. */
  tagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Given years UUIDs that should be used for Activity report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type EsgAnswer = {
  /** Answer contents. */
  answer?: Maybe<Scalars['String']['output']>;
  /** Resolves grouped tag information. */
  assignedTags: Array<EsgAnswerTags>;
  /** Returns the chatbot associated with the answer. Or null if not associated. */
  chatbot?: Maybe<Chatbot>;
  /** Answer creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** Resolves user who created the answer. */
  createdBy?: Maybe<UserType>;
  /** Tags assigned to resolved answer */
  embeddedTags: Array<Tag>;
  /** Array of answer files */
  files: Array<EsgFile>;
  /** Array of answer images */
  images: Array<EsgFile>;
  /** Flag indicating if question is default */
  isDefault: Scalars['Boolean']['output'];
  /** Returns true if the answer is linked to the specified metric for the given year. */
  isLinked: Scalars['Boolean']['output'];
  /** Returns metrics linked to this answer. */
  linkedMetrics: Array<Metric>;
  /** Returns answer parent question. */
  question: EsgQuestion;
  /** Resolves active tasks for user. */
  tasks?: Maybe<Array<Task>>;
  /** Answer last update date. */
  updatedAt: Scalars['DateTime']['output'];
  /** Resolves last user who updated the answer. */
  updatedBy?: Maybe<UserType>;
  /** UUID of esg answer. */
  uuid: Scalars['ID']['output'];
  /** Resolves answer version */
  version: Scalars['Int']['output'];
  /** Resolve version tag for answer. Null for default answer. */
  versionTag?: Maybe<Tag>;
  /** Reporting year for which the question was answered */
  year: Year;
};


export type EsgAnswerIsLinkedArgs = {
  input: IsLinkedInput;
};


export type EsgAnswerTasksArgs = {
  input?: InputMaybe<EsgTasksInput>;
};

/** Represents the input for deleting ESG answers. */
export type EsgAnswerDeleteInput = {
  /** UUIDs of answers to be deleted. */
  uuidsToDelete: Array<Scalars['UUID']['input']>;
};

export type EsgAnswerGenerateInput = {
  /** UUID of question for answer generation. */
  questionUuid: Scalars['UUID']['input'];
  /** Short answer or summary used to generate answer to question. */
  shortAnswer: Scalars['String']['input'];
};

export type EsgAnswerGenerateResult = {
  generatedAnswer: Scalars['String']['output'];
  question: EsgQuestion;
};

export type EsgAnswerTags = {
  /** Answer group tag. */
  groupTag: GroupTag;
  /** Tags total count. */
  tagCount: Scalars['Int']['output'];
  /** Array of answer tags. */
  tags: Array<Tag>;
};

/** Type representing input for esg answer upsert by answer UUID. */
export type EsgAnswerUpsertByUuidInput = {
  /** Answer content. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Array of file uuids. If provided - will remove embedded files not defined in input. If not provided will not update the answer's images. */
  embeddedFileUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Answered question UUID. Will not be changed on update. */
  questionUuid: Scalars['UUID']['input'];
  /** Answer UUID. Omit to create a new answer. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of version tag assigned to this answer. Will not be changed on update. If omitted will create default answer. */
  versionTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of reporting year assigned to this answer. Will not be changed on update. If omitted will craete version for current active year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Type representing input for esg answer upsert by version data (year and tag). */
export type EsgAnswerUpsertByVersionDataInput = {
  /** Answer content. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Array of file uuids. If provided - will remove embedded files not defined in input. If not provided will not update the answer's images. */
  embeddedFileUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Answered question UUID. Will not be changed on update. */
  questionUuid: Scalars['UUID']['input'];
  /** UUID of version tag assigned to this answer. Will not be changed on update. If omitted will create default answer. */
  versionTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of reporting year assigned to this answer. Will not be changed on update. If omitted will craete version for current active year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Type representing input for ESG answer upsert. */
export type EsgAnswerUpsertInput = {
  /** Answer contents. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Answer UUID. Omit to create a new answer. */
  answerUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Array of assigned group tags. Omitted group tags will be removed. */
  assignedGroupTagUuids: Array<Scalars['UUID']['input']>;
  /** Array of assigned tags. Omitted tags will be removed. */
  assignedTagUuids: Array<Scalars['UUID']['input']>;
  /** Uuid of a chatbot to be associated with the answer */
  chatbotUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Array of embedded images UUIDs. Will set given UUIDs as embedded images and remove any that are not included in the array. */
  embeddedImagesUuids: Array<Scalars['UUID']['input']>;
  /** Array of embedded tag UUIDs. Will set given UUIDs as embedded tags. Will remove all omitted tags. */
  embeddedTagUuids: Array<Scalars['UUID']['input']>;
  /** Array of file UUIDs. Will set given UUIDs as answer files. Will remove all omitted files. */
  fileUuids: Array<Scalars['UUID']['input']>;
  /** Flag indicating if should be set as default. Only valid for creating new answers, will be ignored for updates. */
  isDefault: Scalars['Boolean']['input'];
  /** Answered question UUID. Question UUID is ignored on update. */
  questionUuid: Scalars['UUID']['input'];
  /** UUID of reporting year assigned to this answer */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents pagination input for connection of esg articles */
export type EsgArticlesPaginationInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
};

/** Represents ACTIVITY report generation input */
export type EsgAuditReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Report custom name. Max length: 85. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating should only answers to questions marked as answered be considered in report. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional array of riskAreas UUIDs. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Uuid of standard for country report */
  standardUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional array of steps */
  steps?: InputMaybe<Array<Esg_Step>>;
  /** Optional array of tag UUIDs. */
  tagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Given years UUIDs that should be used for Audit report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type EsgCategoriesInput = {
  /** Optional input for limiting results by risk area name. Expects enum value. */
  name?: InputMaybe<Array<Esg_Category>>;
  /** Optional input for limiting results by EsgCategory type. By default will return all. */
  type?: Array<Esg_Category_Type>;
};

export type EsgCategory = {
  /** Description of category */
  description: Scalars['String']['output'];
  /** Unique name of category */
  name: Esg_Category;
  riskAreas: Array<RiskArea>;
  statistics: EsgStatistics;
  /** @deprecated Use riskAreas. */
  subcategories: Array<EsgSubcategory>;
  /** ESG Category type. */
  type: Esg_Category_Type;
  /** Uuid of category */
  uuid: Scalars['ID']['output'];
};


export type EsgCategoryRiskAreasArgs = {
  filter?: InputMaybe<Array<Esg_Subcategory>>;
  input?: InputMaybe<EsgCategoryRiskAreasInput>;
};


export type EsgCategoryStatisticsArgs = {
  input?: InputMaybe<EsgStatisticsInput>;
};


export type EsgCategorySubcategoriesArgs = {
  filter?: InputMaybe<Array<Esg_Subcategory>>;
};

export type EsgCategoryRiskAreasInput = {
  /** Input to filter risk areas by those that have assigned any enabled risk area */
  hasSomeRiskAreaAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional input to include tenant disabled risk areas. By default will not return disabled risk areas. */
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional input for limiting results by risk area name. Expects enum value or custom label name. */
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  /** Include all risk areas (ignore scope by permissions). Allowed only with ESG_RISK_AREA_MANAGEMENT */
  showAllRiskAreas?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents COUNTRY report generation input */
export type EsgCountryReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Report custom name. Max length: 85. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating should only answers to questions marked as answered be considered in report. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional programme UUIDs. Limits Country report to risk areas linked to these programmes for the tenant. */
  programmeUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of risk area UUIDs. Empty array means all risk areas available for the report. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of steps */
  steps?: InputMaybe<Array<Esg_Step>>;
  /** Optional array of tag UUIDs. */
  tagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Given years UUIDs that should be used for Country report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Input to delete a framework document from a framework library. */
export type EsgDeleteFrameworkDocumentInput = {
  /** FrameworkDocument UUID to delete. */
  documentUuid: Scalars['UUID']['input'];
};

/** Represents ESRS report generation input */
export type EsgEsrsReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional name for report */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating should only answered questions be considered for answers. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional programme UUIDs. Limits ESRS topics to risk areas linked to these programmes for the tenant. */
  programmeUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of risk area UUIDs (E1 Climate Change, E2 Pollution, etc.). Combined with programmeUuids when both are set. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Flag indicating should strict tag mode be used. If true, tagUuids are required to generate report. */
  strictTagMode?: Scalars['Boolean']['input'];
  /** Optional array of tag UUIDs. */
  tagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Given years UUIDs that should be used for ESRS report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type EsgFile = {
  /** Array of answers that resolved file is assigned to. */
  answers: Array<EsgAnswer>;
  /** File mime type. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Name of file */
  name: Scalars['String']['output'];
  /** File size in bytes. */
  size?: Maybe<Scalars['Int']['output']>;
  /** User who uploaded file. */
  uploadedBy?: Maybe<UserType>;
  /** Download URL. Valid for 1 hour. */
  url: Scalars['URL']['output'];
  /** Files unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the input for attaching uploaded files to answers. */
export type EsgFilesUpdateInput = {
  /** Uuid of answer to connect files */
  answerUuid: Scalars['UUID']['input'];
  /** UUIDs of uploaded files.. */
  fileUuids: Array<Scalars['UUID']['input']>;
};

/** Represents the input for uploading esg files. */
export type EsgFilesUploadInput = {
  /** Files to be uploaded. */
  files: Array<Scalars['Upload']['input']>;
};

/** External-assurance audit of one framework (risk area) for one assessment year. Carries a co-equal auditor set (1..N); terminal audits remain as history and a new cycle is a new record. */
export type EsgFrameworkAudit = {
  /** When the first auditor was assigned. */
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Co-equal auditor set. */
  auditors: Array<EsgFrameworkAuditAuditor>;
  /** When the audit was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the client requested the audit. */
  requestedAt: Scalars['DateTime']['output'];
  /** Framework (risk area) under audit. */
  riskAreaUuid: Scalars['UUID']['output'];
  /** Lifecycle status, derived from the auditor set while active: ASSIGNED once at least one auditor is attached, back to REQUESTED when the last one is removed. */
  status: Framework_Audit_Status;
  /** Unique audit identifier. */
  uuid: Scalars['UUID']['output'];
  /** When the client withdrew the request. */
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  /** Assessment year under audit. */
  yearUuid: Scalars['UUID']['output'];
};

/** One audit in the Speeki-admin cross-tenant list, with its owning tenant. */
export type EsgFrameworkAuditAdminEntry = {
  /** The audit itself. */
  audit: EsgFrameworkAudit;
  /** Audited framework (risk area) display name. */
  frameworkName: Scalars['String']['output'];
  /** Tenant display name. */
  tenantName: Scalars['String']['output'];
  /** Tenant that owns the audit. */
  tenantUuid: Scalars['UUID']['output'];
};

/** One member of an audit’s co-equal auditor set. */
export type EsgFrameworkAuditAuditor = {
  /** When this auditor joined the audit. */
  assignedAt: Scalars['DateTime']['output'];
  /** Auditor e-mail captured at assignment. */
  auditorEmail: Scalars['String']['output'];
  /** Auditor first name captured at assignment. */
  auditorFirstName?: Maybe<Scalars['String']['output']>;
  /** Auditor last name captured at assignment. */
  auditorLastName?: Maybe<Scalars['String']['output']>;
  /** Auditor seat user, set once provisioning completes. */
  auditorUserUuid?: Maybe<Scalars['UUID']['output']>;
  /** Unique assignment identifier. */
  uuid: Scalars['UUID']['output'];
};

export type EsgFrameworkAuditAuditorAddInput = {
  /** Audit to add the auditor to. */
  auditUuid: Scalars['UUID']['input'];
  /** Auditor e-mail; seat provisioning is driven off the emitted message. */
  auditorEmail: Scalars['String']['input'];
  /** Auditor first name; seeds the provisioned seat user. */
  auditorFirstName: Scalars['String']['input'];
  /** Auditor last name; seeds the provisioned seat user. */
  auditorLastName: Scalars['String']['input'];
};

export type EsgFrameworkAuditAuditorRemoveInput = {
  /** Audit to remove the auditor from. */
  auditUuid: Scalars['UUID']['input'];
  /** Auditor assignment to remove. */
  auditorUuid: Scalars['UUID']['input'];
};

export type EsgFrameworkAuditCompleteInput = {
  /** Audit to complete. */
  auditUuid: Scalars['UUID']['input'];
};

export type EsgFrameworkAuditEntriesInput = {
  /** Audit to read entries from. */
  auditUuid: Scalars['UUID']['input'];
  /** Limit to one requirement (question). */
  questionUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Append-only auditor workspace entry (comment or finding) on one requirement. Entries are never edited or deleted — a newer finding supersedes older ones. */
export type EsgFrameworkAuditEntry = {
  /** An AI draft was amended by the auditor before publishing. Never means post-publish editing — entries are append-only. */
  aiDraftEdited: Scalars['Boolean']['output'];
  /** The entry was drafted by AI (an accepted Nicole gap suggestion). */
  aiGenerated: Scalars['Boolean']['output'];
  /** Nicole's evidence trail captured when the suggestion was accepted (findings only); null on manual entries. */
  aiJustification?: Maybe<EsgFrameworkAuditEntryAiJustification>;
  /** Authoring auditor. */
  authorUuid: Scalars['UUID']['output'];
  /** Entry text. */
  body?: Maybe<Scalars['String']['output']>;
  /** When the entry was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** Comment or finding. */
  entryKind: Audit_Entry_Kind;
  /** Finding classification; set only when entryKind is FINDING. */
  findingType?: Maybe<Audit_Finding_Type>;
  /** Audit the entry belongs to. */
  frameworkAuditUuid: Scalars['UUID']['output'];
  /** Requirement (question) the entry is about. */
  questionUuid: Scalars['UUID']['output'];
  /** Verbatim capture of the addressed response at write time (findings only). Entries are only recordable while the requirement is addressed and unedited since, and drift fires only when a newer addressed version lands. */
  responseSnapshot?: Maybe<Scalars['String']['output']>;
  /** Unique entry identifier. */
  uuid: Scalars['UUID']['output'];
};

/** Nicole's evidence trail persisted onto an accepted finding — the citations and scope-of-search lines the auditor saw when they signed it. */
export type EsgFrameworkAuditEntryAiJustification = {
  /** Scope-of-search lines ('what Nicole checked'). */
  checked: Array<Scalars['String']['output']>;
  /** Cited passages backing the accepted finding. */
  citations: Array<EsgFrameworkAuditGapCitation>;
};

export type EsgFrameworkAuditEntryCreateInput = {
  /** Audit to record the entry on. */
  auditUuid: Scalars['UUID']['input'];
  /** Entry text; required for comments, optional for findings. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Comment or finding. */
  entryKind: Audit_Entry_Kind;
  /** Required when entryKind is FINDING. */
  findingType?: InputMaybe<Audit_Finding_Type>;
  /** Requirement (question) the entry is about. */
  questionUuid: Scalars['UUID']['input'];
  /** Addressing timestamp of the version the auditor reviewed (from the requirement read). Submission is rejected as stale if the requirement was re-addressed since. */
  reviewedAddressedAt: Scalars['DateTime']['input'];
};

export type EsgFrameworkAuditEvidenceCitationsInput = {
  /** Audit whose assignment scopes the read. */
  auditUuid: Scalars['UUID']['input'];
  /** Requirement (question) to read citations for. */
  questionUuid: Scalars['UUID']['input'];
};

/** Count of requirements holding each finding type as their verdict. */
export type EsgFrameworkAuditFindingMix = {
  count: Scalars['Int']['output'];
  findingType: Audit_Finding_Type;
};

export type EsgFrameworkAuditGapAnalysisStartInput = {
  /** Audit to run the gap analysis on. */
  auditUuid: Scalars['UUID']['input'];
};

/** One citation backing a suggestion: a verbatim excerpt of the addressed response (source RESPONSE) or of a stored evidence passage with its file identity (source EVIDENCE). */
export type EsgFrameworkAuditGapCitation = {
  /** Verbatim cited passage. */
  excerpt: Scalars['String']['output'];
  /** Cited file name (EVIDENCE only). */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Cited evidence file (EVIDENCE only). */
  fileUuid?: Maybe<Scalars['UUID']['output']>;
  /** Which occurrence of the excerpt is meant when it repeats (RESPONSE only). */
  occurrence?: Maybe<Scalars['Int']['output']>;
  /** Page of the cited passage, when known. */
  page?: Maybe<Scalars['Int']['output']>;
  /** RESPONSE or EVIDENCE. */
  source: Scalars['String']['output'];
  /** Citation subtype, when known. */
  type?: Maybe<Scalars['String']['output']>;
};

/** One AI gap-analysis pass over an audit’s addressed requirements. Result messages bump the progress counters; a new run supersedes the prior run’s pending suggestions. */
export type EsgFrameworkAuditGapRun = {
  /** Requirements processed so far — drives the progress bar. */
  completedCount: Scalars['Int']['output'];
  /** When the run was started. */
  createdAt: Scalars['DateTime']['output'];
  /** Failure reason; set only when the run FAILED. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The run is still active but its heartbeat has gone quiet, so the next start attempt will reap it and begin a fresh run. */
  isStale: Scalars['Boolean']['output'];
  /** Last result heartbeat. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Run lifecycle status. */
  status: Framework_Audit_Gap_Run_Status;
  /** Requirements the run set out to analyze. */
  totalCount: Scalars['Int']['output'];
  /** Unique run identifier. */
  uuid: Scalars['UUID']['output'];
};

export type EsgFrameworkAuditGapRunInput = {
  /** Audit to read the latest run of. */
  auditUuid: Scalars['UUID']['input'];
};

/** An AI-proposed finding for one requirement, pending until an auditor accepts (publishing a comment + finding entry pair) or dismisses it. */
export type EsgFrameworkAuditGapSuggestion = {
  /** Addressing marker of the version the AI analyzed; the accept path replays it through the entry-create staleness gate server-side. */
  capturedAddressedAt: Scalars['DateTime']['output'];
  /** Deterministic scope-of-search lines — what the analysis looked at. */
  checked: Array<Scalars['String']['output']>;
  /** Citation trail backing the suggestion. */
  citations: Array<EsgFrameworkAuditGapCitation>;
  /** When the suggestion was produced. */
  createdAt: Scalars['DateTime']['output'];
  /** Proposed finding note. */
  note: Scalars['String']['output'];
  /** Requirement (question) the suggestion is about. */
  questionUuid: Scalars['UUID']['output'];
  /** Suggestion lifecycle status. */
  status: Framework_Audit_Gap_Suggestion_Status;
  /** Proposed finding classification. */
  suggestedType: Audit_Finding_Type;
  /** Unique suggestion identifier. */
  uuid: Scalars['UUID']['output'];
};

export type EsgFrameworkAuditGapSuggestionAcceptInput = {
  /** Finding type to publish — the suggested type, possibly amended by the auditor. */
  findingType: Audit_Finding_Type;
  /** Note to publish — the suggestion’s note, possibly amended by the auditor. */
  note: Scalars['String']['input'];
  /** Suggestion to accept. */
  suggestionUuid: Scalars['UUID']['input'];
};

export type EsgFrameworkAuditGapSuggestionDismissInput = {
  /** Suggestion to dismiss. */
  suggestionUuid: Scalars['UUID']['input'];
};

export type EsgFrameworkAuditGapSuggestionsInput = {
  /** Audit to read suggestions from. */
  auditUuid: Scalars['UUID']['input'];
  /** Limit to one requirement (question). */
  questionUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Review state of one requirement, derived from its entries: the verdict is the latest finding and is never stored. */
export type EsgFrameworkAuditQuestionReview = {
  /** Total entries (comments and findings). */
  entryCount: Scalars['Int']['output'];
  /** Timestamp of the newest entry. */
  lastEntryAt?: Maybe<Scalars['DateTime']['output']>;
  /** Requirement (question). */
  questionUuid: Scalars['UUID']['output'];
  /** Derived verdict — the latest finding on the requirement, if any. */
  verdict?: Maybe<Audit_Finding_Type>;
};

export type EsgFrameworkAuditRequestInput = {
  /** Framework (risk area) to audit. */
  riskAreaUuid: Scalars['UUID']['input'];
  /** Assessment year to audit. */
  yearUuid: Scalars['UUID']['input'];
};

/** Per-audit rollup for cockpit tiles and the auditor landing: reviewed = requirements whose derived verdict exists. */
export type EsgFrameworkAuditSummary = {
  /** Verdict distribution. */
  findingMix: Array<EsgFrameworkAuditFindingMix>;
  /** Audit the summary describes. */
  frameworkAuditUuid: Scalars['UUID']['output'];
  /** Per-requirement review states. */
  questionReviews: Array<EsgFrameworkAuditQuestionReview>;
  /** Requirements with at least one finding (a verdict). */
  reviewedCount: Scalars['Int']['output'];
};

/** A document uploaded for Smart Fill processing against a framework. */
export type EsgFrameworkDocument = {
  /** Number of answers in THIS framework that currently use this document as evidence. A 0 here does not mean the document is deletable: deletion is guarded separately, server-side, across ALL frameworks the document is used in. */
  citedInCount: Scalars['Int']['output'];
  /** Date when this document was uploaded for Smart Fill. */
  createdAt: Scalars['DateTime']['output'];
  /** Source file associated with this framework document. */
  file: EsgFile;
  /** Whether Nicole has read this document (a previous Smart Fill run parsed it successfully). A read document will be skipped for re-parsing on a subsequent run. */
  isRead: Scalars['Boolean']['output'];
  /** Number of requirements in this framework that Nicole answered using this document (citations on accepted drafts). */
  nicoleCitedCount: Scalars['Int']['output'];
  /** Number of pending Smart Fill drafts (awaiting review), across ALL frameworks, that cite this document. Deliberately not scoped to this framework: it mirrors the delete guard, which blocks deletion while > 0 no matter which framework the pending draft belongs to. */
  pendingDraftCount: Scalars['Int']['output'];
  /** Current Smart Fill processing status of this document. */
  smartFillStatus: Smart_Fill_Document_Status;
  /** Unique framework document identifier. */
  uuid: Scalars['UUID']['output'];
};

/** Result of a framework document write (register / status update). */
export type EsgFrameworkDocumentMutationResult = {
  /** Number of document rows affected. */
  affectedCount: Scalars['Int']['output'];
};

/** Summary statistics for framework documents. */
export type EsgFrameworkDocumentStats = {
  /** Number of documents currently used as evidence in at least one answer. */
  cited: Scalars['Int']['output'];
  /** Number of documents that failed processing. */
  failed: Scalars['Int']['output'];
  /** Number of documents successfully processed. */
  processed: Scalars['Int']['output'];
  /** Total number of documents uploaded for this framework. */
  total: Scalars['Int']['output'];
};

/** Framework documents with summary statistics. */
export type EsgFrameworkDocuments = {
  /** List of framework documents. */
  documents: Array<EsgFrameworkDocument>;
  /** Summary statistics for the framework documents. */
  stats: EsgFrameworkDocumentStats;
};

/** Input to list framework documents for a framework. */
export type EsgFrameworkDocumentsInput = {
  /** Framework (risk area) UUID. */
  frameworkUuid: Scalars['UUID']['input'];
};

/** Batch of Gap Analysis jobs started for selected framework versions. */
export type EsgGapAnalysisBatch = {
  /** Shared batch identifier linking sequential version jobs. */
  batchUuid: Scalars['UUID']['output'];
  /** Jobs created for each selected version, in request order. */
  jobs: Array<EsgGapAnalysisJob>;
  /** Programme selected for Gap Analysis. */
  programme: Program;
  /** Framework (risk area) selected for Gap Analysis. */
  riskArea: RiskArea;
  /** Reporting year UUID used for the analysis (tenant active year). */
  yearUuid: Scalars['UUID']['output'];
};

/** Single Gap Analysis job created for one answer version within a batch. */
export type EsgGapAnalysisJob = {
  /** Current processing step while the job is running. */
  currentStep?: Maybe<Insights_Gap_Analysis_Step>;
  /** Current processing status of the Gap Analysis job. */
  status: Insights_Gap_Analysis_Job_Status;
  /** Unique Gap Analysis job identifier in Insights. */
  uuid: Scalars['UUID']['output'];
  /** Human-readable version label shown in the UI. */
  versionLabel: Scalars['String']['output'];
  /** Version tag UUID. Null for the default (Global Standards) version. */
  versionTagUuid?: Maybe<Scalars['UUID']['output']>;
};

/** Input to start Gap Analysis for a programme and framework. Uses the tenant active reporting year. */
export type EsgGapAnalysisStartInput = {
  /** Framework (risk area) UUID to analyse. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Programme UUID used to scope Gap Analysis. */
  programmeUuid: Scalars['UUID']['input'];
  /** Version tags to analyse in UI order. Use null for the default (Global Standards) version. An empty array analyses all available versions (default first, then custom tags alphabetically). */
  versionTagUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** Represents GRI report generation input */
export type EsgGriReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag indicating should only answered questions be considered for answers. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional array of sector UUIDs. */
  sectorUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of tag UUIDs. */
  tagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of unit UUIDs. */
  unitUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Given years UUIDs that should be used for GRI report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Group tags connection. */
export type EsgGroupTagConnection = {
  /** Array of edges. */
  edges: Array<EsgGroupTagEdge>;
  /** Array of direct nodes. */
  nodes: Array<GroupTag>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for group tags connection. */
export type EsgGroupTagConnectionInput = {
  /** Tag UUIDs to exclude, default: [] */
  excludeTagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Group tag UUIDs to exclude. */
  excludeUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter to narrow group tags. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Include assigned group tags */
  includeAssignedGroupTags?: Scalars['Boolean']['input'];
  /** Include group tags without tags */
  includeGroupTagsWithoutTags?: Scalars['Boolean']['input'];
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Risk area or standard UUIDs. */
  riskAreasUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Narrows group tags to standard ones only. */
  standardTagsOnly?: Scalars['Boolean']['input'];
};

export type EsgGroupedStatistics = {
  /** Compound ID. */
  id: Scalars['ID']['output'];
  /** Statistic's risk area. */
  standard: RiskArea;
  /** Risk area statistics. */
  statistics: EsgStatistics;
};

export type EsgHistoryElement = {
  /** Date of edit. */
  createdAt: Scalars['DateTime']['output'];
  /** User who committed given change. */
  editedBy?: Maybe<UserType>;
  /** UUID of changelog entity. */
  uuid: Scalars['ID']['output'];
};

export type EsgQuestion = {
  /**
   * Question activity type.
   * @deprecated Resolve QuestionActivity object type instead
   */
  activity: Scalars['String']['output'];
  /** When the requirement was last marked Addressed for the year; null while un-addressed. Echo this back as reviewedAddressedAt on esgFrameworkAuditEntryCreate; it also anchors the audit drift indicator. Distinct from lastActivityDate, which moves on any activity. */
  addressedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Resolved default answer for question. */
  answerForVersion?: Maybe<EsgAnswer>;
  /** Answers for resolved question. */
  answers: Array<EsgAnswer>;
  /** Answers count on question. */
  answersCount: Scalars['Int']['output'];
  /** Resolves audit events for question. If yearUuid is provided, only events for that year will be returned. If yearUuid is not provided, events for the active year will be returned. */
  auditEvents: AuditEventConnection;
  /** Resolved default answer for question. */
  defaultAnswer?: Maybe<EsgAnswer>;
  /** Files associated with the question. */
  files: Array<EsgFile>;
  /** Count of files associated with the question. */
  filesCount: Scalars['Int']['output'];
  /** Question header */
  header?: Maybe<Scalars['String']['output']>;
  /**
   * Flag indicating if question has been answered.
   * @deprecated Function moved to enum in status field
   */
  isAnswered: Scalars['Boolean']['output'];
  /** Returns true if the question is linked to the specified metric for the given year */
  isLinked: Scalars['Boolean']['output'];
  /** Last activity date */
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns metrics linked to this question. */
  linkedMetrics: Array<Metric>;
  /** Question metadata */
  metadata: Array<EsgQuestionMetadata>;
  /** Question navigation title */
  navigationTitle?: Maybe<Scalars['String']['output']>;
  /** Order of question. */
  order: Scalars['Int']['output'];
  /** Question contents. */
  question: Scalars['String']['output'];
  /** Fetches paginated question activities. */
  questionActivity?: Maybe<QuestionActivity>;
  /** ESG Question status */
  status: Esg_Question_Status;
  /** Parent step of given question. */
  step: EsgStep;
  /** Resolves active tasks for user. */
  tasks?: Maybe<Array<Task>>;
  /** Url to template of question. */
  templateURL?: Maybe<Scalars['URL']['output']>;
  /** UUID of resolved question. */
  uuid: Scalars['ID']['output'];
  /** Related video title */
  videoTitle?: Maybe<Scalars['String']['output']>;
  /** Url to video guide. */
  videoURL?: Maybe<Scalars['String']['output']>;
};


export type EsgQuestionAddressedAtArgs = {
  input?: InputMaybe<EsgQuestionAddressedAtInput>;
};


export type EsgQuestionAnswerForVersionArgs = {
  input?: InputMaybe<AnswerForVersionInput>;
};


export type EsgQuestionAnswersArgs = {
  input?: EsgQuestionAnswersInput;
};


export type EsgQuestionAnswersCountArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type EsgQuestionAuditEventsArgs = {
  input?: QuestionAuditEventsConnectionInput;
};


export type EsgQuestionFilesArgs = {
  input: EsgQuestionFilesResolveInput;
};


export type EsgQuestionFilesCountArgs = {
  input: EsgQuestionFilesResolveInput;
};


export type EsgQuestionIsAnsweredArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type EsgQuestionIsLinkedArgs = {
  input: IsLinkedInput;
};


export type EsgQuestionLastActivityDateArgs = {
  input?: InputMaybe<EsgQuestionLastActivityDateInput>;
};


export type EsgQuestionMetadataArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type EsgQuestionStatusArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type EsgQuestionTasksArgs = {
  input?: InputMaybe<EsgTasksInput>;
};

/** Represents input type for fetching a question's addressing timestamp. */
export type EsgQuestionAddressedAtInput = {
  /** Reporting year. If omitted will fetch for current active year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgQuestionAnswersInput = {
  taskMode?: Esg_Related_Tasks_Mode;
  /** Array of risk area UUIDs to filter answers by. Provide null to include default answer. */
  versionTagUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Reporting year associated with answer. If not provided, current active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for assigning files to question. */
export type EsgQuestionAssignFilesInput = {
  /** Array of file identifiers. Will only add files, not remove omited files by identifiers. */
  fileUuids: Array<Scalars['UUID']['input']>;
  /** Question identifier. */
  questionUuid: Scalars['UUID']['input'];
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgQuestionBatchUpdateInput = {
  questions: Array<EsgQuestionUpdateInput>;
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represetns esg question connection */
export type EsgQuestionConnection = {
  /** Array of edges. */
  edges: Array<EsgQuestionEdge>;
  /** Array of direct nodes. */
  nodes: Array<EsgQuestion>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for esg question connection. */
export type EsgQuestionConnectionInput = {
  /** Flag indicating should user settings be considered or not. */
  ignoreUserSettings?: Scalars['Boolean']['input'];
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /**
   * Question states that should be included. By default will return answered and unanswered questions.
   * @deprecated Since we added additional status, right now we should use query with array of enums instead of enum
   */
  questionState?: Esg_Question_State;
  /** Question statuses that should be included. By default will return all questions. */
  questionStatus?: InputMaybe<Array<Esg_Question_Status>>;
  /** Task assignment mode.  */
  questionTaskRelation?: Esg_Related_Tasks_Mode;
  /** Array of standard UUIDs to narrow down the list of questions. By default will query all tenant's enabled Standards. */
  standardsUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Tasks statuses that should be included. By default will return all task statuses. */
  taskStatus?: InputMaybe<Array<Task_Status>>;
  /** Array of units/industries to narrow down the list of questions. By default will query all tenant's enabled units. */
  unitsUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for esg question connection on filters page. */
export type EsgQuestionConnectionSearchInput = {
  /** Filters applicable to esg questions connection */
  filters?: InputMaybe<QuestionnaireFiltersInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
};

/** Represents EsgQuestion connection edge. */
export type EsgQuestionEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the EsgQuestion record. */
  node: EsgQuestion;
};

/** Input for querying files assigned to given question */
export type EsgQuestionFilesInput = {
  /** UUID of question. */
  questionUuid: Scalars['UUID']['input'];
  /** UUID of year. If not provided will return for current active year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for resolving files for question. */
export type EsgQuestionFilesResolveInput = {
  /** UUID of year. If not provided will return for current active year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input type for fetching question's last activity date. */
export type EsgQuestionLastActivityDateInput = {
  /** Year for activity. If omitted will fetch for current active year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgQuestionMetadata = {
  /** Metadata identifier. */
  id: Scalars['ID']['output'];
  metadata: Array<EsgQuestionRiskAreaMetadata>;
  standard: RiskArea;
};

export type EsgQuestionRiskAreaMetadata = {
  /**
   * @deprecated This field is no longer utilized by the frontend.
   * Instead, guideline paths are derived from nested tag data.
   * Refer to the EsgQuestionTagsMetadata type for details.
   */
  guidelinePath?: Maybe<Scalars['String']['output']>;
  /** Standard metadata identifier. */
  id: Scalars['ID']['output'];
  tagData: Array<EsgQuestionTagsMetadata>;
  unit?: Maybe<Unit>;
};

/** Represetns esg question search connection for filters page */
export type EsgQuestionSearchConnection = {
  /** Array of edges. */
  edges: Array<EsgQuestionEdge>;
  /** Array of direct nodes. */
  nodes: Array<EsgQuestion>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type EsgQuestionTagMetadata = {
  guidelinePath?: Maybe<Scalars['String']['output']>;
  /** Unit standard group tag tag metadata identifier. */
  id: Scalars['ID']['output'];
  tag: Tag;
};

export type EsgQuestionTagsMetadata = {
  groupTag: GroupTag;
  guidelinePath?: Maybe<Scalars['String']['output']>;
  /** Unit standard group tag metadata identifier. */
  id: Scalars['ID']['output'];
  tags: Array<EsgQuestionTagMetadata>;
  totalCount: Scalars['Int']['output'];
};

/** Represents input type for unassigning files from question. */
export type EsgQuestionUnassignFilesInput = {
  /** Array of file identifiers. Will only unassign files by provided identifiers. */
  fileUuids: Array<Scalars['UUID']['input']>;
  /** Question identifier. */
  questionUuid: Scalars['UUID']['input'];
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgQuestionUpdateInput = {
  /** Text of edited question. Nullable if TENANT_ADMIN deletes it's own question */
  question?: InputMaybe<Scalars['String']['input']>;
  /** UUID of edited question */
  uuid: Scalars['UUID']['input'];
};

export type EsgQuestionsInput = {
  /** Flag indicating should user settings be considered or not. */
  ignoreUserSettings?: Scalars['Boolean']['input'];
  /**
   * Question states that should be included. By default will return answered and unanswered questions.
   * @deprecated Since we added additional status, right now we should use query with array of enums instead of enum
   */
  questionState?: Esg_Question_State;
  /** Question statuses that should be included. By default will return all questions. */
  questionStatus?: InputMaybe<Array<Esg_Question_Status>>;
  /** Task assignment mode.  */
  questionTaskRelation?: Esg_Related_Tasks_Mode;
  /** Array of standard UUIDs to narrow down the list of questions. By default will query all tenant's enabled Standards. */
  standardsUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Tasks statuses that should be included. By default will return all task statuses. */
  taskStatus?: InputMaybe<Array<Task_Status>>;
  /** Array of units/industries to narrow down the list of questions. By default will query all tenant's enabled units. */
  unitsUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input to register uploaded documents into a framework library. */
export type EsgRegisterFrameworkDocumentsInput = {
  /** File UUIDs to register (status UPLOADED). */
  fileUuids: Array<Scalars['UUID']['input']>;
  /** Framework (risk area) UUID. */
  frameworkUuid: Scalars['UUID']['input'];
};

export type EsgRiskAreaSettingByProgram = {
  /** The flag indicating if the risk area setting is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the risk area setting */
  name: Scalars['String']['output'];
  /** The UUID of the risk area setting */
  uuid: Scalars['UUID']['output'];
};

export type EsgRiskAreaSettingsByProgram = {
  /** The UUID of the program */
  programUuid: Scalars['UUID']['output'];
  /** The risk area settings of the program */
  riskAreaSettings: Array<EsgRiskAreaSettingByProgram>;
  /** The UUID of the tenant */
  tenantUuid: Scalars['String']['output'];
};

export type EsgRiskAreaSettingsByProgramConfig = {
  isEnabled: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type EsgRolePermission = {
  /** Role permission name. */
  permission: Assignable_Permission;
  /** Risk area related to this permission. */
  riskArea: RiskArea;
  /** Role permission UUID. */
  uuid: Scalars['UUID']['output'];
};

/** Input to set the Smart Fill processing status of framework documents. */
export type EsgSetSmartFillDocumentStatusInput = {
  /** File UUIDs whose documents to update. */
  fileUuids: Array<Scalars['UUID']['input']>;
  /** Framework (risk area) UUID. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Target processing status. */
  status: Smart_Fill_Document_Status;
};

/** A citation (file + optional section/excerpt) to persist when accepting a draft. */
export type EsgSmartFillAcceptCitationInput = {
  /** UUID of the cited source file. */
  fileUuid: Scalars['UUID']['input'];
  /** Optional page in the source document. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Optional section reference or excerpt. */
  sectionOrExcerpt?: InputMaybe<Scalars['String']['input']>;
  /** Sheet name for spreadsheet sources; null for other file types. */
  sheetName?: InputMaybe<Scalars['String']['input']>;
  /** Optional classification of the citation content. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input to accept a pending Smart Fill draft as an answer with evidence. */
export type EsgSmartFillAcceptDraftInput = {
  /** UUID of the draft to accept. */
  draftUuid: Scalars['UUID']['input'];
  /** Edited answer JSON; when omitted the original draft answer is used. */
  editedAnswer?: InputMaybe<Scalars['String']['input']>;
  /** Edited citation set; when omitted the ingested citations are used. */
  editedCitations?: InputMaybe<Array<EsgSmartFillAcceptCitationInput>>;
};

/** One Smart Fill draft row to persist as an ESG answer (editor JSON + optional version tag). */
export type EsgSmartFillApplyDraftItemInput = {
  /** Answer content as serialized editor JSON (same format as questionnaire answers). */
  draftAnswer: Scalars['String']['input'];
  /** Question UUID within the selected framework. */
  questionUuid: Scalars['UUID']['input'];
  /** Version tag UUID. When omitted or null, writes to the default (Global Standards) answer for the question. */
  selectedVersion?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input to persist selected Smart Fill drafts as ESG answers, or finish the job without saving any drafts (empty drafts array). */
export type EsgSmartFillApplyDraftsInput = {
  /** Draft rows to persist. An empty array finishes the job without writing any answers. */
  drafts: Array<EsgSmartFillApplyDraftItemInput>;
  /** Framework (risk area) UUID. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Smart Fill job UUID from esgSmartFillStart. Marks the job as APPLIED in Insights after apply. */
  jobUuid: Scalars['UUID']['input'];
  /** Programme UUID used to scope questions and framework access. */
  programmeUuid: Scalars['UUID']['input'];
  /** Reporting year UUID. When omitted, the tenant active year is used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of applying Smart Fill drafts to ESG questionnaire answers. */
export type EsgSmartFillApplyDraftsPayload = {
  /** Persisted answers in questionnaire version order (same as input drafts order). */
  answers: Array<EsgAnswer>;
  /** Number of answers successfully upserted. */
  appliedCount: Scalars['Int']['output'];
};

export type EsgSmartFillCancelInput = {
  /** Framework (risk area) UUID the run belongs to. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Smart Fill job UUID to cancel. */
  jobUuid: Scalars['UUID']['input'];
  /** Programme UUID. Omit for standalone frameworks. */
  programmeUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of cancelling a Smart Fill run. */
export type EsgSmartFillCancelPayload = {
  /** Smart Fill job UUID. */
  jobUuid: Scalars['UUID']['output'];
  /** CANCELLED on success. */
  status: Insights_Smart_Fill_Job_Status;
};

/** Input to dismiss a pending Smart Fill draft. */
export type EsgSmartFillDismissDraftInput = {
  /** UUID of the draft to dismiss. */
  draftUuid: Scalars['UUID']['input'];
};

/** AI-generated draft answer for a single question in Smart Fill job. */
export type EsgSmartFillDraftAnswer = {
  /** Confidence score assigned by Smart Fill model. */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Draft answer text generated by Smart Fill. */
  draftAnswer?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the draft answer was generated by AI. */
  isAiDraft: Scalars['Boolean']['output'];
  /** Question for which this Smart Fill draft was generated. */
  question: EsgQuestion;
  /** Source snippets used to construct this draft answer. */
  sources: Array<EsgSmartFillSource>;
  /** Current review status of the draft answer. */
  status: Insights_Smart_Fill_Draft_Status;
};

/** Citation linking a Smart Fill draft answer to a source file. */
export type EsgSmartFillDraftCitation = {
  /** Source file from which this citation was extracted. */
  file: EsgFile;
  /** Page in the source document the excerpt was drawn from. */
  page?: Maybe<Scalars['Int']['output']>;
  /** Section reference or excerpt from the source file. */
  sectionOrExcerpt?: Maybe<Scalars['String']['output']>;
  /** Sheet name for spreadsheet sources; null for other file types. */
  sheetName?: Maybe<Scalars['String']['output']>;
  /** Classification of the citation content. */
  type?: Maybe<Scalars['String']['output']>;
  /** Unique citation identifier. */
  uuid: Scalars['UUID']['output'];
};

/** Result of a Smart Fill draft review action (accept or dismiss). */
export type EsgSmartFillDraftMutationResult = {
  /** Linked answer UUID when the draft was accepted. */
  answerUuid?: Maybe<Scalars['UUID']['output']>;
  /** Resulting review status of the draft. */
  status: Smart_Fill_Draft_Status;
  /** Unique draft identifier. */
  uuid: Scalars['UUID']['output'];
};

/** Input to fetch the accepted Smart Fill draft citations for a question (Evidence tab attribution). */
export type EsgSmartFillEvidenceCitationsInput = {
  /** Question UUID. */
  questionUuid: Scalars['UUID']['input'];
  /** Reporting year UUID. When omitted, the tenant active year is used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** A single Smart Fill draft row to ingest for a question. */
export type EsgSmartFillIngestDraftItemInput = {
  /** Confidence score assigned by the Smart Fill model. */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /** Draft answer from the Smart Fill model as plain text (prose) or serialized editor JSON. Null when the model produced no answer; null/empty answers are skipped on ingest. */
  draftAnswer?: InputMaybe<Scalars['String']['input']>;
  /** Question UUID this draft was generated for. */
  questionUuid: Scalars['UUID']['input'];
  /** Source citations for this draft answer. */
  sources: Array<EsgSmartFillIngestSourceInput>;
};

/** Input to ingest a batch of Smart Fill draft answers produced by the Insights pipeline. */
export type EsgSmartFillIngestDraftsInput = {
  /** Draft rows to persist (max 500, one per question). */
  drafts: Array<EsgSmartFillIngestDraftItemInput>;
  /** Framework (risk area) UUID. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Smart Fill job UUID from the Insights pipeline. */
  jobUuid: Scalars['UUID']['input'];
  /** Programme UUID used to scope the ingest. Omit for standalone frameworks. */
  programmeUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Reporting year UUID. When omitted, the tenant active year is used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of a Smart Fill draft ingest operation. */
export type EsgSmartFillIngestResult = {
  /** Number of drafts successfully ingested. */
  ingestedCount: Scalars['Int']['output'];
};

/** A single source document reference for a Smart Fill draft ingest. */
export type EsgSmartFillIngestSourceInput = {
  /** UUID of the source file. */
  fileUuid: Scalars['UUID']['input'];
  /** Optional page in the source document. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Optional section reference or excerpt from the source file. */
  sectionOrExcerpt?: InputMaybe<Scalars['String']['input']>;
  /** Sheet name for spreadsheet sources; null for other file types. */
  sheetName?: InputMaybe<Scalars['String']['input']>;
  /** Optional classification of the source content. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Smart Fill job state with contextual data and generated drafts. */
export type EsgSmartFillJob = {
  /** Draft answers currently available for this Smart Fill job. */
  drafts: Array<EsgSmartFillDraftAnswer>;
  /** Programme selected for Smart Fill processing. Null for standalone frameworks. */
  programme?: Maybe<Program>;
  /** Risk area (framework) selected for Smart Fill processing. */
  riskArea: RiskArea;
  /** Current processing status of Smart Fill job. */
  status: Insights_Smart_Fill_Job_Status;
  /** Unique Smart Fill job identifier. */
  uuid: Scalars['UUID']['output'];
};

/** A persisted Smart Fill draft awaiting user review. */
export type EsgSmartFillPendingDraft = {
  /** Citations supporting this draft answer. */
  citations: Array<EsgSmartFillDraftCitation>;
  /** Confidence score assigned by the Smart Fill model. */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Date when this draft was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Draft answer text generated by Smart Fill. */
  draftAnswer: Scalars['String']['output'];
  /** Question UUID this draft was generated for. */
  questionUuid: Scalars['UUID']['output'];
  /** Current review status of this draft. */
  status: Smart_Fill_Draft_Status;
  /** Unique draft identifier. */
  uuid: Scalars['UUID']['output'];
};

/** Input to query pending Smart Fill drafts for a framework and optional year. */
export type EsgSmartFillPendingDraftsInput = {
  /** Framework (risk area) UUID. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Reporting year UUID. When omitted, the tenant active year is used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgSmartFillResumeInput = {
  /** Documents to leave out of the resumed run. Only documents Nicole couldn't read may be listed here. */
  excludeFileUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Framework (risk area) UUID the run belongs to. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Smart Fill job UUID to resume. */
  jobUuid: Scalars['UUID']['input'];
  /** How to proceed: CONTINUE_WITHOUT drafts without the unreadable documents, RETRY re-attempts them. */
  mode: Smart_Fill_Resume_Mode;
  /** Programme UUID. Omit for standalone frameworks. */
  programmeUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of resuming a halted (AWAITING_INPUT) Smart Fill run. */
export type EsgSmartFillResumePayload = {
  /** Smart Fill job UUID. */
  jobUuid: Scalars['UUID']['output'];
  /** QUEUED on success. */
  status: Insights_Smart_Fill_Job_Status;
};

/** Source fragment used to generate Smart Fill draft answer. */
export type EsgSmartFillSource = {
  /** File from which this source fragment was extracted. */
  file: EsgFile;
  /** Page in the source document the excerpt was drawn from. */
  page?: Maybe<Scalars['Int']['output']>;
  /** Optional section reference or excerpt used by Smart Fill. */
  sectionOrExcerpt?: Maybe<Scalars['String']['output']>;
  /** Sheet name for spreadsheet sources; null for other file types. */
  sheetName?: Maybe<Scalars['String']['output']>;
  /** Classification of source content used for the draft. */
  type: Insights_Smart_Fill_Source_Type;
};

export type EsgSmartFillStartInput = {
  /** How this job's drafts are delivered on completion. Omit for the legacy client-apply flow. */
  completionMode?: InputMaybe<Insights_Smart_Fill_Completion_Mode>;
  /** UUIDs of already uploaded files. */
  fileUuids: Array<Scalars['UUID']['input']>;
  /** Framework (risk area) UUID for Smart Fill job. */
  frameworkUuid: Scalars['UUID']['input'];
  /** Programme UUID used to scope Smart Fill job context. Omit for standalone frameworks. */
  programmeUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents Engage Stakeholder report generation input. */
export type EsgStakeholderReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Report custom name. Max length: 85. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating should only answers to questions marked as answered be considered in report. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional programme UUIDs. Limits Stakeholder report to risk areas linked to these programmes for the tenant. */
  programmeUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of risk area that should be used for Stakeholder report generation. */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUIDs of risk area that should be used for Stakeholder report generation. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Steps that should be used to fetch answers and questions to report. */
  steps?: InputMaybe<Array<Esg_Step>>;
  /** Given years UUIDs that should be used for Stakeholder report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type EsgStandard = {
  /** Is standard enabled for tenant */
  enabled: Scalars['Boolean']['output'];
  /** Framework category bucket (FRAMEWORK_CATEGORY dictionary value); the panel groups by this live value instead of a client-side manifest */
  frameworkCategory?: Maybe<Scalars['String']['output']>;
  /** Standard name */
  name: Scalars['String']['output'];
  /** The seat count recorded for this framework, as reported by the tenants service. Null means no terms are recorded for this framework - never zero: a recorded zero is a real answer and is returned as 0, not null. Always null for a disabled framework. */
  seatCount?: Maybe<Scalars['Int']['output']>;
  /** The Smart Fill entitlement recorded for this framework, as reported by the tenants service. Null means no terms are recorded for this framework - never false: a recorded false is a real answer and is returned as false, not null. Always null for a disabled framework. */
  smartFill?: Maybe<Scalars['Boolean']['output']>;
  /** The tier this framework's seat pool was last sized for, as recorded by the tenants service. Null when no tier was recorded - a negotiated seat count without a tier, a pool that predates the record, or a disabled framework. */
  tier?: Maybe<Framework_Plan>;
  /** Standard uuid */
  uuid: Scalars['UUID']['output'];
};

export type EsgStandardStatusBatchUpdateInput = {
  /** Why this provisioning is being done - recorded on the provisioning history. Required when granting the free tier. */
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantStandards: Array<EsgStandardStatusUpdateInput>;
  /** Tenant UUID */
  tenantUuid: Scalars['ID']['input'];
};

export type EsgStandardStatusUpdateInput = {
  /** Tier this framework is provisioned on, by name - the same tiers the shop sells, plus the staff-only free tier. Provisioning writes the framework's own seat pool from it, so an offline sale records what was bought instead of falling back to the tenant-wide licence count. Only valid when enabling - and required when enabling, together with or instead of seatCount: an enable row with neither is refused, since it would leave the framework with no seat pool at all. */
  plan?: InputMaybe<Framework_Plan>;
  /** Explicit seat pool for this framework, for a negotiated contract. Overrides the plan's seat count when both are given. Only valid when enabling. */
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  /** Flag indicating should be active or inactive */
  status: Scalars['Boolean']['input'];
  /** ESG Standard UUID */
  uuid: Scalars['UUID']['input'];
};

/** ESG standard with at least one risk area */
export type EsgStandardWithConnectedRiskAreas = {
  /** Name of the standard */
  name: Scalars['String']['output'];
  /** UUID of the standard */
  uuid: Scalars['UUID']['output'];
};

export type EsgStatistics = {
  /** Number of answered questions for given category or subcategory. */
  answeredQuestions: Scalars['Int']['output'];
  /** Compound ID. */
  id: Scalars['ID']['output'];
  /** Total number of questions for given category or subcategory. */
  totalQuestions: Scalars['Int']['output'];
};

/** Input for adjusting ESG statistics scope. */
export type EsgStatisticsInput = {
  /** Flag indicating should user settings be considered or not. */
  ignoreUserSettings?: Scalars['Boolean']['input'];
  /** Question statuses that should be included in total questions. By default will return all questions. */
  questionStatus?: InputMaybe<Array<Esg_Question_Status>>;
  /** Task assignment mode.  */
  questionTaskRelation?: Esg_Related_Tasks_Mode;
  /** Array of Standards' UUIDs. By default will consider all enabled standards. */
  standardsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Tasks statuses that should be included. By default will return all task statuses. */
  taskStatus?: InputMaybe<Array<Task_Status>>;
  /** Array of units/industries to narrow down the list of questions. By default will query all tenant's enabled units. */
  unitsUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Uuid of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgStep = {
  /** id of step, format - <risk area uuid>+<step name> */
  id: Scalars['ID']['output'];
  /** Determines if all questions in given step are answered (each questions have status ANSWERED) */
  isAnswered: Scalars['Boolean']['output'];
  /** Name of the step. */
  name: Esg_Step;
  /** Order of the step. */
  order: Scalars['Int']['output'];
  /** List of questions for given step. */
  questions: Array<EsgQuestion>;
  /** Subcategory of resolved step. */
  riskArea: RiskArea;
  /**
   * UUID of the step.
   * @deprecated Steps are no longer identified by UUIDs, use field id.
   */
  uuid: Scalars['ID']['output'];
};


export type EsgStepIsAnsweredArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type EsgStepQuestionsArgs = {
  input?: EsgQuestionsInput;
};

export type EsgStepsForAuditReportInput = {
  /** Array of Risk area uuid. */
  riskAreaUuids: Array<Scalars['UUID']['input']>;
  /** Standard uuid. */
  standardUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgStepsWithAnyQuestionsInput = {
  mode?: Esg_Related_Tasks_Mode;
  /** Risk area uuid. */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Risk area uuid. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * Standard uuid.
   * @deprecated No need to pass standardUuid if riskAreaUuid is passed
   */
  standardUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUIDs of reporting year. If not provided active year will be used */
  yearUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type EsgSubcategory = {
  /** Resolves parent ESG category. */
  category?: Maybe<EsgCategory>;
  /** UUID of parent category. */
  categoryUuid: Scalars['UUID']['output'];
  /** Change history for resolved subcategory. */
  history: Array<EsgHistoryElement>;
  /** Returns last activity date. */
  lastActiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Name of given subcategory */
  name: Esg_Subcategory;
  /** Order of subcategory. */
  order?: Maybe<Scalars['Int']['output']>;
  /** UUID of given subcategory */
  uuid: Scalars['ID']['output'];
};

/** ESG tag connection. */
export type EsgTagConnection = {
  /** Array of edges. */
  edges: Array<EsgTagEdge>;
  /** Array of direct nodes. */
  nodes: Array<Tag>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for ESG tag connection. */
export type EsgTagConnectionInput = {
  /** Excludes tags belonging to given risk area or standard. */
  excludeRiskAreaOrStandardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter to narrow tags. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Risk area UUIDs. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Standard UUIDs. */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents Tag connection edge. */
export type EsgTagEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Tag record. */
  node: Tag;
};

export type EsgTaskDisabledReason = {
  conditionalSectors?: Maybe<Array<Sector>>;
  riskArea?: Maybe<RiskArea>;
  riskAreaDisabled?: Maybe<Scalars['Boolean']['output']>;
  sectors?: Maybe<Array<Sector>>;
  standard?: Maybe<RiskArea>;
  standardDisabled?: Maybe<Scalars['Boolean']['output']>;
  unitDisabled?: Maybe<Scalars['Boolean']['output']>;
  units?: Maybe<Array<Unit>>;
};

export type EsgTasksInput = {
  /** Tasks fetch mode. External user may only fetch tasks assigned to them. */
  mode?: InputMaybe<Esg_Task_Fetch_Mode>;
  /** UUID of given year. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type EsgTenantProgramSetting = {
  /** The count of all risk areas */
  allRiskAreasCount: Scalars['Float']['output'];
  /** The category of the program */
  category: ProgramSettingCategory;
  /** The count of enabled risk areas */
  enabledRiskAreasCount: Scalars['Float']['output'];
  /** Flag indicating if the program is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the program */
  name: Scalars['String']['output'];
  /** The UUID of the program */
  uuid: Scalars['UUID']['output'];
};

export type EsgTenantProgramSettings = {
  /** The settings of the program */
  settings: Array<EsgTenantProgramSetting>;
  /** The UUID of the tenant */
  tenantUuid: Scalars['String']['output'];
};

export type EsgUnansweredQuestionsCountInput = {
  /** UUIDs of risk areas to count unanswered questions. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents question video. */
export type EsgVideo = {
  /** Video Title. */
  videoTitle: Scalars['String']['output'];
  /** Video URL. */
  videoURL: Scalars['String']['output'];
};

/** Represents EsgVideoConnection connection. */
export type EsgVideoConnection = {
  /** Array of edges. */
  edges: Array<EsgVideoEdge>;
  /** Array of direct nodes. */
  nodes: Array<EsgVideo>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of esg videos */
export type EsgVideoConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional array of riskArea UUIDs. Limits videos links to questions in given risk areas. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<EsgVideoSortInput>>;
};

/** Represents EsgVideo connection edge. */
export type EsgVideoEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the EsgVideo record. */
  node: EsgVideo;
};

export type EsgVideoSortFields =
  | 'VIDEO_TITLE';

export type EsgVideoSortInput = {
  direction: SortDirection;
  field: EsgVideoSortFields;
};

/** Represents pagination connection of case owner exclusion users. */
export type ExclusionAdminUserConnection = {
  /** Array of edges. */
  edges: Array<V2CaseExclusionOwnerEdge>;
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Array of direct nodes. */
  nodes: Array<CaseExclusionOwner>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of case owner exclusion users. */
export type ExclusionAdminUserConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<CaseExclusionOwnerSortInput>>;
};

/** Represents the input for user exclusion settings. */
export type ExclusionSettingsInput = {
  /** Exclusion fallback user uuid. */
  fallbackUserUuid?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether case owner exclusion should be enabled. */
  isExclusionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One executive-education course and its flat fee for a session of up to 20 people. */
export type ExecEdCourse = {
  category: Scalars['String']['output'];
  /** 3 or 5. */
  days: Scalars['Int']['output'];
  /** The fee for that duration as a decimal string ("18000.00"); travel and taxes are additional. */
  priceUsd: Scalars['String']['output'];
  /** URL-safe identifier derived from the title; the storefront links to a course by it. */
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** The buyer's course-duration answer for an exec-ed quote. */
export type ExecEdPriceInput = {
  /** 3 or 5. */
  days: Scalars['Int']['input'];
};

/** Represents input for upserting Metric */
export type ExportMetricInput = {
  /** type of file output */
  outputFileType: Metric_Export_File_Extension;
  /** list of ids for cols to be exported */
  selectedColumns: Array<Scalars['String']['input']>;
  /** list of rows & subrows to be exported */
  selectedRows: Array<SelectedRowsToExportMetricInput>;
  /** Uuid of the metric */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** year of the metric data */
  year: Scalars['Int']['input'];
};

export type ExternalUserAvailableRiskArea = {
  /** All risk areas that user may navigate to */
  allRiskAreas: Array<RiskArea>;
  /** Flag which says if user has task on unmapped questions */
  hasUnmappedTask: Scalars['Boolean']['output'];
  /** Risk area that user may navigate to. If null indicates unmapped questions. */
  riskArea?: Maybe<RiskArea>;
};

/** Enumeration of tenant features. */
export type Feature =
  | 'CASES_ASSIGNMENT_RULES'
  | 'CASES_MANUAL_CREATE'
  | 'CASES_PRINTING'
  | 'CASES_REGIONAL_ROLE'
  | 'CASES_REMINDER'
  | 'INSIGHTS_XBRL_TAXONOMY';

export type Fitness_Formula_Kind =
  | 'AVERAGE'
  | 'COMPLEMENT'
  | 'PERCENT_DIRECT'
  | 'RATIO';

export type Fitness_Variable_Role =
  | 'DENOMINATOR'
  | 'NUMERATOR'
  | 'VALUE'
  | 'WEIGHT';

export type Framework_Audit_Gap_Run_Status =
  | 'COMPLETED'
  | 'FAILED'
  | 'PROCESSING'
  | 'QUEUED';

export type Framework_Audit_Gap_Suggestion_Status =
  | 'ACCEPTED'
  | 'DISMISSED'
  | 'PENDING'
  | 'SUPERSEDED';

export type Framework_Audit_Status =
  | 'ASSIGNED'
  | 'COMPLETED'
  | 'REQUESTED'
  | 'WITHDRAWN';

export type Framework_Category =
  | 'BENCHMARKS'
  | 'GREEN_CLAIMS'
  | 'MANAGEMENT_SYSTEMS'
  | 'RATINGS'
  | 'REPORTING'
  | 'VERIFICATION';

/** Tier a framework is provisioned on, by name - the same tiers the shop sells, plus the staff-only free tier. Each carries its own per-framework seat pool. */
export type Framework_Plan =
  | 'ENHANCED'
  | 'ENTERPRISE'
  | 'LIMITED'
  | 'STANDARD';

export type FeatureSetting = {
  enabled: Scalars['Boolean']['output'];
  module: ModuleSetting;
  /** Module UUID */
  moduleUuid: Scalars['UUID']['output'];
  /** Feature. */
  name: Feature;
  /** UUID of given feature. */
  uuid: Scalars['ID']['output'];
};

export type FeatureUpdateInput = {
  /** Corresponds to CASES_ASSIGNMENT_RULES feature. */
  casesAssignmentRules?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corresponds to CASES_MANUAL_CREATE feature. */
  casesManualCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corresponds to CASES_PRINTING feature. */
  casesPrinting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corresponds to CASES_REGIONAL_ROLE feature. */
  casesRegionalRole?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corresponds to CASES_REMINDER feature. */
  casesReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corresponds to INSIGHTS_XBRL_TAXONOMY feature. */
  insightsXbrlTaxonomy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeeTablePrice = {
  bespoke: Scalars['Boolean']['output'];
  /** Set only when bespoke = true, a fact-stated sentence about why the scope is priced by Speeki. */
  bespokeReason?: Maybe<Scalars['String']['output']>;
  /** "Annual" | "Quarterly" | null when bespoke. */
  billing?: Maybe<Scalars['String']['output']>;
  /** Only set when billing = "Quarterly". */
  perQuarterYear1Usd?: Maybe<Scalars['String']['output']>;
  pricingVersion: Scalars['String']['output'];
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  /** Null for exec ed. */
  threeYearUsd?: Maybe<Scalars['String']['output']>;
  year1Usd?: Maybe<Scalars['String']['output']>;
  /** Null for exec ed (single payment, no renewal). */
  year2Usd?: Maybe<Scalars['String']['output']>;
  /** Null for exec ed. */
  year3Usd?: Maybe<Scalars['String']['output']>;
};

/** Inputs for querying tenants by name. May be deprecated when paginated resolver is added */
export type FindGlobalTenantDataByNameInput = {
  tenantCount?: InputMaybe<Scalars['Int']['input']>;
  tenantName: Scalars['String']['input'];
};

/** Object containing details about subscribed or unsubscribed FCM topics. */
export type FirebaseResponse = {
  type: NotificationTopicTypes;
  /** Value of constraint */
  value: Scalars['String']['output'];
};

export type FirebaseToken = {
  /** Firebase Auth Custom token signed with a service account key and containing user uuid (for authorized users) or case uuid (for access via case pin code). */
  token: Scalars['String']['output'];
};

/** Object containing information about subscribed Firebase topic. */
export type FirebaseTopicSubscription = {
  /** The time subscription was created */
  createdAt: Scalars['DateTime']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  type: NotificationTopicTypes;
  /** UUID of subscribed topic */
  uuid: Scalars['String']['output'];
  /** Value of constraint */
  value: Scalars['String']['output'];
};

export type FitnessIndicator = {
  /** Context indicators the guide asks to report alongside. */
  contextIndicators?: Maybe<Scalars['String']['output']>;
  /** Verbatim indicator description. */
  description: Scalars['String']['output'];
  /** Computed fitness percentage (0-100) for the requested year; null until every required variable has a value. */
  fitness?: Maybe<Scalars['Float']['output']>;
  /** Display-only formula, e.g. "F = ER / ET". */
  formulaDisplay: Scalars['String']['output'];
  formulaKind: Fitness_Formula_Kind;
  /** Set only when the goal has several indicators. */
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  variables: Array<FitnessVariable>;
};

export type FitnessVariable = {
  /** Verbatim definition from the guide. */
  definition: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  role: Fitness_Variable_Role;
  /** Display symbol, e.g. "ER". */
  symbol: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  /** The tenant value for the requested year. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type ForwardEarthCredentials = {
  /** Decoded apiKey */
  apiKey: Scalars['String']['output'];
  /** Forward Earth Api Key UUID. */
  forwardEarthApiKeyUuid?: Maybe<Scalars['String']['output']>;
  /** Forward Earth Tenant UUID. */
  forwardEarthTenantUuid: Scalars['String']['output'];
  /** Forward Earth instance URL. */
  instanceUrl: Scalars['String']['output'];
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['output'];
  /** Unique identifier of Forward Earth credentials. */
  uuid: Scalars['String']['output'];
};

export type ForwardEarthCredentialsUpsertInput = {
  /** Forward Earth API key. */
  apiKey: Scalars['String']['input'];
  /** Unique identifier of api key from forward earth. */
  forwardEarthApiKeyUuid?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of tenant from forward earth. */
  forwardEarthTenantUuid: Scalars['String']['input'];
  /** Forward Earth instance URL. */
  instanceUrl: Scalars['String']['input'];
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['input'];
};

export type FrameworkImportCategoryObject = {
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type FrameworkImportFrameworkObject = {
  categoryName: Scalars['String']['output'];
  categoryUuid?: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  edition: Scalars['String']['output'];
  frameworkCategory: Scalars['String']['output'];
  installed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  topicKey: Scalars['String']['output'];
};

export type FrameworkImportInput = {
  commit?: Scalars['Boolean']['input'];
  fileBase64: Scalars['String']['input'];
  meta: FrameworkMetaInput;
};

export type FrameworkImportResult = {
  committed: Scalars['Boolean']['output'];
  counts: ImportCountsObject;
  identityRegistered: Scalars['Boolean']['output'];
  issues: Array<ValidationIssueObject>;
  message?: Maybe<Scalars['String']['output']>;
  topicStatus: Scalars['String']['output'];
  topicUuid?: Maybe<Scalars['String']['output']>;
};

export type FrameworkMetaInput = {
  categoryUuid: Scalars['String']['input'];
  code: Scalars['String']['input'];
  edition: Scalars['String']['input'];
  frameworkCategory: Scalars['String']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  topicKey: Scalars['String']['input'];
};

export type FrameworkRequestInput = {
  /** Display name of the framework the client is requesting access to. */
  frameworkName: Scalars['String']['input'];
};

/** One framework's seat-pool summary for the caller's tenant - counts only, no occupant identities. */
export type FrameworkSeatPoolOverview = {
  /** Seats still available. */
  remainingSeatCount: Scalars['Int']['output'];
  /** UUID of the framework (risk area) this pool belongs to. */
  riskAreaUuid: Scalars['UUID']['output'];
  /** Total seats the tenant holds for this framework. */
  seatCount: Scalars['Int']['output'];
  /** Number of seats currently occupied. */
  usedSeatCount: Scalars['Int']['output'];
  /** Whether the calling user occupies a seat in this framework. */
  viewerHasSeat: Scalars['Boolean']['output'];
};

/** A framework's seat roster - current occupants plus the pool's seat capacity. */
export type FrameworkSeatRoster = {
  /** Users currently occupying a seat in this framework. */
  occupants: Array<UserType>;
  /** Seats still available in the pool. */
  remainingSeatCount: Scalars['Int']['output'];
  /** UUID of the framework (risk area) this roster belongs to. */
  riskAreaUuid: Scalars['UUID']['output'];
  /** Total seats configured for the framework's pool. */
  seatCount: Scalars['Int']['output'];
  /** Number of seats currently occupied. */
  usedSeatCount: Scalars['Int']['output'];
};

/** One framework's Smart Fill entitlement for the caller's tenant. A framework with no recorded entitlement is absent from the list rather than reported as false - absence means "not decided", which consumers must not read as a refusal. */
export type FrameworkSmartFillEntitlement = {
  /** UUID of the framework (risk area) this entitlement belongs to. */
  riskAreaUuid: Scalars['UUID']['output'];
  /** Whether the tenant's plan for this framework includes Nicole Smart Fill. */
  smartFill: Scalars['Boolean']['output'];
};

export type GenericPlanUpdateInput = {
  /** Carbon Lens module enabled flag. */
  carbonLens?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cases module enabled flag. */
  cases?: InputMaybe<Scalars['Boolean']['input']>;
  /** Demo module enabled flag. */
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disclosures module enabled flag. */
  disclosures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Due Diligence module enabled flag. */
  dueDiligence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Esg module enabled flag. */
  esg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feature update input. */
  features?: InputMaybe<FeatureUpdateInput>;
  /** Frameworks module enabled flag. */
  frameworks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Insights module enabled flag. */
  insights?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nicole GPT module enabled flag. */
  nicoleGpt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Edited generic plan name. Custom plans are not accepted. */
  planName: Subscription_Plan;
  /** Sso module enabled flag. */
  sso?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subsidiaries module enabled flag. */
  subsidiarySites?: InputMaybe<Scalars['Boolean']['input']>;
  /** Surveys module enabled flag. */
  surveys?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tasks module enabled flag. */
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Teams module enabled flag. */
  teams?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trainings module enabled flag. */
  trainings?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents input to get unique case activity settings. */
export type GetCaseActivitySettingsInput = {
  /** Unique identifier of case activity settings. */
  uuid: Scalars['UUID']['input'];
};

/** Represents input to fetch unique custom reminder. */
export type GetCaseCustomReminderInput = {
  /** Unique identifier of custom reminder. */
  uuid: Scalars['UUID']['input'];
};

/** Represents input to get unique conclusion type. */
export type GetConclusionTypeInput = {
  /** Unique identifier of conclusion type. */
  uuid: Scalars['UUID']['input'];
};

export type GetProgramSettingsInput = {
  tenantUuid: Scalars['String']['input'];
};

export type GetRegionInput = {
  /** Unique identifier of region and country mapping. */
  uuid: Scalars['String']['input'];
};

/** Represents input to get unique reporting source. */
export type GetReportingSourceInput = {
  /** Unique identifier of reporting source. */
  uuid: Scalars['UUID']['input'];
};

export type GetRiskAreaSettingsByProgramInput = {
  programUuid: Scalars['String']['input'];
  tenantUuid: Scalars['String']['input'];
};

export type GetWhistleblowerCaseReportPdfInput = {
  caseId: Scalars['String']['input'];
  companyCode: Scalars['String']['input'];
  pinCode: Scalars['String']['input'];
};

export type GlobalTenantBaseData = {
  /** Tenant's API URL. */
  apiUrl: Scalars['String']['output'];
  /** Tenant's region. */
  clusterId: ClusterIds;
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Tenant's spreadsheet API URL. */
  spreadsheetApiUrl: Scalars['String']['output'];
  /** Subsidiary site UUID. Null for headquarters or if subsidiary was not provided. */
  subsidiarySiteUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Represents pagination input for connection of glossary entries */
export type GlossaryConnectInput = {
  /** A first letter to scope subjects */
  firstLetter?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of guidelines that glossary entries should be scoped to. */
  guidelinesUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Allow to exact match a glossary entry by the path ID */
  pathId?: InputMaybe<Scalars['String']['input']>;
  /** Text search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to a given standards. All standards if not provided. */
  standard?: InputMaybe<Esg_Standard_Subcategory>;
};

/** Represents paginated collection of glossary entries */
export type GlossaryConnection = {
  /** Array of edges. */
  edges: Array<GlossaryEntryEdge>;
  /** Array of direct nodes. */
  nodes: Array<GlossaryEntry>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type GlossaryEntry = {
  /** Glossary entry content in markdown format */
  description: Scalars['String']['output'];
  /** Glossary entry title */
  subject: Scalars['String']['output'];
  /** UUID of a glossary entry */
  uuid: Scalars['UUID']['output'];
};

/** Represents GlossaryEntry connection edge. */
export type GlossaryEntryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the GlossaryEntry record. */
  node: GlossaryEntry;
};

/** Input to replace glossary by passing markdown with all glossary items */
export type GlossaryInsertInput = {
  /** Glossary markdown. Max length is 16777215 chars */
  markdown: Scalars['String']['input'];
};

/** Grant types of OAuth clients. */
export type GrantTypes =
  | 'AUTHORIZATION_CODE'
  | 'CLIENT_CREDENTIALS'
  | 'IMPLICIT'
  | 'REFRESH_TOKEN';

/** Represents input for user's API storage update. */
export type GraphStorageUpdateInput = {
  /** Represents data which should be persisted in user's API storage. */
  data: Scalars['JSON']['input'];
};

export type GreenDeskPlanRule = {
  /** The plan's price per year. */
  annualUsd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Claim reviews a year the plan covers. */
  reviews: Scalars['Int']['output'];
};

/** The buyer's answer for a GreenDesk price. */
export type GreenDeskPriceInput = {
  /** "occasional" | "often" | "regular": a plan chosen over the suggested one. Defaults to the plan that fits reviewsPerYear. */
  planId?: InputMaybe<Scalars['String']['input']>;
  /** Claim reviews expected per year, whole (round a fraction up). Above the top plan the price is on request. */
  reviewsPerYear: Scalars['Int']['input'];
};

export type GroupTag = {
  /** Returns children for given group tag. */
  childGroupTags: Array<GroupTag>;
  color: Scalars['HexColorCode']['output'];
  colorBackground: Scalars['HexColorCode']['output'];
  /** @deprecated Use color. */
  colorPrimary: Scalars['String']['output'];
  /** @deprecated use colorBackground */
  colorSecondary: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** A user who created the group tag. Speeki admin only */
  createdBy?: Maybe<UserType>;
  /** Resolves group tag metadata. */
  esgMetadata?: Maybe<GroupTagEsgMetadata>;
  /** Applies only when used in tags selector, `NULL` otherwise. */
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating public tag. */
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Returns group tag parent for given tag. */
  parentGroupTag?: Maybe<GroupTag>;
  /** A risk area that group tag belongs to */
  riskArea: RiskArea;
  /** Resolves group tag's tags. */
  tags: TagConnection;
  /** Group tag tenant. */
  tenant?: Maybe<TenantBaseDataType>;
  updatedAt: Scalars['DateTime']['output'];
  /** A user who last updated the group tag. Speeki admin only */
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['ID']['output'];
};


export type GroupTagChildGroupTagsArgs = {
  riskAreaUuids?: Array<Scalars['UUID']['input']>;
};


export type GroupTagTagsArgs = {
  input?: InputMaybe<GroupTagTagConnectionInput>;
};

/** Represents pagination connection of group tags. */
export type GroupTagConnection = {
  /** Array of edges. */
  edges: Array<GroupTagEdge>;
  /** Array of direct nodes. */
  nodes: Array<GroupTag>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type GroupTagConnectionInput = {
  /** Group tag name filter. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Array of risk area UUIDs that should scope results. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<GroupTagSortInput>>;
};

/** Input for deleting a group tag */
export type GroupTagDeleteInput = {
  /** Group tag UUIDs to delete. */
  uuidsToDelete: Array<Scalars['UUID']['input']>;
};

/** Represents GroupTag connection edge. */
export type GroupTagEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the GroupTag record. */
  node: GroupTag;
};

export type GroupTagEsgMetadata = {
  /** Placeholder text for tag descriptions. */
  tagDescriptionPlaceholder: Scalars['String']['output'];
  /** Placeholder text for tags. */
  tagPlaceholder: Scalars['String']['output'];
};

export type GroupTagNameSearchInput = {
  /** Input for tag names filter. Only group tags that contain tags with given names will be returned. */
  includeTagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Input for group tag name search by name */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Input for risk areas UUIDS. Will only return results for matching risk areas. */
  riskAreasUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/**
 * Represents pagination of group tags for a dashboard.
 * Each row is a tag with its group tag. Group tags are repeated for each tag.
 * Group tag appear once if do not have tags
 */
export type GroupTagRow = {
  /** Group tag object */
  groupTag: GroupTag;
  id: Scalars['ID']['output'];
  /** Tag object */
  tag?: Maybe<Tag>;
};

/** Represents pagination connection of group tags tags. */
export type GroupTagRowConnection = {
  /** Array of edges. */
  edges: Array<GroupTagRowEdge>;
  /** Array of direct nodes. */
  nodes: Array<GroupTagRow>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of tags. */
export type GroupTagRowConnectionInput = {
  /** Optional array of group tags names to limit search. Provide empty for all group tags. */
  groupTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional input for inclusion of shared Speeki group tags without any tags assigned. Will not include them by default. */
  includeEmptySpeekiGroupTags?: Scalars['Boolean']['input'];
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional array of risk area to limit search. Provide empty for all risk areas. */
  riskAreasUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional input for text search. Will limit search by risk area name, group tag name, tag name and description contents. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<GroupTagRowSortInput>>;
  /** Narrows tags to standard ones only. */
  standardTagsOnly?: Scalars['Boolean']['input'];
  /** Optional array of tag names to limit search. Provide empty for all tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents GroupTagRow connection edge. */
export type GroupTagRowEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the GroupTagRow record. */
  node: GroupTagRow;
};

export type GroupTagRowSortFields =
  | 'GROUP_TAG_NAME'
  | 'IS_SHARED'
  | 'RISK_AREA_NAME'
  | 'TAG_NAME';

export type GroupTagRowSortInput = {
  direction: SortDirection;
  field: GroupTagRowSortFields;
};

export type GroupTagSortFields =
  | 'IS_SHARED'
  | 'NAME';

export type GroupTagSortInput = {
  direction: SortDirection;
  field: GroupTagSortFields;
};

export type GroupTagTagConnectionInput = {
  /** Narrows tags to custom ones only. */
  customTagsOnly?: Scalars['Boolean']['input'];
  /** Tag UUIDs to exclude. */
  excludeUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional input for text search. Will limit search by risk area name, group tag name, tag name and description contents. */
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Array<Tag_Search_Scope>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<Tag_SortSortInput>>;
  /** Optional array of tags names to limit search. Provide empty for all tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupTagUpsertInput = {
  /** Represents group tag UUID. */
  groupTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Represents group tag name. Required to creating group tag, whilst updating it represents new name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Represents risk area in which tag is located. Whilst editing represents risk area to which group tag should be moved */
  riskAreaUuid: Scalars['UUID']['input'];
  /** Represents tags to be upserted. */
  tagUpsertInput?: InputMaybe<Array<TagBatchUpsertInput>>;
};

/** The buyer's scope answers for a Guardian price quote. */
export type GuardianPriceInput = {
  /** "Limited" | "Reasonable". */
  assurance: Scalars['String']['input'];
  /** "Annual" | "Quarterly". */
  billing: Scalars['String']['input'];
  countries: Scalars['Int']['input'];
  /** "Platform-integrated" | "Mixed" | "Document-based". */
  dataAccess: Scalars['String']['input'];
  euTaxonomy: Scalars['Boolean']['input'];
  /** "CSRD/ESRS" | "ISSB S1+S2 / ASRS / UKSRS" | "GRI Standards" | "Voluntary". */
  framework: Scalars['String']['input'];
  headcount: Scalars['Int']['input'];
  /** Default 0 client-side if unanswered. */
  languages: Scalars['Int']['input'];
  /** "None" | "2-year" | "3-year". */
  multiyear: Scalars['String']['input'];
  priorYear: Scalars['Boolean']['input'];
  topics: Scalars['Int']['input'];
  xbrl: Scalars['Boolean']['input'];
};

export type Guideline = {
  /** Guideline category name. */
  categoryName: Scalars['String']['output'];
  /** Label from fixture */
  label?: Maybe<Scalars['String']['output']>;
  /** Guideline markdown. */
  markdown: Scalars['String']['output'];
  /** Guideline name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Guideline order */
  order: Scalars['Int']['output'];
  /** Path to guideline */
  path?: Maybe<Scalars['String']['output']>;
  riskArea: RiskArea;
  subcategories: Array<Guideline>;
  /**
   * Returns the number of subcategories for given guideline category.
   * Will work only for guideline that is considered as category otherwise it will return null
   */
  subcategoriesCount?: Maybe<Scalars['Int']['output']>;
  /** Returns a unit for given guideline. */
  unit?: Maybe<Unit>;
  uuid: Scalars['UUID']['output'];
};

export type GuidelineBatchUpsertInput = {
  /** Represents guidelines to be upserted */
  guidelineUpsertInput: Array<GuidelineUpsertInput>;
};

/** Represents pagination input for connection of guideline. */
export type GuidelineConnection = {
  /** Array of edges. */
  edges: Array<GuidelineEdge>;
  /** Array of direct nodes. */
  nodes: Array<Guideline>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of guideline. */
export type GuidelineConnectionInput = {
  /** Limits results to given category name */
  categoriesNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional search input. Will look for matching category or guideline name that includes provided substring. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<GuidelineSortInput>>;
  /** Limit results to provided standards. */
  standardsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents the input for deleting guidelines. */
export type GuidelineDeleteInput = {
  /** Uuids of guidelines to delete */
  uuidsToDelete: Array<Scalars['UUID']['input']>;
};

/** Represents Guideline connection edge. */
export type GuidelineEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Guideline record. */
  node: Guideline;
};

/** Represents pagination input for connection of guidelines for programme */
export type GuidelineForProgrammePaginationInput = {
  name: Esg_Subcategory;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
};

export type GuidelineInput = {
  uuids: Array<Scalars['UUID']['input']>;
};

export type GuidelineSortFields =
  | 'CATEGORY'
  | 'NAME'
  | 'ORDER'
  | 'STANDARD_NAME';

export type GuidelineSortInput = {
  direction: SortDirection;
  field: GuidelineSortFields;
};

export type GuidelineUpsertInput = {
  /** Name of a guideline category. Max length is 100 characters */
  categoryName: Scalars['String']['input'];
  /** Markdown content of a guideline */
  markdown: Scalars['String']['input'];
  /** Name of a guideline subcategory. Max length is 300 characters */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Uuid of a standard that guideline is related to */
  standardUuid: Scalars['UUID']['input'];
  /** Unit related with guideline */
  unitUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Uuid of guideline to update. Leave empty to create new guideline */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input to filter guidelines categories */
export type GuidelinesCategoriesInput = {
  /** Limits results to given guidelines uuids */
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Input to filter guidelines categories names */
export type GuidelinesCategoriesNamesInput = {
  /** Limits results to given standard */
  standardsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A price held from the wizard's price screen, or its typed expired result. */
export type HeldQuote = {
  /** True when this quote's TTL has passed. */
  expired: Scalars['Boolean']['output'];
  /** When this quote expires. Null when expired. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** How many people the price was held for - the count its audit days were read for. Null when expired. */
  people?: Maybe<Scalars['Int']['output']>;
  /** The presented price frozen at hold time. Null when expired. */
  price?: Maybe<IsoCertificationPrice>;
};

/** Represents input for user hotspot burning. */
export type HotspotBurnInput = {
  /** Represents data which should be persisted in user's API storage. */
  hotspot: Ui_Hotspot_Key;
};

/** Represents input for resetting user hotspots. */
export type HotspotResetInput = {
  /** Specific hotspots to reset. When omitted or empty, every resettable hotspot is reset. */
  hotspots?: InputMaybe<Array<Ui_Hotspot_Key>>;
};

/** Represents the dispatch status of an email sent to an individual involved. */
export type Individual_Involved_Email_Status =
  | 'SENT';

export type Insights_Gap_Analysis_Job_Status =
  | 'COMPLETED'
  | 'FAILED'
  | 'PROCESSING'
  | 'QUEUED';

export type Insights_Gap_Analysis_Step =
  | 'GENERATING_RECOMMENDATIONS'
  | 'IDENTIFYING_GAPS'
  | 'READING_FRAMEWORK'
  | 'REVIEWING_DATA';

export type Insights_Smart_Fill_Completion_Mode =
  | 'CLIENT_APPLY'
  | 'SERVER_INGEST';

/** Smart Fill draft answer review status. */
export type Insights_Smart_Fill_Draft_Status =
  | 'APPROVED'
  | 'DRAFT';

/** Smart Fill background job processing status. */
export type Insights_Smart_Fill_Job_Status =
  | 'APPLIED'
  | 'AWAITING_INPUT'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'FAILED'
  | 'PROCESSING'
  | 'QUEUED';

/** Classification of Smart Fill source content. */
export type Insights_Smart_Fill_Source_Type =
  | 'DOCUMENT_EXCERPT'
  | 'IMAGE'
  | 'OTHER'
  | 'TABLE';

/** Represents enumeration of investigation entities. */
export type Investigation_Entity =
  | 'HEADQUARTERS'
  | 'LOCAL_OFFICE';

/** Represents enumeration of individual involvement type. */
export type Involvement_Type =
  | 'SUBJECT_OF_ALLEGATION'
  | 'VICTIM'
  | 'WITNESS';

/** Input type for iXBRL generation */
export type IXbrlGenerateInput = {
  /** Unique identifier for the taxonomy report used to generate iXBRL file */
  reportUuid: Scalars['UUID']['input'];
};

export type ImportCountsObject = {
  added: Scalars['Int']['output'];
  changed: Scalars['Int']['output'];
  missing: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
};

/** Represents the restriction for certain incident type regarding anonymity. */
export type IncidentAnonymityRestriction = {
  /** Indicates whether related incident type is restricted. */
  isRestricted: Scalars['Boolean']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Incident type of tenant. */
export type IncidentType = {
  description: Scalars['String']['output'];
  /** Translated description of incident type. */
  descriptionTranslated: Scalars['String']['output'];
  /** Represents the name of tenant incident type. */
  name: Scalars['String']['output'];
  /** Translated name of incident type. */
  nameTranslated: Scalars['String']['output'];
  /** Represents unique identifier of tenant incident type. */
  uuid: Scalars['ID']['output'];
};


/** Incident type of tenant. */
export type IncidentTypeDescriptionTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};


/** Incident type of tenant. */
export type IncidentTypeNameTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

/** Represents setting of specific incident type anonymity settings. */
export type IncidentTypeAnonymity = {
  /** Indicates whether anonymous reports are enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name. */
  name: Scalars['String']['output'];
  /** Unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represent the input for anonymity setting change for a specific incident type. */
export type IncidentTypeAnonymitySettingsInput = {
  /** Indicates whether anonymous reports should be disabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** Unique identifier of incident type. */
  uuid: Scalars['ID']['input'];
};

/** Represents IncidentTypeConnection connection. */
export type IncidentTypeConnection = {
  /** Array of edges. */
  edges: Array<IncidentTypeEdge>;
  /** Array of direct nodes. */
  nodes: Array<IncidentType>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of incident types. */
export type IncidentTypeConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<IncidentTypeSortInput>>;
};

/** Represents IncidentType connection edge. */
export type IncidentTypeEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the IncidentType record. */
  node: IncidentType;
};

export type IncidentTypeSortFields =
  | 'NAME'
  | 'ORDER'
  | 'WEIGHT';

export type IncidentTypeSortInput = {
  direction: SortDirection;
  field: IncidentTypeSortFields;
};

/** Represents the individual involved into case. */
export type IndividualInvolved = {
  /** Business unit of individual involved. */
  businessUnit?: Maybe<BusinessUnit>;
  /** Email address of individual involved. */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** Date of last paperplane email, null if not send */
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** First name of individual involved. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name of individual involved. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Position in company of individual involved. */
  position?: Maybe<Scalars['String']['output']>;
  /** Relationship to company of individual involved. */
  relationship?: Maybe<User_Relationship>;
  /** Type of individuals involvement. */
  type?: Maybe<Involvement_Type>;
  /** Unique identifier of individual involved. */
  uuid: Scalars['UUID']['output'];
};

/** Input for deleting individuals involved */
export type IndividualInvolvedDeleteInput = {
  /** case UUID */
  caseUuid: Scalars['UUID']['input'];
  /** UUIDs to delete */
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents an email sent to an individual involved. */
export type IndividualInvolvedEmail = {
  /** Email body as sent. */
  body: Scalars['String']['output'];
  /** Recipient email address at the time of sending. */
  recipientEmail: Scalars['EmailAddress']['output'];
  /** Recipient name at the time of sending. */
  recipientName?: Maybe<Scalars['String']['output']>;
  /** Date the email was sent. */
  sentAt: Scalars['DateTime']['output'];
  /** User who sent the email. */
  sentBy?: Maybe<UserType>;
  /** Dispatch status from Speeki's side; does not confirm delivery or reading. */
  status: Individual_Involved_Email_Status;
  /** Email subject as sent. */
  subject: Scalars['String']['output'];
  /** Unique identifier of the sent email. */
  uuid: Scalars['UUID']['output'];
};

export type IndustryUnitConnection = {
  /** Array of edges. */
  edges: Array<UnitEdge>;
  /** Array of direct nodes. */
  nodes: Array<Unit>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type IndustryUnitConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Search for units by name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<UnitSortInput>>;
  /** Narrows down the results to given source only */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Narrows down the results to given standard only */
  standardUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type InsightsFile = {
  /** File mime type */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** File name */
  name: Scalars['String']['output'];
  /** File size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Resolves user who uploaded the file. */
  uploadedBy?: Maybe<UserType>;
  /** Resolve signed url. Valid for 1 hour. */
  url: Scalars['URL']['output'];
  /** UUID of file */
  uuid: Scalars['UUID']['output'];
};

export type InvestigationCaseDetailsInput = {
  caseId: Scalars['String']['input'];
};

export type InvestigatorData = {
  type: Case_Investigator_Type;
  userUuid: Scalars['UUID']['input'];
};

export type IsLinkedInput = {
  /** The UUID of the metric to check linkage for */
  metricUuid: Scalars['UUID']['input'];
  /** The UUID of the reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type IsoAssessmentDays = {
  baseS1s2: Scalars['Float']['output'];
  baseSurveillance: Scalars['Float']['output'];
  /** 100 when certified alone, less when integrated. */
  integratedFactorPercent: Scalars['Float']['output'];
  /** 0 to 30. */
  md5ReductionPercent: Scalars['Float']['output'];
  /** The Year 1 initial certification audit days, priced. */
  s1s2: Scalars['Float']['output'];
  /** Each of Year 2 and Year 3 surveillance audit days, priced. */
  surveillance: Scalars['Float']['output'];
};

export type IsoCertificationPrice = {
  days: IsoAssessmentDays;
  fees: IsoFeeSchedule;
  reductions: Array<IsoReductionApplied>;
  /** The pricing rules edition this quote was priced under; an order item freezes this value. */
  rulesVersion: Scalars['String']['output'];
  sites: Scalars['Int']['output'];
  sitesAuditedInitial: Scalars['Int']['output'];
  sitesAuditedSurveillance: Scalars['Int']['output'];
  standard: Scalars['String']['output'];
  standardLabel: Scalars['String']['output'];
  standardName: Scalars['String']['output'];
};

/** One ISO management-system certification a buyer prices. */
export type IsoCertificationPriceInput = {
  /** The MD 5 / MD 1 reductions the buyer has declared. */
  reductions: IsoReductionInput;
  /** Every site in the certification scope; the first is the central function. */
  sites: Array<IsoSiteInput>;
  /** One of ISO_STANDARD_IDS, e.g. iso37001. */
  standard: Scalars['String']['input'];
};

export type IsoCertificationRules = {
  certificationIssuanceUsd: Scalars['String']['output'];
  dayRateUsd: Scalars['String']['output'];
  matureSystemReductionPercent: Scalars['Float']['output'];
  maxReductionPercent: Scalars['Float']['output'];
  /** The floor no Stage 1 + Stage 2 figure is ever priced under, whatever reductions or sampling apply. */
  minStage1Stage2Days: Scalars['Float']['output'];
  priorCertificationReductionPercent: Scalars['Float']['output'];
  /** The pricing rules edition these figures are published under. */
  rulesVersion: Scalars['String']['output'];
  standard: Scalars['String']['output'];
  standardLabel: Scalars['String']['output'];
  standardName: Scalars['String']['output'];
  travelPercent: Scalars['Float']['output'];
};

export type IsoFeeSchedule = {
  certificationIssuanceUsd: Scalars['String']['output'];
  dayRateUsd: Scalars['String']['output'];
  /** Each of Year 2 and Year 3. */
  surveillanceUsd: Scalars['String']['output'];
  /** Year 1 + Year 2 + Year 3. */
  threeYearUsd: Scalars['String']['output'];
  /** Year 1: the initial audit + certification + travel. */
  year1Usd: Scalars['String']['output'];
};

export type IsoReductionApplied = {
  detail: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** The MD 5 / MD 1 reductions the buyer has declared. */
export type IsoReductionInput = {
  /** Number of OTHER ISO standards being certified with Speeki at the same time. */
  integratedStandards: Scalars['Int']['input'];
  /** Management system rated 5/5 on the maturity scale, with the evidence dates given. */
  matureSystem: Scalars['Boolean']['input'];
  /** All IAF MD 1 conditions confirmed (central control, similar processes, internal audits at every site). */
  multiSiteEligible: Scalars['Boolean']['input'];
  /** Currently certified to a related standard, and the same team manages this programme. */
  priorCertification: Scalars['Boolean']['input'];
};

/** One site in scope, by its effective employee count. */
export type IsoSiteInput = {
  /** Effective employees at this site, for the MD 5 audit-day table. */
  effectiveEmployees: Scalars['Int']['input'];
};

/** Represents knowledge library search scope. */
export type Knowledge_Library_Search_Scope =
  | 'ANSWER'
  | 'CATEGORY'
  | 'QUESTION';

/** Represents the options for knowledge library sources. */
export type Knowledge_Library_Source =
  | 'ESG_PROGRAMME'
  | 'KNOWLEDGE_LIBRARY'
  | 'METRIC_DATA'
  | 'TASKS_DATA';

export type KnowledgeLibraryAssets = {
  /** URL to example Excel file for answers generate input. */
  answerGenerateExample?: Maybe<Scalars['URL']['output']>;
  /** URL to example Excel file for answers upload. */
  knowledgeLibraryUploadExample?: Maybe<Scalars['URL']['output']>;
};

export type KnowledgeLibraryConnectionStatistics = {
  /** Number of answered questions for given scope. */
  answeredCount: Scalars['Int']['output'];
  /** Array of categories present in results. */
  categories: Array<DataCategory>;
  /** Number of categories present in given scope. */
  categoryCount: Scalars['Int']['output'];
};

/** Represents input for generating answers for knowledge library. */
export type KnowledgeLibraryGenerateAnswersInput = {
  /** Options for answer generation. */
  options: KnowledgeLibraryGenerateAnswersOptionsInput;
  /** Question content for generating answers */
  questions: Array<KnowledgeLibraryGenerateAnswersQuestionsInput>;
};

/** Represents input for answer generation options. */
export type KnowledgeLibraryGenerateAnswersOptionsInput = {
  /** Flag indicating whether the classifier step should be skipped. */
  skipClassifier?: Scalars['Boolean']['input'];
  /** Flag indicating whether the esg programme should be used. */
  useEsgProgramme?: Scalars['Boolean']['input'];
  /** Flag indicating whether the library should be used. */
  useLibrary?: Scalars['Boolean']['input'];
  /** Flag indicating whether metrics should be used. */
  useMetrics?: Scalars['Boolean']['input'];
  /** Flag indicating whether tasks should be used. */
  useTasks?: Scalars['Boolean']['input'];
  /** Optional user prompt, used to make results more focused on user's needs. Input must be at least 10 and up to 500 characters long. */
  userPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** Represents input for questions for answer generation. */
export type KnowledgeLibraryGenerateAnswersQuestionsInput = {
  /** Answer options, optional */
  answerOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Question contents */
  question: Scalars['String']['input'];
  /** Id of row, for frontend positioning. */
  rowId: Scalars['Int']['input'];
};

/** Represents knowledge library answer generation results. */
export type KnowledgeLibraryGeneratedAnswer = {
  /** Generated answer. */
  answer?: Maybe<Scalars['String']['output']>;
  /** Answer options. */
  answerOptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Category matched to the answer. */
  category?: Maybe<Scalars['String']['output']>;
  /** Explanation of confidence score. */
  confidenceReason?: Maybe<Scalars['String']['output']>;
  /** Confidence score, from 0 (low confidence) to 100 (high confidence) */
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  /** Question content. */
  question?: Maybe<Scalars['String']['output']>;
  /** Explanation of answer. */
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Array of risk areas which content was used to generate answer. */
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Row ID, corresponds to source question. */
  rowId: Scalars['Int']['output'];
  /** Array of enums representing sources used to generate answer. */
  sourcesUsed?: Maybe<Array<Knowledge_Library_Source>>;
};

/** Type representing knowledge library entry with answer options */
export type KnowledgeLibraryOptionsQuestion = KnowledgeLibraryQuestion & {
  answer?: Maybe<Scalars['String']['output']>;
  answerOptions: Array<Scalars['String']['output']>;
  category?: Maybe<DataCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<UserType>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<UserType>;
  question?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Interface abstracting common fields for knowledge library entries */
export type KnowledgeLibraryQuestion = {
  answer?: Maybe<Scalars['String']['output']>;
  category?: Maybe<DataCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<UserType>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<UserType>;
  question?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Represents KnowledgeLibraryQuestionConnection connection. */
export type KnowledgeLibraryQuestionConnection = {
  /** Array of edges. */
  edges: Array<KnowledgeLibraryQuestionEdge>;
  /** Array of direct nodes. */
  nodes: Array<KnowledgeLibraryQuestion>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Statistics for current scope. */
  statistics: KnowledgeLibraryConnectionStatistics;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying connection of knowledge library items */
export type KnowledgeLibraryQuestionConnectionInput = {
  /** Optional input for filter by category UUID. */
  categoryUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional input for search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Optional input for search scope. By default will search across all elements */
  searchScope?: InputMaybe<Array<Knowledge_Library_Search_Scope>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<KnowledgeLibraryQuestionConnectionSortInput>>;
};

export type KnowledgeLibraryQuestionConnectionSortFields =
  | 'ANSWER'
  | 'CATEGORY'
  | 'CREATED_AT'
  | 'LAST_UPDATED_AT'
  | 'QUESTION';

export type KnowledgeLibraryQuestionConnectionSortInput = {
  direction: SortDirection;
  field: KnowledgeLibraryQuestionConnectionSortFields;
};

/** Represents input for deleting multiple knowledge library items. */
export type KnowledgeLibraryQuestionDeleteInput = {
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents KnowledgeLibraryQuestion connection edge. */
export type KnowledgeLibraryQuestionEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the KnowledgeLibraryQuestion record. */
  node: KnowledgeLibraryQuestion;
};

/** Represents input for setting category of knowledge library element. */
export type KnowledgeLibraryQuestionSetCategoryInput = {
  /** Input for connection question with category by name. If category does not exist it will be created. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Input for disconnecting the question from category. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Input for connecting question with category by uuid. Category must exist. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for upsert of knowledge library element. */
export type KnowledgeLibraryQuestionUpsertInput = {
  /** Knowledge library element answer */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Category upsert input. If empty and editing entry will disconnect category from entry. */
  category?: InputMaybe<KnowledgeLibraryQuestionSetCategoryInput>;
  /** Array of options to be provided to question. Send an empty array to clear options!!! */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Knowledge library question content */
  question?: InputMaybe<Scalars['String']['input']>;
  /** "Optional UUID if element update should be executed. If empty will create new record" */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Type representing knowledge library entry without answer options. */
export type KnowledgeLibraryScalarQuestion = KnowledgeLibraryQuestion & {
  answer?: Maybe<Scalars['String']['output']>;
  category?: Maybe<DataCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<UserType>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<UserType>;
  question?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

/** Represents input for upsert of multiple knowledge library elements. */
export type KnowledgeLibraryUpsertInput = {
  /** Array of knowledge item upsert inputs. UUIDs must be unique if provided. */
  data: Array<KnowledgeLibraryQuestionUpsertInput>;
};

/** Represents enumeration of language codes. */
export type Language_Code =
  | 'AF'
  | 'AM'
  | 'AR'
  | 'AZ'
  | 'BE'
  | 'BG'
  | 'BN'
  | 'BS'
  | 'CA'
  | 'CEB'
  | 'CO'
  | 'CS'
  | 'CY'
  | 'DA'
  | 'DE'
  | 'EL'
  | 'EN'
  | 'EO'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FA'
  | 'FI'
  | 'FR'
  | 'FY'
  | 'GA'
  | 'GD'
  | 'GL'
  | 'GU'
  | 'HA'
  | 'HAw'
  | 'HI'
  | 'HMn'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'HY'
  | 'ID'
  | 'IG'
  | 'IS'
  | 'IT'
  | 'IW'
  | 'JA'
  | 'JW'
  | 'KA'
  | 'KK'
  | 'KM'
  | 'KN'
  | 'KO'
  | 'KU'
  | 'KY'
  | 'LA'
  | 'LB'
  | 'LO'
  | 'LT'
  | 'LV'
  | 'MG'
  | 'MI'
  | 'MK'
  | 'ML'
  | 'MN'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MY'
  | 'NE'
  | 'NL'
  | 'NO'
  | 'NY'
  | 'PA'
  | 'PL'
  | 'PS'
  | 'PT'
  | 'RO'
  | 'RU'
  | 'SD'
  | 'SI'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SQ'
  | 'SR'
  | 'ST'
  | 'SU'
  | 'SV'
  | 'SW'
  | 'TA'
  | 'TE'
  | 'TG'
  | 'TH'
  | 'TL'
  | 'TR'
  | 'UK'
  | 'UR'
  | 'UZ'
  | 'VI'
  | 'XH'
  | 'YI'
  | 'YO'
  | 'ZH_CN'
  | 'ZH_TW'
  | 'ZU';

/** Represents enumeration of legacy action slot types. */
export type Legacy_Slot_Type =
  | 'BUBBLE'
  | 'CALENDAR'
  | 'MAP'
  | 'NONE'
  | 'TEXT';

export type LanguageCode =
  | 'AF'
  | 'AM'
  | 'AR'
  | 'AZ'
  | 'BE'
  | 'BG'
  | 'BN'
  | 'BS'
  | 'CA'
  | 'CEB'
  | 'CO'
  | 'CS'
  | 'CY'
  | 'DA'
  | 'DE'
  | 'EL'
  | 'EN'
  | 'EO'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FA'
  | 'FI'
  | 'FR'
  | 'FY'
  | 'GA'
  | 'GD'
  | 'GL'
  | 'GU'
  | 'HA'
  | 'HAw'
  | 'HI'
  | 'HMn'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'HY'
  | 'ID'
  | 'IG'
  | 'IS'
  | 'IT'
  | 'IW'
  | 'JA'
  | 'JW'
  | 'KA'
  | 'KK'
  | 'KM'
  | 'KN'
  | 'KO'
  | 'KU'
  | 'KY'
  | 'LA'
  | 'LB'
  | 'LO'
  | 'LT'
  | 'LV'
  | 'MG'
  | 'MI'
  | 'MK'
  | 'ML'
  | 'MN'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MY'
  | 'NE'
  | 'NL'
  | 'NO'
  | 'NY'
  | 'PA'
  | 'PL'
  | 'PS'
  | 'PT'
  | 'RO'
  | 'RU'
  | 'SD'
  | 'SI'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SQ'
  | 'SR'
  | 'ST'
  | 'SU'
  | 'SV'
  | 'SW'
  | 'TA'
  | 'TE'
  | 'TG'
  | 'TH'
  | 'TL'
  | 'TR'
  | 'UK'
  | 'UR'
  | 'UZ'
  | 'VI'
  | 'XH'
  | 'YI'
  | 'YO'
  | 'ZH_CN'
  | 'ZH_TW'
  | 'ZU';

export type License = {
  /** Total number of tenant's limited licenses. */
  totalLimitedLicenses: Scalars['Int']['output'];
  /** Total number of tenant's standard licenses. */
  totalStandardLicenses: Scalars['Int']['output'];
  /** Number of corrected used limited licenses. Will never be bigger than totalLimitedLicenses value, as any limited license over it will consume standard license. */
  usedLimitedLicenses: Scalars['Int']['output'];
  /** Raw number of used limited licenses. Not limited by totalLimitedLicenses overflow to standard licenses. May be bigger than totalLimitedLicenses. */
  usedLimitedLicensesRaw: Scalars['Int']['output'];
  /** Number of corrected used standard licenses. If there are more limited users than limited licenses limited users over limit will use standard licenses. */
  usedStandardLicenses: Scalars['Int']['output'];
  /** Raw number of used standard licenses. Does not include correction for limited users over total limited license. */
  usedStandardLicensesRaw: Scalars['Int']['output'];
};

export type LinkAnswersToMetricInput = {
  /** Array of question links with their optional answer UUIDs */
  links: Array<QuestionLinkInput>;
  /** The UUID of the metric to link the answers to */
  metricUuid: Scalars['UUID']['input'];
  /** The UUID of the year to link the answers to */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of linking answers to a metric */
export type LinkAnswersToMetricResult = {
  /** UUID of the metric the answers were linked to */
  metricUuid: Scalars['UUID']['output'];
};

/** Represents input to link metrics to answer by identifiers input. */
export type LinkMetricsToAnswerByUuidInput = {
  /** UUID of answer to be linked to metrics. */
  answerUuid: Scalars['UUID']['input'];
  /** The UUIDs of the metrics to link to the answer. */
  metricUuids: Array<Scalars['UUID']['input']>;
};

/** Represents input to link metrics to answer by version data. */
export type LinkMetricsToAnswerByVersionDataInput = {
  /** The UUIDs of the metrics to link to the answer. */
  metricUuids: Array<Scalars['UUID']['input']>;
  /** The UUID of the question to link the metrics to */
  questionUuid: Scalars['UUID']['input'];
  /** The UUID of the version tag to link the metrics to. If omitted current will link to default answer. */
  versionTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUID of the year to link the metrics to. If omitted current active year will be used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input to link metrics to answer. Note: current implementation of GQL does not allow the use of @oneOf directive - once it's supported it will be added to this input. */
export type LinkMetricsToAnswerGenericInput = {
  /** Input for assigning metric to answer by identifiers. */
  byIdentifiers?: InputMaybe<LinkMetricsToAnswerByUuidInput>;
  /** Input for assigining metric to answer by version information. */
  byVersionData?: InputMaybe<LinkMetricsToAnswerByVersionDataInput>;
};

export type LinkMetricsToAnswerInput = {
  /** The UUID of the answer to link the metrics to. If not provided and no answer exists for the year, an empty answer will be created. */
  answerUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUIDs of the metrics to link to the answer */
  metricUuids: Array<Scalars['UUID']['input']>;
  /** The UUID of the question to link the metrics to */
  questionUuid: Scalars['UUID']['input'];
  /** The UUID of the year to link the metrics to */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of linking metrics to an answer */
export type LinkMetricsToAnswerResult = {
  /** UUID of the answer the metrics were linked to */
  answerUuid: Scalars['UUID']['output'];
  /** UUID of the question the answer belongs to */
  questionUuid: Scalars['UUID']['output'];
};

export type LogHelpZeroResultSearchInput = {
  /** The search term that returned zero results */
  term: Scalars['String']['input'];
};

export type LoginExternalInput = {
  token: Scalars['JWT']['input'];
};

export type LoginGuestInput = {
  /** Guest country */
  country: Country_Code;
  /** Guest language */
  language?: InputMaybe<Language_Code>;
  /** Guest relationship to company */
  relationship: Auth_User_Relationship;
  tenantUuid: Scalars['String']['input'];
};

/** Input to login user using a password */
export type LoginPasswordInput = {
  /** User email for authentication */
  email: Scalars['EmailAddress']['input'];
  /** User device fingerprint that allows to skip MFA. User must authenticate with MFA earlier and provide fingerprint */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Password for authentication */
  password: Scalars['String']['input'];
  /** The uuid of the tenant the user will be logged in to */
  tenantUuid: Scalars['String']['input'];
  /** Account type */
  type: Auth_User_Type;
};

/** input type containing code and device fingerprint */
export type LoginWithMfaInput = {
  code: Scalars['String']['input'];
  fingerprint?: InputMaybe<Scalars['String']['input']>;
};

/** Represents file extension type for metric export (ie. CSV, XLSX) */
export type Metric_Export_File_Extension =
  | 'CSV'
  | 'XLSX';

/** Represents metric data source type (ie. SPEEKI, FORWARD-EARTH) */
export type Metric_Source =
  | 'FORWARD_EARTH'
  | 'SPEEKI';

/** Type of MFA method */
export type Mfa_Method_Type =
  | 'OTP';

export type Month =
  | 'APRIL'
  | 'AUGUST'
  | 'DECEMBER'
  | 'FEBRUARY'
  | 'JANUARY'
  | 'JULY'
  | 'JUNE'
  | 'MARCH'
  | 'MAY'
  | 'NOVEMBER'
  | 'OCTOBER'
  | 'SEPTEMBER';

/** The master subscription term in plain terms, for the summary shown above the schedule: its length, exact expiry, and how much remains. */
export type MasterTermSummary = {
  /** The exact date the master term expires, UTC. */
  expiry: Scalars['DateTime']['output'];
  /** Display names of the plans the company already holds on this master term (framework short name plus plan tier, e.g. "SPK CSMS1000 Basic"), oldest first. Empty for a first purchase. */
  heldPlanNames: Array<Scalars['String']['output']>;
  /** True when THIS purchase establishes the master term (the buyer's first shop purchase): the term chosen now becomes the master term and everything later aligns to it. False for a follower joining an existing term. */
  isFirstPurchase: Scalars['Boolean']['output'];
  /** How much of the master term remains, in plain words, e.g. "1 year, 4 months left". */
  plainRemaining: Scalars['String']['output'];
  /** The master term length in years. Null only for a follower whose master term length is not known (its master was not bought through the shop). */
  termYears?: Maybe<Scalars['Int']['output']>;
};

export type Metadata = {
  requireSetup: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type MethodType = {
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  qrCode: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  type: Mfa_Method_Type;
  userUuid: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Metric = {
  /** Resolves years available for given metric based on metrics data */
  availableYears?: Maybe<Array<Scalars['Int']['output']>>;
  /** Resolves owner of the metric */
  createdBy?: Maybe<UserType>;
  /** description of the metric */
  description: Scalars['String']['output'];
  /** Resolves if metric is favourited by the user */
  isFavourite: Scalars['Boolean']['output'];
  /** Returns true if the metric is linked to given answer version. */
  isLinked: Scalars['Boolean']['output'];
  /** Resolves owner of the metric */
  lastUpdatedBy?: Maybe<UserType>;
  /** Returns questions linked to this metric with their answer versions */
  linkedQuestions: Array<MetricLinkedQuestion>;
  /** source of the metric and it's data ie. SPEEKI, FORWARD-EARTH */
  metricSource: Metric_Source;
  /** Resolves stored metrics data */
  metricsData: Array<MetricData>;
  /** name of the metric */
  name: Scalars['String']['output'];
  /** Resolves owner of the metric */
  owner?: Maybe<UserType>;
  /**
   * Resolves risk area of the metric, deprecated: use RiskAreas
   * @deprecated use RiskAreas
   */
  riskArea?: Maybe<RiskArea>;
  /** Resolves risk area of the metric */
  riskAreas: Array<RiskArea>;
  /** UUID of the metric */
  uuid: Scalars['UUID']['output'];
};


export type MetricIsLinkedArgs = {
  input: MetricIsLinkedInput;
};


export type MetricLinkedQuestionsArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for getting Metric by id. */
export type MetricByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents MetricConnection connection. */
export type MetricConnection = {
  /** Array of edges. */
  edges: Array<MetricEdge>;
  /** Array of direct nodes. */
  nodes: Array<Metric>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of Metrics. */
export type MetricConnectionInput = {
  /** Filter metrics by risk area uuid, owner uuid */
  filter?: InputMaybe<MetricFilterInput>;
  /** filter metrics by isFavourite, when true it returns marked as favorite, when false returns those that are not favorite */
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Search across metric name, description, owner name, and risk area names
   * @deprecated Migrate to use search
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Search across metric name, description, owner name, and risk area names */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<MetricSortInput>>;
  /** Filter metrics by year of metric data */
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MetricData = {
  /** Resolves user which created metric */
  createdBy?: Maybe<UserType>;
  /** json representation for content of the metric data */
  data: Scalars['JSON']['output'];
  /** json representation for metric settings */
  settings: Scalars['JSON']['output'];
  /** Resolves user that was the last one to update metric data */
  updatedBy?: Maybe<UserType>;
  /** UUID of the metric data */
  uuid: Scalars['UUID']['output'];
  /** year of the metric data */
  year: Scalars['Int']['output'];
};

/** Represents input for getting MetricData by metric uuid and year. */
export type MetricDataByMetricUuidAndYearInput = {
  metricUuid: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
};

/** Represents input for getting MetricData by uuid. */
export type MetricDataByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

/** Model for metric data column fields */
export type MetricDataColumnSelector = {
  /** name of metric data column */
  columnName?: Maybe<Scalars['String']['output']>;
  /** just random id for frontend caching */
  id: Scalars['ID']['output'];
};

/** Represents pagination input for connection of metric column names */
export type MetricDataColumnSelectorInput = {
  /** UUID of the metric */
  metricUuid: Scalars['UUID']['input'];
  /** name of the metric column field */
  search?: InputMaybe<Scalars['String']['input']>;
  /** year of the metric data */
  year: Scalars['Int']['input'];
};

/** Model for metric data select fields */
export type MetricDataSelector = {
  /** just random id for frontend caching */
  id: Scalars['ID']['output'];
  /** name of the metric data row (global) */
  rowName: Scalars['String']['output'];
  /** name of metric data sub row (global from subRow) */
  subRowName?: Maybe<Scalars['String']['output']>;
};

/** Represents pagination input for connection of metric data row & subrow names */
export type MetricDataSelectorInput = {
  /** UUID of the metric */
  metricUuid: Scalars['UUID']['input'];
  /** name of the metric field */
  search?: InputMaybe<Scalars['String']['input']>;
  /** year of the metric data */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type MetricDataYear = {
  /** Identifier of the year */
  id: Scalars['ID']['output'];
  /** Year value */
  year: Scalars['Int']['output'];
};

/** Represents input type for fetching list of years that have defined metric data. */
export type MetricDataYearsInput = {
  /** Optional input to filter the year by maximum value. */
  max?: InputMaybe<Scalars['Int']['input']>;
  /** Optional input to filter the year by minimum value. */
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents Metric connection edge. */
export type MetricEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Metric record. */
  node: Metric;
};

/** Represents input for toggling metric as favourite */
export type MetricFavouriteToggleInput = {
  /** Uuid of the metric */
  uuid: Scalars['UUID']['input'];
};

/** Represents input for filtering metrics */
export type MetricFilterInput = {
  /** Filter metrics by owner uuids */
  ownerUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter metrics by risk area uuids */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type MetricIsLinkedInput = {
  /** UUID of question. */
  questionUuid: Scalars['UUID']['input'];
  /** UUID of year. If not provided default version will be used. */
  versionTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of year. If not provided active year will be used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents a question with its linked answer versions for a metric */
export type MetricLinkedQuestion = {
  /** Answer versions linked to this metric */
  linkedAnswers: Array<EsgAnswer>;
  /** The linked question */
  question: EsgQuestion;
};

export type MetricSortFields =
  | 'CREATED_AT'
  | 'DESCRIPTION'
  | 'NAME'
  | 'OWNER'
  | 'RISK_AREAS';

export type MetricSortInput = {
  direction: SortDirection;
  field: MetricSortFields;
};

export type Mfa = {
  /** Determine if mfa require setup */
  requireSetup: Scalars['Boolean']['output'];
  /** Type of mfa method that should be performed */
  type: Mfa_Method_Type;
  /** Uuid of the user who performs mfa */
  uuid: Scalars['UUID']['output'];
};

/** A provisioning-history emit that failed after its underlying entitlement write already committed (the tenantSubscriptionUpdate non-blocking path). Durably recorded so it is queryable and a staff member can re-add the missing provisioning-history record. Staff-only (SPEEKI_ADMIN) surface. */
export type MissedProvisioningEmit = {
  /** Identifier of the actor. */
  actorId: Scalars['String']['output'];
  /** Who/what authored the delta. */
  actorType: Provisioning_Actor_Type;
  /** N-tenant fan-out set affected, when scope = GLOBAL/TEMPLATE. */
  affectedTenantUuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Request/trace id shared by every delta emitted by the same request. */
  correlationId: Scalars['String']['output'];
  /** Event category of the delta that failed to emit. */
  eventType: Provisioning_Event_Type;
  /** Identifier of the item acted on. */
  itemId?: Maybe<Scalars['String']['output']>;
  /** Kind of entitlement item the delta acted on. */
  itemType: Provisioning_Item_Type;
  /** The error message from the failed emit attempt, for staff triage. */
  missReason: Scalars['String']['output'];
  /** When the miss was first durably recorded. */
  missedAt: Scalars['DateTime']['output'];
  /** Serialized state or payload after the change. */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Business timestamp when the original delta occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** Serialized state or payload before the change. */
  oldValue?: Maybe<Scalars['String']['output']>;
  /** Back-reference to the triggering delta's eventId, when this was a cascaded child event. */
  parentEventId?: Maybe<Scalars['String']['output']>;
  /** When a staff member successfully re-added the missing provisioning-history record. Null while the miss is outstanding. */
  reAddedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The eventId minted by the successful re-add emit, for cross-referencing the resulting provisioning-history row. */
  reAddedEventId?: Maybe<Scalars['String']['output']>;
  /** Human or synthetic reason for the delta, if any. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the delta affects one tenant or a fan-out set. */
  scope: Provisioning_Scope;
  /** Tenant affected, when scope = TENANT. */
  tenantUuid?: Maybe<Scalars['UUID']['output']>;
  /** UUID for this missed-emit record. */
  uuid: Scalars['ID']['output'];
};

export type MobileApiTokenInput = {
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['input'];
};

export type ModuleSetting = {
  enabled: Scalars['Boolean']['output'];
  /** Array of module features. */
  features: Array<FeatureSetting>;
  name: ServiceModules;
  plan: SubscriptionPlan;
  /** UUID of plan */
  planUuid: Scalars['UUID']['output'];
  /** UUID of module */
  uuid: Scalars['ID']['output'];
};

export type ModuleSettings = {
  carbonLens: ModuleSetting;
  cases: ModuleSetting;
  demo: ModuleSetting;
  disclosures: ModuleSetting;
  dueDiligence: ModuleSetting;
  esg: ModuleSetting;
  frameworks: ModuleSetting;
  insights: ModuleSetting;
  nicoleGpt: ModuleSetting;
  sso: ModuleSetting;
  subsidiarySites: ModuleSetting;
  surveys: ModuleSetting;
  tasks: ModuleSetting;
  teams: ModuleSetting;
  trainings: ModuleSetting;
};

export type Mutation = {
  /** Deletes admin user given by input. Returns UUIDs of deleted user. */
  adminUserDelete: Scalars['String']['output'];
  /** Mutation used for add/update adminUser. */
  adminUserUpsert: AdminUserData;
  amsInviteAuditor: AmsAuditor;
  amsReactivateAuditor: AmsAuditor;
  amsSuspendAuditor: AmsAuditor;
  amsUpdateAuditor: AmsAuditor;
  /** Approves a pending seat request: grants the seat through the existing capacity-checked assignment path, then marks the request approved. If the pool has no room, the grant throws and the request stays pending for a retry. */
  approveFrameworkSeatRequest: SeatRequestType;
  /** Approve a pending approval request. Sends the underlying order's EXISTING nominated signer (never the approver) for e-signature - approval is authority to spend, not authority to sign. Requires the company-settings permission. Gated by the shop-surface flag. */
  approveOrderApprovalRequest: ShopApprovalRequest;
  /** Seats a tenant admin into a framework, bounded by that framework's seat capacity. */
  assignUserFrameworkSeat: UserType;
  /** ONE-OFF MIGRATION TOOLING: backfills the missing per-framework Smart Fill grant record for every legacy tenant whose Nicole-tier purchase predates the per-framework grant model, so the (currently off) per-framework tier gate can be switched on safely. To be removed once every environment has been backfilled. SPEEKI_ADMIN only. Gated by the shop-surface flag. */
  backfillFrameworkSmartFillEntitlements: BackfillFrameworkSmartFillEntitlementsResult;
  /** Mutation for batch update of banned email status. */
  bannedEmailBatchStatusChange: Array<BannedEmail>;
  /**
   * Mutation used for deletion of banned emails
   * @deprecated use bannedEmailDelete
   */
  bannedEmailDelete: Scalars['Int']['output'];
  /** Mutation for update of banned email status. */
  bannedEmailStatusChange: BannedEmail;
  /** Mutation used for creating new or updating existing banned emails. */
  bannedEmailUpsert: BannedEmail;
  /** Clear biometrics for the current user */
  biometricsClear: Scalars['Boolean']['output'];
  /** Setup biometrics for the current user */
  biometricsSetup: Scalars['Boolean']['output'];
  /** Creates new case in database and returns a nest case object. */
  callsCaseCreate: CallsCase;
  /** Updates case in database and returns an updated object */
  callsCaseUpdate: CallsCase;
  /** Withdraw the signed-in person's own pending request to join a company. Gated by the join-by-domain flag. */
  cancelMyAccessRequest: PortalAccessRequest;
  /** Withdraw one of the caller's own pending approval requests (or, for a company-settings holder, anyone else's in the tenant). Open to any tenant staff caller (tenant admin or employee) - withdrawing your own ask is not spending. Gated by the shop-surface flag. */
  cancelMyApprovalRequest: ShopApprovalRequest;
  /** Cancel one of the caller tenant's unfinished (DRAFT / AWAITING_SIGNATURE) orders. No reason required. Gated by the shop-surface flag. */
  cancelMyUnsignedOrder: Order;
  /** Cancel a signed order for a tenant, unwinding the grant/contract/invoice. Gated by the shop-surface flag. */
  cancelOrder: Order;
  /** Cancels the caller tenant's live downgrade election. Requires the company-settings permission - a caller without it is refused (see PlanChangeSpendAuthorityRequiredError) and must ask whoever manages the organisation's billing. Refuses when there is none (already cancelled, already applied, or never elected). Gated by the shop-surface flag. */
  cancelPlanDowngrade: PlanUpgradeContext;
  /** Returns a redirect URL after finalizing CarbonLens SSO */
  carbonLensFinalizeSSO: Scalars['String']['output'];
  /** Returns a redirect URL to CarbonLens SSO initiation */
  carbonLensInitializeSSO: Scalars['String']['output'];
  caseActivityCreate: CaseActivity;
  /** Mutation allows batch upsert of case activity settings. */
  caseActivitySettingsBatchUpsert: Array<CaseActivitySettings>;
  /** Mutation allows to upsert case activity settings. */
  caseActivitySettingsUpsert: CaseActivitySettings;
  /** Mutation used to generate an upload of analytics reports. Returns url to pdf file */
  caseAnalyticsReportPdf: Scalars['URL']['output'];
  /** Deletes case anonymity settings for given countries. */
  caseAnonymitySettingsDelete: Array<Country_Code>;
  /** Mutations allows to delete case assignment. */
  caseAssignmentDelete: Array<Scalars['String']['output']>;
  /** Mutations allows to upsert case assignment. */
  caseAssignmentUpsert: CaseAssignment;
  caseAttachmentUpload: Array<CaseFile>;
  caseBusinessUnitAssign: Case;
  caseClose: Case;
  caseConversationUpdate: Array<ConversationMessage>;
  /** Mutation allows to delete custom reminders. */
  caseCustomReminderDelete: Array<Scalars['UUID']['output']>;
  /** Mutation allows to upsert custom reminder. */
  caseCustomReminderUpsert: CaseCustomReminder;
  caseCustomTitleUpdate: Case;
  /** Complete the following details as it pertains to the report. (Case Details were formerly known as Case Allegation Details) */
  caseDetailsUpdate: Case;
  caseIncidentTypeAssign: Case;
  /** Mutations to send user changed individual involved message. */
  caseIndividualInvolvedMessageSend: Case;
  caseIndividualInvolvedUpsert: Case;
  caseIndividualsInvolvedDelete: Case;
  /** Generates and uploads a summary of the reported case in pdf format. */
  caseInvestigationPdfReportGenerate: CaseInvestigationPdfReportGenerateResponse;
  /** Generates a report from the filtered list of case investigation in the xlsx format and returns its url. */
  caseInvestigationsXlsxReportGenerate: ReportResponse;
  caseInvestigatorsUpdate: Case;
  caseOwnerExclusionUpsert: CaseOwnerExclusion;
  caseOwnerExclusionsDelete: Array<Scalars['UUID']['output']>;
  caseReopen: Case;
  caseReportCreate: Case;
  /** Updates and returns case settings. */
  caseSettingsUpdate: CaseSettings;
  caseTriageScoreUpdate: Case;
  /** Updates provided subsidiary sites information for provided cases. */
  casesSubsidiarySiteUpdate: Scalars['Int']['output'];
  changeDisclosureStatus: Disclosure;
  /** Correct who signs one of the caller tenant's AWAITING_SIGNATURE orders: re-addresses the EXISTING DocuSign envelope to the new signer and delivers it to them, keeping the same agreement, document and audit trail. Subject to the same cross-order send budget as sendOrderForSignature, but NOT to the per-order resend cooldown/cap - see ResendCooldownActiveError / ResendCapReachedError, which govern "Send it again" only. A name-only correction (same address, a corrected name) is a valid change and is delivered like any other. Refuses only when NEITHER the address nor the name actually changes (SIGNER_UNCHANGED). Does not change the invoice recipient. Gated by the shop-surface flag. */
  changeOrderSigner: Order;
  /** Allows to change password */
  changePassword: UserType;
  /** Allows to change the survey reminder frequency. */
  changeSurveyReminder: Survey;
  /** Allows to change the survey status from ongoing to completed. */
  changeSurveyStatus: Survey;
  /** Mutation for uploading files */
  chatRoomFilesUpload: Array<ChatsFile>;
  /** Create a new chat */
  chatbotCreate: Chatbot;
  /** Create a new message in a chat */
  chatbotMessageCreate: ChatbotMessage;
  /** Verify password reset token. */
  checkPasswordResetToken: Scalars['Boolean']['output'];
  /** Staff-assisted compose of an activation order for a tenant. Gated by the shop-surface flag. */
  composeOrder: Order;
  /** Mutation allows batch upsert of conclusion types. */
  conclusionTypeBatchUpsert: Array<ConclusionType>;
  /** Mutation allows to upsert conclusion type. */
  conclusionTypeUpsert: ConclusionType;
  /** Confirms the checkout buyer controls the address, using the code emailed to it. Public: unauthenticated. Gated by the shop-surface flag. */
  confirmCheckoutEmailVerification: ConfirmCheckoutEmailVerification;
  /** Mutation for confirming mfa setup */
  confirmMfaSetup: Scalars['Boolean']['output'];
  /** Confirms the reporter controls the address, using the code emailed to it. */
  confirmReporterEmailVerification: ConfirmReporterEmailVerification;
  /** Correct the caller tenant's own billing identity (entity name, address, invoice recipient) across every one of its purchased orders, and return them. Requires the company-settings permission. The tenant is taken from the caller's token - there is no tenant argument - and the correction is tenant-wide rather than per-order, because every purchased order raises its future invoices from its own copy of these values. Applies to future invoices only: already-issued invoices and signed agreements are never altered. Gated by the shop-surface flag. */
  correctMyBillingIdentity: Array<Order>;
  /** Correct a tenant's billing identity (entity name, address, invoice recipient) on an already-placed, purchased-status order. Applies to future invoices only - already-issued invoices and signed agreements are never altered. Gated by the shop-surface flag. */
  correctOrderBillingIdentity: Order;
  /** Creates a new assistant slot. */
  createAssistantSlot: AssistantSlot;
  /** Create a self-serve checkout order for an assurance service (Guardian, Carbon Lens, GreenDesk, RatingsReady, Partner Integrity or Beacon), priced from the buyer's scope answers. Requires the company-settings permission. Idempotent per (tenant, idempotencyKey). Gated by the shop-surface flag AND the assurance-order flag. Send the returned order's uuid to sendOrderForSignature next. */
  createAssuranceOrder: Order;
  /** Create a self-serve checkout order for an SPK audit engagement, priced from the buyer's scope answers. Requires the company-settings permission. Idempotent per (tenant, idempotencyKey). Gated by the shop-surface flag AND the audit-order flag. Send the returned order's uuid to sendOrderForSignature next. */
  createAuditOrder: Order;
  /** Creates new business unit. */
  createBusinessUnit: Array<BusinessUnit>;
  /** Create a self-serve checkout order for the caller's tenant. Requires the company-settings permission for a PAID plan - a caller without it must raise a plan-approval request instead (see OrderSpendApprovalRequiredError / ShopApprovalRequestService.requestPlanApproval); the free Basic plan needs no such authority, since nothing is invoiced. Idempotent per (tenant, idempotencyKey). Gated by the shop-surface flag. Send the returned order's uuid to sendOrderForSignature next. */
  createCheckoutOrder: Order;
  /** Starts a new checkout session for a product/plan and returns its bearer token (shown once) plus the session's public view. Public: unauthenticated. Gated by the shop-surface flag. */
  createCheckoutSession: CreateCheckoutSessionPayload;
  /** Create a self-serve checkout order for one executive-education course, priced server-side from the course list (flat fee by length; travel and taxes additional). Requires the company-settings permission. Idempotent per (tenant, idempotencyKey). Gated by the shop-surface flag AND the course-order flag. Send the returned order's uuid to sendOrderForSignature next. */
  createCourseOrder: Order;
  /** Mutation used for creating employee. */
  createEmployeeAccount: SessionWithOaExchange;
  /** Create the DRAFT plan-upgrade order for the caller's tenant: upgrades exactly the selected standards to the target tier, each priced separately and prorated co-terminously, and the total is the accepted uplift sum. Requires the company-settings permission - a caller without it is refused (see PlanChangeSpendAuthorityRequiredError) and must ask whoever manages the organisation's billing, because drafting an upgrade also cancels any live downgrade election and freezes the signer and invoice recipient onto the Order Form. The signer, invoice recipient and billing identity are inherited from the tenant's recorded billing identity (myBillingIdentity) unless the input overrides them. Send it for signature next; it activates on signing. Gated by the shop-surface flag. */
  createPlanUpgradeOrder: Order;
  /** Mint a single-use, sixty-second code that the other origin (my.speeki.com or app.speeki.com) redeems for this same session — only together with the binding secret this browser keeps in its speeki_handoff cookie. */
  createSessionHandoffCode: SessionHandoffCode;
  /** Mutation for editing custom plans. Will set the edited custom plan as active for given tenant. */
  customPlanUpdate: AdminTenantData;
  /** Mutation for creating data category. On duplicate name will return existing category. */
  dataCategoryCreate: DataCategory;
  /** Mutation for creating data categories. On duplicate name will return existing category. */
  dataCategoryCreateMany: Array<DataCategory>;
  /** Declines a pending seat request. No seat is touched. */
  declineFrameworkSeatRequest: SeatRequestType;
  /** Decline a pending approval request, with an optional reason the requester will see - a decline always reads as DECLINED to its requester, never disguised. Requires the company-settings permission. Gated by the shop-surface flag. */
  declineShopApprovalRequest: ShopApprovalRequest;
  /** Deletes existing assistant slot. */
  deleteAssistantSlot: AssistantSlotIdentifiers;
  /**
   * Mutation used for deletion of banned emails
   * @deprecated use bannedEmailDelete
   */
  deleteBannedEmail: Scalars['Int']['output'];
  /**
   * Mutation used for deleting disclosure drafts. You can only delete a form if form's author is present in context or disclosure has been orphaned.
   * @deprecated Use new disclosureDelete instead. It handle all disclosure types including drafts.
   */
  deleteDisclosureDraft: Array<Scalars['ID']['output']>;
  /** Mutation for removing individual email entry. */
  deleteEmailEntry: Array<Scalars['ID']['output']>;
  /**
   * Mutation for deleting email list.
   * @deprecated Use emailListDelete.
   */
  deleteEmailList: Array<Scalars['ID']['output']>;
  deleteEmailTarget: Array<Scalars['ID']['output']>;
  /** Mutation used for deleting user account. Accessible by employee type users. */
  deleteEmployeeAccount: UserType;
  /** Mutation used for updating deleting forward earth credentials. */
  deleteForwardEarthCredentials: Scalars['String']['output'];
  /** Removes tenant logo. */
  deleteTenantLogo: Scalars['Boolean']['output'];
  /** Mutation responsible for unsubscribing user's devices from appropriate Firebase topics based on his account details. Requires user to be signed in.Client should call 'firebaseMessaging.deleteToken()' or equivalent method to invalidate FCM token for fail-safe cancellation of push notifications. */
  disablePushNotificationsForDevice: Array<FirebaseResponse>;
  /** Mutation used for deleting disclosure. You can only delete a form if form's author is present in context or disclosure has been orphaned. */
  disclosureDelete: Array<Scalars['ID']['output']>;
  disclosureResponseApprove: DisclosureResponse;
  disclosureResponseCommentUpsert: DisclosureResponseComment;
  disclosureRiskAreasUpsert: Disclosure;
  disclosureUpsert: Disclosure;
  /** Saves the survey response if not yet filled. This operation can be repeated upon success. */
  disclosureUserFill: DisclosureResponse;
  /** Mutation for editing email list entry. */
  editEmailEntry: EmailEntryEditResult;
  editEmailTarget: SurveyEmailTarget;
  /** Elects a downgrade for the caller's tenant, effective at the end of the signed term (on a one-year term, the next renewal). Requires the company-settings permission - a caller without it is refused (see PlanChangeSpendAuthorityRequiredError) and must ask whoever manages the organisation's billing. Needs no signature - a confirmed in-product election, cancellable until it applies. Downgrades exactly the selected standards to the target tier; refuses a selection that is not strictly above the target, a second election while one is already live, or an election onto the Basic tier without the Basic Licence terms accepted. Gated by the shop-surface flag. */
  electPlanDowngrade: PlanUpgradeContext;
  /** Mutation for deleting eLine numbers. */
  elineNumberDelete: Array<Scalars['UUID']['output']>;
  /** Mutation for updating or creating new eLine numbers. */
  elineNumberUpsert: ElineNumber;
  /**
   * Mutation for deleting email list.
   * @deprecated Use emailListDelete.
   */
  emailListDelete: Array<Scalars['ID']['output']>;
  /** Mutation for creating new or editing existing email list. */
  emailListUpsert: Array<EmailList>;
  emailTemplateCarbonCopyUpdate: EmailTemplate;
  emailTemplateUpdate: EmailTemplate;
  emailTemplatesStatusUpdate: Array<EmailTemplate>;
  /** Mutation responsible for signing up user's devices to appropriate Firebase topics based on his account details. Requires user to be signed in. */
  enablePushNotificationsForDevice: Array<FirebaseResponse>;
  /** Mutation used to generate Activity report. */
  esgActivityReportGenerate: EsgFile;
  /** Mutation for deletion of one or many ESG answers. */
  esgAnswerDelete: Array<Scalars['UUID']['output']>;
  /** Draft upsert of a Frameworks answer by version data — persists without writing an audit-trail event. Use for explicit "Save" (draft); the audited esgAnswerUpsertByVersionData is the commit path used at Mark as Addressed. */
  esgAnswerDraftUpsertByVersionData: EsgAnswer;
  /** Updates answer files. Any not included files will be removed. */
  esgAnswerFilesSet: EsgAnswer;
  /** Mutation for generating responses to esg questions. Still WIP. */
  esgAnswerGenerate: EsgAnswerGenerateResult;
  /** Mutation for upsert of one or many ESG answers. */
  esgAnswerUpsert: Array<EsgAnswer>;
  /** Mutation for upsert of answer by UUID. */
  esgAnswerUpsertByUuid: EsgAnswer;
  /** Mutation for upsert of answer by UUID. */
  esgAnswerUpsertByVersionData: EsgAnswer;
  /** Mutation used to generate Engage Audit report. */
  esgAuditReportGenerate: EsgFile;
  /** Mutation used to generate Country report. */
  esgCountryReportGenerate: EsgFile;
  /** Deletes a framework document from a framework library; blocked while the file is attached as evidence or cited by a pending draft. */
  esgDeleteFrameworkDocument: EsgFrameworkDocumentMutationResult;
  esgEsrsReportGenerate: EsgFile;
  /** Returns uploaded files. */
  esgFilesUpload: Array<EsgFile>;
  /** Speeki admin adds one auditor to the audit’s co-equal set; the first auditor moves the audit to ASSIGNED. Seat provisioning is driven off the emitted message. */
  esgFrameworkAuditAuditorAdd: EsgFrameworkAudit;
  /** Speeki admin removes one auditor from an active audit; removing the last auditor reverts it to REQUESTED (awaiting assignment). */
  esgFrameworkAuditAuditorRemove: EsgFrameworkAudit;
  /** Auditor completes the review; the audit becomes terminal. */
  esgFrameworkAuditComplete: EsgFrameworkAudit;
  /** Auditor records an append-only entry (comment or finding) on a requirement. Entries are never edited or deleted; a newer finding supersedes older ones. */
  esgFrameworkAuditEntryCreate: EsgFrameworkAuditEntry;
  /** Auditor starts an AI gap analysis over the audit’s addressed requirements. One run at a time per audit; a new run supersedes the prior run’s pending suggestions. */
  esgFrameworkAuditGapAnalysisStart: EsgFrameworkAuditGapRun;
  /** Auditor accepts a pending suggestion: publishes a comment (the note) plus a finding entry pair and marks the suggestion accepted, atomically. */
  esgFrameworkAuditGapSuggestionAccept: EsgFrameworkAuditGapSuggestion;
  /** Auditor dismisses a pending suggestion; nothing is published. */
  esgFrameworkAuditGapSuggestionDismiss: EsgFrameworkAuditGapSuggestion;
  /** Client requests an external audit of a framework for an assessment year. */
  esgFrameworkAuditRequest: EsgFrameworkAudit;
  /** Starts Gap Analysis for selected programme, framework, and answer versions using the tenant active reporting year. */
  esgGapAnalysisStart: EsgGapAnalysisBatch;
  /** Mutation for generating GRI report. */
  esgGriReportGenerate: EsgFile;
  /** Mutation for assigning files to question. */
  esgQuestionAssignFiles: EsgQuestion;
  /** Draft assign of evidence files — persists without writing an audit-trail event. Use for explicit Evidence "Save"; the audited capture happens at Mark as Addressed. */
  esgQuestionAssignFilesDraft: EsgQuestion;
  /** Captures the current saved evidence set into the audit trail (used at Mark as Addressed). Does not modify the evidence relation. */
  esgQuestionCaptureEvidence: EsgQuestion;
  /** Mutation for assigning files to question. */
  esgQuestionUnassignFiles: EsgQuestion;
  /** Draft unassign of evidence files — persists without writing an audit-trail event. Use for explicit Evidence "Save". */
  esgQuestionUnassignFilesDraft: EsgQuestion;
  /** As a SPEEKI_ADMIN updates common questions. As a TENANT_ADMIN updates their own questions */
  esgQuestionUpdate: Array<EsgQuestion>;
  /** Registers uploaded documents into a framework library (idempotent; status UPLOADED). */
  esgRegisterFrameworkDocuments: EsgFrameworkDocumentMutationResult;
  /** Sets the Smart Fill processing status of framework documents (UPLOADED → PROCESSING → PROCESSED/FAILED). */
  esgSetSmartFillDocumentStatus: EsgFrameworkDocumentMutationResult;
  /** Accepts a pending Nicole Smart Fill draft: writes the answer, attaches cited files as evidence, clears any Addressed marking, and marks the draft ACCEPTED. */
  esgSmartFillAcceptDraft: EsgSmartFillDraftMutationResult;
  /** Persists selected Smart Fill drafts as ESG answers and marks the Smart Fill job APPLIED in Insights. */
  esgSmartFillApplyDrafts: EsgSmartFillApplyDraftsPayload;
  /** Cancels a running Smart Fill job. Only the user who started it may cancel. */
  esgSmartFillCancel: EsgSmartFillCancelPayload;
  /** Dismisses a pending Nicole Smart Fill draft; no answer is written. */
  esgSmartFillDismissDraft: EsgSmartFillDraftMutationResult;
  /** Ingests an insights Smart Fill job (drafts + citations) into esg; idempotent per job, replaces pending drafts. */
  esgSmartFillIngestDrafts: EsgSmartFillIngestResult;
  /** Resumes a halted (AWAITING_INPUT) Smart Fill job. Only the user who started it may resume. */
  esgSmartFillResume: EsgSmartFillResumePayload;
  /** Starts Smart Fill analysis job for selected framework and uploaded files. */
  esgSmartFillStart: EsgSmartFillJob;
  /** Mutation used to generate Stakeholder report. */
  esgStakeholderReportGenerate: EsgFile;
  /** Mutation used to generate Standard report. */
  esgStandardReportGenerate: EsgFile;
  /**
   * Allows to exchange sso IdToken received from Microsoft Azure AD for a session payload. Will try to connect user to SSO and will fail if user tenant sso is not set up
   * @deprecated Use mutation loginAzureSso instead
   */
  exchangeAzureSingleSignOnToken: SsoAuthPayload;
  /** Export Metric */
  exportMetric: InsightsFile;
  /** Mutation used for generation and upload of disclosure response reports */
  fetchDisclosureReport: SurveyReportUploadResponse;
  /** Mutation used for generation and upload of survey response reports. */
  fetchPdfSurveyReport: SurveyReportUploadResponse;
  /** Generates and uploads a summary of the reported case in pdf format. */
  fetchWhistleblowerCaseReportPdf: WhistleblowerCaseReportPdfResponse;
  /** Fetch Forward Earth Data */
  forwardEarthDataFetch: Scalars['Boolean']['output'];
  /** Import or update a My-Frameworks framework + its requirements from an Excel sheet. commit:false = dry-run preview (writes nothing). */
  frameworkImport: FrameworkImportResult;
  /** Create a new AI report */
  generateAiReport: AiReport;
  /** Mutation for editing generic plans. */
  genericPlanUpdate: SubscriptionPlan;
  /** Allows to generate firebase token for authenticated user. Valid for 1 hour. */
  getFirebaseToken: FirebaseToken;
  /** Parse given markdown and store glossary. Returns inserted glossary entries */
  glossaryInsert: Scalars['String']['output'];
  /** Updates the user's API storage data. */
  graphStorageUpdate: UserType;
  /** Upserts group tag. Can also upsert child tags. */
  groupTagUpsert: GroupTag;
  /**
   * Delete group tags. Will remove child tags and replace tags references elsewhere.
   * Speeki admin can delete public tags. Tenant admin can delete their own group tag only.
   */
  groupTagsDelete: Array<Scalars['UUID']['output']>;
  /** Mutation for deletion of one or many guidelines. */
  guidelineDelete: Array<Scalars['UUID']['output']>;
  /** Operation for batch creation or update of existing guidelines. */
  guidelineUpsert: Array<Guideline>;
  /** Holds an ISO certification's price, re-priced server-side from the given answers, for 30 days. Public. Gated by the shop-surface flag. */
  holdQuote: HeldQuote;
  /** Burn a specific hotspot for a current user. Will result in hiding a hotspot */
  hotspotBurn: Array<Ui_Hotspot_Key>;
  /** Burn every hotspot for a current user. */
  hotspotBurnAll: Array<Ui_Hotspot_Key>;
  /**
   * Reset the current user's hotspots so they appear again. Pass `input.hotspots`
   * to reset only those keys; omit it to reset every resettable hotspot.
   * Returns true if at least one hotspot was reset.
   */
  hotspotReset: Scalars['Boolean']['output'];
  /** Initiate chat room on firebase. When chatRoomSecret is null it means that chat room is not initialized. Chat can be initialized once. Subsequent attempts of chat creation will not affect firestore nor database. */
  initFirebaseChatRoom: ChatRoom;
  /** Generate an iXBRL file */
  ixbrlGenerate: InsightsFile;
  knowledgeLibraryDeleteMany: Array<Scalars['UUID']['output']>;
  /** Mutation for generating answers for knowledge library. */
  knowledgeLibraryGenerateAnswers: Array<KnowledgeLibraryGeneratedAnswer>;
  /** Mutation for upsert of many knowledge library elements. */
  knowledgeLibraryUpsert: Array<KnowledgeLibraryQuestion>;
  /** Links multiple answers to a single metric */
  linkAnswersToMetric: LinkAnswersToMetricResult;
  /** Links multiple metrics to a single answer */
  linkMetricsToAnswer: LinkMetricsToAnswerResult;
  /** Mutation for linking metrics to an ESG answer. */
  linkMetricsToAnswerByUuidOrVersion: EsgAnswer;
  /** Logs a Help Center search that returned zero results, so missing articles can be identified. Search term only - no user-identifying payload. */
  logHelpZeroResultSearch: Scalars['Boolean']['output'];
  /** Exchanges a Speeki admin sign-in link for a session. The link is single-use and short-lived. */
  loginAdminWithMagicLink: AdminContextTokens;
  /** Authenticate user using Microsoft IdToken. If user login first time then account will be connected. Azure AD account must belongs to AD connected with a tenant */
  loginAzureSso: SessionPayload;
  /** Login a user with signed message. Signed message must match with public key associated with the user UUID and device UUID */
  loginBiometrics: SessionPayload;
  /** Login EXTERNAL USER */
  loginExternal: SessionPayload;
  /** Login anonymous user, GUEST */
  loginGuest: SessionPayload;
  /** Login user using password. Only EMPLOYEE, TENANT_ADMIN and AUDITOR are supported. */
  loginPassword: SessionPayload;
  /** Mutation for fetching JWT used for authorizing requests to the Spreadsheet Server API. */
  loginSpreadsheetServer: Scalars['JWT']['output'];
  /** Mutation for login with MFA */
  loginWithMfa: SessionPayload;
  /** Mutation for marking all unread notifications as read. Requires user to be signed in.Returned array may be deprecated and replaced with paginated list. */
  markAllNotificationsAsRead: Array<Scalars['String']['output']>;
  /** Mutation for marking all notifications as unread. Requires user to be signed in.  */
  markAllNotificationsAsUnread: Scalars['Float']['output'];
  /** Mark one year of a split (50% at the start, 50% on delivery) order delivered, raising that year's delivery invoice, due in 30 days. Refused when the order is not split, is not ACTIVATED or ACTIVE, or the year is not StaffOrderScheduleDetail.markDeliveredYear. Idempotent for a year already delivered. Gated by the shop-surface flag. */
  markEngagementDelivered: StaffOrderScheduleDetail;
  /** Mutation for marking one or many notifications as read. Returns an array of marked notifications uuids. */
  markNotificationsAsRead: Array<Scalars['String']['output']>;
  /** Mutation for marking selected notifications as unread. Requires user to be signed in */
  markNotificationsAsUnread: Scalars['Float']['output'];
  /** Mutation to mark given question as answered */
  markQuestionAsAnswered: EsgQuestion;
  /** Persists a question status change without writing an audit-trail event. Use for the auto-revert to Pending when an addressed requirement is edited. */
  markQuestionAsAnsweredDraft: EsgQuestion;
  /** Delete metric data by uuid */
  metricDataDeleteByUuid: MetricData;
  /** Upsert Metric Data */
  metricDataUpsert: MetricData;
  /** Delete metric by uuid */
  metricDeleteByUuid: Metric;
  /** Toggles metric as favourite */
  metricFavouriteToggle: Metric;
  /** Upsert Metric */
  metricUpsert: Metric;
  mfaResetConfirm: Scalars['Boolean']['output'];
  mfaResetRequest: Scalars['Boolean']['output'];
  /** Sign in to Speeki from my.speeki.com: exchange the assertion that site issued for the platform's own session — or a company choice, an MFA step, or an SSO hand-off, depending on the tenant. Unauthenticated; every refusal is the same generic error. */
  mySpeekiSignIn: MySpeekiSignInResult;
  /** Mutation for deletion of custom nicole assets. Will remove the custom image, if one exists and set Nicole settings as disabled. */
  nicoleAvatarDelete: AssetSettings;
  /** Mutation for changing the Nicole setting. CUSTOM may only be set if custom Nicole asset was uploaded. */
  nicoleAvatarSettingUpdate: AssetSettings;
  /** Mutation for upload of custom Nicole assets. */
  nicoleAvatarUpload: AssetSettings;
  /** Mutation for continuing NicoleGPT Session. */
  nicoleGptSessionContinue: NicoleGptSession;
  /** Update NicoleGPT session description */
  nicoleGptSessionDescriptionUpdate: NicoleGptSession;
  /** Mutation for regenerating a chat entry */
  nicoleGptSessionEntryRegenerate: NicoleGptSession;
  /** Initialize a new NicoleGPT session. */
  nicoleGptSessionInitialize: NicoleGptSession;
  /** Delete NicoleGPT sessions by their UUIDs. */
  nicoleGptSessionsDelete: Array<Scalars['UUID']['output']>;
  /** Mutation to create OAuth client */
  oAuthClientUpsert: Array<OAuthClient>;
  /** Mutation to delete OAuth client */
  oAuthClientsDelete: Array<Scalars['UUID']['output']>;
  /**
   * Mutation for editing custom and generic plans.
   * @deprecated Deprecated - use genericPlanUpdate or customPlanUpdate
   */
  planUpdate: SubscriptionPlan;
  /** Mutation to set questionnaire filters */
  questionnaireFiltersSet: QuestionnaireFilter;
  /** Re-adds a missed provisioning-history record. Idempotent: re-running against an already-resolved miss returns it unchanged rather than writing a duplicate record. */
  reAddMissedProvisioningEmit: MissedProvisioningEmit;
  /** Records a "Was this helpful?" vote on a Help Center article. */
  recordHelpArticleVote: Scalars['Boolean']['output'];
  /** Redeem the one-time code a MFA_REQUIRED sign-in answered with, presenting the binding secret from this browser's speeki_handoff cookie. Answers with the MFA challenge in the shape a password login gives it — sessionToken is the MFA token — so this host's own MFA screen carries on unchanged. Only this host should ever call it: the MFA token is enough to sign in without an authenticator code, which is exactly why the storefront is given a code instead. Unauthenticated; single use; sixty seconds. */
  redeemMfaHandoffCode: SessionPayload;
  /** Redeem a session hand-off code minted on the other origin, presenting the binding secret from this browser's speeki_handoff cookie. Unauthenticated; single use. */
  redeemSessionHandoffCode: SessionPayload;
  /** Refreshes session token for both guest and registered users. Returns new session and refresh tokens. */
  refreshAdminSession: AdminContextTokens;
  /** AMS sessions only. Refused for Engage and Speeki admin tokens, and after the 12-hour cap. */
  refreshAmsSession: AmsSessionTokens;
  /** Refreshes session token for both guest and registered users. */
  refreshSession: SessionPayload;
  regionUpsert: Array<Region>;
  /** Mutation for setting release notes as read. */
  releaseNoteMarkRead: UserType;
  /** Mutation for modifying release note. */
  releaseNoteUpsert: ReleaseNote;
  /** Remove ms teams tenant id from tenant */
  removeTeamsId: TenantBaseDataType;
  /** Gives the caller tenant's notice of non-renewal: the subscription will not renew at the end of its term. Cancellable with renewalNoticeWithdraw until the renewal date. Requires the company-settings permission. Gated by the shop-surface flag. */
  renewalNoticeGive: SubscriptionTerm;
  /** Withdraws the caller tenant's notice of non-renewal, so the subscription renews again. Only possible until the renewal date. Requires the company-settings permission. Gated by the shop-surface flag. */
  renewalNoticeWithdraw: SubscriptionTerm;
  /** Uploads files to the case being reported. */
  reportCaseFilesUpload: Array<ReportCaseFile>;
  /** Creates a new case, initializes assistant conversation and returns first message from chat assistant. */
  reportCaseStart: ConversationAssistantResponse;
  /** Submits case completing the reporting process.Not submitted cases eventually expires and will be removed. */
  reportCaseSubmit: CaseReportSubmit;
  /** Finishes the chat assistant conversation and returns the case summary. */
  reportCaseSummarize: CaseReportSummaryResponse;
  /** Deletes files from case being reported. */
  reportDeleteCaseFiles: Array<Scalars['ID']['output']>;
  /** Updates supplied conversation messages (textual only) and returns them. */
  reportEditConversation: Array<ConversationMessage>;
  /** Mutation to delete one or many report prompts templates. */
  reportPromptTemplateDelete: Scalars['Boolean']['output'];
  /** Mutation to upsert one or many report prompts templates. */
  reportPromptTemplateUpsert: Array<ReportPromptTemplate>;
  /** Upserts reporting group. */
  reportingGroupUpsert: ReportingGroup;
  /** Deletes reporting group. */
  reportingGroupsDelete: Array<Scalars['UUID']['output']>;
  /** Mutation to set reporting period for tenant. */
  reportingPeriodSet: TenantReportingPeriod;
  /** Mutation allows batch upsert of reporting sources. */
  reportingSourceBatchUpsert: Array<ReportingSource>;
  /** Mutation allows to upsert reporting source. */
  reportingSourceUpsert: ReportingSource;
  /** Creates unlock account token and send an email */
  requestAccountUnlock: Scalars['Boolean']['output'];
  /** Requests a Speeki admin sign-in link by email. Always returns true, whether or not the address has an account, so it cannot be used to discover which addresses are Speeki admins. */
  requestAdminMagicLink: Scalars['Boolean']['output'];
  /** Emails a confirmation code to an address a checkout buyer wants to use. The address is only kept on the checkout session once it is confirmed from the same session. Public: unauthenticated. Gated by the shop-surface flag. */
  requestCheckoutEmailVerification: RequestCheckoutEmailVerification;
  /** Sends a framework-access request email to Speeki on behalf of the current client. */
  requestFramework: Scalars['Boolean']['output'];
  /** Requests a seat for the caller in a framework the tenant owns. Queues the ask for admin approval - never grants a seat directly. */
  requestFrameworkSeat: SeatRequestType;
  /** Mutation for generating secret and qr code. */
  requestMfaSetup: MethodType;
  /** Ask an administrator to approve one of the caller tenant's DRAFT orders for spend, before it is sent for signature. Open to any tenant staff caller (tenant admin or employee) - asking to spend is not spending; approving stays with a company-settings holder. Gated by the shop-surface flag. */
  requestOrderApproval: ShopApprovalRequest;
  /** Send request to reset password that result in sending email with details */
  requestPasswordReset: Scalars['Boolean']['output'];
  /** Ask an administrator to accept a plan for a framework - no draft order exists yet; the administrator composes it themselves on acceptance. Open to any tenant staff caller (tenant admin or employee) - asking is not spending. Gated by the shop-surface flag. */
  requestPlanApproval: ShopApprovalRequest;
  /** Ask the administrators of a company the signed-in person is linked to for a plan. planRef is '<productId>:<planId>'. Same one-open-ask-per-product rule and administrator notice as the company-session request; refused for a company the person is not linked to. Gated by the shop-surface flag. */
  requestPlanByPass: ShopApprovalRequest;
  /** Emails a confirmation code to an address the reporter wants used for follow-up. The address is only kept on the report once it is confirmed from the same session. */
  requestReporterEmailVerification: RequestReporterEmailVerification;
  /** A checkout buyer submits a service's scope for a hand-priced quote - no price is computed, staff are notified to follow up. Public: unauthenticated. Gated by the shop-surface flag. */
  requestServicePricing: ServicePricingRequestResult;
  /** A checkout buyer asks to join an organisation that already uses Speeki - the organisation is resolved server-side from the checkout session's own verified-email domain match, not supplied here. Public: unauthenticated. Gated by the shop-surface flag. */
  requestTenantAccess: TenantAccessRequestResult;
  /** Ask to join the company that claimed the signed-in person's email domain. The company is resolved from the proved address, never supplied. Gated by the join-by-domain flag. */
  requestTenantAccessByDomain: TenantAccessRequestResult;
  /** Resend auth email with new token */
  resendAuthEmail: Scalars['Boolean']['output'];
  /** Resend create tenant email */
  resendCreateTenantEmail: Scalars['String']['output'];
  /** Re-send the signing email for one of the caller tenant's AWAITING_SIGNATURE orders. Rate-limited (cooldown + a hard cap) - see ResendCooldownActiveError / ResendCapReachedError - and subject to the same cross-order send budget as sendOrderForSignature. Gated by the shop-surface flag. */
  resendOrderSigningEmail: Order;
  /** Reset user password */
  resetPassword: SessionPayload;
  /**
   * Mutation for deleting questionnaire entries.
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireEntriesDelete: Array<Scalars['UUID']['output']>;
  /**
   * Mutation for upsert of questionnaire entries.
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireEntriesUpsert: Array<RespondQuestionnaireEntry>;
  /**
   * Mutation for upsert of
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireUpsert: RespondQuestionnaire;
  /** Mutation for changing the status of questionnaire */
  respondQuestionnaireV2ChangeStatus: RespondQuestionnaireV2;
  /** Mutation for creation of questionnaire. */
  respondQuestionnaireV2Create: RespondQuestionnaireV2;
  /** Mutation for batch delete of questionnares. */
  respondQuestionnaireV2Delete: Array<Scalars['UUID']['output']>;
  /** Mutation for delete of questionnaire entries by UUIDs */
  respondQuestionnaireV2EntriesDelete: Array<Scalars['UUID']['output']>;
  /** Mutation for edit of questionnaire entries by sheet reference. */
  respondQuestionnaireV2EntriesUpdateByAddress: Array<QuestionnaireEntry>;
  /** Mutation for edit of questionnaire entries by UUIDs. */
  respondQuestionnaireV2EntriesUpdateByUuid: Array<QuestionnaireEntry>;
  /** Mutation for edit of questionnaire entry by sheet reference. */
  respondQuestionnaireV2EntryUpdateByAddress: QuestionnaireEntry;
  /** Mutation for edit of questionnaire entry by UUIDs. */
  respondQuestionnaireV2EntryUpdateByUuid: QuestionnaireEntry;
  /** Mutation for setting the questionnaire as saved */
  respondQuestionnaireV2MarkAsSaved: RespondQuestionnaireV2;
  /** Mutation for update of filled excel file for questionnaire. */
  respondQuestionnaireV2UpdateExcelFile: RespondQuestionnaireV2;
  /**
   * Mutation for deleting questionnaires.
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnairesDelete: Array<Scalars['UUID']['output']>;
  /** Mutation for enabling and disabling tenant's risk areas. */
  riskAreaSettingsSet: Array<RiskArea>;
  /** Adds/Edits label of RiskArea */
  riskAreaUpdate: Array<RiskArea>;
  /** Enable and disable roles. */
  rolesChangeStatus: Array<Role>;
  /** Delete roles. */
  rolesDelete: Array<Role>;
  /** Upsert roles. */
  rolesUpsert: Array<Role>;
  /** Returns a sector by its UUID */
  sectorsSetState: Array<Sector>;
  /** Sends next user conversation message to the chat assistant and returns its response. */
  sendConversationMessage: ConversationAssistantResponse;
  /** Send invitation email based on tenant uuid and invited tenant email */
  sendInvitationEmail: Scalars['Boolean']['output'];
  /** Send one of the caller tenant's Draft orders for e-signature. Requires the company-settings permission for a PAID order - a caller without it must raise an approval request on the draft instead (see OrderSpendApprovalRequiredError); a caller's OWN free Basic order needs no such authority. Gated by the shop-surface flag. Subject to a cross-order send budget - see SigningSendRecipientBudgetExceededError / SigningSendTenantBudgetExceededError. */
  sendOrderForSignature: Order;
  /** A web portal visitor asks Speeki support for help; the request is emailed to the support inbox. Public: unauthenticated, so it is rate limited per IP and per email address. */
  sendPortalSupportRequest: Scalars['Boolean']['output'];
  /** Upsert the viewer tenant's value for one fitness formula variable in one reporting year; returns the refreshed indicator with its recomputed fitness. */
  setFitnessVariableValue: FitnessIndicator;
  /** Set Microsoft tenant id for teams integration */
  setMsTenantID: TenantBaseDataType;
  /** Allow or refuse sign-in from my.speeki.com for the caller's own company (the client's switch). Returns the setting now in force. */
  setMySpeekiSignInEnabled: Scalars['Boolean']['output'];
  /** Add mfa recovery email to user */
  setRecoveryEmail: SessionPayload;
  /**
   * Add mfa recovery email to user for tenant admin
   * @deprecated Temporary mutation to avoid breaking change. Will be replaces with new gql api
   */
  setRecoveryEmailTenantAdmin: SessionPayload;
  setRiskAreaSettingsByProgram: EsgRiskAreaSettingsByProgram;
  /** Set Speeki's standing pick, replacing whatever it was - at most one framework is ever featured. Refuses a framework the shop does not sell and a window that ends at or before it starts. To stop featuring anything, set `endsAt` to now. Gated by the shop-surface flag. */
  setSpeekiPick: SpeekiPick;
  /** Sets the custom label for a risk area. If no custom label is provided, the risk area custom label will be removed. */
  setTenantRiskAreaCustomLabel: TenantRiskAreaSetting;
  /**
   * Sets the risk area settings for a tenant scoped by a standard. Risk areas not included in the input will remain unchanged.
   * @deprecated Risk areas should be set up per programme.
   */
  setTenantRiskAreaSettings: TenantRiskAreaSettings;
  /** Set whether a suite member topic is in the tenant's material scope. */
  setTopicMaterialInScope: Scalars['Boolean']['output'];
  /**
   * Allows tenant admin to setup Azure Active Directory Single Sign On integration. In the same time connects admin account as first SSO user.
   * @deprecated User ssoAzureSetup mutation instead
   */
  setupAzureSingleSignOnForTenant: SsoAuthPayload;
  /** Ends the caller's own AMS session: its session and refresh tokens are refused from now on. Other sessions of the same user are not affected. Safe to call more than once. */
  signOutAmsSession: Scalars['Boolean']['output'];
  /** Temporary mutation to skip MFA during the transition period */
  skipMfa: SessionPayload;
  /** Setup Azure AD SSO for a tenant and authenticate user. User will be connected with Azure AD Account */
  ssoAzureSetup: SessionPayload;
  /** Allows to delete provider. Speeki admin can delete any provider. Tenant Admin can delete only providers assigned to his tenant */
  ssoProviderDelete: SsoProvider;
  /** Allows to setup custom sso manually. Speeki admin only */
  ssoProviderUpsert: SsoProvider;
  /** Allows send activation request for tenants with TRIAL */
  subscriptionRenewalRequest: Scalars['Boolean']['output'];
  /** Updates the reporting label for subsidiary site. */
  subsidiarySiteHeadquartersReportingLabelUpdate: SubsidiarySite;
  /** Mutation for editing subsidiary site roles. */
  subsidiarySiteRoleUpdate: SubsidiarySite;
  subsidiarySiteStatusUpdate: ClientSubsidiarySite;
  /** Switch user to specific subsidiary */
  subsidiarySiteSwitch: SessionPayload;
  /** Mutation for editing subsidiary site name and admin. */
  subsidiarySiteUpdate: SubsidiarySite;
  subsidiarySiteUpsert: ClientSubsidiarySite;
  /** Edits existing or creates new survey. */
  surveyRiskAreasUpsert: Survey;
  /** AI generated summary of survey results */
  surveySummary: SurveySummary;
  /**
   * Edits existing or creates new survey template.
   * @deprecated Use templateUpsert
   */
  surveyTemplateUpsert: SurveyTemplate;
  /**
   * Deletes existing survey templates based on provided identifiers
   * @deprecated Deprecated - please use templateDelete
   */
  surveyTemplatesDeletion: Array<Scalars['String']['output']>;
  /** Edits existing or creates new survey. */
  surveyUpsert: Survey;
  /** Saves the survey response if not yet filled. This operation cannot be repeated upon success. */
  surveyUserFill: SurveyResponse;
  /** Deletes existing survey  based on provided identifiers */
  surveysDeletion: Array<Scalars['ID']['output']>;
  /** Delete Symbol */
  symbolDelete: Symbol;
  /** Upsert Symbol */
  symbolUpsert: Symbol;
  /** Mutation for creating tags for versioning in programmes. Will assign tags to group tag 'Custom' in SHARED risk area. */
  tagCreateForVersion: Tag;
  /** Deletes tag description. */
  tagDescriptionDelete: Tag;
  tagDescriptionUpdate: Tag;
  /** Mutation for creating new or updating existing tag. */
  tagUpdate: Tag;
  /** Mutation for creating new or updating existing tag. */
  tagUpsert: Tag;
  /**
   * Delete tags. Will replace tags references elsewhere,
   * Speeki admin can delete public tags. Tenant admin can delete their own tags only.
   */
  tagsDelete: Array<Scalars['UUID']['output']>;
  /** Mutation for batch creation or update of existing tags. */
  tagsUpsert: Array<Tag>;
  /** Batch delete target */
  targetBatchDelete: Array<Scalars['UUID']['output']>;
  /** Delete target */
  targetDelete: Scalars['UUID']['output'];
  /** Upsert target */
  targetUpsert: Target;
  /** Return deleted task. */
  taskDelete: Task;
  /** Marks tasks as seen (task is not new anymore). */
  taskMarkAsSeen: Task;
  /** Returns updated task with new status. */
  taskUpdateStatus: Task;
  /** Upsert a task. */
  taskUpsert: Task;
  /** Create a new taxonomy report */
  taxonomyReportCreate: TaxonomyReport;
  /** Delete a taxonomy fact by its UUID. */
  taxonomyReportFactDelete: TaxonomyReportFact;
  /** Create or update a taxonomy fact. */
  taxonomyReportFactUpsert: TaxonomyReportFact;
  /** Deletes existing templates based on provided identifiers */
  templateDelete: Array<Scalars['ID']['output']>;
  /** Edits existing or creates new relation to riskAreas. */
  templateRiskAreasUpsert: Template;
  /** Edits existing or creates new template. */
  templateUpsert: Template;
  /** Invite a new tenant admin */
  tenantAdminInvite: UserType;
  tenantAdminInviteFinish: SessionWithOaExchange;
  /** Invites a new tenant admin AND seats them in one framework, atomically. The framework's seat capacity is checked before the user is created, so a full pool rejects the whole request rather than leaving an invited user with no seat. */
  tenantAdminInviteWithFrameworkSeat: UserType;
  /** Mutation to change tenant admin's regions.Applicable only for `REGIONAL_USER` role */
  tenantAdminRegionsChange: UserType;
  /** Mutation for tenant admins to edit other tenant admin's roles. */
  tenantAdminRolesUpdate: UserType;
  /** Mutation for tenant admins to edit other tenant admins. */
  tenantAdminUpdate: UserType;
  /** Mutation to change tenant admins' statuses. */
  tenantAdminsStatusesUpdate: Array<UserType>;
  /** One-off: turns auto renewal off for the listed audit-anchored tenants. Dry run by default. Speeki Admin only. Run it before the auto renewal flag is turned on. */
  tenantAuditRenewalBackfill: AuditRenewalBackfillResult;
  /** Checks registration code and call OA to create tenant. Returns tenant from NA. */
  tenantBeginSetup: AdminTenantData;
  tenantChangeStatus: AdminTenantData;
  /** Checks the registration status. When tenant is fully created then returns session tokens. If operation is pending then returns null. Throws an error when code is invalid or invalidated */
  tenantCheckStatus?: Maybe<Session>;
  /** Mutation used for updating tenant's country */
  tenantCountryUpdate: AdminTenantData;
  /** Records and verifies a domain for a tenant in one step. Staff-only: the output decides which tenant a domain routes to. */
  tenantDomainVerify: TenantDomain;
  /** One-off, flag-gated, safe to repeat: claims each active company's contact-email domain where unclaimed. Conflicts are reported, never guessed. */
  tenantDomainsBackfill: TenantDomainBackfillReport;
  /** Removes headline, will set headline to null. When headline is cleared and set to null then default value will be returned. */
  tenantHeadlineRemove: TenantBaseDataType;
  /** Allows to set header for current tenant */
  tenantHeadlineUpdate: TenantBaseDataType;
  /** Mutation used for updating tenant information. */
  tenantInformationUpdate: AdminTenantData;
  /** Mutation used for updating tenant's license count. */
  tenantLicenseCountUpdate: AdminTenantData;
  /** Mutation used for updating tenant's country */
  tenantNameUpdate: AdminTenantData;
  /** Mutation used for updating tenants primary contact details */
  tenantPrimaryContactDataUpdate: AdminTenantData;
  /** Records a notice of non-renewal the customer sent by email. Open to Customer Success and Speeki Admin. */
  tenantRenewalRecordCustomerNotice: AdminTenantData;
  /** Records a notice that the tenant's term will not renew. Speeki Admin only (no restricted role is opted in); a reason is required. */
  tenantRenewalStop: AdminTenantData;
  /** Withdraws a live notice of non-renewal so the term renews again. Speeki Admin for either party; Customer Success only for a CUSTOMER notice. */
  tenantRenewalWithdraw: AdminTenantData;
  /** Validate input and create tenant together with user */
  tenantSignup: AdminTenantData;
  /** Create a tenant together with a user, same as tenantSignup, but for an unauthenticated shop checkout flow: the caller has no session yet, so instead of trusting a client claim that the email was verified, this confirms it server-side against the checkout session before creating anything. */
  tenantSignupVerified: TenantSignupVerifiedData;
  /** Mutation for enabling or disabling standard for tenant. */
  tenantStandardsStatusBatchUpdate: AdminTenantData;
  /** Mutation used for updating tenant's subscription start and end date */
  tenantSubscriberEmailUpdate: AdminTenantData;
  /** Mutation used for updating tenant's subscription start and end date */
  tenantSubscriptionDatesUpdate: AdminTenantData;
  /** Mutation used for updating tenant's subscription details. */
  tenantSubscriptionUpdate: AdminTenantData;
  /** Updates industries (units) enabled for a tenant. */
  tenantUnitsBatchUpdate: Array<Sector>;
  /** Update default version custom label. */
  tenantUpdateDefaultAnswerLabel: TenantBaseDataType;
  /** Deletes tenants given by input. Returns UUIDs of deleted tenants. */
  tenantsDelete: Array<Scalars['ID']['output']>;
  toggleProgramSetting: EsgTenantProgramSetting;
  translate: Array<Scalars['String']['output']>;
  /** Removes a tenant admin from a framework's seat roster. */
  unassignUserFrameworkSeat: UserType;
  /** Unlinks metric from an answer */
  unlinkMetricFromAnswer: UnlinkMetricFromAnswerResult;
  /** Unlinks a question from a metric */
  unlinkQuestionFromMetric: UnlinkQuestionFromMetricResult;
  unlockAccount: Scalars['String']['output'];
  /** Mutation used for updating tenant assistant credentials. */
  updateAssistantCredentials: AssistantCredentials;
  /** Updates existing assistant slot. */
  updateAssistantSlot: AssistantSlot;
  /** Updates existing business unit. */
  updateBusinessUnit: Array<BusinessUnit>;
  /** Updates the buyer-entered draft on a checkout session. Public: unauthenticated. Gated by the shop-surface flag. */
  updateCheckoutSession: CheckoutSessionView;
  /** Updates user recovery email */
  updateRecoveryEmail: UserType;
  /** Updates tenant data. */
  updateTenant: TenantBaseDataType;
  /** Mutation for updating users first and last name */
  updateUserDetails: UserType;
  /** Changes current user settings: language, country or relationship.</br><strong>IMPORTANT: This should be followed with session refresh to ensure consistency.</strong> */
  updateUserSettings: UserSettings;
  /**
   * Mutation used for creating new or updating existing banned emails.
   * @deprecated use bannedEmailUpsert
   */
  upsertBannedEmail: BannedEmail;
  /**
   * Mutation for creating new or editing existing email list.
   * @deprecated Use emailListUpsert
   */
  upsertEmailList: EmailList;
  /** Mutation used for updating tenant forward earth credentials. */
  upsertForwardEarthCredentials: ForwardEarthCredentials;
  /**
   * Upsert a task.
   * @deprecated use taskUpsert
   */
  upsertTask: Task;
  /** Upserts an comment. */
  upsertTaskComment: TaskComment;
  /** Allows to change enabled standards end engage */
  userEnabledStandardsSet: UserType;
  /** Mutation for a user to edit own profile. */
  userProfileUpdate: UserType;
  /** Verifies a checkout session's email from the hub's proof of the signed-in person's address, in place of the six-digit code, and runs the same organisation-domain match confirmCheckoutEmailVerification runs. Public: unauthenticated. Gated by the shop-surface flag. */
  verifyCheckoutSessionWithHubProof: VerifyCheckoutSessionWithHubProofPayload;
  /** Void an unsigned order (DRAFT or AWAITING_SIGNATURE) for a tenant, releasing the duplicate-order block so they can order that standard again. Touches no grant or invoice. Gated by the shop-surface flag. */
  voidUnsignedOrder: Order;
  /** Generate an XBRL file */
  xbrlGenerate: InsightsFile;
  /** Mutation to clear year data. */
  yearClearData: Year;
  /** Mutation to clone data from one year to another. */
  yearClone: Year;
  /** Mutation to add year. */
  yearCreate: Year;
  /** Mutation to delete year. */
  yearDelete: Year;
  /** Mutation to activate year. */
  yearSetActive: Year;
  /** Mutation to close year. */
  yearSetClosed: Year;
  /** Mutation to open year. */
  yearSetOpen: Year;
};


export type MutationAdminUserDeleteArgs = {
  input: AdminUserDeleteInput;
};


export type MutationAdminUserUpsertArgs = {
  input: AdminUserUpsertInputArgs;
};


export type MutationAmsInviteAuditorArgs = {
  input: AmsInviteAuditorInput;
};


export type MutationAmsReactivateAuditorArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationAmsSuspendAuditorArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationAmsUpdateAuditorArgs = {
  input: AmsUpdateAuditorInput;
};


export type MutationApproveFrameworkSeatRequestArgs = {
  requestUuid: Scalars['UUID']['input'];
};


export type MutationApproveOrderApprovalRequestArgs = {
  requestUuid: Scalars['String']['input'];
};


export type MutationAssignUserFrameworkSeatArgs = {
  input: UserFrameworkSeatInput;
};


export type MutationBannedEmailBatchStatusChangeArgs = {
  input: BannedEmailStatusChangeBatchInput;
};


export type MutationBannedEmailDeleteArgs = {
  emailsToDelete: Array<Scalars['String']['input']>;
};


export type MutationBannedEmailStatusChangeArgs = {
  input: BannedEmailStatusChangeInput;
};


export type MutationBannedEmailUpsertArgs = {
  input: BannedEmailUpsertInput;
};


export type MutationBiometricsClearArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBiometricsSetupArgs = {
  input: BiometricsSetupInput;
};


export type MutationCallsCaseCreateArgs = {
  caseInput: CallsCaseCreateInput;
};


export type MutationCallsCaseUpdateArgs = {
  caseInput: CallsCaseUpdateInput;
};


export type MutationCancelMyAccessRequestArgs = {
  pass: Scalars['String']['input'];
  requestUuid: Scalars['ID']['input'];
};


export type MutationCancelMyApprovalRequestArgs = {
  requestUuid: Scalars['String']['input'];
};


export type MutationCancelMyUnsignedOrderArgs = {
  orderUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelOrderArgs = {
  orderUuid: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantUuid: Scalars['String']['input'];
};


export type MutationCarbonLensFinalizeSsoArgs = {
  interactionId: Scalars['String']['input'];
};


export type MutationCaseActivityCreateArgs = {
  input: CaseActivityCreateInput;
};


export type MutationCaseActivitySettingsBatchUpsertArgs = {
  input: CaseActivitySettingsBatchUpsertInput;
};


export type MutationCaseActivitySettingsUpsertArgs = {
  input: CaseActivitySettingsUpsertInput;
};


export type MutationCaseAnalyticsReportPdfArgs = {
  input: AnalyticsReportUploadInput;
};


export type MutationCaseAnonymitySettingsDeleteArgs = {
  input: CaseAnonymitySettingsDeleteInput;
};


export type MutationCaseAssignmentDeleteArgs = {
  input: CaseAssignmentDeleteInput;
};


export type MutationCaseAssignmentUpsertArgs = {
  input: CaseAssignmentUpsertInput;
};


export type MutationCaseAttachmentUploadArgs = {
  input: CaseFilesUploadInput;
};


export type MutationCaseBusinessUnitAssignArgs = {
  input: CaseBusinessUnitAssignInput;
};


export type MutationCaseCloseArgs = {
  input: CaseCloseInput;
};


export type MutationCaseConversationUpdateArgs = {
  input: CaseConversationUpdateInput;
};


export type MutationCaseCustomReminderDeleteArgs = {
  input: CaseCustomReminderDeleteInput;
};


export type MutationCaseCustomReminderUpsertArgs = {
  input: CaseCustomReminderUpsertInput;
};


export type MutationCaseCustomTitleUpdateArgs = {
  input: CaseCustomTitleUpdateInput;
};


export type MutationCaseDetailsUpdateArgs = {
  input: CaseDetailsUpdateInput;
};


export type MutationCaseIncidentTypeAssignArgs = {
  input: CaseIncidentTypeAssignInput;
};


export type MutationCaseIndividualInvolvedMessageSendArgs = {
  input: CaseIndividualInvolvedMessageInput;
};


export type MutationCaseIndividualInvolvedUpsertArgs = {
  input: CaseIndividualInvolvedUpsertInput;
};


export type MutationCaseIndividualsInvolvedDeleteArgs = {
  input: IndividualInvolvedDeleteInput;
};


export type MutationCaseInvestigationPdfReportGenerateArgs = {
  input: CaseInvestigationPdfReportGenerateInput;
};


export type MutationCaseInvestigationsXlsxReportGenerateArgs = {
  input: CaseInvestigationsXlsxReportGenerateInput;
};


export type MutationCaseInvestigatorsUpdateArgs = {
  input: CaseInvestigatorUpdateInput;
};


export type MutationCaseOwnerExclusionUpsertArgs = {
  input: CaseOwnerExclusionUpsertInput;
};


export type MutationCaseOwnerExclusionsDeleteArgs = {
  input: CaseOwnerExclusionsDeleteInput;
};


export type MutationCaseReopenArgs = {
  input: CaseReopenInput;
};


export type MutationCaseReportCreateArgs = {
  input: CaseReportCreateInput;
};


export type MutationCaseSettingsUpdateArgs = {
  input: CaseSettingsUpdateInput;
};


export type MutationCaseTriageScoreUpdateArgs = {
  input: CaseTriageScoreUpdateInput;
};


export type MutationCasesSubsidiarySiteUpdateArgs = {
  input: CasesSubsidiarySiteUpdateInput;
};


export type MutationChangeDisclosureStatusArgs = {
  changeDisclosureStatusArgs: DisclosureChangeStatusInput;
};


export type MutationChangeOrderSignerArgs = {
  input: ChangeOrderSignerInput;
  orderUuid: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationChangeSurveyReminderArgs = {
  surveyStatusUpdateInput: SurveyReminderUpdateInput;
};


export type MutationChangeSurveyStatusArgs = {
  surveyStatusUpdateInput: SurveyStatusUpdateInput;
};


export type MutationChatRoomFilesUploadArgs = {
  filesInput: ChatsFileUploadInput;
};


export type MutationChatbotCreateArgs = {
  input?: InputMaybe<CreateChatbotInput>;
};


export type MutationChatbotMessageCreateArgs = {
  input: CreateChatbotMessageInput;
};


export type MutationCheckPasswordResetTokenArgs = {
  checkPasswordResetTokenInput: CheckPasswordResetTokenInput;
};


export type MutationComposeOrderArgs = {
  input: ComposeOrderInput;
  tenantUuid: Scalars['String']['input'];
};


export type MutationConclusionTypeBatchUpsertArgs = {
  input: ConclusionTypeBatchUpsertInput;
};


export type MutationConclusionTypeUpsertArgs = {
  input: ConclusionTypeUpsertInput;
};


export type MutationConfirmCheckoutEmailVerificationArgs = {
  input: ConfirmCheckoutEmailVerificationInput;
};


export type MutationConfirmMfaSetupArgs = {
  code: Scalars['String']['input'];
};


export type MutationConfirmReporterEmailVerificationArgs = {
  input: ConfirmReporterEmailVerificationInput;
};


export type MutationCorrectMyBillingIdentityArgs = {
  input: CorrectOrderBillingIdentityInput;
};


export type MutationCorrectOrderBillingIdentityArgs = {
  input: CorrectOrderBillingIdentityInput;
  orderUuid: Scalars['String']['input'];
  tenantUuid: Scalars['String']['input'];
};


export type MutationCreateAssistantSlotArgs = {
  input: AssistantSlotCreateInput;
};


export type MutationCreateAssuranceOrderArgs = {
  idempotencyKey: Scalars['String']['input'];
  input: CreateAssuranceOrderInput;
};


export type MutationCreateAuditOrderArgs = {
  idempotencyKey: Scalars['String']['input'];
  input: CreateAuditOrderInput;
};


export type MutationCreateBusinessUnitArgs = {
  input: Array<CreateBusinessUnitInput>;
};


export type MutationCreateCheckoutOrderArgs = {
  idempotencyKey: Scalars['String']['input'];
  input: CreateCheckoutOrderInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateCourseOrderArgs = {
  idempotencyKey: Scalars['String']['input'];
  input: CreateCourseOrderInput;
};


export type MutationCreateEmployeeAccountArgs = {
  signUpRequestInput: SignUpRequestInput;
};


export type MutationCreatePlanUpgradeOrderArgs = {
  input: CreatePlanUpgradeOrderInput;
};


export type MutationCreateSessionHandoffCodeArgs = {
  input: SessionHandoffCreateInput;
};


export type MutationCustomPlanUpdateArgs = {
  input: CustomPlanUpdateInput;
};


export type MutationDataCategoryCreateArgs = {
  input: DataCategoryCreateInput;
};


export type MutationDataCategoryCreateManyArgs = {
  input: DataCategoryCreateManyInput;
};


export type MutationDeclineFrameworkSeatRequestArgs = {
  requestUuid: Scalars['UUID']['input'];
};


export type MutationDeclineShopApprovalRequestArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestUuid: Scalars['String']['input'];
};


export type MutationDeleteAssistantSlotArgs = {
  input: AssistantSlotDeleteInput;
};


export type MutationDeleteBannedEmailArgs = {
  emailsToDelete: Array<Scalars['String']['input']>;
};


export type MutationDeleteDisclosureDraftArgs = {
  disclosureUuids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEmailEntryArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEmailListArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEmailTargetArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteForwardEarthCredentialsArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type MutationDisablePushNotificationsForDeviceArgs = {
  deviceToken: Scalars['String']['input'];
};


export type MutationDisclosureDeleteArgs = {
  input: DisclosureDeleteInput;
};


export type MutationDisclosureResponseApproveArgs = {
  input: DisclosureResponseApproveInput;
};


export type MutationDisclosureResponseCommentUpsertArgs = {
  commentInput: DisclosureCommentUpsertInput;
};


export type MutationDisclosureRiskAreasUpsertArgs = {
  data: DisclosureRiskAreasUpsertInput;
};


export type MutationDisclosureUpsertArgs = {
  disclosureUpsertInput: DisclosureUpsertInput;
};


export type MutationDisclosureUserFillArgs = {
  responseInput: DisclosureResponseInput;
};


export type MutationEditEmailEntryArgs = {
  input: EmailEntryEditInput;
};


export type MutationEditEmailTargetArgs = {
  input: EmailAudienceEntryEditInput;
};


export type MutationElectPlanDowngradeArgs = {
  input: ElectPlanDowngradeInput;
};


export type MutationElineNumberDeleteArgs = {
  input: ElineNumberDeleteInput;
};


export type MutationElineNumberUpsertArgs = {
  input: ElineNumberUpsertInput;
};


export type MutationEmailListDeleteArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type MutationEmailListUpsertArgs = {
  input: Array<EmailListUpsertInput>;
};


export type MutationEmailTemplateCarbonCopyUpdateArgs = {
  input: EmailTemplateCarbonCopyUpdateInput;
};


export type MutationEmailTemplateUpdateArgs = {
  input: EmailTemplateUpdateInput;
};


export type MutationEmailTemplatesStatusUpdateArgs = {
  input: Array<EmailTemplateStatusUpdateInput>;
};


export type MutationEnablePushNotificationsForDeviceArgs = {
  deviceToken: Scalars['String']['input'];
};


export type MutationEsgActivityReportGenerateArgs = {
  input: EsgActivityReportGenerateInput;
};


export type MutationEsgAnswerDeleteArgs = {
  input: EsgAnswerDeleteInput;
};


export type MutationEsgAnswerDraftUpsertByVersionDataArgs = {
  input: EsgAnswerUpsertByVersionDataInput;
};


export type MutationEsgAnswerFilesSetArgs = {
  input: EsgFilesUpdateInput;
};


export type MutationEsgAnswerGenerateArgs = {
  input: EsgAnswerGenerateInput;
};


export type MutationEsgAnswerUpsertArgs = {
  input: Array<EsgAnswerUpsertInput>;
};


export type MutationEsgAnswerUpsertByUuidArgs = {
  input: EsgAnswerUpsertByUuidInput;
};


export type MutationEsgAnswerUpsertByVersionDataArgs = {
  input: EsgAnswerUpsertByVersionDataInput;
};


export type MutationEsgAuditReportGenerateArgs = {
  input: EsgAuditReportGenerateInput;
};


export type MutationEsgCountryReportGenerateArgs = {
  input: EsgCountryReportGenerateInput;
};


export type MutationEsgDeleteFrameworkDocumentArgs = {
  input: EsgDeleteFrameworkDocumentInput;
};


export type MutationEsgEsrsReportGenerateArgs = {
  input: EsgEsrsReportGenerateInput;
};


export type MutationEsgFilesUploadArgs = {
  input: EsgFilesUploadInput;
};


export type MutationEsgFrameworkAuditAuditorAddArgs = {
  input: EsgFrameworkAuditAuditorAddInput;
};


export type MutationEsgFrameworkAuditAuditorRemoveArgs = {
  input: EsgFrameworkAuditAuditorRemoveInput;
};


export type MutationEsgFrameworkAuditCompleteArgs = {
  input: EsgFrameworkAuditCompleteInput;
};


export type MutationEsgFrameworkAuditEntryCreateArgs = {
  input: EsgFrameworkAuditEntryCreateInput;
};


export type MutationEsgFrameworkAuditGapAnalysisStartArgs = {
  input: EsgFrameworkAuditGapAnalysisStartInput;
};


export type MutationEsgFrameworkAuditGapSuggestionAcceptArgs = {
  input: EsgFrameworkAuditGapSuggestionAcceptInput;
};


export type MutationEsgFrameworkAuditGapSuggestionDismissArgs = {
  input: EsgFrameworkAuditGapSuggestionDismissInput;
};


export type MutationEsgFrameworkAuditRequestArgs = {
  input: EsgFrameworkAuditRequestInput;
};


export type MutationEsgGapAnalysisStartArgs = {
  input: EsgGapAnalysisStartInput;
};


export type MutationEsgGriReportGenerateArgs = {
  input: EsgGriReportGenerateInput;
};


export type MutationEsgQuestionAssignFilesArgs = {
  input: EsgQuestionAssignFilesInput;
};


export type MutationEsgQuestionAssignFilesDraftArgs = {
  input: EsgQuestionAssignFilesInput;
};


export type MutationEsgQuestionCaptureEvidenceArgs = {
  questionUuid: Scalars['UUID']['input'];
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationEsgQuestionUnassignFilesArgs = {
  input: EsgQuestionUnassignFilesInput;
};


export type MutationEsgQuestionUnassignFilesDraftArgs = {
  input: EsgQuestionUnassignFilesInput;
};


export type MutationEsgQuestionUpdateArgs = {
  input: EsgQuestionBatchUpdateInput;
};


export type MutationEsgRegisterFrameworkDocumentsArgs = {
  input: EsgRegisterFrameworkDocumentsInput;
};


export type MutationEsgSetSmartFillDocumentStatusArgs = {
  input: EsgSetSmartFillDocumentStatusInput;
};


export type MutationEsgSmartFillAcceptDraftArgs = {
  input: EsgSmartFillAcceptDraftInput;
};


export type MutationEsgSmartFillApplyDraftsArgs = {
  input: EsgSmartFillApplyDraftsInput;
};


export type MutationEsgSmartFillCancelArgs = {
  input: EsgSmartFillCancelInput;
};


export type MutationEsgSmartFillDismissDraftArgs = {
  input: EsgSmartFillDismissDraftInput;
};


export type MutationEsgSmartFillIngestDraftsArgs = {
  input: EsgSmartFillIngestDraftsInput;
};


export type MutationEsgSmartFillResumeArgs = {
  input: EsgSmartFillResumeInput;
};


export type MutationEsgSmartFillStartArgs = {
  input: EsgSmartFillStartInput;
};


export type MutationEsgStakeholderReportGenerateArgs = {
  input: EsgStakeholderReportGenerateInput;
};


export type MutationEsgStandardReportGenerateArgs = {
  input: StandardReportGenerateInput;
};


export type MutationExchangeAzureSingleSignOnTokenArgs = {
  azureSSOLoginInput: AzureSsoLoginInput;
};


export type MutationExportMetricArgs = {
  input: ExportMetricInput;
};


export type MutationFetchDisclosureReportArgs = {
  reportUploadInput: ReportUploadInput;
};


export type MutationFetchPdfSurveyReportArgs = {
  reportUploadInput: ReportUploadInput;
};


export type MutationFetchWhistleblowerCaseReportPdfArgs = {
  input: GetWhistleblowerCaseReportPdfInput;
};


export type MutationFrameworkImportArgs = {
  input: FrameworkImportInput;
};


export type MutationGenerateAiReportArgs = {
  input: AiReportGenerateInput;
};


export type MutationGenericPlanUpdateArgs = {
  input: GenericPlanUpdateInput;
};


export type MutationGlossaryInsertArgs = {
  input: GlossaryInsertInput;
};


export type MutationGraphStorageUpdateArgs = {
  input: GraphStorageUpdateInput;
};


export type MutationGroupTagUpsertArgs = {
  input: GroupTagUpsertInput;
};


export type MutationGroupTagsDeleteArgs = {
  input: GroupTagDeleteInput;
};


export type MutationGuidelineDeleteArgs = {
  input: GuidelineDeleteInput;
};


export type MutationGuidelineUpsertArgs = {
  input: GuidelineBatchUpsertInput;
};


export type MutationHoldQuoteArgs = {
  input: IsoCertificationPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
  proof?: InputMaybe<Scalars['String']['input']>;
};


export type MutationHotspotBurnArgs = {
  input: HotspotBurnInput;
};


export type MutationHotspotResetArgs = {
  input?: InputMaybe<HotspotResetInput>;
};


export type MutationInitFirebaseChatRoomArgs = {
  refUuid: Scalars['String']['input'];
};


export type MutationIxbrlGenerateArgs = {
  input: IXbrlGenerateInput;
};


export type MutationKnowledgeLibraryDeleteManyArgs = {
  input: KnowledgeLibraryQuestionDeleteInput;
};


export type MutationKnowledgeLibraryGenerateAnswersArgs = {
  input: KnowledgeLibraryGenerateAnswersInput;
};


export type MutationKnowledgeLibraryUpsertArgs = {
  input: KnowledgeLibraryUpsertInput;
};


export type MutationLinkAnswersToMetricArgs = {
  input: LinkAnswersToMetricInput;
};


export type MutationLinkMetricsToAnswerArgs = {
  input: LinkMetricsToAnswerInput;
};


export type MutationLinkMetricsToAnswerByUuidOrVersionArgs = {
  input: LinkMetricsToAnswerGenericInput;
};


export type MutationLogHelpZeroResultSearchArgs = {
  input: LogHelpZeroResultSearchInput;
};


export type MutationLoginAdminWithMagicLinkArgs = {
  input: AdminMagicLinkLoginInput;
};


export type MutationLoginAzureSsoArgs = {
  input: SsoAzureLoginInput;
};


export type MutationLoginBiometricsArgs = {
  input: BiometricsLoginInput;
};


export type MutationLoginExternalArgs = {
  input: LoginExternalInput;
};


export type MutationLoginGuestArgs = {
  input: LoginGuestInput;
};


export type MutationLoginPasswordArgs = {
  input: LoginPasswordInput;
};


export type MutationLoginWithMfaArgs = {
  input: LoginWithMfaInput;
};


export type MutationMarkEngagementDeliveredArgs = {
  orderUuid: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type MutationMarkNotificationsAsReadArgs = {
  notificationUuids: Array<Scalars['String']['input']>;
};


export type MutationMarkNotificationsAsUnreadArgs = {
  notificationUuids: Array<Scalars['String']['input']>;
};


export type MutationMarkQuestionAsAnsweredArgs = {
  answered?: Scalars['Boolean']['input'];
  questionUuid: Scalars['String']['input'];
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationMarkQuestionAsAnsweredDraftArgs = {
  answered?: Scalars['Boolean']['input'];
  questionUuid: Scalars['String']['input'];
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationMetricDataDeleteByUuidArgs = {
  input: DeleteMetricDataInput;
};


export type MutationMetricDataUpsertArgs = {
  input: UpsertMetricDataInput;
};


export type MutationMetricDeleteByUuidArgs = {
  input: DeleteMetricInput;
};


export type MutationMetricFavouriteToggleArgs = {
  input: MetricFavouriteToggleInput;
};


export type MutationMetricUpsertArgs = {
  input: UpsertMetricInput;
};


export type MutationMfaResetConfirmArgs = {
  mfaResetToken: Scalars['String']['input'];
};


export type MutationMySpeekiSignInArgs = {
  input: MySpeekiSignInInput;
};


export type MutationNicoleAvatarSettingUpdateArgs = {
  input: NicoleSettingsUpdateInput;
};


export type MutationNicoleAvatarUploadArgs = {
  input: NicoleAvatarUploadInput;
};


export type MutationNicoleGptSessionContinueArgs = {
  input: NicoleGptSessionContinueInput;
};


export type MutationNicoleGptSessionDescriptionUpdateArgs = {
  input: NicoleGptSessionDescriptionUpdate;
};


export type MutationNicoleGptSessionEntryRegenerateArgs = {
  input: NicoleGptSessionEntryRegenerateInput;
};


export type MutationNicoleGptSessionInitializeArgs = {
  input: NicoleGptSessionInitializeInput;
};


export type MutationNicoleGptSessionsDeleteArgs = {
  input: NicoleGptSessionsDeleteInput;
};


export type MutationOAuthClientUpsertArgs = {
  input: Array<OAuthClientUpsertInput>;
};


export type MutationOAuthClientsDeleteArgs = {
  input: OAuthClientDeleteInput;
};


export type MutationPlanUpdateArgs = {
  input: PlanUpdateInput;
};


export type MutationQuestionnaireFiltersSetArgs = {
  input: QuestionnaireFiltersInput;
};


export type MutationReAddMissedProvisioningEmitArgs = {
  uuid: Scalars['UUID']['input'];
};


export type MutationRecordHelpArticleVoteArgs = {
  input: RecordHelpArticleVoteInput;
};


export type MutationRedeemMfaHandoffCodeArgs = {
  input: SessionHandoffRedeemInput;
};


export type MutationRedeemSessionHandoffCodeArgs = {
  input: SessionHandoffRedeemInput;
};


export type MutationRefreshAdminSessionArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRefreshAmsSessionArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRefreshSessionArgs = {
  token: Scalars['JWT']['input'];
};


export type MutationRegionUpsertArgs = {
  input: Array<RegionUpsertInput>;
};


export type MutationReleaseNoteUpsertArgs = {
  input: ReleaseNoteUpsertInput;
};


export type MutationRenewalNoticeGiveArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReportCaseFilesUploadArgs = {
  input: CaseFilesUploadInput;
};


export type MutationReportCaseStartArgs = {
  input: CaseReportStartInput;
};


export type MutationReportCaseSubmitArgs = {
  input: CaseReportSubmitInput;
};


export type MutationReportCaseSummarizeArgs = {
  input: CaseReportIdentifierInput;
};


export type MutationReportDeleteCaseFilesArgs = {
  input: CaseFilesDeleteInput;
};


export type MutationReportEditConversationArgs = {
  input: CaseReportEditConversationInput;
};


export type MutationReportPromptTemplateDeleteArgs = {
  input: ReportPromptTemplateDeleteInput;
};


export type MutationReportPromptTemplateUpsertArgs = {
  input: ReportPromptTemplateBatchUpsertInput;
};


export type MutationReportingGroupUpsertArgs = {
  input: ReportingGroupUpsertInput;
};


export type MutationReportingGroupsDeleteArgs = {
  input: ReportingGroupsDeleteInput;
};


export type MutationReportingPeriodSetArgs = {
  input: TenantReportingPeriodInput;
};


export type MutationReportingSourceBatchUpsertArgs = {
  input: ReportingSourceBatchUpsertInput;
};


export type MutationReportingSourceUpsertArgs = {
  input: ReportingSourceUpsertInput;
};


export type MutationRequestAccountUnlockArgs = {
  input: RequestUnlockTokenInput;
};


export type MutationRequestAdminMagicLinkArgs = {
  input: RequestAdminMagicLinkInput;
};


export type MutationRequestCheckoutEmailVerificationArgs = {
  input: RequestCheckoutEmailVerificationInput;
};


export type MutationRequestFrameworkArgs = {
  input: FrameworkRequestInput;
};


export type MutationRequestFrameworkSeatArgs = {
  input: RequestFrameworkSeatInput;
};


export type MutationRequestMfaSetupArgs = {
  input: RequestMfaSetupInput;
};


export type MutationRequestOrderApprovalArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  passwordResetRequestInput: PasswordResetRequestInput;
};


export type MutationRequestPlanApprovalArgs = {
  input: RequestPlanApprovalInput;
};


export type MutationRequestPlanByPassArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  pass: Scalars['String']['input'];
  planRef: Scalars['String']['input'];
  tenantUuid: Scalars['ID']['input'];
};


export type MutationRequestReporterEmailVerificationArgs = {
  input: RequestReporterEmailVerificationInput;
};


export type MutationRequestServicePricingArgs = {
  input: RequestServicePricingInput;
};


export type MutationRequestTenantAccessArgs = {
  input: RequestTenantAccessInput;
};


export type MutationRequestTenantAccessByDomainArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  pass: Scalars['String']['input'];
};


export type MutationResendAuthEmailArgs = {
  input: LoginExternalInput;
};


export type MutationResendCreateTenantEmailArgs = {
  input: ResendTenantCreateEmailInput;
};


export type MutationResendOrderSigningEmailArgs = {
  orderUuid: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};


export type MutationRespondQuestionnaireEntriesDeleteArgs = {
  input: RespondQuestionnaireEntriesDeleteInput;
};


export type MutationRespondQuestionnaireEntriesUpsertArgs = {
  input: RespondQuestionnaireEntriesUpsertInput;
};


export type MutationRespondQuestionnaireUpsertArgs = {
  input: RespondQuestionnaireUpsertInput;
};


export type MutationRespondQuestionnaireV2ChangeStatusArgs = {
  input: RespondQuestionnaireV2ChangeStatusInput;
};


export type MutationRespondQuestionnaireV2CreateArgs = {
  input: RespondQuestionnaireV2CreateInput;
};


export type MutationRespondQuestionnaireV2DeleteArgs = {
  input: RespondQuestionnaireV2DeleteInput;
};


export type MutationRespondQuestionnaireV2EntriesDeleteArgs = {
  input: RespondQuestionnaireV2EntryDelete;
};


export type MutationRespondQuestionnaireV2EntriesUpdateByAddressArgs = {
  input: RespondQuestionnaireV2EntryBatchEditByAddressInput;
};


export type MutationRespondQuestionnaireV2EntriesUpdateByUuidArgs = {
  input: RespondQuestionnaireV2EntryBatchEditByUuidInput;
};


export type MutationRespondQuestionnaireV2EntryUpdateByAddressArgs = {
  input: RespondQuestionnaireV2EntryEditByAddressInput;
};


export type MutationRespondQuestionnaireV2EntryUpdateByUuidArgs = {
  input: RespondQuestionnaireV2EntryEditByUuidInput;
};


export type MutationRespondQuestionnaireV2MarkAsSavedArgs = {
  input: RespondQuestionnaireV2MarkAsSavedInput;
};


export type MutationRespondQuestionnaireV2UpdateExcelFileArgs = {
  input: RespondQuestionnaireV2UpdateExcelFileInput;
};


export type MutationRespondQuestionnairesDeleteArgs = {
  input: RespondQuestionnaireDeleteInput;
};


export type MutationRiskAreaSettingsSetArgs = {
  input: RiskAreaSettingsSetInput;
};


export type MutationRiskAreaUpdateArgs = {
  input: RiskAreaBatchUpdateInput;
};


export type MutationRolesChangeStatusArgs = {
  input: RolesChangeStatusInput;
};


export type MutationRolesDeleteArgs = {
  input: RolesDeleteInput;
};


export type MutationRolesUpsertArgs = {
  input: RolesUpsertInput;
};


export type MutationSectorsSetStateArgs = {
  input: SectorSetStateInput;
};


export type MutationSendConversationMessageArgs = {
  input: ConversationUserResponseInput;
};


export type MutationSendInvitationEmailArgs = {
  input: TenantAdminInvitationEmailInput;
};


export type MutationSendOrderForSignatureArgs = {
  orderUuid: Scalars['String']['input'];
};


export type MutationSendPortalSupportRequestArgs = {
  input: PortalSupportRequestInput;
};


export type MutationSetFitnessVariableValueArgs = {
  input: SetFitnessVariableValueInput;
};


export type MutationSetMsTenantIdArgs = {
  setMsTenantIDInput: SetMsTenantIdInput;
};


export type MutationSetMySpeekiSignInEnabledArgs = {
  input: MySpeekiSignInSettingInput;
};


export type MutationSetRecoveryEmailArgs = {
  mfaRecoveryEmail: Scalars['String']['input'];
};


export type MutationSetRecoveryEmailTenantAdminArgs = {
  mfaRecoveryEmail: Scalars['String']['input'];
};


export type MutationSetRiskAreaSettingsByProgramArgs = {
  input: SetRiskAreaSettingsByProgramInput;
};


export type MutationSetSpeekiPickArgs = {
  input: SetSpeekiPickInput;
};


export type MutationSetTenantRiskAreaCustomLabelArgs = {
  input: TenantRiskAreaCustomLabelSetInput;
};


export type MutationSetTenantRiskAreaSettingsArgs = {
  input: TenantRiskAreaSettingsSetInput;
};


export type MutationSetTopicMaterialInScopeArgs = {
  input: SetMaterialInScopeInput;
};


export type MutationSetupAzureSingleSignOnForTenantArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationSsoAzureSetupArgs = {
  input: SsoAzureSetupInput;
};


export type MutationSsoProviderDeleteArgs = {
  input: SsoProviderDeleteInput;
};


export type MutationSsoProviderUpsertArgs = {
  input: SsoUpsertInput;
};


export type MutationSubsidiarySiteHeadquartersReportingLabelUpdateArgs = {
  input: SubsidiarySiteHeadquartersReportingLabelUpdateInput;
};


export type MutationSubsidiarySiteRoleUpdateArgs = {
  input: SubsidiarySiteRoleUpdateInput;
};


export type MutationSubsidiarySiteStatusUpdateArgs = {
  input: SubsidiarySiteStatusUpdateInput;
};


export type MutationSubsidiarySiteSwitchArgs = {
  input?: InputMaybe<SubsidiarySiteSwitchInput>;
};


export type MutationSubsidiarySiteUpdateArgs = {
  input: SubsidiarySiteUpdateInput;
};


export type MutationSubsidiarySiteUpsertArgs = {
  input: SubsidiarySiteUpsertInput;
};


export type MutationSurveyRiskAreasUpsertArgs = {
  data: SurveyRiskAreasUpsertInput;
};


export type MutationSurveySummaryArgs = {
  surveyUuid: Scalars['UUID']['input'];
};


export type MutationSurveyTemplateUpsertArgs = {
  template: SurveyTemplateUpsertInput;
};


export type MutationSurveyTemplatesDeletionArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationSurveyUpsertArgs = {
  survey: SurveyUpsertInput;
};


export type MutationSurveyUserFillArgs = {
  responseInput: SurveyResponseInput;
};


export type MutationSurveysDeletionArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type MutationSymbolDeleteArgs = {
  input: DeleteSymbolInput;
};


export type MutationSymbolUpsertArgs = {
  input: UpsertSymbolInput;
};


export type MutationTagCreateForVersionArgs = {
  input: TagForVersionCreateInput;
};


export type MutationTagDescriptionDeleteArgs = {
  tagUuid: Scalars['UUID']['input'];
};


export type MutationTagDescriptionUpdateArgs = {
  input: TagDescriptionUpdateInput;
};


export type MutationTagUpdateArgs = {
  input: TagUpdateInput;
};


export type MutationTagUpsertArgs = {
  input: TagUpsertInput;
};


export type MutationTagsDeleteArgs = {
  input: TagDeleteInput;
};


export type MutationTagsUpsertArgs = {
  input: TagsUpsertInput;
};


export type MutationTargetBatchDeleteArgs = {
  input: TargetBatchDeleteInput;
};


export type MutationTargetDeleteArgs = {
  input: TargetDeleteInput;
};


export type MutationTargetUpsertArgs = {
  input: UpsertTargetInput;
};


export type MutationTaskDeleteArgs = {
  input: DeleteTaskInput;
};


export type MutationTaskMarkAsSeenArgs = {
  input: TaskMarkAsSeenInput;
};


export type MutationTaskUpdateStatusArgs = {
  input: UpdateTaskStatusInput;
};


export type MutationTaskUpsertArgs = {
  input: TaskUpsertInput;
};


export type MutationTaxonomyReportCreateArgs = {
  input: TaxonomyReportCreateInput;
};


export type MutationTaxonomyReportFactDeleteArgs = {
  input: TaxonomyReportFactDeleteInput;
};


export type MutationTaxonomyReportFactUpsertArgs = {
  input: TaxonomyReportFactUpsertInput;
};


export type MutationTemplateDeleteArgs = {
  uuids: Array<Scalars['ID']['input']>;
};


export type MutationTemplateRiskAreasUpsertArgs = {
  data: TemplateRiskAreasUpsertInput;
};


export type MutationTemplateUpsertArgs = {
  template: TemplateUpsertInput;
};


export type MutationTenantAdminInviteArgs = {
  tenantAdminInviteInput: TenantAdminInviteInput;
};


export type MutationTenantAdminInviteFinishArgs = {
  input: TenantAdminInviteFinishInput;
};


export type MutationTenantAdminInviteWithFrameworkSeatArgs = {
  input: TenantAdminInviteWithFrameworkSeatInput;
};


export type MutationTenantAdminRegionsChangeArgs = {
  input: TenantAdminRegionsChangeInput;
};


export type MutationTenantAdminRolesUpdateArgs = {
  input: TenantAdminRoleUpdateInput;
};


export type MutationTenantAdminUpdateArgs = {
  input: TenantAdminUpdateInput;
};


export type MutationTenantAdminsStatusesUpdateArgs = {
  input: TenantAdminsStatusesUpdateInput;
};


export type MutationTenantAuditRenewalBackfillArgs = {
  input: TenantAuditRenewalBackfillInput;
};


export type MutationTenantBeginSetupArgs = {
  registerCode: Scalars['String']['input'];
};


export type MutationTenantChangeStatusArgs = {
  input: TenantStatusChangeInput;
};


export type MutationTenantCheckStatusArgs = {
  registerCode: Scalars['String']['input'];
};


export type MutationTenantCountryUpdateArgs = {
  input: TenantCountryUpdateInput;
};


export type MutationTenantDomainVerifyArgs = {
  input: TenantDomainVerifyInput;
};


export type MutationTenantHeadlineUpdateArgs = {
  headline: Scalars['HTML']['input'];
};


export type MutationTenantInformationUpdateArgs = {
  input: TenantInformationUpdateInput;
};


export type MutationTenantLicenseCountUpdateArgs = {
  input: TenantLicenseCountUpdateInput;
};


export type MutationTenantNameUpdateArgs = {
  input: TenantNameUpdateInput;
};


export type MutationTenantPrimaryContactDataUpdateArgs = {
  input: TenantPrimaryContactDataUpdateInput;
};


export type MutationTenantRenewalRecordCustomerNoticeArgs = {
  input: TenantRenewalRecordCustomerNoticeInput;
};


export type MutationTenantRenewalStopArgs = {
  input: TenantRenewalStopInput;
};


export type MutationTenantRenewalWithdrawArgs = {
  input: TenantRenewalWithdrawInput;
};


export type MutationTenantSignupArgs = {
  input: TenantCreateInput;
};


export type MutationTenantSignupVerifiedArgs = {
  checkoutSessionToken: Scalars['String']['input'];
  input: TenantCreateInput;
};


export type MutationTenantStandardsStatusBatchUpdateArgs = {
  input: EsgStandardStatusBatchUpdateInput;
};


export type MutationTenantSubscriberEmailUpdateArgs = {
  input: TenantSubscriberEmailUpdateInput;
};


export type MutationTenantSubscriptionDatesUpdateArgs = {
  input: TenantSubscriptionDatesUpdateInput;
};


export type MutationTenantSubscriptionUpdateArgs = {
  input: TenantSubscriptionUpdateInput;
};


export type MutationTenantUnitsBatchUpdateArgs = {
  input: TenantUnitBatchInput;
};


export type MutationTenantUpdateDefaultAnswerLabelArgs = {
  input: TenantUpdateDefaultAnswerLabelInput;
};


export type MutationTenantsDeleteArgs = {
  input: Array<TenantDeleteInput>;
};


export type MutationToggleProgramSettingArgs = {
  input: ToggleProgramSettingInput;
};


export type MutationTranslateArgs = {
  input: TranslateInput;
};


export type MutationUnassignUserFrameworkSeatArgs = {
  input: UserFrameworkSeatInput;
};


export type MutationUnlinkMetricFromAnswerArgs = {
  input: UnlinkMetricFromAnswerInput;
};


export type MutationUnlinkQuestionFromMetricArgs = {
  input: UnlinkQuestionFromMetricInput;
};


export type MutationUnlockAccountArgs = {
  input: UnlockAccountInput;
};


export type MutationUpdateAssistantCredentialsArgs = {
  input: AssistantCredentialsUpdateInput;
};


export type MutationUpdateAssistantSlotArgs = {
  input: AssistantSlotUpdateInput;
};


export type MutationUpdateBusinessUnitArgs = {
  input: Array<UpdateBusinessUnitInput>;
};


export type MutationUpdateCheckoutSessionArgs = {
  draft: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateRecoveryEmailArgs = {
  input: UpdateRecoveryEmailInput;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


export type MutationUpdateUserDetailsArgs = {
  userDetailsInput: UserDetailsInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: SessionUserSettingsUpdateInput;
};


export type MutationUpsertBannedEmailArgs = {
  bannedEmailUpsertInput: BannedEmailUpsertInput;
};


export type MutationUpsertEmailListArgs = {
  input: EmailListUpsertInput;
};


export type MutationUpsertForwardEarthCredentialsArgs = {
  input: ForwardEarthCredentialsUpsertInput;
};


export type MutationUpsertTaskArgs = {
  input: TaskUpsertInput;
};


export type MutationUpsertTaskCommentArgs = {
  input: TaskCommentUpsertInput;
};


export type MutationUserEnabledStandardsSetArgs = {
  input: UserEnabledStandardsSetInput;
};


export type MutationUserProfileUpdateArgs = {
  input: UserProfileUpdateInput;
};


export type MutationVerifyCheckoutSessionWithHubProofArgs = {
  input: VerifyCheckoutSessionWithHubProofInput;
};


export type MutationVoidUnsignedOrderArgs = {
  orderUuid: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  tenantUuid: Scalars['String']['input'];
};


export type MutationXbrlGenerateArgs = {
  input: XbrlGenerateInput;
};


export type MutationYearClearDataArgs = {
  input: ClearYearDataInput;
};


export type MutationYearCloneArgs = {
  input: CloneYearInput;
};


export type MutationYearCreateArgs = {
  input: AddYearInput;
};


export type MutationYearDeleteArgs = {
  input: DeleteYearInput;
};


export type MutationYearSetActiveArgs = {
  input: ChangeYearStatusInput;
};


export type MutationYearSetClosedArgs = {
  input: ChangeYearStatusInput;
};


export type MutationYearSetOpenArgs = {
  input: ChangeYearStatusInput;
};

export type MySpeekiCompany = {
  /** Whether that company enforces multi-factor authentication, so the picker can say so before the step appears */
  mfaEnforced: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** How this person is registered in that company */
  role: User_Type_Key;
  tenantUuid: Scalars['String']['output'];
};

export type MySpeekiProfile = {
  /** The company they gave to my.speeki.com — a prefill for the billing entity, not the tenant's registered name */
  company?: Maybe<Scalars['String']['output']>;
  /** The person's own name, as they gave it to my.speeki.com */
  name?: Maybe<Scalars['String']['output']>;
};

export type MySpeekiSignInInput = {
  /** The assertion my.speeki.com issued (first call) */
  assertion?: InputMaybe<Scalars['String']['input']>;
  /** A random secret this browser keeps in the speeki_handoff cookie on the shared base domain. Sent on every call, because the answer may be MFA_REQUIRED and its one-time code is bound to this secret: a browser that cannot present the same one cannot redeem it. */
  binding: Scalars['String']['input'];
  /** The choice token from a CHOOSE_COMPANY result (second call) */
  choiceToken?: InputMaybe<Scalars['String']['input']>;
  /** The company chosen from a CHOOSE_COMPANY result */
  tenantUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MySpeekiSignInResult = {
  /** CHOOSE_COMPANY: pass back with the chosen tenantUuid, within five minutes */
  choiceToken?: Maybe<Scalars['String']['output']>;
  /** CHOOSE_COMPANY: the companies to pick from */
  companies?: Maybe<Array<MySpeekiCompany>>;
  /** MFA_REQUIRED: a one-time code, sixty seconds, bound to this browser, that app.<env> redeems on its own origin for the MFA challenge. NOT a credential in itself — the MFA token never travels here, because holding one is enough to sign in without an authenticator code. */
  mfaHandoffCode?: Maybe<Scalars['String']['output']>;
  /** What my.speeki.com knows about the person, for prefilling a checkout they then edit. Returned with every outcome, including after a company choice. Claims, not proof. */
  profile?: Maybe<MySpeekiProfile>;
  /** SESSION: the refresh token */
  refreshToken?: Maybe<Scalars['JWT']['output']>;
  /** SESSION: the session token */
  sessionToken?: Maybe<Scalars['JWT']['output']>;
  status: MySpeekiSignInStatus;
  /** The company the outcome is for, once one is chosen */
  tenantUuid?: Maybe<Scalars['String']['output']>;
};

export type MySpeekiSignInSettingInput = {
  /** true = administrators of the caller's company may sign in from my.speeki.com (the default); false = refuse it */
  enabled: Scalars['Boolean']['input'];
};

export type MySpeekiSignInStatus =
  | 'CHOOSE_COMPANY'
  | 'MFA_REQUIRED'
  | 'NO_ACCOUNT'
  | 'SESSION'
  | 'SSO_REQUIRED';

/** Represents enumeration of Nicole assistant settings. */
export type Nicole_Setting =
  | 'CUSTOM'
  | 'DEFAULT'
  | 'DISABLED';

/** Who gave notice that a term will not renew. */
export type Non_Renewal_Party =
  | 'CUSTOMER'
  | 'SPEEKI';

/** Represents the named file upload. */
export type NamedFileUpload = {
  /** Uploaded file. */
  file: Scalars['Upload']['input'];
  /** Identifier of the file. */
  fileKey: Scalars['String']['input'];
};

/** Represents the named file upload. */
export type NamedUpload = {
  /** Uploaded file. */
  file: Scalars['Upload']['input'];
  /** Identifier of the file. */
  fileKey: Scalars['String']['input'];
};

export type NicoleAvatarUploadInput = {
  /** Custom nicole asset. Accepts jpg and png files, smaller than 1MB */
  customNicoleAvatar: Scalars['Upload']['input'];
};

/** Type representing a NicoleGPT session. */
export type NicoleGptSession = {
  /** Timestamp when the session was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Heading of the NicoleGPT session. */
  description: Scalars['String']['output'];
  /** List of chat entries in the session. */
  entries: NicoleGptSessionEntryConnection;
  /** Timestamp when the session was last updated. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the NicoleGPT session. */
  uuid: Scalars['UUID']['output'];
};


/** Type representing a NicoleGPT session. */
export type NicoleGptSessionEntriesArgs = {
  input?: NicoleGptSessionEntryConnectionInput;
};

/** Represents pagination connection of Nicole GPT sessions */
export type NicoleGptSessionConnection = {
  /** Array of edges. */
  edges: Array<NicoleGptSessionEdge>;
  /** Array of direct nodes. */
  nodes: Array<NicoleGptSession>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input for paginating Nicole GPT sessions */
export type NicoleGptSessionConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional input to search sessions by description */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<NicoleGptSessionSortInput>>;
};

/** Input for continuing a new NicoleGpt Session */
export type NicoleGptSessionContinueInput = {
  /** NicoleGpt session message. Up to 3000 characters long. */
  message: Scalars['String']['input'];
  /** UUID of the session to continue */
  sessionUuid: Scalars['UUID']['input'];
};

/** Input for editing chat description */
export type NicoleGptSessionDescriptionUpdate = {
  /** Session description */
  description: Scalars['String']['input'];
  /** UUID of edited session. */
  sessionUuid: Scalars['UUID']['input'];
};

/** Represents NicoleGptSession connection edge. */
export type NicoleGptSessionEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the NicoleGptSession record. */
  node: NicoleGptSession;
};

/** Type representing the content of a NicoleGPT chat entry. */
export type NicoleGptSessionEntry = {
  /** Confidence reasoning of the generated entry. */
  confidenceReasoning?: Maybe<Scalars['String']['output']>;
  /** Confidence score of the generated entry. */
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  /** The actual content of the chat entry. */
  content?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the session was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Reasoning behind hallucination verification */
  hallucinationReasoning?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if message has been emitted by assistant */
  isAssistant: Scalars['Boolean']['output'];
  /** Indicates if the entry is generated. */
  isGenerated: Scalars['Boolean']['output'];
  /** Flag indicating if message has been been halucinated */
  isHallucinated: Scalars['Boolean']['output'];
  /** Timestamp when the session was last updated. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Risk areas of ESG questionnaires used for generating message. */
  riskAreas?: Maybe<Array<RiskArea>>;
  /** List of knowledge sources used to generate the entry. */
  sourcesUsed: Array<Knowledge_Library_Source>;
  /** Unique identifier for the NicoleGPT chat entry. */
  uuid: Scalars['UUID']['output'];
};

/** Represents pagination connection of Nicole GPT sessions */
export type NicoleGptSessionEntryConnection = {
  /** Array of edges. */
  edges: Array<NicoleGptSessionEntryEdge>;
  /** Array of direct nodes. */
  nodes: Array<NicoleGptSessionEntry>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input for paginating Nicole GPT sessions */
export type NicoleGptSessionEntryConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<NicoleGptSessionEntrySortInput>>;
};

/** Represents NicoleGptSessionEntry connection edge. */
export type NicoleGptSessionEntryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the NicoleGptSessionEntry record. */
  node: NicoleGptSessionEntry;
};

/** Input for regenerating a nicole gpt response */
export type NicoleGptSessionEntryRegenerateInput = {
  entryUuid: Scalars['UUID']['input'];
};

export type NicoleGptSessionEntrySortFields =
  | 'CREATED_AT';

export type NicoleGptSessionEntrySortInput = {
  direction: SortDirection;
  field: NicoleGptSessionEntrySortFields;
};

/** Input for initiating a new NicoleGpt Session */
export type NicoleGptSessionInitializeInput = {
  /** NicoleGpt session message. Up to 3000 characters long. */
  message: Scalars['String']['input'];
};

export type NicoleGptSessionInput = {
  /** Unique identifier for the NicoleGPT session. */
  uuid: Scalars['UUID']['input'];
};

export type NicoleGptSessionSortFields =
  | 'CREATED_AT'
  | 'DESCRIPTION';

export type NicoleGptSessionSortInput = {
  direction: SortDirection;
  field: NicoleGptSessionSortFields;
};

/** Input for deleting a NicoleGpt sessions */
export type NicoleGptSessionsDeleteInput = {
  /** UUIDs of the sessions to delete */
  sessionUuids: Array<Scalars['UUID']['input']>;
};

export type NicoleSettingsUpdateInput = {
  /** Target Nicole setting. */
  setting: Nicole_Setting;
};

/** Object representing notification */
export type Notification = {
  /** Notification channel - direct or meant for broad audience */
  channel: NotificationChannels;
  /** Time when notification was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier of notification creator */
  createdByUuid?: Maybe<Scalars['String']['output']>;
  payload: NotificationPayload;
  /** Object containing information about time when notification was marked as read */
  readNotification?: Maybe<Array<ReadNotification>>;
  /** Type of notification */
  type?: Maybe<NotificationTypes>;
  /** Notification unique identifier */
  uuid: Scalars['ID']['output'];
};

/** Enumeration of possible notification channels */
export type NotificationChannels =
  /** Notification sent directly to a given user */
  | 'DIRECT_NOTIFICATION'
  /** Notification sent to users that match given email. */
  | 'EMAIL_NOTIFICATION'
  /** Notification sent to all users subscribed to given topics */
  | 'TOPIC_NOTIFICATION';

export type NotificationContents = {
  /** Body of notification */
  body?: Maybe<Scalars['String']['output']>;
  /** Title of notification */
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationData = {
  /** Extra information related to notification. */
  extra?: Maybe<NotificationExtraUnion>;
  /**
   * Referenced event uuid
   * @deprecated Deprecated - migrate to top level type, refUuid and meta fields to interpolate notification.
   */
  refUuid?: Maybe<Scalars['String']['output']>;
  /**
   * Type of notification
   * @deprecated Deprecated - migrate to top level type, refUuid and meta fields to interpolate notification.
   */
  type: NotificationTypes;
};

/** Represents the edge container of paginated `Notification` data. */
export type NotificationEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: Notification;
};

export type NotificationExtraUnion = DisclosureChatNotificationExtra;

/** Represents the filter input for the list of notifications */
export type NotificationFilterInput = {
  /** Fetch notifications created before given date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Notification channel that should be returned exclusively */
  filterChannels?: InputMaybe<NotificationChannels>;
  /** Notification types that should be returned exclusively */
  filterTypes?: InputMaybe<Array<NotificationTypes>>;
  /** Parameter exclusively selecting read or unread notifications */
  selectNotificationState?: InputMaybe<NotificationReadState>;
  /** Fetch notifications created after given date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Enumeration of possible keys used to order a list of notifications. */
export type NotificationOrderField =
  | 'createdAt';

/** Represents the singular `NotificationOrderFieldInput` order input object. */
export type NotificationOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: NotificationOrderField;
};

/** Represents the input type for ordering the list of notifications. */
export type NotificationOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<NotificationOrderFieldInput>;
};

/** Represents the page container of paginated `Notification` data. */
export type NotificationPage = {
  /** List of edges. */
  edges?: Maybe<Array<NotificationEdge>>;
  /** Page information. */
  info: PageInfo;
};

/** Represents the list of paginated notification type objects. */
export type NotificationPaginated = {
  /** Pages of data `edges` and page meta `info`. */
  page: NotificationPage;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationPayload = {
  /** @deprecated Deprecated - migrate to top level type, refUuid and meta fields to interpolate notification. */
  data: NotificationData;
  /** Value used for interpolating notification contents. */
  metadata: Scalars['String']['output'];
  /** @deprecated Deprecated - migrate to top level type, refUuid and meta fields to interpolate notification. */
  notification: NotificationContents;
  /** Referenced event uuid */
  reference: Scalars['String']['output'];
  /** Type of notification. */
  type: NotificationTypes;
};

/** Enumeration of possible notification read states */
export type NotificationReadState =
  /** Notification sent directly to a given user */
  | 'NOTIFICATION_READ'
  /** Notification sent to all users subscribed to given topics */
  | 'NOTIFICATION_UNREAD';

/** Topic constraint types. */
export type NotificationTopicTypes =
  /** Constraint type representing recipient country. */
  | 'COUNTRY'
  /** Constraint type representing reminders to specific survey */
  | 'DISABLE_REMINDER'
  /** Constraint type representing recipients relationship with tenant */
  | 'RELATIONSHIP'
  /** Constraint type representing specific tenant whose clients should receive notification */
  | 'TENANT_UUID';

/** Enumeration of possible notification channels */
export type NotificationTypes =
  /** Notification regarding disclosure chat */
  | 'DISCLOSURE_CHAT'
  | 'DISCLOSURE_RESPONSE_APPROVAL_APPROVED'
  | 'DISCLOSURE_RESPONSE_APPROVAL_DISAPPROVED'
  /** Notification regarding new available disclosure */
  | 'NEW_DISCLOSURE'
  /** Notification regarding new message */
  | 'NEW_MESSAGE'
  /** Notification regarding new available survey */
  | 'NEW_SURVEY'
  | 'RESPOND_PROCESSING_FINISHED'
  | 'SMART_FILL_RUN_COMPLETED'
  | 'SMART_FILL_RUN_FAILED'
  | 'SMART_FILL_RUN_HALTED'
  /** Notification regarding report update */
  | 'STATUS_UPDATE'
  /** Notification regarding survey reminder */
  | 'SURVEY_REMINDER'
  | 'TAXONOMY_REPORT_READY';

export type OAuthClient = {
  /** OAuth client's id. */
  clientId: Scalars['String']['output'];
  /** OAuth client's name. */
  clientName: Scalars['String']['output'];
  /** OAuth client's secret. */
  clientSecret: Scalars['String']['output'];
  /** OAuth client's cluster id. */
  clusterId: ClusterIds;
  /** OAuth client's grant types. */
  grantTypes: Array<GrantTypes>;
  /** OAuth client's redirect uris. */
  redirectUris: Array<Scalars['String']['output']>;
  /** OAuth client's scope. */
  scope: Scalars['String']['output'];
  /** OAuth client's uuid. */
  uuid: Scalars['UUID']['output'];
};

/** Represents OAuthClientConnection connection. */
export type OAuthClientConnection = {
  /** Array of edges. */
  edges: Array<OAuthClientEdge>;
  /** Array of direct nodes. */
  nodes: Array<OAuthClient>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying OAuth clients. */
export type OAuthClientConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional argument for OAuth clients search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<OAuthClientSortInput>>;
};

export type OAuthClientDeleteInput = {
  /** OAuth client's uuids. */
  clientsUuids: Array<Scalars['UUID']['input']>;
};

/** Represents OAuthClient connection edge. */
export type OAuthClientEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OAuthClient record. */
  node: OAuthClient;
};

export type OAuthClientInput = {
  /** OAuth client uuid. */
  uuid: Scalars['UUID']['input'];
};

export type OAuthClientSortFields =
  | 'CREATE_DATE'
  | 'NAME';

export type OAuthClientSortInput = {
  direction: SortDirection;
  field: OAuthClientSortFields;
};

export type OAuthClientUpsertInput = {
  /** OAuth client's ID. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** OAuth client's names. */
  clientName: Scalars['String']['input'];
  /** OAuth client's secrets. */
  clientSecret: Scalars['String']['input'];
  /** OAuth client's cluster id. */
  clusterId: ClusterIds;
  /** OAuth client's grant types. */
  grantTypes: Array<GrantTypes>;
  /** OAuth client's redirect urls. */
  redirectUris: Array<Scalars['String']['input']>;
  /** OAuth client's scope. */
  scope: Scalars['String']['input'];
  /** OAuth client's UUID. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** An activation order (self-serve or staff-assisted). */
export type Order = {
  /** Billing address printed on the invoice. Null unless the caller is Speeki staff, or a tenant admin holding the company-settings permission. */
  billingAddress?: Maybe<Scalars['String']['output']>;
  /** ANNUAL | QUARTERLY - how Year 1 is invoiced. QUARTERLY means `total` is the Year 1 sum of four instalments, raised one at a time; ANNUAL means one invoice for the whole of `total`. */
  billingCadence?: Maybe<Scalars['String']['output']>;
  /** Billing entity legal name for the invoice contact. Null unless the caller is Speeki staff, or a tenant admin holding the company-settings permission. */
  billingEntityName?: Maybe<Scalars['String']['output']>;
  /** Live invoice + credit-note state for this order, read from the accounting system on demand (staff read). Null when no invoice has been raised; `unavailable` when the accounting system could not be reached. */
  billingStatus?: Maybe<OrderBillingStatus>;
  /** ISO-2 buyer country. */
  buyerCountry: Scalars['String']['output'];
  /** What this order committed to: purchased tier, term, whole-term total, and every invoice the term produces - the same figures printed on the agreement that was signed. Null when the order records no term the shop can state honestly (a free-tier order, or one predating the term columns). */
  commitment?: Maybe<OrderCommitment>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  gstApplicable: Scalars['Boolean']['output'];
  /** STAFF_ASSISTED | SELF_SERVE */
  initiatorType: Scalars['String']['output'];
  /** Invoice recipient email. Null unless the caller is Speeki staff, or a tenant admin holding the company-settings permission - and an empty string on an order predating this field. */
  invoiceRecipientEmail?: Maybe<Scalars['String']['output']>;
  /** Invoice recipient's first name. Null unless the caller is Speeki staff, or a tenant admin holding the company-settings permission. */
  invoiceRecipientFirstName?: Maybe<Scalars['String']['output']>;
  /** Invoice recipient's last name. Null unless the caller is Speeki staff, or a tenant admin holding the company-settings permission. */
  invoiceRecipientLastName?: Maybe<Scalars['String']['output']>;
  /** Forward billing state: NONE | CREATE_PENDING | EMAIL_PENDING | CREATED | FAILED. */
  invoiceState?: Maybe<Scalars['String']['output']>;
  items: Array<OrderLine>;
  /** When the buyer last used "Send it again" to manually resend the agreement. Null when the agreement has never been manually resent. Resolved per order (one extra query) on every Order-returning read except myUnfinishedOrders, which already batches it for the whole list. */
  lastResentAt?: Maybe<Scalars['DateTime']['output']>;
  /** HALF_ON_DELIVERY when the fee is billed 50% at the start and 50% when Speeki staff mark the engagement delivered, SIXTY_ON_SIGN when it is billed 60% at signing and 40% when staff mark the audit finished; each invoice net 30. Null for every other order. */
  paymentSplit?: Maybe<Scalars['String']['output']>;
  /** QUARTERLY only: the per-quarter instalment frozen at checkout (money as a string) - what is due now, and again each quarter; the fourth quarter is the remainder so the four add up to `total`. Null on an annual order, and never guessed when a quarterly order has lost its frozen figure. */
  quarterlyInstalmentAmount?: Maybe<Scalars['String']['output']>;
  /** Distinct riskAreaUuids across this order's STANDARD/SEATS lines, for the seat-assignment deep link. Empty when no line resolves to a real uuid (e.g. a legacy slug ref). */
  riskAreaUuids: Array<Scalars['ID']['output']>;
  /** When the agreement was last sent to the signer - the latest transition into AWAITING_SIGNATURE. Differs from createdAt: an order can sit as a DRAFT for a while before it is ever sent, and this is when it actually went out, not when it was started. States a historical fact rather than the order's current status: a CANCELLED or VOID order that was sent before being cancelled or voided still reports that send date. Null only for a DRAFT that has never been sent, or an order with no such transition. Resolved per order (one extra query) on every Order-returning read except myUnfinishedOrders, which already batches it for the whole list. */
  sentForSignatureAt?: Maybe<Scalars['DateTime']['output']>;
  /** When an unsigned order will be given up on and cancelled. Non-null ONLY while the order is awaiting signature - once it is signed or cancelled there is no deadline left to warn about. Present so the buyer can be warned BEFORE the order lapses rather than after. */
  signatureDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** When the agreement was actually signed - the latest transition into SIGNED. Differs from sentForSignatureAt: an order can be sent for signature more than once before it is finally signed, and this is when that actually happened. Null for an order that has never been signed. States a historical fact rather than the order's current status: a CANCELLED order that was signed before being cancelled still reports that signing date. Resolved per order (one extra query) on every Order-returning read. */
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who the agreement was actually sent to for signature. The buyer is often not the signer, so this is what lets them see whose signature the order is waiting on - and chase that person directly. Falls back to the invoice recipient exactly as the send does, so it names the real addressee rather than reading empty for a buyer who named no separate signer. Null only when there is no addressee at all (a free order, which activates without an agreement). */
  signerEmail?: Maybe<Scalars['String']['output']>;
  /** DRAFT | AWAITING_SIGNATURE | SIGNED | ACTIVATED | ACTIVE | VOID | CANCELLED */
  status: Scalars['String']['output'];
  /** INCLUSIVE | EXCLUSIVE - the pricing basis this order was quoted on, frozen at creation. INCLUSIVE means `total` already contains any Sales Tax; EXCLUSIVE means `total` is a subtotal and tax is added on the invoice. Null for an order created before the basis was recorded. */
  taxBasis?: Maybe<Scalars['String']['output']>;
  /** The tax rate as a percentage (e.g. 9 for 9%) frozen at creation, for DISPLAY only - the tax amount is always computed on the invoice. 0 means no tax applied to this order; null means the rate is unknown (no rate configured, or an order predating the column) and must never be rendered as zero. */
  taxRatePercent?: Maybe<Scalars['Float']['output']>;
  /** Order total (money as a string to avoid float loss). */
  total?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

/** Live billing state for one order, read back from the accounting system when it is asked for (staff read). Every field is nullable on purpose: when the accounting system cannot be reached `unavailable` is true and the rest are null, so the screen shows a dash rather than an error or a misleading zero. */
export type OrderBillingStatus = {
  /** Amount still outstanding on the invoice. */
  amountDue?: Maybe<Scalars['Float']['output']>;
  /** Amount paid against the invoice so far. */
  amountPaid?: Maybe<Scalars['Float']['output']>;
  /** Null when no credit note is allocated to this invoice; otherwise the status of the most recent one. */
  creditNoteStatus?: Maybe<Scalars['String']['output']>;
  /** Total credit-noted against this invoice; 0 when nothing has been credited. */
  creditedAmount?: Maybe<Scalars['Float']['output']>;
  /** The accounting system's invoice id. */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** The human invoice number, e.g. "INV-0042". */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** DRAFT | SUBMITTED | AUTHORISED | PAID | VOIDED | DELETED | UNKNOWN. */
  status?: Maybe<Scalars['String']['output']>;
  /** True when the accounting system could not be reached and every other field is therefore null - show a dash, never an error. */
  unavailable?: Maybe<Scalars['Boolean']['output']>;
};

/** What a signed order actually committed to: the purchased tier, the term, and every invoice that term produces. Resolved from the order's own frozen facts, so the figures here are the ones printed on the agreement that was signed - not a fresh quote. */
export type OrderCommitment = {
  /** NEW_PERIOD (this purchase established its own term) or CO_TERMINOUS (it was aligned to a subscription period the tenant already held). Null on an order predating the column. */
  anchorMode?: Maybe<Scalars['String']['output']>;
  /** The committed fee PER YEAR, tax-exclusive, discount already applied (money as a string). What each anniversary invoice charges - never the total for the term. */
  annualAmount: Scalars['String']['output'];
  /** The day the customer's term runs from: the signature date for a NEW_PERIOD order signed under the commencement-on-signature schedule edition, and the order date otherwise (including every CO_TERMINOUS follower, whose first charge was quoted and frozen against the order date before any signature existed). Read as 'your term started here'. It is NOT necessarily the first row of `schedule`: the schedule is anchored on the order date, as the signed agreement's own Schedule is, so on an order signed some days after it was placed the two legitimately differ. */
  commencementDate: Scalars['DateTime']['output'];
  /** ISO-4217 code the amounts above are denominated in. */
  currency: Scalars['String']['output'];
  /** The subscription term this order belongs to: its length, exact expiry, and how much of it remains. */
  masterTerm: MasterTermSummary;
  /** Every invoice this order produces, in order, running to the end of the committed term - including ones already raised. Amounts are tax-EXCLUSIVE. This is the same schedule the buyer saw on the review page and then signed. */
  schedule: Array<PaymentScheduleRow>;
  /** For NEW_PERIOD, the committed term length in years. For a CO_TERMINOUS follower this is the MASTER term's length, which is NOT the number of years this order runs for - read `masterTerm.expiry` for the date it actually ends. Null when no term was recorded. */
  termYears?: Maybe<Scalars['Int']['output']>;
  /** The purchased tier id, frozen at checkout. Null for a staff-composed order that recorded none. */
  tierId?: Maybe<Scalars['String']['output']>;
  /** The whole-term total, tax-exclusive (money as a string): the sum of every row in `schedule`. NOT annualAmount x termYears - a co-terminous follower's first and final periods are prorated part-years. This is the figure the signed agreement's Schedule states. */
  totalAmount: Scalars['String']['output'];
};

/** One state-change event in an order's provisioning timeline (append-only, staff read). */
export type OrderEvent = {
  /** Status before this transition; null for the initial compose. */
  fromStatus?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  /** Provider correlation ref (e.g. a DocuSign envelope id). */
  providerRef?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** DRAFT | AWAITING_SIGNATURE | SIGNED | ACTIVATED | ACTIVE | VOID | CANCELLED */
  toStatus: Scalars['String']['output'];
  /** STAFF | SELF_SERVE | DOCUSIGN_WEBHOOK | SYSTEM */
  trigger: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type OrderItemInput = {
  kind: Scalars['String']['input'];
  /** Seats. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Standard code / module key. */
  ref: Scalars['String']['input'];
};

/** One line of an order. */
export type OrderLine = {
  /** STANDARD | MODULE | SEATS */
  kind: Scalars['String']['output'];
  /** Seats. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Standard code / module key. */
  ref: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type OriginalReport = {
  /** Incident type of reported case. */
  incidentType?: Maybe<IncidentType>;
  /** Language with which case has been reported. */
  language: Language_Code;
  reporter: CaseReporter;
  /**
   * Reporting source name.
   * @deprecated Use nested reportSource object instead.
   */
  reportingSource?: Maybe<Scalars['String']['output']>;
};

/** Enumeration of user permissions. */
export type Permission =
  | 'ASSIGNMENT_RULES'
  | 'CARBON_LENS_MODULE'
  | 'COMPANY_SETTINGS'
  | 'CREATE_CASE'
  | 'CUSTOM_REMINDER'
  | 'DASHBOARD'
  | 'DELETE_CASE'
  | 'DEMO_FEATURES'
  | 'DISCLOSURES_DASHBOARD'
  | 'DUE_DILIGENCE_MODULE'
  | 'EDIT_CASE'
  | 'EDIT_CONVERSATION'
  | 'ESG_ADD_TASK_ALL'
  | 'ESG_DASHBOARD'
  | 'ESG_PROFILE_MANAGEMENT'
  | 'ESG_QUESTIONNAIRE'
  | 'ESG_READ_ALL'
  | 'ESG_REPORTING'
  | 'ESG_RISK_AREA_ADD_TASK'
  | 'ESG_RISK_AREA_MANAGEMENT'
  | 'ESG_RISK_AREA_READ'
  | 'ESG_RISK_AREA_WRITE'
  | 'ESG_TAG_MANAGEMENT'
  | 'ESG_WRITE_ALL'
  | 'FRAMEWORKS_AUDIT_COMMENT'
  | 'FRAMEWORKS_AUDIT_VIEW'
  | 'FRAMEWORKS_DASHBOARD'
  | 'METRICS_MANAGEMENT'
  | 'NICOLE_GPT_MODULE'
  | 'NOTIFICATION_PARTICIPANT'
  | 'OWN_CASE'
  | 'PRINT_CASE'
  | 'PRINT_CASE_SETTINGS'
  | 'PROCESS_SETTINGS'
  | 'REGION_USER_ASSIGNMENT'
  | 'REMOVE_USER'
  | 'SEE_ALL_CASES'
  | 'SEE_REGION_CASE'
  | 'SEE_TRENDS'
  | 'STAKEHOLD_CASE'
  | 'SUBSIDIARY_SETTINGS'
  | 'SUPER_ADMIN'
  | 'SURVEYS_DASHBOARD'
  | 'TASKS_ASSIGNEE'
  | 'TASKS_ASSIGNOR'
  | 'TASKS_DASHBOARD';

/** Who/what authored the provisioning delta. */
export type Provisioning_Actor_Type =
  | 'STAFF'
  | 'SYSTEM'
  | 'TENANT_ADMIN';

/** Provisioning entitlement-delta event category. */
export type Provisioning_Event_Type =
  | 'PROVISIONING_MODULE_DISABLED'
  | 'PROVISIONING_MODULE_ENABLED'
  | 'PROVISIONING_PLAN_SWITCHED'
  | 'PROVISIONING_RISK_AREA_PREDELETE'
  | 'PROVISIONING_SEATS_CHANGED'
  | 'PROVISIONING_STAFF_OVERRIDE'
  | 'PROVISIONING_STANDARD_GRANTED'
  | 'PROVISIONING_STANDARD_REVOKED'
  | 'PROVISIONING_SUBSIDIARY_SITE_DISABLED';

/** Kind of entitlement item the delta acted on. */
export type Provisioning_Item_Type =
  | 'MODULE'
  | 'PLAN'
  | 'RISK_AREA'
  | 'SEATS'
  | 'STANDARD'
  | 'SUBSIDIARY_SITE';

/** Whether a delta affects one tenant or a fan-out set. */
export type Provisioning_Scope =
  | 'GLOBAL'
  | 'TEMPLATE'
  | 'TENANT';

/** Represents the page information. */
export type PageInfo = {
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageSize: Scalars['Int']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Represents page info object. V2 suffix is added to not break previous `PageInfo`. It will be stripped when old `PageInfo` deprecated will be able to be deleted. */
export type PageInfoV2 = {
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage: Scalars['Boolean']['output'];
  /** true if paging backwards and there are more records. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The page size. */
  pageSize: Scalars['Int']['output'];
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

/** Represents  both offset and cursor  pagination input object. */
export type PaginationInput = {
  /** Cursor after which page should start (exclusive). */
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  /** Cursor before which page should start (exclusive). */
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  /** Size of the page. Used with `afterCursor`. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the page. Used with `beforeCursor`. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Offset where the page should start (inclusive) */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the page. */
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the paging input. */
export type PagingInput = {
  /** Paginate after opaque cursor. */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor. */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Limit the number of records returned. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to start returning records from. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Who a Partner Integrity assessment audits. Recorded on the agreement; never a price input. */
export type PartnerIdentityInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** One of: Supplier, Distributor, Reseller, Agent / intermediary, Joint-venture partner, Other third party. */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerIntegrityDomainRule = {
  feeUsd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** What Nicole and the assessor review. */
  reviews: Scalars['String']['output'];
};

/** The buyer's scope answers for a Partner Integrity price quote. */
export type PartnerIntegrityPriceInput = {
  /** Domain ids, from partnerIntegrityRules. */
  domains: Array<Scalars['String']['input']>;
  highRisk: Scalars['Boolean']['input'];
  interviews: Scalars['Int']['input'];
  /** The PARTNER's headcount. */
  partnerHeadcount: Scalars['Int']['input'];
  /** "summary" | "findings" | "full". */
  reportLevel: Scalars['String']['input'];
  /** Report needed within 2 weeks. */
  rush: Scalars['Boolean']['input'];
};

export type PartnerIntegrityReportLevelRule = {
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type PartnerIntegrityRules = {
  domains: Array<PartnerIntegrityDomainRule>;
  interviewFeeUsd: Scalars['String']['output'];
  maxDomains: Scalars['Int']['output'];
  maxHeadcount: Scalars['Int']['output'];
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  reportLevels: Array<PartnerIntegrityReportLevelRule>;
};

/** This input represents data required to request a password reset and send an email with more instructions. */
export type PasswordResetRequestInput = {
  /** An email that is used to identify the user. */
  email: Scalars['String']['input'];
  /** A tenant to identify the user */
  tenantUuid: Scalars['ID']['input'];
  /** Account type */
  type: Auth_User_Type;
};

/** One invoice the buyer will receive for this purchase, tax-EXCLUSIVE. The full schedule spells out every invoice, not just the first, so the second invoice is never a surprise. Tax is computed on each invoice, never mixed into an amount here. */
export type PaymentScheduleRow = {
  /** The net (tax-exclusive) amount for this period (money as a string). The due-now row repeats the amount already shown as due now; later rows are full years at the committed rate, and a co-terminous follower's final year is prorated to the signed end. */
  amountUsd: Scalars['String']['output'];
  /** Positional label for the row: "Due now (prorated)", "Due now", "Next" or "Then". */
  label: Scalars['String']['output'];
  /** The day the NEXT period begins - the term/anniversary boundary, EXCLUSIVE of this period, UTC. It is the same 'to' date the annual invoice line prints, and the exact end a prorated amount is computed against. */
  periodEnd: Scalars['DateTime']['output'];
  /** First covered day of this period (inclusive), UTC. */
  periodStart: Scalars['DateTime']['output'];
  /** Whether this row is a prorated part-year rather than a full year - true for the co-terminous first period and for a final off-grid year. */
  prorated: Scalars['Boolean']['output'];
};

/** The tenant's live downgrade election (#860 Fold C): needs no signature, recorded and cancellable until it applies at the end of the signed term. */
export type PendingDowngrade = {
  createdAt: Scalars['DateTime']['output'];
  /** The date the election applies on: the end of the signed term (on a multi-year term, later than renewalDate, which is the next yearly invoice). Null only if the anchor itself is no longer resolvable. */
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** The catalogue plan id the tenant elected to move to. */
  electedTier: Scalars['ID']['output'];
  /** The riskAreaUuids of the owned standards this election drops to electedTier at the end of the signed term. Null only on a legacy tenant-wide election recorded before this field existed - the frontend maps refs to names via the context's standards. */
  selectedRefs?: Maybe<Array<Scalars['ID']['output']>>;
};

export type PlanUpdateInput = {
  /** Carbon Lens module enabled flag. */
  carbonLens?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cases module enabled flag. */
  cases?: InputMaybe<Scalars['Boolean']['input']>;
  /** Demo module enabled flag. */
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disclosures module enabled flag. */
  disclosures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Due Diligence module enabled flag. */
  dueDiligence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Esg module enabled flag. */
  esg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feature update input. */
  features?: InputMaybe<FeatureUpdateInput>;
  /** Frameworks module enabled flag. */
  frameworks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Insights module enabled flag. */
  insights?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nicole GPT module enabled flag. */
  nicoleGpt?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of edited plan. */
  planUuid: Scalars['UUID']['input'];
  /** Sso module enabled flag. */
  sso?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subsidiaries module enabled flag. */
  subsidiarySites?: InputMaybe<Scalars['Boolean']['input']>;
  /** Surveys module enabled flag. */
  surveys?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tasks module enabled flag. */
  tasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Teams module enabled flag. */
  teams?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trainings module enabled flag. */
  trainings?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One upgrade target the caller's tenant may move to. */
export type PlanUpgradeCandidate = {
  lines: Array<PlanUpgradeQuoteLine>;
  /** The catalogue plan id this candidate upgrades to. */
  targetTier: Scalars['ID']['output'];
  /** The sum of every selectable line's upliftNowCents, in cents - the ceiling if every eligible standard were selected. The frontend computes the live total from the rows the customer has actually ticked. */
  upliftNowTotalCents: Scalars['Int']['output'];
};

/** Everything the plan page needs: the tenant's owned standards with current tiers, the priced upgrade candidates, the co-terminous renewal date, whether a plan change is already in flight, the current anchor tier, why there are no upgrade candidates (if any), and a pending downgrade election (if any). */
export type PlanUpgradeContext = {
  /** The tenant's current anchor tier (locked #860 decision: the highest tier among purchased standards). */
  anchorTier: Scalars['ID']['output'];
  /** Null when candidates is non-empty. Otherwise a stable code the FE can map to copy, e.g. "NO_PAID_ANCHOR" or "NO_HIGHER_TIER_AVAILABLE". */
  blockedReason?: Maybe<Scalars['String']['output']>;
  /** Empty when the tenant has no live paid subscription anchor to upgrade co-terminously, or is already at the top tier - see blockedReason. */
  candidates: Array<PlanUpgradeCandidate>;
  /** The rate this tenant's inherited multi-year discount actually contracts the Standard tier at PER YEAR (dollars, not cents) - listAnnualRateUsd with that discount applied. Equal to listAnnualRateUsd when no discount applies. */
  contractedAnnualRateUsd?: Maybe<Scalars['Float']['output']>;
  /** The multi-year discount this tenant inherited from its anchor NEW_PERIOD purchase, in basis points. 0 when the anchor carried no discount or there is none to inherit - not the same as null. */
  discountBpsApplied?: Maybe<Scalars['Int']['output']>;
  /** Why the discount applies, e.g. "2-year term" - the anchor order's committed term length. Null when discountBpsApplied is 0. */
  discountReason?: Maybe<Scalars['String']['output']>;
  /** Whether Sales Tax applies to an upgrade this tenant makes, decided server-side from the tenant's stored billing identity - the country on the most recent purchased order that carries one (findLatestBuyerCountry). The change-plan screen cannot change the billing company, so this is never influenced by anything the caller sends; it can only ever reflect what is already on file. Null when nothing is on file yet - not the same as false - which is the case for a tenant whose orders have never recorded a billing identity. */
  gstApplicable?: Maybe<Scalars['Boolean']['output']>;
  /** The Standard tier's undiscounted rate PER YEAR (dollars, not cents) - the reference list rate this page states a contracted rate against. There is no single 'which tier's quote' the way checkout's CheckoutTermsContext has one, so this is always the Standard tier's list price, whichever tiers the tenant's candidates actually offer. */
  listAnnualRateUsd?: Maybe<Scalars['Float']['output']>;
  /** The tenant's live downgrade election, or null. */
  pendingDowngrade?: Maybe<PendingDowngrade>;
  /** True while a plan-change order is between being sent for signature and activating - at most one per tenant. */
  planChangeInFlight: Scalars['Boolean']['output'];
  /** The subscription anniversary every uplift is prorated to. Null without a live paid anchor. */
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
  standards: Array<PlanUpgradeStandardTier>;
  /** The tax rate as a percentage (e.g. 9 for 9%), for DISPLAY only - the tax amount is always computed on the invoice, never here. Null when tax does not apply, when nothing is on file yet, or when no rate is configured; a caller must never render null as zero. */
  taxRatePercent?: Maybe<Scalars['Float']['output']>;
};

/** One per-standard uplift line of an upgrade quote. selectable=true means this standard's current tier is strictly below the candidate's target tier, so the customer may tick it to move it; selectable=false lines are already at or above the target and carry zeroed amounts. */
export type PlanUpgradeQuoteLine = {
  /** What this standard's annual rate rises by at the target tier, in cents, with the inherited discount applied. Zero on a non-selectable line. */
  annualDeltaCents: Scalars['Int']['output'];
  currentTier: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  riskAreaUuid: Scalars['ID']['output'];
  /** True when this standard's current tier is strictly below the candidate's target tier, so it can be selected to move up. */
  selectable: Scalars['Boolean']['output'];
  /** What is charged now, in cents, if this line is selected: the annual delta prorated over the remaining co-terminous term. Zero on a non-selectable line. */
  upliftNowCents: Scalars['Int']['output'];
};

/** One standard the caller's tenant owns, with the plan tier it is currently on. Free/included standards are on the free tier. */
export type PlanUpgradeStandardTier = {
  /** The tenant's most recent Basic Licence acceptance for this framework, or null when there is none - which is the case for a tier Speeki provisioned, and for any framework never taken on the Basic plan by the tenant itself. */
  basicLicenceAcceptance?: Maybe<BasicLicenceAcceptance>;
  /** The catalogue plan id this standard is currently on. */
  currentTier: Scalars['ID']['output'];
  /** True when Speeki granted this tenant the free tier on this framework. Sticky - a later paid purchase does not clear it - because it is what entitles the tenant to elect a downgrade back to free at renewal on a framework the shop does not otherwise sell at that tier. */
  freeTierGranted: Scalars['Boolean']['output'];
  /** The tier staff recorded when they activated this framework for the tenant. Null for a purchased standard, and for a free/included one with nothing recorded (a legacy grant) - currentTier above still falls back to the Basic tier in that case. */
  grantedTier?: Maybe<Entitlement_Tier>;
  name: Scalars['String']['output'];
  ownedSource: Catalogue_Owned_Source;
  riskAreaUuid: Scalars['ID']['output'];
};

/** One of the person's own requests to join a company. */
export type PortalAccessRequest = {
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The administrator's reason, present on a decline. */
  declineReason?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** When the company's administrators are next reminded; null when none is coming. */
  nextReminderAt?: Maybe<Scalars['DateTime']['output']>;
  requestUuid: Scalars['ID']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** PENDING | APPROVED | DECLINED | CANCELLED. */
  status: Scalars['String']['output'];
};

/** The company that has claimed the person's email domain and that the person can ask to join. */
export type PortalDomainOffer = {
  companyName: Scalars['String']['output'];
};

/** One framework a linked company holds, named with the label the shop shows. Not the esg RiskArea: a portal pass carries no platform session, so esg cannot resolve names for it. */
export type PortalFramework = {
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** One company a signed-in person is linked to, with the facts the my.speeki home states about it. */
export type PortalLink = {
  /** The frameworks the company holds, each with its name. */
  activeFrameworks: Array<PortalFramework>;
  companyName?: Maybe<Scalars['String']['output']>;
  /** Whether the person has an Engage seat they can sign in with. */
  engageSeat: Scalars['Boolean']['output'];
  /** The highest plan the company holds a framework on. */
  planName?: Maybe<Scalars['String']['output']>;
  /** ADMINISTRATOR | MEMBER. */
  role: Scalars['String']['output'];
  subscriptionEndsAt?: Maybe<Scalars['DateTime']['output']>;
  tenantUuid: Scalars['ID']['output'];
};

/** A web portal visitor's request for help from Speeki support. Every field is visitor-supplied and untrusted. */
export type PortalSupportRequestInput = {
  /** Where support should reply */
  email: Scalars['String']['input'];
  /** Portal language code */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Must be left empty. */
  leaveBlank?: InputMaybe<Scalars['String']['input']>;
  /** What the visitor needs help with */
  message: Scalars['String']['input'];
  /** The visitor's name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Portal page path the visitor was on, without a query string */
  page?: InputMaybe<Scalars['String']['input']>;
  /** The company portal the visitor is on, when one is selected. The company name is looked up server-side, never taken from the client. */
  tenantUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the presigned case file. */
export type PresignedCaseFile = {
  /** File mime type. */
  mimeType: Scalars['String']['output'];
  /** File name. */
  name: Scalars['String']['output'];
  /** File size (in bytes). */
  size?: Maybe<Scalars['Float']['output']>;
  /** File presigned url. */
  url: Scalars['String']['output'];
  /** File unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the input for presigned case file. */
export type PresignedCaseFileInput = {
  /** Case unique identifier. */
  caseUuid: Scalars['ID']['input'];
  /** File unique identifier. */
  uuid: Scalars['ID']['input'];
};

export type PrimaryContact = {
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** A single, immutable product-provisioning compliance record describing one distinct entitlement delta: actor, item, old/new state, mandatory reason, and its position in the tamper-evident per-scope hash chain. Staff-only (SPEEKI_ADMIN) read surface - never exposed to a tenant-scoped token. */
export type ProductProvisioningHistory = {
  /** Identifier of the actor - or, for actorType=SYSTEM, the system process/job that authored the event. */
  actorId: Scalars['String']['output'];
  /** Who/what authored this delta. */
  actorType: Provisioning_Actor_Type;
  /** N-tenant fan-out set affected by this delta, when scope = GLOBAL/TEMPLATE. */
  affectedTenantUuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Request/trace id shared, non-unique, by every delta emitted by one request. */
  correlationId: Scalars['String']['output'];
  /** Row creation time in this store (set on insert). */
  createdAt: Scalars['DateTime']['output'];
  /** Unique per-delta dedup/idempotency key (one per outbox row). */
  eventId: Scalars['String']['output'];
  /** Event category. */
  eventType: Provisioning_Event_Type;
  /** Identifier of the item acted on. */
  itemId?: Maybe<Scalars['String']['output']>;
  /** Kind of entitlement item this delta acted on. */
  itemType: Provisioning_Item_Type;
  /** Serialized state or payload after the change. */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Business timestamp when the delta occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** Serialized state or payload before the change. */
  oldValue?: Maybe<Scalars['String']['output']>;
  /** Back-reference to the triggering delta's eventId, set on cascaded child events. */
  parentEventId?: Maybe<Scalars['String']['output']>;
  /** SHA-256 rowHash of the previous row in this scope's chain. */
  prevHash?: Maybe<Scalars['String']['output']>;
  /** Mandatory human or synthetic reason for the delta. Never empty. */
  reason: Scalars['String']['output'];
  /** SHA-256 seal of this row, chained on prevHash. */
  rowHash: Scalars['String']['output'];
  /** Whether this delta affects one tenant or a fan-out set. */
  scope: Provisioning_Scope;
  /** Tenant affected, when scope = TENANT. */
  tenantUuid?: Maybe<Scalars['UUID']['output']>;
  /** UUID for this provisioning record. */
  uuid: Scalars['ID']['output'];
};

/** Represents ProductProvisioningHistoryConnection connection. */
export type ProductProvisioningHistoryConnection = {
  /** Array of edges. */
  edges: Array<ProductProvisioningHistoryEdge>;
  /** Array of direct nodes. */
  nodes: Array<ProductProvisioningHistory>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input for paginating/filtering product provisioning history. */
export type ProductProvisioningHistoryConnectionInput = {
  /** Filter by actor id. */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor type. */
  actorTypes?: InputMaybe<Array<Provisioning_Actor_Type>>;
  /** Filter by correlation id (groups every delta of one request). */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by end date (occurredAt). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by item id. */
  itemId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by item type. */
  itemTypes?: InputMaybe<Array<Provisioning_Item_Type>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<ProductProvisioningHistorySortInput>>;
  /** Filter by start date (occurredAt). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by tenant uuid. */
  tenantUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents ProductProvisioningHistory connection edge. */
export type ProductProvisioningHistoryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ProductProvisioningHistory record. */
  node: ProductProvisioningHistory;
};

export type ProductProvisioningHistorySortFields =
  | 'CREATED_AT'
  | 'OCCURRED_AT';

export type ProductProvisioningHistorySortInput = {
  direction: SortDirection;
  field: ProductProvisioningHistorySortFields;
};

/** Program with risk areas that have available questions for user */
export type Program = {
  /** Returns categories with their risk areas associated with this program. */
  category: EsgCategory;
  /** Program description */
  description?: Maybe<Scalars['String']['output']>;
  /** Program name */
  name: Scalars['String']['output'];
  /** Program order */
  order: Scalars['Int']['output'];
  /** Returns risk areas associated with this program. */
  riskAreas: Array<RiskArea>;
  /** Programme UUID */
  uuid: Scalars['UUID']['output'];
};


/** Program with risk areas that have available questions for user */
export type ProgramRiskAreasArgs = {
  input?: ProgramRiskAreasInput;
};

/** Category with its risk areas for programs context */
export type ProgramCategory = {
  /** Category name */
  name: Scalars['String']['output'];
  /** Risk areas in this category */
  riskAreas: Array<RiskArea>;
  /** Category UUID */
  uuid: Scalars['ID']['output'];
};

/** Input for program by uuid */
export type ProgramInput = {
  /** Program UUID */
  uuid: Scalars['UUID']['input'];
};

/** Input for resolving risk areas on Program. */
export type ProgramRiskAreasInput = {
  /** Access mode filter. By default will only resolve risk areas that are enabled by user permissions. */
  accessMode?: Risk_Area_Access_Mode;
  /** Optional flag to include all disabled risk areas. */
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramSettingCategory = {
  /** Category name */
  name: Scalars['String']['output'];
  /** Category uuid */
  uuid: Scalars['UUID']['output'];
};

/** Input for filtering programs with available questions */
export type ProgramsListInput = {
  /** Access mode filter. By default will only resolve programmes that are enabled by user permissions. */
  accessMode?: Risk_Area_Access_Mode;
  /** Filter by category UUIDs (OR logic with riskAreaUuids) */
  categoryUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional flag to include programmes with no frameworks */
  includeNoFramework?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by specific risk area UUIDs (OR logic with categoryUuids) */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Text search - filters by question text, header, navigation title, context */
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the status of the questionnaire */
export type Questionnaire_Status =
  /** Questionnaire has been processed and awaits for review */
  | 'PROCESSED'
  /** Questionnaire is being processed. */
  | 'PROCESSING'
  | 'REVIEW_IN_PROGRESS'
  /** Questionnaire has been processed, review and saved by user. */
  | 'SAVED';

export type Query = {
  /** The signed-in admin's own account, including the access level the portal uses to decide what to show them. */
  adminMe: AdminUserData;
  /** Query for fetching admin user details. Accessible by speeki admins only. */
  adminUser: AdminUserData;
  adminUsers: AdminUserDataConnection;
  /** Every auditor in the caller's firm. */
  amsAuditors: Array<AmsAuditor>;
  /** The signed-in AMS user. */
  amsMe: AmsAuditor;
  /** Returns app version */
  appVersion?: Maybe<Scalars['String']['output']>;
  /** Resolves tag names that were used in answers for given risk areas. */
  assignedTagNames: Array<Scalars['String']['output']>;
  /** Returns paginated assignees. */
  assignees: UserConnection;
  /** Returns paginated assignors. */
  assignors: UserConnection;
  /** Returns the paginated connection of tenants assistant credentials. */
  assistantCredentials: AssistantCredentialsConnection;
  /** Returns the paginated connection of assistant slots. */
  assistantSlots: AssistantSlotConnection;
  auditEvent: AuditEvent;
  auditEvents: AuditEventConnection;
  /** An Audit Ready price: a base fee plus a fee for each further standard. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  auditReadyPrice: SetPriceQuote;
  /** Whether the tenant currently has at least one auditor seat. Drives the visibility of the auditor sign-in option. */
  auditorSeatAvailable: Scalars['Boolean']['output'];
  bannedEmail: BannedEmail;
  /** Query for fetching paginated list of banned email domains. */
  bannedEmails: BannedEmailConnection;
  /** The standing Speeki Engage Basic Licence click-through terms (edition, title and the terms themselves as trusted static HTML), so a tenant can read them before accepting. Public: readable without authentication. Gated by the shop-surface flag. */
  basicLicenceTerms: BasicLicenceTerms;
  /** A Beacon engagement priced from the buyer's scope answers. Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  beaconPrice: EngagementPrice;
  /** The published domains, accreditation options and limits of Beacon, for the inputs screen. Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  beaconRules: BeaconRules;
  /** Returns the paginated connection of business units. */
  businessUnits: BusinessUnitConnection;
  /** Returns the case object based on provided uuid. */
  callsCaseDetails: CallsCase;
  /** A Carbon Lens quote priced from the buyer's scope answers. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  carbonLensPrice: FeeTablePrice;
  /** Object to resolve specific analytics of cases */
  caseAnalytics: CaseAnalytics;
  /**
   * Returns list of incident type anonymity settings grouped by country codes.
   * @deprecated Deprecated in favor of `countryAnonymityValidate`.
   */
  caseAnonymityRestrictions: Array<CaseAnonymityRestrictions>;
  /** Returns the paginated connection of incident type anonymity settings grouped by country codes. */
  caseAnonymitySettings: CaseAnonymityConnection;
  /** Query to list emails sent to an individual involved, newest first. */
  caseIndividualInvolvedEmails: Array<IndividualInvolvedEmail>;
  /** Returns case investigation. */
  caseInvestigation: Case;
  /** Returns paginated connection of case investigations. */
  caseInvestigations: CaseInvestigationConnection;
  /** Query to get parsed email template. */
  caseParsedMessageGet: EmailMessageParsedResponse;
  /** Returns the paginated list of cases reported by employee user. */
  caseReports: CaseReportConnection;
  /** Returns case settings. */
  caseSettings: CaseSettings;
  /** Query for fetching information about chatroom file */
  chatRoomFileInfo: ChatsFile;
  /** Return year data state for tenant. */
  checkYearDataStatus?: Maybe<TenantYearDataState>;
  /** Reads a checkout session by its bearer token. Null if the token is unknown or the session has expired - the two are indistinguishable. Public: unauthenticated. Gated by the shop-surface flag. */
  checkoutSession?: Maybe<CheckoutSessionView>;
  /** The pre-checkout subscription-terms context for a product+plan (NEW_PERIOD term pricing, a CO_TERMINOUS prorated quote, FREE_FOREVER, or a BLOCKED_* reason), plus the server-decided tax signal when buyerCountry is given, and - when a term is chosen - the full payment schedule + master-term summary for the review page. Public: an authenticated tenant admin gets their real, anchor-aware context; anyone else gets the generic NEW_PERIOD term table. A price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  checkoutTermsContext: CheckoutTermsContext;
  /** Query for fetching tenant details. Accessible by speeki admins only. */
  client: AdminTenantData;
  /** Returns client's subsidiary with given name. */
  clientSubsidiarySiteByName?: Maybe<ClientSubsidiarySite>;
  /** Returns paginated connection of client's subsidiary sites */
  clientSubsidiarySites: ClientSubsidiarySitesConnection;
  clientUsers: Array<ClientUser>;
  clients: AdminTenantDataConnection;
  countryAnonymityEnabled: Scalars['Boolean']['output'];
  /** Validate whether case report can be submitted anonymously. */
  countryAnonymityValidate: Scalars['Boolean']['output'];
  /** Returns tenant's custom plan. May not represent tenant's current plan. */
  customPlan?: Maybe<SubscriptionPlan>;
  /** The standing Speeki Customer Agreement (edition, title and the agreement itself as trusted static HTML), so a buyer can read the contract before committing. Public: readable without authentication. Gated by the shop-surface flag. */
  customerAgreement: CustomerAgreement;
  /** Query for fetching category by name */
  dataCategoryByName?: Maybe<DataCategory>;
  /** Query for fetching category by uuid */
  dataCategoryByUuid?: Maybe<DataCategory>;
  /** Resolves paginated connection of data categories. */
  dataCategoryList: DataCategoryConnection;
  dictionaryTranslated: Scalars['JSON']['output'];
  /**
   * Returns the admin disclosure paginated list
   * @deprecated Use disclosureAdminListV2.
   */
  disclosureAdminList: DisclosurePaginated;
  /** v2 pagination supported disclosure list. Due to ORM constraints, currently <strong>OFFSET</strong> pagination is supported */
  disclosureAdminListV2: DisclosureConnection;
  /** Returns a paginated list of disclosure response comments. Available to tenant admins only. */
  disclosureCommentsList: DisclosureCommentsPaginated;
  disclosureDetails: Disclosure;
  /**
   * Returns a paginated list of responses to specific disclosure form created by signed in employee user.
   * @deprecated use disclosureEmployeeUserResponseListV2
   */
  disclosureEmployeeUserResponseList: DisclosureResponsesPaginated;
  disclosureEmployeeUserResponseListV2: DisclosureResponseConnection;
  /** Returns connection of disclosure responders. */
  disclosureResponders: DisclosureUserConnection;
  /**
   * Returns all users' responses for a given disclosure.
   * @deprecated use getAnalyticsResponseListV2 instead
   */
  disclosureResponseAnalyticsList: DisclosureResponsesPaginated;
  /** Returns all users' responses for a given disclosure. */
  disclosureResponseAnalyticsListV2: DisclosureResponseConnection;
  /** Returns Disclosure Response by provided UUID. */
  disclosureResponseByUuid: DisclosureResponse;
  /** @deprecated use disclosureResponseByUuid */
  disclosureResponseDetails: DisclosureResponse;
  /**
   * Returns a list of disclosures available for user.
   * @deprecated New version disclosureUserListV2 exists
   */
  disclosureUserList: DisclosurePaginated;
  disclosureUserListV2: DisclosureConnection;
  /**
   * Returns a paginated list of specific users disclosure responses.
   * @deprecated use getAdminResponseListV2 instead
   */
  disclosureUserResponseList: DisclosureResponsesPaginated;
  /** Returns a paginated list of specific users disclosure responses. */
  disclosureUserResponseListV2: DisclosureResponseConnection;
  /** Returns user disclosure statistics */
  disclosureUserStatistics: UserDisclosureStatistics;
  /** @deprecated Use disclosureUserStatistics. */
  disclosuresUserCount: Scalars['Int']['output'];
  /** Returns details for specific email list given by UUID. */
  emailList: EmailList;
  /**
   * Returns details for specific email list given by UUID.
   * @deprecated Use emailList
   */
  emailListDetails: EmailList;
  /** Returns a list of email lists. */
  emailLists: EmailListConnection;
  /** Resolve activities for activity report */
  esgActivitiesForActivityReport: Array<EsgActivitiesForActivityReport>;
  /** Returns answer by UUID. */
  esgAnswerByUuid: EsgAnswer;
  /** Returns answers to given question */
  esgAnswersByQuestion: Array<EsgAnswer>;
  /** Returns flat array of categories */
  esgCategories: Array<EsgCategory>;
  /** Returns category by given name */
  esgCategoryByName: EsgCategory;
  /** Returns uploaded file. */
  esgFileByUuid: EsgFile;
  /** Returns tenant's uploaded files */
  esgFiles: Array<EsgFile>;
  /** Entries of an audit, newest first, optionally scoped to one requirement. */
  esgFrameworkAuditEntries: Array<EsgFrameworkAuditEntry>;
  /** Smart Fill citations behind a requirement's evidence, for an assigned auditor — the auditor-scoped counterpart of esgSmartFillEvidenceCitations, which only admits client sessions. Empty when the answer was not produced by Smart Fill. */
  esgFrameworkAuditEvidenceCitations: Array<EsgSmartFillDraftCitation>;
  /** The audit’s latest gap-analysis run in any status — null before the first start. */
  esgFrameworkAuditGapRun?: Maybe<EsgFrameworkAuditGapRun>;
  /** Gap suggestions of an audit, newest first, optionally scoped to one requirement. */
  esgFrameworkAuditGapSuggestions: Array<EsgFrameworkAuditGapSuggestion>;
  /** Derived per-audit review rollup (verdict = latest finding per requirement, never stored). */
  esgFrameworkAuditSummary: EsgFrameworkAuditSummary;
  /** Audits for the tenant, optionally scoped to one assessment year. Feeds the client Next-review tile and the auditor landing. */
  esgFrameworkAudits: Array<EsgFrameworkAudit>;
  /** Audits across all tenants for the Speeki-admin Audits tab, newest request first. Defaults to active statuses; optionally filtered by status set and tenant. */
  esgFrameworkAuditsAdmin: Array<EsgFrameworkAuditAdminEntry>;
  /** Framework documents for a framework — list with Smart Fill processing status + "cited in N answers", plus summary stats. */
  esgFrameworkDocuments: EsgFrameworkDocuments;
  esgGroupTagsSelector: EsgGroupTagConnection;
  /** Returns question by given UUID. */
  esgQuestion: EsgQuestion;
  /** Query for files associated with the given question for given year. */
  esgQuestionFiles: Array<EsgFile>;
  /** Returns 3 recent searches for questions by user. Expires after 24 hours. */
  esgQuestionSearchRecent: Array<Scalars['String']['output']>;
  /** Fetches paginated question activities. */
  esgQuestionsActivities: QuestionActivityConnection;
  /** Returns connection of questions for filters page. */
  esgQuestionsSearchConnection: EsgQuestionSearchConnection;
  /**
   * Returns unmapped questions.
   * @deprecated This query is not optimized! Use esgQuestionsUnmappedConnection
   */
  esgQuestionsUnmapped: Array<EsgQuestion>;
  /** Returns connection of unmapped questions. */
  esgQuestionsUnmappedConnection: EsgQuestionConnection;
  /** Citations of the accepted Nicole Smart Fill draft backing a question's current answer (Evidence-tab attribution). */
  esgSmartFillEvidenceCitations: Array<EsgSmartFillDraftCitation>;
  /** Pending Nicole Smart Fill drafts for a framework (row pills + side-panel review). */
  esgSmartFillPendingDrafts: Array<EsgSmartFillPendingDraft>;
  /** Returns question statistics for standards. */
  esgStatistics: Array<EsgGroupedStatistics>;
  /** Resolve steps for given risk areas for audit report. */
  esgStepsForAuditReport: Array<Esg_Step>;
  /** Resolve steps for given risk area that have any questions for user. */
  esgStepsWithAnyQuestions: Array<EsgStep>;
  /**
   * Returns ESG subcategories. Optional input allows for selecting specific subcategories.
   * @deprecated Use riskAreas
   */
  esgSubcategories: Array<EsgSubcategory>;
  /**
   * Returns ESG subcategory by name.
   * @deprecated use riskAreaByName
   */
  esgSubcategoryByName: EsgSubcategory;
  /**
   * Returns ESG subcategory by UUID.
   * @deprecated use riskAreaByUuid
   */
  esgSubcategoryByUuid: EsgSubcategory;
  /** Connection of tags. Cursor pagination is not supported, only limit and offset are supported. */
  esgTagsSelect: TagsSelectConnection;
  /** Returns count of unanswered questions for given risk areas. */
  esgUnansweredQuestionsCount: Scalars['Int']['output'];
  /** Paginated list of ESG questions videos. Resolves only videos that have both url and title. */
  esgVideos: EsgVideoConnection;
  /** Every executive-education course with its duration and fee. Public; prices are answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  execEdCourses: Array<ExecEdCourse>;
  /** An executive-education course quote priced by duration. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  execEdPrice: FeeTablePrice;
  /**
   * Looks for a tenant given by unique tenant company code
   * @deprecated Use getGlobalTenantDataByCode instead
   */
  findGlobalTenantDataByCode: GlobalTenantBaseData;
  /**
   * Looks for tenant with given name in global scope (across all regions).
   * For now has fixed number of returned tenants (20), pagination will be added if needed
   * in other query.
   */
  findGlobalTenantDataByName: Array<GlobalTenantBaseData>;
  /** Full framework catalog, not tenant-scoped. */
  frameworkCatalog: Array<RiskArea>;
  /** ESG categories for the Framework Import category picker (SPEEKI_ADMIN). */
  frameworkImportCategories: Array<FrameworkImportCategoryObject>;
  /** Known frameworks for the Framework Import picker — catalog + per-env categoryUuid + whether already installed (SPEEKI_ADMIN). */
  frameworkImportFrameworks: Array<FrameworkImportFrameworkObject>;
  /** The caller's tenant's pending seat-request queue, optionally narrowed to one framework. */
  frameworkSeatRequests: Array<SeatRequestType>;
  /** Returns a framework's seat roster for the caller's tenant: the current occupants plus the pool's seat/used/remaining counts. */
  frameworkSeatRoster: FrameworkSeatRoster;
  /** Returns generic plan. */
  genericPlan: SubscriptionPlan;
  /** Returns list of generic plans. */
  genericPlans: Array<SubscriptionPlan>;
  /**
   * Returns ways of logging in, which should be shown by frontend for given tenant
   * @deprecated the data is included in getSsoTenantInformation now
   */
  getActiveSsoMethodsForTenant: EnabledSsoMethodsForTenant;
  /**
   * Query for fetching tenant details. Accessible by speeki admins only.
   * @deprecated Use client
   */
  getAdminTenantDetails: AdminTenantData;
  /** Looks for a tenant with unique tenant company code in global scope */
  getGlobalTenantDataByCode: GlobalTenantBaseData;
  /** Looks for a tenant with unique microsoft tenant id */
  getGlobalTenantDataByMicrosoftTenantId: GlobalTenantBaseData;
  /** Looks for a tenant for given reportingSlug in global scope */
  getGlobalTenantDataByReportingSlug: GlobalTenantBaseData;
  /** Looks for a tenant with given UUID in global scope */
  getGlobalTenantDataByUuid: GlobalTenantBaseData;
  /** Returns minimum supported mobile app versions */
  getMinimumSupportedMobileAppVersions: SupportedMobileAppVersions;
  /** Query for fetching current topics user is subscribed to. Requires user to be signed in. */
  getMyNotificationTopics: Array<FirebaseTopicSubscription>;
  /**
   * Returns Saml request details for a specific tenant
   * @deprecated Use resolved field on TenantBaseDataType.ssoSamlRequestUrl instead
   */
  getSamlRequestDetailsForTenant: TenantSamlRequestDetails;
  /** @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant */
  getSsoTenantInformation: SsoTenantInformation;
  /** Returns tenant based on given CompanyCode. Throws an error when tenant cannot be found. */
  getTenantByCompanyCode: TenantBaseDataType;
  /** Returns tenant based on given UUID. Throws an error when tenant cannot be found. */
  getTenantByUuid: TenantBaseDataType;
  /** Query for fetching current number of unread notifications of logged in user. */
  getUnreadNotificationCount: Scalars['Float']['output'];
  /** Returns user for given uuid. */
  getUserByUuid: UserType;
  /** List glossary entries */
  glossary: GlossaryConnection;
  /** Export existing glossary entries into markdown */
  glossaryMarkdown: Scalars['String']['output'];
  /** A GreenDesk plan priced from the claim reviews expected a year; above the top plan it is bespoke. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  greenDeskPrice: SetPriceQuote;
  /** Returns group tag for given identifier. */
  groupTag: GroupTag;
  /** Returns paginated connection of group tags. For speeki admins returns public group tags only. */
  groupTags: GroupTagConnection;
  /** Returns list of distinct group tag names. For speeki admin returns public group tags, for tenant admins returns public and tenant group tags. */
  groupTagsNameSearch: Array<Scalars['String']['output']>;
  groupTagsRows: GroupTagRowConnection;
  /** A Guardian quote priced from the buyer's scope answers. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  guardianPrice: FeeTablePrice;
  /** Query for fetching paginated list of guidelines. Accessible to Speeki Admin only. */
  guidelines: GuidelineConnection;
  /** Returns all guidelines from given uuids. */
  guidelinesByUuids: Array<Guideline>;
  /** Get the unique names of the guideline categories */
  guidelinesCategoriesNames: Array<Scalars['String']['output']>;
  /** Query for fetching paginated list of guidelines for programme. */
  guidelinesForProgramme: GuidelineConnection;
  /** A previously held price, or a typed expired result - which is also what a price held by someone else looks like. Public. Gated by the shop-surface flag. */
  heldQuote: HeldQuote;
  /** Returns the paginated connection of incidentType. */
  incidentTypes: IncidentTypeConnection;
  industryUnits: IndustryUnitConnection;
  /** @deprecated Please use `caseInvestigation` query instead. */
  investigationCaseDetails: CaseInvestigation;
  /** An ISO management-system certification priced from the buyer's answers, exactly as Speeki's published rules state it. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  isoCertificationPrice: IsoCertificationPrice;
  /** The published pricing rules of one ISO certification, for the inputs screen. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  isoCertificationRules: IsoCertificationRules;
  knowledgeLibraryExamples: KnowledgeLibraryAssets;
  /** Query for fetching paginated connection  */
  knowledgeLibraryList: KnowledgeLibraryQuestionConnection;
  /** Returns all tags connected to the risk area or standard. When tags related to standard are fetched the tags originated from other entities are also fetched whenever they are used together with the standard tag. When some standard is provided simultaneously in `standardUuids` and `excludeRiskAreaOrStandardUuids` the standard tags are not fetch though tags originated from other entities used with given standard tags are still fetched. */
  linkedTags: EsgTagConnection;
  /** Returns notifications for logged in user as a paginated list */
  listNotifications: NotificationPaginated;
  /** Returns current user data. */
  me: UserType;
  /** Get metric by uuid */
  metricByUuid: Metric;
  /** Get metric data by metric uuid and year */
  metricDataByMetricUuidAndYear: MetricData;
  /** Get metric data by uuid */
  metricDataByUuid: MetricData;
  /**
   * Returns the paginated connection of metrics data column names
   * @deprecated Column selector is not used in new flow.
   */
  metricDataColumnsList: Array<MetricDataColumnSelector>;
  /**
   * Returns the paginated connection of metrics data rows & subrows names
   * @deprecated Row selector is not used in new flow.
   */
  metricDataRowSelect: Array<MetricDataSelector>;
  /** Returns an array of objects representing years that have defined metrics data. */
  metricDataYears: Array<MetricDataYear>;
  /** Returns the paginated connection of metrics, by default sorted by name ascending */
  metricList: MetricConnection;
  /** Fetch list of metric owners */
  metricOwners: Array<UserType>;
  /** Lists outstanding (not yet re-added) missed provisioning-history emits, oldest first. Staff-only (SPEEKI_ADMIN). */
  missedProvisioningEmits: Array<MissedProvisioningEmit>;
  /** The person's own requests to join a company, newest first, each with the date the administrators are next reminded. Gated by the join-by-domain flag. */
  myAccessRequests: Array<PortalAccessRequest>;
  /** Up to three frameworks the caller's tenant does not hold yet, each with the fact behind it: the same catalogue family as something they already run (PAIRS_WITH), or Speeki's own standing pick (SPEEKI_PICK). Nothing on the rail is derived from other customers' data. Frameworks the tenant already holds, has raised an order for in the past year, or has had an approval request declined for in the past year are excluded. Fewer than three slots - including none - is a normal answer. The tenant is taken from the caller's token; there is no tenant argument. Gated by the shop-surface flag. */
  myAvailableToAdd: Array<AvailableToAddSlot>;
  /** The caller tenant's recorded billing identity - entity name, address, buyer country, registered-office facts and invoice recipient - from its most recent order that carries one. The prefill source for every order after the first. Requires the company-settings permission; a caller without it gets null. The tenant is taken from the caller's token - there is no tenant argument. Gated by the shop-surface flag. */
  myBillingIdentity?: Maybe<BillingIdentity>;
  /** The facts of a company the person is linked to. Answers only for a company the signed-in person is linked to; seat figures are not part of it. Gated by the shop-surface flag. */
  myClientHoldings: PortalLink;
  /** The company that claimed the person's email domain, when the person is not yet linked to it and has no open request for it. Gated by the join-by-domain flag. */
  myDomainOffer?: Maybe<PortalDomainOffer>;
  myEntitlements?: Maybe<TenantEntitlements>;
  /** The signed-in person's held prices bound to the proved address, not expired, newest first, at most 20. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  myHeldQuotes: Array<HeldQuote>;
  /** One of the caller's own raised invoices, as a downloadable PDF. `ref` is CustomerInvoice.ref, from myInvoices. A ref that isn't one of the caller's own rows, or names a row that isn't downloadable (see CustomerInvoice.downloadable - read that field rather than inferring it from `kind`), fails clearly rather than returning a document. Gated by the shop-surface flag. */
  myInvoicePdf: CustomerInvoicePdf;
  /** The caller tenant's own invoice history: every invoice raised, and every billing record this view cannot honestly price (kind RECORD_ONLY - contact support for detail; never an amount owed), rows newest due date first. Only invoices that exist - a year the signed term still owes has not been invoiced and is not listed here; read Order.commitment for the term and each year's amount. `truncated` is true when the history has hit its cap, so older invoices are missing - see CustomerInvoiceHistory.truncated. The tenant is taken from the caller's token - there is no tenant argument. A caller without the company-settings permission gets an empty, untruncated history, since a partial invoice history would read as a complete one. Gated by the shop-surface flag. */
  myInvoices: CustomerInvoiceHistory;
  /** The caller tenant's own purchased orders (signed and beyond), newest first, capped at the 50 most recent. The tenant is taken from the caller's token - there is no tenant argument. Unfinished and cancelled orders are excluded: this answers 'what have we bought?'. Gated by the shop-surface flag. */
  myOrders: Array<Order>;
  /** Every company the signed-in person is linked to, with their role, Engage seat and the company's facts. Gated by the shop-surface flag. */
  myPortalLinks: Array<PortalLink>;
  /** The public shop catalogue augmented with which products the caller tenant already owns, derived from the shop's own orders. Open to any tenant staff caller (tenant admin or employee) - browsing is not buying. Gated by the shop-surface flag. */
  myShopCatalogue: ShopCatalogue;
  /** The caller tenant's unfinished (DRAFT / AWAITING_SIGNATURE) orders, newest first, capped at 50 - a holder of the company-settings permission sees the whole tenant's, everyone else sees only their own. Gated by the shop-surface flag. */
  myUnfinishedOrders: Array<UnfinishedOrder>;
  /** Retrieve a NicoleGPT session by its UUID. */
  nicoleGptSession: NicoleGptSession;
  /** Retrieve NicoleGPT sessions for the current user. */
  nicoleGptSessions: NicoleGptSessionConnection;
  /** Query to return OAuth client by uuid */
  oAuthClientByUuid: OAuthClient;
  /** Query to return paginated OAuth clients list */
  oAuthClientList?: Maybe<OAuthClientConnection>;
  /** Read one of the caller tenant's orders by uuid. */
  order?: Maybe<Order>;
  /** One order's event timeline, chronological oldest-first, capped at the 200 most recent transitions (staff read). Gated by the shop-surface flag. */
  orderEvents: Array<OrderEvent>;
  /** One order's contracted schedule, signer, and event history (staff read). Reuses the buyer-facing schedule builder and the live Xero read - never recomputed. Gated by the shop-surface flag. */
  orderScheduleDetail?: Maybe<StaffOrderScheduleDetail>;
  /** A Partner Integrity assessment priced from the buyer's scope answers. Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  partnerIntegrityPrice: EngagementPrice;
  /** The published domains, report levels and limits of Partner Integrity, for the inputs screen. Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  partnerIntegrityRules: PartnerIntegrityRules;
  /** The caller tenant's plan page: owned standards with current tiers, priced upgrade candidates (per-standard uplift lines, prorated co-terminously), the renewal date, and whether a plan change is in flight. Gated by the shop-surface flag. */
  planUpgradeContext: PlanUpgradeContext;
  /** Staff-only (SPEEKI_ADMIN) read of the tamper-evident product provisioning history. Filterable by tenant/item/actor/date/correlationId. */
  productProvisioningHistory: ProductProvisioningHistoryConnection;
  /** Returns a program by its UUID. */
  program: Program;
  /** Returns risk areas grouped by categories. Only includes risk areas with available questions for the current user. */
  programRiskAreasByCategory: Array<ProgramCategory>;
  programSettings: EsgTenantProgramSettings;
  /** Returns list of programs. */
  programsList: Array<Program>;
  /** Count how many of the filtered questions are already linked to a specific metric. Uses the same filters as questionSearchRiskAreas. */
  questionSearchLinkedCount: QuestionSearchLinkedCount;
  /** Search for risk areas with step summaries (counts only). Use questionSearchStepQuestions to fetch actual questions for a specific step. */
  questionSearchRiskAreas: Array<QuestionSearchRiskArea>;
  /** Fetch questions for a specific risk area grouped into steps (no pagination). Filters match questionSearchRiskAreas except riskAreaUuids (riskAreaUuid is required here). */
  questionSearchSteps: Array<QuestionSearchStep>;
  /** Query to get questionnaire filters */
  questionnaireFilters?: Maybe<QuestionnaireFilter>;
  questionnaireNavigation: QuestionnaireNavigation;
  questionnaireNavigationQuestions: Array<QuestionnaireNavigationStep>;
  /** A RatingsReady engagement priced from the buyer's scope answers. Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  ratingsReadyPrice: EngagementPrice;
  /** The published platforms, size bands and terms of RatingsReady, for the inputs screen. Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  ratingsReadyRules: RatingsReadyRules;
  /** Returns currently published release note, if there is one published for TENANT_ADMIN user. Returns release note for SPEEKI_ADMIN */
  releaseNote?: Maybe<ReleaseNote>;
  reportAudiences: Array<ReportAudience>;
  /** Returns the case details of the reported case. */
  reportCaseDetails: CaseReportSummaryResponse;
  /** Returns the case details for Guest user without access token by caseId and pinCode. */
  reportCaseDetailsUnlogged: CaseReportSummaryResponse;
  /**
   * Returns paginated list of case owner users which could be excluded case management.
   * @deprecated Use reportCaseExclusionOwner which supports pagination v2.
   */
  reportCaseExclusionOwnerList: CaseExclusionOwnerListPaginated;
  /** Returns the paginated connection of case owner exclusion users. */
  reportCaseExclusionOwners: ExclusionAdminUserConnection;
  /**
   * Returns the paginated list of cases reported by employee user.
   * @deprecated Deprecated in favor of `caseReports`.
   */
  reportCases: CaseReportConnection;
  /**
   * Returns the statistics for the reported cases (related to `Employee` user type).
   * @deprecated Deprecated in favor of `statistics` field added to
   */
  reportCasesStatistics: CaseReportStatistics;
  /** Returns the reported case file object with presigned url based on provided identifier. */
  reportPresignedCaseFile: PresignedCaseFile;
  /** Get report prompt template by UUID. */
  reportPromptTemplateByUuid: ReportPromptTemplate;
  /** Paginated list of report prompt templates. */
  reportsPromptsTemplates: ReportPromptTemplateConnection;
  /**
   * Query for querying specific questionnaire by it's identifier
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaire?: Maybe<RespondQuestionnaire>;
  /**
   * Resolves all questionnaire's entries as CSV formatted string.
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireEntriesCsv: Scalars['String']['output'];
  /**
   * Query for querying paginated list of questionnaire entries.
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireEntriesList: RespondQuestionnaireEntryConnection;
  /**
   * Query for querying specific entry by it's identifier
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireEntry?: Maybe<RespondQuestionnaireEntry>;
  /**
   * Query for querying paginated list of questionnaires.
   * @deprecated This mutation uses old respond flow. Please migrate to new flow once availible.
   */
  respondQuestionnaireList: RespondQuestionnaireConnection;
  /** Query for querying paginated list of questionnaire entries. */
  respondQuestionnaireV2Entries: QuestionnaireEntryConnection;
  respondQuestionnaireV2GetByUuid: RespondQuestionnaireV2;
  /** Resolves paginated list of questionnaires. */
  respondQuestionnairesV2: RespondQuestionnaireV2Connection;
  /** Returns RiskAreas by activity. */
  riskAreaByActivity: Array<RiskArea>;
  /** Returns RiskArea by name. */
  riskAreaByName: RiskArea;
  /** Returns RiskArea  by UUID. */
  riskAreaByUuid: RiskArea;
  riskAreaSettingsByProgram: EsgRiskAreaSettingsByProgram;
  riskAreas: Array<RiskArea>;
  riskAreasWithAnyQuestions: Array<RiskAreasWithAnyQuestionsElement>;
  /** Get role by UUID. */
  roleByUuid: Role;
  /** Paginated list of roles. */
  roles: RoleConnection;
  /** Returns a sector by its UUID */
  sectorByUuid: Sector;
  /** The published set prices and the lists the set-price forms render (Speeki Certification, Audit Ready, GreenDesk). Public; answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  setPriceRules: SetPriceRules;
  /** The caller tenant's approval-request queue, newest first, capped at 100 - a holder of the company-settings permission sees the whole tenant's, everyone else sees only their own. Open to any tenant staff caller (tenant admin or employee). Gated by the shop-surface flag. */
  shopApprovalRequests: Array<ShopApprovalRequest>;
  /** The public, sellable Speeki Engage catalogue - names always answer; a price is answered only with a valid pass while the price-access flag is on. Returns null while the shop surface feature flag is off. */
  shopCatalogue?: Maybe<ShopCatalogue>;
  /** Shop service health marker. Returns a disabled marker while the shop surface feature flag is off. */
  shopHealth: Scalars['String']['output'];
  /** Lists open Smart Fill jobs for the current tenant (same SmartFillJob type as smartFillJob; excludes APPLIED and FAILED). */
  smartFillActiveJobs: Array<SmartFillJob>;
  /** Returns Smart Fill job status and drafts (single query for polling until completed). */
  smartFillJob: SmartFillJob;
  /** Non-retryable files Smart Fill has proven it cannot read, for greying out in the document picker. */
  smartFillUnreadableFiles: Array<SmartFillUnreadableFile>;
  /** A Speeki Certification (ISO 37002 / ISO 37008) set price. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  speekiCertPrice: SetPriceQuote;
  /** Speeki's standing pick: the one framework the shop leads with, as staff configured it (staff read). Null when no pick has been set. A pick outside its window is still returned, with `live` false - nothing is featured then, and the My Frameworks rail simply renders fewer slots. Gated by the shop-surface flag. */
  speekiPick?: Maybe<SpeekiPick>;
  /** A SPK certification priced from the buyer's answers, exactly as Speeki's published rules state it. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  spkCertificationPrice: SpkCertificationPrice;
  /** The published pricing rules of one SPK certification, for the inputs screen. Public; a price is answered only with a valid pass while the price-access flag is on. Gated by the shop-surface flag. */
  spkCertificationRules: SpkCertificationRules;
  /** Fetch stakeholder engagement records */
  stakeholderEngagementList: StakeholderEngagementConnectionConnection;
  /** Resolves risk areas assgined to given standard. */
  standardAssignedRiskAreas: StandardAssignedRiskAreasConnection;
  /** Resolves enabled units for standard. */
  standardEnabledUnits: Array<Unit>;
  standardsWithConnectedRiskAreas: Array<EsgStandardWithConnectedRiskAreas>;
  /** Returns static translations for given source. */
  staticTranslations: Scalars['JSON']['output'];
  /** The caller tenant's subscription term: when it ends, whether it renews by itself and for how long, and any notice of non-renewal on file. Gated by the shop-surface flag. */
  subscriptionTerm: SubscriptionTerm;
  /** Returns subsidiary given by UUID */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Returns paginated connection of subsidiary sites for currently signed in tenant. */
  subsidiarySites: SubsidiarySitesConnection;
  /**
   * Returns the tenant admin survey paginated list.
   * @deprecated use surveyAdminListV2
   */
  surveyAdminList: SurveyPaginated;
  /** Returns connection of surveys */
  surveyAdminListV2: SurveyConnection;
  /**
   * Returns the tenant admin survey paginated list found by name and description
   * @deprecated use surveyAdminListV2
   */
  surveyAdminSearchList: SurveyPaginated;
  /** Returns paginated list of survey responses with attached original survey object. */
  surveyResponseList: SurveyResponsePaginated;
  /**
   * Returns the survey template details based on provided `uuid` identifier.
   * @deprecated Use templateDetails
   */
  surveyTemplateDetails: SurveyTemplate;
  /**
   * Returns the survey template paginated list.
   * @deprecated Use template list.
   */
  surveyTemplateList: SurveyTemplatePaginated;
  /**
   * Returns the user or guest survey paginated list.
   * @deprecated use surveyUserListV2
   */
  surveyUserList: SurveyPaginated;
  surveyUserListV2: SurveyConnection;
  /** Returns the survey details based on provided `uuid` identifier. */
  surveysDetails?: Maybe<Survey>;
  /** Get unit by uuid */
  symbolByUuid: Symbol;
  /** Returns the paginated connection of symbols, by default sorted by name ascending */
  symbolList: SymbolConnection;
  /** Returns tag for given identifier. Speeki Admin may access public tags, tenant admin public or tenant's tags. */
  tag: Tag;
  tags: TagConnection;
  tagsNameSearch: Array<Scalars['String']['output']>;
  /** Get target by uuid */
  targetByUuid: Target;
  /** Returns the paginated connection of targets */
  targetList: TargetConnection;
  /** Returns task by its id. */
  taskByUuid: Task;
  /** Returns array of task names */
  taskNameHints: TaskNameHintConnection;
  /** Returns paginated connection of tasks. */
  tasks: TaskConnection;
  /** Query to get a paginated list of taxonomies */
  taxonomies: TaxonomyConnection;
  /** Query to get a taxonomy by UUID */
  taxonomy: Taxonomy;
  /** Get a taxonomy concept by UUID */
  taxonomyConcept: TaxonomyConcept;
  /** Query to get a paginated list of taxonomy concepts */
  taxonomyConcepts: TaxonomyConceptConnection;
  /** Get a taxonomy report by UUID */
  taxonomyReport: TaxonomyReport;
  /** Get a taxonomy fact by its UUID. */
  taxonomyReportFact: TaxonomyReportFact;
  /** Get a paginated connection of taxonomy report facts. */
  taxonomyReportFacts: TaxonomyReportFactConnection;
  /** Query to get a taxonomy report page */
  taxonomyReportPage: TaxonomyReportPage;
  /** Query to search taxonomy report pages containing given phrase */
  taxonomyReportPages: Array<TaxonomyReportPage>;
  /** Query to get a paginated list of taxonomy reports */
  taxonomyReports: TaxonomyReportConnection;
  /** Returns the template details based on provided `uuid` identifier. */
  templateDetails: Template;
  /** Returns the paginated connection of templates */
  templateList: TemplateConnection;
  /** Returns tenant for current user. */
  tenant: TenantBaseDataType;
  /** Returns the paginated connection of tenant admins. */
  tenantAdmins: UserTypeConnection;
  /** The caller's tenant-wide framework seat overview: one row per framework the tenant holds seats for (or has occupants in), with capacity, usage and whether the caller occupies a seat. Counts only - occupant identities require frameworkSeatRoster. */
  tenantFrameworkSeatOverview: Array<FrameworkSeatPoolOverview>;
  /** The caller's tenant-wide Smart Fill entitlements: one row per framework the tenant has a recorded entitlement for. A framework with no row has not been decided - consumers must not read its absence as a refusal. */
  tenantFrameworkSmartFillEntitlements: Array<FrameworkSmartFillEntitlement>;
  /** A tenant's orders, newest first, capped at the 50 most recent (staff read). Gated by the shop-surface flag. */
  tenantOrders: Array<Order>;
  /**
   * Returns the risk area settings for a tenant scoped by a standard grouped by category
   * @deprecated Risk areas should be resolved per programme.
   */
  tenantRiskAreaSettings: TenantRiskAreaSettings;
  /** The companies the daily run would switch off right now, whether or not switch-off is turned on. Changes nothing. Speeki Admin only. */
  tenantSwitchOffPreview: Array<TenantSwitchOffPreview>;
  /** Resolves number of unmapped questions, including breakdown per Standard. */
  unmappedQuestionsCount: UnmappedQuestionStatistics;
  /** Returns array of tags that are used in answers that also use enabled tags from provided standard. */
  usedCustomTags: Array<Tag>;
  /**
   * Returns user disclosure statistics
   * @deprecated Use disclosureUserStatistics
   */
  userDisclosureStatistics: UserDisclosureStatistics;
  /** Validate if a company with provided name and account with provided email can be created, return true if valid, error otherwise */
  validateEmailTenantName: Scalars['Boolean']['output'];
  /** Verifies registration code from user confirmation email */
  verifyRegistrationCode: Scalars['String']['output'];
  /** An object that expose the Webflow API */
  webflow: Webflow;
  /** Return tenant's years */
  years?: Maybe<YearConnection>;
};


export type QueryAdminUserArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryAdminUsersArgs = {
  input?: InputMaybe<AdminUsersConnectionInput>;
};


export type QueryAssignedTagNamesArgs = {
  riskAreaUuids: Array<Scalars['UUID']['input']>;
};


export type QueryAssigneesArgs = {
  input?: InputMaybe<UserConnectionInput>;
};


export type QueryAssignorsArgs = {
  input?: InputMaybe<UserConnectionInput>;
};


export type QueryAssistantCredentialsArgs = {
  input: AssistantCredentialsConnectionInput;
};


export type QueryAssistantSlotsArgs = {
  input?: InputMaybe<AssistantSlotConnectionInput>;
};


export type QueryAuditEventArgs = {
  input: AuditEventGetInput;
};


export type QueryAuditEventsArgs = {
  input?: AuditEventConnectionInput;
};


export type QueryAuditReadyPriceArgs = {
  input: AuditReadyPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuditorSeatAvailableArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type QueryBannedEmailArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryBannedEmailsArgs = {
  input?: BannedEmailConnectionInput;
};


export type QueryBeaconPriceArgs = {
  input: BeaconPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBeaconRulesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBusinessUnitsArgs = {
  input?: InputMaybe<BusinessUnitConnectionInput>;
};


export type QueryCallsCaseDetailsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCarbonLensPriceArgs = {
  input: CarbonLensPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaseAnonymitySettingsArgs = {
  input?: InputMaybe<CaseAnonymityConnectionInput>;
};


export type QueryCaseIndividualInvolvedEmailsArgs = {
  input: CaseIndividualInvolvedEmailsInput;
};


export type QueryCaseInvestigationArgs = {
  input: CaseInvestigationGetInput;
};


export type QueryCaseInvestigationsArgs = {
  input?: InputMaybe<CaseInvestigationConnectionInput>;
};


export type QueryCaseParsedMessageGetArgs = {
  input: CaseEmailMessageParseRequestInput;
};


export type QueryCaseReportsArgs = {
  input?: InputMaybe<CaseReportsInput>;
};


export type QueryChatRoomFileInfoArgs = {
  fileUuid: Scalars['String']['input'];
};


export type QueryCheckYearDataStatusArgs = {
  input: YearDataStatusInput;
};


export type QueryCheckoutSessionArgs = {
  token: Scalars['String']['input'];
};


export type QueryCheckoutTermsContextArgs = {
  buyerCountry?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  term?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type QueryClientSubsidiarySiteByNameArgs = {
  name: Scalars['String']['input'];
  tenantUuid: Scalars['String']['input'];
};


export type QueryClientSubsidiarySitesArgs = {
  input: ClientSubsidiarySiteConnectionInput;
};


export type QueryClientUsersArgs = {
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  tenantUuid: Scalars['String']['input'];
};


export type QueryClientsArgs = {
  input?: InputMaybe<AdminTenantConnectionInput>;
};


export type QueryCountryAnonymityValidateArgs = {
  input: CountryAnonymityValidateInput;
};


export type QueryCustomPlanArgs = {
  tenantUuid: Scalars['ID']['input'];
};


export type QueryDataCategoryByNameArgs = {
  input: DataCategoryByNameInput;
};


export type QueryDataCategoryByUuidArgs = {
  input: DataCategoryByUuidInput;
};


export type QueryDataCategoryListArgs = {
  input?: DataCategoryConnectionInput;
};


export type QueryDictionaryTranslatedArgs = {
  input: DictionaryTranslationInput;
};


export type QueryDisclosureAdminListArgs = {
  disclosureFilterInput?: InputMaybe<DisclosureFilterInput>;
  orderInput?: InputMaybe<DisclosureOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  textQueryInput?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDisclosureAdminListV2Args = {
  input?: InputMaybe<DisclosureAdminListConnectionInput>;
};


export type QueryDisclosureCommentsListArgs = {
  disclosureResponseUuid: Scalars['String']['input'];
  orderInput?: InputMaybe<DisclosureCommentOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QueryDisclosureDetailsArgs = {
  disclosureUuid: Scalars['String']['input'];
};


export type QueryDisclosureEmployeeUserResponseListArgs = {
  disclosureUuid: Scalars['String']['input'];
  orderInput?: InputMaybe<DisclosureResponseOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QueryDisclosureEmployeeUserResponseListV2Args = {
  input?: InputMaybe<DisclosureResponseConnectionInput>;
};


export type QueryDisclosureRespondersArgs = {
  input: DisclosureRespondersConnectionInput;
};


export type QueryDisclosureResponseAnalyticsListArgs = {
  disclosureUuid: Scalars['String']['input'];
  orderInput?: InputMaybe<DisclosureResponseOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QueryDisclosureResponseAnalyticsListV2Args = {
  input?: InputMaybe<DisclosureResponseConnectionInput>;
};


export type QueryDisclosureResponseByUuidArgs = {
  responseUuid: Scalars['UUID']['input'];
};


export type QueryDisclosureResponseDetailsArgs = {
  responseUuid: Scalars['String']['input'];
};


export type QueryDisclosureUserListArgs = {
  orderInput?: InputMaybe<DisclosureUserOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  textQueryInput?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDisclosureUserListV2Args = {
  input?: InputMaybe<DisclosureUserConnectionInput>;
};


export type QueryDisclosureUserResponseListArgs = {
  disclosureUuid: Scalars['String']['input'];
  orderInput?: InputMaybe<DisclosureResponseOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  userUuid: Scalars['String']['input'];
};


export type QueryDisclosureUserResponseListV2Args = {
  input?: InputMaybe<DisclosureResponseAdminConnectionInput>;
};


export type QueryEmailListArgs = {
  listUUID: Scalars['UUID']['input'];
};


export type QueryEmailListDetailsArgs = {
  listUUID: Scalars['String']['input'];
};


export type QueryEmailListsArgs = {
  input?: InputMaybe<EmailListConnectionInput>;
};


export type QueryEsgAnswerByUuidArgs = {
  answerUuid: Scalars['UUID']['input'];
};


export type QueryEsgAnswersByQuestionArgs = {
  input?: EsgQuestionAnswersInput;
  questionUuid: Scalars['UUID']['input'];
};


export type QueryEsgCategoriesArgs = {
  input?: EsgCategoriesInput;
  name?: InputMaybe<Array<Esg_Category>>;
};


export type QueryEsgCategoryByNameArgs = {
  name: Esg_Category;
};


export type QueryEsgFileByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryEsgFrameworkAuditEntriesArgs = {
  input: EsgFrameworkAuditEntriesInput;
};


export type QueryEsgFrameworkAuditEvidenceCitationsArgs = {
  input: EsgFrameworkAuditEvidenceCitationsInput;
};


export type QueryEsgFrameworkAuditGapRunArgs = {
  input: EsgFrameworkAuditGapRunInput;
};


export type QueryEsgFrameworkAuditGapSuggestionsArgs = {
  input: EsgFrameworkAuditGapSuggestionsInput;
};


export type QueryEsgFrameworkAuditSummaryArgs = {
  auditUuid: Scalars['UUID']['input'];
};


export type QueryEsgFrameworkAuditsArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEsgFrameworkAuditsAdminArgs = {
  statuses?: InputMaybe<Array<Framework_Audit_Status>>;
  tenantUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEsgFrameworkDocumentsArgs = {
  input: EsgFrameworkDocumentsInput;
};


export type QueryEsgGroupTagsSelectorArgs = {
  input?: EsgGroupTagConnectionInput;
};


export type QueryEsgQuestionArgs = {
  uuid: Scalars['UUID']['input'];
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEsgQuestionFilesArgs = {
  input: EsgQuestionFilesInput;
};


export type QueryEsgQuestionsActivitiesArgs = {
  input?: InputMaybe<QuestionActivityConnectionInput>;
};


export type QueryEsgQuestionsSearchConnectionArgs = {
  input?: EsgQuestionConnectionSearchInput;
};


export type QueryEsgQuestionsUnmappedArgs = {
  input?: InputMaybe<EsgQuestionsInput>;
};


export type QueryEsgQuestionsUnmappedConnectionArgs = {
  input?: EsgQuestionConnectionInput;
};


export type QueryEsgSmartFillEvidenceCitationsArgs = {
  input: EsgSmartFillEvidenceCitationsInput;
};


export type QueryEsgSmartFillPendingDraftsArgs = {
  input: EsgSmartFillPendingDraftsInput;
};


export type QueryEsgStatisticsArgs = {
  input?: InputMaybe<EsgStatisticsInput>;
};


export type QueryEsgStepsForAuditReportArgs = {
  input: EsgStepsForAuditReportInput;
};


export type QueryEsgStepsWithAnyQuestionsArgs = {
  input: EsgStepsWithAnyQuestionsInput;
};


export type QueryEsgSubcategoriesArgs = {
  names?: InputMaybe<Array<Esg_Subcategory>>;
};


export type QueryEsgSubcategoryByNameArgs = {
  name: Esg_Subcategory;
};


export type QueryEsgSubcategoryByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryEsgTagsSelectArgs = {
  input: TagsSelectConnectionInput;
};


export type QueryEsgUnansweredQuestionsCountArgs = {
  input?: InputMaybe<EsgUnansweredQuestionsCountInput>;
};


export type QueryEsgVideosArgs = {
  input?: InputMaybe<EsgVideoConnectionInput>;
};


export type QueryExecEdCoursesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExecEdPriceArgs = {
  input: ExecEdPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindGlobalTenantDataByCodeArgs = {
  companyCode: Scalars['String']['input'];
};


export type QueryFindGlobalTenantDataByNameArgs = {
  inputFilters: FindGlobalTenantDataByNameInput;
};


export type QueryFrameworkSeatRequestsArgs = {
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryFrameworkSeatRosterArgs = {
  riskAreaUuid: Scalars['UUID']['input'];
};


export type QueryGenericPlanArgs = {
  plan: Subscription_Plan;
};


export type QueryGetActiveSsoMethodsForTenantArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type QueryGetAdminTenantDetailsArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type QueryGetGlobalTenantDataByCodeArgs = {
  companyCode: Scalars['String']['input'];
};


export type QueryGetGlobalTenantDataByMicrosoftTenantIdArgs = {
  microsoftTenantId: Scalars['String']['input'];
};


export type QueryGetGlobalTenantDataByReportingSlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetGlobalTenantDataByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetSamlRequestDetailsForTenantArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type QueryGetTenantByCompanyCodeArgs = {
  companyCode: Scalars['String']['input'];
};


export type QueryGetTenantByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryGetUserByUuidArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryGlossaryArgs = {
  input: GlossaryConnectInput;
};


export type QueryGreenDeskPriceArgs = {
  input: GreenDeskPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupTagArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryGroupTagsArgs = {
  input?: InputMaybe<GroupTagConnectionInput>;
};


export type QueryGroupTagsNameSearchArgs = {
  input?: InputMaybe<GroupTagNameSearchInput>;
};


export type QueryGroupTagsRowsArgs = {
  input?: GroupTagRowConnectionInput;
};


export type QueryGuardianPriceArgs = {
  input: GuardianPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGuidelinesArgs = {
  input?: InputMaybe<GuidelineConnectionInput>;
};


export type QueryGuidelinesByUuidsArgs = {
  input: GuidelineInput;
};


export type QueryGuidelinesCategoriesNamesArgs = {
  input: GuidelinesCategoriesNamesInput;
};


export type QueryGuidelinesForProgrammeArgs = {
  input?: InputMaybe<GuidelineForProgrammePaginationInput>;
};


export type QueryHeldQuoteArgs = {
  id: Scalars['ID']['input'];
  pass?: InputMaybe<Scalars['String']['input']>;
  proof?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIncidentTypesArgs = {
  input?: InputMaybe<IncidentTypeConnectionInput>;
};


export type QueryIndustryUnitsArgs = {
  input?: InputMaybe<IndustryUnitConnectionInput>;
};


export type QueryInvestigationCaseDetailsArgs = {
  input: InvestigationCaseDetailsInput;
};


export type QueryIsoCertificationPriceArgs = {
  input: IsoCertificationPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsoCertificationRulesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
  standard: Scalars['String']['input'];
};


export type QueryKnowledgeLibraryListArgs = {
  input?: KnowledgeLibraryQuestionConnectionInput;
};


export type QueryLinkedTagsArgs = {
  input?: EsgTagConnectionInput;
};


export type QueryListNotificationsArgs = {
  filterInput?: InputMaybe<NotificationFilterInput>;
  orderInput?: InputMaybe<NotificationOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QueryMetricByUuidArgs = {
  input: MetricByUuidInput;
};


export type QueryMetricDataByMetricUuidAndYearArgs = {
  input: MetricDataByMetricUuidAndYearInput;
};


export type QueryMetricDataByUuidArgs = {
  input: MetricDataByUuidInput;
};


export type QueryMetricDataColumnsListArgs = {
  input?: InputMaybe<MetricDataColumnSelectorInput>;
};


export type QueryMetricDataRowSelectArgs = {
  input?: InputMaybe<MetricDataSelectorInput>;
};


export type QueryMetricDataYearsArgs = {
  input: MetricDataYearsInput;
};


export type QueryMetricListArgs = {
  input?: InputMaybe<MetricConnectionInput>;
};


export type QueryMetricOwnersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMissedProvisioningEmitsArgs = {
  tenantUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMyAccessRequestsArgs = {
  pass: Scalars['String']['input'];
};


export type QueryMyClientHoldingsArgs = {
  pass: Scalars['String']['input'];
  tenantUuid: Scalars['ID']['input'];
};


export type QueryMyDomainOfferArgs = {
  pass: Scalars['String']['input'];
};


export type QueryMyHeldQuotesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
  proof?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyInvoicePdfArgs = {
  ref: Scalars['String']['input'];
};


export type QueryMyPortalLinksArgs = {
  pass: Scalars['String']['input'];
};


export type QueryNicoleGptSessionArgs = {
  input: NicoleGptSessionInput;
};


export type QueryNicoleGptSessionsArgs = {
  input?: NicoleGptSessionConnectionInput;
};


export type QueryOAuthClientByUuidArgs = {
  input: OAuthClientInput;
};


export type QueryOAuthClientListArgs = {
  input?: InputMaybe<OAuthClientConnectionInput>;
};


export type QueryOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderEventsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryOrderScheduleDetailArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryPartnerIntegrityPriceArgs = {
  input: PartnerIntegrityPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerIntegrityRulesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductProvisioningHistoryArgs = {
  input?: ProductProvisioningHistoryConnectionInput;
};


export type QueryProgramArgs = {
  input: ProgramInput;
};


export type QueryProgramRiskAreasByCategoryArgs = {
  input?: InputMaybe<ProgramsListInput>;
};


export type QueryProgramSettingsArgs = {
  input: GetProgramSettingsInput;
};


export type QueryProgramsListArgs = {
  input?: ProgramsListInput;
};


export type QueryQuestionSearchLinkedCountArgs = {
  input: QuestionSearchLinkedCountInput;
};


export type QueryQuestionSearchRiskAreasArgs = {
  input?: InputMaybe<QuestionSearchFilterInput>;
};


export type QueryQuestionSearchStepsArgs = {
  input: QuestionSearchStepsInput;
};


export type QueryQuestionnaireNavigationArgs = {
  input: QuestionnaireNavigationArgs;
};


export type QueryQuestionnaireNavigationQuestionsArgs = {
  input: QuestionnaireNavigationQuestionsArgs;
};


export type QueryRatingsReadyPriceArgs = {
  input: RatingsReadyPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRatingsReadyRulesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportCaseDetailsArgs = {
  input: CaseReportDetailsInput;
};


export type QueryReportCaseDetailsUnloggedArgs = {
  input: ReportCaseDetailsUnloggedInput;
};


export type QueryReportCaseExclusionOwnerListArgs = {
  filterInput?: InputMaybe<Scalars['String']['input']>;
  orderInput?: InputMaybe<CaseExclusionOwnerListOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QueryReportCaseExclusionOwnersArgs = {
  input?: InputMaybe<ExclusionAdminUserConnectionInput>;
};


export type QueryReportCasesArgs = {
  input?: InputMaybe<CaseReportsInput>;
};


export type QueryReportPresignedCaseFileArgs = {
  input: PresignedCaseFileInput;
};


export type QueryReportPromptTemplateByUuidArgs = {
  input: ReportPromptTemplateByUuidInput;
};


export type QueryReportsPromptsTemplatesArgs = {
  input?: InputMaybe<ReportPromptTemplateConnectionInput>;
};


export type QueryRespondQuestionnaireArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryRespondQuestionnaireEntriesCsvArgs = {
  input: RespondQuestionnaireEntriesCsvInput;
};


export type QueryRespondQuestionnaireEntriesListArgs = {
  input: RespondQuestionnaireEntryConnectionInput;
};


export type QueryRespondQuestionnaireEntryArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryRespondQuestionnaireListArgs = {
  input?: RespondQuestionnaireConnectionInput;
};


export type QueryRespondQuestionnaireV2EntriesArgs = {
  input: QuestionnaireEntryConnectionInput;
};


export type QueryRespondQuestionnaireV2GetByUuidArgs = {
  input: RespondQuestionnaireV2ByUuidInput;
};


export type QueryRespondQuestionnairesV2Args = {
  input?: RespondQuestionnaireV2ConnectionInput;
};


export type QueryRiskAreaByActivityArgs = {
  input: RiskAreaByActivityInput;
};


export type QueryRiskAreaByNameArgs = {
  microservice?: InputMaybe<Risk_Areas_Service_Context>;
  name: Esg_Subcategory;
};


export type QueryRiskAreaByUuidArgs = {
  microservice?: InputMaybe<Risk_Areas_Service_Context>;
  uuid: Scalars['UUID']['input'];
};


export type QueryRiskAreaSettingsByProgramArgs = {
  input: GetRiskAreaSettingsByProgramInput;
};


export type QueryRiskAreasArgs = {
  input?: InputMaybe<RiskAreasInput>;
};


export type QueryRiskAreasWithAnyQuestionsArgs = {
  input?: RiskAreasWithAnyQuestionsInput;
};


export type QueryRoleByUuidArgs = {
  input: RoleByUuidInput;
};


export type QueryRolesArgs = {
  input?: InputMaybe<RoleConnectionInput>;
};


export type QuerySectorByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySetPriceRulesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShopApprovalRequestsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShopCatalogueArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySmartFillJobArgs = {
  input: SmartFillJobInput;
};


export type QuerySmartFillUnreadableFilesArgs = {
  input: SmartFillUnreadableFilesInput;
};


export type QuerySpeekiCertPriceArgs = {
  input: SpeekiCertPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpkCertificationPriceArgs = {
  input: SpkCertificationPriceInput;
  pass?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpkCertificationRulesArgs = {
  pass?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['String']['input'];
};


export type QueryStakeholderEngagementListArgs = {
  input?: StakeholderEngagementConnectionInput;
};


export type QueryStandardAssignedRiskAreasArgs = {
  input: StandardAssignedRiskAreasConnectionInput;
};


export type QueryStandardEnabledUnitsArgs = {
  input: StandardEnabledUnitsInput;
};


export type QueryStaticTranslationsArgs = {
  input: StaticTranslationsInput;
};


export type QuerySubsidiarySiteArgs = {
  input: SubsidiarySiteInput;
};


export type QuerySubsidiarySitesArgs = {
  input?: InputMaybe<SubsidiarySitesConnectionInput>;
};


export type QuerySurveyAdminListArgs = {
  filtersInput?: InputMaybe<SurveyFilterInput>;
  orderInput?: InputMaybe<SurveyOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QuerySurveyAdminListV2Args = {
  input?: SurveysConnectionInput;
};


export type QuerySurveyAdminSearchListArgs = {
  freeTextQuery: Scalars['String']['input'];
  orderInput?: InputMaybe<SurveyTextSearchOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QuerySurveyResponseListArgs = {
  paginationInput?: InputMaybe<PaginationInput>;
  surveyUuid: Scalars['String']['input'];
};


export type QuerySurveyTemplateDetailsArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySurveyTemplateListArgs = {
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  orderInput?: InputMaybe<SurveyTemplateOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QuerySurveyUserListArgs = {
  excludedUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  orderInput?: InputMaybe<SurveyUserOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
};


export type QuerySurveyUserListV2Args = {
  input?: InputMaybe<SurveysConnectionInput>;
};


export type QuerySurveysDetailsArgs = {
  detailsInput: SurveyDetailsInput;
};


export type QuerySymbolByUuidArgs = {
  input: SymbolByUuidInput;
};


export type QuerySymbolListArgs = {
  input?: InputMaybe<SymbolConnectionInput>;
};


export type QueryTagArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryTagsArgs = {
  input?: TagConnectionInput;
};


export type QueryTagsNameSearchArgs = {
  input?: InputMaybe<TagsNameSearchInput>;
};


export type QueryTargetByUuidArgs = {
  input: TargetByUuidInput;
};


export type QueryTargetListArgs = {
  input?: InputMaybe<TargetConnectionInput>;
};


export type QueryTaskByUuidArgs = {
  input: TaskByUuidInput;
};


export type QueryTaskNameHintsArgs = {
  input?: InputMaybe<TaskNameHintConnectionInput>;
};


export type QueryTasksArgs = {
  input?: InputMaybe<TaskConnectionInput>;
};


export type QueryTaxonomiesArgs = {
  input: TaxonomyConnectionInput;
};


export type QueryTaxonomyArgs = {
  input: TaxonomyInput;
};


export type QueryTaxonomyConceptArgs = {
  input: TaxonomyConceptInput;
};


export type QueryTaxonomyConceptsArgs = {
  input: TaxonomyConceptConnectionInput;
};


export type QueryTaxonomyReportArgs = {
  input: TaxonomyReportInput;
};


export type QueryTaxonomyReportFactArgs = {
  input: TaxonomyReportFactInput;
};


export type QueryTaxonomyReportFactsArgs = {
  input: TaxonomyReportFactConnectionInput;
};


export type QueryTaxonomyReportPageArgs = {
  input: TaxonomyReportPageInput;
};


export type QueryTaxonomyReportPagesArgs = {
  input: TaxonomyReportPagesInput;
};


export type QueryTaxonomyReportsArgs = {
  input: TaxonomyReportConnectionInput;
};


export type QueryTemplateDetailsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTemplateListArgs = {
  input?: InputMaybe<TemplateConnectionInput>;
};


export type QueryTenantAdminsArgs = {
  input?: InputMaybe<TenantAdminConnectionInput>;
};


export type QueryTenantOrdersArgs = {
  tenantUuid: Scalars['String']['input'];
};


export type QueryTenantRiskAreaSettingsArgs = {
  standardUuid: Scalars['UUID']['input'];
  tenantUuid: Scalars['UUID']['input'];
};


export type QueryUnmappedQuestionsCountArgs = {
  input: UnmappedQuestionsStatisticsInput;
};


export type QueryUsedCustomTagsArgs = {
  input: UsedCustomTagsInput;
};


export type QueryValidateEmailTenantNameArgs = {
  input: ValidateTenantInput;
};


export type QueryVerifyRegistrationCodeArgs = {
  input: VerifyRegistrationInput;
};


export type QueryYearsArgs = {
  input: YearsConnectionInput;
};

export type QuestionActivity = {
  /** Question activity name. */
  name: Scalars['String']['output'];
  /** Resolve activities for activity report. Replaces esgActivitiesForActivityReport resolver */
  topicsCount: Scalars['Int']['output'];
  /** Question activity UUID. */
  uuid: Scalars['UUID']['output'];
};

/** Represents questions activities pagination connection */
export type QuestionActivityConnection = {
  /** Array of edges. */
  edges: Array<QuestionActivityEdge>;
  /** Array of direct nodes. */
  nodes: Array<QuestionActivity>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for questions activities connection. */
export type QuestionActivityConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<QuestionActivitySortInput>>;
};

/** Represents QuestionActivity connection edge. */
export type QuestionActivityEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the QuestionActivity record. */
  node: QuestionActivity;
};

export type QuestionActivitySortFields =
  | 'KEY'
  | 'Name';

export type QuestionActivitySortInput = {
  direction: SortDirection;
  field: QuestionActivitySortFields;
};

export type QuestionAuditEventsConnectionInput = {
  /** Filter by service context. */
  context?: InputMaybe<Audit_Event_Service_Context>;
  /** Filter by end date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Search input for audit events. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<AuditEventSortInput>>;
  /** Filter by start date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by status. */
  statuses?: InputMaybe<Array<Audit_Event_Status>>;
  /** Filter by type. */
  types?: InputMaybe<Array<Audit_Event_Type>>;
  /** Filter by user uuid. */
  userUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Question events year UUID. If omited active year will be used. */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Link configuration for a single question */
export type QuestionLinkInput = {
  /** The UUIDs of the answers to link. If not provided: links to all existing answers for the year, or creates an empty answer if none exist. */
  answerUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUID of the question to link */
  questionUuid: Scalars['UUID']['input'];
};

/** Input for searching questions grouped by risk areas and steps */
export type QuestionSearchFilterInput = {
  /** Filter by specific risk area UUIDs */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by stage/step - returns risk areas having questions in specified stages */
  stages?: InputMaybe<Array<Esg_Step>>;
  /** Filter by standard UUIDs - returns risk areas directly connected to standards or having questions connected to standards */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by tag names - returns risk areas having questions with specified tags */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Text search - filters by question text, header, navigation title, context */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  /** UUID of reporting year. If not provided, active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Count of filtered questions that are linked to a metric */
export type QuestionSearchLinkedCount = {
  /** Number of filtered questions linked to the metric */
  linkedCount: Scalars['Int']['output'];
};

/** Input for counting how many filtered questions are linked to a specific metric */
export type QuestionSearchLinkedCountInput = {
  /** Metric UUID to check links for */
  metricUuid: Scalars['UUID']['input'];
  /** Filter by specific risk area UUIDs */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by stage/step - returns risk areas having questions in specified stages */
  stages?: InputMaybe<Array<Esg_Step>>;
  /** Filter by standard UUIDs - returns risk areas directly connected to standards or having questions connected to standards */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by tag names - returns risk areas having questions with specified tags */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Text search - filters by question text, header, navigation title, context */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  /** UUID of reporting year. If not provided, active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Risk area with question count */
export type QuestionSearchRiskArea = {
  /** Category of this risk area */
  category: EsgCategory;
  /** Risk area label */
  customLabel: Scalars['String']['output'];
  /** Risk area name */
  name: Scalars['String']['output'];
  /** Total number of questions in this risk area */
  totalQuestions: Scalars['Int']['output'];
  /** Risk area UUID */
  uuid: Scalars['UUID']['output'];
};

/** Step with questions */
export type QuestionSearchStep = {
  /** id of step, format - <risk area uuid>+<step name> */
  id: Scalars['ID']['output'];
  /** Step key/name */
  name: Esg_Step;
  /** Questions in this step */
  questions: Array<EsgQuestion>;
  /** Total number of questions in this step */
  totalQuestions: Scalars['Int']['output'];
};

/** Input for fetching questions for a specific risk area grouped into steps (no pagination) */
export type QuestionSearchStepsInput = {
  /** Risk area UUID */
  riskAreaUuid: Scalars['UUID']['input'];
  /** Filter by stage/step - returns only steps having questions in specified stages */
  stages?: InputMaybe<Array<Esg_Step>>;
  /** Filter by standard UUIDs - keeps semantics aligned with questionSearchRiskAreas */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by tag names - keeps semantics aligned with questionSearchRiskAreas */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Text search - filters by question text, header, navigation title, context */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  /** UUID of reporting year. If not provided, active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for querying connection of questionnaire entries for resolved questionnaire. */
export type QuestionnaireEntriesConnectionInput = {
  /** Maximum validation score. */
  accuracyMax?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum validation score. */
  accuracyMin?: InputMaybe<Scalars['Int']['input']>;
  /** If true only answered entries will be queried. If false only unanswered entries will be queried. If left nullish will return all records. */
  answeredStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional argument for entry search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<RespondQuestionnaireEntrySortInput>>;
};

export type QuestionnaireEntry = {
  /** Answer accuracy reason. */
  accuracyReason?: Maybe<Scalars['String']['output']>;
  /** Answer accuracy score. */
  accuracyScore?: Maybe<Scalars['Int']['output']>;
  /** Answer, generated by AI based on sources. */
  answer?: Maybe<Scalars['String']['output']>;
  /** Category, proposed by AI. */
  category?: Maybe<Scalars['String']['output']>;
  /** Entry cell address */
  cellAddress: Scalars['String']['output'];
  conflictingKnowledgeLibraryItems: Array<KnowledgeLibraryQuestion>;
  /** Reasoning behind conflicting items analysis */
  conflictingKnowledgeLibraryReasoning?: Maybe<Scalars['String']['output']>;
  /** Date of entry creation. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the entry. */
  createdBy?: Maybe<UserType>;
  /** Flag indicating if entry has any conflicting entries in knowledge library. */
  hasConflictingKnowledgeLibraryItems: Scalars['Boolean']['output'];
  /** User who last updated the entry. */
  lastUpdatedBy?: Maybe<UserType>;
  /** Question, generated by AI based on source file. */
  question?: Maybe<Scalars['String']['output']>;
  /** Answer reasoning. */
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Array of risk areas which content was used to generate answer. */
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Row ID of questionnaire entry. */
  rowId: Scalars['Int']['output'];
  /** Source sheet name. */
  sheetName: Scalars['String']['output'];
  /** Array of enum values representing sources used to generate answer. */
  sourcesUsed: Array<Knowledge_Library_Source>;
  /** Date of entry last update. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of questionnaire entry. */
  uuid: Scalars['ID']['output'];
  /** Array of validation arguments. */
  validationArgs: Array<Scalars['String']['output']>;
  /** Cell validation mode. */
  validationMode?: Maybe<Scalars['String']['output']>;
  /** Cell validation type. */
  validationType?: Maybe<Scalars['String']['output']>;
};

/** Represents QuestionnaireEntryConnection connection. */
export type QuestionnaireEntryConnection = {
  /** Array of edges. */
  edges: Array<QuestionnaireEntryEdge>;
  /** Array of direct nodes. */
  nodes: Array<QuestionnaireEntry>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying connection of questionnaire entries. */
export type QuestionnaireEntryConnectionInput = {
  /** Maximum validation score. */
  accuracyMax?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum validation score. */
  accuracyMin?: InputMaybe<Scalars['Int']['input']>;
  /** If true only answered entries will be queried. If false only unanswered entries will be queried. If left nullish will return all records. */
  answeredStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true only conflicting entries will be queried. If false only not conflicting entries will be queried. If left nullish will return all records. */
  conflictStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Identifier of questionnaire. */
  questionnaireUuid: Scalars['UUID']['input'];
  /** Optional argument for entry search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Optional input, to filter entries by sheet name */
  sheetName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<QuestionnaireEntrySortInput>>;
};

/** Represents QuestionnaireEntry connection edge. */
export type QuestionnaireEntryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the QuestionnaireEntry record. */
  node: QuestionnaireEntry;
};

export type QuestionnaireEntrySortFields =
  | 'CREATED_AT'
  | 'IS_CONFLICTING'
  | 'NAME'
  | 'ROW_ID';

export type QuestionnaireEntrySortInput = {
  direction: SortDirection;
  field: QuestionnaireEntrySortFields;
};

/** Represents enabled questionnaire filters. */
export type QuestionnaireFilter = {
  /** Array of enabled questionnaire filter scopes. */
  scope: Array<ScopeFilter>;
  /** Array of users that are assigned to the questionnaire filters. */
  taskAssignees: Array<UserType>;
  /** Text search filter. */
  textSearch?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type QuestionnaireFiltersInput = {
  /** Question states that should be included in the filters. Empty array will disable filtering by question states. */
  scope: Array<Esg_Questionnaire_Filter>;
  /** Array of user identifiers that should be enabled in the filters. Empty array will disable filtering by task assignees. */
  taskAssigneeUuids: Array<Scalars['ID']['input']>;
  /** Search query to filter questions by text. */
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

/** Questionnaire navigation object */
export type QuestionnaireNavigation = {
  /** List of categories with their subcategories and questions */
  categories: Array<QuestionnaireNavigationCategory>;
};

export type QuestionnaireNavigationArgs = {
  ignoreFilters: Scalars['Boolean']['input'];
};

/** Questionnaire navigation category object */
export type QuestionnaireNavigationCategory = {
  /** The category name */
  name: Scalars['String']['output'];
  /** Risk areas associated with this category */
  riskAreas: Array<QuestionnaireNavigationRiskArea>;
  /** The category UUID */
  uuid: Scalars['UUID']['output'];
};

export type QuestionnaireNavigationQuestionsArgs = {
  ignoreFilters?: Scalars['Boolean']['input'];
  /** @deprecated Use riskAreaUuids instead. */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Questionnaire navigation risk area object */
export type QuestionnaireNavigationRiskArea = {
  /** Custom label for the risk area */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** The risk area name */
  name: Scalars['String']['output'];
  /** The risk area order */
  order: Scalars['Int']['output'];
  /** Standards associated with this risk area */
  standards: Array<QuestionnaireNavigationStandard>;
  /** Statistics for the risk area */
  statistics: QuestionnaireNavigationStatistics;
  /** The risk area UUID */
  uuid: Scalars['UUID']['output'];
};


/** Questionnaire navigation risk area object */
export type QuestionnaireNavigationRiskAreaStandardsArgs = {
  input: QuestionnaireNavigationStatisticsArgs;
};


/** Questionnaire navigation risk area object */
export type QuestionnaireNavigationRiskAreaStatisticsArgs = {
  input: QuestionnaireNavigationStatisticsArgs;
};

/** Questionnaire navigation standard object */
export type QuestionnaireNavigationStandard = {
  /** The standard name */
  name: Scalars['String']['output'];
  /** The standard UUID */
  uuid: Scalars['UUID']['output'];
};

/** Questionnaire navigation statistics object */
export type QuestionnaireNavigationStatistics = {
  /** The number of answered questions */
  answeredQuestions: Scalars['Int']['output'];
  /** The total number of questions */
  totalQuestions: Scalars['Int']['output'];
};

export type QuestionnaireNavigationStatisticsArgs = {
  ignoreFilters?: Scalars['Boolean']['input'];
};

/** Questionnaire navigation step object */
export type QuestionnaireNavigationStep = {
  /** The step name */
  name: Esg_Step;
  /** The step order */
  order: Scalars['Int']['output'];
  /** Questions associated with this step */
  questions: Array<EsgQuestion>;
  /** Name of risk area */
  riskAreaName?: Maybe<Scalars['String']['output']>;
  /** Section of the standard this step represents ("4", "A.2"); null for steps that are not a section of a standard */
  section?: Maybe<Scalars['String']['output']>;
  /** Statistics for the step */
  statistics: QuestionnaireNavigationStatistics;
  /** The step UUID (format: <risk area uuid>+<step name>) */
  uuid: Scalars['ID']['output'];
};


/** Questionnaire navigation step object */
export type QuestionnaireNavigationStepStatisticsArgs = {
  input: QuestionnaireNavigationStatisticsArgs;
};

/** Represents input for querying connection of questionnaire entries for resolved questionnaire. */
export type QuestionnaireV2EntriesConnectionInput = {
  /** Maximum validation score. */
  accuracyMax?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum validation score. */
  accuracyMin?: InputMaybe<Scalars['Int']['input']>;
  /** If true only answered entries will be queried. If false only unanswered entries will be queried. If left nullish will return all records. */
  answeredStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true only conflicting entries will be queried. If false only not conflicting entries will be queried. If left nullish will return all records. */
  conflictStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional argument for entry search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Optional input, to filter entries by sheet name */
  sheetName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<QuestionnaireEntrySortInput>>;
};

export type Risk_Areas_Service_Context =
  | 'COLLECT'
  | 'COMPANY_SETTINGS'
  | 'ESG'
  | 'METRICS'
  | 'PULSE'
  | 'REPORTING';

export type Risk_Areas_Sort =
  | 'IS_SHARED'
  | 'NAME'
  | 'ORDER';

/** Defines how access to risk areas is determined. */
export type Risk_Area_Access_Mode =
  /** Will only resolve Programs/Risk Areas enabled by user permissions. */
  | 'PERMISSION_ONLY'
  /** Will resolve Programs/Risk Areas enabled by user permissions and by tasks. */
  | 'TASK_AND_PERMISSION'
  /** Will only resolve Programs/Risk Areas enabled by user tasks. */
  | 'TASK_ONLY';

export type Role_Edit_Mode =
  | 'CASES_ROLES_EDITABLE'
  | 'EDITABLE'
  | 'NOT_EDITABLE';

export type RatingsReadyMultiyearRule = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type RatingsReadyPlatformRule = {
  /** Base fee at fewer than 500 employees. */
  baseFeeUsd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

/** The buyer's scope answers for a RatingsReady price quote. */
export type RatingsReadyPriceInput = {
  /** The organisation's headcount. */
  headcount: Scalars['Int']['input'];
  /** "None" | "2-year" | "3-year". */
  multiyear: Scalars['String']['input'];
  /** Platform ids, from ratingsReadyRules. */
  platforms: Array<Scalars['String']['input']>;
  /** Submission deadline within 4 weeks. */
  rush: Scalars['Boolean']['input'];
};

export type RatingsReadyRules = {
  multiyearOptions: Array<RatingsReadyMultiyearRule>;
  platforms: Array<RatingsReadyPlatformRule>;
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  /** Rush premium, percent of the sub-total. */
  rushPercent: Scalars['Int']['output'];
  sizeBands: Array<RatingsReadySizeBandRule>;
};

export type RatingsReadySizeBandRule = {
  fromHeadcount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type ReadNotification = {
  readAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RecordHelpArticleVoteInput = {
  /** Slug of the article being voted on */
  articleSlug: Scalars['String']['input'];
  /** Optional free-text feedback, shown only on a "not helpful" vote */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Whether the article was helpful */
  helpful: Scalars['Boolean']['input'];
};

export type Region = {
  /** List of countries in the region and country map. */
  countries: Array<Country_Code>;
  /** Indicates whether the region and country map is active. */
  isActive: Scalars['Boolean']['output'];
  /** Name of the region and country map. */
  name: Scalars['String']['output'];
  /** Unique identifier of region and country map. */
  uuid: Scalars['ID']['output'];
};

/** Represents RegionConnection connection. */
export type RegionConnection = {
  /** Array of edges. */
  edges: Array<RegionEdge>;
  /** Array of direct nodes. */
  nodes: Array<Region>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of region and country mappings. */
export type RegionConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<RegionSortInput>>;
};

/** Represents Region connection edge. */
export type RegionEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Region record. */
  node: Region;
};

export type RegionSortFields =
  | 'NAME';

export type RegionSortInput = {
  direction: SortDirection;
  field: RegionSortFields;
};

export type RegionUpsertInput = {
  /** List of countries in the region and country map. */
  countries: Array<Country_Code>;
  /** Indicates whether the region and country map is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the region and country map. */
  name: Scalars['String']['input'];
  /** Unique identifier of region and country mapping. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type RegularRolePermission = {
  /** Role permission name. */
  permission: Assignable_Permission;
  /** Role permission UUID. */
  uuid: Scalars['UUID']['output'];
};

export type ReleaseNote = {
  /** Release note contents. */
  content: Scalars['HTML']['output'];
  /** Date of release note creation. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the release note. */
  createdBy?: Maybe<UserType>;
  /** Flag indicating if release note is classified as new feature. */
  isNewFeature: Scalars['Boolean']['output'];
  /** Flag indicating if note is published. */
  isPublished: Scalars['Boolean']['output'];
  /** Flag indicating if release note is classified as feature update. */
  isUpdate: Scalars['Boolean']['output'];
  /** Date of release note last update. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the release note. */
  lastUpdatedBy?: Maybe<UserType>;
  /** Release note title. */
  title: Scalars['String']['output'];
  /** Release note UUID. */
  uuid: Scalars['ID']['output'];
  /** Release version. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ReleaseNoteUpsertInput = {
  /** Release note content. */
  content: Scalars['HTML']['input'];
  /** Flag indicating if release contains a new feature. */
  isNewFeature: Scalars['Boolean']['input'];
  /** Flag indicating should release note be marked as published. */
  isPublished: Scalars['Boolean']['input'];
  /** Flag indicating if release contains a feature update. */
  isUpdate: Scalars['Boolean']['input'];
  /** Release note title. */
  title: Scalars['String']['input'];
  /**
   * Release note version. When null or empty string is passed then latest
   * release version will be set automatically (if possible). Setting a string will set a string.
   * When skipped then value is not changed
   */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ReportAudience = {
  /** Audience unique id. For cache purposes */
  id: Scalars['String']['output'];
  /** Label of the report audience */
  label: Scalars['String']['output'];
};

export type ReportCaseDetailsUnloggedInput = {
  /** Human readable case unique identifier. */
  caseId: Scalars['String']['input'];
  /** Case pin code (related to `Guest` user type). */
  pinCode?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of tenant. */
  tenantUuid: Scalars['String']['input'];
};

/** Represents the reporter case file. */
export type ReportCaseFile = {
  /** File name. */
  name: Scalars['String']['output'];
  /** File size (in bytes). */
  size?: Maybe<Scalars['Float']['output']>;
  /** File unique identifier. */
  uuid: Scalars['ID']['output'];
};

export type ReportPromptTemplate = {
  /** The default audience for the report prompt template. */
  audience?: Maybe<ReportAudience>;
  /** Suggested topic for the report */
  defaultTopic?: Maybe<RiskArea>;
  /** An icon representation of the report prompt template */
  icon?: Maybe<Scalars['String']['output']>;
  /** Prompt for the report */
  prompt: Scalars['String']['output'];
  /** Purpose of the report */
  purpose: Scalars['String']['output'];
  /** Resolve template name, fills placeholders in templates. */
  reportName: Scalars['String']['output'];
  /** Report template name for the report. Only for SPEEKI_ADMIN. If you want to get name check "reportName" field. */
  reportNameTemplate: Scalars['String']['output'];
  /** Suggested report length in words */
  suggestedReportLength: Scalars['Int']['output'];
  /** Name of the template */
  templateName: Scalars['String']['output'];
  /** Report prompt template uuid UUID. */
  uuid: Scalars['UUID']['output'];
};

export type ReportPromptTemplateBatchUpsertInput = {
  /** Represents report prompt templates to be upserted */
  batch: Array<ReportPromptTemplateUpsertInput>;
};

/** Represents input to get report prompt template by uuid. */
export type ReportPromptTemplateByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents reports prompts templates pagination connection */
export type ReportPromptTemplateConnection = {
  /** Array of edges. */
  edges: Array<ReportPromptTemplateEdge>;
  /** Array of direct nodes. */
  nodes: Array<ReportPromptTemplate>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for reports prompts templates connection. */
export type ReportPromptTemplateConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<ReportPromptTemplateSortInput>>;
};

/** Represents the input for deleting report prompt templates */
export type ReportPromptTemplateDeleteInput = {
  /** Uuids of report prompt templates to delete */
  uuidsToDelete: Array<Scalars['UUID']['input']>;
};

/** Represents ReportPromptTemplate connection edge. */
export type ReportPromptTemplateEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ReportPromptTemplate record. */
  node: ReportPromptTemplate;
};

export type ReportPromptTemplateSortFields =
  | 'TemplateName';

export type ReportPromptTemplateSortInput = {
  direction: SortDirection;
  field: ReportPromptTemplateSortFields;
};

export type ReportPromptTemplateUpsertInput = {
  /** Audience of a report */
  audienceId?: InputMaybe<Scalars['String']['input']>;
  /** Uuid of default topic related to this report prompt template */
  defaultTopicUuid?: InputMaybe<Scalars['String']['input']>;
  /** Icon url of the report prompt template icon. It should be a valid URL that not expires */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Prompt for the report */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of the report */
  purpose?: InputMaybe<Scalars['String']['input']>;
  /** Report name template. Allowed placeholders: {{date|mmmm yyyy}}. Placeholders are optional */
  reportNameTemplate: Scalars['String']['input'];
  /** Suggested report length in words */
  suggestedReportLength?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the template */
  templateName: Scalars['String']['input'];
  /** Uuid of report prompt template to update. Leave empty to create new report prompt template */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents common respons for uploaded files. */
export type ReportResponse = {
  /** File presigned url. */
  url: Scalars['String']['output'];
};

export type ReportSettings = {
  subsidiaryChoiceEnabled?: Maybe<Scalars['Boolean']['output']>;
  subsidiarySelectionCopy?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};


export type ReportSettingsSubsidiarySelectionCopyArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};

export type ReportUploadInput = {
  /** Survey response report images.  Accepts jpg and png files. */
  files: Array<Scalars['Upload']['input']>;
  /** Survey or disclosure uuid. */
  surveyUuid: Scalars['ID']['input'];
};

/** Represents unique reporting group. */
export type ReportingGroup = {
  businessUnits: Array<BusinessUnit>;
  subsidiarySite: SubsidiarySite;
  /** Unique identifier of reporting group. */
  uuid: Scalars['ID']['output'];
};

/** Represents pagination connection of reporting groups. */
export type ReportingGroupConnection = {
  /** Array of edges. */
  edges: Array<ReportingGroupEdge>;
  /** Array of direct nodes. */
  nodes: Array<ReportingGroup>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of reporting groups. */
export type ReportingGroupConnectionInput = {
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<ReportingGroupSortInput>>;
};

/** Represents ReportingGroup connection edge. */
export type ReportingGroupEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ReportingGroup record. */
  node: ReportingGroup;
};

/** Represents input to fetch unique reporting group. */
export type ReportingGroupGetInput = {
  /** Unique identifier of reporting group to fetch. */
  uuid: Scalars['UUID']['input'];
};

export type ReportingGroupSortFields =
  | 'CREATED_AT';

export type ReportingGroupSortInput = {
  direction: SortDirection;
  field: ReportingGroupSortFields;
};

/** Represents input to upsert reporting group. */
export type ReportingGroupUpsertInput = {
  /** Unique identifiers of business units. */
  businessUnitUuids: Array<Scalars['ID']['input']>;
  /** Unique identifier of subsidiary site. */
  subsidiarySiteUuid: Scalars['UUID']['input'];
  /** Unique identifier of reporting group to update. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input to delete reporting groups. */
export type ReportingGroupsDeleteInput = {
  /** Unique identifiers of reporting groups to delete. */
  uuids: Array<Scalars['UUID']['input']>;
};

export type ReportingSource = {
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Represents input to batch upsert reporting sources. */
export type ReportingSourceBatchUpsertInput = {
  /** An array of reporting sources. */
  reportingSources: Array<ReportingSourceUpsertInput>;
};

/** Represents pagination connection of reporting sources settings. */
export type ReportingSourceConnection = {
  /** Array of edges. */
  edges: Array<ReportingSourceEdge>;
  /** Array of direct nodes. */
  nodes: Array<ReportingSource>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of reporting sources settings. */
export type ReportingSourceConnectionInput = {
  /** Represents optional text filter to limit the results. It allows filtering by name. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<ReportingSourceSortInput>>;
};

/** Represents ReportingSource connection edge. */
export type ReportingSourceEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ReportingSource record. */
  node: ReportingSource;
};

export type ReportingSourceSortFields =
  | 'NAME'
  | 'STATUS';

export type ReportingSourceSortInput = {
  direction: SortDirection;
  field: ReportingSourceSortFields;
};

/** Represents input to upsert reporting source. */
export type ReportingSourceUpsertInput = {
  /** Indicates whether reporting source is enabled. */
  isActive: Scalars['Boolean']['input'];
  /** Name of the reporting source. */
  name: Scalars['String']['input'];
  /** Unique identifier of reporting source. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type RequestAdminMagicLinkInput = {
  email: Scalars['EmailAddress']['input'];
};

/** The result of requesting a checkout confirmation code. */
export type RequestCheckoutEmailVerification = {
  /** Seconds to wait before another code can be requested. */
  cooldownSeconds: Scalars['Int']['output'];
  /** When the outstanding code stops working. Null when no code is outstanding. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether a confirmation email was sent. False with a positive `cooldownSeconds` means a resend cooldown or send cap is active; false with zero means the address is already confirmed for this session. */
  sent: Scalars['Boolean']['output'];
};

/** Input requesting a confirmation code for the email address a checkout buyer wants to use. */
export type RequestCheckoutEmailVerificationInput = {
  /** Address to send the confirmation code to. */
  email: Scalars['String']['input'];
  /** The checkout session's bearer token. */
  sessionToken: Scalars['String']['input'];
};

/** Represents input to request a seat in a framework. */
export type RequestFrameworkSeatInput = {
  /** UUID of the framework (risk area) to request a seat in. */
  riskAreaUuid: Scalars['UUID']['input'];
};

/** input type containing method and qr code size required to setup mfa for user */
export type RequestMfaSetupInput = {
  method: Mfa_Method_Type;
  qrCodeSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for asking an administrator to accept a plan for a framework, before any order exists. */
export type RequestPlanApprovalInput = {
  /** An optional note to the organisation's administrators. Capped at 500 characters. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The catalogue plan id (e.g. 'standard'). */
  planId: Scalars['String']['input'];
  /** The catalogue product (standard/framework) id. */
  productId: Scalars['String']['input'];
};

/** Represents the result of requesting a confirmation code. */
export type RequestReporterEmailVerification = {
  /** Seconds to wait before another code can be requested. */
  cooldownSeconds: Scalars['Int']['output'];
  /** When the outstanding code stops working. Null when no code is outstanding. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether a confirmation email was sent. False with a positive `cooldownSeconds` means the resend cooldown is still running; false with zero means the address is already confirmed for this session and no further code is needed. */
  sent: Scalars['Boolean']['output'];
};

/** Represents the input requesting a confirmation code for an address a reporter wants used for follow-up. */
export type RequestReporterEmailVerificationInput = {
  /** Address to send the confirmation code to. */
  email: Scalars['String']['input'];
};

/** Input for a checkout buyer submitting a service's scope for a hand-priced quote. No price is computed - this only records the request and notifies staff. */
export type RequestServicePricingInput = {
  /** The scope-clarifying answers, up to 40. */
  answers: Array<ScopeAnswerInput>;
  /** The storefront's service id. */
  serviceId: Scalars['String']['input'];
  /** The service's display name at request time. */
  serviceName: Scalars['String']['input'];
  /** The checkout session's bearer token. */
  sessionToken: Scalars['String']['input'];
};

/** Input for a checkout buyer asking to join an organisation that already uses Speeki - the organisation itself is resolved server-side from the checkout session, never supplied here. */
export type RequestTenantAccessInput = {
  /** An optional note to the organisation's administrators. Capped at 500 characters. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The requester's own name, if they gave one. */
  requesterName?: InputMaybe<Scalars['String']['input']>;
  /** The checkout session's bearer token. */
  sessionToken: Scalars['String']['input'];
};

/** Input for account unlock request */
export type RequestUnlockTokenInput = {
  /** Locked account email */
  email: Scalars['String']['input'];
  /** Locked account tenant uuid */
  tenantUuid: Scalars['String']['input'];
};

/** Input to resend tenant create input */
export type ResendTenantCreateEmailInput = {
  companyCode: Scalars['String']['input'];
};

/** Allows setting new password with a valid password reset token */
export type ResetPasswordInput = {
  /** User device fingerprint that allows to skip MFA. User must authenticate with MFA earlier and provide fingerprint */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Type representing questionnaire. */
export type RespondQuestionnaire = {
  /** Date of questionnaire creation */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the questionnaire */
  createdBy?: Maybe<UserType>;
  /** Resolve paginated list of entries. */
  entries: RespondQuestionnaireEntryConnection;
  /** User who last updated the questionnaire */
  lastUpdatedBy?: Maybe<UserType>;
  /** Questionnaire name. */
  name: Scalars['String']['output'];
  /** Original name. */
  originalName?: Maybe<Scalars['String']['output']>;
  /** Array of enums representing sources used to generate answer. */
  sourcesUsed: Array<Knowledge_Library_Source>;
  /** Date of questionnaire last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Questionnaire UUID. */
  uuid: Scalars['UUID']['output'];
};


/** Type representing questionnaire. */
export type RespondQuestionnaireEntriesArgs = {
  input?: QuestionnaireEntriesConnectionInput;
};

/** Represents RespondQuestionnaireConnection connection. */
export type RespondQuestionnaireConnection = {
  /** Array of edges. */
  edges: Array<RespondQuestionnaireEdge>;
  /** Array of direct nodes. */
  nodes: Array<RespondQuestionnaire>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying connection of questionnaire entries. */
export type RespondQuestionnaireConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional argument for questionnaire search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<RespondQuestionnaireSortInput>>;
};

/** Represents input for questionnaire delete. */
export type RespondQuestionnaireDeleteInput = {
  /** Array of questionnaire UUIDs to be deleted. */
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents RespondQuestionnaire connection edge. */
export type RespondQuestionnaireEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RespondQuestionnaire record. */
  node: RespondQuestionnaire;
};

export type RespondQuestionnaireEntriesCsvInput = {
  /** CSV delimiter. Uses ";" by default */
  delimiter?: Scalars['String']['input'];
  /** UUID of questionnaire. */
  questionnaireUuid: Scalars['UUID']['input'];
};

/** Represents input for delete of questionnaire entries */
export type RespondQuestionnaireEntriesDeleteInput = {
  /** Array of entries to be deleted. */
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents input for upsert of questionnaire entries */
export type RespondQuestionnaireEntriesUpsertInput = {
  /** Array of entries to be upserted. */
  entries: Array<RespondQuestionnaireEntryUpsertInput>;
};

/** Represents input for upsert of respond questionnaire entries with respond questionnaire. */
export type RespondQuestionnaireEntriesUpsertWithQuestionnaireInput = {
  /** Answer content */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Answer options */
  answerOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional input for category. Accepts UUID, name or input for flag to disconnect record from category. */
  categoryInput?: InputMaybe<RespondQuestionnaireEntryCategoryInput>;
  /** Confidence reasoning */
  confidenceReasoning?: InputMaybe<Scalars['String']['input']>;
  /** Confidence score */
  confidenceScore?: InputMaybe<Scalars['Int']['input']>;
  /** Question content */
  question?: InputMaybe<Scalars['String']['input']>;
  /** Answer reasoning */
  reasoning?: InputMaybe<Scalars['String']['input']>;
  /** Array of risk area UUIDs */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Row id */
  rowId: Scalars['Int']['input'];
  /** Array of used sources */
  sources?: InputMaybe<Array<Knowledge_Library_Source>>;
  /** UUID of entry for update. Omit to create new entry */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Type representing questionnaire entry. */
export type RespondQuestionnaireEntry = {
  /** Generated answer. */
  answer?: Maybe<Scalars['String']['output']>;
  /** Answer options. */
  answerOptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Entry's category. */
  category?: Maybe<DataCategory>;
  /** Explanation of confidence score. */
  confidenceReason?: Maybe<Scalars['String']['output']>;
  /** Confidence score, from 0 (low confidence) to 100 (high confidence) */
  confidenceScore?: Maybe<Scalars['Int']['output']>;
  /** Date of entry creation. */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the entry. */
  createdBy?: Maybe<UserType>;
  /** User who last updated the entry. */
  lastUpdatedBy?: Maybe<UserType>;
  /** Question content. */
  question?: Maybe<Scalars['String']['output']>;
  /** Explanation of answer. */
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Array of risk areas which content was used to generate answer. */
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Row ID, corresponds to source question. */
  rowId: Scalars['Int']['output'];
  /** Array of enums representing sources used to generate answer. */
  sourcesUsed?: Maybe<Array<Knowledge_Library_Source>>;
  /** Date of entry last update. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of entry. */
  uuid: Scalars['UUID']['output'];
  /** Validation arguments */
  validationArguments: Array<Scalars['String']['output']>;
  /** Cell validation operator. */
  validationOperator?: Maybe<Excel_Validation_Operator>;
  /** Cell validation type. */
  validationType?: Maybe<Excel_Validation_Type>;
};

/** Represents category input for knowledge library entry */
export type RespondQuestionnaireEntryCategoryInput = {
  /** Input for connection question with category by name. If category does not exist it will be created. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Input for disconnecting the question from category. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Input for connecting question with category by uuid. Category must exist. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents RespondQuestionnaireEntryConnection connection. */
export type RespondQuestionnaireEntryConnection = {
  /** Array of edges. */
  edges: Array<RespondQuestionnaireEntryEdge>;
  /** Array of direct nodes. */
  nodes: Array<RespondQuestionnaireEntry>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying connection of questionnaire entries. */
export type RespondQuestionnaireEntryConnectionInput = {
  /** Maximum validation score. */
  accuracyMax?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum validation score. */
  accuracyMin?: InputMaybe<Scalars['Int']['input']>;
  /** If true only answered entries will be queried. If false only unanswered entries will be queried. If left nullish will return all records. */
  answeredStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Identifier of questionnaire. */
  questionnaireUuid: Scalars['UUID']['input'];
  /** Optional argument for entry search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<RespondQuestionnaireEntrySortInput>>;
};

/** Represents RespondQuestionnaireEntry connection edge. */
export type RespondQuestionnaireEntryEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RespondQuestionnaireEntry record. */
  node: RespondQuestionnaireEntry;
};

export type RespondQuestionnaireEntrySortFields =
  | 'CREATED_AT'
  | 'IS_CONFLICTING'
  | 'NAME'
  | 'ROW_ID';

export type RespondQuestionnaireEntrySortInput = {
  direction: SortDirection;
  field: RespondQuestionnaireEntrySortFields;
};

/** Represents input for respond questionnaire entry upsert */
export type RespondQuestionnaireEntryUpsertInput = {
  /** Answer content */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Answer options */
  answerOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional input for category. Accepts UUID, name or input for flag to disconnect record from category. */
  categoryInput?: InputMaybe<RespondQuestionnaireEntryCategoryInput>;
  /** Confidence reasoning */
  confidenceReasoning?: InputMaybe<Scalars['String']['input']>;
  /** Confidence score */
  confidenceScore?: InputMaybe<Scalars['Int']['input']>;
  /** Question content */
  question?: InputMaybe<Scalars['String']['input']>;
  /** UUID of questionnaire */
  questionnaireUuid: Scalars['UUID']['input'];
  /** Answer reasoning */
  reasoning?: InputMaybe<Scalars['String']['input']>;
  /** Array of risk area UUIDs */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Row id */
  rowId: Scalars['Int']['input'];
  /** Array of used sources */
  sources?: InputMaybe<Array<Knowledge_Library_Source>>;
  /** UUID of entry for update. Omit to create new entry */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type RespondQuestionnaireSortFields =
  | 'CREATED_AT'
  | 'NAME'
  | 'UPDATED_AT';

export type RespondQuestionnaireSortInput = {
  direction: SortDirection;
  field: RespondQuestionnaireSortFields;
};

/** Represents input for upsert of respond questionnaire */
export type RespondQuestionnaireUpsertInput = {
  /** Optional input for upsert of entries. WARNING - IF VALIDATION FAILS FOR SOME REASON, YOU WILL NOT RECEIVE ANY ERRORS */
  entries?: InputMaybe<Array<RespondQuestionnaireEntriesUpsertWithQuestionnaireInput>>;
  /** Questionnaire name. Duplicated names will be appended with number */
  name: Scalars['String']['input'];
  /** Optional file name. If absent, value from "name" will be used on create. On update original name will not be changed if value is not provided. */
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Array of enums representing sources used to generate answer. */
  sourcesUsed?: InputMaybe<Array<Knowledge_Library_Source>>;
  /** UUID of questionnaire for update. Omit to create new questionnaire */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents v2 respond questionnaire */
export type RespondQuestionnaireV2 = {
  /** Number of answered questionnaire entries */
  answeredEntriesCount: Scalars['Int']['output'];
  /** Number of conflicting questionnaire entries */
  conflictingEntriesCount: Scalars['Int']['output'];
  /** Date of questionnaire creation */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the questionnaire */
  createdBy?: Maybe<UserType>;
  /** Resolve entries of the questionnaire. */
  entries: QuestionnaireEntryConnection;
  /** Total number of questionnaire entries */
  entriesCount: Scalars['Int']['output'];
  /** Questionnaire file name */
  fileName: Scalars['String']['output'];
  /** Filled file. */
  filledFile?: Maybe<InsightsFile>;
  /** Flag indicating if any of questionnaire entries has conflicting entry in knowledge library. */
  hasConflictingEntries: Scalars['Boolean']['output'];
  /** Last reviewed date of the questionnaire. */
  lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date of questionnaire last update */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the questionnaire */
  lastUpdatedBy?: Maybe<UserType>;
  /** Questionnaire name. */
  name: Scalars['String']['output'];
  /** Original excel file. */
  originalFile: InsightsFile;
  /** Array of risk areas assigned to questionnaire as sources. */
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Array of enums representing sources used to generate answer. */
  sourcesUsed: Array<Knowledge_Library_Source>;
  /** Represents questionnaire status */
  status: Questionnaire_Status;
  /** Number of questions with conflicting entries */
  totalConflictsCount: Scalars['Int']['output'];
  /** Questionnaire UUID. */
  uuid: Scalars['UUID']['output'];
};


/** Represents v2 respond questionnaire */
export type RespondQuestionnaireV2EntriesArgs = {
  input?: QuestionnaireV2EntriesConnectionInput;
};

export type RespondQuestionnaireV2ByUuidInput = {
  /** UUID of questionnaire. */
  uuid: Scalars['UUID']['input'];
};

/** Input for changing the state of questionnaire */
export type RespondQuestionnaireV2ChangeStatusInput = {
  /** Questionnaire identifier */
  questionnaireUuid: Scalars['UUID']['input'];
  /** Status of questionnaire to be set. Cannot be PROCESSING. */
  status: Questionnaire_Status;
};

/** Represents RespondQuestionnaireV2Connection connection. */
export type RespondQuestionnaireV2Connection = {
  /** Array of edges. */
  edges: Array<RespondQuestionnaireV2Edge>;
  /** Array of direct nodes. */
  nodes: Array<RespondQuestionnaireV2>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for querying connection of questionnaire entries. */
export type RespondQuestionnaireV2ConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional argument for questionnaire search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<RespondQuestionnaireV2SortInput>>;
  /** Optional filter by status. */
  status?: InputMaybe<Array<Questionnaire_Status>>;
};

export type RespondQuestionnaireV2CreateInput = {
  /** Array of integers representing the year scope for ESG data sources. */
  esgYearScope?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Optional file name. If absent, value from file itself will be used. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Array of metric uuids to scope the metric data sources. */
  metricUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Array of integers representing the year scope for metric data sources. */
  metricYearScope?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Questionnaire name. Duplicated names will be appended with number. If not provided file name will be used */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Questionnaire file. */
  questionnaireFile: Scalars['Upload']['input'];
  /** Array of metric uuids to scope the ESG data sources. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Array of enums representing sources used to generate answer. */
  sourcesUsed: Array<Knowledge_Library_Source>;
};

/** Input for batch delete of questionnaires. */
export type RespondQuestionnaireV2DeleteInput = {
  /** UUIDs of questionnaires to be deleted */
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents RespondQuestionnaireV2 connection edge. */
export type RespondQuestionnaireV2Edge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RespondQuestionnaireV2 record. */
  node: RespondQuestionnaireV2;
};

/** Input for batch edit of questionnaire entries by cell reference */
export type RespondQuestionnaireV2EntryBatchEditByAddressInput = {
  /** Array of inputs for entry update */
  args: Array<RespondQuestionnaireV2EntryEditByAddressInput>;
};

/** Input for batch edit of questionnaire entries by UUIDs */
export type RespondQuestionnaireV2EntryBatchEditByUuidInput = {
  /** Array of inputs for entry update */
  args: Array<RespondQuestionnaireV2EntryEditByUuidInput>;
};

/** Input for delete of multiple questionnaire entries */
export type RespondQuestionnaireV2EntryDelete = {
  /** Array of entry UUIDs to be deleted. */
  entryUuids: Array<Scalars['UUID']['input']>;
};

/** Input for questionnaire entry edit */
export type RespondQuestionnaireV2EntryEditByAddressInput = {
  /** Entry answer */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Entry category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Cell address */
  cellAddress: Scalars['String']['input'];
  /** Array of conflicting Knowledge Library items UUIDs */
  conflictingKnowledgeLibraryItemsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Entry question */
  question?: InputMaybe<Scalars['String']['input']>;
  /** Questionnaire identifier */
  questionnaireUuid: Scalars['UUID']['input'];
  /** Sheet name */
  sheetName: Scalars['String']['input'];
};

/** Input for questionnaire entry edit */
export type RespondQuestionnaireV2EntryEditByUuidInput = {
  /** Entry answer */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Entry category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Array of conflicting Knowledge Library items UUIDs */
  conflictingKnowledgeLibraryItemsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Entry question */
  question?: InputMaybe<Scalars['String']['input']>;
  /** Entry identifier */
  uuid: Scalars['UUID']['input'];
};

/** Input for setting the questionnaire as saved */
export type RespondQuestionnaireV2MarkAsSavedInput = {
  /** Questionnaire identifier */
  uuid: Scalars['UUID']['input'];
};

export type RespondQuestionnaireV2SortFields =
  | 'CREATED_AT'
  | 'NAME'
  | 'STATUS'
  | 'UPDATED_AT';

export type RespondQuestionnaireV2SortInput = {
  direction: SortDirection;
  field: RespondQuestionnaireV2SortFields;
};

/** Input for update of filled Excel file */
export type RespondQuestionnaireV2UpdateExcelFileInput = {
  /** Updated file */
  file: Scalars['Upload']['input'];
  /** Questionnaire identifier */
  uuid: Scalars['UUID']['input'];
};

export type RiskArea = {
  /** Resolves parent ESG category. */
  category?: Maybe<EsgCategory>;
  /** RiskArea color. */
  color?: Maybe<Scalars['HexColorCode']['output']>;
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Goal fitness percentage (0-100) for the given year - the average over its indicators; null until every indicator is computable. */
  fitness?: Maybe<Scalars['Float']['output']>;
  /** The goal's Benchmark progress indicators with the viewer tenant's values for the given year. Empty for non-benchmark topics. */
  fitnessIndicators: Array<FitnessIndicator>;
  /** Framework catalog bucket. Non-null marks the row as framework-owned (My frameworks); null rows are programme-only. */
  frameworkCategory?: Maybe<Framework_Category>;
  /** Group tags associated with the risk area that belong to a current user tenant */
  groupTags: GroupTagConnection;
  /** Returns statistics breakdown. Returns array of statistics for Engage risk areas. Returns empty array for standards risk areas */
  groupedStatistics: Array<EsgGroupedStatistics>;
  /**
   * Gets the first guideline for the category. It's the one with the lowest order number.
   * If there isn't any guidelines or the subcategory isn't a standard then returns null.
   */
  guidelineMain?: Maybe<Guideline>;
  guidelines: GuidelineConnection;
  guidelinesCategories: Array<Guideline>;
  /** Check if some unit is enabled for a tenant's standard. For non standard returns null. Ignores default sectors */
  hasSomeIndustryEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Change history for resolved subcategory. */
  history: Array<EsgHistoryElement>;
  /** Resolve risk area status. */
  isEnabled: Scalars['Boolean']['output'];
  /** Flag indicating whether risk area is fully migrated. */
  isMigrated: Scalars['Boolean']['output'];
  /** Flag indicating common risk area. */
  isShared: Scalars['Boolean']['output'];
  /** Returns last activity date. */
  lastActiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns all tags connected to this risk area. */
  linkedTags?: Maybe<EsgTagConnection>;
  /** Whether this suite member topic is in the tenant's material reporting scope (null = not yet decided). */
  materialInScope?: Maybe<Scalars['Boolean']['output']>;
  /** Resolve source risk areas that were merged into the risk area */
  mergedRiskAreas?: Maybe<Array<RiskArea>>;
  /** Risk area name. */
  name: Esg_Subcategory;
  /** Order of risk area. */
  order?: Maybe<Scalars['Int']['output']>;
  /** The sellable representative parent of this content topic; null when the row represents itself (it is its own sellable framework). */
  repParentUuid?: Maybe<Scalars['ID']['output']>;
  /** Resolve risk areas on standard */
  riskAreas: Array<RiskArea>;
  /** Returns paginated list of sectors. Accessible for Tenant Admin */
  sectors?: Maybe<SectorConnection>;
  /** Resolves statistics for risk area. */
  statistics?: Maybe<EsgStatistics>;
  /** Steps for given subcategory. */
  steps: Array<EsgStep>;
  /** The kind of suite member this topic is - CORE is always in the tenant's material scope and cannot be toggled out, ELECTIVE follows the tenant's scope decisions. Null when the row is not a suite member. */
  suiteMemberKind?: Maybe<Suite_Member_Kind>;
  tags: TagConnection;
  /** Resolves target risk area that the risk area is merged to */
  targetRiskArea?: Maybe<RiskArea>;
  /** RiskArea type. */
  type?: Maybe<Esg_Subcategory_Type>;
  /** Return units by given standard UUID */
  units?: Maybe<Array<Unit>>;
  uuid: Scalars['ID']['output'];
  /** Whether the viewer holds a seat for this framework, i.e. may open its content. True for non-framework risk areas and while seat enforcement is off. Visibility of the risk area itself is a separate gate (framework module access). */
  viewerHasSeat: Scalars['Boolean']['output'];
};


export type RiskAreaFitnessArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type RiskAreaFitnessIndicatorsArgs = {
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type RiskAreaGroupTagsArgs = {
  input?: InputMaybe<RiskAreaGroupTagConnectionInput>;
};


export type RiskAreaGroupedStatisticsArgs = {
  input?: InputMaybe<EsgStatisticsInput>;
};


export type RiskAreaGuidelinesArgs = {
  input?: RiskAreaGuidelineConnectionInput;
};


export type RiskAreaGuidelinesCategoriesArgs = {
  input?: InputMaybe<GuidelinesCategoriesInput>;
};


export type RiskAreaLinkedTagsArgs = {
  input?: InputMaybe<EsgTagConnectionInput>;
};


export type RiskAreaRiskAreasArgs = {
  microservice?: InputMaybe<Risk_Areas_Service_Context>;
};


export type RiskAreaSectorsArgs = {
  input?: InputMaybe<SectorConnectionInput>;
};


export type RiskAreaStatisticsArgs = {
  input?: InputMaybe<EsgStatisticsInput>;
};


export type RiskAreaStepsArgs = {
  input?: EsgQuestionsInput;
};


export type RiskAreaTagsArgs = {
  input?: InputMaybe<RiskAreaTagConnectionInput>;
};

export type RiskAreaBatchUpdateInput = {
  riskAreas: Array<RiskAreaUpdateInput>;
};

export type RiskAreaByActivityInput = {
  /**
   * Selected activity
   * @deprecated Use field activityUuid instead
   */
  activity?: InputMaybe<Esg_Question_Activity>;
  /** Selected activity UUID */
  activityUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Microservice requesting the risk areas */
  microservice?: InputMaybe<Risk_Areas_Service_Context>;
};

export type RiskAreaGroupTagConnectionInput = {
  /** Group tag name filter. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<GroupTagSortInput>>;
};

export type RiskAreaGuidelineConnectionInput = {
  /** Limits results to given category name */
  categoriesNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional search input. Will look for matching category or guideline name that includes provided substring. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<GuidelineSortInput>>;
};

export type RiskAreaSettingsInput = {
  isEnabled: Scalars['Boolean']['input'];
  riskAreaUuid: Scalars['UUID']['input'];
  /** Optional risk area UUID to which move questions */
  targetRiskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type RiskAreaSettingsSetInput = {
  settings: Array<RiskAreaSettingsInput>;
};

export type RiskAreaSortFields =
  | 'CATEGORY'
  | 'NAME'
  | 'ORDER';

export type RiskAreaSortInput = {
  direction: SortDirection;
  field: RiskAreaSortFields;
};

export type RiskAreaTagConnectionInput = {
  /** Narrows tags to custom ones only. */
  customTagsOnly?: Scalars['Boolean']['input'];
  /** Tag UUIDs to exclude. */
  excludeUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of group tags names to limit search. Provide empty for all group tags. */
  groupTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional input for text search. Will limit search by risk area name, group tag name, tag name and description contents. */
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Array<Tag_Search_Scope>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<Tag_SortSortInput>>;
  /** Optional array of tags names to limit search. Provide empty for all tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RiskAreaUpdateInput = {
  /** Label of edited risk area. Null to delete TENANT_ADMIN own label */
  customLabel?: InputMaybe<Scalars['String']['input']>;
  /** UUID of given subcategory */
  uuid: Scalars['UUID']['input'];
};

/** Represents input type for risk areas query. */
export type RiskAreasInput = {
  /** Access mode filter. By default will only resolve risk areas that are enabled by user permissions. */
  accessMode?: Risk_Area_Access_Mode;
  /** Input to filter risk areas by those that have assigned any enabled risk area */
  hasSomeRiskAreaAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Input for inclusion of disabled risk areas. */
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Input for tag names filter. Only risk areas that contain tags with given names will be returned. */
  includeTagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set to false, will only return risk areas that have questions */
  includeWithNoQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Input for group tag names filter. Only risk areas that contain group tag with given name will be returned. */
  includesGroupTagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Microservice requesting the risk areas */
  microservice?: InputMaybe<Risk_Areas_Service_Context>;
  /** Input for risk area search by name */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Optional array for UUIDs of programmes. Will only return risk areas connected to given enabled programmes for current tenant */
  programmeUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Order input for list  */
  sort?: InputMaybe<Array<RiskAreasSortInput>>;
  /** Optional array for UUIDs of standards. Will only return risk areas connected to given standards */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array for UUIDs of tenants. Will only return risk areas connected to given tenants */
  tenantUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Input to filter risk areas by filters. Provide null for all risk areas. */
  types?: InputMaybe<Array<Esg_Subcategory_Type>>;
  /** Optional array for UUIDs of years. Will only return risk areas that have any questions that have answers for given year. */
  yearUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type RiskAreasSortInput = {
  direction: SortDirection;
  field: Risk_Areas_Sort;
};

export type RiskAreasWithAnyQuestionsElement = {
  /** Risk area that has any questions. If nullish indicates unmapped questions. */
  riskArea?: Maybe<RiskArea>;
};

export type RiskAreasWithAnyQuestionsInput = {
  /** Boolean value indicating should unmapped questions be included. */
  includeUnmapped?: Scalars['Boolean']['input'];
  mode: Esg_Related_Tasks_Mode;
  /** Array of standard UUIDs to scope query. */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type Role = {
  /** Role description */
  description?: Maybe<Scalars['String']['output']>;
  editMode: Role_Edit_Mode;
  /** Role status (is it active) */
  isActive: Scalars['Boolean']['output'];
  /** Role name */
  name: Scalars['String']['output'];
  permissions: Array<RolePermission>;
  regions: Array<Region>;
  riskAreas: Array<RoleRiskArea>;
  /** A list of users attached to this role. */
  users: Array<UserType>;
  /** Role UUID. */
  uuid: Scalars['ID']['output'];
};

export type RoleByUuidInput = {
  /** UUID of role. */
  uuid: Scalars['UUID']['input'];
};

/** Represents pagination connections of roles. */
export type RoleConnection = {
  /** Array of edges. */
  edges: Array<RoleEdge>;
  /** Array of direct nodes. */
  nodes: Array<Role>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of roles. */
export type RoleConnectionInput = {
  /** Narrows the result of pagination to given filter criteria. */
  filtering?: InputMaybe<RoleFilterInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Narrows the result of pagination to given search criteria. */
  searching?: InputMaybe<RoleSearchInput>;
};

/** Represents Role connection edge. */
export type RoleEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Role record. */
  node: Role;
};

/** Represents input for roles pagination filter. */
export type RoleFilterInput = {
  /**
   * Narrows the result of pagination by isActive. True for active roles,
   * false for inactive roles, null / undefined for all roles.
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RolePermission = CasesRolePermission | EsgRolePermission | RegularRolePermission;

export type RolePermissionInput = {
  /** Role permission name. */
  name: Assignable_Permission;
  /** Risk role UUID to which the permission is scoped. */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Subsidiary UUID to which the permission is scoped. */
  subsidiaryUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Role permission UUID. Required while update. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type RoleRiskArea = {
  /** Role permissions related to this risk area. */
  permissions: Array<Assignable_Permission>;
  riskArea: RiskArea;
};

/** Multiple search filter will work like OR condition. */
export type RoleSearchInput = {
  /** Narrows the result of pagination by description. */
  description?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by name. */
  name?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result to the given keywords. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

export type RoleStatusChange = {
  /** New status of role. */
  active: Scalars['Boolean']['input'];
  /** UUID of role to change status. */
  roleUuid: Scalars['UUID']['input'];
};

export type RoleUpsertInput = {
  /** Role description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Role name. */
  name: Scalars['String']['input'];
  /** Role permissions */
  permissions: Array<RolePermissionInput>;
  /** Regions UUIDs assigned to the role */
  regionsUuids: Array<Scalars['String']['input']>;
  /** Role UUID. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type RolesChangeStatusInput = {
  /** Roles to change status. */
  roles: Array<RoleStatusChange>;
};

export type RolesDeleteInput = {
  /** UUIDs of roles to delete. */
  roleUuids: Array<Scalars['UUID']['input']>;
};

export type RolesUpsertInput = {
  /** Roles to upsert. */
  roles: Array<RoleUpsertInput>;
};

export type Service_Modules_Key =
  | 'CARBON_LENS'
  | 'CASES'
  | 'DEMO'
  | 'DISCLOSURES'
  | 'DUE_DILIGENCE'
  | 'ESG'
  | 'FRAMEWORKS'
  | 'INSIGHTS'
  | 'NICOLE_GPT'
  | 'SSO'
  | 'SUBSIDIARY_SITES'
  | 'SURVEYS'
  | 'TASKS'
  | 'TEAMS'
  | 'TRAININGS';

/** Represents enumeration of possible assistant slot types. */
export type Slot_Type =
  | 'BUBBLE'
  | 'CALENDAR'
  | 'COUNTRY_SELECTOR'
  | 'MAP'
  | 'NONE'
  | 'TEXT';

export type Smart_Fill_Document_Status =
  | 'FAILED'
  | 'PROCESSED'
  | 'PROCESSING'
  | 'UPLOADED';

export type Smart_Fill_Draft_Status =
  | 'ACCEPTED'
  | 'DISMISSED'
  | 'PENDING';

export type Smart_Fill_Resume_Mode =
  | 'CONTINUE_WITHOUT'
  | 'RETRY';

/** Why Smart Fill could not read a document. */
export type Smart_Fill_Unread_Reason =
  | 'IMAGE_TOO_BIG'
  | 'NO_CONTENT'
  | 'PASSWORD_PROTECTED'
  | 'SHEET_TOO_BIG'
  | 'TRANSIENT'
  | 'UNSUPPORTED';

/** Enumeration of available SSO providers */
export type Sso_Provider =
  | 'SSO_AZURE'
  | 'SSO_SAML';

/** Represents enumeration of states codes. */
export type States_Code =
  | 'AD_02'
  | 'AD_03'
  | 'AD_04'
  | 'AD_05'
  | 'AD_06'
  | 'AD_07'
  | 'AD_08'
  | 'AE_01'
  | 'AE_02'
  | 'AE_03'
  | 'AE_04'
  | 'AE_05'
  | 'AE_06'
  | 'AE_07'
  | 'AF_01'
  | 'AF_02'
  | 'AF_03'
  | 'AF_05'
  | 'AF_06'
  | 'AF_07'
  | 'AF_08'
  | 'AF_09'
  | 'AF_10'
  | 'AF_11'
  | 'AF_13'
  | 'AF_14'
  | 'AF_17'
  | 'AF_18'
  | 'AF_19'
  | 'AF_23'
  | 'AF_24'
  | 'AF_26'
  | 'AF_27'
  | 'AF_28'
  | 'AF_29'
  | 'AF_30'
  | 'AF_31'
  | 'AF_32'
  | 'AF_33'
  | 'AF_34'
  | 'AF_35'
  | 'AF_36'
  | 'AF_37'
  | 'AF_38'
  | 'AF_39'
  | 'AF_40'
  | 'AF_41'
  | 'AF_42'
  | 'AG_01'
  | 'AG_03'
  | 'AG_04'
  | 'AG_05'
  | 'AG_06'
  | 'AG_07'
  | 'AG_08'
  | 'AG_09'
  | 'AL_40'
  | 'AL_41'
  | 'AL_42'
  | 'AL_43'
  | 'AL_44'
  | 'AL_45'
  | 'AL_46'
  | 'AL_47'
  | 'AL_48'
  | 'AL_49'
  | 'AL_50'
  | 'AL_51'
  | 'AM_01'
  | 'AM_02'
  | 'AM_03'
  | 'AM_04'
  | 'AM_05'
  | 'AM_06'
  | 'AM_07'
  | 'AM_08'
  | 'AM_09'
  | 'AM_10'
  | 'AM_11'
  | 'AO_01'
  | 'AO_02'
  | 'AO_03'
  | 'AO_04'
  | 'AO_05'
  | 'AO_06'
  | 'AO_07'
  | 'AO_08'
  | 'AO_09'
  | 'AO_12'
  | 'AO_13'
  | 'AO_14'
  | 'AO_15'
  | 'AO_16'
  | 'AO_17'
  | 'AO_18'
  | 'AO_19'
  | 'AO_20'
  | 'AQ_00'
  | 'AR_01'
  | 'AR_02'
  | 'AR_03'
  | 'AR_04'
  | 'AR_05'
  | 'AR_06'
  | 'AR_07'
  | 'AR_08'
  | 'AR_09'
  | 'AR_10'
  | 'AR_11'
  | 'AR_12'
  | 'AR_13'
  | 'AR_14'
  | 'AR_15'
  | 'AR_16'
  | 'AR_17'
  | 'AR_18'
  | 'AR_19'
  | 'AR_20'
  | 'AR_21'
  | 'AR_22'
  | 'AR_23'
  | 'AR_24'
  | 'AS_010'
  | 'AS_020'
  | 'AS_030'
  | 'AS_040'
  | 'AS_050'
  | 'AT_01'
  | 'AT_02'
  | 'AT_03'
  | 'AT_04'
  | 'AT_05'
  | 'AT_06'
  | 'AT_07'
  | 'AT_08'
  | 'AT_09'
  | 'AU_01'
  | 'AU_02'
  | 'AU_03'
  | 'AU_04'
  | 'AU_05'
  | 'AU_06'
  | 'AU_07'
  | 'AU_08'
  | 'AW_00'
  | 'AX_211'
  | 'AX_212'
  | 'AX_213'
  | 'AZ_01'
  | 'AZ_02'
  | 'AZ_03'
  | 'AZ_04'
  | 'AZ_05'
  | 'AZ_06'
  | 'AZ_07'
  | 'AZ_08'
  | 'AZ_09'
  | 'AZ_10'
  | 'AZ_11'
  | 'AZ_12'
  | 'AZ_13'
  | 'AZ_14'
  | 'AZ_15'
  | 'AZ_16'
  | 'AZ_18'
  | 'AZ_19'
  | 'AZ_20'
  | 'AZ_21'
  | 'AZ_22'
  | 'AZ_23'
  | 'AZ_24'
  | 'AZ_25'
  | 'AZ_26'
  | 'AZ_27'
  | 'AZ_28'
  | 'AZ_29'
  | 'AZ_31'
  | 'AZ_32'
  | 'AZ_33'
  | 'AZ_34'
  | 'AZ_35'
  | 'AZ_36'
  | 'AZ_37'
  | 'AZ_38'
  | 'AZ_39'
  | 'AZ_40'
  | 'AZ_41'
  | 'AZ_42'
  | 'AZ_43'
  | 'AZ_44'
  | 'AZ_45'
  | 'AZ_46'
  | 'AZ_47'
  | 'AZ_48'
  | 'AZ_49'
  | 'AZ_50'
  | 'AZ_51'
  | 'AZ_52'
  | 'AZ_53'
  | 'AZ_54'
  | 'AZ_55'
  | 'AZ_57'
  | 'AZ_58'
  | 'AZ_59'
  | 'AZ_60'
  | 'AZ_61'
  | 'AZ_62'
  | 'AZ_63'
  | 'AZ_64'
  | 'AZ_65'
  | 'AZ_66'
  | 'AZ_67'
  | 'AZ_68'
  | 'AZ_69'
  | 'AZ_70'
  | 'AZ_71'
  | 'BA_01'
  | 'BA_02'
  | 'BA_BRC'
  | 'BB_01'
  | 'BB_02'
  | 'BB_03'
  | 'BB_04'
  | 'BB_05'
  | 'BB_06'
  | 'BB_07'
  | 'BB_08'
  | 'BB_09'
  | 'BB_10'
  | 'BB_11'
  | 'BD_81'
  | 'BD_82'
  | 'BD_83'
  | 'BD_84'
  | 'BD_85'
  | 'BD_86'
  | 'BD_87'
  | 'BE_BRU'
  | 'BE_VAN'
  | 'BE_VBR'
  | 'BE_VLI'
  | 'BE_VOV'
  | 'BE_VWV'
  | 'BE_WBR'
  | 'BE_WHT'
  | 'BE_WLG'
  | 'BE_WLX'
  | 'BE_WNA'
  | 'BF_BAL'
  | 'BF_BAM'
  | 'BF_BAN'
  | 'BF_BAZ'
  | 'BF_BGR'
  | 'BF_BLG'
  | 'BF_BLK'
  | 'BF_COM'
  | 'BF_GAN'
  | 'BF_GNA'
  | 'BF_GOU'
  | 'BF_HOU'
  | 'BF_IOB'
  | 'BF_KAD'
  | 'BF_KEN'
  | 'BF_KMD'
  | 'BF_KMP'
  | 'BF_KOP'
  | 'BF_KOS'
  | 'BF_KOT'
  | 'BF_KOW'
  | 'BF_LER'
  | 'BF_LOR'
  | 'BF_MOU'
  | 'BF_NAM'
  | 'BF_NAO'
  | 'BF_NAY'
  | 'BF_NOU'
  | 'BF_OUB'
  | 'BF_OUD'
  | 'BF_PAS'
  | 'BF_PON'
  | 'BF_SEN'
  | 'BF_SIS'
  | 'BF_SMT'
  | 'BF_SNG'
  | 'BF_SOM'
  | 'BF_SOR'
  | 'BF_TAP'
  | 'BF_TUI'
  | 'BF_YAG'
  | 'BF_YAT'
  | 'BF_ZIR'
  | 'BF_ZON'
  | 'BF_ZOU'
  | 'BG_54'
  | 'BG_55'
  | 'BG_56'
  | 'BG_57'
  | 'BG_58'
  | 'BG_59'
  | 'BG_60'
  | 'BG_61'
  | 'BG_62'
  | 'BG_63'
  | 'BG_64'
  | 'BG_65'
  | 'BH_15'
  | 'BH_16'
  | 'BH_17'
  | 'BH_18'
  | 'BI_09'
  | 'BI_10'
  | 'BI_11'
  | 'BI_12'
  | 'BI_13'
  | 'BI_14'
  | 'BI_15'
  | 'BI_16'
  | 'BI_17'
  | 'BI_18'
  | 'BI_19'
  | 'BI_20'
  | 'BI_21'
  | 'BI_22'
  | 'BI_23'
  | 'BI_24'
  | 'BJ_07'
  | 'BJ_08'
  | 'BJ_09'
  | 'BJ_10'
  | 'BJ_11'
  | 'BJ_12'
  | 'BJ_13'
  | 'BJ_14'
  | 'BJ_15'
  | 'BJ_16'
  | 'BJ_17'
  | 'BJ_18'
  | 'BM_01'
  | 'BM_02'
  | 'BM_03'
  | 'BM_04'
  | 'BM_05'
  | 'BM_06'
  | 'BM_07'
  | 'BM_08'
  | 'BM_09'
  | 'BM_10'
  | 'BM_11'
  | 'BN_01'
  | 'BN_02'
  | 'BN_03'
  | 'BN_04'
  | 'BO_01'
  | 'BO_02'
  | 'BO_03'
  | 'BO_04'
  | 'BO_05'
  | 'BO_06'
  | 'BO_07'
  | 'BO_08'
  | 'BO_09'
  | 'BR_01'
  | 'BR_02'
  | 'BR_03'
  | 'BR_04'
  | 'BR_05'
  | 'BR_06'
  | 'BR_07'
  | 'BR_08'
  | 'BR_11'
  | 'BR_13'
  | 'BR_14'
  | 'BR_15'
  | 'BR_16'
  | 'BR_17'
  | 'BR_18'
  | 'BR_20'
  | 'BR_21'
  | 'BR_22'
  | 'BR_23'
  | 'BR_24'
  | 'BR_25'
  | 'BR_26'
  | 'BR_27'
  | 'BR_28'
  | 'BR_29'
  | 'BR_30'
  | 'BR_31'
  | 'BS_36'
  | 'BS_37'
  | 'BS_38'
  | 'BS_39'
  | 'BS_40'
  | 'BS_41'
  | 'BS_42'
  | 'BS_43'
  | 'BS_44'
  | 'BS_45'
  | 'BS_46'
  | 'BS_47'
  | 'BS_48'
  | 'BS_49'
  | 'BS_50'
  | 'BS_51'
  | 'BS_52'
  | 'BS_53'
  | 'BS_54'
  | 'BT_05'
  | 'BT_06'
  | 'BT_07'
  | 'BT_08'
  | 'BT_10'
  | 'BT_11'
  | 'BT_12'
  | 'BT_13'
  | 'BT_14'
  | 'BT_15'
  | 'BT_16'
  | 'BT_17'
  | 'BT_18'
  | 'BT_19'
  | 'BT_20'
  | 'BT_21'
  | 'BT_22'
  | 'BT_23'
  | 'BT_24'
  | 'BW_01'
  | 'BW_03'
  | 'BW_04'
  | 'BW_05'
  | 'BW_06'
  | 'BW_08'
  | 'BW_09'
  | 'BW_10'
  | 'BW_11'
  | 'BY_01'
  | 'BY_02'
  | 'BY_03'
  | 'BY_04'
  | 'BY_05'
  | 'BY_06'
  | 'BY_07'
  | 'BZ_01'
  | 'BZ_02'
  | 'BZ_03'
  | 'BZ_04'
  | 'BZ_05'
  | 'BZ_06'
  | 'CA_01'
  | 'CA_02'
  | 'CA_03'
  | 'CA_04'
  | 'CA_05'
  | 'CA_07'
  | 'CA_08'
  | 'CA_09'
  | 'CA_10'
  | 'CA_11'
  | 'CA_12'
  | 'CA_13'
  | 'CA_14'
  | 'CD_02'
  | 'CD_04'
  | 'CD_06'
  | 'CD_08'
  | 'CD_10'
  | 'CD_11'
  | 'CD_12'
  | 'CD_13'
  | 'CD_14'
  | 'CD_15'
  | 'CD_16'
  | 'CD_17'
  | 'CD_18'
  | 'CD_19'
  | 'CD_20'
  | 'CD_21'
  | 'CD_22'
  | 'CD_23'
  | 'CD_24'
  | 'CD_25'
  | 'CD_26'
  | 'CD_27'
  | 'CD_28'
  | 'CD_29'
  | 'CD_30'
  | 'CF_06'
  | 'CF_07'
  | 'CF_08'
  | 'CF_09'
  | 'CF_11'
  | 'CF_12'
  | 'CF_13'
  | 'CF_14'
  | 'CF_15'
  | 'CF_16'
  | 'CF_17'
  | 'CF_18'
  | 'CG_01'
  | 'CG_04'
  | 'CG_05'
  | 'CG_06'
  | 'CG_07'
  | 'CG_08'
  | 'CG_10'
  | 'CG_11'
  | 'CG_12'
  | 'CG_13'
  | 'CG_14'
  | 'CH_AG'
  | 'CH_AI'
  | 'CH_AR'
  | 'CH_BE'
  | 'CH_BL'
  | 'CH_BS'
  | 'CH_FR'
  | 'CH_GE'
  | 'CH_GL'
  | 'CH_GR'
  | 'CH_JU'
  | 'CH_LU'
  | 'CH_NE'
  | 'CH_NW'
  | 'CH_OW'
  | 'CH_SG'
  | 'CH_SH'
  | 'CH_SO'
  | 'CH_SZ'
  | 'CH_TG'
  | 'CH_TI'
  | 'CH_UR'
  | 'CI_83'
  | 'CI_85'
  | 'CI_87'
  | 'CI_89'
  | 'CI_90'
  | 'CI_92'
  | 'CI_93'
  | 'CI_94'
  | 'CI_95'
  | 'CI_96'
  | 'CI_97'
  | 'CI_98'
  | 'CK_126'
  | 'CK_384'
  | 'CK_388'
  | 'CK_425'
  | 'CL_01'
  | 'CL_02'
  | 'CL_03'
  | 'CL_04'
  | 'CL_05'
  | 'CL_06'
  | 'CL_07'
  | 'CL_08'
  | 'CL_10'
  | 'CL_11'
  | 'CL_12'
  | 'CL_14'
  | 'CL_15'
  | 'CL_16'
  | 'CL_17'
  | 'CM_04'
  | 'CM_05'
  | 'CM_07'
  | 'CM_08'
  | 'CM_09'
  | 'CM_10'
  | 'CM_11'
  | 'CM_12'
  | 'CM_13'
  | 'CM_14'
  | 'CN_01'
  | 'CN_02'
  | 'CN_03'
  | 'CN_04'
  | 'CN_05'
  | 'CN_06'
  | 'CN_07'
  | 'CN_08'
  | 'CN_09'
  | 'CN_10'
  | 'CN_11'
  | 'CN_12'
  | 'CN_13'
  | 'CN_14'
  | 'CN_15'
  | 'CN_16'
  | 'CN_18'
  | 'CN_19'
  | 'CN_20'
  | 'CN_21'
  | 'CN_22'
  | 'CN_23'
  | 'CN_24'
  | 'CN_25'
  | 'CN_26'
  | 'CN_28'
  | 'CN_29'
  | 'CN_30'
  | 'CN_31'
  | 'CO_22'
  | 'CO_23'
  | 'CO_24'
  | 'CO_25'
  | 'CO_26'
  | 'CO_27'
  | 'CO_28'
  | 'CO_29'
  | 'CO_30'
  | 'CO_31'
  | 'CO_32'
  | 'CO_33'
  | 'CO_34'
  | 'CO_35'
  | 'CO_36'
  | 'CO_37'
  | 'CO_38'
  | 'CR_01'
  | 'CR_02'
  | 'CR_03'
  | 'CR_04'
  | 'CR_06'
  | 'CR_07'
  | 'CR_08'
  | 'CU_01'
  | 'CU_02'
  | 'CU_03'
  | 'CU_04'
  | 'CU_05'
  | 'CU_07'
  | 'CU_08'
  | 'CU_09'
  | 'CU_10'
  | 'CU_12'
  | 'CU_13'
  | 'CU_14'
  | 'CU_15'
  | 'CU_16'
  | 'CU_AR'
  | 'CU_MA'
  | 'CV_05'
  | 'CV_07'
  | 'CV_08'
  | 'CV_11'
  | 'CV_13'
  | 'CV_14'
  | 'CV_15'
  | 'CV_16'
  | 'CV_17'
  | 'CV_18'
  | 'CV_19'
  | 'CV_20'
  | 'CV_21'
  | 'CV_22'
  | 'CV_23'
  | 'CV_24'
  | 'CV_25'
  | 'CV_26'
  | 'CV_27'
  | 'CY_01'
  | 'CY_02'
  | 'CY_03'
  | 'CY_04'
  | 'CY_05'
  | 'CY_06'
  | 'CZ_52'
  | 'CZ_78'
  | 'CZ_79'
  | 'CZ_80'
  | 'CZ_81'
  | 'CZ_82'
  | 'CZ_83'
  | 'CZ_84'
  | 'CZ_85'
  | 'CZ_86'
  | 'CZ_87'
  | 'CZ_88'
  | 'CZ_89'
  | 'CZ_90'
  | 'DE_02'
  | 'DE_03'
  | 'DE_04'
  | 'DE_05'
  | 'DE_06'
  | 'DE_07'
  | 'DE_08'
  | 'DE_09'
  | 'DE_10'
  | 'DE_11'
  | 'DE_12'
  | 'DE_13'
  | 'DE_14'
  | 'DE_15'
  | 'DE_16'
  | 'DJ_01'
  | 'DJ_04'
  | 'DJ_05'
  | 'DJ_06'
  | 'DJ_07'
  | 'DJ_08'
  | 'DK_17'
  | 'DK_18'
  | 'DK_19'
  | 'DK_20'
  | 'DK_21'
  | 'DM_02'
  | 'DM_03'
  | 'DM_04'
  | 'DM_05'
  | 'DM_06'
  | 'DM_07'
  | 'DM_08'
  | 'DM_09'
  | 'DM_10'
  | 'DM_11'
  | 'DO_01'
  | 'DO_02'
  | 'DO_03'
  | 'DO_04'
  | 'DO_06'
  | 'DO_08'
  | 'DO_09'
  | 'DO_10'
  | 'DO_11'
  | 'DO_12'
  | 'DO_14'
  | 'DO_15'
  | 'DO_16'
  | 'DO_18'
  | 'DO_19'
  | 'DO_20'
  | 'DO_21'
  | 'DO_23'
  | 'DO_24'
  | 'DO_25'
  | 'DO_26'
  | 'DO_27'
  | 'DO_28'
  | 'DO_29'
  | 'DO_30'
  | 'DO_31'
  | 'DO_32'
  | 'DO_33'
  | 'DO_34'
  | 'DO_35'
  | 'DO_36'
  | 'DO_37'
  | 'DZ_26'
  | 'DZ_27'
  | 'DZ_29'
  | 'DZ_30'
  | 'DZ_31'
  | 'DZ_33'
  | 'DZ_34'
  | 'DZ_35'
  | 'DZ_36'
  | 'DZ_37'
  | 'DZ_38'
  | 'DZ_39'
  | 'DZ_40'
  | 'DZ_41'
  | 'DZ_42'
  | 'DZ_43'
  | 'DZ_44'
  | 'DZ_45'
  | 'DZ_46'
  | 'DZ_47'
  | 'DZ_48'
  | 'DZ_49'
  | 'DZ_50'
  | 'DZ_51'
  | 'DZ_52'
  | 'DZ_53'
  | 'DZ_54'
  | 'DZ_55'
  | 'DZ_56'
  | 'EC_13'
  | 'EC_14'
  | 'EC_15'
  | 'EC_17'
  | 'EC_18'
  | 'EC_19'
  | 'EC_20'
  | 'EC_22'
  | 'EC_23'
  | 'EC_24'
  | 'EC_25'
  | 'EC_26'
  | 'EE_04'
  | 'EE_05'
  | 'EE_07'
  | 'EE_08'
  | 'EE_11'
  | 'EE_12'
  | 'EE_13'
  | 'EE_14'
  | 'EE_18'
  | 'EE_19'
  | 'EE_20'
  | 'EE_21'
  | 'EG_04'
  | 'EG_05'
  | 'EG_06'
  | 'EG_07'
  | 'EG_08'
  | 'EG_09'
  | 'EG_10'
  | 'EG_11'
  | 'EG_12'
  | 'EG_13'
  | 'EG_15'
  | 'EG_16'
  | 'EG_17'
  | 'EG_18'
  | 'EG_19'
  | 'EG_20'
  | 'EG_21'
  | 'EG_22'
  | 'EG_23'
  | 'EG_24'
  | 'EG_26'
  | 'EG_27'
  | 'EG_28'
  | 'EH_07'
  | 'EH_11'
  | 'EH_CE'
  | 'ER_01'
  | 'ER_02'
  | 'ER_03'
  | 'ER_04'
  | 'ER_05'
  | 'ER_06'
  | 'ES_07'
  | 'ES_27'
  | 'ES_29'
  | 'ES_31'
  | 'ES_32'
  | 'ES_34'
  | 'ES_39'
  | 'ES_51'
  | 'ES_52'
  | 'ES_53'
  | 'ES_54'
  | 'ES_55'
  | 'ES_56'
  | 'ES_57'
  | 'ES_58'
  | 'ES_59'
  | 'ES_60'
  | 'ES_CE'
  | 'ES_ML'
  | 'ET_44'
  | 'ET_45'
  | 'ET_46'
  | 'ET_47'
  | 'ET_48'
  | 'ET_49'
  | 'ET_50'
  | 'ET_51'
  | 'ET_52'
  | 'ET_53'
  | 'ET_54'
  | 'FI_17'
  | 'FI_18'
  | 'FI_19'
  | 'FI_20'
  | 'FI_22'
  | 'FI_23'
  | 'FI_24'
  | 'FI_25'
  | 'FI_26'
  | 'FI_27'
  | 'FI_28'
  | 'FI_29'
  | 'FI_30'
  | 'FI_31'
  | 'FI_32'
  | 'FI_33'
  | 'FI_34'
  | 'FI_35'
  | 'FJ_01'
  | 'FJ_02'
  | 'FJ_03'
  | 'FJ_04'
  | 'FJ_05'
  | 'FM_01'
  | 'FM_02'
  | 'FM_03'
  | 'FM_04'
  | 'FO_NO'
  | 'FO_OS'
  | 'FO_SA'
  | 'FO_ST'
  | 'FO_SU'
  | 'FO_VG'
  | 'FR_11'
  | 'FR_24'
  | 'FR_27'
  | 'FR_28'
  | 'FR_32'
  | 'FR_44'
  | 'FR_52'
  | 'FR_53'
  | 'FR_75'
  | 'FR_76'
  | 'FR_84'
  | 'FR_93'
  | 'FR_94'
  | 'GA_01'
  | 'GA_02'
  | 'GA_03'
  | 'GA_04'
  | 'GA_05'
  | 'GA_06'
  | 'GA_07'
  | 'GA_08'
  | 'GA_09'
  | 'GB_ENG'
  | 'GB_NIR'
  | 'GB_SCT'
  | 'GB_WLS'
  | 'GD_01'
  | 'GD_02'
  | 'GD_03'
  | 'GD_04'
  | 'GD_05'
  | 'GD_06'
  | 'GD_10'
  | 'GE_02'
  | 'GE_04'
  | 'GE_51'
  | 'GE_65'
  | 'GE_66'
  | 'GE_67'
  | 'GE_68'
  | 'GE_69'
  | 'GE_70'
  | 'GE_71'
  | 'GE_72'
  | 'GE_73'
  | 'GF_GF'
  | 'GG_00'
  | 'GH_01'
  | 'GH_02'
  | 'GH_03'
  | 'GH_04'
  | 'GH_05'
  | 'GH_06'
  | 'GH_08'
  | 'GH_09'
  | 'GH_10'
  | 'GH_11'
  | 'GL_04'
  | 'GL_05'
  | 'GL_06'
  | 'GL_07'
  | 'GM_01'
  | 'GM_02'
  | 'GM_03'
  | 'GM_04'
  | 'GM_05'
  | 'GM_07'
  | 'GN_B'
  | 'GN_C'
  | 'GN_D'
  | 'GN_F'
  | 'GN_K'
  | 'GN_L'
  | 'GN_M'
  | 'GN_N'
  | 'GP_GP'
  | 'GQ_03'
  | 'GQ_04'
  | 'GQ_05'
  | 'GQ_06'
  | 'GQ_07'
  | 'GQ_08'
  | 'GQ_09'
  | 'GR_19'
  | 'GR_35'
  | 'GR_49'
  | 'GR_51'
  | 'GR_69'
  | 'GR_A'
  | 'GR_B'
  | 'GR_C'
  | 'GR_D'
  | 'GR_E'
  | 'GR_F'
  | 'GR_G'
  | 'GR_H'
  | 'GR_I'
  | 'GR_J'
  | 'GR_K'
  | 'GR_L'
  | 'GR_M'
  | 'GT_01'
  | 'GT_02'
  | 'GT_03'
  | 'GT_04'
  | 'GT_05'
  | 'GT_06'
  | 'GT_07'
  | 'GT_08'
  | 'GT_09'
  | 'GT_10'
  | 'GT_11'
  | 'GT_12'
  | 'GT_13'
  | 'GT_14'
  | 'GT_15'
  | 'GT_16'
  | 'GT_17'
  | 'GT_18'
  | 'GT_19'
  | 'GT_20'
  | 'GT_21'
  | 'GT_22'
  | 'GU_IN'
  | 'GU_MA'
  | 'GU_ME'
  | 'GU_MT'
  | 'GU_PI'
  | 'GU_SJ'
  | 'GU_SR'
  | 'GU_TF'
  | 'GU_TM'
  | 'GU_UM'
  | 'GU_YG'
  | 'GU_YN'
  | 'GW_01'
  | 'GW_02'
  | 'GW_04'
  | 'GW_05'
  | 'GW_06'
  | 'GW_07'
  | 'GW_10'
  | 'GW_11'
  | 'GW_12'
  | 'GY_10'
  | 'GY_11'
  | 'GY_12'
  | 'GY_13'
  | 'GY_14'
  | 'GY_15'
  | 'GY_16'
  | 'GY_17'
  | 'GY_18'
  | 'GY_19'
  | 'HK_HCW'
  | 'HK_HEA'
  | 'HK_HSO'
  | 'HK_HWC'
  | 'HK_KKC'
  | 'HK_KKT'
  | 'HK_KSS'
  | 'HK_KWT'
  | 'HK_KYT'
  | 'HK_NIS'
  | 'HK_NKT'
  | 'HK_NNO'
  | 'HK_NSK'
  | 'HK_NST'
  | 'HK_NTM'
  | 'HK_NTP'
  | 'HK_NTW'
  | 'HK_NYL'
  | 'HN_01'
  | 'HN_02'
  | 'HN_03'
  | 'HN_04'
  | 'HN_05'
  | 'HN_06'
  | 'HN_07'
  | 'HN_08'
  | 'HN_09'
  | 'HN_10'
  | 'HN_11'
  | 'HN_12'
  | 'HN_13'
  | 'HN_14'
  | 'HN_15'
  | 'HN_16'
  | 'HN_17'
  | 'HN_18'
  | 'HR_06'
  | 'HR_07'
  | 'HR_08'
  | 'HR_09'
  | 'HR_10'
  | 'HR_11'
  | 'HR_12'
  | 'HR_13'
  | 'HR_14'
  | 'HR_15'
  | 'HR_16'
  | 'HR_17'
  | 'HR_18'
  | 'HR_19'
  | 'HR_20'
  | 'HR_21'
  | 'HT_03'
  | 'HT_06'
  | 'HT_07'
  | 'HT_09'
  | 'HT_10'
  | 'HT_11'
  | 'HT_12'
  | 'HT_13'
  | 'HT_14'
  | 'HT_15'
  | 'HU_01'
  | 'HU_02'
  | 'HU_03'
  | 'HU_04'
  | 'HU_05'
  | 'HU_06'
  | 'HU_08'
  | 'HU_09'
  | 'HU_10'
  | 'HU_11'
  | 'HU_12'
  | 'HU_14'
  | 'HU_16'
  | 'HU_17'
  | 'HU_18'
  | 'HU_20'
  | 'HU_21'
  | 'HU_22'
  | 'HU_23'
  | 'HU_24'
  | 'ID_10'
  | 'ID_11'
  | 'ID_12'
  | 'ID_13'
  | 'ID_14'
  | 'ID_15'
  | 'ID_17'
  | 'ID_18'
  | 'ID_21'
  | 'ID_22'
  | 'ID_24'
  | 'ID_26'
  | 'ID_28'
  | 'ID_29'
  | 'ID_30'
  | 'ID_31'
  | 'ID_32'
  | 'ID_33'
  | 'ID_34'
  | 'ID_35'
  | 'ID_36'
  | 'ID_37'
  | 'ID_38'
  | 'ID_39'
  | 'ID_40'
  | 'ID_41'
  | 'IE_LS'
  | 'IE_MH'
  | 'IE_MN'
  | 'IE_MO'
  | 'IE_OY'
  | 'IE_RN'
  | 'IE_SO'
  | 'IE_TA'
  | 'IE_WD'
  | 'IE_WH'
  | 'IE_WW'
  | 'IE_WX'
  | 'IL_01'
  | 'IL_02'
  | 'IL_03'
  | 'IL_04'
  | 'IL_05'
  | 'IL_06'
  | 'IL_WE'
  | 'IM_00'
  | 'IN_01'
  | 'IN_02'
  | 'IN_03'
  | 'IN_05'
  | 'IN_06'
  | 'IN_07'
  | 'IN_09'
  | 'IN_10'
  | 'IN_11'
  | 'IN_12'
  | 'IN_13'
  | 'IN_14'
  | 'IN_16'
  | 'IN_17'
  | 'IN_18'
  | 'IN_19'
  | 'IN_20'
  | 'IN_21'
  | 'IN_22'
  | 'IO_00'
  | 'IQ_01'
  | 'IQ_02'
  | 'IQ_03'
  | 'IQ_04'
  | 'IQ_05'
  | 'IQ_06'
  | 'IQ_07'
  | 'IQ_08'
  | 'IQ_09'
  | 'IQ_10'
  | 'IQ_11'
  | 'IQ_12'
  | 'IQ_13'
  | 'IQ_14'
  | 'IQ_15'
  | 'IQ_16'
  | 'IQ_17'
  | 'IQ_18'
  | 'IR_08'
  | 'IR_09'
  | 'IR_10'
  | 'IR_11'
  | 'IR_13'
  | 'IR_15'
  | 'IR_16'
  | 'IR_22'
  | 'IR_23'
  | 'IR_25'
  | 'IR_26'
  | 'IR_28'
  | 'IR_29'
  | 'IR_32'
  | 'IR_33'
  | 'IR_34'
  | 'IR_35'
  | 'IR_36'
  | 'IR_37'
  | 'IR_38'
  | 'IR_39'
  | 'IR_40'
  | 'IR_41'
  | 'IR_42'
  | 'IR_43'
  | 'IR_44'
  | 'IS_38'
  | 'IS_39'
  | 'IS_40'
  | 'IS_41'
  | 'IS_42'
  | 'IS_43'
  | 'IS_44'
  | 'IS_45'
  | 'IT_01'
  | 'IT_02'
  | 'IT_03'
  | 'IT_04'
  | 'IT_05'
  | 'IT_06'
  | 'IT_07'
  | 'IT_08'
  | 'IT_09'
  | 'IT_10'
  | 'IT_11'
  | 'IT_12'
  | 'IT_13'
  | 'IT_14'
  | 'IT_15'
  | 'IT_16'
  | 'IT_17'
  | 'IT_18'
  | 'IT_19'
  | 'IT_20'
  | 'JE_00'
  | 'JM_01'
  | 'JM_02'
  | 'JM_04'
  | 'JM_07'
  | 'JM_08'
  | 'JM_09'
  | 'JM_10'
  | 'JM_11'
  | 'JM_12'
  | 'JM_13'
  | 'JM_14'
  | 'JM_15'
  | 'JM_16'
  | 'JM_17'
  | 'JO_02'
  | 'JO_09'
  | 'JO_12'
  | 'JO_15'
  | 'JO_16'
  | 'JO_17'
  | 'JO_18'
  | 'JO_19'
  | 'JO_20'
  | 'JO_21'
  | 'JO_22'
  | 'JO_23'
  | 'JP_01'
  | 'JP_02'
  | 'JP_03'
  | 'JP_04'
  | 'JP_05'
  | 'JP_06'
  | 'JP_07'
  | 'JP_08'
  | 'JP_09'
  | 'JP_10'
  | 'JP_11'
  | 'JP_12'
  | 'JP_13'
  | 'JP_14'
  | 'JP_15'
  | 'JP_16'
  | 'JP_17'
  | 'JP_18'
  | 'JP_19'
  | 'JP_20'
  | 'JP_21'
  | 'JP_22'
  | 'JP_23'
  | 'JP_24'
  | 'JP_25'
  | 'JP_26'
  | 'JP_27'
  | 'JP_28'
  | 'JP_29'
  | 'JP_30'
  | 'JP_31'
  | 'JP_32'
  | 'JP_33'
  | 'JP_34'
  | 'JP_35'
  | 'JP_36'
  | 'JP_37'
  | 'JP_38'
  | 'JP_39'
  | 'JP_40'
  | 'JP_41'
  | 'JP_42'
  | 'JP_43'
  | 'JP_44'
  | 'JP_45'
  | 'JP_46'
  | 'JP_47'
  | 'KE_05'
  | 'KE_10'
  | 'KE_11'
  | 'KE_12'
  | 'KE_13'
  | 'KE_14'
  | 'KE_15'
  | 'KE_16'
  | 'KE_17'
  | 'KE_18'
  | 'KE_19'
  | 'KE_20'
  | 'KE_21'
  | 'KE_22'
  | 'KE_23'
  | 'KE_24'
  | 'KE_25'
  | 'KE_26'
  | 'KE_27'
  | 'KE_28'
  | 'KE_29'
  | 'KE_30'
  | 'KE_31'
  | 'KE_32'
  | 'KE_33'
  | 'KE_34'
  | 'KE_35'
  | 'KE_36'
  | 'KE_37'
  | 'KE_38'
  | 'KE_39'
  | 'KE_40'
  | 'KE_41'
  | 'KE_42'
  | 'KE_43'
  | 'KE_44'
  | 'KE_45'
  | 'KE_46'
  | 'KE_47'
  | 'KE_48'
  | 'KE_49'
  | 'KE_50'
  | 'KE_51'
  | 'KE_52'
  | 'KE_53'
  | 'KE_54'
  | 'KE_55'
  | 'KG_01'
  | 'KG_02'
  | 'KG_03'
  | 'KG_04'
  | 'KG_06'
  | 'KG_07'
  | 'KG_08'
  | 'KG_09'
  | 'KG_10'
  | 'KH_02'
  | 'KH_03'
  | 'KH_04'
  | 'KH_05'
  | 'KH_07'
  | 'KH_08'
  | 'KH_09'
  | 'KH_10'
  | 'KH_12'
  | 'KH_13'
  | 'KH_14'
  | 'KH_17'
  | 'KH_18'
  | 'KH_19'
  | 'KH_21'
  | 'KH_22'
  | 'KH_23'
  | 'KH_24'
  | 'KH_25'
  | 'KH_26'
  | 'KH_27'
  | 'KH_28'
  | 'KH_29'
  | 'KH_30'
  | 'KI_01'
  | 'KI_02'
  | 'KI_03'
  | 'KM_01'
  | 'KM_02'
  | 'KM_03'
  | 'KN_01'
  | 'KN_02'
  | 'KN_03'
  | 'KN_04'
  | 'KN_05'
  | 'KN_06'
  | 'KN_07'
  | 'KN_08'
  | 'KN_09'
  | 'KN_10'
  | 'KN_11'
  | 'KN_12'
  | 'KN_13'
  | 'KN_15'
  | 'KP_01'
  | 'KP_03'
  | 'KP_06'
  | 'KP_07'
  | 'KP_09'
  | 'KP_11'
  | 'KP_12'
  | 'KP_13'
  | 'KP_15'
  | 'KP_17'
  | 'KP_18'
  | 'KR_01'
  | 'KR_03'
  | 'KR_05'
  | 'KR_06'
  | 'KR_10'
  | 'KR_11'
  | 'KR_12'
  | 'KR_13'
  | 'KR_14'
  | 'KR_15'
  | 'KR_16'
  | 'KR_17'
  | 'KR_18'
  | 'KR_19'
  | 'KR_20'
  | 'KR_21'
  | 'KV_01'
  | 'KV_02'
  | 'KV_03'
  | 'KV_04'
  | 'KV_05'
  | 'KV_06'
  | 'KV_07'
  | 'KW_02'
  | 'KW_04'
  | 'KW_05'
  | 'KW_07'
  | 'KW_08'
  | 'KW_09'
  | 'KZ_01'
  | 'KZ_02'
  | 'KZ_03'
  | 'KZ_04'
  | 'KZ_05'
  | 'KZ_06'
  | 'KZ_07'
  | 'KZ_08'
  | 'KZ_09'
  | 'KZ_10'
  | 'KZ_11'
  | 'KZ_12'
  | 'KZ_13'
  | 'KZ_14'
  | 'KZ_15'
  | 'KZ_16'
  | 'KZ_17'
  | 'LA_01'
  | 'LA_02'
  | 'LA_03'
  | 'LA_07'
  | 'LA_13'
  | 'LA_14'
  | 'LA_15'
  | 'LA_16'
  | 'LA_17'
  | 'LA_18'
  | 'LA_19'
  | 'LA_20'
  | 'LA_22'
  | 'LA_23'
  | 'LA_24'
  | 'LA_26'
  | 'LA_27'
  | 'LB_04'
  | 'LB_05'
  | 'LB_06'
  | 'LB_07'
  | 'LB_08'
  | 'LB_09'
  | 'LB_10'
  | 'LB_11'
  | 'LC_01'
  | 'LC_03'
  | 'LC_04'
  | 'LC_05'
  | 'LC_06'
  | 'LC_07'
  | 'LC_08'
  | 'LC_09'
  | 'LC_10'
  | 'LI_01'
  | 'LI_02'
  | 'LI_03'
  | 'LI_04'
  | 'LI_05'
  | 'LI_06'
  | 'LI_07'
  | 'LI_08'
  | 'LI_09'
  | 'LI_10'
  | 'LI_11'
  | 'LK_29'
  | 'LK_30'
  | 'LK_32'
  | 'LK_33'
  | 'LK_34'
  | 'LK_35'
  | 'LK_36'
  | 'LK_38'
  | 'LR_01'
  | 'LR_09'
  | 'LR_10'
  | 'LR_11'
  | 'LR_12'
  | 'LR_13'
  | 'LR_14'
  | 'LR_15'
  | 'LR_16'
  | 'LR_17'
  | 'LR_18'
  | 'LR_19'
  | 'LR_20'
  | 'LR_21'
  | 'LR_22'
  | 'LS_10'
  | 'LS_11'
  | 'LS_12'
  | 'LS_13'
  | 'LS_14'
  | 'LS_15'
  | 'LS_16'
  | 'LS_17'
  | 'LS_18'
  | 'LS_19'
  | 'LT_56'
  | 'LT_57'
  | 'LT_58'
  | 'LT_59'
  | 'LT_60'
  | 'LT_61'
  | 'LT_62'
  | 'LT_63'
  | 'LT_64'
  | 'LT_65'
  | 'LU_02'
  | 'LU_03'
  | 'LV_01'
  | 'LV_02'
  | 'LV_03'
  | 'LV_04'
  | 'LV_05'
  | 'LV_06'
  | 'LV_07'
  | 'LV_08'
  | 'LV_09'
  | 'LV_10'
  | 'LV_11'
  | 'LV_12'
  | 'LV_13'
  | 'LV_14'
  | 'LV_15'
  | 'LV_16'
  | 'LV_17'
  | 'LV_18'
  | 'LV_19'
  | 'LV_20'
  | 'LV_21'
  | 'LV_22'
  | 'LV_23'
  | 'LV_24'
  | 'LV_25'
  | 'LV_27'
  | 'LV_28'
  | 'LV_29'
  | 'LV_30'
  | 'LV_31'
  | 'LV_32'
  | 'LV_33'
  | 'LV_34'
  | 'LV_35'
  | 'LV_37'
  | 'LV_38'
  | 'LV_39'
  | 'LV_40'
  | 'LV_42'
  | 'LV_43'
  | 'LV_44'
  | 'LV_45'
  | 'LV_46'
  | 'LV_47'
  | 'LV_50'
  | 'LV_51'
  | 'LV_52'
  | 'LV_53'
  | 'LV_55'
  | 'LV_56'
  | 'LV_57'
  | 'LV_60'
  | 'LV_61'
  | 'LV_62'
  | 'LV_63'
  | 'LV_64'
  | 'LV_65'
  | 'LV_67'
  | 'LV_68'
  | 'LV_69'
  | 'LV_70'
  | 'LV_71'
  | 'LV_72'
  | 'LV_73'
  | 'LV_77'
  | 'LV_78'
  | 'LV_79'
  | 'LV_80'
  | 'LV_81'
  | 'LV_82'
  | 'LV_84'
  | 'LV_85'
  | 'LV_87'
  | 'LV_88'
  | 'LV_90'
  | 'LV_91'
  | 'LV_94'
  | 'LV_95'
  | 'LV_96'
  | 'LV_97'
  | 'LV_98'
  | 'LV_99'
  | 'LV_A2'
  | 'LV_A3'
  | 'LV_A4'
  | 'LV_A5'
  | 'LV_A6'
  | 'LV_A8'
  | 'LV_A9'
  | 'LV_B1'
  | 'LV_B3'
  | 'LV_B4'
  | 'LV_B5'
  | 'LV_B6'
  | 'LV_B7'
  | 'LV_B8'
  | 'LV_B9'
  | 'LV_C1'
  | 'LV_C2'
  | 'LV_C3'
  | 'LV_C5'
  | 'LV_C6'
  | 'LV_C7'
  | 'LV_C8'
  | 'LV_C9'
  | 'LV_D1'
  | 'LV_D2'
  | 'LV_D3'
  | 'LV_D5'
  | 'LV_D7'
  | 'LV_E1'
  | 'LV_E2'
  | 'LV_E3'
  | 'LV_E4'
  | 'LV_E6'
  | 'LV_E7'
  | 'LV_E8'
  | 'LV_E9'
  | 'LY_63'
  | 'LY_64'
  | 'LY_65'
  | 'LY_66'
  | 'LY_67'
  | 'LY_68'
  | 'LY_69'
  | 'LY_70'
  | 'LY_71'
  | 'LY_72'
  | 'LY_73'
  | 'LY_74'
  | 'LY_75'
  | 'LY_76'
  | 'LY_77'
  | 'LY_78'
  | 'LY_79'
  | 'LY_80'
  | 'LY_81'
  | 'LY_82'
  | 'LY_83'
  | 'LY_84'
  | 'MA_45'
  | 'MA_46'
  | 'MA_47'
  | 'MA_48'
  | 'MA_49'
  | 'MA_50'
  | 'MA_51'
  | 'MA_52'
  | 'MA_53'
  | 'MA_54'
  | 'MA_55'
  | 'MA_56'
  | 'MA_57'
  | 'MA_58'
  | 'MA_59'
  | 'MA_CE'
  | 'MA_EH'
  | 'MC_00'
  | 'MD_51'
  | 'MD_57'
  | 'MD_58'
  | 'MD_59'
  | 'MD_60'
  | 'MD_61'
  | 'MD_62'
  | 'MD_63'
  | 'MD_64'
  | 'MD_65'
  | 'MD_66'
  | 'MD_67'
  | 'MD_68'
  | 'MD_69'
  | 'MD_70'
  | 'MD_71'
  | 'MD_72'
  | 'MD_73'
  | 'MD_74'
  | 'MD_75'
  | 'MD_76'
  | 'MD_77'
  | 'MD_78'
  | 'MD_79'
  | 'MD_80'
  | 'MD_81'
  | 'MD_82'
  | 'MD_83'
  | 'MD_84'
  | 'MD_85'
  | 'MD_86'
  | 'MD_87'
  | 'MD_88'
  | 'MD_89'
  | 'MD_90'
  | 'MD_91'
  | 'MD_92'
  | 'ME_01'
  | 'ME_02'
  | 'ME_03'
  | 'ME_04'
  | 'ME_05'
  | 'ME_06'
  | 'ME_07'
  | 'ME_08'
  | 'ME_09'
  | 'ME_10'
  | 'ME_11'
  | 'ME_12'
  | 'ME_13'
  | 'ME_14'
  | 'ME_15'
  | 'ME_16'
  | 'ME_17'
  | 'ME_18'
  | 'ME_19'
  | 'ME_20'
  | 'ME_21'
  | 'MG_01'
  | 'MG_02'
  | 'MG_03'
  | 'MG_04'
  | 'MG_05'
  | 'MG_06'
  | 'MH_010'
  | 'MH_030'
  | 'MH_040'
  | 'MH_050'
  | 'MH_080'
  | 'MH_090'
  | 'MH_110'
  | 'MH_120'
  | 'MH_140'
  | 'MH_150'
  | 'MH_160'
  | 'MH_170'
  | 'MH_180'
  | 'MH_190'
  | 'MH_300'
  | 'MH_310'
  | 'MH_320'
  | 'MH_330'
  | 'MH_340'
  | 'MH_350'
  | 'MH_390'
  | 'MH_400'
  | 'MH_410'
  | 'MH_420'
  | 'MH_430'
  | 'MK_01'
  | 'MK_04'
  | 'MK_06'
  | 'MK_08'
  | 'MK_11'
  | 'MK_12'
  | 'MK_18'
  | 'MK_19'
  | 'MK_20'
  | 'MK_22'
  | 'MK_25'
  | 'MK_28'
  | 'MK_33'
  | 'MK_35'
  | 'MK_36'
  | 'MK_40'
  | 'MK_41'
  | 'MK_43'
  | 'MK_44'
  | 'MK_46'
  | 'MK_47'
  | 'MK_51'
  | 'MK_52'
  | 'MK_53'
  | 'MK_54'
  | 'MK_59'
  | 'MK_60'
  | 'MK_62'
  | 'MK_69'
  | 'MK_72'
  | 'MK_78'
  | 'MK_79'
  | 'MK_80'
  | 'MK_83'
  | 'MK_84'
  | 'MK_85'
  | 'MK_86'
  | 'MK_87'
  | 'MK_92'
  | 'MK_97'
  | 'MK_98'
  | 'MK_A2'
  | 'MK_A3'
  | 'MK_A4'
  | 'MK_A5'
  | 'MK_A9'
  | 'MK_B3'
  | 'MK_B4'
  | 'MK_B7'
  | 'MK_C2'
  | 'MK_C3'
  | 'MK_C6'
  | 'MK_C7'
  | 'MK_C8'
  | 'MK_C9'
  | 'MK_D2'
  | 'MK_D3'
  | 'MK_D4'
  | 'MK_D5'
  | 'MK_D6'
  | 'MK_D7'
  | 'MK_D8'
  | 'MK_D9'
  | 'MK_E1'
  | 'MK_E2'
  | 'MK_E3'
  | 'MK_E4'
  | 'MK_E5'
  | 'MK_E6'
  | 'MK_E7'
  | 'MK_E8'
  | 'MK_E9'
  | 'MK_F1'
  | 'MK_F4'
  | 'MK_F5'
  | 'ML_01'
  | 'ML_03'
  | 'ML_04'
  | 'ML_05'
  | 'ML_06'
  | 'ML_07'
  | 'ML_08'
  | 'ML_09'
  | 'ML_10'
  | 'MM_01'
  | 'MM_02'
  | 'MM_03'
  | 'MM_04'
  | 'MM_05'
  | 'MM_06'
  | 'MM_08'
  | 'MM_10'
  | 'MM_11'
  | 'MM_12'
  | 'MM_13'
  | 'MM_15'
  | 'MM_16'
  | 'MM_17'
  | 'MN_01'
  | 'MN_02'
  | 'MN_03'
  | 'MN_06'
  | 'MN_07'
  | 'MN_08'
  | 'MN_09'
  | 'MN_10'
  | 'MN_11'
  | 'MN_12'
  | 'MN_13'
  | 'MN_14'
  | 'MN_15'
  | 'MN_16'
  | 'MN_17'
  | 'MN_18'
  | 'MN_19'
  | 'MN_20'
  | 'MN_21'
  | 'MN_23'
  | 'MN_24'
  | 'MN_25'
  | 'MO_01'
  | 'MO_02'
  | 'MP_085'
  | 'MP_100'
  | 'MP_110'
  | 'MP_120'
  | 'MQ_FF'
  | 'MQ_MA'
  | 'MQ_SP'
  | 'MQ_TR'
  | 'MR_01'
  | 'MR_02'
  | 'MR_03'
  | 'MR_04'
  | 'MR_05'
  | 'MR_06'
  | 'MR_07'
  | 'MR_08'
  | 'MR_09'
  | 'MR_10'
  | 'MR_11'
  | 'MR_12'
  | 'MR_NKC'
  | 'MS_01'
  | 'MS_02'
  | 'MS_03'
  | 'MT_01'
  | 'MT_02'
  | 'MT_03'
  | 'MT_04'
  | 'MT_05'
  | 'MT_06'
  | 'MT_07'
  | 'MT_08'
  | 'MT_09'
  | 'MT_10'
  | 'MT_11'
  | 'MT_12'
  | 'MT_13'
  | 'MT_14'
  | 'MT_15'
  | 'MT_16'
  | 'MT_17'
  | 'MT_18'
  | 'MT_19'
  | 'MT_20'
  | 'MT_21'
  | 'MT_22'
  | 'MT_23'
  | 'MT_24'
  | 'MT_25'
  | 'MT_26'
  | 'MT_27'
  | 'MT_28'
  | 'MT_29'
  | 'MT_30'
  | 'MT_31'
  | 'MT_32'
  | 'MT_33'
  | 'MT_34'
  | 'MT_35'
  | 'MT_36'
  | 'MT_37'
  | 'MT_38'
  | 'MT_39'
  | 'MT_40'
  | 'MT_41'
  | 'MT_42'
  | 'MT_43'
  | 'MT_44'
  | 'MT_45'
  | 'MT_46'
  | 'MT_47'
  | 'MT_48'
  | 'MT_49'
  | 'MT_50'
  | 'MT_51'
  | 'MT_52'
  | 'MT_53'
  | 'MT_54'
  | 'MT_55'
  | 'MT_56'
  | 'MT_57'
  | 'MT_58'
  | 'MT_59'
  | 'MT_60'
  | 'MT_61'
  | 'MT_62'
  | 'MT_63'
  | 'MT_64'
  | 'MT_65'
  | 'MT_66'
  | 'MT_67'
  | 'MT_68'
  | 'MU_12'
  | 'MU_13'
  | 'MU_14'
  | 'MU_15'
  | 'MU_16'
  | 'MU_17'
  | 'MU_18'
  | 'MU_19'
  | 'MU_20'
  | 'MU_21'
  | 'MU_23'
  | 'MV_01'
  | 'MV_05'
  | 'MV_30'
  | 'MV_31'
  | 'MV_32'
  | 'MV_33'
  | 'MV_34'
  | 'MV_36'
  | 'MV_37'
  | 'MV_38'
  | 'MV_39'
  | 'MV_40'
  | 'MV_42'
  | 'MV_43'
  | 'MV_44'
  | 'MV_45'
  | 'MV_46'
  | 'MV_47'
  | 'MV_48'
  | 'MV_49'
  | 'MV_50'
  | 'MV_51'
  | 'MV_53'
  | 'MV_75'
  | 'MW_BA'
  | 'MW_BL'
  | 'MW_CK'
  | 'MW_CR'
  | 'MW_CT'
  | 'MW_DE'
  | 'MW_DO'
  | 'MW_KR'
  | 'MW_KS'
  | 'MW_LI'
  | 'MW_LK'
  | 'MW_MC'
  | 'MW_MG'
  | 'MW_MH'
  | 'MW_MU'
  | 'MW_MW'
  | 'MW_MZ'
  | 'MW_NB'
  | 'MW_NE'
  | 'MW_NI'
  | 'MW_NK'
  | 'MW_NS'
  | 'MW_NU'
  | 'MW_PH'
  | 'MW_RU'
  | 'MW_SA'
  | 'MW_TH'
  | 'MW_ZO'
  | 'MX_01'
  | 'MX_02'
  | 'MX_03'
  | 'MX_04'
  | 'MX_05'
  | 'MX_06'
  | 'MX_07'
  | 'MX_08'
  | 'MX_09'
  | 'MX_10'
  | 'MX_11'
  | 'MX_12'
  | 'MX_13'
  | 'MX_14'
  | 'MX_15'
  | 'MX_16'
  | 'MX_17'
  | 'MX_18'
  | 'MX_19'
  | 'MX_20'
  | 'MX_21'
  | 'MX_22'
  | 'MX_23'
  | 'MX_24'
  | 'MX_25'
  | 'MX_26'
  | 'MX_27'
  | 'MX_28'
  | 'MX_29'
  | 'MX_30'
  | 'MX_31'
  | 'MX_32'
  | 'MY_01'
  | 'MY_02'
  | 'MY_03'
  | 'MY_04'
  | 'MY_05'
  | 'MY_06'
  | 'MY_07'
  | 'MY_08'
  | 'MY_09'
  | 'MY_11'
  | 'MY_12'
  | 'MY_13'
  | 'MY_14'
  | 'MY_15'
  | 'MY_16'
  | 'MY_17'
  | 'MZ_01'
  | 'MZ_02'
  | 'MZ_03'
  | 'MZ_04'
  | 'MZ_05'
  | 'MZ_06'
  | 'MZ_07'
  | 'MZ_08'
  | 'MZ_09'
  | 'MZ_10'
  | 'MZ_11'
  | 'NA_21'
  | 'NA_28'
  | 'NA_29'
  | 'NA_30'
  | 'NA_31'
  | 'NA_32'
  | 'NA_33'
  | 'NA_35'
  | 'NA_36'
  | 'NA_37'
  | 'NA_38'
  | 'NA_39'
  | 'NC_01'
  | 'NC_02'
  | 'NC_03'
  | 'NE_01'
  | 'NE_02'
  | 'NE_03'
  | 'NE_04'
  | 'NE_06'
  | 'NE_07'
  | 'NE_08'
  | 'NE_09'
  | 'NG_05'
  | 'NG_11'
  | 'NG_16'
  | 'NG_21'
  | 'NG_22'
  | 'NG_23'
  | 'NG_24'
  | 'NG_25'
  | 'NG_26'
  | 'NG_27'
  | 'NG_28'
  | 'NG_29'
  | 'NG_30'
  | 'NG_31'
  | 'NG_32'
  | 'NG_35'
  | 'NG_36'
  | 'NG_37'
  | 'NG_39'
  | 'NG_40'
  | 'NG_41'
  | 'NG_42'
  | 'NG_43'
  | 'NG_44'
  | 'NG_45'
  | 'NG_46'
  | 'NG_47'
  | 'NG_48'
  | 'NG_49'
  | 'NG_50'
  | 'NG_51'
  | 'NG_52'
  | 'NG_53'
  | 'NG_54'
  | 'NG_55'
  | 'NG_56'
  | 'NG_57'
  | 'NI_01'
  | 'NI_02'
  | 'NI_03'
  | 'NI_04'
  | 'NI_05'
  | 'NI_06'
  | 'NI_07'
  | 'NI_08'
  | 'NI_09'
  | 'NI_10'
  | 'NI_11'
  | 'NI_12'
  | 'NI_13'
  | 'NI_14'
  | 'NI_15'
  | 'NI_17'
  | 'NI_18'
  | 'NL_01'
  | 'NL_02'
  | 'NL_03'
  | 'NL_04'
  | 'NL_05'
  | 'NL_06'
  | 'NL_07'
  | 'NL_09'
  | 'NL_10'
  | 'NL_11'
  | 'NL_15'
  | 'NL_16'
  | 'NO_01'
  | 'NO_02'
  | 'NO_04'
  | 'NO_05'
  | 'NO_06'
  | 'NO_07'
  | 'NO_08'
  | 'NO_09'
  | 'NO_10'
  | 'NO_11'
  | 'NO_12'
  | 'NO_13'
  | 'NO_14'
  | 'NO_15'
  | 'NO_16'
  | 'NO_17'
  | 'NO_18'
  | 'NO_19'
  | 'NO_20'
  | 'NP_BA'
  | 'NP_BH'
  | 'NP_DH'
  | 'NP_GA'
  | 'NP_JA'
  | 'NP_KA'
  | 'NP_KO'
  | 'NP_LU'
  | 'NP_MA'
  | 'NP_ME'
  | 'NP_NA'
  | 'NP_RA'
  | 'NP_SA'
  | 'NP_SE'
  | 'NR_01'
  | 'NR_02'
  | 'NR_03'
  | 'NR_04'
  | 'NR_05'
  | 'NR_06'
  | 'NR_07'
  | 'NR_09'
  | 'NR_10'
  | 'NR_11'
  | 'NR_12'
  | 'NR_13'
  | 'NR_14'
  | 'NZ_10'
  | 'NZ_E7'
  | 'NZ_E8'
  | 'NZ_E9'
  | 'NZ_F1'
  | 'NZ_F2'
  | 'NZ_F3'
  | 'NZ_F4'
  | 'NZ_F5'
  | 'NZ_F6'
  | 'NZ_F7'
  | 'NZ_F8'
  | 'NZ_F9'
  | 'NZ_G1'
  | 'NZ_G2'
  | 'NZ_G3'
  | 'NZ_TAS'
  | 'OM_01'
  | 'OM_02'
  | 'OM_03'
  | 'OM_04'
  | 'OM_06'
  | 'OM_07'
  | 'OM_08'
  | 'OM_09'
  | 'OM_10'
  | 'PA_01'
  | 'PA_02'
  | 'PA_03'
  | 'PA_04'
  | 'PA_05'
  | 'PA_06'
  | 'PA_07'
  | 'PA_08'
  | 'PA_09'
  | 'PA_10'
  | 'PA_11'
  | 'PA_12'
  | 'PE_01'
  | 'PE_02'
  | 'PE_03'
  | 'PE_04'
  | 'PE_05'
  | 'PE_06'
  | 'PE_07'
  | 'PE_08'
  | 'PE_09'
  | 'PE_10'
  | 'PE_11'
  | 'PE_12'
  | 'PE_13'
  | 'PE_14'
  | 'PE_15'
  | 'PE_16'
  | 'PE_17'
  | 'PE_18'
  | 'PE_19'
  | 'PE_20'
  | 'PE_21'
  | 'PE_22'
  | 'PE_23'
  | 'PE_24'
  | 'PE_25'
  | 'PE_LMA'
  | 'PF_01'
  | 'PF_02'
  | 'PF_03'
  | 'PF_04'
  | 'PF_05'
  | 'PG_01'
  | 'PG_02'
  | 'PG_03'
  | 'PG_04'
  | 'PG_05'
  | 'PG_06'
  | 'PG_07'
  | 'PG_08'
  | 'PG_09'
  | 'PG_10'
  | 'PG_11'
  | 'PG_12'
  | 'PG_13'
  | 'PG_14'
  | 'PG_15'
  | 'PG_16'
  | 'PG_17'
  | 'PG_18'
  | 'PG_19'
  | 'PG_20'
  | 'PH_00'
  | 'PH_ABR'
  | 'PH_AGN'
  | 'PH_AGS'
  | 'PH_AKL'
  | 'PH_ALB'
  | 'PH_ANT'
  | 'PH_APA'
  | 'PH_AUR'
  | 'PH_BAN'
  | 'PH_BAS'
  | 'PH_BEN'
  | 'PH_BIL'
  | 'PH_BOH'
  | 'PH_BTG'
  | 'PH_BTN'
  | 'PH_BUK'
  | 'PH_BUL'
  | 'PH_CAG'
  | 'PH_CAM'
  | 'PH_CAN'
  | 'PH_CAP'
  | 'PH_CAS'
  | 'PH_CAT'
  | 'PH_CAV'
  | 'PH_CEB'
  | 'PH_COM'
  | 'PH_DAO'
  | 'PH_DAS'
  | 'PH_DAV'
  | 'PH_DIN'
  | 'PH_EAS'
  | 'PH_GUI'
  | 'PH_IFU'
  | 'PH_ILI'
  | 'PH_ILN'
  | 'PH_ILS'
  | 'PH_ISA'
  | 'PH_KAL'
  | 'PH_LAG'
  | 'PH_LAN'
  | 'PH_LAS'
  | 'PH_LEY'
  | 'PH_LUN'
  | 'PH_MAD'
  | 'PH_MAG'
  | 'PH_MAS'
  | 'PH_MDC'
  | 'PH_MDR'
  | 'PH_MOU'
  | 'PH_MSC'
  | 'PH_MSR'
  | 'PH_NCO'
  | 'PH_NCR'
  | 'PH_NEC'
  | 'PH_NER'
  | 'PH_NSA'
  | 'PH_NUE'
  | 'PH_NUV'
  | 'PH_PAM'
  | 'PH_PAN'
  | 'PH_PLW'
  | 'PH_QUE'
  | 'PH_QUI'
  | 'PH_RIZ'
  | 'PH_ROM'
  | 'PH_SAR'
  | 'PH_SCO'
  | 'PH_SIG'
  | 'PH_SLE'
  | 'PH_SLU'
  | 'PH_SOR'
  | 'PH_SUK'
  | 'PH_SUN'
  | 'PH_SUR'
  | 'PH_TAR'
  | 'PH_TAW'
  | 'PH_WSA'
  | 'PH_ZAN'
  | 'PH_ZAS'
  | 'PH_ZMB'
  | 'PH_ZSI'
  | 'PK_01'
  | 'PK_02'
  | 'PK_03'
  | 'PK_04'
  | 'PK_05'
  | 'PK_06'
  | 'PK_07'
  | 'PK_08'
  | 'PL_72'
  | 'PL_73'
  | 'PL_74'
  | 'PL_75'
  | 'PL_76'
  | 'PL_77'
  | 'PL_78'
  | 'PL_79'
  | 'PL_80'
  | 'PL_81'
  | 'PL_82'
  | 'PL_83'
  | 'PL_84'
  | 'PL_85'
  | 'PL_86'
  | 'PL_87'
  | 'PM_'
  | 'PR_001'
  | 'PR_003'
  | 'PR_005'
  | 'PR_007'
  | 'PR_009'
  | 'PR_011'
  | 'PR_013'
  | 'PR_015'
  | 'PR_017'
  | 'PR_019'
  | 'PR_021'
  | 'PR_023'
  | 'PR_025'
  | 'PR_027'
  | 'PR_029'
  | 'PR_031'
  | 'PR_033'
  | 'PR_035'
  | 'PR_037'
  | 'PR_039'
  | 'PR_041'
  | 'PR_043'
  | 'PR_045'
  | 'PR_047'
  | 'PR_049'
  | 'PR_051'
  | 'PR_053'
  | 'PR_054'
  | 'PR_055'
  | 'PR_057'
  | 'PR_059'
  | 'PR_061'
  | 'PR_063'
  | 'PR_065'
  | 'PR_067'
  | 'PR_069'
  | 'PR_071'
  | 'PR_073'
  | 'PR_075'
  | 'PR_077'
  | 'PR_079'
  | 'PR_081'
  | 'PR_083'
  | 'PR_085'
  | 'PR_087'
  | 'PR_089'
  | 'PR_091'
  | 'PR_093'
  | 'PR_095'
  | 'PR_097'
  | 'PR_099'
  | 'PR_101'
  | 'PR_103'
  | 'PR_105'
  | 'PR_107'
  | 'PR_109'
  | 'PR_111'
  | 'PR_113'
  | 'PR_115'
  | 'PR_117'
  | 'PR_119'
  | 'PR_121'
  | 'PR_123'
  | 'PR_125'
  | 'PR_127'
  | 'PR_129'
  | 'PR_131'
  | 'PR_133'
  | 'PR_135'
  | 'PR_137'
  | 'PR_139'
  | 'PR_141'
  | 'PR_143'
  | 'PR_145'
  | 'PR_147'
  | 'PR_149'
  | 'PR_151'
  | 'PR_153'
  | 'PS_GZ'
  | 'PS_WE'
  | 'PT_02'
  | 'PT_03'
  | 'PT_04'
  | 'PT_05'
  | 'PT_06'
  | 'PT_07'
  | 'PT_08'
  | 'PT_09'
  | 'PT_10'
  | 'PT_11'
  | 'PT_13'
  | 'PT_14'
  | 'PT_16'
  | 'PT_17'
  | 'PT_18'
  | 'PT_19'
  | 'PT_20'
  | 'PT_21'
  | 'PT_22'
  | 'PT_23'
  | 'PW_01'
  | 'PW_02'
  | 'PW_03'
  | 'PW_04'
  | 'PW_05'
  | 'PW_06'
  | 'PW_07'
  | 'PW_08'
  | 'PW_09'
  | 'PW_10'
  | 'PW_11'
  | 'PW_12'
  | 'PW_13'
  | 'PW_14'
  | 'PW_15'
  | 'PW_16'
  | 'PY_01'
  | 'PY_02'
  | 'PY_04'
  | 'PY_05'
  | 'PY_06'
  | 'PY_07'
  | 'PY_08'
  | 'PY_10'
  | 'PY_11'
  | 'PY_12'
  | 'PY_13'
  | 'PY_15'
  | 'PY_16'
  | 'PY_17'
  | 'PY_19'
  | 'PY_22'
  | 'PY_23'
  | 'PY_24'
  | 'QA_01'
  | 'QA_02'
  | 'QA_03'
  | 'QA_04'
  | 'QA_06'
  | 'QA_08'
  | 'QA_09'
  | 'QA_10'
  | 'QA_13'
  | 'RE_RE'
  | 'RO_01'
  | 'RO_02'
  | 'RO_03'
  | 'RO_04'
  | 'RO_05'
  | 'RO_06'
  | 'RO_07'
  | 'RO_08'
  | 'RO_09'
  | 'RO_10'
  | 'RO_11'
  | 'RO_12'
  | 'RO_13'
  | 'RO_14'
  | 'RO_15'
  | 'RO_16'
  | 'RO_17'
  | 'RO_18'
  | 'RO_19'
  | 'RO_20'
  | 'RO_21'
  | 'RO_22'
  | 'RO_23'
  | 'RO_25'
  | 'RO_26'
  | 'RO_27'
  | 'RO_28'
  | 'RO_29'
  | 'RO_30'
  | 'RO_31'
  | 'RO_32'
  | 'RO_33'
  | 'RO_34'
  | 'RO_35'
  | 'RO_36'
  | 'RO_37'
  | 'RO_38'
  | 'RO_39'
  | 'RO_40'
  | 'RO_41'
  | 'RO_42'
  | 'RO_43'
  | 'RS_00'
  | 'RS_01'
  | 'RS_02'
  | 'RS_03'
  | 'RS_04'
  | 'RS_05'
  | 'RS_06'
  | 'RS_07'
  | 'RS_08'
  | 'RS_09'
  | 'RS_10'
  | 'RS_11'
  | 'RS_12'
  | 'RS_13'
  | 'RS_14'
  | 'RS_15'
  | 'RS_16'
  | 'RS_17'
  | 'RS_18'
  | 'RS_19'
  | 'RS_20'
  | 'RS_21'
  | 'RS_22'
  | 'RS_23'
  | 'RS_24'
  | 'RS_25'
  | 'RS_28'
  | 'RU_01'
  | 'RU_03'
  | 'RU_04'
  | 'RU_05'
  | 'RU_06'
  | 'RU_07'
  | 'RU_08'
  | 'RU_09'
  | 'RU_10'
  | 'RU_11'
  | 'RU_12'
  | 'RU_13'
  | 'RU_14'
  | 'RU_15'
  | 'RU_16'
  | 'RU_17'
  | 'RU_19'
  | 'RU_20'
  | 'RU_21'
  | 'RU_22'
  | 'RU_23'
  | 'RU_24'
  | 'RU_25'
  | 'RU_27'
  | 'RU_28'
  | 'RU_29'
  | 'RU_30'
  | 'RU_31'
  | 'RU_32'
  | 'RU_33'
  | 'RU_34'
  | 'RU_37'
  | 'RU_38'
  | 'RU_40'
  | 'RU_41'
  | 'RU_42'
  | 'RU_43'
  | 'RU_44'
  | 'RU_45'
  | 'RU_46'
  | 'RU_47'
  | 'RU_48'
  | 'RU_49'
  | 'RU_50'
  | 'RU_51'
  | 'RU_52'
  | 'RU_53'
  | 'RU_54'
  | 'RU_55'
  | 'RU_56'
  | 'RU_57'
  | 'RU_59'
  | 'RU_60'
  | 'RU_61'
  | 'RU_62'
  | 'RU_63'
  | 'RU_64'
  | 'RU_65'
  | 'RU_66'
  | 'RU_67'
  | 'RU_68'
  | 'RU_69'
  | 'RU_70'
  | 'RU_71'
  | 'RU_72'
  | 'RU_73'
  | 'RU_75'
  | 'RU_76'
  | 'RU_77'
  | 'RU_78'
  | 'RU_79'
  | 'RU_80'
  | 'RU_81'
  | 'RU_83'
  | 'RU_84'
  | 'RU_85'
  | 'RU_86'
  | 'RU_87'
  | 'RU_88'
  | 'RU_89'
  | 'RU_90'
  | 'RU_91'
  | 'RU_92'
  | 'RU_93'
  | 'RW_11'
  | 'RW_12'
  | 'RW_13'
  | 'RW_14'
  | 'RW_15'
  | 'SA_02'
  | 'SA_05'
  | 'SA_06'
  | 'SA_08'
  | 'SA_10'
  | 'SA_11'
  | 'SA_13'
  | 'SA_14'
  | 'SA_15'
  | 'SA_16'
  | 'SA_17'
  | 'SA_19'
  | 'SA_20'
  | 'SB_03'
  | 'SB_06'
  | 'SB_07'
  | 'SB_08'
  | 'SB_09'
  | 'SB_10'
  | 'SB_11'
  | 'SB_12'
  | 'SB_13'
  | 'SC_01'
  | 'SC_02'
  | 'SC_03'
  | 'SC_05'
  | 'SC_06'
  | 'SC_07'
  | 'SC_08'
  | 'SC_09'
  | 'SC_10'
  | 'SC_11'
  | 'SC_12'
  | 'SC_14'
  | 'SC_17'
  | 'SC_18'
  | 'SC_19'
  | 'SC_20'
  | 'SC_22'
  | 'SC_23'
  | 'SC_24'
  | 'SC_25'
  | 'SC_26'
  | 'SC_27'
  | 'SC_28'
  | 'SC_29'
  | 'SC_30'
  | 'SD_29'
  | 'SD_36'
  | 'SD_38'
  | 'SD_39'
  | 'SD_41'
  | 'SD_42'
  | 'SD_43'
  | 'SD_47'
  | 'SD_49'
  | 'SD_50'
  | 'SD_52'
  | 'SD_55'
  | 'SD_56'
  | 'SD_58'
  | 'SE_02'
  | 'SE_03'
  | 'SE_05'
  | 'SE_06'
  | 'SE_07'
  | 'SE_08'
  | 'SE_09'
  | 'SE_10'
  | 'SE_12'
  | 'SE_14'
  | 'SE_15'
  | 'SE_16'
  | 'SE_18'
  | 'SE_21'
  | 'SE_22'
  | 'SE_23'
  | 'SE_24'
  | 'SE_25'
  | 'SE_26'
  | 'SE_27'
  | 'SE_28'
  | 'SG_'
  | 'SG_00'
  | 'SG_01'
  | 'SG_02'
  | 'SG_03'
  | 'SG_04'
  | 'SG_05'
  | 'SH_01'
  | 'SH_02'
  | 'SH_03'
  | 'SI_01'
  | 'SI_02'
  | 'SI_03'
  | 'SI_04'
  | 'SI_05'
  | 'SI_06'
  | 'SI_07'
  | 'SI_08'
  | 'SI_09'
  | 'SI_11'
  | 'SI_12'
  | 'SI_13'
  | 'SI_14'
  | 'SI_15'
  | 'SI_16'
  | 'SI_17'
  | 'SI_19'
  | 'SI_20'
  | 'SI_22'
  | 'SI_24'
  | 'SI_25'
  | 'SI_26'
  | 'SI_27'
  | 'SI_28'
  | 'SI_29'
  | 'SI_30'
  | 'SI_31'
  | 'SI_32'
  | 'SI_34'
  | 'SI_35'
  | 'SI_36'
  | 'SI_37'
  | 'SI_38'
  | 'SI_39'
  | 'SI_40'
  | 'SI_42'
  | 'SI_44'
  | 'SI_45'
  | 'SI_46'
  | 'SI_47'
  | 'SI_49'
  | 'SI_50'
  | 'SI_51'
  | 'SI_52'
  | 'SI_53'
  | 'SI_54'
  | 'SI_55'
  | 'SI_57'
  | 'SI_61'
  | 'SI_62'
  | 'SI_64'
  | 'SI_66'
  | 'SI_68'
  | 'SI_71'
  | 'SI_72'
  | 'SI_73'
  | 'SI_74'
  | 'SI_76'
  | 'SI_77'
  | 'SI_78'
  | 'SI_79'
  | 'SI_80'
  | 'SI_81'
  | 'SI_82'
  | 'SI_83'
  | 'SI_84'
  | 'SI_86'
  | 'SI_87'
  | 'SI_88'
  | 'SI_89'
  | 'SI_91'
  | 'SI_92'
  | 'SI_94'
  | 'SI_97'
  | 'SI_98'
  | 'SI_99'
  | 'SI_A1'
  | 'SI_A2'
  | 'SI_A3'
  | 'SI_A6'
  | 'SI_A7'
  | 'SI_A8'
  | 'SI_B1'
  | 'SI_B2'
  | 'SI_B3'
  | 'SI_B4'
  | 'SI_B6'
  | 'SI_B7'
  | 'SI_B8'
  | 'SI_B9'
  | 'SI_C1'
  | 'SI_C2'
  | 'SI_C4'
  | 'SI_C5'
  | 'SI_C6'
  | 'SI_C7'
  | 'SI_C8'
  | 'SI_C9'
  | 'SI_D1'
  | 'SI_D2'
  | 'SI_D3'
  | 'SI_D4'
  | 'SI_D5'
  | 'SI_D6'
  | 'SI_D7'
  | 'SI_D8'
  | 'SI_E1'
  | 'SI_E2'
  | 'SI_E3'
  | 'SI_E5'
  | 'SI_E6'
  | 'SI_E7'
  | 'SI_E9'
  | 'SI_F1'
  | 'SI_F2'
  | 'SI_F3'
  | 'SI_F4'
  | 'SI_F5'
  | 'SI_F6'
  | 'SI_F7'
  | 'SI_F8'
  | 'SI_F9'
  | 'SI_G1'
  | 'SI_G2'
  | 'SI_G3'
  | 'SI_G4'
  | 'SI_G5'
  | 'SI_G6'
  | 'SI_G7'
  | 'SI_G8'
  | 'SI_G9'
  | 'SI_H1'
  | 'SI_H2'
  | 'SI_H3'
  | 'SI_H4'
  | 'SI_H5'
  | 'SI_H6'
  | 'SI_H7'
  | 'SI_H8'
  | 'SI_H9'
  | 'SI_I1'
  | 'SI_I2'
  | 'SI_I3'
  | 'SI_I4'
  | 'SI_I5'
  | 'SI_I6'
  | 'SI_I7'
  | 'SI_I8'
  | 'SI_I9'
  | 'SI_J1'
  | 'SI_J2'
  | 'SI_J3'
  | 'SI_J4'
  | 'SI_J5'
  | 'SI_J6'
  | 'SI_J7'
  | 'SI_J8'
  | 'SI_J9'
  | 'SI_K1'
  | 'SI_K2'
  | 'SI_K3'
  | 'SI_K4'
  | 'SI_K5'
  | 'SI_K6'
  | 'SI_K7'
  | 'SI_K8'
  | 'SI_K9'
  | 'SI_L1'
  | 'SI_L2'
  | 'SI_L3'
  | 'SI_L4'
  | 'SI_L5'
  | 'SI_L6'
  | 'SI_L7'
  | 'SI_L8'
  | 'SI_L9'
  | 'SI_M1'
  | 'SI_M2'
  | 'SI_M3'
  | 'SI_M4'
  | 'SI_M5'
  | 'SI_M6'
  | 'SI_M7'
  | 'SI_M8'
  | 'SI_M9'
  | 'SI_N1'
  | 'SI_N2'
  | 'SI_N3'
  | 'SI_N4'
  | 'SI_N5'
  | 'SI_N6'
  | 'SI_N7'
  | 'SI_N8'
  | 'SI_N9'
  | 'SI_O1'
  | 'SI_O2'
  | 'SI_O3'
  | 'SI_O4'
  | 'SI_O5'
  | 'SI_O7'
  | 'SJ_21'
  | 'SJ_22'
  | 'SK_01'
  | 'SK_02'
  | 'SK_03'
  | 'SK_04'
  | 'SK_05'
  | 'SK_06'
  | 'SK_07'
  | 'SK_08'
  | 'SL_01'
  | 'SL_02'
  | 'SL_03'
  | 'SL_04'
  | 'SM_01'
  | 'SM_02'
  | 'SM_03'
  | 'SM_04'
  | 'SM_05'
  | 'SM_06'
  | 'SM_07'
  | 'SM_08'
  | 'SM_09'
  | 'SN_01'
  | 'SN_03'
  | 'SN_05'
  | 'SN_07'
  | 'SN_09'
  | 'SN_10'
  | 'SN_11'
  | 'SN_12'
  | 'SN_13'
  | 'SN_14'
  | 'SN_15'
  | 'SN_16'
  | 'SN_17'
  | 'SN_18'
  | 'SO_01'
  | 'SO_02'
  | 'SO_03'
  | 'SO_04'
  | 'SO_05'
  | 'SO_06'
  | 'SO_07'
  | 'SO_08'
  | 'SO_09'
  | 'SO_10'
  | 'SO_12'
  | 'SO_13'
  | 'SO_14'
  | 'SO_18'
  | 'SO_19'
  | 'SO_20'
  | 'SO_21'
  | 'SO_22'
  | 'SR_10'
  | 'SR_11'
  | 'SR_12'
  | 'SR_13'
  | 'SR_14'
  | 'SR_15'
  | 'SR_16'
  | 'SR_17'
  | 'SR_18'
  | 'SR_19'
  | 'SS_01'
  | 'SS_02'
  | 'SS_03'
  | 'SS_04'
  | 'SS_05'
  | 'SS_06'
  | 'SS_07'
  | 'SS_08'
  | 'SS_09'
  | 'SS_085'
  | 'SS_10'
  | 'SS_543'
  | 'SS_544'
  | 'SS_545'
  | 'SS_548'
  | 'SS_552'
  | 'SS_555'
  | 'SS_558'
  | 'SS_562'
  | 'SS_563'
  | 'SS_564'
  | 'SS_565'
  | 'SS_566'
  | 'SS_567'
  | 'SS_569'
  | 'SS_570'
  | 'SS_571'
  | 'SS_573'
  | 'SS_574'
  | 'SS_575'
  | 'SS_576'
  | 'SS_577'
  | 'SS_578'
  | 'SS_579'
  | 'SS_580'
  | 'SS_581'
  | 'SS_582'
  | 'SS_588'
  | 'SS_589'
  | 'SS_596'
  | 'SS_661'
  | 'SS_894'
  | 'ST_01'
  | 'ST_02'
  | 'SV_01'
  | 'SV_02'
  | 'SV_03'
  | 'SV_04'
  | 'SV_05'
  | 'SV_06'
  | 'SV_07'
  | 'SV_08'
  | 'SV_09'
  | 'SV_10'
  | 'SV_11'
  | 'SV_12'
  | 'SV_13'
  | 'SV_14'
  | 'SY_01'
  | 'SY_02'
  | 'SY_03'
  | 'SY_04'
  | 'SY_05'
  | 'SY_06'
  | 'SY_07'
  | 'SY_08'
  | 'SY_09'
  | 'SY_10'
  | 'SY_11'
  | 'SY_12'
  | 'SY_13'
  | 'SY_14'
  | 'SZ_01'
  | 'SZ_02'
  | 'SZ_03'
  | 'SZ_04'
  | 'TD_01'
  | 'TD_02'
  | 'TD_05'
  | 'TD_06'
  | 'TD_07'
  | 'TD_08'
  | 'TD_09'
  | 'TD_12'
  | 'TD_13'
  | 'TD_14'
  | 'TD_15'
  | 'TD_16'
  | 'TD_17'
  | 'TD_18'
  | 'TD_19'
  | 'TD_20'
  | 'TD_21'
  | 'TD_22'
  | 'TD_23'
  | 'TD_25'
  | 'TD_26'
  | 'TF_01'
  | 'TF_03'
  | 'TG_22'
  | 'TG_23'
  | 'TG_24'
  | 'TG_25'
  | 'TG_26'
  | 'TH_01'
  | 'TH_02'
  | 'TH_03'
  | 'TH_04'
  | 'TH_05'
  | 'TH_06'
  | 'TH_07'
  | 'TH_08'
  | 'TH_09'
  | 'TH_10'
  | 'TH_11'
  | 'TH_12'
  | 'TH_13'
  | 'TH_14'
  | 'TH_15'
  | 'TH_16'
  | 'TH_17'
  | 'TH_18'
  | 'TH_20'
  | 'TH_22'
  | 'TH_23'
  | 'TH_24'
  | 'TH_25'
  | 'TH_26'
  | 'TH_27'
  | 'TH_28'
  | 'TH_29'
  | 'TH_30'
  | 'TH_31'
  | 'TH_32'
  | 'TH_33'
  | 'TH_34'
  | 'TH_35'
  | 'TH_36'
  | 'TH_37'
  | 'TH_38'
  | 'TH_39'
  | 'TH_40'
  | 'TH_41'
  | 'TH_42'
  | 'TH_43'
  | 'TH_44'
  | 'TH_46'
  | 'TH_47'
  | 'TH_48'
  | 'TH_49'
  | 'TH_50'
  | 'TH_51'
  | 'TH_52'
  | 'TH_53'
  | 'TH_54'
  | 'TH_55'
  | 'TH_56'
  | 'TH_57'
  | 'TH_58'
  | 'TH_59'
  | 'TH_60'
  | 'TH_61'
  | 'TH_62'
  | 'TH_63'
  | 'TH_64'
  | 'TH_65'
  | 'TH_66'
  | 'TH_67'
  | 'TH_68'
  | 'TH_69'
  | 'TH_70'
  | 'TH_72'
  | 'TH_73'
  | 'TH_74'
  | 'TH_75'
  | 'TH_76'
  | 'TH_77'
  | 'TH_78'
  | 'TH_79'
  | 'TH_80'
  | 'TH_81'
  | 'TJ_01'
  | 'TJ_02'
  | 'TJ_03'
  | 'TJ_05'
  | 'TK_A'
  | 'TK_F'
  | 'TK_N'
  | 'TL_AL'
  | 'TL_AN'
  | 'TL_BA'
  | 'TL_BO'
  | 'TL_CO'
  | 'TL_DI'
  | 'TL_ER'
  | 'TL_LA'
  | 'TL_LI'
  | 'TL_MF'
  | 'TL_MT'
  | 'TL_OE'
  | 'TL_VI'
  | 'TM_01'
  | 'TM_02'
  | 'TM_03'
  | 'TM_04'
  | 'TM_05'
  | 'TN_02'
  | 'TN_03'
  | 'TN_06'
  | 'TN_14'
  | 'TN_15'
  | 'TN_16'
  | 'TN_17'
  | 'TN_18'
  | 'TN_19'
  | 'TN_22'
  | 'TN_23'
  | 'TN_27'
  | 'TN_28'
  | 'TN_29'
  | 'TN_30'
  | 'TN_31'
  | 'TN_32'
  | 'TN_33'
  | 'TN_34'
  | 'TN_35'
  | 'TN_36'
  | 'TN_37'
  | 'TN_38'
  | 'TN_39'
  | 'TO_01'
  | 'TO_02'
  | 'TO_03'
  | 'TO_EU'
  | 'TO_NI'
  | 'TR_02'
  | 'TR_03'
  | 'TR_04'
  | 'TR_05'
  | 'TR_07'
  | 'TR_08'
  | 'TR_09'
  | 'TR_10'
  | 'TR_11'
  | 'TR_12'
  | 'TR_13'
  | 'TR_14'
  | 'TR_15'
  | 'TR_16'
  | 'TR_17'
  | 'TR_19'
  | 'TR_20'
  | 'TR_21'
  | 'TR_22'
  | 'TR_23'
  | 'TR_24'
  | 'TR_25'
  | 'TR_26'
  | 'TR_28'
  | 'TR_31'
  | 'TR_32'
  | 'TR_33'
  | 'TR_34'
  | 'TR_35'
  | 'TR_37'
  | 'TR_38'
  | 'TR_39'
  | 'TR_40'
  | 'TR_41'
  | 'TR_43'
  | 'TR_44'
  | 'TR_45'
  | 'TR_46'
  | 'TR_48'
  | 'TR_49'
  | 'TR_50'
  | 'TR_52'
  | 'TR_53'
  | 'TR_54'
  | 'TR_55'
  | 'TR_57'
  | 'TR_58'
  | 'TR_59'
  | 'TR_60'
  | 'TR_61'
  | 'TR_62'
  | 'TR_63'
  | 'TR_64'
  | 'TR_65'
  | 'TR_66'
  | 'TR_68'
  | 'TR_69'
  | 'TR_70'
  | 'TR_71'
  | 'TR_72'
  | 'TR_73'
  | 'TR_74'
  | 'TR_75'
  | 'TR_76'
  | 'TR_77'
  | 'TR_78'
  | 'TR_79'
  | 'TR_80'
  | 'TR_81'
  | 'TR_82'
  | 'TR_83'
  | 'TR_84'
  | 'TR_85'
  | 'TR_86'
  | 'TR_87'
  | 'TR_88'
  | 'TR_89'
  | 'TR_90'
  | 'TR_91'
  | 'TR_92'
  | 'TR_93'
  | 'TT_01'
  | 'TT_03'
  | 'TT_05'
  | 'TT_10'
  | 'TT_11'
  | 'TT_CHA'
  | 'TT_CTT'
  | 'TT_DMN'
  | 'TT_PED'
  | 'TT_PRT'
  | 'TT_PTF'
  | 'TT_SGE'
  | 'TT_SIP'
  | 'TT_SJL'
  | 'TT_TUP'
  | 'TV_FUN'
  | 'TV_NIT'
  | 'TV_NKF'
  | 'TV_NKL'
  | 'TV_NMA'
  | 'TV_NMG'
  | 'TV_NUI'
  | 'TV_VAI'
  | 'TW_KH'
  | 'TW_TA'
  | 'TW_TG'
  | 'TW_TN'
  | 'TW_TP'
  | 'TW_TY'
  | 'TZ_02'
  | 'TZ_03'
  | 'TZ_04'
  | 'TZ_05'
  | 'TZ_06'
  | 'TZ_07'
  | 'TZ_08'
  | 'TZ_09'
  | 'TZ_10'
  | 'TZ_11'
  | 'TZ_12'
  | 'TZ_13'
  | 'TZ_14'
  | 'TZ_15'
  | 'TZ_16'
  | 'TZ_17'
  | 'TZ_18'
  | 'TZ_19'
  | 'TZ_20'
  | 'TZ_21'
  | 'TZ_22'
  | 'TZ_23'
  | 'TZ_24'
  | 'TZ_25'
  | 'TZ_26'
  | 'TZ_27'
  | 'TZ_28'
  | 'TZ_29'
  | 'TZ_30'
  | 'TZ_31'
  | 'UA_01'
  | 'UA_02'
  | 'UA_03'
  | 'UA_04'
  | 'UA_05'
  | 'UA_06'
  | 'UA_07'
  | 'UA_08'
  | 'UA_09'
  | 'UA_10'
  | 'UA_11'
  | 'UA_12'
  | 'UA_13'
  | 'UA_14'
  | 'UA_15'
  | 'UA_16'
  | 'UA_17'
  | 'UA_18'
  | 'UA_19'
  | 'UA_20'
  | 'UA_21'
  | 'UA_22'
  | 'UA_23'
  | 'UA_24'
  | 'UA_25'
  | 'UA_26'
  | 'UA_27'
  | 'UG_101'
  | 'UG_102'
  | 'UG_103'
  | 'UG_104'
  | 'UG_105'
  | 'UG_106'
  | 'UG_107'
  | 'UG_108'
  | 'UG_109'
  | 'UG_110'
  | 'UG_111'
  | 'UG_112'
  | 'UG_113'
  | 'UG_114'
  | 'UG_115'
  | 'UG_116'
  | 'UG_117'
  | 'UG_118'
  | 'UG_119'
  | 'UG_120'
  | 'UG_121'
  | 'UG_122'
  | 'UG_123'
  | 'UG_124'
  | 'UG_201'
  | 'UG_202'
  | 'UG_203'
  | 'UG_204'
  | 'UG_205'
  | 'UG_206'
  | 'UG_207'
  | 'UG_208'
  | 'UG_209'
  | 'UG_210'
  | 'UG_211'
  | 'UG_212'
  | 'UG_213'
  | 'UG_214'
  | 'UG_215'
  | 'UG_216'
  | 'UG_217'
  | 'UG_218'
  | 'UG_219'
  | 'UG_220'
  | 'UG_221'
  | 'UG_222'
  | 'UG_223'
  | 'UG_224'
  | 'UG_225'
  | 'UG_226'
  | 'UG_227'
  | 'UG_228'
  | 'UG_229'
  | 'UG_230'
  | 'UG_231'
  | 'UG_232'
  | 'UG_301'
  | 'UG_302'
  | 'UG_303'
  | 'UG_304'
  | 'UG_305'
  | 'UG_306'
  | 'UG_307'
  | 'UG_308'
  | 'UG_309'
  | 'UG_310'
  | 'UG_311'
  | 'UG_312'
  | 'UG_313'
  | 'UG_314'
  | 'UG_315'
  | 'UG_316'
  | 'UG_317'
  | 'UG_318'
  | 'UG_319'
  | 'UG_320'
  | 'UG_321'
  | 'UG_322'
  | 'UG_323'
  | 'UG_324'
  | 'UG_325'
  | 'UG_326'
  | 'UG_327'
  | 'UG_328'
  | 'UG_329'
  | 'UG_330'
  | 'UG_401'
  | 'UG_402'
  | 'UG_403'
  | 'UG_404'
  | 'UG_405'
  | 'UG_406'
  | 'UG_407'
  | 'UG_408'
  | 'UG_409'
  | 'UG_410'
  | 'UG_411'
  | 'UG_412'
  | 'UG_413'
  | 'UG_414'
  | 'UG_415'
  | 'UG_416'
  | 'UG_417'
  | 'UG_418'
  | 'UG_419'
  | 'UG_420'
  | 'UG_421'
  | 'UG_422'
  | 'UG_423'
  | 'UG_424'
  | 'UG_425'
  | 'UG_426'
  | 'UM_050'
  | 'UM_100'
  | 'UM_150'
  | 'UM_200'
  | 'UM_250'
  | 'UM_300'
  | 'UM_350'
  | 'UM_400'
  | 'UM_450'
  | 'US_AK'
  | 'US_AL'
  | 'US_AR'
  | 'US_AZ'
  | 'US_CA'
  | 'US_CO'
  | 'US_CT'
  | 'US_DC'
  | 'US_DE'
  | 'US_FL'
  | 'US_GA'
  | 'US_HI'
  | 'US_IA'
  | 'US_ID'
  | 'US_IL'
  | 'US_IN'
  | 'US_KS'
  | 'US_KY'
  | 'US_LA'
  | 'US_MA'
  | 'US_MD'
  | 'US_ME'
  | 'US_MI'
  | 'US_MN'
  | 'US_MO'
  | 'US_MS'
  | 'US_MT'
  | 'US_NC'
  | 'US_ND'
  | 'US_NE'
  | 'US_NH'
  | 'US_NJ'
  | 'US_NM'
  | 'US_NV'
  | 'US_NY'
  | 'US_OH'
  | 'US_OK'
  | 'US_OR'
  | 'US_PA'
  | 'US_RI'
  | 'US_SC'
  | 'US_SD'
  | 'US_TN'
  | 'US_TX'
  | 'US_UT'
  | 'US_VA'
  | 'US_VT'
  | 'US_WA'
  | 'US_WI'
  | 'US_WV'
  | 'US_WY'
  | 'UY_01'
  | 'UY_02'
  | 'UY_03'
  | 'UY_04'
  | 'UY_05'
  | 'UY_06'
  | 'UY_07'
  | 'UY_08'
  | 'UY_09'
  | 'UY_10'
  | 'UY_11'
  | 'UY_12'
  | 'UY_13'
  | 'UY_14'
  | 'UY_15'
  | 'UY_16'
  | 'UY_17'
  | 'UY_18'
  | 'UY_19'
  | 'UZ_01'
  | 'UZ_02'
  | 'UZ_03'
  | 'UZ_05'
  | 'UZ_06'
  | 'UZ_07'
  | 'UZ_08'
  | 'UZ_09'
  | 'UZ_10'
  | 'UZ_12'
  | 'UZ_13'
  | 'UZ_14'
  | 'UZ_15'
  | 'UZ_16'
  | 'VC_01'
  | 'VC_02'
  | 'VC_03'
  | 'VC_04'
  | 'VC_05'
  | 'VC_06'
  | 'VE_01'
  | 'VE_02'
  | 'VE_03'
  | 'VE_04'
  | 'VE_05'
  | 'VE_06'
  | 'VE_07'
  | 'VE_08'
  | 'VE_09'
  | 'VE_11'
  | 'VE_12'
  | 'VE_13'
  | 'VE_14'
  | 'VE_15'
  | 'VE_16'
  | 'VE_17'
  | 'VE_18'
  | 'VE_19'
  | 'VE_20'
  | 'VE_21'
  | 'VE_22'
  | 'VE_23'
  | 'VE_24'
  | 'VE_25'
  | 'VE_26'
  | 'VI_010'
  | 'VI_020'
  | 'VI_030'
  | 'VN_01'
  | 'VN_03'
  | 'VN_05'
  | 'VN_09'
  | 'VN_13'
  | 'VN_20'
  | 'VN_21'
  | 'VN_23'
  | 'VN_24'
  | 'VN_30'
  | 'VN_32'
  | 'VN_33'
  | 'VN_34'
  | 'VN_35'
  | 'VN_37'
  | 'VN_39'
  | 'VN_43'
  | 'VN_44'
  | 'VN_45'
  | 'VN_46'
  | 'VN_47'
  | 'VN_49'
  | 'VN_50'
  | 'VN_51'
  | 'VN_52'
  | 'VN_53'
  | 'VN_54'
  | 'VN_55'
  | 'VN_58'
  | 'VN_59'
  | 'VN_60'
  | 'VN_61'
  | 'VN_62'
  | 'VN_63'
  | 'VN_64'
  | 'VN_65'
  | 'VN_66'
  | 'VN_67'
  | 'VN_68'
  | 'VN_69'
  | 'VN_70'
  | 'VN_71'
  | 'VN_72'
  | 'VN_73'
  | 'VN_74'
  | 'VN_75'
  | 'VN_76'
  | 'VN_77'
  | 'VN_78'
  | 'VN_79'
  | 'VN_80'
  | 'VN_81'
  | 'VN_82'
  | 'VN_83'
  | 'VN_84'
  | 'VN_85'
  | 'VN_86'
  | 'VN_87'
  | 'VN_88'
  | 'VN_89'
  | 'VN_90'
  | 'VN_91'
  | 'VN_92'
  | 'VN_93'
  | 'VU_07'
  | 'VU_13'
  | 'VU_15'
  | 'VU_16'
  | 'VU_17'
  | 'VU_18'
  | 'WF_AL'
  | 'WF_SI'
  | 'WF_UV'
  | 'WS_01'
  | 'WS_02'
  | 'WS_03'
  | 'WS_04'
  | 'WS_05'
  | 'WS_06'
  | 'WS_07'
  | 'WS_08'
  | 'WS_09'
  | 'WS_10'
  | 'WS_11'
  | 'YE_01'
  | 'YE_02'
  | 'YE_03'
  | 'YE_04'
  | 'YE_05'
  | 'YE_08'
  | 'YE_10'
  | 'YE_11'
  | 'YE_14'
  | 'YE_15'
  | 'YE_16'
  | 'YE_18'
  | 'YE_19'
  | 'YE_20'
  | 'YE_21'
  | 'YE_22'
  | 'YE_23'
  | 'YE_24'
  | 'YE_25'
  | 'YE_26'
  | 'YE_27'
  | 'YT_AC'
  | 'YT_BB'
  | 'YT_BL'
  | 'YT_BO'
  | 'YT_CC'
  | 'YT_CR'
  | 'YT_DE'
  | 'YT_DZ'
  | 'YT_KK'
  | 'YT_KO'
  | 'YT_MA'
  | 'YT_MB'
  | 'YT_MJ'
  | 'YT_OU'
  | 'YT_PA'
  | 'YT_SA'
  | 'YT_TS'
  | 'ZA_02'
  | 'ZA_03'
  | 'ZA_05'
  | 'ZA_06'
  | 'ZA_07'
  | 'ZA_08'
  | 'ZA_09'
  | 'ZA_10'
  | 'ZA_11'
  | 'ZM_01'
  | 'ZM_02'
  | 'ZM_03'
  | 'ZM_04'
  | 'ZM_05'
  | 'ZM_06'
  | 'ZM_07'
  | 'ZM_08'
  | 'ZM_09'
  | 'ZW_01'
  | 'ZW_02'
  | 'ZW_03'
  | 'ZW_04'
  | 'ZW_05'
  | 'ZW_06'
  | 'ZW_07'
  | 'ZW_08'
  | 'ZW_09'
  | 'ZW_10';

/** Represents enumeration of available subscription plans. */
export type Subscription_Plan =
  | 'CUSTOM'
  | 'LARGE'
  | 'LITE'
  | 'SMALL'
  | 'TRIAL';

export type Subscription_Plan_Key =
  | 'CUSTOM'
  | 'LARGE'
  | 'LITE'
  | 'SMALL'
  | 'TRIAL';

export type Suite_Member_Kind =
  | 'CORE'
  | 'ELECTIVE';

/** Represents the type of a symbol (ie. METRIC) */
export type Symbol_Type =
  | 'METRIC';

/** One scope-clarifying question and the buyer's answer to it. */
export type ScopeAnswerInput = {
  /** The buyer's answer. */
  answer: Scalars['String']['input'];
  /** The question the storefront asked. */
  question: Scalars['String']['input'];
};

export type ScopeFilter = {
  filter: Esg_Questionnaire_Filter;
  isFilterEnabled: Scalars['Boolean']['output'];
};

/** The status of a seat request in the admin approval queue. */
export type SeatRequestStatus =
  | 'APPROVED'
  | 'DECLINED'
  | 'PENDING';

/** A seatless user's request to join a framework the tenant owns - the admin approval queue's view of it. Approving one never grants the seat directly; it delegates to the existing capacity-checked assignment path. */
export type SeatRequestType = {
  createdAt: Scalars['DateTime']['output'];
  /** When this request was approved or declined. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the admin who resolved this request, once resolved. */
  resolvedBy?: Maybe<Scalars['String']['output']>;
  /** UUID of the framework (risk area) requested. */
  riskAreaUuid: Scalars['UUID']['output'];
  /** Current state of the request. */
  status: SeatRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  /** Requesting user's UUID. */
  userUuid: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type Sector = {
  /** Sector description */
  description?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if sector is turned on by default */
  isDefault: Scalars['Boolean']['output'];
  /** Flag indicating if all sector's units are enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Sector name */
  name: Scalars['String']['output'];
  /** Sector order. */
  order: Scalars['Float']['output'];
  /** List of units in this sector. Includes both enabled and disabled units */
  units: Array<Unit>;
  /** UUID of sector. */
  uuid: Scalars['UUID']['output'];
};

/** Represents pagination input for connection of sectors */
export type SectorConnection = {
  /** Array of edges. */
  edges: Array<SectorEdge>;
  /** Array of direct nodes. */
  nodes: Array<Sector>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of sectors */
export type SectorConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<SectorSortInput>>;
  /** Include only sectors that have at least one unit */
  withUnits?: Scalars['Boolean']['input'];
};

/** Represents Sector connection edge. */
export type SectorEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Sector record. */
  node: Sector;
};

/** Represents input for enabling or disabling state of multiple sectors. */
export type SectorSetStateInput = {
  /** Array of inputs to update sectors' units state. */
  sectorInput: Array<SectorStateInput>;
};

export type SectorSortFields =
  | 'ORDER'
  | 'SECTOR_NAME';

export type SectorSortInput = {
  direction: SortDirection;
  field: SectorSortFields;
};

/** Represents input for changing state of sector. */
export type SectorStateInput = {
  /** Enables or disables all sector's units */
  isEnabled: Scalars['Boolean']['input'];
  /** Sector UUID. */
  sectorUuid: Scalars['UUID']['input'];
};

export type Select = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents input rows for exporting Metric */
export type SelectedRowsToExportMetricInput = {
  /** name of the row */
  rowName: Scalars['String']['input'];
  /** name of the subRow */
  subRowName?: InputMaybe<Scalars['String']['input']>;
};

/** Enumeration of cluster ids. */
export type ServiceModules =
  | 'CARBON_LENS'
  | 'CASES'
  | 'DEMO'
  | 'DISCLOSURES'
  | 'DUE_DILIGENCE'
  | 'ESG'
  | 'FRAMEWORKS'
  | 'INSIGHTS'
  | 'NICOLE_GPT'
  | 'SSO'
  | 'SUBSIDIARY_SITES'
  | 'SURVEYS'
  | 'TASKS'
  | 'TEAMS'
  | 'TRAININGS';

/** The result of a checkout buyer submitting a service's scope for a hand-priced quote. */
export type ServicePricingRequestResult = {
  /** The created (or already-pending) request's uuid. */
  requestUuid: Scalars['ID']['output'];
  /** PENDING | PRICED | CLOSED. */
  status: Scalars['String']['output'];
};

/** Session tokens and old architecture exchange token */
export type Session = {
  refreshToken: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
};

export type SessionHandoffCode = {
  /** Single use, sixty seconds: redeem it on the other origin for the same session */
  code: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
};

export type SessionHandoffCreateInput = {
  /** A random secret this browser keeps in the speeki_handoff cookie on the shared base domain; the redeem must present the same one */
  binding: Scalars['String']['input'];
};

export type SessionHandoffRedeemInput = {
  /** The secret from this browser's speeki_handoff cookie, set when the code was minted */
  binding: Scalars['String']['input'];
  /** The code minted on the other origin */
  code: Scalars['String']['input'];
};

export type SessionPayload = {
  /** Token used for authentication with firebase. Available for TENANT_ADMIN and EMPLOYEE. */
  firebaseToken?: Maybe<Scalars['JWT']['output']>;
  /**
   * contain the MFA details if mfa is enabled
   * @deprecated use mfa
   */
  metadata?: Maybe<Mfa>;
  /** contain the MFA details if mfa is enabled  */
  mfa?: Maybe<Mfa>;
  /** Long lived token to refresh a user session. Can be used only once. Can be null when MFA is required */
  refreshToken?: Maybe<Scalars['JWT']['output']>;
  /** Token to authenticate a user session. Can be session token, mfa token or mfa setup token */
  sessionToken: Scalars['JWT']['output'];
};

/** Represents the input for current user  update. */
export type SessionUserSettingsUpdateInput = {
  /** Country code to change to. */
  country?: InputMaybe<Country_Code>;
  /** Language code to change to. */
  language?: InputMaybe<UserAuthLanguage>;
  /** Relationship code to change to. */
  relationship?: InputMaybe<TenantsUserRelationship>;
};

export type SessionWithOaExchange = {
  metadata?: Maybe<Metadata>;
  /**
   * Access token to use with mobile-api (kotlin)
   * @deprecated SessionWithOaExchange Type is no longer supported. Use `SessionPayload` object type
   */
  mobileApiToken?: Maybe<Scalars['String']['output']>;
  /**
   * This token can be use with legacy php API to receive access token
   * @deprecated SessionWithOaExchange Type is no longer supported. Use `SessionPayload` object type
   */
  oaExchangeToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  sessionToken: Scalars['String']['output'];
};

export type SetFitnessVariableValueInput = {
  value: Scalars['Float']['input'];
  variableUuid: Scalars['UUID']['input'];
  yearUuid: Scalars['UUID']['input'];
};

export type SetMaterialInScopeInput = {
  materialInScope: Scalars['Boolean']['input'];
  riskAreaUuid: Scalars['UUID']['input'];
};

/** Input for setting microsoft tenant id */
export type SetMsTenantIdInput = {
  msTenantID: Scalars['String']['input'];
};

export type SetPriceQuote = {
  /** Audit Ready only: the part of annualUsd for standards beyond the first. */
  additionalUsd?: Maybe<Scalars['String']['output']>;
  /** The price per year. */
  annualUsd?: Maybe<Scalars['String']['output']>;
  bespoke: Scalars['Boolean']['output'];
  /** Set only when bespoke = true: why the scope is priced by Speeki. */
  bespokeReason?: Maybe<Scalars['String']['output']>;
  /** GreenDesk only: "occasional" | "often" | "regular". */
  planId?: Maybe<Scalars['String']['output']>;
  /** GreenDesk only: the plan name. */
  planName?: Maybe<Scalars['String']['output']>;
  /** GreenDesk only: claim reviews a year the plan covers. */
  planReviews?: Maybe<Scalars['Int']['output']>;
  pricingVersion: Scalars['String']['output'];
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  /** Audit Ready only: the standards assessed. */
  standards?: Maybe<Scalars['Int']['output']>;
  /** annualUsd over the whole term. */
  termTotalUsd?: Maybe<Scalars['String']['output']>;
  /** Years committed: 1, or 3 for GreenDesk. */
  termYears?: Maybe<Scalars['Int']['output']>;
};

export type SetPriceRules = {
  auditReadyAdditionalUsd: Scalars['String']['output'];
  auditReadyBaseUsd: Scalars['String']['output'];
  /** Every certification product the buyer can tick as certified or assessed together. */
  certificationProducts: Array<Scalars['String']['output']>;
  greenDeskPlans: Array<GreenDeskPlanRule>;
  greenDeskTermYears: Scalars['Int']['output'];
  speekiCertAloneUsd: Scalars['String']['output'];
  speekiCertStandards: Array<SpeekiCertStandardRule>;
  speekiCertTogetherUsd: Scalars['String']['output'];
};

export type SetRiskAreaSettingsByProgramInput = {
  programUuid: Scalars['String']['input'];
  riskAreaSettings: Array<EsgRiskAreaSettingsByProgramConfig>;
  tenantUuid: Scalars['String']['input'];
};

/** Sets Speeki's standing pick, replacing whatever it was. */
export type SetSpeekiPickInput = {
  /** When the pick stops showing (exclusive). Omit to show until it is replaced. Set it to now to stop featuring anything. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** An optional short internal note about why this pick was made. Staff-facing only - never shown to customers. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The riskAreaUuid of the framework to feature. Must be a framework the shop actually sells. */
  standardRef: Scalars['ID']['input'];
  /** When the pick starts showing (inclusive). Omit to start immediately. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A request to approve an order for spend before it is sent for signature (kind ORDER_APPROVAL), or - in a later phase - to join a tenant that already uses Speeki (kind TENANT_ACCESS). One generic mechanism, one `kind` discriminator; only the EFFECT of approval differs between kinds. */
export type ShopApprovalRequest = {
  createdAt: Scalars['DateTime']['output'];
  /** The approver's reason for declining - mandatory on every decline, null for every other status. Visible to everyone who can see the request, the requester included: the whole point is that they are told why. */
  declineReason?: Maybe<Scalars['String']['output']>;
  /** True when the caller themselves is the requester. */
  isMine: Scalars['Boolean']['output'];
  /** ORDER_APPROVAL | TENANT_ACCESS */
  kind: Scalars['String']['output'];
  /** When the last administrator reminder went out; null if none has yet. */
  lastRemindedAt?: Maybe<Scalars['DateTime']['output']>;
  /** An optional note from the requester to the approver. */
  message?: Maybe<Scalars['String']['output']>;
  /** The order this request asks someone to approve (ORDER_APPROVAL only; null for TENANT_ACCESS). */
  order?: Maybe<Order>;
  /** The order this request asks someone to approve. Present for ORDER_APPROVAL; null for TENANT_ACCESS, which has no order. */
  orderUuid?: Maybe<Scalars['ID']['output']>;
  /** How many administrator reminders have gone out while this request stayed PENDING. */
  reminderCount: Scalars['Int']['output'];
  /** The catalogue plan id a PLAN request asks for (e.g. 'standard') - null on a draft-based ORDER_APPROVAL row and on TENANT_ACCESS. */
  requestedPlanId?: Maybe<Scalars['String']['output']>;
  /** The catalogue product (standard/framework) a PLAN request asks for - null on a draft-based ORDER_APPROVAL row and on TENANT_ACCESS. */
  requestedStandardRef?: Maybe<Scalars['String']['output']>;
  /** The verified requester's email address (TENANT_ACCESS only; null for ORDER_APPROVAL, which has a real user requester - see requesterUuid). Company-settings only. */
  requesterEmail?: Maybe<Scalars['String']['output']>;
  /** The requester's user uuid for ORDER_APPROVAL. For TENANT_ACCESS this holds the requester's own verified email instead (no user row exists by construction - see requesterEmail, which is the correctly-typed way to read it); kept here too only because a second field would be a breaking rename of an already-shipped one. */
  requesterUuid: Scalars['ID']['output'];
  /** When this request left PENDING; null while pending. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** PENDING | APPROVED | DECLINED | CANCELLED - the true persisted status, the same for every viewer. A decline always reads as DECLINED, including to its own requester, with declineReason explaining it. */
  status: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** The public, sellable Speeki Engage catalogue: categories, products and plans. */
export type ShopCatalogue = {
  categories: Array<CatalogueCategory>;
  plans: Array<CataloguePlan>;
  products: Array<CatalogueProduct>;
  /** The tenant's next subscription anniversary - the single page-level renewal line. Null on anonymous reads, non-PAID anchors, and any lookup failure. */
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for creating new user */
export type SignUpRequestInput = {
  /** New employee country */
  country: Country_Code;
  /** New employee email */
  email: Scalars['String']['input'];
  /** (Optional) New employee language. English is used as default */
  language?: InputMaybe<UserAuthLanguage>;
  /** New user name */
  name: Scalars['String']['input'];
  /** New employee password  */
  password: Scalars['String']['input'];
  /** New employee relationship */
  relationship: TenantsUserRelationship;
  /** New employee tenantUuid */
  tenantUuid: Scalars['String']['input'];
};

/** Represents enumeration of possible slot data types. */
export type SlotDataType =
  | 'CITY'
  | 'COUNTRY'
  | 'DAMAGE_COST'
  | 'INVOLVED_BUSINESS_UNIT'
  | 'INVOLVED_COMPANY_NAME'
  | 'INVOLVED_EMAIL'
  | 'INVOLVED_NAME'
  | 'INVOLVED_POSITION'
  | 'INVOLVED_RELATIONSHIP'
  | 'INVOLVED_TYPE'
  | 'LOCATION'
  | 'STATE';

/** Represents the input for user response to slot options. */
export type SlotResponseInput = {
  /** Chosen action identifier. */
  actionId: Scalars['Int']['input'];
  /** Response action text. */
  text: Scalars['String']['input'];
};

/** AI-generated draft answer for a single question in Smart Fill job. */
export type SmartFillDraftAnswer = {
  /** Confidence score assigned by Smart Fill model. */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Draft answer text generated by Smart Fill. */
  draftAnswer?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the draft answer was generated by AI. */
  isAiDraft: Scalars['Boolean']['output'];
  /** Question for which this Smart Fill draft was generated. */
  question: EsgQuestion;
  /** Source snippets used to construct this draft answer. */
  sources: Array<SmartFillSource>;
  /** Current review status of the draft answer. */
  status: Insights_Smart_Fill_Draft_Status;
};

/** Smart Fill job state with contextual data and generated drafts. */
export type SmartFillJob = {
  /** When the run was started. */
  createdAt: Scalars['DateTime']['output'];
  /** Draft answers currently available for this Smart Fill job. */
  drafts: Array<SmartFillDraftAnswer>;
  /** Programme selected for Smart Fill processing (null for standalone frameworks). */
  programme?: Maybe<Program>;
  /** Risk area (framework) selected for Smart Fill processing. */
  riskArea: RiskArea;
  /** User who started the run (federated reference). */
  startedBy?: Maybe<UserType>;
  /** Current processing status of Smart Fill job. */
  status: Insights_Smart_Fill_Job_Status;
  /** Documents this run could not read. Only populated while the job is AWAITING_INPUT. */
  unreadDocuments: Array<SmartFillUnreadDocument>;
  /** Unique Smart Fill job identifier. */
  uuid: Scalars['UUID']['output'];
};

/** Input for querying Smart Fill job status and drafts. */
export type SmartFillJobInput = {
  /** Smart Fill job UUID. */
  jobUuid: Scalars['UUID']['input'];
};

/** Source fragment used to generate Smart Fill draft answer. */
export type SmartFillSource = {
  /** File from which this source fragment was extracted. */
  file: InsightsFile;
  /** Page in the source document the excerpt was drawn from. */
  page?: Maybe<Scalars['Int']['output']>;
  /** Optional section reference or excerpt used by Smart Fill. */
  sectionOrExcerpt?: Maybe<Scalars['String']['output']>;
  /** Sheet name for spreadsheet sources; null for other file types. */
  sheetName?: Maybe<Scalars['String']['output']>;
  /** Classification of source content used for the draft. */
  type: Insights_Smart_Fill_Source_Type;
};

/** A document Smart Fill could not read, from a halted (AWAITING_INPUT) run. */
export type SmartFillUnreadDocument = {
  /** The unread file's UUID. */
  fileUuid: Scalars['UUID']['output'];
  /** Why the document could not be read. */
  reasonKind: Smart_Fill_Unread_Reason;
  /** Whether re-attempting the read (without changing the file) is worth offering. */
  retryable: Scalars['Boolean']['output'];
};

/** A document Smart Fill has proven it cannot read; re-uploading a fixed copy is the only recovery. */
export type SmartFillUnreadableFile = {
  /** The unreadable file's UUID. */
  fileUuid: Scalars['UUID']['output'];
  /** Why the document could not be read. */
  reasonKind: Smart_Fill_Unread_Reason;
};

/** Input for looking up non-retryable unreadable files. */
export type SmartFillUnreadableFilesInput = {
  /** File UUIDs to check. */
  fileUuids: Array<Scalars['UUID']['input']>;
};

/** Sort Directions */
export type SortDirection =
  | 'ASC'
  | 'DESC';

/** Enumeration of possible directions in which to order a list of elements. */
export type SortingOrderDirection =
  | 'asc'
  | 'desc';

/** The buyer's answers for a Speeki Certification price. */
export type SpeekiCertPriceInput = {
  /** "iso37002" | "iso37008". */
  standard: Scalars['String']['input'];
  /** The other certification products certified at the same time. */
  togetherWith: Array<Scalars['String']['input']>;
};

export type SpeekiCertStandardRule = {
  id: Scalars['String']['output'];
  /** The thing the certificate covers. */
  system: Scalars['String']['output'];
};

/** Speeki's own standing pick: the one framework the shop leads with, as staff configured it. */
export type SpeekiPick = {
  /** When the pick stops showing (exclusive). Null means it shows until it is replaced. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this pick is showing right now. False for a pick whose window has not opened or has already closed - in which case no framework is featured at all, and the rail renders fewer slots. */
  live: Scalars['Boolean']['output'];
  /** An optional short internal note about why this pick was made. Staff-facing only - it is never shown to customers and never appears on the rail. */
  reason?: Maybe<Scalars['String']['output']>;
  setAt: Scalars['DateTime']['output'];
  /** The staff user who set this pick. */
  setByUserUuid: Scalars['ID']['output'];
  standardRef: Scalars['ID']['output'];
  /** When the pick starts showing (inclusive). Null means it is already showing. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SpkAssessmentDays = {
  baseStage2: Scalars['Float']['output'];
  highRiskAdjustment: Scalars['Float']['output'];
  /** Zero or negative. */
  isoCredit: Scalars['Float']['output'];
  isoCreditsApplied: Array<Scalars['String']['output']>;
  netStage2: Scalars['Float']['output'];
  reporting: Scalars['Float']['output'];
  reviewAdjustment: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
  sectorAdjustment: Scalars['Float']['output'];
  /** STANDARD | HIGH | VERY_HIGH for the chosen sector. */
  sectorTier: Scalars['String']['output'];
  setup: Scalars['Float']['output'];
  stage1: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type SpkCertificationPrice = {
  /** The commercial adjustments applied, in order; empty at the rate card. */
  adjustments: Array<SpkPriceAdjustment>;
  days: SpkAssessmentDays;
  fees: SpkFeeSchedule;
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  standard: Scalars['String']['output'];
};

/** One of the three SPK certification products a buyer prices on the page. */
export type SpkCertificationPriceInput = {
  /** annual (one assessment block) or quarterly (four checkpoints across the year, 15% off Year 1 and renewals). Absent means annual. */
  billing?: InputMaybe<Scalars['String']['input']>;
  /** Evidence will be loaded on the Engage framework with assessor access before the audit: 10% off Year 1 and renewals. Absent means false. */
  engageEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** The high-risk subset: important topics (Meridian), high-risk third parties (Sentinel) or high-risk claims (Verdant). */
  highRisk: Scalars['Int']['input'];
  /** Evidence per held certificate. Only a certificate with an issuer and an expiry in the current month or later is credited; without evidence nothing is credited. */
  isoEvidence?: InputMaybe<Array<SpkIsoEvidenceInput>>;
  /** Deprecated and ignored: it earns no credit. Send isoEvidence; kept only so a client still sending it keeps working. */
  isoHeld?: InputMaybe<Array<Scalars['String']['input']>>;
  /** csms1000 (Speeki Meridian), ddms2000 (Speeki Sentinel) or gcms3000 (Speeki Verdant). */
  product: Scalars['String']['input'];
  /** The assessment must start under six weeks from order: 25% on Year 1. Absent means false. */
  rush?: InputMaybe<Scalars['Boolean']['input']>;
  /** One of the product's sector names, verbatim (see spkCertificationRules.sectors). */
  sector: Scalars['String']['input'];
  /** The primary volume: employees (Meridian), third parties (Sentinel) or annual environmental claims (Verdant) in scope. */
  volume: Scalars['Int']['input'];
  /** Certification cycle committed up front, 1, 2 or 3 years: 5% off Year 1 for 2, 10% for 3. Absent means 1. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

export type SpkCertificationRules = {
  baseDaysMax: Scalars['Float']['output'];
  baseDaysMin: Scalars['Float']['output'];
  highRiskHigh: Scalars['Int']['output'];
  highRiskLabel: Scalars['String']['output'];
  highRiskLow: Scalars['Int']['output'];
  isoCreditCapDays: Scalars['Float']['output'];
  /** Days the first certificate credits: 1.0 for Meridian and Sentinel (0.5 baseline plus 0.5), 0.5 for Verdant. */
  isoCreditFirstDays: Scalars['Float']['output'];
  isoCredits: Array<SpkIsoCredit>;
  product: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  reviewDaysEach: Scalars['Float']['output'];
  /** Implementation spot-checks | Third-party file reviews | Regulatory jurisdiction reviews */
  reviewName: Scalars['String']['output'];
  sectorLabel: Scalars['String']['output'];
  sectorMaxAdjustmentDays: Scalars['Float']['output'];
  /** Complexity tier | Exposure tier */
  sectorTierName: Scalars['String']['output'];
  /** The sector names only, in the workbook's order; the tier of a sector is Speeki's determination and is not published here. */
  sectors: Array<Scalars['String']['output']>;
  standard: Scalars['String']['output'];
  volumeLabel: Scalars['String']['output'];
};

export type SpkFeeSchedule = {
  /** Days by each of the Lead Assessor and Nicole AI: half of the total. */
  assessorDays: Scalars['Float']['output'];
  blendedRateUsd: Scalars['String']['output'];
  certificationIssuanceUsd: Scalars['String']['output'];
  leadAssessorFeeUsd: Scalars['String']['output'];
  leadAssessorRateUsd: Scalars['String']['output'];
  nicoleAiFeeUsd: Scalars['String']['output'];
  nicoleAiRateUsd: Scalars['String']['output'];
  /** per year | per quarter */
  perPeriodLabel: Scalars['String']['output'];
  /** What is invoiced per period: Year 1 for annual, a quarter of it for quarterly. */
  perPeriodUsd: Scalars['String']['output'];
  /** Year 1 at the rate card, before any commercial adjustment. */
  rateCardYear1Usd: Scalars['String']['output'];
  threeYearUsd: Scalars['String']['output'];
  travelUsd: Scalars['String']['output'];
  /** Year 1 after the commercial adjustments; the rate card when none apply. */
  year1Usd: Scalars['String']['output'];
  year2Usd: Scalars['String']['output'];
  year3Usd: Scalars['String']['output'];
};

export type SpkIsoCredit = {
  /** Days this certificate credits when it is not the first one counted: 0.5. The first certificate credits isoCreditFirstDays; the total is capped at isoCreditCapDays. */
  days: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Evidence for one held certification: which credit it is, who issued it and the month it expires. It credits only with an issuer and an expiry in the current month or later. */
export type SpkIsoEvidenceInput = {
  /** The expiry month, YYYY-MM. */
  expiry: Scalars['String']['input'];
  /** The credit id (see spkCertificationRules.isoCredits), e.g. iso14001. */
  id: Scalars['String']['input'];
  /** The certification body that issued it. */
  issuer: Scalars['String']['input'];
};

export type SpkPriceAdjustment = {
  detail: Scalars['String']['output'];
  /** engage | quarterly | rush | multiyear */
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Signed fraction, e.g. -0.15 or 0.25. */
  pct: Scalars['Float']['output'];
};

export type SsoAccount = {
  /** Sso provider that the account is associated with */
  provider?: Maybe<SsoProvider>;
  /** UUID of the Sso provider */
  ssoUuid: Scalars['UUID']['output'];
};

export type SsoAuthPayload = {
  /** @deprecated Use SessionPayload instead */
  refreshToken: Scalars['String']['output'];
  /** @deprecated Use SessionPayload instead */
  sessionToken: Scalars['String']['output'];
};

export type SsoAzureLoginInput = {
  /** IdToken received from Azure */
  idToken: Scalars['String']['input'];
  /** A type of user. Required to connect account with appropriate user type */
  userType: User_Type_Key;
};

export type SsoAzureSetupInput = {
  /** IdToken received from Azure */
  idToken: Scalars['String']['input'];
};

/** Returns informations about Azure AD SSO settings for tenant */
export type SsoAzureTenantInformation = {
  /**
   * Contains Azure Active Directory Unique Tenant ID
   * @deprecated Use SsoProvider Object type instead
   */
  azureTenantId?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates whether tenant is able to login using Azure.
   * @deprecated Use SsoProvider Object type instead
   */
  canLogin: Scalars['Boolean']['output'];
  /**
   * Indicates whether Azure SSO is enabled by Speeki Admin for given tenant.
   * @deprecated Use SsoProvider Object type instead
   */
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type SsoProvider = {
  /** sso app id */
  appId?: Maybe<Scalars['String']['output']>;
  /** Sso login url */
  loginUrl?: Maybe<Scalars['String']['output']>;
  /** Sso provider name */
  provider: Sso_Provider;
  /** Sso provider Id. For example Azure AD tenant ID */
  providerId: Scalars['String']['output'];
  /** SAML certificate */
  samlCertificate?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SsoProviderDeleteInput = {
  /** Uuid of the provider to delete */
  ssoProviderUuid: Scalars['UUID']['input'];
};

export type SsoSamlRequestUrlInput = {
  /** Determine a provider to generate a SAML request URL */
  ssoProviderUuid: Scalars['UUID']['input'];
};

/** Returns informations about SAML SSO settings for tenant */
export type SsoSamlTenantInformation = {
  /**
   * Indicates whether tenant is able to login using SAML.
   * @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant
   */
  canLogin: Scalars['Boolean']['output'];
  /**
   * Indicates whether SAML SSO is enabled by Speeki Admin for given tenant.
   * @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant
   */
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Returns informations about various sources of SSO for given tenant */
export type SsoTenantInformation = {
  /** @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant */
  azure: SsoAzureTenantInformation;
  /** @deprecated Use TenantBaseDataType.ssoProviders field to resolve available sso methods for a tenant */
  saml: SsoSamlTenantInformation;
};

export type SsoUpsertInput = {
  /** Id of an sso app. In some cases can be different than tenant id */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** Login url of the given provider. It is not required by all providers */
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  /** A provider */
  provider: Sso_Provider;
  /** Unique ID of the provider. Sometimes refereed as issuer. */
  providerId: Scalars['String']['input'];
  /** SAML certificate. Only form saml */
  samlCertificate?: InputMaybe<Scalars['String']['input']>;
  /** Tenant to setup sso */
  tenantUuid: Scalars['UUID']['input'];
};

export type SsoUserType =
  | 'EMPLOYEE'
  | 'GUEST'
  | 'SPEEKI_ADMIN'
  | 'TENANT_ADMIN';

/** Staff read of one order's contracted schedule, signer, and event history - what a signed order committed the client to, annotated year by year with what has happened, so staff can answer 'what did this client commit to, what have we invoiced, what is paid, what is still to collect, who signed, when' from this read alone. */
export type StaffOrderScheduleDetail = {
  /** The order's event timeline, chronological oldest-first - the same rows `orderEvents` returns, reused rather than recomputed. */
  events: Array<OrderEvent>;
  /** The year staff may mark delivered now (see markEngagementDelivered). Null when the order is not split, is not ACTIVATED or ACTIVE, every invoiced year is already delivered, or the year's start invoice has not been raised. */
  markDeliveredYear?: Maybe<Scalars['Int']['output']>;
  /** The contracted schedule, reusing OrderCommitment.schedule - the same builder the buyer saw before signing and the signed agreement itself prints. Empty for an order with no committed term recorded. */
  schedule: Array<StaffScheduleRow>;
  /** When the order was signed, read off its own event timeline. Null for an order that has not reached SIGNED. */
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who the agreement was actually signed by. Null for an order that has not been signed (or a free order, which activates without one). */
  signerName?: Maybe<Scalars['String']['output']>;
  /** The whole-term amount still to collect (tax-exclusive, money as a string): every scheduled year's amount, less what Xero has recorded as paid on each year actually invoiced (the activation invoice and any annual-ledger invoice); credit notes are not netted, and the figure floors at zero. Null when the order carries no committed term (nothing to sum). */
  stillToCollectUsd?: Maybe<Scalars['String']['output']>;
};

/** One year of a signed order's contracted schedule, annotated with what has happened to it. Amounts are tax-EXCLUSIVE, matching OrderCommitment.schedule - this reuses that same builder, never recomputing it. `paymentStatus` and `emailStatus` are never conflated: payment is Xero's own live read, email is the shop's own send-attempt state, and both are null on a row that has not been raised yet. */
export type StaffScheduleRow = {
  /** The net (tax-exclusive) amount committed for this period (money as a string), from OrderCommitment.schedule. */
  amountUsd: Scalars['String']['output'];
  /** The shop's own forward-billing send state for the raised invoice: NONE | CREATE_PENDING | EMAIL_PENDING | CREATED | FAILED. Null until raised. Never conflated with paymentStatus - a failed email does not mean the money is unpaid. */
  emailStatus?: Maybe<Scalars['String']['output']>;
  /** START | DELIVERY on a split order (paymentSplit HALF_ON_DELIVERY or SIXTY_ON_SIGN), where each year shows two rows with the same year: START is the 50% (60% for SIXTY_ON_SIGN) raised at activation or by the annual sweep, DELIVERY is the 50% (40% for SIXTY_ON_SIGN) raised when staff mark that year delivered or its audit finished. A DELIVERY row not yet marked shows the amount it will bill, invoiceRaised false and no invoice number. Null on an order that is not split. */
  instalment?: Maybe<Scalars['String']['output']>;
  /** The raised invoice's human number (e.g. 'INV-0042'). Null until raised. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Whether this year's invoice has actually been raised. False for every future year - the shop only ever raises the CURRENT period's invoice, never ahead of it. */
  invoiceRaised: Scalars['Boolean']['output'];
  /** Positional label for the row, from the schedule builder: "Due now (prorated)", "Due now", "Next" or "Then". */
  label: Scalars['String']['output'];
  /** Live Xero payment status of the raised invoice: DRAFT | SUBMITTED | AUTHORISED | PAID | VOIDED | DELETED | UNKNOWN. Null until raised. Never conflated with emailStatus. */
  paymentStatus?: Maybe<Scalars['String']['output']>;
  /** The day the NEXT period begins - the term/anniversary boundary, EXCLUSIVE of this period, UTC. */
  periodEnd: Scalars['DateTime']['output'];
  /** First covered day of this period (inclusive), UTC. */
  periodStart: Scalars['DateTime']['output'];
  /** Whether this row is a prorated part-year rather than a full year. */
  prorated: Scalars['Boolean']['output'];
  /** 1-based position in the schedule (year 1, year 2, ...). */
  year: Scalars['Int']['output'];
};

/** Interface abstracting common fields for surveys and disclosures */
export type StakeholderEngagementCommonData = {
  /** Survey audience type */
  audienceType: SurveyAudienceType;
  /** Flag indicating if user can edit or delete disclosure. */
  canEdit: Scalars['Boolean']['output'];
  /** List of audience countries. */
  countries?: Maybe<Array<SurveyCountry>>;
  /** Date of survey creation. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Survey/Disclosure description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if user is the author of engagement form. */
  isAuthor: Scalars['Boolean']['output'];
  /** Survey questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['output'];
  /** Survey/Disclosure name. */
  name: Scalars['String']['output'];
  /** List of audience relationships. */
  relationships?: Maybe<Array<SurveyUserRelationship>>;
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Last update of the survey data. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Survey/Disclosure unique identifier. */
  uuid: Scalars['ID']['output'];
};

export type StakeholderEngagementCommonDataSortFields =
  | 'CONTEXT'
  | 'COUNTRIES'
  | 'CREATED_AT'
  | 'NAME'
  | 'RELATIONSHIPS'
  | 'UPDATED_AT';

export type StakeholderEngagementCommonDataSortInput = {
  direction: SortDirection;
  field: StakeholderEngagementCommonDataSortFields;
};

/** Represents StakeholderEngagementConnectionConnection connection. */
export type StakeholderEngagementConnectionConnection = {
  /** Array of edges. */
  edges: Array<StakeholderEngagementConnectionEdge>;
  /** Array of direct nodes. */
  nodes: Array<StakeholderEngagementCommonData>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents StakeholderEngagementConnection connection edge. */
export type StakeholderEngagementConnectionEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the StakeholderEngagementConnection record. */
  node: StakeholderEngagementCommonData;
};

/** Represents pagination input for fetching draft surveys and disclosures. */
export type StakeholderEngagementConnectionInput = {
  /** Determines whether only Surveys or Disclosures are returned. If not provided results are mixed. */
  context?: InputMaybe<Array<SurveyContext>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<StakeholderEngagementCommonDataSortInput>>;
  /** Filter responses by status */
  status?: InputMaybe<Array<SurveyStatus>>;
};

/** Represents StandardAssignedRiskArea connection edge. */
export type StandardAssignedRiskAreaEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the StandardAssignedRiskArea record. */
  node: RiskArea;
};

/** Risk areas assigned to some standard connection. */
export type StandardAssignedRiskAreasConnection = {
  /** Array of edges. */
  edges: Array<StandardAssignedRiskAreaEdge>;
  /** Array of direct nodes. */
  nodes: Array<RiskArea>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

export type StandardAssignedRiskAreasConnectionInput = {
  /** Microservice requesting the risk areas */
  microservice?: InputMaybe<Risk_Areas_Service_Context>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<RiskAreaSortInput>>;
  /** Optional standard names used to filter assigned risk areas */
  standards?: InputMaybe<Array<Esg_Standard_Subcategory>>;
  /** Optional flag to only include enabled (if true), disabled (if false) or all if left unchecked */
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardEnabledUnitsInput = {
  /** Array of sectors for additional scope. */
  sectorUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Resolved standard UUID. */
  standardUuid: Scalars['UUID']['input'];
};

/** Represents Standard report generation input */
export type StandardReportGenerateInput = {
  /** When true will include default answer in report. */
  includeDefaultAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional name for report */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating should only answered questions be considered for answers. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** UUID of the standard to generate report for. */
  standardUuid: Scalars['UUID']['input'];
  /** Flag indicating should strict tag mode be used. If true, tagUuids are required to generate report. */
  strictTagMode?: Scalars['Boolean']['input'];
  /** Optional array of tag UUIDs. */
  tagUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of topic UUIDs. */
  topicUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Given years UUIDs that should be used for report generation. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type StaticTranslationsInput = {
  /** Available sources: MOBILE, WEBPORTAL */
  source: UserSource;
  /** Translation target input. Optional if user is signed in. */
  targetLanguage?: InputMaybe<LanguageCode>;
};

export type SubscriptionPlan = {
  /** Flat array of plan's feature settings/. */
  features: Array<FeatureSetting>;
  modules: ModuleSettings;
  name: Subscription_Plan;
  /** Plan uuid. */
  uuid: Scalars['UUID']['output'];
};

/** The caller tenant's current subscription term and what happens at its end: whether it renews by itself, for how long, and any notice of non-renewal on file. */
export type SubscriptionTerm = {
  /** Whether the caller may give or withdraw the notice: a tenant administrator holding the company-settings permission. Lets the screen hide the Don't renew button from everyone else. */
  canGiveNotice: Scalars['Boolean']['output'];
  /** When the current term ends and, if it renews, the new one starts. Null when the tenant has no fixed paid term (a trial, or no subscription). */
  endsOn?: Maybe<Scalars['DateTime']['output']>;
  /** When that notice was given. Null when none. */
  noticeGivenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who gave the notice of non-renewal on file: CUSTOMER or SPEEKI. Null when none. */
  noticeGivenBy?: Maybe<Scalars['String']['output']>;
  /** Length in years of the next term when the subscription renews; null otherwise. */
  renewalTermYears?: Maybe<Scalars['Int']['output']>;
  /** True when the term renews by itself at its end: a paid or Basic term with no notice of non-renewal on file. */
  renewsAutomatically: Scalars['Boolean']['output'];
};

/** Represents the input for subsidiary reporting settings */
export type SubsidiaryReportingSettingsInput = {
  subsidiaryChoiceEnabled: Scalars['Boolean']['input'];
  /** Providing NULL will restore default copy. Providing undefined will not update the field. */
  subsidiarySelectionCopy?: InputMaybe<Scalars['String']['input']>;
  useCustomCopy: Scalars['Boolean']['input'];
};

export type SubsidiarySite = {
  /** Array of admins. */
  admins?: Maybe<Array<UserType>>;
  /** Case owner exclusion of subsidiary site. */
  caseOwnerExclusion?: Maybe<CaseOwnerExclusion>;
  /** Flag indicating if subsidiary site is active. */
  isActive: Scalars['Boolean']['output'];
  /** Flag indicating if subsidiary is headquarters */
  isHeadquarters: Scalars['Boolean']['output'];
  /** Name of subsidiary site. */
  name: Scalars['String']['output'];
  /** Reporting group of subsidiary site. */
  reportingGroup?: Maybe<ReportingGroup>;
  reportingLabel?: Maybe<Scalars['String']['output']>;
  /** Reporting slug */
  reportingSlug?: Maybe<Scalars['String']['output']>;
  /** Resolves reporting URL for subsidiary. */
  reportingUrl?: Maybe<Scalars['URL']['output']>;
  /** Returns number of users in given subsidiary. Only counts active users. */
  userCount?: Maybe<Scalars['Int']['output']>;
  /** Array of users assigned to subsidiary. */
  users?: Maybe<Array<UserRole>>;
  /** UUID of subsidiary site. */
  uuid?: Maybe<Scalars['ID']['output']>;
};


export type SubsidiarySiteReportingLabelArgs = {
  tenantUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Represents SubsidiarySite connection edge. */
export type SubsidiarySiteEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SubsidiarySite record. */
  node: SubsidiarySite;
};

export type SubsidiarySiteGetInput = {
  /** Optional UUID for subsidiary site. Used for logged out context. */
  tenantUuid?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of subsidiary site.  */
  uuid: Scalars['UUID']['input'];
};

export type SubsidiarySiteHeadquartersReportingLabelUpdateInput = {
  reportingLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SubsidiarySiteInput = {
  /** Uuid of subsidiary. Null for HQ. */
  subsidiaryUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Tenant UUID. */
  tenantUuid: Scalars['String']['input'];
};

/** Represents subsidiary sites reporting options */
export type SubsidiarySiteReportingSettings = {
  /** Indicates whether current user can edit the setting. */
  canEdit: Scalars['Boolean']['output'];
  defaultCopy: Scalars['String']['output'];
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Copy for selection of subsidiary site. */
  subsidiarySelectionCopy?: Maybe<Scalars['String']['output']>;
  useCustomCopy: Scalars['Boolean']['output'];
};

export type SubsidiarySiteRoleUpdateInput = {
  /** Array of upsert inputs. */
  rolesToUpsert: Array<SubsidiarySiteRoleUpsertInput>;
  /** UUID of subsidiary to update. */
  subsidiaryUuid: Scalars['UUID']['input'];
  /** UUIDs of users whose roles to remove. */
  userUuidsRolesToDelete: Array<Scalars['ID']['input']>;
};

export type SubsidiarySiteRoleUpsertInput = {
  /** Target user role. REGIONAL_USER is not accepted. */
  role: User_Role;
  /** Edit role's user uuid. */
  userUuid: Scalars['String']['input'];
};

export type SubsidiarySiteStatusUpdateInput = {
  /** Flag indicating should subsidiary be active or inactive. */
  status: Scalars['Boolean']['input'];
  /** Subsidiary site UUID */
  uuid: Scalars['UUID']['input'];
};

export type SubsidiarySiteSwitchInput = {
  /** Uuid of the subsidiary site to switch */
  subsidiaryUuid: Scalars['UUID']['input'];
};

/** Represents input for subsidiary site update */
export type SubsidiarySiteUpdateInput = {
  /** New name of subsidiary. */
  name: Scalars['String']['input'];
  /** UUID of edited subsidiary site. */
  uuid: Scalars['UUID']['input'];
};

export type SubsidiarySiteUpsertInput = {
  /** Array of users to be set as admins in subsidiary. Omitted users will be removed as admins. */
  adminUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Flag indicating should subsidiary be set as active or inactive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subsidiary site name. Must be unique in tenant scope. */
  name: Scalars['String']['input'];
  /** Tenant uuid. */
  tenantUuid: Scalars['String']['input'];
  /** Optional - subsidiary site uuid. If present will try to update existing subsidiary. If missing will try to create new. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents pagination connection of subsidiary sites. */
export type SubsidiarySitesConnection = {
  /** Array of edges. */
  edges: Array<SubsidiarySiteEdge>;
  /** Array of direct nodes. */
  nodes: Array<SubsidiarySite>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represent pagination input for connection of subsidiary sites */
export type SubsidiarySitesConnectionInput = {
  /** Optional subsidiary site file name. */
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Tenant UUID. Used for unsgined contexts. */
  tenantUuid?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether headquarters should be included in connection. */
  withHeadquarters?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains data about minimum supported mobile app versions.Could be used to check if used app is outdated and needs to be forced to update. */
export type SupportedMobileAppVersions = {
  /** Contains minimum Android app version. Should contain exact tag name. */
  android: Scalars['String']['output'];
  /** Contains minimum Ios app version. Should contain exact tag name. */
  ios: Scalars['String']['output'];
};

/** Represents the survey object. */
export type Survey = StakeholderEngagementCommonData & {
  /** Survey audience type */
  audienceType: SurveyAudienceType;
  /** Flag indicating if user can edit or delete disclosure. */
  canEdit: Scalars['Boolean']['output'];
  /** List of audience countries. */
  countries?: Maybe<Array<SurveyCountry>>;
  /** Date of survey creation. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Resolves template author. Returns null for standard template and empty author. */
  createdBy?: Maybe<UserType>;
  /**
   * Survey creator name (tenants see the creator of the standard template as the Speeki trademark).
   * @deprecated Use createdBy.
   */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** Survey remaining number of days. */
  daysValidity?: Maybe<Scalars['Int']['output']>;
  /** Survey/Disclosure description. */
  description?: Maybe<Scalars['String']['output']>;
  emailTargets: Array<SurveyEmailTarget>;
  emailTargetsCount: Scalars['Int']['output'];
  /** End date of the survey (UTC). */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Flag indicating if user is the author of engagement form. */
  isAuthor: Scalars['Boolean']['output'];
  /** Survey questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['output'];
  /**
   * Last update of the survey data.
   * @deprecated Moved to updatedAt common field across surveys and disclosures
   */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Survey/Disclosure name. */
  name: Scalars['String']['output'];
  /** List of audience relationships. */
  relationships?: Maybe<Array<SurveyUserRelationship>>;
  /** Survey reminder. Determine frequency of reminding notifications. */
  reminder: SurveyReminder;
  /** Number of respondents in the current day. */
  respondersCountPerDay?: Maybe<Scalars['Int']['output']>;
  /** Total number of respondents. */
  respondersTotalCount?: Maybe<Scalars['Int']['output']>;
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Start date of the survey (UTC). */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Survey status. */
  status?: Maybe<SurveyStatus>;
  /** Last update of the survey data. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Survey/Disclosure unique identifier. */
  uuid: Scalars['ID']['output'];
};


/** Represents the survey object. */
export type SurveyEmailTargetsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Survey audience type. */
export type SurveyAudienceType =
  /** Survey that should be accessible by users with given emails. */
  | 'EMAIL'
  /** Survey that should be accessible by users with matching country and relationship settings */
  | 'RELATION';

/** Represents SurveyConnection connection. */
export type SurveyConnection = {
  /** Array of edges. */
  edges: Array<V2SurveyEdge>;
  /** Array of direct nodes. */
  nodes: Array<Survey>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  statistics?: Maybe<SurveyStatistics>;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Determines whether the object is of Survey or Disclosure type */
export type SurveyContext =
  | 'DISCLOSURE'
  | 'SURVEY';

/** Enumeration of country codes. */
export type SurveyCountry =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'ALL'
  | 'AM'
  | 'AN'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KV'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

/** Represents data needed for survey details retrieval. */
export type SurveyDetailsInput = {
  /** Survey unique identifier. */
  uuid: Scalars['ID']['input'];
};

/** Represents the edge container of paginated `Survey` data. */
export type SurveyEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: Survey;
};

export type SurveyEmailTarget = {
  /** Flag indicating if given email responded. */
  answered: Scalars['Boolean']['output'];
  /** Email */
  email: Scalars['String']['output'];
  /** Flag indicating if email has been sent to given target. */
  sent: Scalars['Boolean']['output'];
  /** Response to given survey. Null if unanswered or user answered anonymously. */
  surveyAnswer?: Maybe<SurveyResponse>;
  /** UUID of email target. */
  uuid: Scalars['ID']['output'];
};

/** Represents the filter input for the list of surveys. */
export type SurveyFilterInput = {
  /** Filter the surveys matching given countries. */
  countries?: InputMaybe<Array<SurveyCountry>>;
  /** Filter the surveys matching given date range. */
  dates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** If set to `true` returns the draft surveys of the context user. Additionally some response fields might resolve to `null` values (statistics, responders etc.) and rest of the filter fields are ignored. */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter the surveys matching given relationships. */
  relationships?: InputMaybe<Array<SurveyUserRelationship>>;
  /** Uuid of risk area to return only surveys related to given risk area. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter the surveys matching given statuses. */
  statuses?: InputMaybe<Array<SurveyStatus>>;
};

/** Enumeration of possible keys used to order a list of surveys. */
export type SurveyOrderField =
  | 'createdAt'
  | 'createdByName'
  | 'daysValidity'
  | 'endDate'
  | 'lastUpdatedAt'
  | 'name'
  | 'respondersTotalCount'
  | 'startDate'
  | 'status';

/** Represents the singular `SurveyOrderFieldInput` order input object. */
export type SurveyOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: SurveyOrderField;
};

/** Represents the input type for ordering the list of surveys. */
export type SurveyOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<SurveyOrderFieldInput>;
};

/** Represents the page container of paginated `Survey` data. */
export type SurveyPage = {
  /** List of edges. */
  edges?: Maybe<Array<SurveyEdge>>;
  /** Page information. */
  info: PageInfo;
};

/** Represents the list of paginated survey objects. */
export type SurveyPaginated = {
  /** Pages of data `edges` and page meta `info`. */
  page: SurveyPage;
  /** Represents the survey filtered list overall statistics. */
  statistics?: Maybe<SurveyStatistics>;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Enumeration of survey reminder types. */
export type SurveyReminder =
  | 'BIWEEKLY'
  | 'DAILY'
  | 'MONTHLY'
  | 'NONE'
  | 'WEEKLY';

/** Represents the input type required for updating survey reminder frequency */
export type SurveyReminderUpdateInput = {
  /** Intended survey reminder frequency. */
  reminder: SurveyReminder;
  /** Edited survey UUID */
  surveyUuid: Scalars['String']['input'];
};

export type SurveyReportUploadResponse = {
  /** A URL to PDF file uploaded to S3. */
  s3Url: Scalars['String']['output'];
};

/** Represents the survey response object. */
export type SurveyResponse = {
  /** Date when response was created. Accessible only by tenant admins. */
  createdAt: Scalars['DateTime']['output'];
  /** Survey response creator */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** UUID of survey responder. Accessible only by tenant admins. */
  createdByUuid?: Maybe<Scalars['String']['output']>;
  /** Response json object. Accessible only by tenant admins. */
  json: Scalars['JSON']['output'];
  /** Source of response. Accessible only by tenant admins. */
  source: SurveyUserSource;
  /** Survey unique UUID */
  surveyUuid: Scalars['String']['output'];
  /** The response unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the edge container of paginated `SurveyResponse` data. */
export type SurveyResponseEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: SurveyResponse;
};

/** Represents the input type required for answering the survey. */
export type SurveyResponseInput = {
  /** Flag indicating should answer by given anonymously. */
  anonymousResponse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Files related to survey template questions */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Survey answers JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['input'];
  /** The Answered survey unique identifier. This survey must be not yet answered by the context user and match to the user tenant. */
  surveyUuid: Scalars['ID']['input'];
};

/** Represents the page container of paginated `SurveyResponse` data. */
export type SurveyResponsePage = {
  /** List of edges. */
  edges?: Maybe<Array<SurveyResponseEdge>>;
  /** Page information. */
  info: PageInfo;
};

/** Represents the list of paginated survey responses */
export type SurveyResponsePaginated = {
  /** Pages of data `edges` and page meta `info`. */
  page: SurveyResponsePage;
  /** Survey object */
  surveyData?: Maybe<Survey>;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents the survey risk areas upsert input type. */
export type SurveyRiskAreasUpsertInput = {
  /** array of risk area uuids */
  riskAreaUuids: Array<Scalars['UUID']['input']>;
  /** survey uuid. */
  uuid: Scalars['UUID']['input'];
};

export type SurveySortFields =
  | 'createdAt'
  | 'createdByName'
  | 'daysValidity'
  | 'endDate'
  | 'lastUpdatedAt'
  | 'name'
  | 'respondersTotalCount'
  | 'startDate'
  | 'status';

export type SurveySortInput = {
  direction: SortDirection;
  field: SurveySortFields;
};

/** Represents the survey filtered list overall statistics. */
export type SurveyStatistics = {
  /** Number of completed surveys. */
  completedCount: Scalars['Float']['output'];
  /** Number of ongoing surveys. */
  ongoingCount: Scalars['Float']['output'];
  /** Number of scheduled surveys. */
  scheduledCount: Scalars['Float']['output'];
};

/** Enumeration of survey status types. */
export type SurveyStatus =
  | 'COMPLETED'
  | 'DRAFT'
  | 'ONGOING'
  | 'SCHEDULED';

/** Represents the input type required for updating survey status. */
export type SurveyStatusUpdateInput = {
  /** New survey status. Currently the only supported status is "COMPLETED" */
  status: SurveyStatus;
  /** UUID of the survey that should be updated */
  surveyUuid: Scalars['String']['input'];
};

/** Represents survey summary object. */
export type SurveySummary = {
  url: Scalars['String']['output'];
};

/** Represents the survey template object. */
export type SurveyTemplate = {
  /** Flag indicating if user can edit or delete disclosure. */
  canEdit: Scalars['Boolean']['output'];
  /** Template creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** Survey template creator name (tenants see the creator of the standard template as the Speeki trademark). */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if user is the disclosure author. */
  isAuthor: Scalars['Boolean']['output'];
  /** States if survey template is public or private for tenant templates. In the case of a standard template, the falsy `isPublic` flag means the template is a draft. */
  isPublic: Scalars['Boolean']['output'];
  /** Survey questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['output'];
  /** Last update of the survey template data. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Survey template unique name. */
  name: Scalars['String']['output'];
  type: SurveyTemplateType;
  /** Survey template unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents the edge container of paginated `SurveyTemplate` data. */
export type SurveyTemplateEdge = {
  /** Element cursor position in the whole list. */
  cursor: Scalars['String']['output'];
  /** Data element. */
  node: SurveyTemplate;
};

/** Enumeration of possible keys used to order a list of survey templates. */
export type SurveyTemplateOrderField =
  | 'createdByName'
  | 'lastUpdatedAt'
  | 'name';

/** Represents the singular `SurveyTemplateOrderFieldInput` order input object. */
export type SurveyTemplateOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: SurveyTemplateOrderField;
};

/** Represents the input type for ordering the list of survey templates. */
export type SurveyTemplateOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<SurveyTemplateOrderFieldInput>;
};

/** Represents the page container of paginated `SurveyTemplate` data. */
export type SurveyTemplatePage = {
  /** List of edges. */
  edges?: Maybe<Array<SurveyTemplateEdge>>;
  /** Page information. */
  info: PageInfo;
};

/** Represents the list of paginated survey template type objects. */
export type SurveyTemplatePaginated = {
  /** Pages of data `edges` and page meta `info`. */
  page: SurveyTemplatePage;
  /** Total count of elements on all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents the survey template type object. */
export type SurveyTemplateType = {
  /** States if the context user is an owner of this template. */
  isOwner: Scalars['Boolean']['output'];
  /** States if this is the standard template (from Speeki admin portal). */
  isStandardTemplate: Scalars['Boolean']['output'];
  /** Template type enumeration label. */
  label: TemplateTypeLabel;
};

/** Represents the input type required for survey template edition or creation. */
export type SurveyTemplateUpsertInput = {
  /** Files related to survey template questions */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Edited or new public or private survey template state (public or draft for standard template). */
  isPublic: Scalars['Boolean']['input'];
  /** Edited or new template questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['input'];
  /** Edited or new survey template name. */
  name: Scalars['String']['input'];
  /** Scope for template (where it can be used later) */
  scope?: Template_Scope;
  /** Edited survey template unique identifier. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Enumeration of possible keys used to order a list of surveys queried by text. */
export type SurveyTextSearchOrderField =
  | 'createdByName'
  | 'endDate'
  | 'lastUpdatedAt'
  | 'name'
  | 'startDate'
  | 'status';

/** Represents the singular `SurveyTextSearchOrderFieldInput` order input object. */
export type SurveyTextSearchOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: SurveyTextSearchOrderField;
};

/** Represents the input type for ordering the list of surveys queried by text. */
export type SurveyTextSearchOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<SurveyTextSearchOrderFieldInput>;
};

/** Represents the input type required for survey edition or creation. */
export type SurveyUpsertInput = {
  /** Type of survey audience, by email list or by country and relationship to company */
  audienceType?: InputMaybe<SurveyAudienceType>;
  /** Edited or new survey countries array. */
  countries?: InputMaybe<Array<SurveyCountry>>;
  /** Edited or new survey description. */
  description?: InputMaybe<Scalars['String']['input']>;
  emailAudienceInput?: InputMaybe<EmailAudienceInput>;
  /** Edited or new survey end date. Must be future date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Files related to survey questions */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Survey draft flag. Defaults to `true`. If set to `false` act as schedule action which requires some fields to be set. */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Edited or new survey questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['input'];
  /** Edited or new survey name. */
  name: Scalars['String']['input'];
  /** Edited or new survey relationships array. */
  relationships?: InputMaybe<Array<SurveyUserRelationship>>;
  /** Edited survey reminder. Determine the frequency of reminding survey completion. By default, no reminder is set. */
  reminder?: InputMaybe<SurveyReminder>;
  /** Edited or new survey start date. Must be future date and not earlier than endDate. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Edited survey template unique identifier. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Enumeration of possible keys used to order a list of surveys queried by user. */
export type SurveyUserOrderField =
  | 'createdAt'
  | 'lastUpdatedAt'
  | 'name';

/** Represents the singular `SurveyUserOrderFieldInput` order input object. */
export type SurveyUserOrderFieldInput = {
  /** Order direction of the field. */
  direction?: InputMaybe<SortingOrderDirection>;
  /** Name of the order field. */
  field: SurveyUserOrderField;
};

/** Represents the input type for ordering the list of surveys. */
export type SurveyUserOrderInput = {
  /** Array of order input objects. The earlier the item position, the higher priority it has. */
  orderBy: Array<SurveyUserOrderFieldInput>;
};

/** Enumeration of user relationships. */
export type SurveyUserRelationship =
  | 'ALL'
  | 'ANONYMOUS'
  | 'CUSTOMER'
  | 'EMPLOYEE'
  | 'EX_EMPLOYEE'
  | 'FAMILY'
  | 'INVESTOR'
  | 'OTHER'
  | 'SUPPLIER';

/** Enumeration of survey response sources. */
export type SurveyUserSource =
  | 'CM'
  | 'ELINE'
  | 'MOBILE'
  | 'UNKNOWN'
  | 'WEBPORTAL';

/** Represents pagination input for user survey list. */
export type SurveysConnectionInput = {
  /** Filter the surveys matching given countries. */
  countries?: InputMaybe<Array<SurveyCountry>>;
  /** Filter the surveys matching given date range. */
  dates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  excludedUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  /** If set to `true` returns the draft surveys of the context user. Additionally some response fields might resolve to `null` values (statistics, responders etc.) and rest of the filter fields are ignored. */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Filter the surveys matching given relationships. */
  relationships?: InputMaybe<Array<SurveyUserRelationship>>;
  /**
   * Uuid of risk area to return only surveys assigned to given risk area. When no value is provided all standard templates will be returned.
   * @deprecated use SurveysConnectionInput::riskAreaUuids instead
   */
  riskAreaUuid?: InputMaybe<Scalars['String']['input']>;
  /** Uuid of risk area to return only surveys assigned to given risk area */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<SurveySortInput>>;
  /** Filter the surveys matching given statuses. */
  statuses?: InputMaybe<Array<SurveyStatus>>;
};

export type Symbol = {
  /** denotation of the symbol (eg. kg) */
  denotation: Scalars['String']['output'];
  /** flag indicating if symbol is default in system */
  isSeeded: Scalars['Boolean']['output'];
  /** name of the symbol */
  name: Scalars['String']['output'];
  /** UUID of the symbol */
  uuid: Scalars['UUID']['output'];
};

/** Represents input for getting Symbol by id. */
export type SymbolByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents SymbolConnection connection. */
export type SymbolConnection = {
  /** Array of edges. */
  edges: Array<SymbolEdge>;
  /** Array of direct nodes. */
  nodes: Array<Symbol>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of Symbols. */
export type SymbolConnectionInput = {
  /** filter by name or denotation (for search) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<SymbolSortInput>>;
  /** Enum to filter symbols by its use type */
  type?: InputMaybe<Array<Symbol_Type>>;
};

/** Represents Symbol connection edge. */
export type SymbolEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Symbol record. */
  node: Symbol;
};

export type SymbolSortFields =
  | 'DENOTATION'
  | 'NAME';

export type SymbolSortInput = {
  direction: SortDirection;
  field: SymbolSortFields;
};

export type Tag_Search_Scope =
  | 'GROUP_TAG_NAME'
  | 'RISK_AREA_NAME'
  | 'TAG_NAME';

export type Tag_SortSortFields =
  | 'GROUP_TAG_NAME'
  | 'NAME'
  | 'RISK_AREA_NAME';

export type Tag_SortSortInput = {
  direction: SortDirection;
  field: Tag_SortSortFields;
};

/** Represents direction for target (ie. DECREASE, INCREASE, CONSTANT) */
export type Target_Direction =
  | 'CONSTANT'
  | 'DECREASE'
  | 'INCREASE';

/** Represents target point type (ie. OVERALL, YEARLY, RECURRING) */
export type Target_Point =
  | 'OVERALL'
  | 'RECURRING'
  | 'YEARLY';

/** Step key. */
export type Tasks_Step_Key =
  | 'ACCESS_FOR_LOW_INCOME_PATIENTS'
  | 'ACCESS_TO_COVERAGE'
  | 'ACCESS_TO_MEDICINES'
  | 'ACCIDENT_MANAGEMENT'
  | 'ACCIDENT_SAFETY_MANAGEMENT'
  | 'ADVERTISING_INTEGRITY'
  | 'AFFORDABILITY_PRICING'
  | 'AIR_EMISSIONS_FROM_REFRIGERATION'
  | 'AIR_QUALITY'
  | 'ANIMAL_CARE_WELFARE'
  | 'ANIMAL_FEED_SOURCING'
  | 'ANTIBIOTIC_USE_IN_ANIMAL_PRODUCTION'
  | 'BIODIVERSITY_IMPACTS'
  | 'BP_1'
  | 'BP_2'
  | 'BUILD'
  | 'BUSINESS_CONTEXT'
  | 'BUSINESS_ETHICS'
  | 'BUSINESS_ETHICS_PAYMENTS_TRANSPARENCY'
  | 'BUSINESS_ETHICS_TRANSPARENCY'
  | 'BUSINESS_MODEL_AND_VALUE_CHAIN'
  | 'BUSINESS_OVERVIEW'
  | 'BUY_IN'
  | 'CHEMICALS_MANAGEMENT'
  | 'CHEMICAL_SAFETY_HAZARDS_OF_PRODUCTS'
  | 'CLIMATE_CHANGE_ADAPTATION'
  | 'CLIMATE_CHANGE_IMPACTS_ON_HUMAN_HEALTH'
  | 'CLIMATE_CHANGE_IMPACTS_ON_HUMAN_HEALTH_INFRASTRUCTURE'
  | 'CLIMATE_IMPACTS_OF_BUSINESS_MIX'
  | 'CLIMATE_RELATED_METRICS'
  | 'CLIMATE_RELATED_RISKS_AND_OPPORTUNITIES'
  | 'CLIMATE_RELATED_TARGETS'
  | 'CLIMATE_RESILIENCE'
  | 'COAL_ASH_MANAGEMENT'
  | 'COMMITMENT'
  | 'COMMUNICATE'
  | 'COMMUNITY_IMPACTS_OF_NEW_DEVELOPMENTS'
  | 'COMMUNITY_RELATIONS'
  | 'COMPARATIVE_INFORMATION'
  | 'COMPETITIVE_BEHAVIOUR'
  | 'COMPETITIVE_BEHAVIOUR_OPEN_INTERNET'
  | 'CONTEXT_OF_THE_ORGANISATION'
  | 'COUNTERFEIT_DRUGS'
  | 'CRITICAL_INCIDENT_RISK_MANAGEMENT'
  | 'CSMS1000_AWARENESS_TRAINING'
  | 'CSMS1000_BUSINESS_CONTEXT'
  | 'CSMS1000_BUYIN_LEADERSHIP'
  | 'CSMS1000_IMPACTS_RISKS_OPPORTUNITIES'
  | 'CSMS1000_IMPROVEMENT'
  | 'CSMS1000_LEVERAGE'
  | 'CSMS1000_OBJECTIVES_STRATEGY'
  | 'CSMS1000_PERFORMANCE_AUDIT'
  | 'CSMS1000_POLICIES_CONTROLS'
  | 'CSMS1000_ROLES_COMPETENCE'
  | 'CUSTOMER_HEALTH_SAFETY'
  | 'CUSTOMER_PRIVACY'
  | 'CUSTOMER_PRIVACY_TECHNOLOGY_STANDARDS'
  | 'CUSTOMER_SAFETY'
  | 'DATA_PRIVACY'
  | 'DATA_PRIVACY_ADVERTISING_STANDARDS'
  | 'DATA_PRIVACY_ADVERTISING_STANDARDS_FREEDOM_OF_EXPRESSION'
  | 'DATA_PRIVACY_FREEDOM_OF_EXPRESSION'
  | 'DATA_SECURITY'
  | 'DATA_SECURITY_PRIVACY'
  | 'DDMS2000_AWARENESS_TRAINING'
  | 'DDMS2000_BUSINESS_CONTEXT'
  | 'DDMS2000_BUYIN_LEADERSHIP'
  | 'DDMS2000_DOCUMENTATION_DISCLOSURE'
  | 'DDMS2000_IMPROVEMENT'
  | 'DDMS2000_OBJECTIVES_STRATEGY'
  | 'DDMS2000_PERFORMANCE_AUDIT'
  | 'DDMS2000_POLICIES_CONTROLS'
  | 'DDMS2000_ROLES_COMPETENCE'
  | 'DDMS2000_UNDERSTANDING_RISKS'
  | 'DESIGN_FOR_FUEL_EFFICIENCY'
  | 'DESIGN_FOR_RESOURCE_EFFICIENCY'
  | 'DEVELOP_THE_WHISTLEBLOWING_POLICY'
  | 'DISCHARGE_MANAGEMENT_ECOLOGICAL_IMPACTS'
  | 'DISCLOSURE_OF_INFORMATION_ABOUT_SOURCES_OF_GUIDANCE'
  | 'DISCRIMINATORY_LENDING'
  | 'DISTRIBUTION_NETWORK_EFFICIENCY'
  | 'DRINKING_WATER_QUALITY'
  | 'DRUG_SAFETY'
  | 'DRUG_SUPPLY_CHAIN_INTEGRITY'
  | 'E1_1'
  | 'E1_2'
  | 'E1_3'
  | 'E1_4'
  | 'E1_5'
  | 'E1_6'
  | 'E1_7'
  | 'E1_8'
  | 'E1_9'
  | 'E1_GOV_3'
  | 'E1_IRO_1'
  | 'E1_SBM_3'
  | 'E2_1'
  | 'E2_2'
  | 'E2_3'
  | 'E2_4'
  | 'E2_5'
  | 'E2_6'
  | 'E2_IRO_1'
  | 'E3_1'
  | 'E3_2'
  | 'E3_3'
  | 'E3_4'
  | 'E3_5'
  | 'E3_IRO_1'
  | 'E4_1'
  | 'E4_2'
  | 'E4_3'
  | 'E4_4'
  | 'E4_5'
  | 'E4_6'
  | 'E4_IRO_1'
  | 'E4_SBM_3'
  | 'E5_1'
  | 'E5_2'
  | 'E5_3'
  | 'E5_4'
  | 'E5_5'
  | 'E5_6'
  | 'E5_IRO_1'
  | 'ECOLOGICAL_IMPACTS'
  | 'ECOLOGICAL_IMPACTS_OF_PROJECT_DEVELOPMENT'
  | 'ECOLOGICAL_IMPACT_MANAGEMENT'
  | 'ECOSYSTEM_SERVICES_IMPACTS'
  | 'EFFLUENT_QUALITY_MANAGEMENT'
  | 'EMISSIONS_REDUCTION_SERVICES_FUELS_MANAGEMENT'
  | 'EMPLOYEE_DIVERSITY_INCLUSION'
  | 'EMPLOYEE_INCENTIVES_RISK_TAKING'
  | 'EMPLOYEE_RECRUITMENT_DEVELOPMENT_RETENTION'
  | 'EMPLOYEE_RECRUITMENT_INCLUSION_PERFORMANCE'
  | 'END_USE_EFFICIENCY'
  | 'END_USE_EFFICIENCY_DEMAND'
  | 'ENERGY_AFFORDABILITY'
  | 'ENERGY_MANAGEMENT'
  | 'ENERGY_MANAGEMENT_IN_MANUFACTURING'
  | 'ENERGY_MANAGEMENT_IN_RETAIL'
  | 'ENERGY_MANAGEMENT_IN_RETAIL_DISTRIBUTION'
  | 'ENVIRONMENTAL_FOOTPRINT_OF_HARDWARE_INFRASTRUCTURE'
  | 'ENVIRONMENTAL_FOOTPRINT_OF_OPERATIONS'
  | 'ENVIRONMENTAL_IMPACTS_IN_THE_SUPPLY_CHAIN'
  | 'ENVIRONMENTAL_IMPACTS_OF_PROJECT_DEVELOPMENT'
  | 'ENVIRONMENTAL_RISK_TO_MORTGAGED_PROPERTIES'
  | 'ENVIRONMENTAL_SOCIAL_IMPACTS_OF_ANIMAL_SUPPLY_CHAIN'
  | 'ENVIRONMENTAL_SOCIAL_IMPACTS_OF_INGREDIENT_SUPPLY_CHAIN'
  | 'ENVIRONMENTAL_SOCIAL_IMPACTS_OF_PALM_OIL_SUPPLY_CHAIN'
  | 'ERRORS'
  | 'ETHICAL_MARKETING'
  | 'FINANCED_EMISSIONS'
  | 'FINANCIAL_INCLUSION_CAPACITY_BUILDING'
  | 'FINANCIAL_POSITION_FINANCIAL_PERFORMANCE_AND_CASH_FLOWS'
  | 'FLEET_FUEL_ECONOMY_UTILISATION'
  | 'FLEET_FUEL_MANAGEMENT'
  | 'FOOD_PACKAGING_WASTE_MANAGEMENT'
  | 'FOOD_SAFETY'
  | 'FOOD_WASTE_MANAGEMENT'
  | 'FRAUD_UNNECESSARY_PROCEDURES'
  | 'FUEL_ECONOMY_EMISSIONS_IN_USE_PHASE'
  | 'FUEL_ECONOMY_USE_PHASE_EMISSIONS'
  | 'G1_1'
  | 'G1_2'
  | 'G1_3'
  | 'G1_4'
  | 'G1_5'
  | 'G1_6'
  | 'G1_GOV_1'
  | 'GCMS3000_CONTEXT'
  | 'GCMS3000_IMPROVEMENT'
  | 'GCMS3000_LEADERSHIP'
  | 'GCMS3000_LEVERAGE'
  | 'GCMS3000_OPERATION'
  | 'GCMS3000_PERFORMANCE'
  | 'GCMS3000_PLANNING'
  | 'GCMS3000_SUPPORT'
  | 'GENERAL'
  | 'GENETICALLY_MODIFIED_ORGANISMS'
  | 'GMO_MANAGEMENT'
  | 'GOVERNANCE'
  | 'GOVERNANCE_STRUCTURE'
  | 'GOV_1'
  | 'GOV_2'
  | 'GOV_3'
  | 'GOV_4'
  | 'GOV_5'
  | 'GREENHOUSE_GAS_EMISSIONS'
  | 'GREENHOUSE_GAS_EMISSIONS_ENERGY_RESOURCE_PLANNING'
  | 'GRID_RESILIENCY'
  | 'HARDWARE_INFRASTRUCTURE_ENERGY_WATER_MANAGEMENT'
  | 'HAZARDOUS_MATERIALS_MANAGEMENT'
  | 'HAZARDOUS_WASTE_MANAGEMENT'
  | 'HEALTH_NUTRITION'
  | 'IDENTIFYING_APPLICABLE_DISCLOSURE_REQUIREMENTS'
  | 'IDENTIFYING_SUSTAINABILITY_RELATED_RISKS_AND_OPPORTUNITIES'
  | 'IMPROVED_OUTCOMES'
  | 'IMPROVEMENT'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_CREDIT_ANALYSIS'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_INVESTMENT_BANKING_BROKERAGE_ACTIVITIES'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_INVESTMENT_MANAGEMENT'
  | 'INCORPORATION_OF_ENVIRONMENTAL_SOCIAL_AND_GOVERNANCE_FACTORS_IN_INVESTMENT_MANAGEMENT_ADVISORY'
  | 'INGREDIENT_SOURCING'
  | 'INSIGHTS'
  | 'INTEGRITY_OF_GAS_DELIVERY_INFRASTRUCTURE'
  | 'INTELLECTUAL_PROPERTY_PROTECTION_COMPETITIVE_BEHAVIOUR'
  | 'INTELLECTUAL_PROPERTY_PROTECTION_MEDIA_PIRACY'
  | 'IRO_1'
  | 'IRO_2'
  | 'ISO_9001_CONTEXT'
  | 'ISO_9001_IMPROVEMENT'
  | 'ISO_9001_LEADERSHIP'
  | 'ISO_9001_OPERATION'
  | 'ISO_9001_PERFORMANCE'
  | 'ISO_9001_PLANNING'
  | 'ISO_9001_SUPPORT'
  | 'ISO_14001_CONTEXT'
  | 'ISO_14001_IMPROVEMENT'
  | 'ISO_14001_LEADERSHIP'
  | 'ISO_14001_OPERATION'
  | 'ISO_14001_PERFORMANCE'
  | 'ISO_14001_PLANNING'
  | 'ISO_14001_SUPPORT'
  | 'ISO_17298_ACTION_PLAN'
  | 'ISO_17298_COMMUNICATION'
  | 'ISO_17298_CONTEXT'
  | 'ISO_17298_IMPACTS_RISKS'
  | 'ISO_17298_IMPLEMENTATION'
  | 'ISO_17298_INTERESTED_PARTIES'
  | 'ISO_26000_CORE_SUBJECTS'
  | 'ISO_26000_INTEGRATING'
  | 'ISO_26000_PRINCIPLES'
  | 'ISO_26000_RECOGNISING_SR'
  | 'ISO_27001_CONTEXT'
  | 'ISO_27001_IMPROVEMENT'
  | 'ISO_27001_LEADERSHIP'
  | 'ISO_27001_OPERATION'
  | 'ISO_27001_ORG_CONTROLS'
  | 'ISO_27001_PEOPLE_CONTROLS'
  | 'ISO_27001_PERFORMANCE'
  | 'ISO_27001_PHYSICAL_CONTROLS'
  | 'ISO_27001_PLANNING'
  | 'ISO_27001_SUPPORT'
  | 'ISO_27001_TECH_CONTROLS'
  | 'ISO_27002_ORG_CONTROLS'
  | 'ISO_27002_PEOPLE_CONTROLS'
  | 'ISO_27002_PHYSICAL_CONTROLS'
  | 'ISO_27002_TECH_CONTROLS'
  | 'ISO_37003_CONTEXT'
  | 'ISO_37003_IMPROVEMENT'
  | 'ISO_37003_LEADERSHIP'
  | 'ISO_37003_OPERATION'
  | 'ISO_37003_PERFORMANCE'
  | 'ISO_37003_PLANNING'
  | 'ISO_37003_SUPPORT'
  | 'ISO_37008_DISCIPLINARY'
  | 'ISO_37008_POLICY'
  | 'ISO_37008_PRINCIPLES'
  | 'ISO_37008_PROCESS'
  | 'ISO_37008_REMEDIATION'
  | 'ISO_37008_SAFETY'
  | 'ISO_37008_STAKEHOLDERS'
  | 'ISO_37008_SUPPORT'
  | 'ISO_37200_CONTEXT'
  | 'ISO_37200_IMPROVEMENT'
  | 'ISO_37200_LEADERSHIP'
  | 'ISO_37200_OPERATION'
  | 'ISO_37200_PERFORMANCE'
  | 'ISO_37200_RISK_ASSESSMENT'
  | 'ISO_37200_SUPPORT'
  | 'ISO_42001_AI_POLICIES'
  | 'ISO_42001_CONTEXT'
  | 'ISO_42001_DATA'
  | 'ISO_42001_IMPACT_ASSESSMENT'
  | 'ISO_42001_IMPROVEMENT'
  | 'ISO_42001_INTERESTED_PARTIES'
  | 'ISO_42001_INTERNAL_ORG'
  | 'ISO_42001_LEADERSHIP'
  | 'ISO_42001_LIFE_CYCLE'
  | 'ISO_42001_OPERATION'
  | 'ISO_42001_PERFORMANCE'
  | 'ISO_42001_PLANNING'
  | 'ISO_42001_RESOURCES'
  | 'ISO_42001_SUPPORT'
  | 'ISO_42001_THIRD_PARTY'
  | 'ISO_42001_USE'
  | 'ISO_45001_CONTEXT'
  | 'ISO_45001_IMPROVEMENT'
  | 'ISO_45001_LEADERSHIP'
  | 'ISO_45001_OPERATION'
  | 'ISO_45001_PERFORMANCE'
  | 'ISO_45001_PLANNING'
  | 'ISO_45001_SUPPORT'
  | 'ISO_50001_CONTEXT'
  | 'ISO_50001_IMPROVEMENT'
  | 'ISO_50001_LEADERSHIP'
  | 'ISO_50001_OPERATION'
  | 'ISO_50001_PERFORMANCE'
  | 'ISO_50001_PLANNING'
  | 'ISO_50001_SUPPORT'
  | 'ISO_50002_1_COMPETENCE'
  | 'ISO_50002_1_PERFORMING'
  | 'ISO_50002_1_PRINCIPLES'
  | 'JOURNALISTIC_INTEGRITY_SPONSORSHIP_IDENTIFICATION'
  | 'JUDGEMENTS'
  | 'LABOUR_CONDITIONS_IN_THE_SUPPLY_CHAIN'
  | 'LABOUR_PRACTICES'
  | 'LABOUR_RELATIONS'
  | 'LAND_USE_ECOLOGICAL_IMPACTS'
  | 'LEADERSHIP'
  | 'LENDING_PRACTICES'
  | 'LEVERAGE'
  | 'LIFECYCLE_EMISSIONS_BALANCE'
  | 'LIFECYCLE_IMPACTS_OF_BUILDINGS_INFRASTRUCTURE'
  | 'LOCATION_OF_DISCLOSURES'
  | 'MANAGEMENT_OF_CHEMICALS_IN_PRODUCTS'
  | 'MANAGEMENT_OF_CONTROLLED_SUBSTANCES'
  | 'MANAGEMENT_OF_ENERGY_INFRASTRUCTURE_INTEGRATION_RELATED_REGULATIONS'
  | 'MANAGEMENT_OF_ENVIRONMENTAL_SOCIAL_IMPACTS_IN_THE_SUPPLY_CHAIN'
  | 'MANAGEMENT_OF_LEACHATE_HAZARDOUS_WASTE'
  | 'MANAGEMENT_OF_THE_LEGAL_REGULATORY_ENVIRONMENT'
  | 'MANAGING_BUSINESS_CONTINUITY_TECHNOLOGY_RISKS'
  | 'MANAGING_CONFLICTS_OF_INTEREST'
  | 'MANAGING_SYSTEMIC_RISKS_FROM_TECHNOLOGY_DISRUPTIONS'
  | 'MARKETING_PRACTICES'
  | 'MARKETING_RECRUITING_PRACTICES'
  | 'MATERIALITY_ASSESSMENT'
  | 'MATERIALS_EFFICIENCY'
  | 'MATERIALS_EFFICIENCY_RECYCLING'
  | 'MATERIALS_SOURCING'
  | 'MEASUREMENT_UNCERTAINTY'
  | 'MEDIA_PLURALISM'
  | 'METRICS_ADVERTISING_MARKETING'
  | 'METRICS_AEROSPACE_DEFENCE'
  | 'METRICS_AGRICULTURAL_PRODUCTS'
  | 'METRICS_AIRLINES'
  | 'METRICS_AIR_FREIGHT_LOGISTICS'
  | 'METRICS_ALCOHOLIC_BEVERAGES'
  | 'METRICS_AND_TARGETS'
  | 'METRICS_APPAREL_ACCESSORIES_FOOTWEAR'
  | 'METRICS_APPLIANCE_MANUFACTURING'
  | 'METRICS_ASSET_MANAGEMENT_CUSTODY_ACTIVITIES'
  | 'METRICS_AUTO_PARTS'
  | 'METRICS_BIOFUELS'
  | 'METRICS_BIOTECHNOLOGY_PHARMACEUTICALS'
  | 'METRICS_BUILDING_PRODUCTS_FURNISHINGS'
  | 'METRICS_CAR_RENTAL_LEASING'
  | 'METRICS_CHEMICALS'
  | 'METRICS_COAL_OPERATIONS'
  | 'METRICS_COMMERCIAL_BANKS'
  | 'METRICS_CONSTRUCTION_MATERIALS'
  | 'METRICS_CONSUMER_FINANCE'
  | 'METRICS_CONTAINERS_PACKAGING'
  | 'METRICS_CRUISE_LINES'
  | 'METRICS_DRUG_RETAILERS'
  | 'METRICS_EDUCATION'
  | 'METRICS_ELECTRICAL_ELECTRONIC_EQUIPMENT'
  | 'METRICS_ELECTRIC_UTILITIES_POWER_GENERATORS'
  | 'METRICS_ELECTRONIC_MANUFACTURING_SERVICES_ORIGINAL_DESIGN_MANUFACTURING'
  | 'METRICS_ENGINEERING_CONSTRUCTION_SERVICES'
  | 'METRICS_E_COMMERCE'
  | 'METRICS_FOOD_RETAILERS_DISTRIBUTORS'
  | 'METRICS_FORESTRY_MANAGEMENT'
  | 'METRICS_FUEL_CELLS_INDUSTRIAL_BATTERIES'
  | 'METRICS_GAS_UTILITIES_DISTRIBUTORS'
  | 'METRICS_HARDWARE'
  | 'METRICS_HEALTH_CARE_DELIVERY'
  | 'METRICS_HEALTH_CARE_DISTRIBUTORS'
  | 'METRICS_HOME_BUILDERS'
  | 'METRICS_HOTELS_LODGING'
  | 'METRICS_HOUSEHOLD_PERSONAL_PRODUCTS'
  | 'METRICS_INDUSTRIAL_MACHINERY_GOODS'
  | 'METRICS_INSURANCE'
  | 'METRICS_INTERNET_MEDIA_SERVICES'
  | 'METRICS_INVESTMENT_BANKING_BROKERAGE'
  | 'METRICS_IRON_STEEL_PRODUCERS'
  | 'METRICS_LEISURE_FACILITIES'
  | 'METRICS_MANAGED_CARE'
  | 'METRICS_MARINE_TRANSPORTATION'
  | 'METRICS_MEAT_POULTRY_DAIRY'
  | 'METRICS_MEDIA_ENTERTAINMENT'
  | 'METRICS_MEDICAL_EQUIPMENT_SUPPLIES'
  | 'METRICS_METALS_MINING'
  | 'METRICS_MORTGAGE_FINANCE'
  | 'METRICS_MULTILINE_SPECIALTY_RETAILERS_DISTRIBUTORS'
  | 'METRICS_NON_ALCOHOLIC_BEVERAGES'
  | 'METRICS_OIL_GAS_EXPLORATION_PRODUCTION'
  | 'METRICS_OIL_GAS_MIDSTREAM'
  | 'METRICS_OIL_GAS_REFINING_MARKETING'
  | 'METRICS_OIL_GAS_SERVICES'
  | 'METRICS_PROCESSED_FOODS'
  | 'METRICS_PROFESSIONAL_COMMERCIAL_SERVICES'
  | 'METRICS_PULP_PAPER_PRODUCTS'
  | 'METRICS_RAIL_TRANSPORTATION'
  | 'METRICS_REAL_ESTATE_SERVICES'
  | 'METRICS_RESTAURANTS'
  | 'METRICS_ROAD_TRANSPORTATION'
  | 'METRICS_SECURITY_COMMODITY_EXCHANGES'
  | 'METRICS_SEMICONDUCTORS'
  | 'METRICS_SOFTWARE_IT_SERVICES'
  | 'METRICS_SOLAR_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'METRICS_TELECOMMUNICATION_SERVICES'
  | 'METRICS_TOBACCO'
  | 'METRICS_TOYS_SPORTING_GOODS'
  | 'METRICS_WASTE_MANAGEMENT'
  | 'METRICS_WATER_UTILITIES_SERVICES'
  | 'METRICS_WIND_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'NETWORK_RESILIENCY_IMPACTS_OF_CLIMATE_CHANGE'
  | 'NUCLEAR_SAFETY_EMERGENCY_MANAGEMENT'
  | 'NUTRITIONAL_CONTENT'
  | 'OPERATION'
  | 'OPERATIONAL_SAFETY_EMERGENCY_PREPAREDNESS_RESPONSE'
  | 'PACKAGING_LIFECYCLE_MANAGEMENT'
  | 'PATIENT_HEALTH_OUTCOMES'
  | 'PATIENT_PRIVACY_ELECTRONIC_HEALTH_RECORDS'
  | 'PERFORMANCE_EVALUATION'
  | 'PHYSICAL_RISK_EXPOSURE'
  | 'PLANNING'
  | 'PLAN_PERFORMANCE'
  | 'POLICIES_DESIGNED_TO_INCENTIVISE_RESPONSIBLE_BEHAVIOUR'
  | 'PRICING_BILLING_TRANSPARENCY'
  | 'PRICING_INTEGRITY_TRANSPARENCY'
  | 'PRODUCT_DESIGN_FOR_USE_PHASE_EFFICIENCY'
  | 'PRODUCT_DESIGN_LIFECYCLE_MANAGEMENT'
  | 'PRODUCT_EFFICIENCY'
  | 'PRODUCT_END_OF_LIFE_MANAGEMENT'
  | 'PRODUCT_ENVIRONMENTAL_HEALTH_AND_SAFETY_PERFORMANCE'
  | 'PRODUCT_HEALTH_NUTRITION'
  | 'PRODUCT_INNOVATION'
  | 'PRODUCT_LABELLING_MARKETING'
  | 'PRODUCT_LIFECYCLE_ENVIRONMENTAL_IMPACTS'
  | 'PRODUCT_LIFECYCLE_MANAGEMENT'
  | 'PRODUCT_PACKAGING_DISTRIBUTION'
  | 'PRODUCT_SAFETY'
  | 'PRODUCT_SECURITY'
  | 'PRODUCT_SOURCING_PACKAGING_MARKETING'
  | 'PRODUCT_SPECIFICATIONS_CLEAN_FUEL_BLENDS'
  | 'PROFESSIONAL_INTEGRITY'
  | 'PROMOTING_TRANSPARENT_EFFICIENT_CAPITAL_MARKETS'
  | 'PUBLIC_HEALTH'
  | 'QUALITY_OF_CARE_PATIENT_SATISFACTION'
  | 'QUALITY_OF_EDUCATION_GAINFUL_EMPLOYMENT'
  | 'RAW_MATERIALS_SOURCING'
  | 'RECRUITING_MANAGING_A_GLOBAL_DIVERSE_SKILLED_WORKFORCE'
  | 'RECRUITING_MANAGING_A_GLOBAL_SKILLED_WORKFORCE'
  | 'RECYCLING_RESOURCE_RECOVERY'
  | 'REMANUFACTURING_DESIGN_SERVICES'
  | 'REPORTING_PREPARATION'
  | 'RESERVES_VALUATION_CAPITAL_EXPENDITURES'
  | 'RESILIENCE'
  | 'RESPONSIBLE_DRINKING_MARKETING'
  | 'RIGHTS_OF_INDIGENOUS_PEOPLES'
  | 'RISK_MANAGEMENT'
  | 'S1_1'
  | 'S1_2'
  | 'S1_3'
  | 'S1_4'
  | 'S1_5'
  | 'S1_6'
  | 'S1_7'
  | 'S1_8'
  | 'S1_9'
  | 'S1_10'
  | 'S1_11'
  | 'S1_12'
  | 'S1_13'
  | 'S1_14'
  | 'S1_15'
  | 'S1_16'
  | 'S1_17'
  | 'S1_SBM_3'
  | 'S2_1'
  | 'S2_2'
  | 'S2_3'
  | 'S2_4'
  | 'S2_5'
  | 'S2_SBM_3'
  | 'S3_1'
  | 'S3_2'
  | 'S3_3'
  | 'S3_4'
  | 'S3_5'
  | 'S3_SBM_3'
  | 'S4_1'
  | 'S4_2'
  | 'S4_3'
  | 'S4_4'
  | 'S4_5'
  | 'S4_SBM_3'
  | 'SAFETY_ENVIRONMENTAL_STEWARDSHIP_OF_CHEMICALS'
  | 'SAFETY_OF_CLINICAL_TRIAL_PARTICIPANTS'
  | 'SBM_1'
  | 'SBM_2'
  | 'SBM_3'
  | 'SECURITY_HUMAN_RIGHTS_RIGHTS_OF_INDIGENOUS_PEOPLES'
  | 'SELLING_PRACTICES'
  | 'SETTING_OBJECTIVES'
  | 'SOURCING_ENVIRONMENTAL_IMPACTS_OF_FEEDSTOCK_PRODUCTION'
  | 'STATEMENT_OF_COMPLIANCE'
  | 'STRATEGY'
  | 'STRATEGY_AND_DECISION_MAKING'
  | 'STRUCTURAL_INTEGRITY_SAFETY'
  | 'SUPPLY_CHAIN_MANAGEMENT'
  | 'SUPPLY_CHAIN_MANAGEMENT_FOOD_SOURCING'
  | 'SUPPORT'
  | 'SUSTAINABILITY_RELATED_RISKS_AND_OPPORTUNITIES'
  | 'SUSTAINABILITY_SERVICES'
  | 'SYSTEMIC_RISK_MANAGEMENT'
  | 'TAILINGS_STORAGE_FACILITIES_MANAGEMENT'
  | 'TIMING_OF_REPORTING'
  | 'TRANSPARENT_INFORMATION_FAIR_ADVICE_FOR_CUSTOMERS'
  | 'TRANSPARENT_INFORMATION_MANAGEMENT_OF_CONFLICT_OF_INTEREST'
  | 'UNDERSTANDING_RISKS'
  | 'WASTE_HAZARDOUS_MATERIALS_MANAGEMENT'
  | 'WASTE_MANAGEMENT'
  | 'WATER_AFFORDABILITY_ACCESS'
  | 'WATER_MANAGEMENT'
  | 'WATER_MANAGEMENT_IN_MANUFACTURING'
  | 'WATER_MANAGEMENT_SERVICES'
  | 'WATER_SUPPLY_RESILIENCE'
  | 'WOOD_SUPPLY_CHAIN_MANAGEMENT'
  | 'WORKFORCE_CONDITIONS_HEALTH_SAFETY'
  | 'WORKFORCE_DIVERSITY_ENGAGEMENT'
  | 'WORKFORCE_DIVERSITY_INCLUSION'
  | 'WORKFORCE_HEALTH_SAFETY';

/** User status */
export type Tasks_User_Status =
  | 'ACTIVE'
  | 'INACTIVE';

/** Task assignment mode */
export type Task_Assignment_Mode =
  | 'ALL'
  | 'ASSIGNED_BY_ME'
  | 'ASSIGNED_TO_ME';

/** Task comment type */
export type Task_Comment_Type =
  | 'COMMENT'
  | 'STATUS_CHANGE';

/** Task status */
export type Task_Status =
  | 'CLOSED'
  | 'IN_PROGRESS'
  | 'OPEN';

/** Task type */
export type Task_Type =
  | 'DISCLOSURE'
  | 'FRAMEWORK'
  | 'METRIC'
  | 'PROFILE'
  | 'SURVEY';

/** Represents the status of the taxonomy report */
export type Taxonomy_Report_Status =
  /** PDF report is being parsed */
  | 'PARSING'
  | 'PENDING'
  /** Tagging is done, report is ready */
  | 'READY'
  /** PDF content is being tagged by AI */
  | 'TAGGING';

/** Enumeration of template application types. Describes if template applies to Surveys, Disclosures or both. */
export type Template_Scope =
  | 'DISCLOSURE'
  | 'SURVEY'
  | 'UNIVERSAL';

/** Status of a verified tenant domain. Only VERIFIED domains are ever eligible to match a lookup. */
export type Tenant_Domain_Status =
  | 'PENDING'
  | 'REVOKED'
  | 'VERIFIED';

/** How a tenant domain was verified. Only STAFF is implemented in v1. */
export type Tenant_Domain_Verification_Method =
  | 'DNS_TXT'
  | 'SIGNUP'
  | 'STAFF';

/**
 * Represents the status of a tenant.
 * When tenant is in state AWAIT_ACTIVATION then the status should not be changed.
 * In this case one of the following is applicable:
 * - the user can activate tenant
 * - speeki admin can activate tenant
 * - tenant can be deleted.
 */
export type Tenant_Status =
  | 'ACTIVE'
  | 'AWAIT_ACTIVATION'
  | 'INACTIVE';

/** Time Interval */
export type Time_Interval =
  | 'DAY'
  | 'MONTH'
  | 'QUARTER'
  | 'YEAR';

/** Represents enumeration of time zones. */
export type Time_Zone =
  | 'UTC'
  | 'UTC0100'
  | 'UTC0100z'
  | 'UTC0200'
  | 'UTC0200z'
  | 'UTC0300'
  | 'UTC0330'
  | 'UTC0400'
  | 'UTC0430'
  | 'UTC0500'
  | 'UTC0530'
  | 'UTC0545'
  | 'UTC0600'
  | 'UTC0630'
  | 'UTC0700'
  | 'UTC0800'
  | 'UTC0845'
  | 'UTC0900'
  | 'UTC0930'
  | 'UTC0930z'
  | 'UTC1000'
  | 'UTC1000z'
  | 'UTC1030'
  | 'UTC1100'
  | 'UTC1130'
  | 'UTC1200'
  | 'UTC1200z'
  | 'UTC1245'
  | 'UTC1300'
  | 'UTC1400'
  | 'UTC_0100'
  | 'UTC_0100z'
  | 'UTC_0200'
  | 'UTC_0300'
  | 'UTC_0300z'
  | 'UTC_0330'
  | 'UTC_0400'
  | 'UTC_0400z'
  | 'UTC_0430'
  | 'UTC_0500'
  | 'UTC_0500z'
  | 'UTC_0600'
  | 'UTC_0600z'
  | 'UTC_0700'
  | 'UTC_0700z'
  | 'UTC_0800'
  | 'UTC_0800z'
  | 'UTC_0900'
  | 'UTC_0900z'
  | 'UTC_0930'
  | 'UTC_1000'
  | 'UTC_1000z'
  | 'UTC_1100'
  | 'UTC_1200'
  | 'UTCa'
  | 'UTCz';

export type Tag = {
  color: Scalars['HexColorCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** A user who created the tags. Speeki admin only */
  createdBy?: Maybe<UserType>;
  /** Tag description for current tenant */
  description?: Maybe<Scalars['String']['output']>;
  /** A group tag that the tag belongs to. */
  groupTag: GroupTag;
  /** Flag indicating public tag. */
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Group tag tenant. */
  tenant?: Maybe<TenantBaseDataType>;
  updatedAt: Scalars['DateTime']['output'];
  /** A user who last updated the tag. Speeki admin only */
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['ID']['output'];
};

export type TagBatchUpsertInput = {
  /** Tag description. Only for tenants. 1000 characters max. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tag name. Max length 80. */
  name: Scalars['String']['input'];
  /** UUID of edited tag. Omit to create new. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents pagination connection of tags. */
export type TagConnection = {
  /** Array of edges. */
  edges: Array<TagEdge>;
  /** Array of direct nodes. */
  nodes: Array<Tag>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of tags. */
export type TagConnectionInput = {
  /** Narrows tags to custom ones only. */
  customTagsOnly?: Scalars['Boolean']['input'];
  /** Tag UUIDs to exclude. */
  excludeUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of group tags names to limit search. Provide empty for all group tags. */
  groupTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional array of risk area uuids to limit search. Provide empty for all risk areas. */
  riskAreasUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional input for text search. Will limit search by risk area name, group tag name, tag name and description contents. */
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Array<Tag_Search_Scope>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<Tag_SortSortInput>>;
  /** Narrows tags to standard ones only. */
  standardTagsOnly?: Scalars['Boolean']['input'];
  /** Optional array of tags names to limit search. Provide empty for all tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for deleting a group tag */
export type TagDeleteInput = {
  /** Tags UUIDs to delete. */
  uuidsToDelete: Array<Scalars['UUID']['input']>;
};

/** Input for tag description update. */
export type TagDescriptionUpdateInput = {
  /** Tag description. 300 characters max. */
  description: Scalars['String']['input'];
  /** Tag UUID. */
  uuid: Scalars['UUID']['input'];
};

/** Represents Tag connection edge. */
export type TagEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Tag record. */
  node: Tag;
};

export type TagForVersionCreateInput = {
  /** Tag description. Only for tenants. 1000 characters max. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tag name. Max length 80. */
  name: Scalars['String']['input'];
};

export type TagUpdateInput = {
  /** Tag description. Only for tenants. 1000 characters max. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Tag name. Max length 80. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** UUID of edited tag. */
  uuid: Scalars['UUID']['input'];
};

export type TagUpsertInput = {
  /** Tag description. Only for tenants. 1000 characters max. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** UUID of related group tag. */
  groupTagUuid: Scalars['UUID']['input'];
  /** Tag name. Max length 80. */
  name: Scalars['String']['input'];
  /** UUID of edited tag. Omit to create new. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type TagsNameSearchInput = {
  /** Array of group tag names, that should scope results. */
  groupTagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tag name search. */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Array of risk area uuids that should scope results. */
  riskAreasUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents pagination connection of tags and group tags. */
export type TagsSelectConnection = {
  /** Array of edges. */
  edges: Array<EsgTagEdge>;
  /** Array of direct nodes. */
  nodes: Array<Tag>;
  /** Paging information. */
  pageInfo: PageInfoV2;
};

/** Input type for group tags connection. */
export type TagsSelectConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Search query to filter tags and group tags by name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TagsUpsertInput = {
  /** UUID of related group tag. */
  groupTagUuid: Scalars['UUID']['input'];
  tagUpsertInput: Array<TagBatchUpsertInput>;
};

export type Target = {
  /** baseYear of the target */
  baseYear: Scalars['Int']['output'];
  /** Resolves owner of the target */
  createdBy?: Maybe<UserType>;
  /** description of the target */
  description: Scalars['String']['output'];
  /** direction of the target */
  direction: Target_Direction;
  /** Resolves target goals */
  goals?: Maybe<Array<TargetGoals>>;
  /** Resolves owner of the target */
  lastUpdatedBy?: Maybe<UserType>;
  /** Resolves parent metric of field */
  metric: Metric;
  /** name of the target */
  name: Scalars['String']['output'];
  /** point type of target */
  points: Target_Point;
  /** Resolves target data per year */
  targetData?: Maybe<Array<TargetData>>;
  /** end year of the target */
  targetYear: Scalars['Int']['output'];
  /** Address of the target cell */
  trackedCellAddress?: Maybe<Scalars['String']['output']>;
  /**
   * id of row for tracked data of the target (ie. Scope1)
   * @deprecated This field has been deprecated and is not used with Syncfusion metrics schema
   */
  trackedDataRowId?: Maybe<Scalars['String']['output']>;
  /**
   * id of subrow for tracked data of the target (ie. Methane)
   * @deprecated This field has been deprecated and is not used with Syncfusion metrics schema
   */
  trackedDataSubRowId?: Maybe<Scalars['String']['output']>;
  /** Target unit */
  unit?: Maybe<Scalars['String']['output']>;
  /** UUID of the target */
  uuid: Scalars['UUID']['output'];
};

/** Represents input for batch deleting Target by uuids. */
export type TargetBatchDeleteInput = {
  uuids: Array<Scalars['UUID']['input']>;
};

/** Represents input for getting Target by uuid. */
export type TargetByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents TargetConnection connection. */
export type TargetConnection = {
  /** Array of edges. */
  edges: Array<TargetEdge>;
  /** Array of direct nodes. */
  nodes: Array<Target>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of Targets. */
export type TargetConnectionInput = {
  /** uuid of the metric */
  metricUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** filter by name or description (for search) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TargetSortInput>>;
};

export type TargetData = {
  /** current target goal value per target year */
  currentValue: Scalars['Float']['output'];
  /** is current goal base year of the target */
  isBaseYear: Scalars['Boolean']['output'];
  /** target predicted value per target year */
  predictedValue: Scalars['Float']['output'];
  /** target goal value per target year */
  targetValue: Scalars['Float']['output'];
  /** current target goal unit per target year */
  unit?: Maybe<Scalars['String']['output']>;
  /** year of the target goal */
  year: Scalars['Int']['output'];
};

/** Represents input for deleting Target by uuid. */
export type TargetDeleteInput = {
  uuid: Scalars['UUID']['input'];
};

/** Represents Target connection edge. */
export type TargetEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Target record. */
  node: Target;
};

export type TargetGoals = {
  /** UUID of the target goal */
  uuid: Scalars['UUID']['output'];
  /** value of the target goal */
  value: Scalars['Float']['output'];
  /** year of the target goal */
  year: Scalars['Int']['output'];
};

/** The company a Beacon engagement audits. Recorded on the agreement; never a price input. */
export type TargetIdentityInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Contains data about target risk area */
export type TargetRiskArea = {
  /** Custom label for the target risk area */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Name of the target risk area */
  name: Scalars['String']['output'];
  /** UUID of the target risk area */
  uuid: Scalars['UUID']['output'];
};

export type TargetSortFields =
  | 'BASE_YEAR'
  | 'DESCRIPTION'
  | 'NAME'
  | 'TARGET_YEAR';

export type TargetSortInput = {
  direction: SortDirection;
  field: TargetSortFields;
};

export type Task = {
  /** Returns user who created the task. */
  assignee?: Maybe<UserType>;
  /** Returns user who assigned the task. */
  assignor?: Maybe<UserType>;
  /** Returns comments of the tasks. */
  comments?: Maybe<Array<TaskComment>>;
  /** Date when the task was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the task */
  description?: Maybe<Scalars['String']['output']>;
  /** Date when the task is due */
  dueDate: Scalars['DateTime']['output'];
  /** Date when the task will expire */
  expiryDate: Scalars['DateTime']['output'];
  /** 8 characters numeric string which identifies task */
  id: Scalars['String']['output'];
  /** Indicates if task was seen by any assignee */
  isNew: Scalars['Boolean']['output'];
  /** Date when the task was updated */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Resolves task profile metadata */
  metadata?: Maybe<TaskMetadata>;
  /** Risk area associated with the task. */
  riskArea?: Maybe<RiskArea>;
  /** Status of the task */
  status: Task_Status;
  /** Name of the task */
  title: Scalars['String']['output'];
  /** Type of the task */
  type: Task_Type;
  /** UUID of the task */
  uuid: Scalars['ID']['output'];
  year: Year;
};

/** Represents input for task getting task by id. */
export type TaskByUuidInput = {
  uuid: Scalars['UUID']['input'];
};

export type TaskComment = {
  /** Content of the task comment */
  content: Scalars['String']['output'];
  /** Date when the task comment was created */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the task comment */
  createdBy?: Maybe<UserType>;
  /** Date when the task comment was last updated */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Status of the task after the comment. Relevant only if task comment type is "STATUS_CHANGE" */
  newStatus?: Maybe<Task_Status>;
  /** Type of the task comment */
  type: Task_Comment_Type;
  /** UUID of the task comment */
  uuid: Scalars['ID']['output'];
};

/** Represents input for creating a new comment. */
export type TaskCommentUpsertInput = {
  /** Content of the comment. Required in create. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the parent Task. Required in create. */
  taskUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the comment. Required in update. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents pagination connection of tasks. */
export type TaskConnection = {
  /** Array of edges. */
  edges: Array<TaskEdge>;
  /** Array of direct nodes. */
  nodes: Array<Task>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Returns statistics of the tasks. */
  statistics?: Maybe<TaskStatistics>;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of tasks. */
export type TaskConnectionInput = {
  /** Narrows the result of pagination to given criteria. */
  filtering?: InputMaybe<TaskFilterInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Narrows the result of pagination to given search criteria. */
  searching?: InputMaybe<TaskSearchInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaskSortInput>>;
};

/** Represents Task connection edge. */
export type TaskEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Task record. */
  node: Task;
};

/** Represents input for task pagination filter. */
export type TaskFilterInput = {
  /** Narrows the pagination result to the given assignees. */
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Narrows the pagination result to the given assignment mode. */
  assignmentMode?: InputMaybe<Task_Assignment_Mode>;
  /** Narrows the pagination result to the given assignors. */
  assignors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional input for 'max days offset' for due date filter in days. Rules: today + [maxDueDateOffset] >= due date. */
  maxDueDateOffset?: InputMaybe<Scalars['Float']['input']>;
  /** Optional input for 'min days offset' for due date filter in days. Rules: today + [minDueDateOffset] =< due date. Accepts negative integers. */
  minDueDateOffset?: InputMaybe<Scalars['Float']['input']>;
  /** Optional array of question uuids to scope results (framework requirements / programme questions). */
  questionUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array of risk area uuids to scope results. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Narrows the pagination result to the given statuses. */
  statuses?: InputMaybe<Array<Task_Status>>;
  /** Narrows the pagination result to the given task types. */
  taskTypes?: InputMaybe<Array<Task_Type>>;
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for marking task as seen. */
export type TaskMarkAsSeenInput = {
  uuid: Scalars['UUID']['input'];
};

export type TaskMetadata = {
  /** Task answer. */
  answer?: Maybe<EsgAnswer>;
  disabledReason?: Maybe<EsgTaskDisabledReason>;
  /** Task programme. */
  programme?: Maybe<Program>;
  /** Task question. */
  question?: Maybe<EsgQuestion>;
  /** Task risk area. */
  riskArea?: Maybe<RiskArea>;
  /** Task stage */
  stage?: Maybe<EsgStep>;
  /** Task standard. */
  standard?: Maybe<RiskArea>;
  /** Task version tag. */
  versionTag?: Maybe<Tag>;
};

export type TaskNameHint = {
  /** Name hint of the task */
  title: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Represents pagination connection of tasks. */
export type TaskNameHintConnection = {
  /** Array of edges. */
  edges: Array<TaskNameHintEdge>;
  /** Array of direct nodes. */
  nodes: Array<TaskNameHint>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of tasks. */
export type TaskNameHintConnectionInput = {
  /** Narrows the result of pagination to given criteria. */
  filtering?: InputMaybe<TaskNameHintFilterInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Narrows the result of pagination to given search criteria. */
  searching?: InputMaybe<TaskNameHintSearchInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaskNameHintSortInput>>;
};

/** Represents TaskNameHint connection edge. */
export type TaskNameHintEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TaskNameHint record. */
  node: TaskNameHint;
};

/** Represents task name hint input */
export type TaskNameHintFilterInput = {
  /** Narrows result to the given task types. */
  taskTypes?: InputMaybe<Array<Task_Type>>;
};

/** Represents input for task name hint search. */
export type TaskNameHintSearchInput = {
  /** Narrows the pagination search result to the given keywords. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

export type TaskNameHintSortFields =
  | 'ASSIGNEE_NAME'
  | 'ASSIGNOR_NAME'
  | 'DATE_CREATED'
  | 'DUE_DATE'
  | 'RISK_AREA'
  | 'STAGE'
  | 'STATUS'
  | 'TASK_ID'
  | 'TITLE'
  | 'TYPE';

export type TaskNameHintSortInput = {
  direction: SortDirection;
  field: TaskNameHintSortFields;
};

/** Represents input for task search. */
export type TaskSearchInput = {
  /** Narrows the pagination search result by assignee last name. */
  narrowByAssigneeLastName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by assignee name. */
  narrowByAssigneeName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by assignor last name. */
  narrowByAssignorLastName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by assignor name. */
  narrowByAssignorName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by task id. */
  narrowByTaskId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by task title. */
  narrowByTaskTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result to the given keywords. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

export type TaskSortFields =
  | 'ASSIGNEE_NAME'
  | 'ASSIGNOR_NAME'
  | 'DATE_CREATED'
  | 'DUE_DATE'
  | 'RISK_AREA'
  | 'STAGE'
  | 'STATUS'
  | 'TASK_ID'
  | 'TITLE'
  | 'TYPE';

export type TaskSortInput = {
  direction: SortDirection;
  field: TaskSortFields;
};

/** The summary of task funnel. */
export type TaskStatistics = {
  /** Count of completed tasks. */
  closedCount: Scalars['Int']['output'];
  /** Count of in progress tasks. */
  inProgressCount: Scalars['Int']['output'];
  /**
   * Total count of inprogress without overdue and upcoming tasks.
   * @deprecated Use use overdue and upcoming count.
   */
  inProgressWithoutUpcomingAndOverdueCount: Scalars['Int']['output'];
  /** Total count of new tasks. */
  newCount: Scalars['Int']['output'];
  /** Count of open tasks. */
  openedCount: Scalars['Int']['output'];
  /**
   * Total count of overdue and upcoming tasks.
   * @deprecated Use overdue and upcoming count.
   */
  overDueAndUpcomingCount: Scalars['Int']['output'];
  /** Count of overdue tasks. */
  overdueCount: Scalars['Int']['output'];
  /** Total count of tasks. */
  totalCount: Scalars['Int']['output'];
  /** Count of upcoming tasks. */
  upcomingCount: Scalars['Int']['output'];
};

/** Represents input for creating a new task or updating existing one. */
export type TaskUpsertInput = {
  answerUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Internal user assignee uuid. Required this or externalAssignee in create. */
  assigneeUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Description of the task. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Due date of the task. */
  dueDate: Scalars['DateTime']['input'];
  /** External user assignee email. Required this or assigneeUuid in create. */
  externalAssignee?: InputMaybe<Scalars['String']['input']>;
  /** Programme uuid for profile type tasks */
  programmeUuid?: InputMaybe<Scalars['UUID']['input']>;
  questionUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Risk area uuid for profile type tasks. Nullish implies unmapped. */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Step key. Required if questions from risk area are assigned. */
  stepKey?: InputMaybe<Tasks_Step_Key>;
  /** Title of the task. */
  title: Scalars['String']['input'];
  /** Type of the task. */
  type: Task_Type;
  /** UUID of the task. Required in update. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Version tag uuid for profile type tasks */
  versionTagUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of year associated with task */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents UserType connection edge. */
export type TasksUserTypeEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the UserType record. */
  node: UserType;
};

export type Taxonomy = {
  /** Name of the taxonomy */
  name: Scalars['String']['output'];
  /** Unique identifier for the taxonomy */
  uuid: Scalars['UUID']['output'];
  /** Version of the taxonomy */
  version: Scalars['String']['output'];
};

export type TaxonomyComplexUnit = {
  /** Denominator of the complex unit */
  denominator: Array<TaxonomySimpleUnit>;
  /** Label of the complex unit */
  label: Scalars['String']['output'];
  /** Numerator of the complex unit */
  numerator: Array<TaxonomySimpleUnit>;
};

/** Taxonomy concept */
export type TaxonomyConcept = {
  /** Get the dimension sets of a taxonomy concept */
  dimensionSets?: Maybe<Array<TaxonomyDimensionSet>>;
  /** Get the enumeration of a taxonomy concept */
  enumeration?: Maybe<TaxonomyEnumeration>;
  /** Get applicable formats of a taxonomy concept */
  formats?: Maybe<Array<TaxonomyFormat>>;
  /** Item type of the taxonomy concept */
  itemType: Scalars['String']['output'];
  /** Human-readable name of the taxonomy concept */
  label: Scalars['String']['output'];
  /** Qualified name of the taxonomy concept */
  name: Scalars['String']['output'];
  /** Period type of the taxonomy concept */
  periodType: Scalars['String']['output'];
  /** Hierarchy trees of the concept */
  trees: Array<Array<Scalars['String']['output']>>;
  /** Get the units that can be used with a taxonomy concept */
  units?: Maybe<Array<TaxonomyUnit>>;
  /** Unique identifier for the taxonomy concept */
  uuid: Scalars['UUID']['output'];
};

/** Paginated connection type for taxonomy concepts */
export type TaxonomyConceptConnection = {
  /** Array of edges. */
  edges: Array<TaxonomyConceptEdge>;
  /** Array of direct nodes. */
  nodes: Array<TaxonomyConcept>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for paginated connection of taxonomy concepts */
export type TaxonomyConceptConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Search taxonomy concepts by human-readable name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaxonomyConceptSortInput>>;
};

/** Represents TaxonomyConcept connection edge. */
export type TaxonomyConceptEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TaxonomyConcept record. */
  node: TaxonomyConcept;
};

/** Input type for taxonomy concept */
export type TaxonomyConceptInput = {
  /** Unique identifier for the taxonomy concept */
  uuid: Scalars['UUID']['input'];
};

export type TaxonomyConceptSortFields =
  | 'ITEM_TYPE'
  | 'LABEL'
  | 'NAME'
  | 'PERIOD_TYPE';

export type TaxonomyConceptSortInput = {
  direction: SortDirection;
  field: TaxonomyConceptSortFields;
};

/** Paginated connection type for taxonomies */
export type TaxonomyConnection = {
  /** Array of edges. */
  edges: Array<TaxonomyEdge>;
  /** Array of direct nodes. */
  nodes: Array<Taxonomy>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for paginated taxonomy connection */
export type TaxonomyConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaxonomySortInput>>;
};

export type TaxonomyDimension = TaxonomyExplicitDimension | TaxonomyTypedDimension;

export type TaxonomyDimensionSet = {
  /** Definition of the taxonomy dimension set */
  definition: Scalars['String']['output'];
  /** Dimensions included in the taxonomy dimension set */
  dimensions: Array<TaxonomyDimension>;
  /** Human-readable label for the taxonomy dimension set */
  label: Scalars['String']['output'];
  /** Qualified name of the taxonomy dimension set */
  name: Scalars['String']['output'];
  /** Unique identifier for the taxonomy dimension set */
  uuid: Scalars['UUID']['output'];
};

export type TaxonomyDomain = {
  /** Indicates if this is the default dimension */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Human-readable label for the domain */
  label: Scalars['String']['output'];
  /** Members of the domain */
  members: Array<TaxonomyMember>;
  /** Qualified name of the domain */
  name: Scalars['String']['output'];
};

/** Represents Taxonomy connection edge. */
export type TaxonomyEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Taxonomy record. */
  node: Taxonomy;
};

export type TaxonomyEnumeration = {
  /** Human-readable name of the enumeration */
  label: Scalars['String']['output'];
  /** Qualified name of the enumeration */
  name: Scalars['String']['output'];
  /** Unique identifier for the enumeration */
  uuid: Scalars['UUID']['output'];
  /** List of values for the enumeration */
  values: Array<TaxonomyEnumerationValue>;
};

export type TaxonomyEnumerationValue = {
  /** Human-readable label of the enumeration value */
  label: Scalars['String']['output'];
  /** Qualified name of the enumeration value */
  name: Scalars['String']['output'];
  /** Value of the enumeration */
  value: Scalars['String']['output'];
};

export type TaxonomyExplicitDimension = {
  /** Domains of the dimension */
  domains: Array<TaxonomyDomain>;
  /** Human-readable label for the dimension */
  label: Scalars['String']['output'];
  /** Qualified name of the dimension */
  name: Scalars['String']['output'];
  /** Type of the dimension */
  type: Scalars['String']['output'];
};

export type TaxonomyFormat = {
  /** Human-readable label of the format */
  label: Scalars['String']['output'];
  /** Qualified name of the format */
  name: Scalars['String']['output'];
};

export type TaxonomyInput = {
  /** Unique identifier for the taxonomy */
  uuid: Scalars['UUID']['input'];
};

export type TaxonomyMember = {
  /** Human-readable label for the member */
  label: Scalars['String']['output'];
  /** Qualified name of the member */
  name: Scalars['String']['output'];
};

/** Taxonomy report object type */
export type TaxonomyReport = {
  /** Audit trail for the taxonomy report */
  audits: TaxonomyReportAuditConnection;
  /** Persons that collaborated in the report tagging */
  collaborators: Array<UserType>;
  /** Creation date of the taxonomy report */
  createdAt: Scalars['DateTime']['output'];
  /** Get the facts associated with a taxonomy report */
  facts: Array<TaxonomyReportFact>;
  /** File used to preare the taxonomy report */
  file: InsightsFile;
  /** Filing identifier associated with the taxonomy report */
  filingId: Scalars['String']['output'];
  /** Name of the taxonomy report */
  name: Scalars['String']['output'];
  /** Number of pages in the report */
  pagesCount: Scalars['Int']['output'];
  /** Person that created the report */
  preparer?: Maybe<UserType>;
  /** Tags usage statistics for the report */
  statistics: TaxonomyReportStatistics;
  /** Status of the taxonomy report */
  status: Taxonomy_Report_Status;
  /** Last update date of the taxonomy report */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the taxonomy report */
  uuid: Scalars['UUID']['output'];
};


/** Taxonomy report object type */
export type TaxonomyReportAuditsArgs = {
  input: TaxonomyReportAuditConnectionInput;
};


/** Taxonomy report object type */
export type TaxonomyReportFactsArgs = {
  input: TaxonomyReportFactsInput;
};

/** Audit trail entry for taxonomy report */
export type TaxonomyReportAudit = {
  /** Action performed on the report */
  action: TaxonomyReportAuditAction;
  /** Timestamp when the action was performed */
  changedAt: Scalars['DateTime']['output'];
  /** User who performed the action */
  changedBy?: Maybe<UserType>;
  /** Unique identifier for the audit entry */
  uuid: Scalars['UUID']['output'];
};

/** Action type for taxonomy report audit entries */
export type TaxonomyReportAuditAction =
  | 'FACT_CREATED'
  | 'FACT_DELETED'
  | 'FACT_UPDATED'
  | 'REPORT_CREATED'
  | 'REPORT_UPDATED';

/** Paginated connection of taxonomy report audit entries */
export type TaxonomyReportAuditConnection = {
  /** Array of edges. */
  edges: Array<TaxonomyReportAuditEdge>;
  /** Array of direct nodes. */
  nodes: Array<TaxonomyReportAudit>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for paginated connection of taxonomy report audit entries */
export type TaxonomyReportAuditConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaxonomyReportAuditSortInput>>;
};

/** Represents TaxonomyReportAudit connection edge. */
export type TaxonomyReportAuditEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TaxonomyReportAudit record. */
  node: TaxonomyReportAudit;
};

export type TaxonomyReportAuditSortFields =
  | 'ACTION'
  | 'CHANGED_AT';

export type TaxonomyReportAuditSortInput = {
  direction: SortDirection;
  field: TaxonomyReportAuditSortFields;
};

/** Paginated connection type for taxonomies */
export type TaxonomyReportConnection = {
  /** Array of edges. */
  edges: Array<TaxonomyReportEdge>;
  /** Array of direct nodes. */
  nodes: Array<TaxonomyReport>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for paginated connection of taxonomy reports */
export type TaxonomyReportConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Search taxonomy reports by name, preparer or collaborator names */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaxonomyReportSortInput>>;
};

/** Input type for creating taxonomy reports */
export type TaxonomyReportCreateInput = {
  /** File to be uploaded for the report */
  file: Scalars['Upload']['input'];
  /** Unique identifier for the taxonomy used in the report */
  taxonomyUuid: Scalars['UUID']['input'];
};

/** Represents TaxonomyReport connection edge. */
export type TaxonomyReportEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TaxonomyReport record. */
  node: TaxonomyReport;
};

export type TaxonomyReportFact = {
  /** Color associated with the taxonomy fact. */
  color: Scalars['HexColorCode']['output'];
  /** Concept associated with the taxonomy fact. */
  concept: TaxonomyConcept;
  /** Unique identifier of the concept this fact is about. */
  conceptUuid: Scalars['UUID']['output'];
  /** Unique identifier for the dimension set used for the fact. */
  dimensionSetUuid?: Maybe<Scalars['UUID']['output']>;
  /** Entity name associated with the taxonomy fact. */
  entityName: Scalars['String']['output'];
  /** Indicates if the taxonomy fact is hidden. */
  hidden: Scalars['Boolean']['output'];
  /** Number of decimal places for the item value. */
  itemDecimals?: Maybe<Scalars['Int']['output']>;
  /** Format of the item value. */
  itemFormat?: Maybe<Scalars['String']['output']>;
  /** Type of the item represented by the taxonomy fact. */
  itemType: Scalars['String']['output'];
  /** Unit of the item represented by the taxonomy fact. */
  itemUnit?: Maybe<Scalars['String']['output']>;
  /** Value of the item represented by the taxonomy fact. Can be a string, array of strings, number, or boolean. */
  itemValue?: Maybe<Scalars['TaxonomyReportFactValue']['output']>;
  /** List of lines this fact applies to, each with start and end positions. */
  lines: Array<TaxonomyReportFactLine>;
  /** Page number this fact applies to. */
  page: Scalars['Int']['output'];
  /** Duration of the period for the taxonomy fact, including start and end dates. */
  periodDuration?: Maybe<TaxonomyReportFactPeriodDuration>;
  /** Instant date for the period of the taxonomy fact. */
  periodInstant?: Maybe<Scalars['DateTime']['output']>;
  /** Type of the period for the taxonomy fact. */
  periodType: Scalars['String']['output'];
  /** Report associated with the taxonomy fact. */
  report: TaxonomyReport;
  /** Unique identifier of the report this fact belongs to. */
  reportUuid: Scalars['UUID']['output'];
  /** Dimensions associated with the taxonomy fact. */
  scenarios?: Maybe<Array<TaxonomyReportFactScenario>>;
  /** Unique identifier for the taxonomy fact. */
  uuid: Scalars['UUID']['output'];
};

/** Paginated connection of taxonomy report facts */
export type TaxonomyReportFactConnection = {
  /** Array of edges. */
  edges: Array<TaxonomyReportFactEdge>;
  /** Array of direct nodes. */
  nodes: Array<TaxonomyReportFact>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input type for paginated connection of taxonomy facts */
export type TaxonomyReportFactConnectionInput = {
  /** Filter facts by hidden status. If not provided, all facts will be returned. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Page number to filter facts by their page number. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Unique identifier of the taxonomy report to filter facts. */
  reportUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Search term to filter facts by their properties. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaxonomyReportFactSortInput>>;
};

/** Input for deleting a taxonomy report fact. */
export type TaxonomyReportFactDeleteInput = {
  /** Unique identifier of fact to be deleted. */
  uuid: Scalars['UUID']['input'];
};

/** Represents TaxonomyReportFact connection edge. */
export type TaxonomyReportFactEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TaxonomyReportFact record. */
  node: TaxonomyReportFact;
};

export type TaxonomyReportFactInput = {
  /** Unique identifier for the taxonomy fact. */
  uuid: Scalars['UUID']['input'];
};

export type TaxonomyReportFactLine = {
  /** The character offset at which this fact ends in the line. */
  end: Scalars['Int']['output'];
  /** Line number this fact applies to. */
  line: Scalars['Int']['output'];
  /** The character offset at which this fact starts in the line. */
  start: Scalars['Int']['output'];
};

export type TaxonomyReportFactLineInput = {
  /** The character offset at which this fact ends in the line. */
  end: Scalars['Int']['input'];
  /** Line number this fact applies to. */
  line: Scalars['Int']['input'];
  /** The character offset at which this fact starts in the line. */
  start: Scalars['Int']['input'];
};

export type TaxonomyReportFactPeriodDuration = {
  /** End date of the period. */
  end: Scalars['DateTime']['output'];
  /** Start date of the period. */
  start: Scalars['DateTime']['output'];
};

export type TaxonomyReportFactPeriodDurationInput = {
  /** End date of the period. */
  end: Scalars['DateTime']['input'];
  /** Start date of the period. */
  start: Scalars['DateTime']['input'];
};

export type TaxonomyReportFactScenario = {
  /** Qualified name of the dimension. */
  dimension: Scalars['String']['output'];
  /** Qualified name of the member for explicit dimensions or arbitrary value for typed dimensions. */
  member: Scalars['String']['output'];
};

export type TaxonomyReportFactScenarioInput = {
  /** Qualified name of the dimension. */
  dimension: Scalars['String']['input'];
  /** Qualified name of the member for explicit dimensions or arbitrary value for typed dimensions. */
  member: Scalars['String']['input'];
};

export type TaxonomyReportFactSortFields =
  | 'CONCEPT_LABEL'
  | 'CONCEPT_NAME'
  | 'CREATED_AT'
  | 'ITEM_TYPE'
  | 'ITEM_VALUE'
  | 'PERIOD_TYPE'
  | 'UPDATED_AT';

export type TaxonomyReportFactSortInput = {
  direction: SortDirection;
  field: TaxonomyReportFactSortFields;
};

export type TaxonomyReportFactUpsertInput = {
  /** Color associated with the taxonomy fact. */
  color: Scalars['HexColorCode']['input'];
  /** Unique identifier of the concept this fact is about. */
  conceptUuid: Scalars['UUID']['input'];
  /** Unique identifier for the dimension set used for the fact. */
  dimensionSetUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Entity name associated with the taxonomy fact. */
  entityName: Scalars['String']['input'];
  /** Indicates if the fact is hidden and not associated with any lines. This flag will be automatically enforced as true for facts whose values cannot be derived from humand-readable report (e.g. enumerations), regardless of the value provided. */
  hidden?: Scalars['Boolean']['input'];
  /** Number of decimal places for the item value. */
  itemDecimals?: InputMaybe<Scalars['Int']['input']>;
  /** Format of the item represented by the taxonomy fact. */
  itemFormat?: InputMaybe<Scalars['String']['input']>;
  /** Unit of the item represented by the taxonomy fact. */
  itemUnit?: InputMaybe<Scalars['String']['input']>;
  /** Value of the item represented by the taxonomy fact. Can be a string, array of strings, number, or boolean. */
  itemValue: Scalars['TaxonomyReportFactValue']['input'];
  /** Array of lines this fact applies to, each with start and end positions. */
  lines?: Array<TaxonomyReportFactLineInput>;
  /** Page number this fact applies to. */
  page: Scalars['Int']['input'];
  /** Duration of the period for the taxonomy fact. */
  periodDuration?: InputMaybe<TaxonomyReportFactPeriodDurationInput>;
  /** Instant of the period for the taxonomy fact. */
  periodInstant?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique identifier of the report this fact belongs to. */
  reportUuid: Scalars['UUID']['input'];
  /** Dimensions associated with the taxonomy fact. */
  scenarios?: InputMaybe<Array<TaxonomyReportFactScenarioInput>>;
  /** Unique identifier of fact to be updated or empty for new fact. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for list of taxonomy facts */
export type TaxonomyReportFactsInput = {
  /** Filter facts by hidden status. If not provided, all facts will be returned. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Page number to filter facts by their page number. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search term to filter facts by their properties. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TaxonomyReportFactSortInput>>;
};

/** Input type for taxonomy report */
export type TaxonomyReportInput = {
  /** Unique identifier for the taxonomy report */
  uuid: Scalars['UUID']['input'];
};

/** Represents a page of taxonomy report */
export type TaxonomyReportPage = {
  /** HTML content of the taxonomy report page */
  html: Scalars['String']['output'];
  /** Page number in the taxonomy report */
  page: Scalars['Int']['output'];
  /** The report this page belongs to */
  report: TaxonomyReport;
  /** Unique identifier for the taxonomy report this page belongs to */
  reportUuid: Scalars['UUID']['output'];
  /** Signed URL to page screenshot */
  screenshot: InsightsFile;
  /** Textual content of the taxonomy report page */
  text: Scalars['String']['output'];
  /** Unique identifier for the taxonomy report page */
  uuid: Scalars['UUID']['output'];
};

export type TaxonomyReportPageInput = {
  /** Page number starting from 1 */
  page: Scalars['Int']['input'];
  /** UUID of the taxonomy report */
  reportUuid: Scalars['UUID']['input'];
};

/** Input for searching taxonomy report pages */
export type TaxonomyReportPagesInput = {
  /** Unique identifier of the taxonomy report */
  reportUuid: Scalars['UUID']['input'];
  /** Search phrase to filter report pages */
  search: Scalars['String']['input'];
};

export type TaxonomyReportSortFields =
  | 'CREATED_AT'
  | 'CREATED_BY'
  | 'NAME'
  | 'STATUS'
  | 'UPDATED_AT';

export type TaxonomyReportSortInput = {
  direction: SortDirection;
  field: TaxonomyReportSortFields;
};

/** Tags usage statistics for taxonomy report */
export type TaxonomyReportStatistics = {
  /** Total number of hidden tags used in the taxonomy report */
  hiddenCount: Scalars['Int']['output'];
  /** Total number of missing tags in the taxonomy report */
  missingCount: Scalars['Int']['output'];
  /** Total number of visible tags in the taxonomy report */
  visibleCount: Scalars['Int']['output'];
};

export type TaxonomySimpleUnit = {
  /** Label of the simple unit */
  label: Scalars['String']['output'];
  /** Measure of the simple unit */
  measure: Scalars['String']['output'];
};

export type TaxonomySortFields =
  | 'NAME'
  | 'VERSION';

export type TaxonomySortInput = {
  direction: SortDirection;
  field: TaxonomySortFields;
};

export type TaxonomyTypedDimension = {
  /** Typed domain of the dimension */
  domain: Scalars['String']['output'];
  /** Human-readable label for the dimension */
  label: Scalars['String']['output'];
  /** Qualified name of the dimension */
  name: Scalars['String']['output'];
  /** Type of the dimension */
  type: Scalars['String']['output'];
};

export type TaxonomyUnit = TaxonomyComplexUnit | TaxonomySimpleUnit;

/** Represents the template object. */
export type Template = {
  /** Template creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** Resolves template author. Returns null for standard template and empty author. */
  createdBy?: Maybe<UserType>;
  /**
   * Template creator name (tenants see the creator of the standard template as the Speeki trademark).
   * @deprecated Use createdBy.
   */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** States if template is public or private for tenant templates. In the case of a standard template, the falsy `isPublic` flag means the template is a draft. */
  isPublic: Scalars['Boolean']['output'];
  /** Survey questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['output'];
  /** Last update of the template data. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Template unique name. */
  name: Scalars['String']['output'];
  /** Returns risk area. */
  riskAreas?: Maybe<Array<RiskArea>>;
  /** Indicates template scope, universal or specific for some context. */
  scope: Template_Scope;
  type: SurveyTemplateType;
  /** Template unique identifier. */
  uuid: Scalars['ID']['output'];
};

/** Represents TemplateConnection connection. */
export type TemplateConnection = {
  /** Array of edges. */
  edges: Array<TemplateEdge>;
  /** Array of direct nodes. */
  nodes: Array<Template>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for template list */
export type TemplateConnectionInput = {
  /** Text to filter results matching template `name`, `creatorName`. */
  freeTextQuery?: InputMaybe<Scalars['String']['input']>;
  /** Flag to filter only draft or only public template results. Used only with Speeki admin context user for standard templates. When no value is provided all standard templates will be returned. */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Uuid of risk area to return only templates assigned to given risk area. When no value is provided all standard templates will be returned. */
  riskAreaUuid?: InputMaybe<Scalars['String']['input']>;
  /** Enum to filter templates by its use type */
  scope?: InputMaybe<Array<Template_Scope>>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<TemplateSortInput>>;
};

/** Represents Template connection edge. */
export type TemplateEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Template record. */
  node: Template;
};

/** Represents the template risk areas upsert input type. */
export type TemplateRiskAreasUpsertInput = {
  /** array of risk area uuids */
  riskAreaUuids: Array<Scalars['UUID']['input']>;
  /** template uuid. */
  uuid: Scalars['UUID']['input'];
};

export type TemplateSortFields =
  | 'CREATED_AT'
  | 'CREATED_BY_NAME'
  | 'IS_PUBLIC'
  | 'LAST_UPDATED_AT'
  | 'NAME';

export type TemplateSortInput = {
  direction: SortDirection;
  field: TemplateSortFields;
};

/** Represents the template type object. */
export type TemplateType = {
  /** States if the context user is an owner of this template. */
  isOwner: Scalars['Boolean']['output'];
  /** States if this is the standard template (from Speeki admin portal). */
  isStandardTemplate: Scalars['Boolean']['output'];
  /** Template type enumeration label. */
  label: TemplateTypeLabel;
};

/** Enumeration of template types (fallbacks to `MY_TEMPLATE` value when context user is the owner). */
export type TemplateTypeLabel =
  | 'MY_TEMPLATE'
  | 'STANDARD_TEMPLATE'
  | 'TENANT_TEMPLATE';

/** Represents the input type required for template edition or creation. */
export type TemplateUpsertInput = {
  /** Files related to template questions */
  files?: InputMaybe<Array<NamedUpload>>;
  /** Edited or new public or private template state (public or draft for standard template). */
  isPublic: Scalars['Boolean']['input'];
  /** Edited or new template questionnaire JSON value from SurveyJS. Should not be edited externally, will not be validated. */
  json: Scalars['JSON']['input'];
  /** Edited or new template name. */
  name: Scalars['String']['input'];
  /** Scope for template (where it can be used later) */
  scope?: Template_Scope;
  /** Edited template unique identifier. */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

/** The result of a checkout buyer asking to join an organisation that already uses Speeki. */
export type TenantAccessRequestResult = {
  /** The created request's uuid. */
  requestUuid: Scalars['ID']['output'];
  /** PENDING | APPROVED | DECLINED | CANCELLED. */
  status: Scalars['String']['output'];
};

/** Represents pagination input for connection of tenant admins. */
export type TenantAdminConnectionInput = {
  /** Allows to narrow users connection to list of users possible to be disabled. */
  disableableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allows to exclude users with given roles from connection. */
  excludeByRole?: InputMaybe<Array<User_Role>>;
  /** Allows to exclude users with given uuids from connection. */
  excludeByUuid?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Represents optional text filter to limit the results. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Allows to narrow users connection to headquarters. */
  headquartersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allows to exclude users with given statuses. */
  invitationFilter?: InputMaybe<Array<User_Invitation_Status>>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<UserTypeSortInput>>;
  /** Allows to filter users with matching statuses. */
  statusFilter?: InputMaybe<Array<TenantsUserStatus>>;
  /** Allows to narrow users connection to given subsidiary site. */
  subsidiaryUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for sending invitation email of tenant admin */
export type TenantAdminInvitationEmailInput = {
  /** Email of invited tenant admin */
  email: Scalars['String']['input'];
  /** Uuid of current tenant */
  tenantUuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for setting password for invited tenant admin */
export type TenantAdminInviteFinishInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Input for inviting new tenants admins  */
export type TenantAdminInviteInput = {
  /** New admin billing role */
  billingRole?: InputMaybe<Scalars['Boolean']['input']>;
  /** New admin business unit name. Optional - tenants without the Incidents module do not use business units. */
  businessUnitName?: InputMaybe<Scalars['String']['input']>;
  /** New admin country */
  country: Country_Code;
  /** New admin email */
  email: Scalars['String']['input'];
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * New admin name
   * @deprecated use firstName & lastName fields
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Admin's subordinate regions uuids. Respected only for REGIONAL_USER role. */
  regionUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * New admin role
   * @deprecated Use roleUuid with id of new role with permissions
   */
  role?: InputMaybe<User_Role>;
  /** Uuid of role */
  roleUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional, for tenants with subsidiary sites enabled. Leave empty for headquarters. */
  subsidiaryUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Invite a person by email and seat them in one framework. Business unit, country and role are resolved from the tenant unless given. */
export type TenantAdminInviteWithFrameworkSeatInput = {
  /** Only needed when the tenant has more than one active business unit; with exactly one, it is used automatically. */
  businessUnitName?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to the inviting admin's own country. */
  country?: InputMaybe<Country_Code>;
  /** The invitee's email address. */
  email: Scalars['String']['input'];
  /** The invitee's first name. */
  firstName: Scalars['String']['input'];
  /** The invitee's last name. */
  lastName: Scalars['String']['input'];
  /** The framework (risk area) to seat them in. Its seat pool is checked BEFORE the user is created, so a full pool rejects the whole request rather than leaving an invited user with nowhere to sit. */
  riskAreaUuid: Scalars['UUID']['input'];
  /** Defaults to the tenant's framework-only role - the one carrying no permissions, which grants platform access and nothing beyond the framework being seated. Only needed if the tenant has several. */
  roleUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input to change tenant admin's regions. Respected only for `REGIONAL_USER` role. */
export type TenantAdminRegionsChangeInput = {
  /** The unique identifier of the region. */
  regionUuids: Array<Scalars['String']['input']>;
  /** The unique identifier of the user.  */
  userUuid: Scalars['String']['input'];
};

/** Represents input to delete user roles. */
export type TenantAdminRoleRemoveInput = {
  /** Boolean flag indicating if role in headquarter should be remove. */
  removeHqRole?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of roles in subsidiary sites to remove. */
  subsidiaryUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents input to update user roles. */
export type TenantAdminRoleUpdateInput = {
  /** Uuid of role */
  roleUuid?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Array of user UUIDs who's roles should be deleted.
   * @deprecated Not suitable with new permissions, use roleUuid
   */
  rolesToDelete?: InputMaybe<TenantAdminRoleRemoveInput>;
  /**
   * Array of roles to be upserted.
   * @deprecated Not suitable with new permissions, use roleUuid
   */
  rolesToUpsert?: InputMaybe<Array<TenantAdminRolesUpsertInput>>;
  /** Edited user's UUID. */
  userUuid: Scalars['String']['input'];
};

/** Represents input to upsert user roles. */
export type TenantAdminRolesUpsertInput = {
  /** Role to be set in given subsidiary or headquarters. */
  role: User_Role;
  /** UUID of subsidiary. Leave null for editing roles in headquarters. */
  subsidiaryUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input to update tenant admin status. */
export type TenantAdminStatusUpdateInput = {
  status: TenantsUserStatus;
  userUuid: Scalars['String']['input'];
};

/** Represents input to update user details. */
export type TenantAdminUpdateInput = {
  /** Edited user business unit UUID. Optional - omitted or null, the business unit stays unchanged; tenants without the Incidents module do not use business units. */
  businessUnitUuid?: InputMaybe<Scalars['String']['input']>;
  /** Edited user country. */
  country: Country_Code;
  /** Edited user email. */
  email: Scalars['EmailAddress']['input'];
  /** Edited user first name. */
  firstName: Scalars['String']['input'];
  /** Edited user last name. */
  lastName: Scalars['String']['input'];
  /** Uuid of role to assign to user. */
  roleUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Edited user UUID. */
  uuid: Scalars['String']['input'];
};

/** Represents input to update tenant admins' statuses. */
export type TenantAdminsStatusesUpdateInput = {
  users: Array<TenantAdminStatusUpdateInput>;
};

/** One-off: turns auto renewal off for terms born from an audit. The tenant uuids come from the shop's audit-anchored export. */
export type TenantAuditRenewalBackfillInput = {
  /** When true (the default) nothing is changed; the result lists what an apply would change. */
  dryRun?: Scalars['Boolean']['input'];
  tenantUuids: Array<Scalars['ID']['input']>;
};

export type TenantBaseDataType = {
  /** Return tenant's active year. */
  activeYear?: Maybe<Year>;
  /** Resolves tenant asset settings. */
  assetSettings: AssetSettings;
  /** Case owner exclusions depending on business unit and specified investigation entity. Omit input when you wish to fetch case owner exclusion directly for the headquarters. Returns `NULL` when case owner exclusion feature is disabled. */
  caseOwnerExclusion?: Maybe<CaseOwnerExclusion>;
  code: Scalars['String']['output'];
  /** The custom default version label. */
  defaultAnswerVersionLabel?: Maybe<Scalars['String']['output']>;
  /** Accessible only for TENANT_ADMIN. */
  elineNumbers: Array<ElinePhoneNumber>;
  enforceMfa: Scalars['Boolean']['output'];
  features?: Maybe<Array<Feature>>;
  forwardEarthUrl?: Maybe<Scalars['String']['output']>;
  /** The frameworks this tenant holds (frameworkCategory not null). Tenant-scoped and seat-agnostic - unlike `standards`, which returns the whole catalogue. */
  frameworks?: Maybe<Array<RiskArea>>;
  /** Returns paginated connection of tenant's group tags. */
  groupTags?: Maybe<GroupTagConnection>;
  /**
   * Check if IFRS standard has any industry enabled.
   * @deprecated Use field "hasSomeIndustryEnabled " resolved on RiskArea type.
   */
  hasSomeIndustryEnabled: Scalars['Boolean']['output'];
  /** Returns tenant headline. If headline is empty then default headline is returned */
  headline?: Maybe<Scalars['HTML']['output']>;
  /** Translated headline content */
  headlineTranslated?: Maybe<Scalars['HTML']['output']>;
  homeContent: Scalars['HTML']['output'];
  /** Translated home content */
  homeContentTranslated: Scalars['HTML']['output'];
  /** @deprecated Use `homeContent`. */
  htmlBanner: Scalars['String']['output'];
  /** Incident types of tenant. */
  incidentTypes: Array<IncidentType>;
  /** List all enabled units for tenant. */
  industryUnits: Array<Unit>;
  lastRenewalRequestSentAt?: Maybe<Scalars['DateTime']['output']>;
  license?: Maybe<License>;
  logo?: Maybe<Scalars['String']['output']>;
  /** Returns modules enabled for given tenant */
  modules: TenantModuleSettings;
  name: Scalars['String']['output'];
  policiesContent?: Maybe<Scalars['HTML']['output']>;
  /** Translated policies Content */
  policiesContentTranslated: Scalars['HTML']['output'];
  /** Returns the unique region and country mapping. */
  region: Region;
  /** Returns the paginated connection of region and country mappings. */
  regions: RegionConnection;
  /** Resolves report settings. */
  reportSettings?: Maybe<ReportSettings>;
  /** Returns unique reporting group. */
  reportingGroup: ReportingGroup;
  /** Returns paginated connection of reporting groups. */
  reportingGroups: ReportingGroupConnection;
  /** Return tenant's reporting period */
  reportingPeriod?: Maybe<TenantReportingPeriod>;
  reportingSlug?: Maybe<Scalars['String']['output']>;
  reportingUrl: Scalars['String']['output'];
  /** List of Sso providers that are available for a tenant */
  ssoProviders: Array<SsoProvider>;
  /** Get the SSO SAML URL. Will return null if no SSO SAML provider is available */
  ssoSamlRequestUrl?: Maybe<Scalars['String']['output']>;
  /** The full visible STANDARD catalogue. NOT tenant-scoped - every tenant receives the same rows. For the frameworks a tenant actually holds, use `frameworks`. */
  standards?: Maybe<Array<RiskArea>>;
  /** Tenant's subscription plan. Resolvable by company admin. */
  subscriptionPlan?: Maybe<TenantSubscription>;
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Returns a paginated list of subsidiary sites. */
  subsidiarySites?: Maybe<SubsidiarySitesConnection>;
  /** Resolves tags for tenant. */
  tags?: Maybe<TagConnection>;
  /** List of tenant admins assigned to headquarters */
  users?: Maybe<Array<UserRole>>;
  uuid: Scalars['ID']['output'];
  /** Return tenant's years */
  years?: Maybe<YearConnection>;
};


export type TenantBaseDataTypeCaseOwnerExclusionArgs = {
  input?: InputMaybe<CaseOwnerExclusionGetByBusinessUnitInput>;
};


export type TenantBaseDataTypeGroupTagsArgs = {
  input?: InputMaybe<GroupTagConnectionInput>;
};


export type TenantBaseDataTypeHeadlineTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};


export type TenantBaseDataTypeHomeContentTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};


export type TenantBaseDataTypeIndustryUnitsArgs = {
  input: TenantIndustryUnitsInput;
};


export type TenantBaseDataTypePoliciesContentTranslatedArgs = {
  input?: InputMaybe<DynamicTranslationInput>;
};


export type TenantBaseDataTypeRegionArgs = {
  input: GetRegionInput;
};


export type TenantBaseDataTypeRegionsArgs = {
  input?: InputMaybe<RegionConnectionInput>;
};


export type TenantBaseDataTypeReportingGroupArgs = {
  input: ReportingGroupGetInput;
};


export type TenantBaseDataTypeReportingGroupsArgs = {
  input: ReportingGroupConnectionInput;
};


export type TenantBaseDataTypeSsoSamlRequestUrlArgs = {
  input: SsoSamlRequestUrlInput;
};


export type TenantBaseDataTypeSubsidiarySiteArgs = {
  input: SubsidiarySiteGetInput;
};


export type TenantBaseDataTypeSubsidiarySitesArgs = {
  input?: InputMaybe<SubsidiarySitesConnectionInput>;
};


export type TenantBaseDataTypeTagsArgs = {
  input?: TagConnectionInput;
};


export type TenantBaseDataTypeYearsArgs = {
  input: YearsConnectionInput;
};

/** Optional shop checkout context carried through signup so the activation email can return the buyer to the shop checkout flow. Only opaque catalogue ids are accepted here, never a URL. */
export type TenantCheckoutContextInput = {
  /** Shop catalogue plan id */
  planId: Scalars['String']['input'];
  /** Shop catalogue product id */
  productId: Scalars['String']['input'];
};

export type TenantCountryUpdateInput = {
  /** New company country. */
  country: TenantsCountry;
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

/** Input for creating new tenants */
export type TenantCreateInput = {
  /** Optional shop checkout context. When present, the activation email returns the buyer to the shop checkout flow instead of the auth app. */
  checkout?: InputMaybe<TenantCheckoutContextInput>;
  clusterRegion: ClusterIds;
  /** New tenant name */
  companyName: Scalars['String']['input'];
  country: TenantsCountry;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Represents input for deleting tenants. WARNING: this action is destructive and not easily rolled back. */
export type TenantDeleteInput = {
  /** Deleted tenant name, used to verify delete. */
  tenantName: Scalars['String']['input'];
  /** Deleted tenant UUID. */
  tenantUuid: Scalars['ID']['input'];
};

export type TenantDomain = {
  /** The verified domain, lower-cased and punycode-normalised. Matches exactly - never a subdomain or parent domain of it. */
  domain: Scalars['String']['output'];
  /** How this domain was verified. Only STAFF exists in v1. */
  method: Tenant_Domain_Verification_Method;
  /** Only VERIFIED domains are ever eligible to match a lookup. */
  status: Tenant_Domain_Status;
  /** UUID of the tenant this domain is verified for. */
  tenantUuid: Scalars['UUID']['output'];
  /** TenantDomain row UUID. */
  uuid: Scalars['ID']['output'];
  /** When this domain was verified. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the Speeki admin who verified this domain. */
  verifiedByUuid?: Maybe<Scalars['UUID']['output']>;
};

export type TenantDomainBackfillClaim = {
  domain: Scalars['String']['output'];
  tenantUuid: Scalars['UUID']['output'];
};

export type TenantDomainBackfillConflict = {
  domain: Scalars['String']['output'];
  /** MULTIPLE_TENANTS, CLAIMED_BY_OTHER, NOT_CLAIMABLE or ERROR (the cause of an ERROR is in the service log). */
  reason: Scalars['String']['output'];
  tenants: Array<TenantDomainBackfillTenant>;
};

export type TenantDomainBackfillReport = {
  claimed: Array<TenantDomainBackfillClaim>;
  /** Domains left unclaimed for a person to decide. */
  conflicts: Array<TenantDomainBackfillConflict>;
  /** Tenants skipped: free-mail, banned or missing email. */
  skipped: Scalars['Int']['output'];
};

export type TenantDomainBackfillTenant = {
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type TenantDomainVerifyInput = {
  /** Domain to verify and record for the tenant, e.g. acme.com. Normalised (lower-cased, punycode) and validated server-side. */
  domain: Scalars['String']['input'];
  /** Tenant this domain belongs to. */
  tenantUuid: Scalars['UUID']['input'];
};

/** One federated, read-only view of what a tenant currently holds. */
export type TenantEntitlements = {
  items: Array<EntitlementItem>;
  legacyPlanName?: Maybe<Subscription_Plan_Key>;
  modules: Array<EntitlementModule>;
  seats?: Maybe<EntitlementSeats>;
  subscriptionEnd?: Maybe<Scalars['DateTime']['output']>;
  subscriptionStart?: Maybe<Scalars['DateTime']['output']>;
  tenantUuid: Scalars['ID']['output'];
  tier?: Maybe<Entitlement_Tier>;
};


/** One federated, read-only view of what a tenant currently holds. */
export type TenantEntitlementsItemsArgs = {
  filter?: InputMaybe<EntitlementItemFilter>;
};

export type TenantIndustryUnitsInput = {
  /** Standard name */
  standardName: Esg_Subcategory;
};

export type TenantInformationUpdateInput = {
  /** New company name. Will throw error if name is duplicated. */
  companyName: Scalars['String']['input'];
  /** New company country. */
  country: TenantsCountry;
  /** New tenant slug. If slug contains invalid characters it will be parsed into valid string. */
  reportingSlug?: InputMaybe<Scalars['String']['input']>;
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

export type TenantLicenseCountUpdateInput = {
  /** Tenant limited license count. */
  limitedLicenseCount: Scalars['Int']['input'];
  /** Tenant license count. */
  standardLicenseCount: Scalars['Int']['input'];
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

export type TenantModuleSettings = {
  CARBON_LENS: Scalars['Boolean']['output'];
  CASES: Scalars['Boolean']['output'];
  DEMO: Scalars['Boolean']['output'];
  DISCLOSURES: Scalars['Boolean']['output'];
  DUE_DILIGENCE: Scalars['Boolean']['output'];
  ESG: Scalars['Boolean']['output'];
  INSIGHTS: Scalars['Boolean']['output'];
  NICOLE_GPT: Scalars['Boolean']['output'];
  SSO: Scalars['Boolean']['output'];
  SUBSIDIARY_SITES: Scalars['Boolean']['output'];
  SURVEYS: Scalars['Boolean']['output'];
  TASKS: Scalars['Boolean']['output'];
  TEAMS: Scalars['Boolean']['output'];
  TRAININGS: Scalars['Boolean']['output'];
  /** @deprecated Use CASES */
  cases: Scalars['Boolean']['output'];
  /** @deprecated Use DISCLOSURES */
  disclosures: Scalars['Boolean']['output'];
  /** @deprecated Use SSO */
  sso: Scalars['Boolean']['output'];
  /** @deprecated Use SUBSIDIARY_SITES */
  subsidiary_sites: Scalars['Boolean']['output'];
  /** @deprecated Use SURVEYS */
  surveys: Scalars['Boolean']['output'];
  /** @deprecated Use TEAMS */
  teams: Scalars['Boolean']['output'];
  teamsTenantId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use TRAININGS */
  trainings: Scalars['Boolean']['output'];
};

export type TenantNameUpdateInput = {
  /** New company name. Will throw error if name is duplicated. */
  companyName: Scalars['String']['input'];
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

export type TenantNonRenewalNotice = {
  createdAt: Scalars['DateTime']['output'];
  party: Non_Renewal_Party;
  reason?: Maybe<Scalars['String']['output']>;
};

export type TenantPrimaryContactDataUpdateInput = {
  /** Primary contact email address */
  email: Scalars['EmailAddress']['input'];
  /** Primary contact first name */
  firstName: Scalars['String']['input'];
  /** Primary contact last name */
  lastName: Scalars['String']['input'];
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

/** Records a notice of non-renewal the customer sent by email. */
export type TenantRenewalRecordCustomerNoticeInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  tenantUuid: Scalars['ID']['input'];
};

/** Records a notice that the tenant's term will not renew. */
export type TenantRenewalStopInput = {
  /** Who is giving notice. Speeki by default; CUSTOMER records a notice the customer sent by email. */
  party?: InputMaybe<Non_Renewal_Party>;
  /** Why the renewal is being stopped. Required; kept with the notice. */
  reason: Scalars['String']['input'];
  tenantUuid: Scalars['ID']['input'];
};

/** Withdraws a live notice of non-renewal. */
export type TenantRenewalWithdrawInput = {
  party?: InputMaybe<Non_Renewal_Party>;
  tenantUuid: Scalars['ID']['input'];
};

export type TenantReportingPeriod = {
  /** Flag indicating if reporting period has been changed */
  isPeriodSet: Scalars['Boolean']['output'];
  /** Start month of reporting period. */
  reportingPeriodStart: Month;
  /** Identifier of reporting period, equal to UUID of tenant it describes. */
  tenantUuid: Scalars['String']['output'];
};

/** Input to change reporting period for tenant. */
export type TenantReportingPeriodInput = {
  /** Start month of reporting period. */
  reportingPeriodStart: Month;
};

/** Input for setting custom label for a risk area */
export type TenantRiskAreaCustomLabelSetInput = {
  /** Custom label for the risk area */
  customLabel?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the risk area */
  riskAreaUuid: Scalars['UUID']['input'];
  /** UUID of the tenant */
  tenantUuid: Scalars['String']['input'];
};

/** Contains data about risk area setting for a tenant */
export type TenantRiskAreaSetting = {
  /**
   * Custom label for the risk area
   * @deprecated This functionality has been removed - this field will always return null.
   */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the risk area is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the risk area */
  name: Scalars['String']['output'];
  /** UUID of the risk area */
  riskAreaUuid: Scalars['UUID']['output'];
  /**
   * Target risk area
   * @deprecated This functionality has been removed - this field will always return null.
   */
  targetRiskArea?: Maybe<TargetRiskArea>;
};

/** Input for single risk area setting for tenant */
export type TenantRiskAreaSettingInput = {
  /** Flag indicating if the risk area is enabled */
  isEnabled: Scalars['Boolean']['input'];
  /** UUID of the risk area */
  riskAreaUuid: Scalars['String']['input'];
  /** UUID of the target risk area */
  targetRiskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Contains data about risk area settings for a tenant */
export type TenantRiskAreaSettings = {
  /** List of risk area settings */
  riskAreaSettings: Array<Category>;
  /** UUID of the tenant */
  tenantUuid: Scalars['String']['output'];
};

/** Input for setting risk area settings for a tenant */
export type TenantRiskAreaSettingsSetInput = {
  /** List of risk area settings */
  riskAreaSettings: Array<TenantRiskAreaSettingInput>;
  /** UUID of the standard */
  standardUuid: Scalars['UUID']['input'];
  /** UUID of the tenant */
  tenantUuid: Scalars['String']['input'];
};

/** Returns Saml request URL */
export type TenantSamlRequestDetails = {
  /** @deprecated Use TenantBaseDataType.ssoSamlRequestUrl field to resolve */
  samlRequestUrl: Scalars['String']['output'];
};

/** Result of a checkout-verified tenant signup. Deliberately a narrower type than AdminTenantData (not a superset/extension of it) - registerCode is a live activation credential and must not be exposed on any broader tenant-lookup query that happens to reuse AdminTenantData. */
export type TenantSignupVerifiedData = {
  /** Tenant's GraphQl API url. */
  apiUrl: Scalars['String']['output'];
  /** The work-email domain claimed for this company at sign-up, or null when none was claimed (free-mail and banned domains are never claimed). */
  claimedDomain?: Maybe<Scalars['String']['output']>;
  /** Tenant's company code */
  code: Scalars['String']['output'];
  /** Tenant's name. */
  name: Scalars['String']['output'];
  /** One-time code the client uses to complete account activation immediately, without the usual email round-trip - safe to skip here because the email was already server-side verified via the checkout session. */
  registerCode: Scalars['String']['output'];
  /** Tenant's UUID. */
  uuid: Scalars['ID']['output'];
};

/** Represents input for changing the status of tenant. Inactive tenants will be removed after certain time */
export type TenantStatusChangeInput = {
  /** Deleted tenant name, used to verify delete. */
  isActive: Scalars['Boolean']['input'];
  /** New subscription end date. Required when switching a tenant back on. */
  subscriptionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deleted tenant UUID. */
  tenantUuid: Scalars['ID']['input'];
};

export type TenantSubscriberEmailUpdateInput = {
  /** Subscriber email address. */
  subscriberEmailAddress: Scalars['EmailAddress']['input'];
  /** UUID of edited company */
  tenantUuid: Scalars['String']['input'];
};

export type TenantSubscription = {
  daysToExpire?: Maybe<Scalars['Int']['output']>;
  /** Subscription end date. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tenant subscription plan. */
  planName?: Maybe<Subscription_Plan>;
  /** Subscription start date. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantSubscriptionDatesUpdateInput = {
  /** Date of tenant subscription end. */
  subscriptionEndDate: Scalars['DateTime']['input'];
  /** Date of tenant subscription start. */
  subscriptionStartDate: Scalars['DateTime']['input'];
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

export type TenantSubscriptionUpdateInput = {
  /** Tenant limited license count. */
  limitedLicenseCount: Scalars['Int']['input'];
  /** New tenant subscription plan. */
  plan: Subscription_Plan;
  /** Tenant license count. */
  standardLicenseCount: Scalars['Int']['input'];
  /** Subscriber email address. */
  subscriberEmailAddress?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Date of tenant subscription end. */
  subscriptionEndDate: Scalars['DateTime']['input'];
  /** Date of tenant subscription start. */
  subscriptionStartDate: Scalars['DateTime']['input'];
  /** UUID of edited company */
  tenantUuid: Scalars['UUID']['input'];
};

export type TenantSwitchOffPreview = {
  name: Scalars['String']['output'];
  /** The end date the term ran out on. */
  subscriptionExpire: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type TenantUnitBatchInput = {
  /** Represents units to be enabled or disabled */
  tenantUnits: Array<TenantUnitInput>;
};

export type TenantUnitInput = {
  /** Flag indicating the target status of unit. */
  isEnabled: Scalars['Boolean']['input'];
  unitUuid: Scalars['UUID']['input'];
};

export type TenantUpdateDefaultAnswerLabelInput = {
  /** Custom label. Provide null to clear. */
  customLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TenantYearDataState = {
  /** Flag indicating if there are answers for given year. */
  hasAnswers: Scalars['Boolean']['output'];
  /** Flag indicating if there are tasks for given year. */
  hasTasks: Scalars['Boolean']['output'];
  /** Identifier of tenant year data state, equal to UUID of year it describes. */
  uuid: Scalars['UUID']['output'];
};

/** Enumeration of country codes. */
export type TenantsCountry =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'ALL'
  | 'AM'
  | 'AN'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KV'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'XK'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

/** Enumeration of user relationships. */
export type TenantsUserRelationship =
  | 'ALL'
  | 'ANONYMOUS'
  | 'CUSTOMER'
  | 'EMPLOYEE'
  | 'EX_EMPLOYEE'
  | 'FAMILY'
  | 'INVESTOR'
  | 'OTHER'
  | 'SUPPLIER';

/** Enumeration of user statuses. */
export type TenantsUserStatus =
  | 'ACTIVE'
  | 'INACTIVE';

/** Enumeration of user types. */
export type TenantsUserType =
  | 'AUDITOR'
  | 'EMPLOYEE'
  | 'EXTERNAL'
  | 'GUEST'
  | 'SHOP_SERVICE'
  | 'SPEEKI_ADMIN'
  | 'TENANT_ADMIN';

export type ToggleProgramSettingInput = {
  programUuid: Scalars['String']['input'];
  tenantUuid: Scalars['String']['input'];
};

export type TranslateInput = {
  /** Optional source language. If missing will google translate detection will be used. */
  sourceLanguage?: InputMaybe<LanguageCode>;
  /** Optional target language. If missing will use the one from user context data if present. */
  targetLanguage?: InputMaybe<LanguageCode>;
  /** Values to translate. */
  text: Array<Scalars['String']['input']>;
};

/** Represents triage score settings. */
export type TriageScoreSetting = {
  /** Indicates whether current user can edit the setting. */
  canEdit: Scalars['Boolean']['output'];
  /** Indicates whether the setting is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The label of severity factor. */
  severityLabel: Scalars['String']['output'];
  /** The weight of severity factor. */
  severityWeight: Scalars['Int']['output'];
  /** The label of urgency factor. */
  urgencyLabel: Scalars['String']['output'];
  /** The weight of urgency factor. */
  urgencyWeight: Scalars['Int']['output'];
};

/** Represents the input for triage score settings. */
export type TriageScoreSettingsInput = {
  /** The label of severity factor. */
  severityLabel?: InputMaybe<Scalars['String']['input']>;
  /** The weight of severity factor. */
  severityWeight: Scalars['Int']['input'];
  /** The label of urgency factor. */
  urgencyLabel?: InputMaybe<Scalars['String']['input']>;
  /** The weight of urgency factor. */
  urgencyWeight: Scalars['Int']['input'];
};

/** Represents hotspot dots. */
export type Ui_Hotspot_Key =
  | 'ANALYTICS_CHART_LEGEND'
  | 'ANALYTICS_FILTER_DATE'
  | 'CM_ACTIVITY_BUTTON'
  | 'CM_ACTIVITY_TAB'
  | 'CM_CASE_INDIVIDUAL_INVOLVED'
  | 'CM_CASE_INFORMATION_PAGE'
  | 'CM_CASE_SETTINGS'
  | 'CM_CASE_STATUS'
  | 'CM_DASHBOARD_FILTER_DATE'
  | 'CM_DASHBOARD_TABLE_SETTINGS'
  | 'CM_ORIGINAL_REPORT_BUTTON'
  | 'ESG_ADD_VERSION_BUTTON'
  | 'ESG_QUESTIONNAIRE_NAVIGATION'
  | 'GLOBAL_SETTINGS'
  | 'NICOLE_GPT_WELCOME_POPUP'
  | 'REPORTING_AI_CUSTOMIZE_REPORT_PROMPT'
  | 'REPORTING_AI_REPORT_TEMPLATE_LIST'
  | 'SMART_FILL_ENTRY'
  | 'SMART_FILL_REVIEW'
  | 'SMART_FILL_UPLOAD';

export type Users_Assignable_Permission_Filter =
  | 'CARBON_LENS_MODULE_ACCESS'
  | 'CASES_ADMIN'
  | 'CASES_LIMITED_USER'
  | 'CASES_MODULE_ACCESS'
  | 'CASES_REGIONAL_USER'
  | 'CASES_USER'
  | 'DISCLOSURES'
  | 'DUE_DILIGENCE_MODULE_ACCESS'
  | 'ESG_MANAGE_ESG_TOPICS'
  | 'ESG_MANAGE_PROFILE_SETTINGS'
  | 'ESG_MODULE_ACCESS'
  | 'ESG_READ'
  | 'ESG_RISK_AREA_READ'
  | 'ESG_RISK_AREA_WRITE'
  | 'ESG_USE_PERM_MATRIX'
  | 'ESG_WRITE'
  | 'METRICS'
  | 'NICOLE_GPT_MODULE_ACCESS'
  | 'REPORTING'
  | 'SUPER_ADMIN'
  | 'SURVEYS'
  | 'TASKS_MANAGEMENT'
  | 'TENANT_EDIT_COMPANY_SETTINGS';

/** Enumeration of user invitation statuses. */
export type User_Invitation_Status =
  | 'PENDING'
  | 'SUCCESS';

/** Represents enumeration of user to company relationships. */
export type User_Relationship =
  | 'ALL'
  | 'ANONYMOUS'
  | 'CUSTOMER'
  | 'EMPLOYEE'
  | 'EX_EMPLOYEE'
  | 'FAMILY'
  | 'INVESTOR'
  | 'OTHER'
  | 'SUPPLIER';

/** Enumeration of allowed user roles. */
export type User_Role =
  | 'ADMIN'
  | 'ASSIGNOR'
  | 'BILLING_USER'
  | 'LIMITED_USER'
  | 'REGIONAL_USER'
  | 'USER';

/** Represents the status of a user. */
export type User_Status_Key =
  | 'ACTIVE'
  | 'INACTIVE';

/** Enumeration of user types */
export type User_Type_Key =
  | 'AUDITOR'
  | 'EMPLOYEE'
  | 'EXTERNAL'
  | 'GUEST'
  | 'SHOP_SERVICE'
  | 'SPEEKI_ADMIN'
  | 'TENANT_ADMIN';

/** One of the caller's tenant's unfinished (DRAFT / AWAITING_SIGNATURE) orders, with the retrieve/resend/cancel affordances a buyer coming back to it needs. */
export type UnfinishedOrder = {
  /** True when "Send it again" is available right now. False for a DRAFT (there is no envelope yet to resend), while the resend cooldown is active, or once the resend cap has been reached. */
  canResend: Scalars['Boolean']['output'];
  /** True when the caller themselves initiated this order. */
  isMine: Scalars['Boolean']['output'];
  order: Order;
  /** True once the resend cap has been reached for this order - canResend is false and will stay false; the buyer should be pointed at support instead of shown a countdown. */
  resendCapReached: Scalars['Boolean']['output'];
  /** Seconds until another resend is allowed. 0 when not on cooldown (including when canResend is false for a reason OTHER than the cooldown, e.g. a DRAFT or the cap). */
  resendCooldownRemainingSeconds: Scalars['Int']['output'];
};

/** An object that represents a unit. For IFRS unit represents industry */
export type Unit = {
  /** Short description of a unit */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Determines if this unit is enabled for current tenant.
   * Can be resolved by TENANT_ADMIN or EXTERNAL.
   */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of a unit */
  name: Scalars['String']['output'];
  /** The sector this unit belongs to. */
  sector: Sector;
  uuid: Scalars['UUID']['output'];
  /** Extra symbol or description of a unit, that helps to locate or identify it in a documentation */
  volume?: Maybe<Scalars['String']['output']>;
};

/** Represents Unit connection edge. */
export type UnitEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Unit record. */
  node: Unit;
};

export type UnitSortFields =
  | 'NAME'
  | 'ORDER';

export type UnitSortInput = {
  direction: SortDirection;
  field: UnitSortFields;
};

export type UnlinkMetricFromAnswerInput = {
  /** The UUID of the answer to unlink the metric from */
  answerUuid: Scalars['UUID']['input'];
  /** The UUID of the metric to unlink the answer from */
  metricUuid: Scalars['UUID']['input'];
  /** The UUID of the year to unlink the metric from the answer */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of unlinking a metric from an answer */
export type UnlinkMetricFromAnswerResult = {
  /** UUID of the answer the metric was unlinked from */
  answerUuid: Scalars['UUID']['output'];
  /** UUID of the metric that was unlinked from the answer */
  metricUuid: Scalars['UUID']['output'];
};

export type UnlinkQuestionFromMetricInput = {
  /** The UUID of the metric to unlink the question from */
  metricUuid: Scalars['UUID']['input'];
  /** The UUID of the question to unlink from the metric */
  questionUuid: Scalars['UUID']['input'];
  /** The UUID of the year to unlink the question from the metric */
  yearUuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Result of unlinking a question from a metric */
export type UnlinkQuestionFromMetricResult = {
  /** UUID of the metric the question was unlinked from */
  metricUuid: Scalars['UUID']['output'];
  /** UUID of the question that was unlinked from the metric */
  questionUuid: Scalars['UUID']['output'];
};

/** Input for unlock account with valid token */
export type UnlockAccountInput = {
  /** A token received in email after account unlock request */
  token: Scalars['String']['input'];
};

/** Object representing detailed unmapped questions statistics. */
export type UnmappedQuestionStandardStatistics = {
  /** Statistics' Standard. */
  standard: RiskArea;
  /** Unmapped questions statistics for resolved standard. */
  statistics: EsgStatistics;
};

/** Represents unmapped questions statistics. */
export type UnmappedQuestionStatistics = {
  /** Total count of unmapped questions. */
  answeredCount: Scalars['Int']['output'];
  /** Array of detailed unmapped questions count per standard. */
  standardsCount: Array<UnmappedQuestionStandardStatistics>;
  /** Total count of unmapped questions. */
  totalCount: Scalars['Int']['output'];
};

/** Represents input for optional scope of unmapped questions statistics. */
export type UnmappedQuestionsStatisticsInput = {
  /** Flag indicating should user settings be considered or not. */
  ignoreUserSettings?: Scalars['Boolean']['input'];
  /** Task assignment mode.  */
  questionTaskRelation?: Esg_Related_Tasks_Mode;
  /** UUIDs of Standards. If omitted all enabled standards will be used. */
  standardUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Array of units/industries to narrow down statistics. By default will query all tenant's enabled units. */
  unitsUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents the input for updating existing business unit. */
export type UpdateBusinessUnitInput = {
  /** Indicates whether business unit is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of business unit. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of business unit. */
  uuid: Scalars['String']['input'];
};

/** Input for updating email. */
export type UpdateRecoveryEmailInput = {
  /** Email to update */
  newRecoveryEmail: Scalars['String']['input'];
};

/** Represents input for updating task status. */
export type UpdateTaskStatusInput = {
  status: Task_Status;
  uuid: Scalars['UUID']['input'];
};

/** Represents the input for updating existing tenant. */
export type UpdateTenantInput = {
  enforceMfa?: InputMaybe<Scalars['Boolean']['input']>;
  homeHtml?: InputMaybe<Scalars['HTML']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  policiesHtml?: InputMaybe<Scalars['HTML']['input']>;
};

/** Represents input for upserting Metric Data */
export type UpsertMetricDataInput = {
  /** json representation of metric data */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** UUID of the metric */
  metricUuid: Scalars['UUID']['input'];
  /**
   * json representation of metric data settings (ie. what column is pinned)
   * @deprecated unused in flows using syncfusion
   */
  settings?: InputMaybe<Scalars['JSON']['input']>;
  /** year of the metric data */
  year: Scalars['Int']['input'];
};

/** Represents input for upserting Metric */
export type UpsertMetricInput = {
  /** description of the metric */
  description: Scalars['String']['input'];
  /** name of the metric */
  name: Scalars['String']['input'];
  /** uuid of the owner of the metric */
  ownerUuid: Scalars['String']['input'];
  /**
   * uuid of the riskArea of the metric, deprecated: use riskAreaUuids
   * @deprecated use riskAreaUuids
   */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** uuids of the risk areas of the metric */
  riskAreaUuids?: Array<Scalars['UUID']['input']>;
  /** Uuid of the metric */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for upserting Symbol */
export type UpsertSymbolInput = {
  /** denotation of the symbol (eg. kg) */
  denotation: Scalars['String']['input'];
  /** name of the symbol */
  name: Scalars['String']['input'];
  /** UUID of the symbol */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents input for upserting goals of the target */
export type UpsertTargetGoalsInput = {
  /** value of the goal */
  value?: InputMaybe<Scalars['Float']['input']>;
  /** goal year of the target */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents input for upserting the target */
export type UpsertTargetInput = {
  /** starting year of the target */
  baseYear?: InputMaybe<Scalars['Int']['input']>;
  /** description of the target */
  description?: InputMaybe<Scalars['String']['input']>;
  /** direction of the target */
  direction: Target_Direction;
  /** goals of the target */
  goals?: InputMaybe<Array<UpsertTargetGoalsInput>>;
  /** UUID of the metric related to target */
  metricUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** name of the target */
  name?: InputMaybe<Scalars['String']['input']>;
  /** points of the target */
  points: Target_Point;
  /** target year of the target */
  targetYear: Scalars['Int']['input'];
  /** Tracked cell address */
  trackedCellAddress?: InputMaybe<Scalars['String']['input']>;
  /**
   * id of row for tracked data of the target (ie. Scope1)
   * @deprecated This field is not used with Syncfusion spreadsheet schema.
   */
  trackedDataRowId?: InputMaybe<Scalars['String']['input']>;
  /**
   * id of subrow for tracked data of the target (ie. Methane)
   * @deprecated This field is not used with Syncfusion spreadsheet schema.
   */
  trackedDataSubRowId?: InputMaybe<Scalars['String']['input']>;
  /** Target unit */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the target */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

export type UsedCustomTagsInput = {
  /** Tag name filter */
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating tag fetch mode setting. */
  onlyAnsweredQuestions?: Scalars['Boolean']['input'];
  /** Optional uuid to scope tags by riskArea */
  riskAreaUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional array to scope tags by multiple riskAreas. */
  riskAreaUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array to scope standard tags by sectors. */
  sectorUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Standard UUID. */
  standardUuid: Scalars['UUID']['input'];
  /** Optional array to scope tags by steps. */
  steps?: InputMaybe<Array<Esg_Step>>;
  /** Optional array to scope standard tags by units. */
  unitUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional array to scope standard tags by years. */
  yearsUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Enumeration of allowed user languages. */
export type UserAuthLanguage =
  | 'AF'
  | 'AM'
  | 'AR'
  | 'AZ'
  | 'BE'
  | 'BG'
  | 'BN'
  | 'BS'
  | 'CA'
  | 'CEB'
  | 'CO'
  | 'CS'
  | 'CY'
  | 'DA'
  | 'DE'
  | 'EL'
  | 'EN'
  | 'EO'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FA'
  | 'FI'
  | 'FR'
  | 'FY'
  | 'GA'
  | 'GD'
  | 'GL'
  | 'GU'
  | 'HA'
  | 'HAw'
  | 'HI'
  | 'HMn'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'HY'
  | 'ID'
  | 'IG'
  | 'IS'
  | 'IT'
  | 'IW'
  | 'JA'
  | 'JW'
  | 'KA'
  | 'KK'
  | 'KM'
  | 'KN'
  | 'KO'
  | 'KU'
  | 'KY'
  | 'LA'
  | 'LB'
  | 'LO'
  | 'LT'
  | 'LV'
  | 'MG'
  | 'MI'
  | 'MK'
  | 'ML'
  | 'MN'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MY'
  | 'NE'
  | 'NL'
  | 'NO'
  | 'NY'
  | 'PA'
  | 'PL'
  | 'PS'
  | 'PT'
  | 'RO'
  | 'RU'
  | 'SD'
  | 'SI'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SQ'
  | 'SR'
  | 'ST'
  | 'SU'
  | 'SV'
  | 'SW'
  | 'TA'
  | 'TE'
  | 'TG'
  | 'TH'
  | 'TL'
  | 'TR'
  | 'UK'
  | 'UR'
  | 'UZ'
  | 'VI'
  | 'XH'
  | 'YI'
  | 'YO'
  | 'ZH_CN'
  | 'ZH_TW'
  | 'ZU';

/** Represents pagination connection of users. */
export type UserConnection = {
  /** Array of edges. */
  edges: Array<TasksUserTypeEdge>;
  /** Array of direct nodes. */
  nodes: Array<UserType>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents pagination input for connection of users. */
export type UserConnectionInput = {
  /** Narrows the result of pagination to given criteria. */
  filtering?: InputMaybe<UserFilterInput>;
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Narrows the result of pagination to given search criteria. */
  searching?: InputMaybe<UserSearchInput>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<UserTypeSortInput>>;
};

/** Represents the input type containing user's details. Either contact email xor phone number with or without country code can be submittedInputs are validated according to logic: contactEmail XOR (phoneNumber && (phoneNumber || countryCode)) */
export type UserDetailsInput = {
  /**
   * Contact email. Can be submitted if country code and phone number are empty.
   * @deprecated New ORGANIZATION/INDIVIDUAL flow
   */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Users country */
  country?: InputMaybe<Country_Code>;
  /**
   * Phone number country code. Can only be submitted if phone number is present.
   * @deprecated New ORGANIZATION/INDIVIDUAL flow
   */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Email of organization user is representing */
  organizationEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** Name of organization user is representing */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Users role in organization */
  organizationRole?: InputMaybe<Scalars['String']['input']>;
  /**
   * Contact phone number. Can only be submitted if email is missing. Does not require country code to be present.
   * @deprecated New ORGANIZATION/INDIVIDUAL flow
   */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the user disclosures statistics */
export type UserDisclosureStatistics = {
  /** Number of available disclosures. */
  availableDisclosures: Scalars['Int']['output'];
  /** Number of disclosures user answered to. Null for guest. */
  respondedDisclosures?: Maybe<Scalars['Int']['output']>;
  /** Number of responses to disclosures. Null for guest. */
  responsesCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents the input for updating user enabled standards. */
export type UserEnabledStandardsSetInput = {
  /** UUIDs of standards to disable. */
  disableUuids: Array<Scalars['UUID']['input']>;
  /** UUIDs of standards to enable. */
  enableUuids: Array<Scalars['UUID']['input']>;
};

/** Represents input for user pagination filter. */
export type UserFilterInput = {
  /** Narrows the pagination results to users without given permissions. */
  forbiddenPermissions?: InputMaybe<Array<Users_Assignable_Permission_Filter>>;
  /** Narrows the search result by user who created task (for assignors) or user who is assigned to task (for assignees). */
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination results to users with given permissions. */
  permissions?: InputMaybe<Array<Users_Assignable_Permission_Filter>>;
  /** Narrows the pagination result to the given user statuses. */
  userStatus?: InputMaybe<Tasks_User_Status>;
};

/** Represents input to seat or unseat a user in a framework's seat roster. */
export type UserFrameworkSeatInput = {
  /** UUID of the framework (risk area) to seat the user into. */
  riskAreaUuid: Scalars['UUID']['input'];
  /** Targeted user's UUID. */
  userUuid: Scalars['String']['input'];
};

/** Represents input to update user own profile details. */
export type UserProfileUpdateInput = {
  /** Edited user country. */
  country: Country_Code;
  /** Edited user email. */
  email: Scalars['EmailAddress']['input'];
  /** Edited user first name. */
  firstName: Scalars['String']['input'];
  /** Edited user last name. */
  lastName: Scalars['String']['input'];
  /** Edited user timezone. */
  timeZone: Time_Zone;
};

export type UserRole = {
  /**
   * Resolves permissions for role.
   * @deprecated This field will not be resolved with new permissions and will be removed soon.
   */
  permissions?: Maybe<Array<Permission>>;
  /** currently logged in user's role in subsidiary site. */
  role: User_Role;
  /** Subsidiary site assigned to role. Undefined for role in hq. */
  subsidiarySite?: Maybe<SubsidiarySite>;
  /** Subsidiary site assigned to role UUID. Undefined for role in hq. */
  subsidiarySiteUuid?: Maybe<Scalars['UUID']['output']>;
  /** Role's user. */
  user: UserType;
  /** Role's user's UUID. */
  userUuid: Scalars['String']['output'];
  /** User role UUID. */
  uuid: Scalars['ID']['output'];
};

/** Represents input for user search. */
export type UserSearchInput = {
  /** Narrows the pagination search result by user email. */
  narrowByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by user last name. */
  narrowByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result by user name. */
  narrowByName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the pagination search result to the given keywords. */
  textQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Type containing all user properties and sessions tokens */
export type UserSettings = {
  /** Tokens with updated details */
  tokens: SessionWithOaExchange;
  /** Updated user entity */
  user: UserType;
};

export type UserSource =
  | 'CM'
  | 'ELINE'
  | 'MOBILE'
  | 'UNKNOWN'
  | 'WEBPORTAL';

export type UserType = {
  /**
   * Current subsidiary site.
   * @deprecated Use activeRole property.
   */
  activeEntity?: Maybe<UserRole>;
  /** Current user role. */
  activeRole?: Maybe<UserRole>;
  /** Assignable roles assigned to user. */
  assignedRole?: Maybe<Role>;
  /**
   * It is only for tenant admin. If you dont have role then it will throw error
   * @deprecated Resolve field UserType.ssoAccounts object type
   */
  azureConnected: Scalars['Boolean']['output'];
  /** The list of biometrics devices IDs. Can be used to check if a device is setup and provide devices count. Can be resolved only for current user otherwise will return null */
  biometricsDevices?: Maybe<Array<Scalars['String']['output']>>;
  businessUnit?: Maybe<BusinessUnit>;
  canResendInvitation: Scalars['Boolean']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country_Code>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** List of user's enabled standards. */
  enabledStandards: Array<RiskArea>;
  entitlements?: Maybe<TenantEntitlements>;
  /** ESG settings for the user. Can be null if the user does not have ESG settings. */
  esgSettings?: Maybe<Array<RoleRiskArea>>;
  /** Token used for authentication with firebase. Only resolvable for self TENANT_ADMIN and EMPLOYEE. */
  firebaseToken?: Maybe<Scalars['JWT']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** Returns user's API storage data for authenticated user or `NULL` otherwise. */
  graphStorage?: Maybe<Scalars['JSON']['output']>;
  /** Flag indicating if there are active unread release notes. */
  hasUnreadReleaseNote?: Maybe<Scalars['Boolean']['output']>;
  /** Returns list of user's non-burned hotspots. */
  hotspots?: Maybe<Array<Ui_Hotspot_Key>>;
  invitation: User_Invitation_Status;
  isBillingRole: Scalars['Boolean']['output'];
  /** Return true if the user is assigned to the questionnaire filters */
  isFilterEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGuest: Scalars['Boolean']['output'];
  isLoggedIn: Scalars['Boolean']['output'];
  isPersonalInfoCompleted: Scalars['Boolean']['output'];
  language?: Maybe<UserAuthLanguage>;
  languageSelect: Select;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  navigableTaskRiskArea?: Maybe<ExternalUserAvailableRiskArea>;
  /** Email address of organization user is representing */
  organizationEmail?: Maybe<Scalars['String']['output']>;
  /** Name of organization user is representing */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** User role in organization */
  organizationRole?: Maybe<Scalars['String']['output']>;
  /** The frameworks this user's tenant owns, regardless of whether the user holds a seat in them. Read RiskArea.viewerHasSeat for the per-framework seat state. Contains no seat/licence counts. */
  ownedFrameworks: Array<RiskArea>;
  /** Array of permissions for user active role. */
  permissions?: Maybe<Array<Permission>>;
  phoneCountryPrefix?: Maybe<Scalars['String']['output']>;
  phoneNonPrefixed?: Maybe<Scalars['String']['output']>;
  /** User contact phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Return questionnaire filters by given user UUID */
  questionnaireFilters?: Maybe<QuestionnaireFilter>;
  /** Recovery email will be fully visible only in me query, in other queries/mutations it should be masked and nullable for other users. */
  recoveryEmail?: Maybe<Scalars['String']['output']>;
  /** Returns list of regional user's regions or `NULL` for other user roles. */
  regions?: Maybe<Array<Region>>;
  relationship?: Maybe<TenantsUserRelationship>;
  /** @deprecated User roles. */
  role?: Maybe<User_Role>;
  /** Array of user roles. */
  roles?: Maybe<Array<UserRole>>;
  /** List user sso accounts */
  ssoAccounts: Array<SsoAccount>;
  status: TenantsUserStatus;
  /** Returns tenant for given user. */
  tenant?: Maybe<TenantBaseDataType>;
  timeZone?: Maybe<Time_Zone>;
  type: TenantsUserType;
  /** Returns active release notes. Null if user already read published release notes. */
  unreadReleaseNote?: Maybe<ReleaseNote>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};


export type UserTypeRolesArgs = {
  includeActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents UserTypeConnection connection. */
export type UserTypeConnection = {
  /** Array of edges. */
  edges: Array<UserTypeEdge>;
  /** Array of direct nodes. */
  nodes: Array<UserType>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents UserType connection edge. */
export type UserTypeEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the UserType record. */
  node: UserType;
};

export type UserTypeSortFields =
  | 'EMAIL'
  | 'NAME';

export type UserTypeSortInput = {
  direction: SortDirection;
  field: UserTypeSortFields;
};

/** Represents CaseExclusionOwner connection edge. */
export type V2CaseExclusionOwnerEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CaseExclusionOwner record. */
  node: CaseExclusionOwner;
};

/** Represents Disclosure connection edge. */
export type V2DisclosureEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Disclosure record. */
  node: Disclosure;
};

/** Represents DisclosureResponse connection edge. */
export type V2DisclosureResponseEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the DisclosureResponse record. */
  node: DisclosureResponse;
};

/** Represents Survey connection edge. */
export type V2SurveyEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Survey record. */
  node: Survey;
};

/** Represents the input type for ordering the list of tenants. By default, the list is ordered by name. */
export type ValidateTenantInput = {
  /** New tenant name */
  companyName: Scalars['String']['input'];
  /** New user email */
  email: Scalars['String']['input'];
};

export type ValidationIssueObject = {
  code: Scalars['String']['output'];
  level: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Input for verifying a checkout session's email from the hub's proof of the signed-in person's address, in place of the six-digit code. */
export type VerifyCheckoutSessionWithHubProofInput = {
  /** The hub's proof of the signed-in person's verified email. */
  proof: Scalars['String']['input'];
  /** The checkout session's bearer token. */
  sessionToken: Scalars['String']['input'];
};

/** The result of verifying a checkout session's email from the hub's proof of the signed-in person's address. */
export type VerifyCheckoutSessionWithHubProofPayload = {
  /** Set only when the verified address's domain matches a tenant that has already verified ownership of it - the ORGANISATION name only, never a colleague's name, a tenant uuid, or any other tenant-internal detail. Null when unverified, unmatched, or the match lookup failed. */
  matchedOrganisationName?: Maybe<Scalars['String']['output']>;
  /** Whether the address is now confirmed for this checkout session. */
  verified: Scalars['Boolean']['output'];
};

/** Input for verifying confirmation email */
export type VerifyRegistrationInput = {
  /** Company code */
  code: Scalars['String']['input'];
  /** Jwt containing user and tenants uuid */
  token: Scalars['String']['input'];
};

export type Webflow = {
  /** Get n latest ESG posts */
  esgArticles: WebflowPostConnection;
  /** Get the latest news from the RSS feed */
  feed: WebflowPostConnection;
  /** Get "Release notes" category latest post */
  latestRelease?: Maybe<WebflowPost>;
  /** Random post, filtered by support category */
  supportArticle?: Maybe<WebflowPost>;
};


export type WebflowEsgArticlesArgs = {
  input?: InputMaybe<EsgArticlesPaginationInput>;
};


export type WebflowFeedArgs = {
  input?: InputMaybe<EsgArticlesPaginationInput>;
};

export type WebflowPost = {
  /** A post categories */
  categories: Array<Scalars['String']['output']>;
  /**
   * A post category
   * @deprecated Sometimes there can be multiple categories. Use categories field
   */
  category?: Maybe<Scalars['String']['output']>;
  /** A post description */
  description?: Maybe<Scalars['String']['output']>;
  /** A post ID for caching purposes. */
  id: Scalars['String']['output'];
  /** A post last published date */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A post title */
  title?: Maybe<Scalars['String']['output']>;
  /** An url to post */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Represents WebflowPostConnection connection. */
export type WebflowPostConnection = {
  /** Array of edges. */
  edges: Array<WebflowPostEdge>;
  /** Array of direct nodes. */
  nodes: Array<WebflowPost>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Represents WebflowPost connection edge. */
export type WebflowPostEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the WebflowPost record. */
  node: WebflowPost;
};

export type WhistleblowerCaseReportPdfResponse = {
  /** The password used to secure the PDF. */
  password: Scalars['String']['output'];
  /** A URL to PDF file uploaded to S3. */
  s3Url: Scalars['String']['output'];
};

/** Input type for XBRL generation */
export type XbrlGenerateInput = {
  /** Unique identifier for the taxonomy report used to generate XBRL file */
  reportUuid: Scalars['UUID']['input'];
};

export type Year = {
  /** Status of year. */
  status: Esg_Year_Status;
  uuid: Scalars['UUID']['output'];
  /** Year value. */
  year: Scalars['Int']['output'];
  /** Return year data state for tenant. */
  yearDataStatus?: Maybe<TenantYearDataState>;
};

/** Represents YearConnection connection. */
export type YearConnection = {
  /** Array of edges. */
  edges: Array<YearEdge>;
  /** Array of direct nodes. */
  nodes: Array<Year>;
  /** Paging information. */
  pageInfo: PageInfoV2;
  /** Total count of records. */
  totalCount: Scalars['Int']['output'];
};

/** Input to check year data status. */
export type YearDataStatusInput = {
  /** Given year uuid. */
  uuid: Scalars['UUID']['input'];
};

/** Represents Year connection edge. */
export type YearEdge = {
  /** Cursor for the node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Year record. */
  node: Year;
};

export type YearSortFields =
  | 'STATUS'
  | 'YEAR';

export type YearSortInput = {
  direction: SortDirection;
  field: YearSortFields;
};

/** Represents input for querying years. */
export type YearsConnectionInput = {
  /** Limit or page results. */
  paging?: InputMaybe<PagingInput>;
  /** Optional argument for scope years by status. */
  scope?: InputMaybe<Scalars['String']['input']>;
  /** Optional argument for years search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specify to sort results. */
  sorting?: InputMaybe<Array<YearSortInput>>;
};

export type AppVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type AppVersionQuery = { version?: string | null };

export type UpdateUserDetailsMutationVariables = Exact<{
  userDetailsInput: UserDetailsInput;
}>;


export type UpdateUserDetailsMutation = { updateUserDetails: { uuid?: string | null, contactEmail?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null } };

export type SendPortalSupportRequestMutationVariables = Exact<{
  input: PortalSupportRequestInput;
}>;


export type SendPortalSupportRequestMutation = { sent: boolean };

export type NotificationListQueryVariables = Exact<{
  filterInput?: InputMaybe<NotificationFilterInput>;
  orderInput?: InputMaybe<NotificationOrderInput>;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type NotificationListQuery = { listNotifications: { page: { edges?: Array<{ node: { uuid: string, channel: NotificationChannels, createdAt: Date, type?: NotificationTypes | null, payload: { data: { refUuid?: string | null, extra?: { disclosureUuid: string } | null }, notification: { body?: string | null, title?: string | null } }, readNotification?: Array<{ readAt?: Date | null }> | null } }> | null, info: { hasNextPage: boolean } } } };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  notificationsUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MarkNotificationsAsReadMutation = { notifications: Array<string> };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { notifications: Array<string> };

export type UpdateSingleNotificationFragment = { readNotification?: Array<{ readAt?: Date | null }> | null };

export type UpdatePersonalInfoMutationVariables = Exact<{
  userDetailsInput: UserDetailsInput;
}>;


export type UpdatePersonalInfoMutation = { updateUserDetails: { uuid?: string | null, country?: Country_Code | null, firstName?: string | null, lastName?: string | null, organizationEmail?: string | null, organizationName?: string | null, relationship?: TenantsUserRelationship | null } };

export type RespondentTypeQueryVariables = Exact<{
  disclosureUuid: Scalars['String']['input'];
}>;


export type RespondentTypeQuery = { details: { uuid: string, respondentType: Disclosure_Respondent_Type } };

export type ExchangeFirebaseTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ExchangeFirebaseTokenMutation = { exchangeFirebaseToken: { token: string } };

export type ChatTranslateMutationVariables = Exact<{
  input: TranslateInput;
}>;


export type ChatTranslateMutation = { translate: Array<string> };

export type ChatRoomFileUrlQueryVariables = Exact<{
  fileUuid: Scalars['String']['input'];
}>;


export type ChatRoomFileUrlQuery = { chatRoomFileInfo: { signedUrl: string } };

export type ChatRoomFileInfoQueryVariables = Exact<{
  fileUuid: Scalars['String']['input'];
}>;


export type ChatRoomFileInfoQuery = { chatRoomFileInfo: { uuid: string, chatRoomUuid: string, mimeType: string, name: string, s3Key: string, size?: number | null } };

export type GetSurveysDetailsQueryVariables = Exact<{
  detailsInput: SurveyDetailsInput;
}>;


export type GetSurveysDetailsQuery = { surveysDetails?: { uuid: string, description?: string | null, endDate?: Date | null, json: string, name: string } | null };

export type SurveyUserFillMutationVariables = Exact<{
  responseInput: SurveyResponseInput;
}>;


export type SurveyUserFillMutation = { surveyUserFill: { uuid: string } };

export type GetSurveysForUserQueryVariables = Exact<{
  input?: InputMaybe<SurveysConnectionInput>;
}>;


export type GetSurveysForUserQuery = { list: { totalCount: number, nodes: Array<{ endDate?: Date | null, name: string, status?: SurveyStatus | null, id: string }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, pageSize: number, startCursor?: string | null } } };

export type CheckIdNumberAndPinQueryVariables = Exact<{
  input: CaseReportDetailsInput;
}>;


export type CheckIdNumberAndPinQuery = { case: { caseId: string } };

export type CheckIdNumberAndPinUnloggedQueryVariables = Exact<{
  input: ReportCaseDetailsUnloggedInput;
}>;


export type CheckIdNumberAndPinUnloggedQuery = { case: { caseId: string } };

export type MfaResetRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type MfaResetRequestMutation = { success: boolean };

export type RequestPasswordResetMutationVariables = Exact<{
  passwordResetRequestInput: PasswordResetRequestInput;
}>;


export type RequestPasswordResetMutation = { success: boolean };

export type RequestMfaSetupMutationVariables = Exact<{
  input: RequestMfaSetupInput;
}>;


export type RequestMfaSetupMutation = { setup: { qrCode: string, secret: string } };

export type ConfirmMfaSetupMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type ConfirmMfaSetupMutation = { success: boolean };

export type ReportCasesQueryVariables = Exact<{
  input?: InputMaybe<CaseReportsInput>;
}>;


export type ReportCasesQuery = { list: { edges: Array<{ cursor: string, node: { uuid: string, caseId: string, chatRoomSecret?: string | null, createdAt: Date, isNewMessageFromAdmin: boolean, isStatusChanged: boolean, lastMessage?: string | null, lastMessageTranslated?: string | null, status: Case_Status } }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, pageSize: number, startCursor?: string | null } } };

export type ReportFileQueryVariables = Exact<{
  input: PresignedCaseFileInput;
}>;


export type ReportFileQuery = { file: { uuid: string, url: string } };

export type ReportCaseDetailsQueryVariables = Exact<{
  input: CaseReportDetailsInput;
  targetLanguage?: InputMaybe<LanguageCode>;
}>;


export type ReportCaseDetailsQuery = { case: { uuid: string, caseId: string, chatRoomSecret?: string | null, firebaseToken?: string | null, language: Language_Code, status: Case_Status, conversationMessages: Array<{ uuid: string, canEdit: boolean, isAssistant: boolean, order: number, text: string, textTranslated: string }>, files: Array<{ uuid: string, name: string, size?: number | null }> } };

export type ReportCaseDetailsUnloggedQueryVariables = Exact<{
  input: ReportCaseDetailsUnloggedInput;
  targetLanguage?: InputMaybe<LanguageCode>;
}>;


export type ReportCaseDetailsUnloggedQuery = { case: { uuid: string, caseId: string, chatRoomSecret?: string | null, firebaseToken?: string | null, language: Language_Code, status: Case_Status, conversationMessages: Array<{ uuid: string, canEdit: boolean, isAssistant: boolean, order: number, text: string, textTranslated: string }>, files: Array<{ uuid: string, name: string, size?: number | null, url: string }> } };

export type DisclosureFillMutationVariables = Exact<{
  responseInput: DisclosureResponseInput;
}>;


export type DisclosureFillMutation = { disclosure: { uuid: string } };

export type DisclosureUserListQueryVariables = Exact<{
  input?: InputMaybe<DisclosureUserConnectionInput>;
}>;


export type DisclosureUserListQuery = { list: { totalCount: number, edges: Array<{ node: { hasAnswered?: boolean | null, name: string, id: string } }> } };

export type FilledDisclosuresListQueryVariables = Exact<{
  input?: InputMaybe<DisclosureResponseConnectionInput>;
}>;


export type FilledDisclosuresListQuery = { list: { totalCount: number, nodes: Array<{ uuid: string, approvalStatus: Disclosure_Response_Approval_Status, chatRoomSecret?: string | null, submissionDate?: Date | null }> } };

export type DisclosureResponseDetailsQueryVariables = Exact<{
  responseUuid: Scalars['String']['input'];
}>;


export type DisclosureResponseDetailsQuery = { details: { approvalStatus: Disclosure_Response_Approval_Status, chatRoomSecret?: string | null, createdAt?: Date | null, disclosureJson?: string | null, json: string } };

export type InitFirebaseChatRoomMutationVariables = Exact<{
  refUuid: Scalars['String']['input'];
}>;


export type InitFirebaseChatRoomMutation = { initFirebaseChatRoom: { referenceType: ChatRoomReferenceType, referenceUuid: string, secret: string, status: ChatRoomStatus } };

export type FetchCaseReportPdfMutationVariables = Exact<{
  input: GetWhistleblowerCaseReportPdfInput;
}>;


export type FetchCaseReportPdfMutation = { casePdf: { password: string, s3Url: string } };

export type StartCaseReportMutationVariables = Exact<{
  input: CaseReportStartInput;
  targetLanguage: LanguageCode;
}>;


export type StartCaseReportMutation = { conversation: { isDescribed: boolean, nextSlotId?: number | null, uuid: string, assistantResponses: Array<string>, slotOptions?: Array<{ actionId: number, extraType: Slot_Type, type: Legacy_Slot_Type, text: string }> | null, progress: { stepLabelTranslated?: string | null, stepOrder?: number | null, stepsCount?: number | null } } };

export type CountryAnonymityValidateQueryVariables = Exact<{
  input: CountryAnonymityValidateInput;
}>;


export type CountryAnonymityValidateQuery = { isRestricted: boolean };

export type EditMessageMutationVariables = Exact<{
  input: CaseReportEditConversationInput;
  targetLanguage: LanguageCode;
}>;


export type EditMessageMutation = { message: Array<{ uuid: string, canEdit: boolean, isAssistant: boolean, order: number, text: string, textTranslated: string }> };

export type SendReportMessageMutationVariables = Exact<{
  input: ConversationUserResponseInput;
  targetLanguage: LanguageCode;
}>;


export type SendReportMessageMutation = { conversation: { isDescribed: boolean, nextSlotId?: number | null, uuid: string, assistantResponses: Array<string>, slotOptions?: Array<{ actionId: number, extraType: Slot_Type, type: Legacy_Slot_Type, text: string }> | null, progress: { stepLabelTranslated?: string | null, stepOrder?: number | null, stepsCount?: number | null } } };

export type DeleteFilesMutationVariables = Exact<{
  input: CaseFilesDeleteInput;
}>;


export type DeleteFilesMutation = { deleteFiles: Array<string> };

export type UploadFilesMutationVariables = Exact<{
  input: CaseFilesUploadInput;
}>;


export type UploadFilesMutation = { file: Array<{ uuid: string, name: string, size?: number | null }> };

export type RequestReporterEmailVerificationMutationVariables = Exact<{
  input: RequestReporterEmailVerificationInput;
}>;


export type RequestReporterEmailVerificationMutation = { request: { sent: boolean, expiresAt?: Date | null, cooldownSeconds: number } };

export type ConfirmReporterEmailVerificationMutationVariables = Exact<{
  input: ConfirmReporterEmailVerificationInput;
}>;


export type ConfirmReporterEmailVerificationMutation = { confirm: { verified: boolean, attemptsRemaining: number } };

export type SubsidiarySitesSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubsidiarySitesSettingsQuery = { tenant: { uuid: string, reportSettings?: { uuid: string, subsidiaryChoiceEnabled?: boolean | null, subsidiarySelectionCopy?: string | null } | null } };

export type CaseSummarizeMutationVariables = Exact<{
  input: CaseReportIdentifierInput;
  targetLanguage: LanguageCode;
}>;


export type CaseSummarizeMutation = { summary: { uuid: string, caseId: string, status: Case_Status, conversationMessages: Array<{ uuid: string, canEdit: boolean, isAssistant: boolean, order: number, text: string, textTranslated: string }>, files: Array<{ uuid: string, name: string, size?: number | null }> } };

export type UpdateRecoveryEmailMutationVariables = Exact<{
  input: UpdateRecoveryEmailInput;
}>;


export type UpdateRecoveryEmailMutation = { user: { uuid?: string | null, recoveryEmail?: string | null } };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { changePassword: { uuid?: string | null } };

export type BasicReportCaseFragment = { uuid: string, caseId: string, chatRoomSecret?: string | null, createdAt: Date, isNewMessageFromAdmin: boolean, isStatusChanged: boolean, lastMessage?: string | null, lastMessageTranslated?: string | null, status: Case_Status };

export type SubmittedCaseResponseFragment = { uuid: string, caseId: string };

export type SummarizeResponseFragment = { uuid: string, caseId: string, status: Case_Status, conversationMessages: Array<{ uuid: string, canEdit: boolean, isAssistant: boolean, order: number, text: string, textTranslated: string }>, files: Array<{ uuid: string, name: string, size?: number | null }> };

export type SlotOptionsFragment = { actionId: number, extraType: Slot_Type, type: Legacy_Slot_Type, text: string };

export type AssistantResponseFragment = { isDescribed: boolean, nextSlotId?: number | null, uuid: string, assistantResponses: Array<string>, progress: { stepLabelTranslated?: string | null, stepOrder?: number | null, stepsCount?: number | null } };

export type ConversationAssistantResponseFragment = { isDescribed: boolean, nextSlotId?: number | null, uuid: string, assistantResponses: Array<string>, progress: { stepLabelTranslated?: string | null, stepOrder?: number | null, stepsCount?: number | null }, slotOptions?: Array<{ actionId: number, extraType: Slot_Type, type: Legacy_Slot_Type, text: string }> | null };

export type MetadataFragment = { requireSetup: boolean, type: Mfa_Method_Type };

export type PageInfoFragment = { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, pageSize: number, startCursor?: string | null };

export type TenantNameFragment = { uuid: string, name: string };

export type TenantModulesFragment = { disclosures: boolean, surveys: boolean, cases: boolean, subsidiarySites: boolean };

export type CheckPasswordResetTokenMutationVariables = Exact<{
  input: CheckPasswordResetTokenInput;
}>;


export type CheckPasswordResetTokenMutation = { success: boolean };

export type CreateAccountMutationVariables = Exact<{
  input: SignUpRequestInput;
}>;


export type CreateAccountMutation = { tokens: { refreshToken?: string | null, sessionToken: string, metadata?: { requireSetup: boolean, type: string } | null } };

export type CreateGuestSessionMutationVariables = Exact<{
  input: LoginGuestInput;
}>;


export type CreateGuestSessionMutation = { tokens: { refreshToken?: string | null, sessionToken: string } };

export type CreateSessionMutationVariables = Exact<{
  input: LoginPasswordInput;
}>;


export type CreateSessionMutation = { tokens: { refreshToken?: string | null, sessionToken: string, metadata?: { requireSetup: boolean, type: Mfa_Method_Type } | null } };

export type LoginWithMfaMutationVariables = Exact<{
  input: LoginWithMfaInput;
}>;


export type LoginWithMfaMutation = { tokens: { refreshToken?: string | null, sessionToken: string, metadata?: { requireSetup: boolean, type: Mfa_Method_Type } | null } };

export type MfaResetConfirmMutationVariables = Exact<{
  mfaResetToken: Scalars['String']['input'];
}>;


export type MfaResetConfirmMutation = { success: boolean };

export type RefreshSessionTokenMutationVariables = Exact<{
  token: Scalars['JWT']['input'];
}>;


export type RefreshSessionTokenMutation = { refreshSession: { refreshToken?: string | null, sessionToken: string } };

export type CaseReportSubmitMutationVariables = Exact<{
  input: CaseReportSubmitInput;
}>;


export type CaseReportSubmitMutation = { newCase: { uuid: string, caseId: string } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { tokens: { refreshToken?: string | null, sessionToken: string, metadata?: { requireSetup: boolean, type: Mfa_Method_Type } | null } };

export type SetRecoveryEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SetRecoveryEmailMutation = { tokens: { refreshToken?: string | null, sessionToken: string } };

export type SkipMfaMutationVariables = Exact<{ [key: string]: never; }>;


export type SkipMfaMutation = { tokens: { refreshToken?: string | null, sessionToken: string } };

export type UpdateSettingsMutationVariables = Exact<{
  input: SessionUserSettingsUpdateInput;
}>;


export type UpdateSettingsMutation = { settings: { tokens: { refreshToken?: string | null, sessionToken: string }, user: { uuid?: string | null, country?: Country_Code | null, language?: UserAuthLanguage | null, relationship?: TenantsUserRelationship | null } } };

export type CaseReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type CaseReportsQuery = { caseReports: { statistics: { all: number, ongoing: number } } };

export type ChatRoomFilesUploadMutationVariables = Exact<{
  filesInput: ChatsFileUploadInput;
}>;


export type ChatRoomFilesUploadMutation = { chatRoomFilesUpload: Array<{ uuid: string, chatRoomUuid: string, mimeType: string, name: string, s3Key: string, signedUrl: string, size?: number | null }> };

export type CountryAnonymityEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryAnonymityEnabledQuery = { isEnabled: boolean };

export type DisclosureDetailsQueryVariables = Exact<{
  disclosureUuid: Scalars['String']['input'];
  withJson: Scalars['Boolean']['input'];
}>;


export type DisclosureDetailsQuery = { details: { uuid: string, canAnswer?: boolean | null, json?: string, name: string } };

export type GetTenantByCodeQueryVariables = Exact<{
  companyCode: Scalars['String']['input'];
}>;


export type GetTenantByCodeQuery = { tenant: { uuid: string, apiUrl: string, code: string, name: string } };

export type GetTenantByNameQueryVariables = Exact<{
  inputFilters: FindGlobalTenantDataByNameInput;
}>;


export type GetTenantByNameQuery = { tenant: Array<{ uuid: string, apiUrl: string, code: string, name: string }> };

export type GetTenantByMsTeamsIdQueryVariables = Exact<{
  microsoftTenantId: Scalars['String']['input'];
}>;


export type GetTenantByMsTeamsIdQuery = { tenant: { uuid: string, apiUrl: string, clusterId: ClusterIds, code: string, name: string } };

export type GlobalTenantDataByReportingSlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GlobalTenantDataByReportingSlugQuery = { tenant: { uuid: string, apiUrl: string, code: string, name: string, subsidiarySiteUuid?: string | null } };

export type TenantByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
  targetLanguage?: InputMaybe<LanguageCode>;
}>;


export type TenantByUuidQuery = { tenant: { uuid: string, code: string, logo?: string | null, name: string, headline?: string | null, homeContent: string, policiesContent: string, assetSettings: { uuid: string, nicoleAvatarUrl?: string | null, nicoleSetting: Nicole_Setting }, modules: { disclosures: boolean, surveys: boolean, cases: boolean, subsidiarySites: boolean } } };

export type TenantModulesByUuidQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type TenantModulesByUuidQuery = { tenant: { uuid: string, modules: { disclosures: boolean, surveys: boolean, cases: boolean, subsidiarySites: boolean } } };

export type TenantLogoQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type TenantLogoQuery = { tenant: { uuid: string, logo?: string | null } };

export type TenantMfaSettingsQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type TenantMfaSettingsQuery = { tenant: { uuid: string, enforceMfa: boolean } };

export type TenantAvatarQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type TenantAvatarQuery = { tenant: { uuid: string, assetSettings: { uuid: string, nicoleAvatarUrl?: string | null, nicoleSetting: Nicole_Setting } } };

export type UnreadNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationCountQuery = { amount: number };

export type ChatUserQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;


export type ChatUserQuery = { getUserByUuid: { firstName?: string | null, lastName?: string | null, name?: string | null } };

export type UserSessionQueryVariables = Exact<{
  isEngagementFeatureEnabled: Scalars['Boolean']['input'];
}>;


export type UserSessionQuery = { user: { uuid?: string | null, contactEmail?: string | null, country?: Country_Code | null, email?: string | null, firstName?: string | null, isPersonalInfoCompleted: boolean, language?: UserAuthLanguage | null, lastName?: string | null, name?: string | null, organizationEmail?: string | null, organizationName?: string | null, organizationRole?: string | null, phoneCountryPrefix?: string | null, phoneNonPrefixed?: string | null, phoneNumber?: string | null, recoveryEmail?: string | null, relationship?: TenantsUserRelationship | null, status: TenantsUserStatus, type: TenantsUserType, languageSelect: { key: string, label: string, value: string }, tenant?: { uuid: string, code: string, logo?: string | null, name: string, modules: { disclosures: boolean, surveys: boolean, cases: boolean, subsidiarySites: boolean } } | null } };

export type UserBasicQueryVariables = Exact<{
  isEngagementFeatureEnabled: Scalars['Boolean']['input'];
}>;


export type UserBasicQuery = { user: { uuid?: string | null, contactEmail?: string | null, country?: Country_Code | null, email?: string | null, firstName?: string | null, isPersonalInfoCompleted: boolean, language?: UserAuthLanguage | null, lastName?: string | null, name?: string | null, organizationEmail?: string | null, organizationName?: string | null, organizationRole?: string | null, phoneCountryPrefix?: string | null, phoneNonPrefixed?: string | null, phoneNumber?: string | null, relationship?: TenantsUserRelationship | null, type: TenantsUserType } };

export type UserCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCompanyQuery = { user: { uuid?: string | null, tenant?: { uuid: string, code: string, logo?: string | null, name: string } | null } };

export type UserModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserModulesQuery = { user: { uuid?: string | null, tenant?: { modules: { disclosures: boolean, surveys: boolean, cases: boolean, subsidiarySites: boolean } } | null } };

export type UserOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOptionsQuery = { user: { uuid?: string | null, country?: Country_Code | null, language?: UserAuthLanguage | null, recoveryEmail?: string | null, relationship?: TenantsUserRelationship | null, languageSelect: { key: string, label: string, value: string } } };

export type TranslationsQueryVariables = Exact<{
  targetLanguage: LanguageCode;
}>;


export type TranslationsQuery = { caseStatus: string, countries: string, translations: string, userRelationship: string };

export type SubsidiarySiteFromUrlQueryVariables = Exact<{
  input: SubsidiarySiteInput;
  tenantUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubsidiarySiteFromUrlQuery = { subsidiarySite?: { uuid?: string | null, isActive: boolean, isHeadquarters: boolean, name: string, reportingLabel?: string | null } | null };

export type SubsidiarySitesQueryVariables = Exact<{
  input?: InputMaybe<SubsidiarySitesConnectionInput>;
}>;


export type SubsidiarySitesQuery = { subsidiarySites: { nodes: Array<{ uuid?: string | null, isActive: boolean, isHeadquarters: boolean, name: string, reportingLabel?: string | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, pageSize: number, startCursor?: string | null } } };

export type SurveysStatisticsQueryVariables = Exact<{
  excludedUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SurveysStatisticsQuery = { statistics: { totalCount?: number | null } };

export type IncidentTypesListQueryVariables = Exact<{
  targetLanguage: LanguageCode;
}>;


export type IncidentTypesListQuery = { tenant: { uuid: string, incidentTypes: Array<{ uuid: string, description: string, name: string }> } };

export type TenantModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantModulesQuery = { tenant: { uuid: string, modules: { disclosures: boolean, surveys: boolean, cases: boolean, subsidiarySites: boolean } } };

export type CompanyInformationQueryVariables = Exact<{
  targetLanguage?: InputMaybe<LanguageCode>;
}>;


export type CompanyInformationQuery = { tenant: { uuid: string, logo?: string | null, name: string, headline?: string | null, homeContent: string, policiesContent: string, assetSettings: { uuid: string, nicoleAvatarUrl?: string | null, nicoleSetting: Nicole_Setting } } };

export type CaseOwnerExclusionQueryVariables = Exact<{
  input?: InputMaybe<CaseOwnerExclusionGetByBusinessUnitInput>;
}>;


export type CaseOwnerExclusionQuery = { tenant: { uuid: string, caseOwnerExclusion?: { uuid: string, excludableUsers: Array<{ uuid?: string | null, email?: string | null, name?: string | null }>, fallbackUser: { uuid?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, name?: string | null } } | null } };

export type DisclosuresStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type DisclosuresStatisticsQuery = { statistics: { availableDisclosures: number, responsesCount?: number | null } };

export const UpdateSingleNotificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpdateSingleNotification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readAt"}}]}}]}}]} as unknown as DocumentNode<UpdateSingleNotificationFragment, unknown>;
export const BasicReportCaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicReportCase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomSecret"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isNewMessageFromAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isStatusChanged"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessage"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageTranslated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<BasicReportCaseFragment, unknown>;
export const SubmittedCaseResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubmittedCaseResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportSubmit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]} as unknown as DocumentNode<SubmittedCaseResponseFragment, unknown>;
export const SummarizeResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummarizeResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportSummaryResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<SummarizeResponseFragment, unknown>;
export const SlotOptionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SlotOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationActionSlot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"extraType"}},{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<SlotOptionsFragment, unknown>;
export const AssistantResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistantResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationAssistantResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"caseUuid"}},{"kind":"Field","alias":{"kind":"Name","value":"assistantResponses"},"name":{"kind":"Name","value":"assistantResponsesTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"isDescribed"}},{"kind":"Field","name":{"kind":"Name","value":"nextSlotId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepLabelTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"stepOrder"}},{"kind":"Field","name":{"kind":"Name","value":"stepsCount"}}]}}]}}]} as unknown as DocumentNode<AssistantResponseFragment, unknown>;
export const ConversationAssistantResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversationAssistantResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationAssistantResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"caseUuid"}},{"kind":"Field","alias":{"kind":"Name","value":"assistantResponses"},"name":{"kind":"Name","value":"assistantResponsesTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"isDescribed"}},{"kind":"Field","name":{"kind":"Name","value":"nextSlotId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepLabelTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"stepOrder"}},{"kind":"Field","name":{"kind":"Name","value":"stepsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slotOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"extraType"}},{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ConversationAssistantResponseFragment, unknown>;
export const MetadataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mfa"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireSetup"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<MetadataFragment, unknown>;
export const PageInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfoV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]} as unknown as DocumentNode<PageInfoFragment, unknown>;
export const TenantNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantBaseDataType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<TenantNameFragment, unknown>;
export const TenantModulesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantModules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantModuleSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cases"},"name":{"kind":"Name","value":"CASES"}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"}},{"kind":"Field","alias":{"kind":"Name","value":"subsidiarySites"},"name":{"kind":"Name","value":"SUBSIDIARY_SITES"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"}}]}}]} as unknown as DocumentNode<TenantModulesFragment, unknown>;
export const AppVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"version"},"name":{"kind":"Name","value":"appVersion"}}]}}]} as unknown as DocumentNode<AppVersionQuery, AppVersionQueryVariables>;
export const UpdateUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userDetailsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userDetailsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userDetailsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]} as unknown as DocumentNode<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const SendPortalSupportRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPortalSupportRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PortalSupportRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sent"},"name":{"kind":"Name","value":"sendPortalSupportRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendPortalSupportRequestMutation, SendPortalSupportRequestMutationVariables>;
export const NotificationListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrderInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paginationInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"paginationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paginationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extra"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DisclosureChatNotificationExtra"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disclosureUuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"refUuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"readNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationListQuery, NotificationListQueryVariables>;
export const MarkNotificationsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationsAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationsUuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"notifications"},"name":{"kind":"Name","value":"markNotificationsAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationUuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationsUuids"}}}]}]}}]} as unknown as DocumentNode<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAllNotificationsAsRead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"notifications"},"name":{"kind":"Name","value":"markAllNotificationsAsRead"}}]}}]} as unknown as DocumentNode<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const UpdatePersonalInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonalInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userDetailsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userDetailsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userDetailsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}}]}}]} as unknown as DocumentNode<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;
export const RespondentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RespondentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disclosureUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"details"},"name":{"kind":"Name","value":"disclosureDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"disclosureUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disclosureUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"respondentType"}}]}}]}}]} as unknown as DocumentNode<RespondentTypeQuery, RespondentTypeQueryVariables>;
export const ExchangeFirebaseTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExchangeFirebaseToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"exchangeFirebaseToken"},"name":{"kind":"Name","value":"getFirebaseToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<ExchangeFirebaseTokenMutation, ExchangeFirebaseTokenMutationVariables>;
export const ChatTranslateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChatTranslate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TranslateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChatTranslateMutation, ChatTranslateMutationVariables>;
export const ChatRoomFileUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatRoomFileUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatRoomFileInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]} as unknown as DocumentNode<ChatRoomFileUrlQuery, ChatRoomFileUrlQueryVariables>;
export const ChatRoomFileInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatRoomFileInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatRoomFileInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomUuid"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]} as unknown as DocumentNode<ChatRoomFileInfoQuery, ChatRoomFileInfoQueryVariables>;
export const GetSurveysDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveysDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"detailsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveysDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"detailsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"detailsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSurveysDetailsQuery, GetSurveysDetailsQueryVariables>;
export const SurveyUserFillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SurveyUserFill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveyResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyUserFill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"responseInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<SurveyUserFillMutation, SurveyUserFillMutationVariables>;
export const GetSurveysForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSurveysForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SurveysConnectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list"},"name":{"kind":"Name","value":"surveyUserListV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfoV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]} as unknown as DocumentNode<GetSurveysForUserQuery, GetSurveysForUserQueryVariables>;
export const CheckIdNumberAndPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckIdNumberAndPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"case"},"name":{"kind":"Name","value":"reportCaseDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]}}]} as unknown as DocumentNode<CheckIdNumberAndPinQuery, CheckIdNumberAndPinQueryVariables>;
export const CheckIdNumberAndPinUnloggedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckIdNumberAndPinUnlogged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCaseDetailsUnloggedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"case"},"name":{"kind":"Name","value":"reportCaseDetailsUnlogged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]}}]} as unknown as DocumentNode<CheckIdNumberAndPinUnloggedQuery, CheckIdNumberAndPinUnloggedQueryVariables>;
export const MfaResetRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MfaResetRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"success"},"name":{"kind":"Name","value":"mfaResetRequest"}}]}}]} as unknown as DocumentNode<MfaResetRequestMutation, MfaResetRequestMutationVariables>;
export const RequestPasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passwordResetRequestInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PasswordResetRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"success"},"name":{"kind":"Name","value":"requestPasswordReset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"passwordResetRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passwordResetRequestInput"}}}]}]}}]} as unknown as DocumentNode<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const RequestMfaSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestMfaSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestMfaSetupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"setup"},"name":{"kind":"Name","value":"requestMfaSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qrCode"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}}]} as unknown as DocumentNode<RequestMfaSetupMutation, RequestMfaSetupMutationVariables>;
export const ConfirmMfaSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmMfaSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"success"},"name":{"kind":"Name","value":"confirmMfaSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ConfirmMfaSetupMutation, ConfirmMfaSetupMutationVariables>;
export const ReportCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportCases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list"},"name":{"kind":"Name","value":"reportCases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicReportCase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicReportCase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReport"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomSecret"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isNewMessageFromAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isStatusChanged"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessage"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageTranslated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfoV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]} as unknown as DocumentNode<ReportCasesQuery, ReportCasesQueryVariables>;
export const ReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresignedCaseFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"file"},"name":{"kind":"Name","value":"reportPresignedCaseFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ReportFileQuery, ReportFileQueryVariables>;
export const ReportCaseDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportCaseDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"case"},"name":{"kind":"Name","value":"reportCaseDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomSecret"}},{"kind":"Field","name":{"kind":"Name","value":"conversationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firebaseToken"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ReportCaseDetailsQuery, ReportCaseDetailsQueryVariables>;
export const ReportCaseDetailsUnloggedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportCaseDetailsUnlogged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCaseDetailsUnloggedInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"case"},"name":{"kind":"Name","value":"reportCaseDetailsUnlogged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomSecret"}},{"kind":"Field","name":{"kind":"Name","value":"conversationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firebaseToken"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ReportCaseDetailsUnloggedQuery, ReportCaseDetailsUnloggedQueryVariables>;
export const DisclosureFillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisclosureFill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisclosureResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"disclosure"},"name":{"kind":"Name","value":"disclosureUserFill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"responseInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<DisclosureFillMutation, DisclosureFillMutationVariables>;
export const DisclosureUserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisclosureUserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DisclosureUserConnectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list"},"name":{"kind":"Name","value":"disclosureUserListV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"hasAnswered"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DisclosureUserListQuery, DisclosureUserListQueryVariables>;
export const FilledDisclosuresListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilledDisclosuresList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DisclosureResponseConnectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list"},"name":{"kind":"Name","value":"disclosureEmployeeUserResponseListV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"approvalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomSecret"}},{"kind":"Field","alias":{"kind":"Name","value":"submissionDate"},"name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FilledDisclosuresListQuery, FilledDisclosuresListQueryVariables>;
export const DisclosureResponseDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisclosureResponseDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"details"},"name":{"kind":"Name","value":"disclosureResponseDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"responseUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomSecret"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"disclosureJson"}},{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<DisclosureResponseDetailsQuery, DisclosureResponseDetailsQueryVariables>;
export const InitFirebaseChatRoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitFirebaseChatRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initFirebaseChatRoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceType"}},{"kind":"Field","name":{"kind":"Name","value":"referenceUuid"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<InitFirebaseChatRoomMutation, InitFirebaseChatRoomMutationVariables>;
export const FetchCaseReportPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FetchCaseReportPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetWhistleblowerCaseReportPdfInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"casePdf"},"name":{"kind":"Name","value":"fetchWhistleblowerCaseReportPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"s3Url"}}]}}]}}]} as unknown as DocumentNode<FetchCaseReportPdfMutation, FetchCaseReportPdfMutationVariables>;
export const StartCaseReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartCaseReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportStartInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"conversation"},"name":{"kind":"Name","value":"reportCaseStart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssistantResponse"}},{"kind":"Field","name":{"kind":"Name","value":"slotOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SlotOptions"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistantResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationAssistantResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"caseUuid"}},{"kind":"Field","alias":{"kind":"Name","value":"assistantResponses"},"name":{"kind":"Name","value":"assistantResponsesTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"isDescribed"}},{"kind":"Field","name":{"kind":"Name","value":"nextSlotId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepLabelTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"stepOrder"}},{"kind":"Field","name":{"kind":"Name","value":"stepsCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SlotOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationActionSlot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"extraType"}},{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<StartCaseReportMutation, StartCaseReportMutationVariables>;
export const CountryAnonymityValidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountryAnonymityValidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryAnonymityValidateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isRestricted"},"name":{"kind":"Name","value":"countryAnonymityValidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CountryAnonymityValidateQuery, CountryAnonymityValidateQueryVariables>;
export const EditMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportEditConversationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"message"},"name":{"kind":"Name","value":"reportEditConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}}]}}]} as unknown as DocumentNode<EditMessageMutation, EditMessageMutationVariables>;
export const SendReportMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendReportMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationUserResponseInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"conversation"},"name":{"kind":"Name","value":"sendConversationMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssistantResponse"}},{"kind":"Field","name":{"kind":"Name","value":"slotOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SlotOptions"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistantResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationAssistantResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uuid"},"name":{"kind":"Name","value":"caseUuid"}},{"kind":"Field","alias":{"kind":"Name","value":"assistantResponses"},"name":{"kind":"Name","value":"assistantResponsesTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"isDescribed"}},{"kind":"Field","name":{"kind":"Name","value":"nextSlotId"}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepLabelTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"stepOrder"}},{"kind":"Field","name":{"kind":"Name","value":"stepsCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SlotOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationActionSlot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"extraType"}},{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<SendReportMessageMutation, SendReportMessageMutationVariables>;
export const DeleteFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseFilesDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteFiles"},"name":{"kind":"Name","value":"reportDeleteCaseFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const UploadFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseFilesUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"file"},"name":{"kind":"Name","value":"reportCaseFilesUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]} as unknown as DocumentNode<UploadFilesMutation, UploadFilesMutationVariables>;
export const RequestReporterEmailVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestReporterEmailVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestReporterEmailVerificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"request"},"name":{"kind":"Name","value":"requestReporterEmailVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"cooldownSeconds"}}]}}]}}]} as unknown as DocumentNode<RequestReporterEmailVerificationMutation, RequestReporterEmailVerificationMutationVariables>;
export const ConfirmReporterEmailVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmReporterEmailVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmReporterEmailVerificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"confirm"},"name":{"kind":"Name","value":"confirmReporterEmailVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"attemptsRemaining"}}]}}]}}]} as unknown as DocumentNode<ConfirmReporterEmailVerificationMutation, ConfirmReporterEmailVerificationMutationVariables>;
export const SubsidiarySitesSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidiarySitesSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"reportSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryChoiceEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiarySelectionCopy"}}]}}]}}]}}]} as unknown as DocumentNode<SubsidiarySitesSettingsQuery, SubsidiarySitesSettingsQueryVariables>;
export const CaseSummarizeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CaseSummarize"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportIdentifierInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"summary"},"name":{"kind":"Name","value":"reportCaseSummarize"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}},{"kind":"Field","name":{"kind":"Name","value":"conversationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isAssistant"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CaseSummarizeMutation, CaseSummarizeMutationVariables>;
export const UpdateRecoveryEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRecoveryEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRecoveryEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"updateRecoveryEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"recoveryEmail"}}]}}]}}]} as unknown as DocumentNode<UpdateRecoveryEmailMutation, UpdateRecoveryEmailMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"changePasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CheckPasswordResetTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckPasswordResetToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPasswordResetTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"success"},"name":{"kind":"Name","value":"checkPasswordResetToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checkPasswordResetTokenInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CheckPasswordResetTokenMutation, CheckPasswordResetTokenMutationVariables>;
export const CreateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignUpRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"createEmployeeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"signUpRequestInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireSetup"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreateGuestSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGuestSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginGuestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"loginGuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<CreateGuestSessionMutation, CreateGuestSessionMutationVariables>;
export const CreateSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"loginPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"mfa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Metadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Mfa"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireSetup"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<CreateSessionMutation, CreateSessionMutationVariables>;
export const LoginWithMfaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWithMfa"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginWithMfaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"loginWithMfa"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireSetup"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<LoginWithMfaMutation, LoginWithMfaMutationVariables>;
export const MfaResetConfirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MfaResetConfirm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mfaResetToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"success"},"name":{"kind":"Name","value":"mfaResetConfirm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mfaResetToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mfaResetToken"}}}]}]}}]} as unknown as DocumentNode<MfaResetConfirmMutation, MfaResetConfirmMutationVariables>;
export const RefreshSessionTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshSessionToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JWT"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<RefreshSessionTokenMutation, RefreshSessionTokenMutationVariables>;
export const CaseReportSubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CaseReportSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseReportSubmitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"newCase"},"name":{"kind":"Name","value":"reportCaseSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]}}]} as unknown as DocumentNode<CaseReportSubmitMutation, CaseReportSubmitMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resetPasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requireSetup"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetRecoveryEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetRecoveryEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"setRecoveryEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mfaRecoveryEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<SetRecoveryEmailMutation, SetRecoveryEmailMutationVariables>;
export const SkipMfaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SkipMfa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tokens"},"name":{"kind":"Name","value":"skipMfa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<SkipMfaMutation, SkipMfaMutationVariables>;
export const UpdateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionUserSettingsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"settings"},"name":{"kind":"Name","value":"updateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const CaseReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CaseReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"all"}},{"kind":"Field","name":{"kind":"Name","value":"ongoing"}}]}}]}}]}}]} as unknown as DocumentNode<CaseReportsQuery, CaseReportsQueryVariables>;
export const ChatRoomFilesUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChatRoomFilesUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatsFileUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatRoomFilesUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filesInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"chatRoomUuid"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]} as unknown as DocumentNode<ChatRoomFilesUploadMutation, ChatRoomFilesUploadMutationVariables>;
export const CountryAnonymityEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountryAnonymityEnabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isEnabled"},"name":{"kind":"Name","value":"countryAnonymityEnabled"}}]}}]} as unknown as DocumentNode<CountryAnonymityEnabledQuery, CountryAnonymityEnabledQueryVariables>;
export const DisclosureDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisclosureDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disclosureUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withJson"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"details"},"name":{"kind":"Name","value":"disclosureDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"disclosureUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disclosureUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"canAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"json"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withJson"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DisclosureDetailsQuery, DisclosureDetailsQueryVariables>;
export const GetTenantByCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantByCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"findGlobalTenantDataByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"apiUrl"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTenantByCodeQuery, GetTenantByCodeQueryVariables>;
export const GetTenantByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FindGlobalTenantDataByNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"findGlobalTenantDataByName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inputFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"apiUrl"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTenantByNameQuery, GetTenantByNameQueryVariables>;
export const GetTenantByMsTeamsIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantByMSTeamsId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"microsoftTenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getGlobalTenantDataByMicrosoftTenantId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"microsoftTenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"microsoftTenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"apiUrl"}},{"kind":"Field","name":{"kind":"Name","value":"clusterId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTenantByMsTeamsIdQuery, GetTenantByMsTeamsIdQueryVariables>;
export const GlobalTenantDataByReportingSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalTenantDataByReportingSlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getGlobalTenantDataByReportingSlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"apiUrl"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiarySiteUuid"}}]}}]}}]} as unknown as DocumentNode<GlobalTenantDataByReportingSlugQuery, GlobalTenantDataByReportingSlugQueryVariables>;
export const TenantByUuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantByUuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getTenantByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"assetSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"nicoleAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nicoleSetting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","alias":{"kind":"Name","value":"headline"},"name":{"kind":"Name","value":"headlineTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"homeContent"},"name":{"kind":"Name","value":"homeContentTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantModules"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"policiesContent"},"name":{"kind":"Name","value":"policiesContentTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantModules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantModuleSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cases"},"name":{"kind":"Name","value":"CASES"}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"}},{"kind":"Field","alias":{"kind":"Name","value":"subsidiarySites"},"name":{"kind":"Name","value":"SUBSIDIARY_SITES"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"}}]}}]} as unknown as DocumentNode<TenantByUuidQuery, TenantByUuidQueryVariables>;
export const TenantModulesByUuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantModulesByUuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getTenantByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantModules"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantModules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantModuleSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cases"},"name":{"kind":"Name","value":"CASES"}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"}},{"kind":"Field","alias":{"kind":"Name","value":"subsidiarySites"},"name":{"kind":"Name","value":"SUBSIDIARY_SITES"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"}}]}}]} as unknown as DocumentNode<TenantModulesByUuidQuery, TenantModulesByUuidQueryVariables>;
export const TenantLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getTenantByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<TenantLogoQuery, TenantLogoQueryVariables>;
export const TenantMfaSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantMfaSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getTenantByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"enforceMfa"}}]}}]}}]} as unknown as DocumentNode<TenantMfaSettingsQuery, TenantMfaSettingsQueryVariables>;
export const TenantAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tenant"},"name":{"kind":"Name","value":"getTenantByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"assetSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"nicoleAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nicoleSetting"}}]}}]}}]}}]} as unknown as DocumentNode<TenantAvatarQuery, TenantAvatarQueryVariables>;
export const UnreadNotificationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnreadNotificationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"amount"},"name":{"kind":"Name","value":"getUnreadNotificationCount"}}]}}]} as unknown as DocumentNode<UnreadNotificationCountQuery, UnreadNotificationCountQueryVariables>;
export const ChatUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserByUuid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ChatUserQuery, ChatUserQueryVariables>;
export const UserSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEngagementFeatureEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"isPersonalInfoCompleted"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"languageSelect"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEngagementFeatureEnabled"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"organizationName"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEngagementFeatureEnabled"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryPrefix"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"phoneNonPrefixed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"recoveryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantModules"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantModules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantModuleSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cases"},"name":{"kind":"Name","value":"CASES"}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"}},{"kind":"Field","alias":{"kind":"Name","value":"subsidiarySites"},"name":{"kind":"Name","value":"SUBSIDIARY_SITES"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"}}]}}]} as unknown as DocumentNode<UserSessionQuery, UserSessionQueryVariables>;
export const UserBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEngagementFeatureEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"isPersonalInfoCompleted"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEngagementFeatureEnabled"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"organizationName"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEngagementFeatureEnabled"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"organizationRole"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryPrefix"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"phoneNonPrefixed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UserBasicQuery, UserBasicQueryVariables>;
export const UserCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompanyQuery, UserCompanyQueryVariables>;
export const UserModulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserModules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantModules"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantModules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantModuleSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cases"},"name":{"kind":"Name","value":"CASES"}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"}},{"kind":"Field","alias":{"kind":"Name","value":"subsidiarySites"},"name":{"kind":"Name","value":"SUBSIDIARY_SITES"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"}}]}}]} as unknown as DocumentNode<UserModulesQuery, UserModulesQueryVariables>;
export const UserOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"languageSelect"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recoveryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}}]}}]} as unknown as DocumentNode<UserOptionsQuery, UserOptionsQueryVariables>;
export const TranslationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Translations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"caseStatus"},"name":{"kind":"Name","value":"dictionaryTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dictionaryType"},"value":{"kind":"EnumValue","value":"CASE_STATUS"}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"countries"},"name":{"kind":"Name","value":"dictionaryTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dictionaryType"},"value":{"kind":"EnumValue","value":"COUNTRIES"}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"translations"},"name":{"kind":"Name","value":"staticTranslations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"WEBPORTAL"}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"userRelationship"},"name":{"kind":"Name","value":"dictionaryTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dictionaryType"},"value":{"kind":"EnumValue","value":"USER_RELATIONSHIP"}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}}]} as unknown as DocumentNode<TranslationsQuery, TranslationsQueryVariables>;
export const SubsidiarySiteFromUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidiarySiteFromUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubsidiarySiteInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantUuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidiarySite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadquarters"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reportingLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantUuid"}}}]}]}}]}}]} as unknown as DocumentNode<SubsidiarySiteFromUrlQuery, SubsidiarySiteFromUrlQueryVariables>;
export const SubsidiarySitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubsidiarySites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubsidiarySitesConnectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidiarySites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadquarters"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reportingLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfoV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}}]} as unknown as DocumentNode<SubsidiarySitesQuery, SubsidiarySitesQueryVariables>;
export const SurveysStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveysStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedUuids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"statistics"},"name":{"kind":"Name","value":"surveyUserList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"excludedUuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedUuids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SurveysStatisticsQuery, SurveysStatisticsQueryVariables>;
export const IncidentTypesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IncidentTypesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"incidentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","alias":{"kind":"Name","value":"description"},"name":{"kind":"Name","value":"descriptionTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"nameTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}}]}}]}}]} as unknown as DocumentNode<IncidentTypesListQuery, IncidentTypesListQueryVariables>;
export const TenantModulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantModules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantModules"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantModules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantModuleSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cases"},"name":{"kind":"Name","value":"CASES"}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"}},{"kind":"Field","alias":{"kind":"Name","value":"subsidiarySites"},"name":{"kind":"Name","value":"SUBSIDIARY_SITES"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"}}]}}]} as unknown as DocumentNode<TenantModulesQuery, TenantModulesQueryVariables>;
export const CompanyInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"assetSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"nicoleAvatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nicoleSetting"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"headline"},"name":{"kind":"Name","value":"headlineTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"homeContent"},"name":{"kind":"Name","value":"homeContentTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"policiesContent"},"name":{"kind":"Name","value":"policiesContentTranslated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"targetLanguage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetLanguage"}}}]}}]}]}}]}}]} as unknown as DocumentNode<CompanyInformationQuery, CompanyInformationQueryVariables>;
export const CaseOwnerExclusionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CaseOwnerExclusion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseOwnerExclusionGetByBusinessUnitInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"caseOwnerExclusion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"excludableUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fallbackUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CaseOwnerExclusionQuery, CaseOwnerExclusionQueryVariables>;
export const DisclosuresStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisclosuresStatistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"statistics"},"name":{"kind":"Name","value":"userDisclosureStatistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableDisclosures"}},{"kind":"Field","name":{"kind":"Name","value":"responsesCount"}}]}}]}}]} as unknown as DocumentNode<DisclosuresStatisticsQuery, DisclosuresStatisticsQueryVariables>;
export const OPERATIONS = {
  Query: {
    AppVersion: 'AppVersion',
    NotificationList: 'NotificationList',
    RespondentType: 'RespondentType',
    ChatRoomFileUrl: 'ChatRoomFileUrl',
    ChatRoomFileInfo: 'ChatRoomFileInfo',
    GetSurveysDetails: 'GetSurveysDetails',
    GetSurveysForUser: 'GetSurveysForUser',
    CheckIdNumberAndPin: 'CheckIdNumberAndPin',
    CheckIdNumberAndPinUnlogged: 'CheckIdNumberAndPinUnlogged',
    ReportCases: 'ReportCases',
    ReportFile: 'ReportFile',
    ReportCaseDetails: 'ReportCaseDetails',
    ReportCaseDetailsUnlogged: 'ReportCaseDetailsUnlogged',
    DisclosureUserList: 'DisclosureUserList',
    FilledDisclosuresList: 'FilledDisclosuresList',
    DisclosureResponseDetails: 'DisclosureResponseDetails',
    CountryAnonymityValidate: 'CountryAnonymityValidate',
    SubsidiarySitesSettings: 'SubsidiarySitesSettings',
    CaseReports: 'CaseReports',
    CountryAnonymityEnabled: 'CountryAnonymityEnabled',
    DisclosureDetails: 'DisclosureDetails',
    GetTenantByCode: 'GetTenantByCode',
    GetTenantByName: 'GetTenantByName',
    GetTenantByMSTeamsId: 'GetTenantByMSTeamsId',
    GlobalTenantDataByReportingSlug: 'GlobalTenantDataByReportingSlug',
    TenantByUuid: 'TenantByUuid',
    TenantModulesByUuid: 'TenantModulesByUuid',
    TenantLogo: 'TenantLogo',
    TenantMfaSettings: 'TenantMfaSettings',
    TenantAvatar: 'TenantAvatar',
    UnreadNotificationCount: 'UnreadNotificationCount',
    ChatUser: 'ChatUser',
    UserSession: 'UserSession',
    UserBasic: 'UserBasic',
    UserCompany: 'UserCompany',
    UserModules: 'UserModules',
    UserOptions: 'UserOptions',
    Translations: 'Translations',
    SubsidiarySiteFromUrl: 'SubsidiarySiteFromUrl',
    SubsidiarySites: 'SubsidiarySites',
    SurveysStatistics: 'SurveysStatistics',
    IncidentTypesList: 'IncidentTypesList',
    TenantModules: 'TenantModules',
    CompanyInformation: 'CompanyInformation',
    CaseOwnerExclusion: 'CaseOwnerExclusion',
    DisclosuresStatistics: 'DisclosuresStatistics'
  },
  Mutation: {
    UpdateUserDetails: 'UpdateUserDetails',
    SendPortalSupportRequest: 'SendPortalSupportRequest',
    MarkNotificationsAsRead: 'MarkNotificationsAsRead',
    MarkAllNotificationsAsRead: 'MarkAllNotificationsAsRead',
    UpdatePersonalInfo: 'UpdatePersonalInfo',
    ExchangeFirebaseToken: 'ExchangeFirebaseToken',
    ChatTranslate: 'ChatTranslate',
    SurveyUserFill: 'SurveyUserFill',
    MfaResetRequest: 'MfaResetRequest',
    RequestPasswordReset: 'RequestPasswordReset',
    RequestMfaSetup: 'RequestMfaSetup',
    ConfirmMfaSetup: 'ConfirmMfaSetup',
    DisclosureFill: 'DisclosureFill',
    InitFirebaseChatRoom: 'InitFirebaseChatRoom',
    FetchCaseReportPdf: 'FetchCaseReportPdf',
    StartCaseReport: 'StartCaseReport',
    EditMessage: 'EditMessage',
    SendReportMessage: 'SendReportMessage',
    DeleteFiles: 'DeleteFiles',
    UploadFiles: 'UploadFiles',
    RequestReporterEmailVerification: 'RequestReporterEmailVerification',
    ConfirmReporterEmailVerification: 'ConfirmReporterEmailVerification',
    CaseSummarize: 'CaseSummarize',
    UpdateRecoveryEmail: 'UpdateRecoveryEmail',
    ChangePassword: 'ChangePassword',
    CheckPasswordResetToken: 'CheckPasswordResetToken',
    CreateAccount: 'CreateAccount',
    CreateGuestSession: 'CreateGuestSession',
    CreateSession: 'CreateSession',
    LoginWithMfa: 'LoginWithMfa',
    MfaResetConfirm: 'MfaResetConfirm',
    RefreshSessionToken: 'RefreshSessionToken',
    CaseReportSubmit: 'CaseReportSubmit',
    ResetPassword: 'ResetPassword',
    SetRecoveryEmail: 'SetRecoveryEmail',
    SkipMfa: 'SkipMfa',
    UpdateSettings: 'UpdateSettings',
    ChatRoomFilesUpload: 'ChatRoomFilesUpload'
  },
  Fragment: {
    UpdateSingleNotification: 'UpdateSingleNotification',
    BasicReportCase: 'BasicReportCase',
    SubmittedCaseResponse: 'SubmittedCaseResponse',
    SummarizeResponse: 'SummarizeResponse',
    SlotOptions: 'SlotOptions',
    AssistantResponse: 'AssistantResponse',
    ConversationAssistantResponse: 'ConversationAssistantResponse',
    Metadata: 'Metadata',
    PageInfo: 'PageInfo',
    TenantName: 'TenantName',
    TenantModules: 'TenantModules'
  }
}
export type AdminContextTokensKeySpecifier = ('refreshToken' | 'sessionToken' | AdminContextTokensKeySpecifier)[];
export type AdminContextTokensFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantDataKeySpecifier = ('adminActiveStatus' | 'apiUrl' | 'assistantCredentials' | 'clusterId' | 'code' | 'country' | 'customPlan' | 'elineNumbers' | 'forwardEarthCredentials' | 'licensesCount' | 'modules' | 'name' | 'primaryContact' | 'primaryContactEmail' | 'primaryContactFirstName' | 'primaryContactLastName' | 'primaryContactName' | 'region' | 'reportingSlug' | 'standards' | 'status' | 'subscription' | 'subscriptionExpire' | 'subscriptionStart' | 'tenantAdminUuid' | 'uuid' | AdminTenantDataKeySpecifier)[];
export type AdminTenantDataFieldPolicy = {
	adminActiveStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	apiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	customPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	licensesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContact?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactName?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscription?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionExpire?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionStart?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantDataConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AdminTenantDataConnectionKeySpecifier)[];
export type AdminTenantDataConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantDataEdgeKeySpecifier = ('cursor' | 'node' | AdminTenantDataEdgeKeySpecifier)[];
export type AdminTenantDataEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantModuleSettingsKeySpecifier = ('moduleCarbonLensEnabled' | 'moduleCasesEnabled' | 'moduleDemoEnabled' | 'moduleDisclosuresEnabled' | 'moduleInsightsEnabled' | 'moduleNicoleGptEnabled' | 'moduleSsoEnabled' | 'moduleSurveysEnabled' | 'moduleTasksEnabled' | 'moduleTeamsEnabled' | 'moduleTrainingsEnabled' | 'subscriberEmail' | 'teamsTenantId' | 'tenant' | 'tenantUuid' | AdminTenantModuleSettingsKeySpecifier)[];
export type AdminTenantModuleSettingsFieldPolicy = {
	moduleCarbonLensEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleCasesEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleDemoEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleDisclosuresEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleInsightsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleNicoleGptEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleSsoEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleSurveysEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleTasksEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleTeamsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleTrainingsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	teamsTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantSubscriptionKeySpecifier = ('autoRenew' | 'end' | 'inactiveChangeDate' | 'licenseCount' | 'limitedLicenseCount' | 'nonRenewalNotice' | 'plan' | 'renewalTermYears' | 'standardLicenseCount' | 'start' | 'status' | 'subscriberEmail' | 'switchedOffAt' | 'toBeDeletedAt' | AdminTenantSubscriptionKeySpecifier)[];
export type AdminTenantSubscriptionFieldPolicy = {
	autoRenew?: FieldPolicy<any> | FieldReadFunction<any>,
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveChangeDate?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	limitedLicenseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	nonRenewalNotice?: FieldPolicy<any> | FieldReadFunction<any>,
	plan?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalTermYears?: FieldPolicy<any> | FieldReadFunction<any>,
	standardLicenseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	switchedOffAt?: FieldPolicy<any> | FieldReadFunction<any>,
	toBeDeletedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminUserDataKeySpecifier = ('email' | 'firstName' | 'lastName' | 'name' | 'role' | 'status' | 'uuid' | AdminUserDataKeySpecifier)[];
export type AdminUserDataFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminUserDataConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AdminUserDataConnectionKeySpecifier)[];
export type AdminUserDataConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminUserDataEdgeKeySpecifier = ('cursor' | 'node' | AdminUserDataEdgeKeySpecifier)[];
export type AdminUserDataEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AiReportKeySpecifier = ('audience' | 'dateApplied' | 'file' | 'generatedBy' | 'maxWordsLength' | 'prompt' | 'purpose' | 'reportName' | 'topics' | 'uuid' | AiReportKeySpecifier)[];
export type AiReportFieldPolicy = {
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	dateApplied?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	maxWordsLength?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	purpose?: FieldPolicy<any> | FieldReadFunction<any>,
	reportName?: FieldPolicy<any> | FieldReadFunction<any>,
	topics?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AiReportTopicKeySpecifier = ('name' | 'riskAreaUuid' | AiReportTopicKeySpecifier)[];
export type AiReportTopicFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AmsAuditorKeySpecifier = ('amsRole' | 'createdAt' | 'email' | 'lastSignInAt' | 'name' | 'status' | 'uuid' | AmsAuditorKeySpecifier)[];
export type AmsAuditorFieldPolicy = {
	amsRole?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSignInAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AmsSessionTokensKeySpecifier = ('refreshToken' | 'sessionToken' | AmsSessionTokensKeySpecifier)[];
export type AmsSessionTokensFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetSettingsKeySpecifier = ('createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'nicoleAvatarUrl' | 'nicoleSetting' | 'tenant' | 'uuid' | AssetSettingsKeySpecifier)[];
export type AssetSettingsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantCredentialsKeySpecifier = ('apiKey' | 'assistantId' | 'instanceUrl' | 'tenant' | 'tenantUuid' | 'uuid' | 'workspaceId' | 'workspaceName' | AssistantCredentialsKeySpecifier)[];
export type AssistantCredentialsFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantId?: FieldPolicy<any> | FieldReadFunction<any>,
	instanceUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	workspaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	workspaceName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantCredentialsConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AssistantCredentialsConnectionKeySpecifier)[];
export type AssistantCredentialsConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantCredentialsEdgeKeySpecifier = ('cursor' | 'node' | AssistantCredentialsEdgeKeySpecifier)[];
export type AssistantCredentialsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotKeySpecifier = ('actionId' | 'dataType' | 'isLegacy' | 'legacyType' | 'slotId' | 'text' | AssistantSlotKeySpecifier)[];
export type AssistantSlotFieldPolicy = {
	actionId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	isLegacy?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyType?: FieldPolicy<any> | FieldReadFunction<any>,
	slotId?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AssistantSlotConnectionKeySpecifier)[];
export type AssistantSlotConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotEdgeKeySpecifier = ('cursor' | 'node' | AssistantSlotEdgeKeySpecifier)[];
export type AssistantSlotEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotIdentifiersKeySpecifier = ('actionId' | 'slotId' | AssistantSlotIdentifiersKeySpecifier)[];
export type AssistantSlotIdentifiersFieldPolicy = {
	actionId?: FieldPolicy<any> | FieldReadFunction<any>,
	slotId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventKeySpecifier = ('answerUuid' | 'context' | 'contextLabel' | 'createdAt' | 'detailsDescription' | 'esgAnswer' | 'esgQuestion' | 'loggedAt' | 'newValue' | 'oldValue' | 'programme' | 'programmeUuid' | 'questionUuid' | 'resourceId' | 'resourceType' | 'riskArea' | 'riskAreaUuid' | 'status' | 'typeKey' | 'typeLabel' | 'user' | 'userAgent' | 'userIp' | 'userUuid' | 'uuid' | 'year' | 'yearUuid' | AuditEventKeySpecifier)[];
export type AuditEventFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	contextLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	loggedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	newValue?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	programmeUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceType?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	typeKey?: FieldPolicy<any> | FieldReadFunction<any>,
	typeLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userAgent?: FieldPolicy<any> | FieldReadFunction<any>,
	userIp?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>,
	yearUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AuditEventConnectionKeySpecifier)[];
export type AuditEventConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventEdgeKeySpecifier = ('cursor' | 'node' | AuditEventEdgeKeySpecifier)[];
export type AuditEventEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditRenewalBackfillResultKeySpecifier = ('count' | 'dryRun' | 'skippedTenantUuids' | 'tenants' | AuditRenewalBackfillResultKeySpecifier)[];
export type AuditRenewalBackfillResultFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	dryRun?: FieldPolicy<any> | FieldReadFunction<any>,
	skippedTenantUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	tenants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditRenewalBackfillTenantKeySpecifier = ('name' | 'uuid' | AuditRenewalBackfillTenantKeySpecifier)[];
export type AuditRenewalBackfillTenantFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticDeletionSettingsKeySpecifier = ('automaticDeletionAfterDays' | 'canEdit' | 'isActivityDeletionEnabled' | 'isChatHistoryDeletionEnabled' | 'isEnabled' | 'isFilesDeletionEnabled' | 'isParticipantDeletionEnabled' | AutomaticDeletionSettingsKeySpecifier)[];
export type AutomaticDeletionSettingsFieldPolicy = {
	automaticDeletionAfterDays?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isActivityDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isChatHistoryDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isFilesDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isParticipantDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvailableToAddSlotKeySpecifier = ('action' | 'category' | 'name' | 'pairsWithName' | 'reason' | 'riskAreaUuid' | AvailableToAddSlotKeySpecifier)[];
export type AvailableToAddSlotFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pairsWithName?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvgDaysToCloseByIncidentTypeKeySpecifier = ('avgDaysToClose' | 'incidentTypeName' | AvgDaysToCloseByIncidentTypeKeySpecifier)[];
export type AvgDaysToCloseByIncidentTypeFieldPolicy = {
	avgDaysToClose?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypeName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvgDaysToCloseByTimeIntervalKeySpecifier = ('avgDaysToClose' | 'date' | AvgDaysToCloseByTimeIntervalKeySpecifier)[];
export type AvgDaysToCloseByTimeIntervalFieldPolicy = {
	avgDaysToClose?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BackfillFrameworkSmartFillEntitlementsResultKeySpecifier = ('failures' | 'frameworksGranted' | 'tenantsGranted' | 'tenantsSeen' | BackfillFrameworkSmartFillEntitlementsResultKeySpecifier)[];
export type BackfillFrameworkSmartFillEntitlementsResultFieldPolicy = {
	failures?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworksGranted?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantsGranted?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantsSeen?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannedEmailKeySpecifier = ('createdAt' | 'createdBy' | 'email' | 'isActive' | 'updatedAt' | 'updatedBy' | 'uuid' | BannedEmailKeySpecifier)[];
export type BannedEmailFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannedEmailConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | BannedEmailConnectionKeySpecifier)[];
export type BannedEmailConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannedEmailEdgeKeySpecifier = ('cursor' | 'node' | BannedEmailEdgeKeySpecifier)[];
export type BannedEmailEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasicLicenceAcceptanceKeySpecifier = ('acceptedAt' | 'acceptedBy' | 'acceptedByEmail' | 'acceptedByName' | 'source' | 'termsEdition' | BasicLicenceAcceptanceKeySpecifier)[];
export type BasicLicenceAcceptanceFieldPolicy = {
	acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptedByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptedByName?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	termsEdition?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasicLicenceTermsKeySpecifier = ('edition' | 'title' | 'trustedHtml' | BasicLicenceTermsKeySpecifier)[];
export type BasicLicenceTermsFieldPolicy = {
	edition?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	trustedHtml?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BeaconDomainRuleKeySpecifier = ('feeUsd' | 'id' | 'isoCertificate' | 'label' | 'reviews' | BeaconDomainRuleKeySpecifier)[];
export type BeaconDomainRuleFieldPolicy = {
	feeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	reviews?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BeaconRulesKeySpecifier = ('assuranceOptions' | 'domains' | 'includedJurisdictions' | 'interviewFeeUsd' | 'maxDomains' | 'maxHeadcount' | 'product' | 'productName' | BeaconRulesKeySpecifier)[];
export type BeaconRulesFieldPolicy = {
	assuranceOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	domains?: FieldPolicy<any> | FieldReadFunction<any>,
	includedJurisdictions?: FieldPolicy<any> | FieldReadFunction<any>,
	interviewFeeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDomains?: FieldPolicy<any> | FieldReadFunction<any>,
	maxHeadcount?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingIdentityKeySpecifier = ('billingAddress' | 'billingEntityName' | 'buyerCountry' | 'invoiceRecipientEmail' | 'invoiceRecipientFirstName' | 'invoiceRecipientLastName' | 'registeredAddress' | 'registeredNumber' | BillingIdentityKeySpecifier)[];
export type BillingIdentityFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntityName?: FieldPolicy<any> | FieldReadFunction<any>,
	buyerCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRecipientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRecipientFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRecipientLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	registeredAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	registeredNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitKeySpecifier = ('isActive' | 'name' | 'reportingGroup' | 'uuid' | BusinessUnitKeySpecifier)[];
export type BusinessUnitFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitConnectionKeySpecifier = ('all' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | BusinessUnitConnectionKeySpecifier)[];
export type BusinessUnitConnectionFieldPolicy = {
	all?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitEdgeKeySpecifier = ('cursor' | 'node' | BusinessUnitEdgeKeySpecifier)[];
export type BusinessUnitEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CallsCaseKeySpecifier = ('assignedCaseType' | 'caseCode' | 'caseCodeReadable' | 'caseTypes' | 'caseTypesCount' | 'country' | 'language' | 'pinCode' | 'pinCodeReadable' | 'recordingUrl' | 'tenantCode' | 'transcriptUpdatedAt' | 'transcription' | 'twilioCallSid' | 'uuid' | CallsCaseKeySpecifier)[];
export type CallsCaseFieldPolicy = {
	assignedCaseType?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCode?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCodeReadable?: FieldPolicy<any> | FieldReadFunction<any>,
	caseTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	caseTypesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	pinCode?: FieldPolicy<any> | FieldReadFunction<any>,
	pinCodeReadable?: FieldPolicy<any> | FieldReadFunction<any>,
	recordingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantCode?: FieldPolicy<any> | FieldReadFunction<any>,
	transcriptUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	transcription?: FieldPolicy<any> | FieldReadFunction<any>,
	twilioCallSid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CallsIncidentTypeKeySpecifier = ('order' | 'type' | 'uuid' | CallsIncidentTypeKeySpecifier)[];
export type CallsIncidentTypeFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseKeySpecifier = ('activities' | 'businessUnit' | 'caseId' | 'chatRoomSecret' | 'city' | 'closedAt' | 'conclusionType' | 'conversationMessages' | 'country' | 'createdAt' | 'createdBy' | 'createdByGuest' | 'currency' | 'customTitle' | 'damageCost' | 'duration' | 'entity' | 'excludedUsers' | 'file' | 'files' | 'firebaseToken' | 'hasOriginalReport' | 'history' | 'inCasePermissions' | 'incidentType' | 'individualsInvolved' | 'investigators' | 'isSubmitted' | 'language' | 'location' | 'openedAt' | 'pinCode' | 'possibleBusinessUnits' | 'possibleInvestigators' | 'relationship' | 'reopenedAt' | 'reportCountry' | 'reportSource' | 'reporter' | 'reportingSource' | 'severity' | 'state' | 'status' | 'submittedAt' | 'subsidiarySite' | 'triageScore' | 'updatedAt' | 'urgency' | 'uuid' | CaseKeySpecifier)[];
export type CaseFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	closedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	conversationMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	customTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	damageCost?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	entity?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	hasOriginalReport?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	inCasePermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	individualsInvolved?: FieldPolicy<any> | FieldReadFunction<any>,
	investigators?: FieldPolicy<any> | FieldReadFunction<any>,
	isSubmitted?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	openedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	pinCode?: FieldPolicy<any> | FieldReadFunction<any>,
	possibleBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	possibleInvestigators?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>,
	reopenedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSource?: FieldPolicy<any> | FieldReadFunction<any>,
	reporter?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	triageScore?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	urgency?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityKeySpecifier = ('activityFiles' | 'activityType' | 'case' | 'conclusionType' | 'createdAt' | 'createdBy' | 'note' | 'relatedField' | 'title' | 'uuid' | CaseActivityKeySpecifier)[];
export type CaseActivityFieldPolicy = {
	activityFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	activityType?: FieldPolicy<any> | FieldReadFunction<any>,
	case?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedField?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseActivityConnectionKeySpecifier)[];
export type CaseActivityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityEdgeKeySpecifier = ('cursor' | 'node' | CaseActivityEdgeKeySpecifier)[];
export type CaseActivityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityRelatedFieldKeySpecifier = ('fieldLabel' | 'fieldName' | 'fieldType' | 'fieldValue' | CaseActivityRelatedFieldKeySpecifier)[];
export type CaseActivityRelatedFieldFieldPolicy = {
	fieldLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldName?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsKeySpecifier = ('isActive' | 'name' | 'relatedField' | 'relatedFields' | 'uuid' | CaseActivitySettingsKeySpecifier)[];
export type CaseActivitySettingsFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedField?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedFields?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseActivitySettingsConnectionKeySpecifier)[];
export type CaseActivitySettingsConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsEdgeKeySpecifier = ('cursor' | 'node' | CaseActivitySettingsEdgeKeySpecifier)[];
export type CaseActivitySettingsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsRelatedFieldKeySpecifier = ('fieldLabel' | 'fieldName' | 'fieldType' | CaseActivitySettingsRelatedFieldKeySpecifier)[];
export type CaseActivitySettingsRelatedFieldFieldPolicy = {
	fieldLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldName?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAnalyticsKeySpecifier = ('avgDaysToCloseByIncidentType' | 'avgDaysToCloseByTimeInterval' | 'casesByCountry' | 'casesByReportSource' | 'casesByStatus' | 'casesStatusByIncidentType' | 'tenantUuid' | CaseAnalyticsKeySpecifier)[];
export type CaseAnalyticsFieldPolicy = {
	avgDaysToCloseByIncidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDaysToCloseByTimeInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	casesByCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	casesByReportSource?: FieldPolicy<any> | FieldReadFunction<any>,
	casesByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	casesStatusByIncidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAnonymityConnectionKeySpecifier = ('edges' | 'isEnabled' | 'nodes' | 'pageInfo' | 'totalCount' | CaseAnonymityConnectionKeySpecifier)[];
export type CaseAnonymityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAnonymityRestrictionsKeySpecifier = ('country' | 'restrictions' | CaseAnonymityRestrictionsKeySpecifier)[];
export type CaseAnonymityRestrictionsFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	restrictions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAssignmentKeySpecifier = ('countries' | 'incidentTypes' | 'regions' | 'subsidiarySite' | 'users' | 'uuid' | CaseAssignmentKeySpecifier)[];
export type CaseAssignmentFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAssignmentConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseAssignmentConnectionKeySpecifier)[];
export type CaseAssignmentConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAssignmentEdgeKeySpecifier = ('cursor' | 'node' | CaseAssignmentEdgeKeySpecifier)[];
export type CaseAssignmentEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByCountryKeySpecifier = ('count' | 'country' | CaseByCountryKeySpecifier)[];
export type CaseByCountryFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByReportSourceKeySpecifier = ('count' | 'source' | CaseByReportSourceKeySpecifier)[];
export type CaseByReportSourceFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByStatusKeySpecifier = ('closed' | 'reported' | CaseByStatusKeySpecifier)[];
export type CaseByStatusFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	reported?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByStatusDataKeySpecifier = ('count' | 'date' | CaseByStatusDataKeySpecifier)[];
export type CaseByStatusDataFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseCustomReminderKeySpecifier = ('afterInactivityDays' | 'channels' | 'countries' | 'message' | 'receivers' | 'status' | 'title' | 'uuid' | CaseCustomReminderKeySpecifier)[];
export type CaseCustomReminderFieldPolicy = {
	afterInactivityDays?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	receivers?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseCustomReminderConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseCustomReminderConnectionKeySpecifier)[];
export type CaseCustomReminderConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseCustomReminderEdgeKeySpecifier = ('cursor' | 'node' | CaseCustomReminderEdgeKeySpecifier)[];
export type CaseCustomReminderEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseEdgeKeySpecifier = ('cursor' | 'node' | CaseEdgeKeySpecifier)[];
export type CaseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerKeySpecifier = ('email' | 'name' | 'uuid' | CaseExclusionOwnerKeySpecifier)[];
export type CaseExclusionOwnerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerEdgeKeySpecifier = ('cursor' | 'node' | CaseExclusionOwnerEdgeKeySpecifier)[];
export type CaseExclusionOwnerEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerListPaginatedKeySpecifier = ('isEnabled' | 'page' | 'totalCount' | CaseExclusionOwnerListPaginatedKeySpecifier)[];
export type CaseExclusionOwnerListPaginatedFieldPolicy = {
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerPageKeySpecifier = ('edges' | 'info' | CaseExclusionOwnerPageKeySpecifier)[];
export type CaseExclusionOwnerPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseFileKeySpecifier = ('case' | 'caseActivity' | 'caseUuid' | 'mimeType' | 'name' | 's3Key' | 'size' | 'type' | 'uploadedAt' | 'uploadedBy' | 'uploadedByReporter' | 'uuid' | CaseFileKeySpecifier)[];
export type CaseFileFieldPolicy = {
	case?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Key?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByReporter?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseFileConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseFileConnectionKeySpecifier)[];
export type CaseFileConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseFileEdgeKeySpecifier = ('cursor' | 'node' | CaseFileEdgeKeySpecifier)[];
export type CaseFileEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseHistoryKeySpecifier = ('case' | 'changedAt' | 'changedBy' | 'newValue' | 'originalValue' | 'record' | 'uuid' | CaseHistoryKeySpecifier)[];
export type CaseHistoryFieldPolicy = {
	case?: FieldPolicy<any> | FieldReadFunction<any>,
	changedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	changedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	newValue?: FieldPolicy<any> | FieldReadFunction<any>,
	originalValue?: FieldPolicy<any> | FieldReadFunction<any>,
	record?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseHistoryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseHistoryConnectionKeySpecifier)[];
export type CaseHistoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseHistoryEdgeKeySpecifier = ('cursor' | 'node' | CaseHistoryEdgeKeySpecifier)[];
export type CaseHistoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationKeySpecifier = ('caseId' | 'caseUuid' | 'createdAt' | 'customTitle' | 'originalReport' | 'status' | 'updatedAt' | CaseInvestigationKeySpecifier)[];
export type CaseInvestigationFieldPolicy = {
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	originalReport?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | CaseInvestigationConnectionKeySpecifier)[];
export type CaseInvestigationConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationPdfReportGenerateResponseKeySpecifier = ('url' | CaseInvestigationPdfReportGenerateResponseKeySpecifier)[];
export type CaseInvestigationPdfReportGenerateResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationStatisticsKeySpecifier = ('closedCount' | 'longInactiveCount' | 'openedCount' | 'totalCount' | CaseInvestigationStatisticsKeySpecifier)[];
export type CaseInvestigationStatisticsFieldPolicy = {
	closedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	longInactiveCount?: FieldPolicy<any> | FieldReadFunction<any>,
	openedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigatorsKeySpecifier = ('owners' | 'stakeholders' | CaseInvestigatorsKeySpecifier)[];
export type CaseInvestigatorsFieldPolicy = {
	owners?: FieldPolicy<any> | FieldReadFunction<any>,
	stakeholders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseOwnerExclusionKeySpecifier = ('excludableUsers' | 'fallbackUser' | 'subsidiarySite' | 'uuid' | CaseOwnerExclusionKeySpecifier)[];
export type CaseOwnerExclusionFieldPolicy = {
	excludableUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	fallbackUser?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseOwnerExclusionConnectionKeySpecifier = ('configurationStatus' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseOwnerExclusionConnectionKeySpecifier)[];
export type CaseOwnerExclusionConnectionFieldPolicy = {
	configurationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseOwnerExclusionEdgeKeySpecifier = ('cursor' | 'node' | CaseOwnerExclusionEdgeKeySpecifier)[];
export type CaseOwnerExclusionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CasePrintSectionsKeySpecifier = ('assistantConversation' | 'basicInformation' | 'caseActivity' | 'caseFiles' | 'caseOwnership' | 'chatConversation' | 'individualsInvolved' | CasePrintSectionsKeySpecifier)[];
export type CasePrintSectionsFieldPolicy = {
	assistantConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	basicInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	caseFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnership?: FieldPolicy<any> | FieldReadFunction<any>,
	chatConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	individualsInvolved?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CasePrintSettingsKeySpecifier = ('ADMIN' | 'CASE_OWNER' | 'REGIONAL_USER' | 'STAKEHOLDER' | CasePrintSettingsKeySpecifier)[];
export type CasePrintSettingsFieldPolicy = {
	ADMIN?: FieldPolicy<any> | FieldReadFunction<any>,
	CASE_OWNER?: FieldPolicy<any> | FieldReadFunction<any>,
	REGIONAL_USER?: FieldPolicy<any> | FieldReadFunction<any>,
	STAKEHOLDER?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportKeySpecifier = ('caseId' | 'chatRoomSecret' | 'createdAt' | 'isNewMessageFromAdmin' | 'isStatusChanged' | 'language' | 'lastMessage' | 'lastMessageTranslated' | 'status' | 'uuid' | CaseReportKeySpecifier)[];
export type CaseReportFieldPolicy = {
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	isNewMessageFromAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	isStatusChanged?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	lastMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	lastMessageTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | CaseReportConnectionKeySpecifier)[];
export type CaseReportConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportEdgeKeySpecifier = ('cursor' | 'node' | CaseReportEdgeKeySpecifier)[];
export type CaseReportEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportStatisticsKeySpecifier = ('all' | 'ongoing' | CaseReportStatisticsKeySpecifier)[];
export type CaseReportStatisticsFieldPolicy = {
	all?: FieldPolicy<any> | FieldReadFunction<any>,
	ongoing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportSubmitKeySpecifier = ('caseId' | 'createdAt' | 'language' | 'status' | 'uuid' | CaseReportSubmitKeySpecifier)[];
export type CaseReportSubmitFieldPolicy = {
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportSummaryResponseKeySpecifier = ('businessUnit' | 'caseId' | 'chatRoomSecret' | 'conversationMessages' | 'country' | 'elineConversation' | 'entity' | 'excludedUsers' | 'files' | 'firebaseToken' | 'incidentType' | 'isStatusChanged' | 'language' | 'mobileApiToken' | 'status' | 'subsidiarySite' | 'uuid' | CaseReportSummaryResponseKeySpecifier)[];
export type CaseReportSummaryResponseFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	conversationMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	elineConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	entity?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	isStatusChanged?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileApiToken?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReporterKeySpecifier = ('country' | 'email' | 'firstName' | 'lastName' | 'relationship' | CaseReporterKeySpecifier)[];
export type CaseReporterFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseSettingAnonymityKeySpecifier = ('canEdit' | 'configuredCountries' | 'countryAnonymities' | 'isEnabled' | CaseSettingAnonymityKeySpecifier)[];
export type CaseSettingAnonymityFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	configuredCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAnonymities?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseSettingExclusionKeySpecifier = ('canEdit' | 'fallbackUserUuid' | 'isEnabled' | CaseSettingExclusionKeySpecifier)[];
export type CaseSettingExclusionFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	fallbackUserUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseSettingsKeySpecifier = ('anonymitySettings' | 'automaticDeletionSettings' | 'caseActivity' | 'caseActivitySetting' | 'caseActivitySettingsAll' | 'caseAssignment' | 'caseAssignments' | 'caseOwnerExclusion' | 'caseOwnerExclusions' | 'conclusionType' | 'conclusionTypes' | 'conclusionTypesAll' | 'conversationEditingSettings' | 'customReminder' | 'customReminders' | 'emailTemplate' | 'emailTemplates' | 'exclusionSetting' | 'notifyCaseOwnersAfterInactivityDays' | 'printingSettings' | 'reportingSource' | 'reportingSources' | 'reportingSourcesAll' | 'subsidiaryReportingSettings' | 'tenantUuid' | 'triageScoreSettings' | CaseSettingsKeySpecifier)[];
export type CaseSettingsFieldPolicy = {
	anonymitySettings?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticDeletionSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySetting?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySettingsAll?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignment?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignments?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusions?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypesAll?: FieldPolicy<any> | FieldReadFunction<any>,
	conversationEditingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	customReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	customReminders?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	exclusionSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyCaseOwnersAfterInactivityDays?: FieldPolicy<any> | FieldReadFunction<any>,
	printingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSources?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSourcesAll?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiaryReportingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	triageScoreSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseStatusByIncidentTypeKeySpecifier = ('closed' | 'incidentTypeName' | 'new' | 'open' | 'reopen' | CaseStatusByIncidentTypeKeySpecifier)[];
export type CaseStatusByIncidentTypeFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypeName?: FieldPolicy<any> | FieldReadFunction<any>,
	new?: FieldPolicy<any> | FieldReadFunction<any>,
	open?: FieldPolicy<any> | FieldReadFunction<any>,
	reopen?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CasesRolePermissionKeySpecifier = ('permission' | 'subsidiarySite' | 'uuid' | CasesRolePermissionKeySpecifier)[];
export type CasesRolePermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CatalogueCategoryKeySpecifier = ('blurb' | 'id' | 'title' | CatalogueCategoryKeySpecifier)[];
export type CatalogueCategoryFieldPolicy = {
	blurb?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CataloguePlanKeySpecifier = ('id' | 'name' | 'priceUsd' | 'seats' | 'tagline' | 'withNicole' | CataloguePlanKeySpecifier)[];
export type CataloguePlanFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	seats?: FieldPolicy<any> | FieldReadFunction<any>,
	tagline?: FieldPolicy<any> | FieldReadFunction<any>,
	withNicole?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CatalogueProductKeySpecifier = ('availablePlanIds' | 'category' | 'highlight' | 'id' | 'name' | 'owned' | 'ownedSource' | 'riskAreaUuid' | 'summary' | 'upgradeable' | CatalogueProductKeySpecifier)[];
export type CatalogueProductFieldPolicy = {
	availablePlanIds?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	highlight?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owned?: FieldPolicy<any> | FieldReadFunction<any>,
	ownedSource?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	summary?: FieldPolicy<any> | FieldReadFunction<any>,
	upgradeable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryKeySpecifier = ('name' | 'riskAreas' | 'uuid' | CategoryKeySpecifier)[];
export type CategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatRoomKeySpecifier = ('referenceType' | 'referenceUuid' | 'secret' | 'status' | ChatRoomKeySpecifier)[];
export type ChatRoomFieldPolicy = {
	referenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotKeySpecifier = ('answersCount' | 'createdAt' | 'createdBy' | 'messages' | 'uuid' | ChatbotKeySpecifier)[];
export type ChatbotFieldPolicy = {
	answersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotMessageKeySpecifier = ('content' | 'createdAt' | 'createdBy' | 'role' | 'uuid' | ChatbotMessageKeySpecifier)[];
export type ChatbotMessageFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotMessageConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ChatbotMessageConnectionKeySpecifier)[];
export type ChatbotMessageConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotMessageEdgeKeySpecifier = ('cursor' | 'node' | ChatbotMessageEdgeKeySpecifier)[];
export type ChatbotMessageEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatsFileKeySpecifier = ('chatRoomUuid' | 'mimeType' | 'name' | 's3Key' | 'signedUrl' | 'size' | 'uuid' | ChatsFileKeySpecifier)[];
export type ChatsFileFieldPolicy = {
	chatRoomUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Key?: FieldPolicy<any> | FieldReadFunction<any>,
	signedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutSessionViewKeySpecifier = ('draft' | 'expiresAt' | 'planId' | 'productId' | 'status' | 'uuid' | 'verifiedEmail' | CheckoutSessionViewKeySpecifier)[];
export type CheckoutSessionViewFieldPolicy = {
	draft?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	planId?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	verifiedEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutTermOptionKeySpecifier = ('annualUsd' | 'discountBps' | 'totalUsd' | 'years' | CheckoutTermOptionKeySpecifier)[];
export type CheckoutTermOptionFieldPolicy = {
	annualUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	discountBps?: FieldPolicy<any> | FieldReadFunction<any>,
	totalUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	years?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutTermsContextKeySpecifier = ('contractedAnnualRateUsd' | 'coversDays' | 'discountBpsApplied' | 'discountReason' | 'gstApplicable' | 'listAnnualRateUsd' | 'masterTerm' | 'mode' | 'paymentSchedule' | 'proratedTotalUsd' | 'renewalDate' | 'taxRatePercent' | 'termOptions' | CheckoutTermsContextKeySpecifier)[];
export type CheckoutTermsContextFieldPolicy = {
	contractedAnnualRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	coversDays?: FieldPolicy<any> | FieldReadFunction<any>,
	discountBpsApplied?: FieldPolicy<any> | FieldReadFunction<any>,
	discountReason?: FieldPolicy<any> | FieldReadFunction<any>,
	gstApplicable?: FieldPolicy<any> | FieldReadFunction<any>,
	listAnnualRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	masterTerm?: FieldPolicy<any> | FieldReadFunction<any>,
	mode?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	proratedTotalUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalDate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRatePercent?: FieldPolicy<any> | FieldReadFunction<any>,
	termOptions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySiteKeySpecifier = ('admins' | 'isActive' | 'name' | 'reportingSlug' | 'uuid' | ClientSubsidiarySiteKeySpecifier)[];
export type ClientSubsidiarySiteFieldPolicy = {
	admins?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySiteAdminKeySpecifier = ('firstName' | 'lastName' | 'uuid' | ClientSubsidiarySiteAdminKeySpecifier)[];
export type ClientSubsidiarySiteAdminFieldPolicy = {
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySiteEdgeKeySpecifier = ('cursor' | 'node' | ClientSubsidiarySiteEdgeKeySpecifier)[];
export type ClientSubsidiarySiteEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySitesConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ClientSubsidiarySitesConnectionKeySpecifier)[];
export type ClientSubsidiarySitesConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientUserKeySpecifier = ('firstName' | 'lastName' | 'uuid' | ClientUserKeySpecifier)[];
export type ClientUserFieldPolicy = {
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConclusionTypeKeySpecifier = ('isActive' | 'name' | 'uuid' | ConclusionTypeKeySpecifier)[];
export type ConclusionTypeFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConclusionTypeConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ConclusionTypeConnectionKeySpecifier)[];
export type ConclusionTypeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConclusionTypeEdgeKeySpecifier = ('cursor' | 'node' | ConclusionTypeEdgeKeySpecifier)[];
export type ConclusionTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfirmCheckoutEmailVerificationKeySpecifier = ('attemptsRemaining' | 'matchedOrganisationName' | 'verified' | ConfirmCheckoutEmailVerificationKeySpecifier)[];
export type ConfirmCheckoutEmailVerificationFieldPolicy = {
	attemptsRemaining?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedOrganisationName?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfirmReporterEmailVerificationKeySpecifier = ('attemptsRemaining' | 'verified' | ConfirmReporterEmailVerificationKeySpecifier)[];
export type ConfirmReporterEmailVerificationFieldPolicy = {
	attemptsRemaining?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationActionSlotKeySpecifier = ('actionId' | 'extraType' | 'text' | 'textTranslated' | 'type' | ConversationActionSlotKeySpecifier)[];
export type ConversationActionSlotFieldPolicy = {
	actionId?: FieldPolicy<any> | FieldReadFunction<any>,
	extraType?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationAssistantResponseKeySpecifier = ('assistantResponses' | 'assistantResponsesTranslated' | 'caseUuid' | 'isDescribed' | 'nextSlotId' | 'progress' | 'slotOptions' | ConversationAssistantResponseKeySpecifier)[];
export type ConversationAssistantResponseFieldPolicy = {
	assistantResponses?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantResponsesTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	isDescribed?: FieldPolicy<any> | FieldReadFunction<any>,
	nextSlotId?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	slotOptions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationEditingSettingsKeySpecifier = ('canEdit' | 'isEnabled' | ConversationEditingSettingsKeySpecifier)[];
export type ConversationEditingSettingsFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationMessageKeySpecifier = ('canEdit' | 'isAssistant' | 'order' | 'text' | 'textTranslated' | 'textTranslatedOverride' | 'uuid' | ConversationMessageKeySpecifier)[];
export type ConversationMessageFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isAssistant?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	textTranslatedOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationProgressKeySpecifier = ('conversationUuid' | 'stepLabel' | 'stepLabelTranslated' | 'stepOrder' | 'stepsCount' | ConversationProgressKeySpecifier)[];
export type ConversationProgressFieldPolicy = {
	conversationUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	stepLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	stepLabelTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	stepOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	stepsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryAnonymityKeySpecifier = ('country' | 'incidentAnonymities' | CountryAnonymityKeySpecifier)[];
export type CountryAnonymityFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentAnonymities?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryAnonymityEdgeKeySpecifier = ('cursor' | 'node' | CountryAnonymityEdgeKeySpecifier)[];
export type CountryAnonymityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateCheckoutSessionPayloadKeySpecifier = ('session' | 'token' | CreateCheckoutSessionPayloadKeySpecifier)[];
export type CreateCheckoutSessionPayloadFieldPolicy = {
	session?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAgreementKeySpecifier = ('edition' | 'title' | 'trustedHtml' | CustomerAgreementKeySpecifier)[];
export type CustomerAgreementFieldPolicy = {
	edition?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	trustedHtml?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerInvoiceKeySpecifier = ('amount' | 'currency' | 'downloadable' | 'dueDate' | 'instalmentLabel' | 'invoiceNumber' | 'issueDate' | 'kind' | 'orderUuid' | 'paymentDueDate' | 'paymentStatus' | 'periodEnd' | 'periodStart' | 'ref' | 'taxBasis' | CustomerInvoiceKeySpecifier)[];
export type CustomerInvoiceFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadable?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	instalmentLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	orderUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentDueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	ref?: FieldPolicy<any> | FieldReadFunction<any>,
	taxBasis?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerInvoiceHistoryKeySpecifier = ('rows' | 'truncated' | CustomerInvoiceHistoryKeySpecifier)[];
export type CustomerInvoiceHistoryFieldPolicy = {
	rows?: FieldPolicy<any> | FieldReadFunction<any>,
	truncated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerInvoicePdfKeySpecifier = ('contentBase64' | 'filename' | CustomerInvoicePdfKeySpecifier)[];
export type CustomerInvoicePdfFieldPolicy = {
	contentBase64?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataCategoryKeySpecifier = ('category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'uuid' | DataCategoryKeySpecifier)[];
export type DataCategoryFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataCategoryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | DataCategoryConnectionKeySpecifier)[];
export type DataCategoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataCategoryEdgeKeySpecifier = ('cursor' | 'node' | DataCategoryEdgeKeySpecifier)[];
export type DataCategoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureKeySpecifier = ('applicantsNumber' | 'audienceType' | 'canAnswer' | 'canEdit' | 'countries' | 'createdAt' | 'description' | 'emailTargets' | 'hasAnswered' | 'hasNewAnswers' | 'isAuthor' | 'json' | 'lastResponded' | 'name' | 'relationships' | 'respondentType' | 'responseCount' | 'responses' | 'riskAreas' | 'status' | 'updatedAt' | 'userResponseCount' | 'uuid' | DisclosureKeySpecifier)[];
export type DisclosureFieldPolicy = {
	applicantsNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	audienceType?: FieldPolicy<any> | FieldReadFunction<any>,
	canAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNewAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastResponded?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relationships?: FieldPolicy<any> | FieldReadFunction<any>,
	respondentType?: FieldPolicy<any> | FieldReadFunction<any>,
	responseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	responses?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userResponseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureChatNotificationExtraKeySpecifier = ('disclosureUuid' | DisclosureChatNotificationExtraKeySpecifier)[];
export type DisclosureChatNotificationExtraFieldPolicy = {
	disclosureUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureCommentsPaginatedKeySpecifier = ('page' | 'totalCount' | DisclosureCommentsPaginatedKeySpecifier)[];
export type DisclosureCommentsPaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | DisclosureConnectionKeySpecifier)[];
export type DisclosureConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureEdgeKeySpecifier = ('cursor' | 'node' | DisclosureEdgeKeySpecifier)[];
export type DisclosureEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureEmailTargetKeySpecifier = ('answered' | 'email' | 'sent' | 'uuid' | DisclosureEmailTargetKeySpecifier)[];
export type DisclosureEmailTargetFieldPolicy = {
	answered?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	sent?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosurePageKeySpecifier = ('edges' | 'info' | DisclosurePageKeySpecifier)[];
export type DisclosurePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosurePaginatedKeySpecifier = ('page' | 'statistics' | 'totalCount' | DisclosurePaginatedKeySpecifier)[];
export type DisclosurePaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseKeySpecifier = ('approvalReason' | 'approvalStatus' | 'chatRoomSecret' | 'commentCount' | 'contactEmail' | 'createdAt' | 'createdByFirstName' | 'createdByLastName' | 'createdByUuid' | 'disclosure' | 'disclosureJson' | 'disclosureUuid' | 'isNew' | 'json' | 'phoneNumber' | 'source' | 'uuid' | DisclosureResponseKeySpecifier)[];
export type DisclosureResponseFieldPolicy = {
	approvalReason?: FieldPolicy<any> | FieldReadFunction<any>,
	approvalStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	commentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosure?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureJson?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	isNew?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseCommentKeySpecifier = ('approvalStatus' | 'commentedBy' | 'content' | 'createdAt' | 'createdBy' | 'isEdited' | 'isMyComment' | 'updatedAt' | 'uuid' | DisclosureResponseCommentKeySpecifier)[];
export type DisclosureResponseCommentFieldPolicy = {
	approvalStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	commentedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	isEdited?: FieldPolicy<any> | FieldReadFunction<any>,
	isMyComment?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseCommentEdgeKeySpecifier = ('cursor' | 'node' | DisclosureResponseCommentEdgeKeySpecifier)[];
export type DisclosureResponseCommentEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseCommentPageKeySpecifier = ('edges' | 'info' | DisclosureResponseCommentPageKeySpecifier)[];
export type DisclosureResponseCommentPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseConnectionKeySpecifier = ('disclosureData' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | DisclosureResponseConnectionKeySpecifier)[];
export type DisclosureResponseConnectionFieldPolicy = {
	disclosureData?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseEdgeKeySpecifier = ('cursor' | 'node' | DisclosureResponseEdgeKeySpecifier)[];
export type DisclosureResponseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponsePageKeySpecifier = ('edges' | 'info' | DisclosureResponsePageKeySpecifier)[];
export type DisclosureResponsePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponsesPaginatedKeySpecifier = ('disclosureData' | 'disclosureJson' | 'page' | 'totalCount' | DisclosureResponsesPaginatedKeySpecifier)[];
export type DisclosureResponsesPaginatedFieldPolicy = {
	disclosureData?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureJson?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureStatisticsKeySpecifier = ('approvedCount' | 'disclosuresCount' | 'newAnswersCount' | 'responsesCount' | 'usersCount' | DisclosureStatisticsKeySpecifier)[];
export type DisclosureStatisticsFieldPolicy = {
	approvedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosuresCount?: FieldPolicy<any> | FieldReadFunction<any>,
	newAnswersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	responsesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	usersCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureUserKeySpecifier = ('approvedCount' | 'contactEmail' | 'country' | 'disapprovedCount' | 'firstName' | 'hasNewAnswers' | 'lastName' | 'lastSubmittedDate' | 'organizationName' | 'organizationRole' | 'phoneNumber' | 'responses' | 'submittedResponsesCount' | 'uuid' | DisclosureUserKeySpecifier)[];
export type DisclosureUserFieldPolicy = {
	approvedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	disapprovedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNewAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSubmittedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	responses?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedResponsesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureUserConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | DisclosureUserConnectionKeySpecifier)[];
export type DisclosureUserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureUserEdgeKeySpecifier = ('cursor' | 'node' | DisclosureUserEdgeKeySpecifier)[];
export type DisclosureUserEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ESGGroupTagEdgeKeySpecifier = ('cursor' | 'node' | ESGGroupTagEdgeKeySpecifier)[];
export type ESGGroupTagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElineConversationKeySpecifier = ('caseUuid' | 'transcription' | 'transcriptionTranslated' | ElineConversationKeySpecifier)[];
export type ElineConversationFieldPolicy = {
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	transcription?: FieldPolicy<any> | FieldReadFunction<any>,
	transcriptionTranslated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElineNumberKeySpecifier = ('assignedCountry' | 'createdAt' | 'defaultCountry' | 'lastUpdatedAt' | 'number' | 'uuid' | ElineNumberKeySpecifier)[];
export type ElineNumberFieldPolicy = {
	assignedCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElinePhoneNumberKeySpecifier = ('number' | ElinePhoneNumberKeySpecifier)[];
export type ElinePhoneNumberFieldPolicy = {
	number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailEntryKeySpecifier = ('createdAt' | 'email' | 'listUuid' | 'updatedAt' | 'uuid' | EmailEntryKeySpecifier)[];
export type EmailEntryFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	listUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailEntryEditResultKeySpecifier = ('deletedEntryUuid' | 'entry' | EmailEntryEditResultKeySpecifier)[];
export type EmailEntryEditResultFieldPolicy = {
	deletedEntryUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	entry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailListKeySpecifier = ('active' | 'createdAt' | 'entries' | 'entriesCount' | 'name' | 'updatedAt' | 'uuid' | EmailListKeySpecifier)[];
export type EmailListFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	entriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailListConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EmailListConnectionKeySpecifier)[];
export type EmailListConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailListEdgeKeySpecifier = ('cursor' | 'node' | EmailListEdgeKeySpecifier)[];
export type EmailListEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailMessageParsedResponseKeySpecifier = ('body' | 'subject' | EmailMessageParsedResponseKeySpecifier)[];
export type EmailMessageParsedResponseFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailTemplateKeySpecifier = ('body' | 'isActive' | 'isCarbonCopyEnabled' | 'recipients' | 'subject' | 'type' | 'variables' | EmailTemplateKeySpecifier)[];
export type EmailTemplateFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarbonCopyEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	recipients?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	variables?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailTemplateRecipientsKeySpecifier = ('cc' | 'to' | EmailTemplateRecipientsKeySpecifier)[];
export type EmailTemplateRecipientsFieldPolicy = {
	cc?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnabledSsoMethodsForTenantKeySpecifier = ('azure' | 'saml' | EnabledSsoMethodsForTenantKeySpecifier)[];
export type EnabledSsoMethodsForTenantFieldPolicy = {
	azure?: FieldPolicy<any> | FieldReadFunction<any>,
	saml?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EngagementPriceKeySpecifier = ('bespoke' | 'bespokeReason' | 'lines' | 'pricingVersion' | 'product' | 'productName' | 'renewalUsd' | 'sizeBand' | 'year1Usd' | EngagementPriceKeySpecifier)[];
export type EngagementPriceFieldPolicy = {
	bespoke?: FieldPolicy<any> | FieldReadFunction<any>,
	bespokeReason?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	sizeBand?: FieldPolicy<any> | FieldReadFunction<any>,
	year1Usd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EngagementPriceLineKeySpecifier = ('amountUsd' | 'key' | 'label' | EngagementPriceLineKeySpecifier)[];
export type EngagementPriceLineFieldPolicy = {
	amountUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntitlementItemKeySpecifier = ('frameworkCategory' | 'kind' | 'refUuid' | 'smartFill' | 'standard' | 'state' | EntitlementItemKeySpecifier)[];
export type EntitlementItemFieldPolicy = {
	frameworkCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	refUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFill?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntitlementModuleKeySpecifier = ('enabled' | 'key' | EntitlementModuleKeySpecifier)[];
export type EntitlementModuleFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EntitlementSeatsKeySpecifier = ('totalLimitedLicenses' | 'totalStandardLicenses' | 'usedLimitedLicenses' | 'usedStandardLicenses' | EntitlementSeatsKeySpecifier)[];
export type EntitlementSeatsFieldPolicy = {
	totalLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	totalStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgActivitiesForActivityReportKeySpecifier = ('name' | 'topicsCount' | EsgActivitiesForActivityReportKeySpecifier)[];
export type EsgActivitiesForActivityReportFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	topicsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgAnswerKeySpecifier = ('answer' | 'assignedTags' | 'chatbot' | 'createdAt' | 'createdBy' | 'embeddedTags' | 'files' | 'images' | 'isDefault' | 'isLinked' | 'linkedMetrics' | 'question' | 'tasks' | 'updatedAt' | 'updatedBy' | 'uuid' | 'version' | 'versionTag' | 'year' | EsgAnswerKeySpecifier)[];
export type EsgAnswerFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbot?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	embeddedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	versionTag?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgAnswerGenerateResultKeySpecifier = ('generatedAnswer' | 'question' | EsgAnswerGenerateResultKeySpecifier)[];
export type EsgAnswerGenerateResultFieldPolicy = {
	generatedAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgAnswerTagsKeySpecifier = ('groupTag' | 'tagCount' | 'tags' | EsgAnswerTagsKeySpecifier)[];
export type EsgAnswerTagsFieldPolicy = {
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	tagCount?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgCategoryKeySpecifier = ('description' | 'name' | 'riskAreas' | 'statistics' | 'subcategories' | 'type' | 'uuid' | EsgCategoryKeySpecifier)[];
export type EsgCategoryFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	subcategories?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFileKeySpecifier = ('answers' | 'mimeType' | 'name' | 'size' | 'uploadedBy' | 'url' | 'uuid' | EsgFileKeySpecifier)[];
export type EsgFileFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditKeySpecifier = ('assignedAt' | 'auditors' | 'completedAt' | 'requestedAt' | 'riskAreaUuid' | 'status' | 'uuid' | 'withdrawnAt' | 'yearUuid' | EsgFrameworkAuditKeySpecifier)[];
export type EsgFrameworkAuditFieldPolicy = {
	assignedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	auditors?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawnAt?: FieldPolicy<any> | FieldReadFunction<any>,
	yearUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditAdminEntryKeySpecifier = ('audit' | 'frameworkName' | 'tenantName' | 'tenantUuid' | EsgFrameworkAuditAdminEntryKeySpecifier)[];
export type EsgFrameworkAuditAdminEntryFieldPolicy = {
	audit?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkName?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditAuditorKeySpecifier = ('assignedAt' | 'auditorEmail' | 'auditorFirstName' | 'auditorLastName' | 'auditorUserUuid' | 'uuid' | EsgFrameworkAuditAuditorKeySpecifier)[];
export type EsgFrameworkAuditAuditorFieldPolicy = {
	assignedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	auditorEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	auditorFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	auditorLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	auditorUserUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditEntryKeySpecifier = ('aiDraftEdited' | 'aiGenerated' | 'aiJustification' | 'authorUuid' | 'body' | 'createdAt' | 'entryKind' | 'findingType' | 'frameworkAuditUuid' | 'questionUuid' | 'responseSnapshot' | 'uuid' | EsgFrameworkAuditEntryKeySpecifier)[];
export type EsgFrameworkAuditEntryFieldPolicy = {
	aiDraftEdited?: FieldPolicy<any> | FieldReadFunction<any>,
	aiGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	aiJustification?: FieldPolicy<any> | FieldReadFunction<any>,
	authorUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entryKind?: FieldPolicy<any> | FieldReadFunction<any>,
	findingType?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkAuditUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	responseSnapshot?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditEntryAiJustificationKeySpecifier = ('checked' | 'citations' | EsgFrameworkAuditEntryAiJustificationKeySpecifier)[];
export type EsgFrameworkAuditEntryAiJustificationFieldPolicy = {
	checked?: FieldPolicy<any> | FieldReadFunction<any>,
	citations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditFindingMixKeySpecifier = ('count' | 'findingType' | EsgFrameworkAuditFindingMixKeySpecifier)[];
export type EsgFrameworkAuditFindingMixFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	findingType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditGapCitationKeySpecifier = ('excerpt' | 'fileName' | 'fileUuid' | 'occurrence' | 'page' | 'source' | 'type' | EsgFrameworkAuditGapCitationKeySpecifier)[];
export type EsgFrameworkAuditGapCitationFieldPolicy = {
	excerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	occurrence?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditGapRunKeySpecifier = ('completedCount' | 'createdAt' | 'errorMessage' | 'isStale' | 'lastUpdatedAt' | 'status' | 'totalCount' | 'uuid' | EsgFrameworkAuditGapRunKeySpecifier)[];
export type EsgFrameworkAuditGapRunFieldPolicy = {
	completedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	isStale?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditGapSuggestionKeySpecifier = ('capturedAddressedAt' | 'checked' | 'citations' | 'createdAt' | 'note' | 'questionUuid' | 'status' | 'suggestedType' | 'uuid' | EsgFrameworkAuditGapSuggestionKeySpecifier)[];
export type EsgFrameworkAuditGapSuggestionFieldPolicy = {
	capturedAddressedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	checked?: FieldPolicy<any> | FieldReadFunction<any>,
	citations?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedType?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditQuestionReviewKeySpecifier = ('entryCount' | 'lastEntryAt' | 'questionUuid' | 'verdict' | EsgFrameworkAuditQuestionReviewKeySpecifier)[];
export type EsgFrameworkAuditQuestionReviewFieldPolicy = {
	entryCount?: FieldPolicy<any> | FieldReadFunction<any>,
	lastEntryAt?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	verdict?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkAuditSummaryKeySpecifier = ('findingMix' | 'frameworkAuditUuid' | 'questionReviews' | 'reviewedCount' | EsgFrameworkAuditSummaryKeySpecifier)[];
export type EsgFrameworkAuditSummaryFieldPolicy = {
	findingMix?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkAuditUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionReviews?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkDocumentKeySpecifier = ('citedInCount' | 'createdAt' | 'file' | 'isRead' | 'nicoleCitedCount' | 'pendingDraftCount' | 'smartFillStatus' | 'uuid' | EsgFrameworkDocumentKeySpecifier)[];
export type EsgFrameworkDocumentFieldPolicy = {
	citedInCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	isRead?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleCitedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingDraftCount?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFillStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkDocumentMutationResultKeySpecifier = ('affectedCount' | EsgFrameworkDocumentMutationResultKeySpecifier)[];
export type EsgFrameworkDocumentMutationResultFieldPolicy = {
	affectedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkDocumentStatsKeySpecifier = ('cited' | 'failed' | 'processed' | 'total' | EsgFrameworkDocumentStatsKeySpecifier)[];
export type EsgFrameworkDocumentStatsFieldPolicy = {
	cited?: FieldPolicy<any> | FieldReadFunction<any>,
	failed?: FieldPolicy<any> | FieldReadFunction<any>,
	processed?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFrameworkDocumentsKeySpecifier = ('documents' | 'stats' | EsgFrameworkDocumentsKeySpecifier)[];
export type EsgFrameworkDocumentsFieldPolicy = {
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgGapAnalysisBatchKeySpecifier = ('batchUuid' | 'jobs' | 'programme' | 'riskArea' | 'yearUuid' | EsgGapAnalysisBatchKeySpecifier)[];
export type EsgGapAnalysisBatchFieldPolicy = {
	batchUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	yearUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgGapAnalysisJobKeySpecifier = ('currentStep' | 'status' | 'uuid' | 'versionLabel' | 'versionTagUuid' | EsgGapAnalysisJobKeySpecifier)[];
export type EsgGapAnalysisJobFieldPolicy = {
	currentStep?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	versionLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	versionTagUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgGroupTagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgGroupTagConnectionKeySpecifier)[];
export type EsgGroupTagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgGroupedStatisticsKeySpecifier = ('id' | 'standard' | 'statistics' | EsgGroupedStatisticsKeySpecifier)[];
export type EsgGroupedStatisticsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgHistoryElementKeySpecifier = ('createdAt' | 'editedBy' | 'uuid' | EsgHistoryElementKeySpecifier)[];
export type EsgHistoryElementFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	editedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionKeySpecifier = ('activity' | 'addressedAt' | 'answerForVersion' | 'answers' | 'answersCount' | 'auditEvents' | 'defaultAnswer' | 'files' | 'filesCount' | 'header' | 'isAnswered' | 'isLinked' | 'lastActivityDate' | 'linkedMetrics' | 'metadata' | 'navigationTitle' | 'order' | 'question' | 'questionActivity' | 'status' | 'step' | 'tasks' | 'templateURL' | 'uuid' | 'videoTitle' | 'videoURL' | EsgQuestionKeySpecifier)[];
export type EsgQuestionFieldPolicy = {
	activity?: FieldPolicy<any> | FieldReadFunction<any>,
	addressedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	answerForVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	answersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	filesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	header?: FieldPolicy<any> | FieldReadFunction<any>,
	isAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	isLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	lastActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	navigationTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	questionActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	step?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	templateURL?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	videoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	videoURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgQuestionConnectionKeySpecifier)[];
export type EsgQuestionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionEdgeKeySpecifier = ('cursor' | 'node' | EsgQuestionEdgeKeySpecifier)[];
export type EsgQuestionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionMetadataKeySpecifier = ('id' | 'metadata' | 'standard' | EsgQuestionMetadataKeySpecifier)[];
export type EsgQuestionMetadataFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionRiskAreaMetadataKeySpecifier = ('guidelinePath' | 'id' | 'tagData' | 'unit' | EsgQuestionRiskAreaMetadataKeySpecifier)[];
export type EsgQuestionRiskAreaMetadataFieldPolicy = {
	guidelinePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tagData?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionSearchConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgQuestionSearchConnectionKeySpecifier)[];
export type EsgQuestionSearchConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionTagMetadataKeySpecifier = ('guidelinePath' | 'id' | 'tag' | EsgQuestionTagMetadataKeySpecifier)[];
export type EsgQuestionTagMetadataFieldPolicy = {
	guidelinePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionTagsMetadataKeySpecifier = ('groupTag' | 'guidelinePath' | 'id' | 'tags' | 'totalCount' | EsgQuestionTagsMetadataKeySpecifier)[];
export type EsgQuestionTagsMetadataFieldPolicy = {
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgRiskAreaSettingByProgramKeySpecifier = ('isEnabled' | 'name' | 'uuid' | EsgRiskAreaSettingByProgramKeySpecifier)[];
export type EsgRiskAreaSettingByProgramFieldPolicy = {
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgRiskAreaSettingsByProgramKeySpecifier = ('programUuid' | 'riskAreaSettings' | 'tenantUuid' | EsgRiskAreaSettingsByProgramKeySpecifier)[];
export type EsgRiskAreaSettingsByProgramFieldPolicy = {
	programUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgRolePermissionKeySpecifier = ('permission' | 'riskArea' | 'uuid' | EsgRolePermissionKeySpecifier)[];
export type EsgRolePermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillApplyDraftsPayloadKeySpecifier = ('answers' | 'appliedCount' | EsgSmartFillApplyDraftsPayloadKeySpecifier)[];
export type EsgSmartFillApplyDraftsPayloadFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	appliedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillCancelPayloadKeySpecifier = ('jobUuid' | 'status' | EsgSmartFillCancelPayloadKeySpecifier)[];
export type EsgSmartFillCancelPayloadFieldPolicy = {
	jobUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillDraftAnswerKeySpecifier = ('confidence' | 'draftAnswer' | 'isAiDraft' | 'question' | 'sources' | 'status' | EsgSmartFillDraftAnswerKeySpecifier)[];
export type EsgSmartFillDraftAnswerFieldPolicy = {
	confidence?: FieldPolicy<any> | FieldReadFunction<any>,
	draftAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	isAiDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillDraftCitationKeySpecifier = ('file' | 'page' | 'sectionOrExcerpt' | 'sheetName' | 'type' | 'uuid' | EsgSmartFillDraftCitationKeySpecifier)[];
export type EsgSmartFillDraftCitationFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionOrExcerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	sheetName?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillDraftMutationResultKeySpecifier = ('answerUuid' | 'status' | 'uuid' | EsgSmartFillDraftMutationResultKeySpecifier)[];
export type EsgSmartFillDraftMutationResultFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillIngestResultKeySpecifier = ('ingestedCount' | EsgSmartFillIngestResultKeySpecifier)[];
export type EsgSmartFillIngestResultFieldPolicy = {
	ingestedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillJobKeySpecifier = ('drafts' | 'programme' | 'riskArea' | 'status' | 'uuid' | EsgSmartFillJobKeySpecifier)[];
export type EsgSmartFillJobFieldPolicy = {
	drafts?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillPendingDraftKeySpecifier = ('citations' | 'confidence' | 'createdAt' | 'draftAnswer' | 'questionUuid' | 'status' | 'uuid' | EsgSmartFillPendingDraftKeySpecifier)[];
export type EsgSmartFillPendingDraftFieldPolicy = {
	citations?: FieldPolicy<any> | FieldReadFunction<any>,
	confidence?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	draftAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillResumePayloadKeySpecifier = ('jobUuid' | 'status' | EsgSmartFillResumePayloadKeySpecifier)[];
export type EsgSmartFillResumePayloadFieldPolicy = {
	jobUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillSourceKeySpecifier = ('file' | 'page' | 'sectionOrExcerpt' | 'sheetName' | 'type' | EsgSmartFillSourceKeySpecifier)[];
export type EsgSmartFillSourceFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionOrExcerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	sheetName?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStandardKeySpecifier = ('enabled' | 'frameworkCategory' | 'name' | 'seatCount' | 'smartFill' | 'tier' | 'uuid' | EsgStandardKeySpecifier)[];
export type EsgStandardFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seatCount?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFill?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStandardWithConnectedRiskAreasKeySpecifier = ('name' | 'uuid' | EsgStandardWithConnectedRiskAreasKeySpecifier)[];
export type EsgStandardWithConnectedRiskAreasFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStatisticsKeySpecifier = ('answeredQuestions' | 'id' | 'totalQuestions' | EsgStatisticsKeySpecifier)[];
export type EsgStatisticsFieldPolicy = {
	answeredQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStepKeySpecifier = ('id' | 'isAnswered' | 'name' | 'order' | 'questions' | 'riskArea' | 'uuid' | EsgStepKeySpecifier)[];
export type EsgStepFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSubcategoryKeySpecifier = ('category' | 'categoryUuid' | 'history' | 'lastActiveDate' | 'name' | 'order' | 'uuid' | EsgSubcategoryKeySpecifier)[];
export type EsgSubcategoryFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	lastActiveDate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgTagConnectionKeySpecifier)[];
export type EsgTagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTagEdgeKeySpecifier = ('cursor' | 'node' | EsgTagEdgeKeySpecifier)[];
export type EsgTagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTaskDisabledReasonKeySpecifier = ('conditionalSectors' | 'riskArea' | 'riskAreaDisabled' | 'sectors' | 'standard' | 'standardDisabled' | 'unitDisabled' | 'units' | EsgTaskDisabledReasonKeySpecifier)[];
export type EsgTaskDisabledReasonFieldPolicy = {
	conditionalSectors?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	sectors?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	standardDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTenantProgramSettingKeySpecifier = ('allRiskAreasCount' | 'category' | 'enabledRiskAreasCount' | 'isEnabled' | 'name' | 'uuid' | EsgTenantProgramSettingKeySpecifier)[];
export type EsgTenantProgramSettingFieldPolicy = {
	allRiskAreasCount?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledRiskAreasCount?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTenantProgramSettingsKeySpecifier = ('settings' | 'tenantUuid' | EsgTenantProgramSettingsKeySpecifier)[];
export type EsgTenantProgramSettingsFieldPolicy = {
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgVideoKeySpecifier = ('videoTitle' | 'videoURL' | EsgVideoKeySpecifier)[];
export type EsgVideoFieldPolicy = {
	videoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	videoURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgVideoConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgVideoConnectionKeySpecifier)[];
export type EsgVideoConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgVideoEdgeKeySpecifier = ('cursor' | 'node' | EsgVideoEdgeKeySpecifier)[];
export type EsgVideoEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExclusionAdminUserConnectionKeySpecifier = ('edges' | 'isEnabled' | 'nodes' | 'pageInfo' | 'totalCount' | ExclusionAdminUserConnectionKeySpecifier)[];
export type ExclusionAdminUserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExecEdCourseKeySpecifier = ('category' | 'days' | 'priceUsd' | 'slug' | 'title' | ExecEdCourseKeySpecifier)[];
export type ExecEdCourseFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	days?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalUserAvailableRiskAreaKeySpecifier = ('allRiskAreas' | 'hasUnmappedTask' | 'riskArea' | ExternalUserAvailableRiskAreaKeySpecifier)[];
export type ExternalUserAvailableRiskAreaFieldPolicy = {
	allRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnmappedTask?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureSettingKeySpecifier = ('enabled' | 'module' | 'moduleUuid' | 'name' | 'uuid' | FeatureSettingKeySpecifier)[];
export type FeatureSettingFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeeTablePriceKeySpecifier = ('bespoke' | 'bespokeReason' | 'billing' | 'perQuarterYear1Usd' | 'pricingVersion' | 'product' | 'productName' | 'threeYearUsd' | 'year1Usd' | 'year2Usd' | 'year3Usd' | FeeTablePriceKeySpecifier)[];
export type FeeTablePriceFieldPolicy = {
	bespoke?: FieldPolicy<any> | FieldReadFunction<any>,
	bespokeReason?: FieldPolicy<any> | FieldReadFunction<any>,
	billing?: FieldPolicy<any> | FieldReadFunction<any>,
	perQuarterYear1Usd?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	threeYearUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	year1Usd?: FieldPolicy<any> | FieldReadFunction<any>,
	year2Usd?: FieldPolicy<any> | FieldReadFunction<any>,
	year3Usd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FirebaseResponseKeySpecifier = ('type' | 'value' | FirebaseResponseKeySpecifier)[];
export type FirebaseResponseFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FirebaseTokenKeySpecifier = ('token' | FirebaseTokenKeySpecifier)[];
export type FirebaseTokenFieldPolicy = {
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FirebaseTopicSubscriptionKeySpecifier = ('createdAt' | 'lastUpdatedAt' | 'type' | 'uuid' | 'value' | FirebaseTopicSubscriptionKeySpecifier)[];
export type FirebaseTopicSubscriptionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FitnessIndicatorKeySpecifier = ('contextIndicators' | 'description' | 'fitness' | 'formulaDisplay' | 'formulaKind' | 'name' | 'order' | 'uuid' | 'variables' | FitnessIndicatorKeySpecifier)[];
export type FitnessIndicatorFieldPolicy = {
	contextIndicators?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	fitness?: FieldPolicy<any> | FieldReadFunction<any>,
	formulaDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	formulaKind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	variables?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FitnessVariableKeySpecifier = ('definition' | 'order' | 'role' | 'symbol' | 'unit' | 'uuid' | 'value' | FitnessVariableKeySpecifier)[];
export type FitnessVariableFieldPolicy = {
	definition?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	symbol?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ForwardEarthCredentialsKeySpecifier = ('apiKey' | 'forwardEarthApiKeyUuid' | 'forwardEarthTenantUuid' | 'instanceUrl' | 'tenantUuid' | 'uuid' | ForwardEarthCredentialsKeySpecifier)[];
export type ForwardEarthCredentialsFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthApiKeyUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthTenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	instanceUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FrameworkImportCategoryObjectKeySpecifier = ('name' | 'uuid' | FrameworkImportCategoryObjectKeySpecifier)[];
export type FrameworkImportCategoryObjectFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FrameworkImportFrameworkObjectKeySpecifier = ('categoryName' | 'categoryUuid' | 'code' | 'edition' | 'frameworkCategory' | 'installed' | 'name' | 'slug' | 'topicKey' | FrameworkImportFrameworkObjectKeySpecifier)[];
export type FrameworkImportFrameworkObjectFieldPolicy = {
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	edition?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	installed?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	topicKey?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FrameworkImportResultKeySpecifier = ('committed' | 'counts' | 'identityRegistered' | 'issues' | 'message' | 'topicStatus' | 'topicUuid' | FrameworkImportResultKeySpecifier)[];
export type FrameworkImportResultFieldPolicy = {
	committed?: FieldPolicy<any> | FieldReadFunction<any>,
	counts?: FieldPolicy<any> | FieldReadFunction<any>,
	identityRegistered?: FieldPolicy<any> | FieldReadFunction<any>,
	issues?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	topicStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	topicUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FrameworkSeatPoolOverviewKeySpecifier = ('remainingSeatCount' | 'riskAreaUuid' | 'seatCount' | 'usedSeatCount' | 'viewerHasSeat' | FrameworkSeatPoolOverviewKeySpecifier)[];
export type FrameworkSeatPoolOverviewFieldPolicy = {
	remainingSeatCount?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	seatCount?: FieldPolicy<any> | FieldReadFunction<any>,
	usedSeatCount?: FieldPolicy<any> | FieldReadFunction<any>,
	viewerHasSeat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FrameworkSeatRosterKeySpecifier = ('occupants' | 'remainingSeatCount' | 'riskAreaUuid' | 'seatCount' | 'usedSeatCount' | FrameworkSeatRosterKeySpecifier)[];
export type FrameworkSeatRosterFieldPolicy = {
	occupants?: FieldPolicy<any> | FieldReadFunction<any>,
	remainingSeatCount?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	seatCount?: FieldPolicy<any> | FieldReadFunction<any>,
	usedSeatCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FrameworkSmartFillEntitlementKeySpecifier = ('riskAreaUuid' | 'smartFill' | FrameworkSmartFillEntitlementKeySpecifier)[];
export type FrameworkSmartFillEntitlementFieldPolicy = {
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFill?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalTenantBaseDataKeySpecifier = ('apiUrl' | 'clusterId' | 'code' | 'name' | 'spreadsheetApiUrl' | 'subsidiarySiteUuid' | 'uuid' | GlobalTenantBaseDataKeySpecifier)[];
export type GlobalTenantBaseDataFieldPolicy = {
	apiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	spreadsheetApiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlossaryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GlossaryConnectionKeySpecifier)[];
export type GlossaryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlossaryEntryKeySpecifier = ('description' | 'subject' | 'uuid' | GlossaryEntryKeySpecifier)[];
export type GlossaryEntryFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlossaryEntryEdgeKeySpecifier = ('cursor' | 'node' | GlossaryEntryEdgeKeySpecifier)[];
export type GlossaryEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GreenDeskPlanRuleKeySpecifier = ('annualUsd' | 'id' | 'name' | 'reviews' | GreenDeskPlanRuleKeySpecifier)[];
export type GreenDeskPlanRuleFieldPolicy = {
	annualUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reviews?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagKeySpecifier = ('childGroupTags' | 'color' | 'colorBackground' | 'colorPrimary' | 'colorSecondary' | 'createdAt' | 'createdBy' | 'esgMetadata' | 'isAssigned' | 'isPublic' | 'name' | 'parentGroupTag' | 'riskArea' | 'tags' | 'tenant' | 'updatedAt' | 'updatedBy' | 'uuid' | GroupTagKeySpecifier)[];
export type GroupTagFieldPolicy = {
	childGroupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	colorBackground?: FieldPolicy<any> | FieldReadFunction<any>,
	colorPrimary?: FieldPolicy<any> | FieldReadFunction<any>,
	colorSecondary?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	esgMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	isAssigned?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parentGroupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GroupTagConnectionKeySpecifier)[];
export type GroupTagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagEdgeKeySpecifier = ('cursor' | 'node' | GroupTagEdgeKeySpecifier)[];
export type GroupTagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagEsgMetadataKeySpecifier = ('tagDescriptionPlaceholder' | 'tagPlaceholder' | GroupTagEsgMetadataKeySpecifier)[];
export type GroupTagEsgMetadataFieldPolicy = {
	tagDescriptionPlaceholder?: FieldPolicy<any> | FieldReadFunction<any>,
	tagPlaceholder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagRowKeySpecifier = ('groupTag' | 'id' | 'tag' | GroupTagRowKeySpecifier)[];
export type GroupTagRowFieldPolicy = {
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagRowConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GroupTagRowConnectionKeySpecifier)[];
export type GroupTagRowConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagRowEdgeKeySpecifier = ('cursor' | 'node' | GroupTagRowEdgeKeySpecifier)[];
export type GroupTagRowEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuidelineKeySpecifier = ('categoryName' | 'label' | 'markdown' | 'name' | 'order' | 'path' | 'riskArea' | 'subcategories' | 'subcategoriesCount' | 'unit' | 'uuid' | GuidelineKeySpecifier)[];
export type GuidelineFieldPolicy = {
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	markdown?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	subcategories?: FieldPolicy<any> | FieldReadFunction<any>,
	subcategoriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuidelineConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GuidelineConnectionKeySpecifier)[];
export type GuidelineConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuidelineEdgeKeySpecifier = ('cursor' | 'node' | GuidelineEdgeKeySpecifier)[];
export type GuidelineEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeldQuoteKeySpecifier = ('expired' | 'expiresAt' | 'id' | 'people' | 'price' | HeldQuoteKeySpecifier)[];
export type HeldQuoteFieldPolicy = {
	expired?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	people?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImportCountsObjectKeySpecifier = ('added' | 'changed' | 'missing' | 'unchanged' | ImportCountsObjectKeySpecifier)[];
export type ImportCountsObjectFieldPolicy = {
	added?: FieldPolicy<any> | FieldReadFunction<any>,
	changed?: FieldPolicy<any> | FieldReadFunction<any>,
	missing?: FieldPolicy<any> | FieldReadFunction<any>,
	unchanged?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentAnonymityRestrictionKeySpecifier = ('isRestricted' | 'name' | 'uuid' | IncidentAnonymityRestrictionKeySpecifier)[];
export type IncidentAnonymityRestrictionFieldPolicy = {
	isRestricted?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeKeySpecifier = ('description' | 'descriptionTranslated' | 'name' | 'nameTranslated' | 'uuid' | IncidentTypeKeySpecifier)[];
export type IncidentTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nameTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeAnonymityKeySpecifier = ('isEnabled' | 'name' | 'uuid' | IncidentTypeAnonymityKeySpecifier)[];
export type IncidentTypeAnonymityFieldPolicy = {
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | IncidentTypeConnectionKeySpecifier)[];
export type IncidentTypeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeEdgeKeySpecifier = ('cursor' | 'node' | IncidentTypeEdgeKeySpecifier)[];
export type IncidentTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndividualInvolvedKeySpecifier = ('businessUnit' | 'email' | 'emailSentAt' | 'firstName' | 'lastName' | 'position' | 'relationship' | 'type' | 'uuid' | IndividualInvolvedKeySpecifier)[];
export type IndividualInvolvedFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndividualInvolvedEmailKeySpecifier = ('body' | 'recipientEmail' | 'recipientName' | 'sentAt' | 'sentBy' | 'status' | 'subject' | 'uuid' | IndividualInvolvedEmailKeySpecifier)[];
export type IndividualInvolvedEmailFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	recipientName?: FieldPolicy<any> | FieldReadFunction<any>,
	sentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sentBy?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndustryUnitConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | IndustryUnitConnectionKeySpecifier)[];
export type IndustryUnitConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsightsFileKeySpecifier = ('mimeType' | 'name' | 'size' | 'uploadedBy' | 'url' | 'uuid' | InsightsFileKeySpecifier)[];
export type InsightsFileFieldPolicy = {
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IsoAssessmentDaysKeySpecifier = ('baseS1s2' | 'baseSurveillance' | 'integratedFactorPercent' | 'md5ReductionPercent' | 's1s2' | 'surveillance' | IsoAssessmentDaysKeySpecifier)[];
export type IsoAssessmentDaysFieldPolicy = {
	baseS1s2?: FieldPolicy<any> | FieldReadFunction<any>,
	baseSurveillance?: FieldPolicy<any> | FieldReadFunction<any>,
	integratedFactorPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	md5ReductionPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	s1s2?: FieldPolicy<any> | FieldReadFunction<any>,
	surveillance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IsoCertificationPriceKeySpecifier = ('days' | 'fees' | 'reductions' | 'rulesVersion' | 'sites' | 'sitesAuditedInitial' | 'sitesAuditedSurveillance' | 'standard' | 'standardLabel' | 'standardName' | IsoCertificationPriceKeySpecifier)[];
export type IsoCertificationPriceFieldPolicy = {
	days?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	reductions?: FieldPolicy<any> | FieldReadFunction<any>,
	rulesVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	sites?: FieldPolicy<any> | FieldReadFunction<any>,
	sitesAuditedInitial?: FieldPolicy<any> | FieldReadFunction<any>,
	sitesAuditedSurveillance?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	standardLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	standardName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IsoCertificationRulesKeySpecifier = ('certificationIssuanceUsd' | 'dayRateUsd' | 'matureSystemReductionPercent' | 'maxReductionPercent' | 'minStage1Stage2Days' | 'priorCertificationReductionPercent' | 'rulesVersion' | 'standard' | 'standardLabel' | 'standardName' | 'travelPercent' | IsoCertificationRulesKeySpecifier)[];
export type IsoCertificationRulesFieldPolicy = {
	certificationIssuanceUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	dayRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	matureSystemReductionPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	maxReductionPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	minStage1Stage2Days?: FieldPolicy<any> | FieldReadFunction<any>,
	priorCertificationReductionPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	rulesVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	standardLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	standardName?: FieldPolicy<any> | FieldReadFunction<any>,
	travelPercent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IsoFeeScheduleKeySpecifier = ('certificationIssuanceUsd' | 'dayRateUsd' | 'surveillanceUsd' | 'threeYearUsd' | 'year1Usd' | IsoFeeScheduleKeySpecifier)[];
export type IsoFeeScheduleFieldPolicy = {
	certificationIssuanceUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	dayRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	surveillanceUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	threeYearUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	year1Usd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IsoReductionAppliedKeySpecifier = ('detail' | 'id' | 'label' | IsoReductionAppliedKeySpecifier)[];
export type IsoReductionAppliedFieldPolicy = {
	detail?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryAssetsKeySpecifier = ('answerGenerateExample' | 'knowledgeLibraryUploadExample' | KnowledgeLibraryAssetsKeySpecifier)[];
export type KnowledgeLibraryAssetsFieldPolicy = {
	answerGenerateExample?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryUploadExample?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryConnectionStatisticsKeySpecifier = ('answeredCount' | 'categories' | 'categoryCount' | KnowledgeLibraryConnectionStatisticsKeySpecifier)[];
export type KnowledgeLibraryConnectionStatisticsFieldPolicy = {
	answeredCount?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryGeneratedAnswerKeySpecifier = ('answer' | 'answerOptions' | 'category' | 'confidenceReason' | 'confidenceScore' | 'question' | 'reasoning' | 'riskAreas' | 'rowId' | 'sourcesUsed' | KnowledgeLibraryGeneratedAnswerKeySpecifier)[];
export type KnowledgeLibraryGeneratedAnswerFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answerOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceReason?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	rowId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryOptionsQuestionKeySpecifier = ('answer' | 'answerOptions' | 'category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'question' | 'uuid' | KnowledgeLibraryOptionsQuestionKeySpecifier)[];
export type KnowledgeLibraryOptionsQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answerOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryQuestionKeySpecifier = ('answer' | 'category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'question' | 'uuid' | KnowledgeLibraryQuestionKeySpecifier)[];
export type KnowledgeLibraryQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryQuestionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | KnowledgeLibraryQuestionConnectionKeySpecifier)[];
export type KnowledgeLibraryQuestionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryQuestionEdgeKeySpecifier = ('cursor' | 'node' | KnowledgeLibraryQuestionEdgeKeySpecifier)[];
export type KnowledgeLibraryQuestionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryScalarQuestionKeySpecifier = ('answer' | 'category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'question' | 'uuid' | KnowledgeLibraryScalarQuestionKeySpecifier)[];
export type KnowledgeLibraryScalarQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LicenseKeySpecifier = ('totalLimitedLicenses' | 'totalStandardLicenses' | 'usedLimitedLicenses' | 'usedLimitedLicensesRaw' | 'usedStandardLicenses' | 'usedStandardLicensesRaw' | LicenseKeySpecifier)[];
export type LicenseFieldPolicy = {
	totalLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	totalStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedLimitedLicensesRaw?: FieldPolicy<any> | FieldReadFunction<any>,
	usedStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedStandardLicensesRaw?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkAnswersToMetricResultKeySpecifier = ('metricUuid' | LinkAnswersToMetricResultKeySpecifier)[];
export type LinkAnswersToMetricResultFieldPolicy = {
	metricUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkMetricsToAnswerResultKeySpecifier = ('answerUuid' | 'questionUuid' | LinkMetricsToAnswerResultKeySpecifier)[];
export type LinkMetricsToAnswerResultFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MasterTermSummaryKeySpecifier = ('expiry' | 'heldPlanNames' | 'isFirstPurchase' | 'plainRemaining' | 'termYears' | MasterTermSummaryKeySpecifier)[];
export type MasterTermSummaryFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	heldPlanNames?: FieldPolicy<any> | FieldReadFunction<any>,
	isFirstPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	plainRemaining?: FieldPolicy<any> | FieldReadFunction<any>,
	termYears?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetadataKeySpecifier = ('requireSetup' | 'type' | 'uuid' | MetadataKeySpecifier)[];
export type MetadataFieldPolicy = {
	requireSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MethodTypeKeySpecifier = ('confirmedAt' | 'qrCode' | 'secret' | 'type' | 'userUuid' | 'uuid' | MethodTypeKeySpecifier)[];
export type MethodTypeFieldPolicy = {
	confirmedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	qrCode?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricKeySpecifier = ('availableYears' | 'createdBy' | 'description' | 'isFavourite' | 'isLinked' | 'lastUpdatedBy' | 'linkedQuestions' | 'metricSource' | 'metricsData' | 'name' | 'owner' | 'riskArea' | 'riskAreas' | 'uuid' | MetricKeySpecifier)[];
export type MetricFieldPolicy = {
	availableYears?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavourite?: FieldPolicy<any> | FieldReadFunction<any>,
	isLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	metricSource?: FieldPolicy<any> | FieldReadFunction<any>,
	metricsData?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | MetricConnectionKeySpecifier)[];
export type MetricConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataKeySpecifier = ('createdBy' | 'data' | 'settings' | 'updatedBy' | 'uuid' | 'year' | MetricDataKeySpecifier)[];
export type MetricDataFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataColumnSelectorKeySpecifier = ('columnName' | 'id' | MetricDataColumnSelectorKeySpecifier)[];
export type MetricDataColumnSelectorFieldPolicy = {
	columnName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataSelectorKeySpecifier = ('id' | 'rowName' | 'subRowName' | MetricDataSelectorKeySpecifier)[];
export type MetricDataSelectorFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rowName?: FieldPolicy<any> | FieldReadFunction<any>,
	subRowName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataYearKeySpecifier = ('id' | 'year' | MetricDataYearKeySpecifier)[];
export type MetricDataYearFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricEdgeKeySpecifier = ('cursor' | 'node' | MetricEdgeKeySpecifier)[];
export type MetricEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricLinkedQuestionKeySpecifier = ('linkedAnswers' | 'question' | MetricLinkedQuestionKeySpecifier)[];
export type MetricLinkedQuestionFieldPolicy = {
	linkedAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MfaKeySpecifier = ('requireSetup' | 'type' | 'uuid' | MfaKeySpecifier)[];
export type MfaFieldPolicy = {
	requireSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MissedProvisioningEmitKeySpecifier = ('actorId' | 'actorType' | 'affectedTenantUuids' | 'correlationId' | 'eventType' | 'itemId' | 'itemType' | 'missReason' | 'missedAt' | 'newValue' | 'occurredAt' | 'oldValue' | 'parentEventId' | 'reAddedAt' | 'reAddedEventId' | 'reason' | 'scope' | 'tenantUuid' | 'uuid' | MissedProvisioningEmitKeySpecifier)[];
export type MissedProvisioningEmitFieldPolicy = {
	actorId?: FieldPolicy<any> | FieldReadFunction<any>,
	actorType?: FieldPolicy<any> | FieldReadFunction<any>,
	affectedTenantUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	correlationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	missReason?: FieldPolicy<any> | FieldReadFunction<any>,
	missedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	newValue?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	parentEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	reAddedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	reAddedEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModuleSettingKeySpecifier = ('enabled' | 'features' | 'name' | 'plan' | 'planUuid' | 'uuid' | ModuleSettingKeySpecifier)[];
export type ModuleSettingFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	plan?: FieldPolicy<any> | FieldReadFunction<any>,
	planUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModuleSettingsKeySpecifier = ('carbonLens' | 'cases' | 'demo' | 'disclosures' | 'dueDiligence' | 'esg' | 'frameworks' | 'insights' | 'nicoleGpt' | 'sso' | 'subsidiarySites' | 'surveys' | 'tasks' | 'teams' | 'trainings' | ModuleSettingsKeySpecifier)[];
export type ModuleSettingsFieldPolicy = {
	carbonLens?: FieldPolicy<any> | FieldReadFunction<any>,
	cases?: FieldPolicy<any> | FieldReadFunction<any>,
	demo?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDiligence?: FieldPolicy<any> | FieldReadFunction<any>,
	esg?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworks?: FieldPolicy<any> | FieldReadFunction<any>,
	insights?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGpt?: FieldPolicy<any> | FieldReadFunction<any>,
	sso?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	surveys?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	teams?: FieldPolicy<any> | FieldReadFunction<any>,
	trainings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('adminUserDelete' | 'adminUserUpsert' | 'amsInviteAuditor' | 'amsReactivateAuditor' | 'amsSuspendAuditor' | 'amsUpdateAuditor' | 'approveFrameworkSeatRequest' | 'approveOrderApprovalRequest' | 'assignUserFrameworkSeat' | 'backfillFrameworkSmartFillEntitlements' | 'bannedEmailBatchStatusChange' | 'bannedEmailDelete' | 'bannedEmailStatusChange' | 'bannedEmailUpsert' | 'biometricsClear' | 'biometricsSetup' | 'callsCaseCreate' | 'callsCaseUpdate' | 'cancelMyAccessRequest' | 'cancelMyApprovalRequest' | 'cancelMyUnsignedOrder' | 'cancelOrder' | 'cancelPlanDowngrade' | 'carbonLensFinalizeSSO' | 'carbonLensInitializeSSO' | 'caseActivityCreate' | 'caseActivitySettingsBatchUpsert' | 'caseActivitySettingsUpsert' | 'caseAnalyticsReportPdf' | 'caseAnonymitySettingsDelete' | 'caseAssignmentDelete' | 'caseAssignmentUpsert' | 'caseAttachmentUpload' | 'caseBusinessUnitAssign' | 'caseClose' | 'caseConversationUpdate' | 'caseCustomReminderDelete' | 'caseCustomReminderUpsert' | 'caseCustomTitleUpdate' | 'caseDetailsUpdate' | 'caseIncidentTypeAssign' | 'caseIndividualInvolvedMessageSend' | 'caseIndividualInvolvedUpsert' | 'caseIndividualsInvolvedDelete' | 'caseInvestigationPdfReportGenerate' | 'caseInvestigationsXlsxReportGenerate' | 'caseInvestigatorsUpdate' | 'caseOwnerExclusionUpsert' | 'caseOwnerExclusionsDelete' | 'caseReopen' | 'caseReportCreate' | 'caseSettingsUpdate' | 'caseTriageScoreUpdate' | 'casesSubsidiarySiteUpdate' | 'changeDisclosureStatus' | 'changeOrderSigner' | 'changePassword' | 'changeSurveyReminder' | 'changeSurveyStatus' | 'chatRoomFilesUpload' | 'chatbotCreate' | 'chatbotMessageCreate' | 'checkPasswordResetToken' | 'composeOrder' | 'conclusionTypeBatchUpsert' | 'conclusionTypeUpsert' | 'confirmCheckoutEmailVerification' | 'confirmMfaSetup' | 'confirmReporterEmailVerification' | 'correctMyBillingIdentity' | 'correctOrderBillingIdentity' | 'createAssistantSlot' | 'createAssuranceOrder' | 'createAuditOrder' | 'createBusinessUnit' | 'createCheckoutOrder' | 'createCheckoutSession' | 'createCourseOrder' | 'createEmployeeAccount' | 'createPlanUpgradeOrder' | 'createSessionHandoffCode' | 'customPlanUpdate' | 'dataCategoryCreate' | 'dataCategoryCreateMany' | 'declineFrameworkSeatRequest' | 'declineShopApprovalRequest' | 'deleteAssistantSlot' | 'deleteBannedEmail' | 'deleteDisclosureDraft' | 'deleteEmailEntry' | 'deleteEmailList' | 'deleteEmailTarget' | 'deleteEmployeeAccount' | 'deleteForwardEarthCredentials' | 'deleteTenantLogo' | 'disablePushNotificationsForDevice' | 'disclosureDelete' | 'disclosureResponseApprove' | 'disclosureResponseCommentUpsert' | 'disclosureRiskAreasUpsert' | 'disclosureUpsert' | 'disclosureUserFill' | 'editEmailEntry' | 'editEmailTarget' | 'electPlanDowngrade' | 'elineNumberDelete' | 'elineNumberUpsert' | 'emailListDelete' | 'emailListUpsert' | 'emailTemplateCarbonCopyUpdate' | 'emailTemplateUpdate' | 'emailTemplatesStatusUpdate' | 'enablePushNotificationsForDevice' | 'esgActivityReportGenerate' | 'esgAnswerDelete' | 'esgAnswerDraftUpsertByVersionData' | 'esgAnswerFilesSet' | 'esgAnswerGenerate' | 'esgAnswerUpsert' | 'esgAnswerUpsertByUuid' | 'esgAnswerUpsertByVersionData' | 'esgAuditReportGenerate' | 'esgCountryReportGenerate' | 'esgDeleteFrameworkDocument' | 'esgEsrsReportGenerate' | 'esgFilesUpload' | 'esgFrameworkAuditAuditorAdd' | 'esgFrameworkAuditAuditorRemove' | 'esgFrameworkAuditComplete' | 'esgFrameworkAuditEntryCreate' | 'esgFrameworkAuditGapAnalysisStart' | 'esgFrameworkAuditGapSuggestionAccept' | 'esgFrameworkAuditGapSuggestionDismiss' | 'esgFrameworkAuditRequest' | 'esgGapAnalysisStart' | 'esgGriReportGenerate' | 'esgQuestionAssignFiles' | 'esgQuestionAssignFilesDraft' | 'esgQuestionCaptureEvidence' | 'esgQuestionUnassignFiles' | 'esgQuestionUnassignFilesDraft' | 'esgQuestionUpdate' | 'esgRegisterFrameworkDocuments' | 'esgSetSmartFillDocumentStatus' | 'esgSmartFillAcceptDraft' | 'esgSmartFillApplyDrafts' | 'esgSmartFillCancel' | 'esgSmartFillDismissDraft' | 'esgSmartFillIngestDrafts' | 'esgSmartFillResume' | 'esgSmartFillStart' | 'esgStakeholderReportGenerate' | 'esgStandardReportGenerate' | 'exchangeAzureSingleSignOnToken' | 'exportMetric' | 'fetchDisclosureReport' | 'fetchPdfSurveyReport' | 'fetchWhistleblowerCaseReportPdf' | 'forwardEarthDataFetch' | 'frameworkImport' | 'generateAiReport' | 'genericPlanUpdate' | 'getFirebaseToken' | 'glossaryInsert' | 'graphStorageUpdate' | 'groupTagUpsert' | 'groupTagsDelete' | 'guidelineDelete' | 'guidelineUpsert' | 'holdQuote' | 'hotspotBurn' | 'hotspotBurnAll' | 'hotspotReset' | 'initFirebaseChatRoom' | 'ixbrlGenerate' | 'knowledgeLibraryDeleteMany' | 'knowledgeLibraryGenerateAnswers' | 'knowledgeLibraryUpsert' | 'linkAnswersToMetric' | 'linkMetricsToAnswer' | 'linkMetricsToAnswerByUuidOrVersion' | 'logHelpZeroResultSearch' | 'loginAdminWithMagicLink' | 'loginAzureSso' | 'loginBiometrics' | 'loginExternal' | 'loginGuest' | 'loginPassword' | 'loginSpreadsheetServer' | 'loginWithMfa' | 'markAllNotificationsAsRead' | 'markAllNotificationsAsUnread' | 'markEngagementDelivered' | 'markNotificationsAsRead' | 'markNotificationsAsUnread' | 'markQuestionAsAnswered' | 'markQuestionAsAnsweredDraft' | 'metricDataDeleteByUuid' | 'metricDataUpsert' | 'metricDeleteByUuid' | 'metricFavouriteToggle' | 'metricUpsert' | 'mfaResetConfirm' | 'mfaResetRequest' | 'mySpeekiSignIn' | 'nicoleAvatarDelete' | 'nicoleAvatarSettingUpdate' | 'nicoleAvatarUpload' | 'nicoleGptSessionContinue' | 'nicoleGptSessionDescriptionUpdate' | 'nicoleGptSessionEntryRegenerate' | 'nicoleGptSessionInitialize' | 'nicoleGptSessionsDelete' | 'oAuthClientUpsert' | 'oAuthClientsDelete' | 'planUpdate' | 'questionnaireFiltersSet' | 'reAddMissedProvisioningEmit' | 'recordHelpArticleVote' | 'redeemMfaHandoffCode' | 'redeemSessionHandoffCode' | 'refreshAdminSession' | 'refreshAmsSession' | 'refreshSession' | 'regionUpsert' | 'releaseNoteMarkRead' | 'releaseNoteUpsert' | 'removeTeamsId' | 'renewalNoticeGive' | 'renewalNoticeWithdraw' | 'reportCaseFilesUpload' | 'reportCaseStart' | 'reportCaseSubmit' | 'reportCaseSummarize' | 'reportDeleteCaseFiles' | 'reportEditConversation' | 'reportPromptTemplateDelete' | 'reportPromptTemplateUpsert' | 'reportingGroupUpsert' | 'reportingGroupsDelete' | 'reportingPeriodSet' | 'reportingSourceBatchUpsert' | 'reportingSourceUpsert' | 'requestAccountUnlock' | 'requestAdminMagicLink' | 'requestCheckoutEmailVerification' | 'requestFramework' | 'requestFrameworkSeat' | 'requestMfaSetup' | 'requestOrderApproval' | 'requestPasswordReset' | 'requestPlanApproval' | 'requestPlanByPass' | 'requestReporterEmailVerification' | 'requestServicePricing' | 'requestTenantAccess' | 'requestTenantAccessByDomain' | 'resendAuthEmail' | 'resendCreateTenantEmail' | 'resendOrderSigningEmail' | 'resetPassword' | 'respondQuestionnaireEntriesDelete' | 'respondQuestionnaireEntriesUpsert' | 'respondQuestionnaireUpsert' | 'respondQuestionnaireV2ChangeStatus' | 'respondQuestionnaireV2Create' | 'respondQuestionnaireV2Delete' | 'respondQuestionnaireV2EntriesDelete' | 'respondQuestionnaireV2EntriesUpdateByAddress' | 'respondQuestionnaireV2EntriesUpdateByUuid' | 'respondQuestionnaireV2EntryUpdateByAddress' | 'respondQuestionnaireV2EntryUpdateByUuid' | 'respondQuestionnaireV2MarkAsSaved' | 'respondQuestionnaireV2UpdateExcelFile' | 'respondQuestionnairesDelete' | 'riskAreaSettingsSet' | 'riskAreaUpdate' | 'rolesChangeStatus' | 'rolesDelete' | 'rolesUpsert' | 'sectorsSetState' | 'sendConversationMessage' | 'sendInvitationEmail' | 'sendOrderForSignature' | 'sendPortalSupportRequest' | 'setFitnessVariableValue' | 'setMsTenantID' | 'setMySpeekiSignInEnabled' | 'setRecoveryEmail' | 'setRecoveryEmailTenantAdmin' | 'setRiskAreaSettingsByProgram' | 'setSpeekiPick' | 'setTenantRiskAreaCustomLabel' | 'setTenantRiskAreaSettings' | 'setTopicMaterialInScope' | 'setupAzureSingleSignOnForTenant' | 'signOutAmsSession' | 'skipMfa' | 'ssoAzureSetup' | 'ssoProviderDelete' | 'ssoProviderUpsert' | 'subscriptionRenewalRequest' | 'subsidiarySiteHeadquartersReportingLabelUpdate' | 'subsidiarySiteRoleUpdate' | 'subsidiarySiteStatusUpdate' | 'subsidiarySiteSwitch' | 'subsidiarySiteUpdate' | 'subsidiarySiteUpsert' | 'surveyRiskAreasUpsert' | 'surveySummary' | 'surveyTemplateUpsert' | 'surveyTemplatesDeletion' | 'surveyUpsert' | 'surveyUserFill' | 'surveysDeletion' | 'symbolDelete' | 'symbolUpsert' | 'tagCreateForVersion' | 'tagDescriptionDelete' | 'tagDescriptionUpdate' | 'tagUpdate' | 'tagUpsert' | 'tagsDelete' | 'tagsUpsert' | 'targetBatchDelete' | 'targetDelete' | 'targetUpsert' | 'taskDelete' | 'taskMarkAsSeen' | 'taskUpdateStatus' | 'taskUpsert' | 'taxonomyReportCreate' | 'taxonomyReportFactDelete' | 'taxonomyReportFactUpsert' | 'templateDelete' | 'templateRiskAreasUpsert' | 'templateUpsert' | 'tenantAdminInvite' | 'tenantAdminInviteFinish' | 'tenantAdminInviteWithFrameworkSeat' | 'tenantAdminRegionsChange' | 'tenantAdminRolesUpdate' | 'tenantAdminUpdate' | 'tenantAdminsStatusesUpdate' | 'tenantAuditRenewalBackfill' | 'tenantBeginSetup' | 'tenantChangeStatus' | 'tenantCheckStatus' | 'tenantCountryUpdate' | 'tenantDomainVerify' | 'tenantDomainsBackfill' | 'tenantHeadlineRemove' | 'tenantHeadlineUpdate' | 'tenantInformationUpdate' | 'tenantLicenseCountUpdate' | 'tenantNameUpdate' | 'tenantPrimaryContactDataUpdate' | 'tenantRenewalRecordCustomerNotice' | 'tenantRenewalStop' | 'tenantRenewalWithdraw' | 'tenantSignup' | 'tenantSignupVerified' | 'tenantStandardsStatusBatchUpdate' | 'tenantSubscriberEmailUpdate' | 'tenantSubscriptionDatesUpdate' | 'tenantSubscriptionUpdate' | 'tenantUnitsBatchUpdate' | 'tenantUpdateDefaultAnswerLabel' | 'tenantsDelete' | 'toggleProgramSetting' | 'translate' | 'unassignUserFrameworkSeat' | 'unlinkMetricFromAnswer' | 'unlinkQuestionFromMetric' | 'unlockAccount' | 'updateAssistantCredentials' | 'updateAssistantSlot' | 'updateBusinessUnit' | 'updateCheckoutSession' | 'updateRecoveryEmail' | 'updateTenant' | 'updateUserDetails' | 'updateUserSettings' | 'upsertBannedEmail' | 'upsertEmailList' | 'upsertForwardEarthCredentials' | 'upsertTask' | 'upsertTaskComment' | 'userEnabledStandardsSet' | 'userProfileUpdate' | 'verifyCheckoutSessionWithHubProof' | 'voidUnsignedOrder' | 'xbrlGenerate' | 'yearClearData' | 'yearClone' | 'yearCreate' | 'yearDelete' | 'yearSetActive' | 'yearSetClosed' | 'yearSetOpen' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	adminUserDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUserUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	amsInviteAuditor?: FieldPolicy<any> | FieldReadFunction<any>,
	amsReactivateAuditor?: FieldPolicy<any> | FieldReadFunction<any>,
	amsSuspendAuditor?: FieldPolicy<any> | FieldReadFunction<any>,
	amsUpdateAuditor?: FieldPolicy<any> | FieldReadFunction<any>,
	approveFrameworkSeatRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	approveOrderApprovalRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	assignUserFrameworkSeat?: FieldPolicy<any> | FieldReadFunction<any>,
	backfillFrameworkSmartFillEntitlements?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailBatchStatusChange?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailStatusChange?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	biometricsClear?: FieldPolicy<any> | FieldReadFunction<any>,
	biometricsSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	callsCaseCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	callsCaseUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelMyAccessRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelMyApprovalRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelMyUnsignedOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelPlanDowngrade?: FieldPolicy<any> | FieldReadFunction<any>,
	carbonLensFinalizeSSO?: FieldPolicy<any> | FieldReadFunction<any>,
	carbonLensInitializeSSO?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivityCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySettingsBatchUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySettingsUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnalyticsReportPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnonymitySettingsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignmentDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignmentUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAttachmentUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	caseBusinessUnitAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	caseClose?: FieldPolicy<any> | FieldReadFunction<any>,
	caseConversationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCustomReminderDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCustomReminderUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCustomTitleUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseDetailsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIncidentTypeAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualInvolvedMessageSend?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualInvolvedUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualsInvolvedDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigationPdfReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigationsXlsxReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigatorsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusionUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusionsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseReopen?: FieldPolicy<any> | FieldReadFunction<any>,
	caseReportCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseSettingsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseTriageScoreUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	casesSubsidiarySiteUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	changeDisclosureStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	changeOrderSigner?: FieldPolicy<any> | FieldReadFunction<any>,
	changePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	changeSurveyReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	changeSurveyStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomFilesUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbotCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbotMessageCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkPasswordResetToken?: FieldPolicy<any> | FieldReadFunction<any>,
	composeOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypeBatchUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypeUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmCheckoutEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmMfaSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmReporterEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	correctMyBillingIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	correctOrderBillingIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	createAssistantSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	createAssuranceOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createAuditOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createCheckoutOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createCourseOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmployeeAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	createPlanUpgradeOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createSessionHandoffCode?: FieldPolicy<any> | FieldReadFunction<any>,
	customPlanUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryCreateMany?: FieldPolicy<any> | FieldReadFunction<any>,
	declineFrameworkSeatRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	declineShopApprovalRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAssistantSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBannedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDisclosureDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailList?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmployeeAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteForwardEarthCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTenantLogo?: FieldPolicy<any> | FieldReadFunction<any>,
	disablePushNotificationsForDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseCommentUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureRiskAreasUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserFill?: FieldPolicy<any> | FieldReadFunction<any>,
	editEmailEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	editEmailTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	electPlanDowngrade?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumberDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumberUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	emailListDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	emailListUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplateCarbonCopyUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplateUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplatesStatusUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	enablePushNotificationsForDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	esgActivityReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerDraftUpsertByVersionData?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerFilesSet?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerUpsertByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerUpsertByVersionData?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAuditReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgCountryReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgDeleteFrameworkDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	esgEsrsReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFilesUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditAuditorAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditAuditorRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditEntryCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditGapAnalysisStart?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditGapSuggestionAccept?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditGapSuggestionDismiss?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	esgGapAnalysisStart?: FieldPolicy<any> | FieldReadFunction<any>,
	esgGriReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionAssignFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionAssignFilesDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionCaptureEvidence?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionUnassignFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionUnassignFilesDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgRegisterFrameworkDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSetSmartFillDocumentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillAcceptDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillApplyDrafts?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillDismissDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillIngestDrafts?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillResume?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillStart?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStakeholderReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStandardReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeAzureSingleSignOnToken?: FieldPolicy<any> | FieldReadFunction<any>,
	exportMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	fetchDisclosureReport?: FieldPolicy<any> | FieldReadFunction<any>,
	fetchPdfSurveyReport?: FieldPolicy<any> | FieldReadFunction<any>,
	fetchWhistleblowerCaseReportPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthDataFetch?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkImport?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAiReport?: FieldPolicy<any> | FieldReadFunction<any>,
	genericPlanUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	getFirebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	glossaryInsert?: FieldPolicy<any> | FieldReadFunction<any>,
	graphStorageUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelineDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelineUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	holdQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspotBurn?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspotBurnAll?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspotReset?: FieldPolicy<any> | FieldReadFunction<any>,
	initFirebaseChatRoom?: FieldPolicy<any> | FieldReadFunction<any>,
	ixbrlGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryDeleteMany?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryGenerateAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAnswersToMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	linkMetricsToAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	linkMetricsToAnswerByUuidOrVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	logHelpZeroResultSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	loginAdminWithMagicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	loginAzureSso?: FieldPolicy<any> | FieldReadFunction<any>,
	loginBiometrics?: FieldPolicy<any> | FieldReadFunction<any>,
	loginExternal?: FieldPolicy<any> | FieldReadFunction<any>,
	loginGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	loginPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	loginSpreadsheetServer?: FieldPolicy<any> | FieldReadFunction<any>,
	loginWithMfa?: FieldPolicy<any> | FieldReadFunction<any>,
	markAllNotificationsAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	markAllNotificationsAsUnread?: FieldPolicy<any> | FieldReadFunction<any>,
	markEngagementDelivered?: FieldPolicy<any> | FieldReadFunction<any>,
	markNotificationsAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	markNotificationsAsUnread?: FieldPolicy<any> | FieldReadFunction<any>,
	markQuestionAsAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	markQuestionAsAnsweredDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataDeleteByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDeleteByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricFavouriteToggle?: FieldPolicy<any> | FieldReadFunction<any>,
	metricUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	mfaResetConfirm?: FieldPolicy<any> | FieldReadFunction<any>,
	mfaResetRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	mySpeekiSignIn?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarSettingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionContinue?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionDescriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionEntryRegenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionInitialize?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	planUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireFiltersSet?: FieldPolicy<any> | FieldReadFunction<any>,
	reAddMissedProvisioningEmit?: FieldPolicy<any> | FieldReadFunction<any>,
	recordHelpArticleVote?: FieldPolicy<any> | FieldReadFunction<any>,
	redeemMfaHandoffCode?: FieldPolicy<any> | FieldReadFunction<any>,
	redeemSessionHandoffCode?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshAdminSession?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshAmsSession?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshSession?: FieldPolicy<any> | FieldReadFunction<any>,
	regionUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNoteMarkRead?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNoteUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	removeTeamsId?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalNoticeGive?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalNoticeWithdraw?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseFilesUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseStart?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseSubmit?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseSummarize?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDeleteCaseFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	reportEditConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPromptTemplateDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPromptTemplateUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroupUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroupsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingPeriodSet?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSourceBatchUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSourceUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	requestAccountUnlock?: FieldPolicy<any> | FieldReadFunction<any>,
	requestAdminMagicLink?: FieldPolicy<any> | FieldReadFunction<any>,
	requestCheckoutEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	requestFramework?: FieldPolicy<any> | FieldReadFunction<any>,
	requestFrameworkSeat?: FieldPolicy<any> | FieldReadFunction<any>,
	requestMfaSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	requestOrderApproval?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPasswordReset?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPlanApproval?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPlanByPass?: FieldPolicy<any> | FieldReadFunction<any>,
	requestReporterEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	requestServicePricing?: FieldPolicy<any> | FieldReadFunction<any>,
	requestTenantAccess?: FieldPolicy<any> | FieldReadFunction<any>,
	requestTenantAccessByDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	resendAuthEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resendCreateTenantEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resendOrderSigningEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2ChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2Create?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2Delete?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntriesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntriesUpdateByAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntriesUpdateByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntryUpdateByAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntryUpdateByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2MarkAsSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2UpdateExcelFile?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnairesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaSettingsSet?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	rolesChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rolesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	rolesUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorsSetState?: FieldPolicy<any> | FieldReadFunction<any>,
	sendConversationMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	sendInvitationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendOrderForSignature?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPortalSupportRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	setFitnessVariableValue?: FieldPolicy<any> | FieldReadFunction<any>,
	setMsTenantID?: FieldPolicy<any> | FieldReadFunction<any>,
	setMySpeekiSignInEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	setRecoveryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setRecoveryEmailTenantAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	setRiskAreaSettingsByProgram?: FieldPolicy<any> | FieldReadFunction<any>,
	setSpeekiPick?: FieldPolicy<any> | FieldReadFunction<any>,
	setTenantRiskAreaCustomLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	setTenantRiskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	setTopicMaterialInScope?: FieldPolicy<any> | FieldReadFunction<any>,
	setupAzureSingleSignOnForTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	signOutAmsSession?: FieldPolicy<any> | FieldReadFunction<any>,
	skipMfa?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoAzureSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoProviderDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoProviderUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionRenewalRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteHeadquartersReportingLabelUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteRoleUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteStatusUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteSwitch?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyRiskAreasUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveySummary?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplateUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplatesDeletion?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUserFill?: FieldPolicy<any> | FieldReadFunction<any>,
	surveysDeletion?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	tagCreateForVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	tagDescriptionDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	tagDescriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tagUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tagUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBatchDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	targetUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	taskDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taskMarkAsSeen?: FieldPolicy<any> | FieldReadFunction<any>,
	taskUpdateStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	taskUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFactDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFactUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	templateDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	templateRiskAreasUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	templateUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminInviteFinish?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminInviteWithFrameworkSeat?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminRegionsChange?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminRolesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminsStatusesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAuditRenewalBackfill?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantBeginSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantCheckStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantCountryUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantDomainVerify?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantDomainsBackfill?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantHeadlineRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantHeadlineUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantInformationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantLicenseCountUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantNameUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantPrimaryContactDataUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantRenewalRecordCustomerNotice?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantRenewalStop?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantRenewalWithdraw?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSignup?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSignupVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantStandardsStatusBatchUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSubscriberEmailUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSubscriptionDatesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSubscriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUnitsBatchUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUpdateDefaultAnswerLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleProgramSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	translate?: FieldPolicy<any> | FieldReadFunction<any>,
	unassignUserFrameworkSeat?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkMetricFromAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkQuestionFromMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAssistantCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAssistantSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCheckoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRecoveryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertBannedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertEmailList?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertForwardEarthCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertTask?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertTaskComment?: FieldPolicy<any> | FieldReadFunction<any>,
	userEnabledStandardsSet?: FieldPolicy<any> | FieldReadFunction<any>,
	userProfileUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyCheckoutSessionWithHubProof?: FieldPolicy<any> | FieldReadFunction<any>,
	voidUnsignedOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	xbrlGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	yearClearData?: FieldPolicy<any> | FieldReadFunction<any>,
	yearClone?: FieldPolicy<any> | FieldReadFunction<any>,
	yearCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	yearDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	yearSetActive?: FieldPolicy<any> | FieldReadFunction<any>,
	yearSetClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	yearSetOpen?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MySpeekiCompanyKeySpecifier = ('mfaEnforced' | 'name' | 'role' | 'tenantUuid' | MySpeekiCompanyKeySpecifier)[];
export type MySpeekiCompanyFieldPolicy = {
	mfaEnforced?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MySpeekiProfileKeySpecifier = ('company' | 'name' | MySpeekiProfileKeySpecifier)[];
export type MySpeekiProfileFieldPolicy = {
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MySpeekiSignInResultKeySpecifier = ('choiceToken' | 'companies' | 'mfaHandoffCode' | 'profile' | 'refreshToken' | 'sessionToken' | 'status' | 'tenantUuid' | MySpeekiSignInResultKeySpecifier)[];
export type MySpeekiSignInResultFieldPolicy = {
	choiceToken?: FieldPolicy<any> | FieldReadFunction<any>,
	companies?: FieldPolicy<any> | FieldReadFunction<any>,
	mfaHandoffCode?: FieldPolicy<any> | FieldReadFunction<any>,
	profile?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionKeySpecifier = ('createdAt' | 'description' | 'entries' | 'lastUpdatedAt' | 'uuid' | NicoleGptSessionKeySpecifier)[];
export type NicoleGptSessionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | NicoleGptSessionConnectionKeySpecifier)[];
export type NicoleGptSessionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEdgeKeySpecifier = ('cursor' | 'node' | NicoleGptSessionEdgeKeySpecifier)[];
export type NicoleGptSessionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEntryKeySpecifier = ('confidenceReasoning' | 'confidenceScore' | 'content' | 'createdAt' | 'hallucinationReasoning' | 'isAssistant' | 'isGenerated' | 'isHallucinated' | 'lastUpdatedAt' | 'riskAreas' | 'sourcesUsed' | 'uuid' | NicoleGptSessionEntryKeySpecifier)[];
export type NicoleGptSessionEntryFieldPolicy = {
	confidenceReasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	hallucinationReasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	isAssistant?: FieldPolicy<any> | FieldReadFunction<any>,
	isGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	isHallucinated?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEntryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | NicoleGptSessionEntryConnectionKeySpecifier)[];
export type NicoleGptSessionEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEntryEdgeKeySpecifier = ('cursor' | 'node' | NicoleGptSessionEntryEdgeKeySpecifier)[];
export type NicoleGptSessionEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('channel' | 'createdAt' | 'createdByUuid' | 'payload' | 'readNotification' | 'type' | 'uuid' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	readNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationContentsKeySpecifier = ('body' | 'title' | NotificationContentsKeySpecifier)[];
export type NotificationContentsFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationDataKeySpecifier = ('extra' | 'refUuid' | 'type' | NotificationDataKeySpecifier)[];
export type NotificationDataFieldPolicy = {
	extra?: FieldPolicy<any> | FieldReadFunction<any>,
	refUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationEdgeKeySpecifier = ('cursor' | 'node' | NotificationEdgeKeySpecifier)[];
export type NotificationEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationPageKeySpecifier = ('edges' | 'info' | NotificationPageKeySpecifier)[];
export type NotificationPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationPaginatedKeySpecifier = ('page' | 'totalCount' | NotificationPaginatedKeySpecifier)[];
export type NotificationPaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationPayloadKeySpecifier = ('data' | 'metadata' | 'notification' | 'reference' | 'type' | NotificationPayloadKeySpecifier)[];
export type NotificationPayloadFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OAuthClientKeySpecifier = ('clientId' | 'clientName' | 'clientSecret' | 'clusterId' | 'grantTypes' | 'redirectUris' | 'scope' | 'uuid' | OAuthClientKeySpecifier)[];
export type OAuthClientFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	clientName?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	grantTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUris?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OAuthClientConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | OAuthClientConnectionKeySpecifier)[];
export type OAuthClientConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OAuthClientEdgeKeySpecifier = ('cursor' | 'node' | OAuthClientEdgeKeySpecifier)[];
export type OAuthClientEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('billingAddress' | 'billingCadence' | 'billingEntityName' | 'billingStatus' | 'buyerCountry' | 'commitment' | 'createdAt' | 'currency' | 'gstApplicable' | 'initiatorType' | 'invoiceRecipientEmail' | 'invoiceRecipientFirstName' | 'invoiceRecipientLastName' | 'invoiceState' | 'items' | 'lastResentAt' | 'paymentSplit' | 'quarterlyInstalmentAmount' | 'riskAreaUuids' | 'sentForSignatureAt' | 'signatureDeadline' | 'signedAt' | 'signerEmail' | 'status' | 'taxBasis' | 'taxRatePercent' | 'total' | 'updatedAt' | 'uuid' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	billingCadence?: FieldPolicy<any> | FieldReadFunction<any>,
	billingEntityName?: FieldPolicy<any> | FieldReadFunction<any>,
	billingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	buyerCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	commitment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	gstApplicable?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatorType?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRecipientEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRecipientFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRecipientLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceState?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	lastResentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSplit?: FieldPolicy<any> | FieldReadFunction<any>,
	quarterlyInstalmentAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	sentForSignatureAt?: FieldPolicy<any> | FieldReadFunction<any>,
	signatureDeadline?: FieldPolicy<any> | FieldReadFunction<any>,
	signedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	signerEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	taxBasis?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRatePercent?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderBillingStatusKeySpecifier = ('amountDue' | 'amountPaid' | 'creditNoteStatus' | 'creditedAmount' | 'invoiceId' | 'invoiceNumber' | 'status' | 'unavailable' | OrderBillingStatusKeySpecifier)[];
export type OrderBillingStatusFieldPolicy = {
	amountDue?: FieldPolicy<any> | FieldReadFunction<any>,
	amountPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	creditNoteStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	creditedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCommitmentKeySpecifier = ('anchorMode' | 'annualAmount' | 'commencementDate' | 'currency' | 'masterTerm' | 'schedule' | 'termYears' | 'tierId' | 'totalAmount' | OrderCommitmentKeySpecifier)[];
export type OrderCommitmentFieldPolicy = {
	anchorMode?: FieldPolicy<any> | FieldReadFunction<any>,
	annualAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	commencementDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	masterTerm?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	termYears?: FieldPolicy<any> | FieldReadFunction<any>,
	tierId?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderEventKeySpecifier = ('fromStatus' | 'occurredAt' | 'providerRef' | 'reason' | 'toStatus' | 'trigger' | 'uuid' | OrderEventKeySpecifier)[];
export type OrderEventFieldPolicy = {
	fromStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	providerRef?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	toStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineKeySpecifier = ('kind' | 'quantity' | 'ref' | 'uuid' | OrderLineKeySpecifier)[];
export type OrderLineFieldPolicy = {
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	ref?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OriginalReportKeySpecifier = ('incidentType' | 'language' | 'reporter' | 'reportingSource' | OriginalReportKeySpecifier)[];
export type OriginalReportFieldPolicy = {
	incidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	reporter?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'pageSize' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoV2KeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'pageSize' | 'startCursor' | PageInfoV2KeySpecifier)[];
export type PageInfoV2FieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerIntegrityDomainRuleKeySpecifier = ('feeUsd' | 'id' | 'label' | 'reviews' | PartnerIntegrityDomainRuleKeySpecifier)[];
export type PartnerIntegrityDomainRuleFieldPolicy = {
	feeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	reviews?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerIntegrityReportLevelRuleKeySpecifier = ('description' | 'id' | 'label' | PartnerIntegrityReportLevelRuleKeySpecifier)[];
export type PartnerIntegrityReportLevelRuleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerIntegrityRulesKeySpecifier = ('domains' | 'interviewFeeUsd' | 'maxDomains' | 'maxHeadcount' | 'product' | 'productName' | 'reportLevels' | PartnerIntegrityRulesKeySpecifier)[];
export type PartnerIntegrityRulesFieldPolicy = {
	domains?: FieldPolicy<any> | FieldReadFunction<any>,
	interviewFeeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDomains?: FieldPolicy<any> | FieldReadFunction<any>,
	maxHeadcount?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	reportLevels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentScheduleRowKeySpecifier = ('amountUsd' | 'label' | 'periodEnd' | 'periodStart' | 'prorated' | PaymentScheduleRowKeySpecifier)[];
export type PaymentScheduleRowFieldPolicy = {
	amountUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	prorated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingDowngradeKeySpecifier = ('createdAt' | 'effectiveAt' | 'electedTier' | 'selectedRefs' | PendingDowngradeKeySpecifier)[];
export type PendingDowngradeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	effectiveAt?: FieldPolicy<any> | FieldReadFunction<any>,
	electedTier?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedRefs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlanUpgradeCandidateKeySpecifier = ('lines' | 'targetTier' | 'upliftNowTotalCents' | PlanUpgradeCandidateKeySpecifier)[];
export type PlanUpgradeCandidateFieldPolicy = {
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	targetTier?: FieldPolicy<any> | FieldReadFunction<any>,
	upliftNowTotalCents?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlanUpgradeContextKeySpecifier = ('anchorTier' | 'blockedReason' | 'candidates' | 'contractedAnnualRateUsd' | 'discountBpsApplied' | 'discountReason' | 'gstApplicable' | 'listAnnualRateUsd' | 'pendingDowngrade' | 'planChangeInFlight' | 'renewalDate' | 'standards' | 'taxRatePercent' | PlanUpgradeContextKeySpecifier)[];
export type PlanUpgradeContextFieldPolicy = {
	anchorTier?: FieldPolicy<any> | FieldReadFunction<any>,
	blockedReason?: FieldPolicy<any> | FieldReadFunction<any>,
	candidates?: FieldPolicy<any> | FieldReadFunction<any>,
	contractedAnnualRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	discountBpsApplied?: FieldPolicy<any> | FieldReadFunction<any>,
	discountReason?: FieldPolicy<any> | FieldReadFunction<any>,
	gstApplicable?: FieldPolicy<any> | FieldReadFunction<any>,
	listAnnualRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingDowngrade?: FieldPolicy<any> | FieldReadFunction<any>,
	planChangeInFlight?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalDate?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRatePercent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlanUpgradeQuoteLineKeySpecifier = ('annualDeltaCents' | 'currentTier' | 'name' | 'riskAreaUuid' | 'selectable' | 'upliftNowCents' | PlanUpgradeQuoteLineKeySpecifier)[];
export type PlanUpgradeQuoteLineFieldPolicy = {
	annualDeltaCents?: FieldPolicy<any> | FieldReadFunction<any>,
	currentTier?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	selectable?: FieldPolicy<any> | FieldReadFunction<any>,
	upliftNowCents?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlanUpgradeStandardTierKeySpecifier = ('basicLicenceAcceptance' | 'currentTier' | 'freeTierGranted' | 'grantedTier' | 'name' | 'ownedSource' | 'riskAreaUuid' | PlanUpgradeStandardTierKeySpecifier)[];
export type PlanUpgradeStandardTierFieldPolicy = {
	basicLicenceAcceptance?: FieldPolicy<any> | FieldReadFunction<any>,
	currentTier?: FieldPolicy<any> | FieldReadFunction<any>,
	freeTierGranted?: FieldPolicy<any> | FieldReadFunction<any>,
	grantedTier?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	ownedSource?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PortalAccessRequestKeySpecifier = ('companyName' | 'createdAt' | 'declineReason' | 'message' | 'nextReminderAt' | 'requestUuid' | 'resolvedAt' | 'status' | PortalAccessRequestKeySpecifier)[];
export type PortalAccessRequestFieldPolicy = {
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	declineReason?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	nextReminderAt?: FieldPolicy<any> | FieldReadFunction<any>,
	requestUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PortalDomainOfferKeySpecifier = ('companyName' | PortalDomainOfferKeySpecifier)[];
export type PortalDomainOfferFieldPolicy = {
	companyName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PortalFrameworkKeySpecifier = ('name' | 'uuid' | PortalFrameworkKeySpecifier)[];
export type PortalFrameworkFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PortalLinkKeySpecifier = ('activeFrameworks' | 'companyName' | 'engageSeat' | 'planName' | 'role' | 'subscriptionEndsAt' | 'tenantUuid' | PortalLinkKeySpecifier)[];
export type PortalLinkFieldPolicy = {
	activeFrameworks?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	engageSeat?: FieldPolicy<any> | FieldReadFunction<any>,
	planName?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionEndsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PresignedCaseFileKeySpecifier = ('mimeType' | 'name' | 'size' | 'url' | 'uuid' | PresignedCaseFileKeySpecifier)[];
export type PresignedCaseFileFieldPolicy = {
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrimaryContactKeySpecifier = ('email' | 'firstName' | 'lastName' | PrimaryContactKeySpecifier)[];
export type PrimaryContactFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductProvisioningHistoryKeySpecifier = ('actorId' | 'actorType' | 'affectedTenantUuids' | 'correlationId' | 'createdAt' | 'eventId' | 'eventType' | 'itemId' | 'itemType' | 'newValue' | 'occurredAt' | 'oldValue' | 'parentEventId' | 'prevHash' | 'reason' | 'rowHash' | 'scope' | 'tenantUuid' | 'uuid' | ProductProvisioningHistoryKeySpecifier)[];
export type ProductProvisioningHistoryFieldPolicy = {
	actorId?: FieldPolicy<any> | FieldReadFunction<any>,
	actorType?: FieldPolicy<any> | FieldReadFunction<any>,
	affectedTenantUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	correlationId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	newValue?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	parentEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	prevHash?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	rowHash?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductProvisioningHistoryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ProductProvisioningHistoryConnectionKeySpecifier)[];
export type ProductProvisioningHistoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductProvisioningHistoryEdgeKeySpecifier = ('cursor' | 'node' | ProductProvisioningHistoryEdgeKeySpecifier)[];
export type ProductProvisioningHistoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProgramKeySpecifier = ('category' | 'description' | 'name' | 'order' | 'riskAreas' | 'uuid' | ProgramKeySpecifier)[];
export type ProgramFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProgramCategoryKeySpecifier = ('name' | 'riskAreas' | 'uuid' | ProgramCategoryKeySpecifier)[];
export type ProgramCategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProgramSettingCategoryKeySpecifier = ('name' | 'uuid' | ProgramSettingCategoryKeySpecifier)[];
export type ProgramSettingCategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('adminMe' | 'adminUser' | 'adminUsers' | 'amsAuditors' | 'amsMe' | 'appVersion' | 'assignedTagNames' | 'assignees' | 'assignors' | 'assistantCredentials' | 'assistantSlots' | 'auditEvent' | 'auditEvents' | 'auditReadyPrice' | 'auditorSeatAvailable' | 'bannedEmail' | 'bannedEmails' | 'basicLicenceTerms' | 'beaconPrice' | 'beaconRules' | 'businessUnits' | 'callsCaseDetails' | 'carbonLensPrice' | 'caseAnalytics' | 'caseAnonymityRestrictions' | 'caseAnonymitySettings' | 'caseIndividualInvolvedEmails' | 'caseInvestigation' | 'caseInvestigations' | 'caseParsedMessageGet' | 'caseReports' | 'caseSettings' | 'chatRoomFileInfo' | 'checkYearDataStatus' | 'checkoutSession' | 'checkoutTermsContext' | 'client' | 'clientSubsidiarySiteByName' | 'clientSubsidiarySites' | 'clientUsers' | 'clients' | 'countryAnonymityEnabled' | 'countryAnonymityValidate' | 'customPlan' | 'customerAgreement' | 'dataCategoryByName' | 'dataCategoryByUuid' | 'dataCategoryList' | 'dictionaryTranslated' | 'disclosureAdminList' | 'disclosureAdminListV2' | 'disclosureCommentsList' | 'disclosureDetails' | 'disclosureEmployeeUserResponseList' | 'disclosureEmployeeUserResponseListV2' | 'disclosureResponders' | 'disclosureResponseAnalyticsList' | 'disclosureResponseAnalyticsListV2' | 'disclosureResponseByUuid' | 'disclosureResponseDetails' | 'disclosureUserList' | 'disclosureUserListV2' | 'disclosureUserResponseList' | 'disclosureUserResponseListV2' | 'disclosureUserStatistics' | 'disclosuresUserCount' | 'emailList' | 'emailListDetails' | 'emailLists' | 'esgActivitiesForActivityReport' | 'esgAnswerByUuid' | 'esgAnswersByQuestion' | 'esgCategories' | 'esgCategoryByName' | 'esgFileByUuid' | 'esgFiles' | 'esgFrameworkAuditEntries' | 'esgFrameworkAuditEvidenceCitations' | 'esgFrameworkAuditGapRun' | 'esgFrameworkAuditGapSuggestions' | 'esgFrameworkAuditSummary' | 'esgFrameworkAudits' | 'esgFrameworkAuditsAdmin' | 'esgFrameworkDocuments' | 'esgGroupTagsSelector' | 'esgQuestion' | 'esgQuestionFiles' | 'esgQuestionSearchRecent' | 'esgQuestionsActivities' | 'esgQuestionsSearchConnection' | 'esgQuestionsUnmapped' | 'esgQuestionsUnmappedConnection' | 'esgSmartFillEvidenceCitations' | 'esgSmartFillPendingDrafts' | 'esgStatistics' | 'esgStepsForAuditReport' | 'esgStepsWithAnyQuestions' | 'esgSubcategories' | 'esgSubcategoryByName' | 'esgSubcategoryByUuid' | 'esgTagsSelect' | 'esgUnansweredQuestionsCount' | 'esgVideos' | 'execEdCourses' | 'execEdPrice' | 'findGlobalTenantDataByCode' | 'findGlobalTenantDataByName' | 'frameworkCatalog' | 'frameworkImportCategories' | 'frameworkImportFrameworks' | 'frameworkSeatRequests' | 'frameworkSeatRoster' | 'genericPlan' | 'genericPlans' | 'getActiveSsoMethodsForTenant' | 'getAdminTenantDetails' | 'getGlobalTenantDataByCode' | 'getGlobalTenantDataByMicrosoftTenantId' | 'getGlobalTenantDataByReportingSlug' | 'getGlobalTenantDataByUuid' | 'getMinimumSupportedMobileAppVersions' | 'getMyNotificationTopics' | 'getSamlRequestDetailsForTenant' | 'getSsoTenantInformation' | 'getTenantByCompanyCode' | 'getTenantByUuid' | 'getUnreadNotificationCount' | 'getUserByUuid' | 'glossary' | 'glossaryMarkdown' | 'greenDeskPrice' | 'groupTag' | 'groupTags' | 'groupTagsNameSearch' | 'groupTagsRows' | 'guardianPrice' | 'guidelines' | 'guidelinesByUuids' | 'guidelinesCategoriesNames' | 'guidelinesForProgramme' | 'heldQuote' | 'incidentTypes' | 'industryUnits' | 'investigationCaseDetails' | 'isoCertificationPrice' | 'isoCertificationRules' | 'knowledgeLibraryExamples' | 'knowledgeLibraryList' | 'linkedTags' | 'listNotifications' | 'me' | 'metricByUuid' | 'metricDataByMetricUuidAndYear' | 'metricDataByUuid' | 'metricDataColumnsList' | 'metricDataRowSelect' | 'metricDataYears' | 'metricList' | 'metricOwners' | 'missedProvisioningEmits' | 'myAccessRequests' | 'myAvailableToAdd' | 'myBillingIdentity' | 'myClientHoldings' | 'myDomainOffer' | 'myEntitlements' | 'myHeldQuotes' | 'myInvoicePdf' | 'myInvoices' | 'myOrders' | 'myPortalLinks' | 'myShopCatalogue' | 'myUnfinishedOrders' | 'nicoleGptSession' | 'nicoleGptSessions' | 'oAuthClientByUuid' | 'oAuthClientList' | 'order' | 'orderEvents' | 'orderScheduleDetail' | 'partnerIntegrityPrice' | 'partnerIntegrityRules' | 'planUpgradeContext' | 'productProvisioningHistory' | 'program' | 'programRiskAreasByCategory' | 'programSettings' | 'programsList' | 'questionSearchLinkedCount' | 'questionSearchRiskAreas' | 'questionSearchSteps' | 'questionnaireFilters' | 'questionnaireNavigation' | 'questionnaireNavigationQuestions' | 'ratingsReadyPrice' | 'ratingsReadyRules' | 'releaseNote' | 'reportAudiences' | 'reportCaseDetails' | 'reportCaseDetailsUnlogged' | 'reportCaseExclusionOwnerList' | 'reportCaseExclusionOwners' | 'reportCases' | 'reportCasesStatistics' | 'reportPresignedCaseFile' | 'reportPromptTemplateByUuid' | 'reportsPromptsTemplates' | 'respondQuestionnaire' | 'respondQuestionnaireEntriesCsv' | 'respondQuestionnaireEntriesList' | 'respondQuestionnaireEntry' | 'respondQuestionnaireList' | 'respondQuestionnaireV2Entries' | 'respondQuestionnaireV2GetByUuid' | 'respondQuestionnairesV2' | 'riskAreaByActivity' | 'riskAreaByName' | 'riskAreaByUuid' | 'riskAreaSettingsByProgram' | 'riskAreas' | 'riskAreasWithAnyQuestions' | 'roleByUuid' | 'roles' | 'sectorByUuid' | 'setPriceRules' | 'shopApprovalRequests' | 'shopCatalogue' | 'shopHealth' | 'smartFillActiveJobs' | 'smartFillJob' | 'smartFillUnreadableFiles' | 'speekiCertPrice' | 'speekiPick' | 'spkCertificationPrice' | 'spkCertificationRules' | 'stakeholderEngagementList' | 'standardAssignedRiskAreas' | 'standardEnabledUnits' | 'standardsWithConnectedRiskAreas' | 'staticTranslations' | 'subscriptionTerm' | 'subsidiarySite' | 'subsidiarySites' | 'surveyAdminList' | 'surveyAdminListV2' | 'surveyAdminSearchList' | 'surveyResponseList' | 'surveyTemplateDetails' | 'surveyTemplateList' | 'surveyUserList' | 'surveyUserListV2' | 'surveysDetails' | 'symbolByUuid' | 'symbolList' | 'tag' | 'tags' | 'tagsNameSearch' | 'targetByUuid' | 'targetList' | 'taskByUuid' | 'taskNameHints' | 'tasks' | 'taxonomies' | 'taxonomy' | 'taxonomyConcept' | 'taxonomyConcepts' | 'taxonomyReport' | 'taxonomyReportFact' | 'taxonomyReportFacts' | 'taxonomyReportPage' | 'taxonomyReportPages' | 'taxonomyReports' | 'templateDetails' | 'templateList' | 'tenant' | 'tenantAdmins' | 'tenantFrameworkSeatOverview' | 'tenantFrameworkSmartFillEntitlements' | 'tenantOrders' | 'tenantRiskAreaSettings' | 'tenantSwitchOffPreview' | 'unmappedQuestionsCount' | 'usedCustomTags' | 'userDisclosureStatistics' | 'validateEmailTenantName' | 'verifyRegistrationCode' | 'webflow' | 'years' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	adminMe?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUser?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	amsAuditors?: FieldPolicy<any> | FieldReadFunction<any>,
	amsMe?: FieldPolicy<any> | FieldReadFunction<any>,
	appVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTagNames?: FieldPolicy<any> | FieldReadFunction<any>,
	assignees?: FieldPolicy<any> | FieldReadFunction<any>,
	assignors?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantSlots?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	auditReadyPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	auditorSeatAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	basicLicenceTerms?: FieldPolicy<any> | FieldReadFunction<any>,
	beaconPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	beaconRules?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	callsCaseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	carbonLensPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnalytics?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnonymityRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnonymitySettings?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualInvolvedEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigation?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigations?: FieldPolicy<any> | FieldReadFunction<any>,
	caseParsedMessageGet?: FieldPolicy<any> | FieldReadFunction<any>,
	caseReports?: FieldPolicy<any> | FieldReadFunction<any>,
	caseSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomFileInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	checkYearDataStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSession?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutTermsContext?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSubsidiarySiteByName?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSubsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	clientUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	clients?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAnonymityEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAnonymityValidate?: FieldPolicy<any> | FieldReadFunction<any>,
	customPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAgreement?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryByName?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryList?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureAdminList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureAdminListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureCommentsList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureEmployeeUserResponseList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureEmployeeUserResponseListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponders?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseAnalyticsList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseAnalyticsListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserResponseList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserResponseListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosuresUserCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailList?: FieldPolicy<any> | FieldReadFunction<any>,
	emailListDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	emailLists?: FieldPolicy<any> | FieldReadFunction<any>,
	esgActivitiesForActivityReport?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswersByQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	esgCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	esgCategoryByName?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFileByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditEvidenceCitations?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditGapRun?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditGapSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAudits?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkAuditsAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFrameworkDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	esgGroupTagsSelector?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionSearchRecent?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsSearchConnection?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsUnmapped?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsUnmappedConnection?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillEvidenceCitations?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillPendingDrafts?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStepsForAuditReport?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStepsWithAnyQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSubcategories?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSubcategoryByName?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSubcategoryByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgTagsSelect?: FieldPolicy<any> | FieldReadFunction<any>,
	esgUnansweredQuestionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	esgVideos?: FieldPolicy<any> | FieldReadFunction<any>,
	execEdCourses?: FieldPolicy<any> | FieldReadFunction<any>,
	execEdPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	findGlobalTenantDataByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	findGlobalTenantDataByName?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkCatalog?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkImportCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkImportFrameworks?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkSeatRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkSeatRoster?: FieldPolicy<any> | FieldReadFunction<any>,
	genericPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	genericPlans?: FieldPolicy<any> | FieldReadFunction<any>,
	getActiveSsoMethodsForTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminTenantDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByMicrosoftTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByReportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	getMinimumSupportedMobileAppVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	getMyNotificationTopics?: FieldPolicy<any> | FieldReadFunction<any>,
	getSamlRequestDetailsForTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	getSsoTenantInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantByCompanyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	getUnreadNotificationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	getUserByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	glossary?: FieldPolicy<any> | FieldReadFunction<any>,
	glossaryMarkdown?: FieldPolicy<any> | FieldReadFunction<any>,
	greenDeskPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagsNameSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagsRows?: FieldPolicy<any> | FieldReadFunction<any>,
	guardianPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelines?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesByUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesCategoriesNames?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesForProgramme?: FieldPolicy<any> | FieldReadFunction<any>,
	heldQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	industryUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	investigationCaseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCertificationPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCertificationRules?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryExamples?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryList?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	listNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	metricByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataByMetricUuidAndYear?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataColumnsList?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataRowSelect?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataYears?: FieldPolicy<any> | FieldReadFunction<any>,
	metricList?: FieldPolicy<any> | FieldReadFunction<any>,
	metricOwners?: FieldPolicy<any> | FieldReadFunction<any>,
	missedProvisioningEmits?: FieldPolicy<any> | FieldReadFunction<any>,
	myAccessRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	myAvailableToAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	myBillingIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	myClientHoldings?: FieldPolicy<any> | FieldReadFunction<any>,
	myDomainOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	myEntitlements?: FieldPolicy<any> | FieldReadFunction<any>,
	myHeldQuotes?: FieldPolicy<any> | FieldReadFunction<any>,
	myInvoicePdf?: FieldPolicy<any> | FieldReadFunction<any>,
	myInvoices?: FieldPolicy<any> | FieldReadFunction<any>,
	myOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	myPortalLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	myShopCatalogue?: FieldPolicy<any> | FieldReadFunction<any>,
	myUnfinishedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSession?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientList?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	orderScheduleDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerIntegrityPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerIntegrityRules?: FieldPolicy<any> | FieldReadFunction<any>,
	planUpgradeContext?: FieldPolicy<any> | FieldReadFunction<any>,
	productProvisioningHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	program?: FieldPolicy<any> | FieldReadFunction<any>,
	programRiskAreasByCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	programSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	programsList?: FieldPolicy<any> | FieldReadFunction<any>,
	questionSearchLinkedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	questionSearchRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	questionSearchSteps?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireNavigation?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireNavigationQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingsReadyPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingsReadyRules?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	reportAudiences?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseDetailsUnlogged?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseExclusionOwnerList?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseExclusionOwners?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCases?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCasesStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPresignedCaseFile?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPromptTemplateByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	reportsPromptsTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaire?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesList?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireList?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2Entries?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2GetByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnairesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaByActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaByName?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaSettingsByProgram?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreasWithAnyQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	roleByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	setPriceRules?: FieldPolicy<any> | FieldReadFunction<any>,
	shopApprovalRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	shopCatalogue?: FieldPolicy<any> | FieldReadFunction<any>,
	shopHealth?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFillActiveJobs?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFillJob?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFillUnreadableFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	speekiCertPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	speekiPick?: FieldPolicy<any> | FieldReadFunction<any>,
	spkCertificationPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	spkCertificationRules?: FieldPolicy<any> | FieldReadFunction<any>,
	stakeholderEngagementList?: FieldPolicy<any> | FieldReadFunction<any>,
	standardAssignedRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	standardEnabledUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	standardsWithConnectedRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	staticTranslations?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTerm?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAdminList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAdminListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAdminSearchList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyResponseList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplateDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplateList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUserList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUserListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	surveysDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolList?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsNameSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	targetByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	targetList?: FieldPolicy<any> | FieldReadFunction<any>,
	taskByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	taskNameHints?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomies?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomy?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyConcept?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyConcepts?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReport?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFact?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFacts?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportPage?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportPages?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReports?: FieldPolicy<any> | FieldReadFunction<any>,
	templateDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	templateList?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdmins?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantFrameworkSeatOverview?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantFrameworkSmartFillEntitlements?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantRiskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSwitchOffPreview?: FieldPolicy<any> | FieldReadFunction<any>,
	unmappedQuestionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	usedCustomTags?: FieldPolicy<any> | FieldReadFunction<any>,
	userDisclosureStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	validateEmailTenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyRegistrationCode?: FieldPolicy<any> | FieldReadFunction<any>,
	webflow?: FieldPolicy<any> | FieldReadFunction<any>,
	years?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionActivityKeySpecifier = ('name' | 'topicsCount' | 'uuid' | QuestionActivityKeySpecifier)[];
export type QuestionActivityFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	topicsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionActivityConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | QuestionActivityConnectionKeySpecifier)[];
export type QuestionActivityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionActivityEdgeKeySpecifier = ('cursor' | 'node' | QuestionActivityEdgeKeySpecifier)[];
export type QuestionActivityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionSearchLinkedCountKeySpecifier = ('linkedCount' | QuestionSearchLinkedCountKeySpecifier)[];
export type QuestionSearchLinkedCountFieldPolicy = {
	linkedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionSearchRiskAreaKeySpecifier = ('category' | 'customLabel' | 'name' | 'totalQuestions' | 'uuid' | QuestionSearchRiskAreaKeySpecifier)[];
export type QuestionSearchRiskAreaFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionSearchStepKeySpecifier = ('id' | 'name' | 'questions' | 'totalQuestions' | QuestionSearchStepKeySpecifier)[];
export type QuestionSearchStepFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireEntryKeySpecifier = ('accuracyReason' | 'accuracyScore' | 'answer' | 'category' | 'cellAddress' | 'conflictingKnowledgeLibraryItems' | 'conflictingKnowledgeLibraryReasoning' | 'createdAt' | 'createdBy' | 'hasConflictingKnowledgeLibraryItems' | 'lastUpdatedBy' | 'question' | 'reasoning' | 'riskAreas' | 'rowId' | 'sheetName' | 'sourcesUsed' | 'updatedAt' | 'uuid' | 'validationArgs' | 'validationMode' | 'validationType' | QuestionnaireEntryKeySpecifier)[];
export type QuestionnaireEntryFieldPolicy = {
	accuracyReason?: FieldPolicy<any> | FieldReadFunction<any>,
	accuracyScore?: FieldPolicy<any> | FieldReadFunction<any>,
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	cellAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	conflictingKnowledgeLibraryItems?: FieldPolicy<any> | FieldReadFunction<any>,
	conflictingKnowledgeLibraryReasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	hasConflictingKnowledgeLibraryItems?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	rowId?: FieldPolicy<any> | FieldReadFunction<any>,
	sheetName?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	validationArgs?: FieldPolicy<any> | FieldReadFunction<any>,
	validationMode?: FieldPolicy<any> | FieldReadFunction<any>,
	validationType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireEntryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | QuestionnaireEntryConnectionKeySpecifier)[];
export type QuestionnaireEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireEntryEdgeKeySpecifier = ('cursor' | 'node' | QuestionnaireEntryEdgeKeySpecifier)[];
export type QuestionnaireEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireFilterKeySpecifier = ('scope' | 'taskAssignees' | 'textSearch' | 'uuid' | QuestionnaireFilterKeySpecifier)[];
export type QuestionnaireFilterFieldPolicy = {
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	taskAssignees?: FieldPolicy<any> | FieldReadFunction<any>,
	textSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationKeySpecifier = ('categories' | QuestionnaireNavigationKeySpecifier)[];
export type QuestionnaireNavigationFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationCategoryKeySpecifier = ('name' | 'riskAreas' | 'uuid' | QuestionnaireNavigationCategoryKeySpecifier)[];
export type QuestionnaireNavigationCategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationRiskAreaKeySpecifier = ('customLabel' | 'name' | 'order' | 'standards' | 'statistics' | 'uuid' | QuestionnaireNavigationRiskAreaKeySpecifier)[];
export type QuestionnaireNavigationRiskAreaFieldPolicy = {
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationStandardKeySpecifier = ('name' | 'uuid' | QuestionnaireNavigationStandardKeySpecifier)[];
export type QuestionnaireNavigationStandardFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationStatisticsKeySpecifier = ('answeredQuestions' | 'totalQuestions' | QuestionnaireNavigationStatisticsKeySpecifier)[];
export type QuestionnaireNavigationStatisticsFieldPolicy = {
	answeredQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationStepKeySpecifier = ('name' | 'order' | 'questions' | 'riskAreaName' | 'section' | 'statistics' | 'uuid' | QuestionnaireNavigationStepKeySpecifier)[];
export type QuestionnaireNavigationStepFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaName?: FieldPolicy<any> | FieldReadFunction<any>,
	section?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingsReadyMultiyearRuleKeySpecifier = ('id' | 'label' | RatingsReadyMultiyearRuleKeySpecifier)[];
export type RatingsReadyMultiyearRuleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingsReadyPlatformRuleKeySpecifier = ('baseFeeUsd' | 'id' | 'label' | 'note' | RatingsReadyPlatformRuleKeySpecifier)[];
export type RatingsReadyPlatformRuleFieldPolicy = {
	baseFeeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingsReadyRulesKeySpecifier = ('multiyearOptions' | 'platforms' | 'product' | 'productName' | 'rushPercent' | 'sizeBands' | RatingsReadyRulesKeySpecifier)[];
export type RatingsReadyRulesFieldPolicy = {
	multiyearOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	platforms?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	rushPercent?: FieldPolicy<any> | FieldReadFunction<any>,
	sizeBands?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RatingsReadySizeBandRuleKeySpecifier = ('fromHeadcount' | 'label' | RatingsReadySizeBandRuleKeySpecifier)[];
export type RatingsReadySizeBandRuleFieldPolicy = {
	fromHeadcount?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReadNotificationKeySpecifier = ('readAt' | ReadNotificationKeySpecifier)[];
export type ReadNotificationFieldPolicy = {
	readAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionKeySpecifier = ('countries' | 'isActive' | 'name' | 'uuid' | RegionKeySpecifier)[];
export type RegionFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RegionConnectionKeySpecifier)[];
export type RegionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionEdgeKeySpecifier = ('cursor' | 'node' | RegionEdgeKeySpecifier)[];
export type RegionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegularRolePermissionKeySpecifier = ('permission' | 'uuid' | RegularRolePermissionKeySpecifier)[];
export type RegularRolePermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReleaseNoteKeySpecifier = ('content' | 'createdAt' | 'createdBy' | 'isNewFeature' | 'isPublished' | 'isUpdate' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'title' | 'uuid' | 'version' | ReleaseNoteKeySpecifier)[];
export type ReleaseNoteFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	isNewFeature?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	isUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportAudienceKeySpecifier = ('id' | 'label' | ReportAudienceKeySpecifier)[];
export type ReportAudienceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportCaseFileKeySpecifier = ('name' | 'size' | 'uuid' | ReportCaseFileKeySpecifier)[];
export type ReportCaseFileFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportPromptTemplateKeySpecifier = ('audience' | 'defaultTopic' | 'icon' | 'prompt' | 'purpose' | 'reportName' | 'reportNameTemplate' | 'suggestedReportLength' | 'templateName' | 'uuid' | ReportPromptTemplateKeySpecifier)[];
export type ReportPromptTemplateFieldPolicy = {
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	purpose?: FieldPolicy<any> | FieldReadFunction<any>,
	reportName?: FieldPolicy<any> | FieldReadFunction<any>,
	reportNameTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedReportLength?: FieldPolicy<any> | FieldReadFunction<any>,
	templateName?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportPromptTemplateConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ReportPromptTemplateConnectionKeySpecifier)[];
export type ReportPromptTemplateConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportPromptTemplateEdgeKeySpecifier = ('cursor' | 'node' | ReportPromptTemplateEdgeKeySpecifier)[];
export type ReportPromptTemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportResponseKeySpecifier = ('url' | ReportResponseKeySpecifier)[];
export type ReportResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportSettingsKeySpecifier = ('subsidiaryChoiceEnabled' | 'subsidiarySelectionCopy' | 'uuid' | ReportSettingsKeySpecifier)[];
export type ReportSettingsFieldPolicy = {
	subsidiaryChoiceEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySelectionCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingGroupKeySpecifier = ('businessUnits' | 'subsidiarySite' | 'uuid' | ReportingGroupKeySpecifier)[];
export type ReportingGroupFieldPolicy = {
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingGroupConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ReportingGroupConnectionKeySpecifier)[];
export type ReportingGroupConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingGroupEdgeKeySpecifier = ('cursor' | 'node' | ReportingGroupEdgeKeySpecifier)[];
export type ReportingGroupEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingSourceKeySpecifier = ('isActive' | 'name' | 'uuid' | ReportingSourceKeySpecifier)[];
export type ReportingSourceFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingSourceConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ReportingSourceConnectionKeySpecifier)[];
export type ReportingSourceConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingSourceEdgeKeySpecifier = ('cursor' | 'node' | ReportingSourceEdgeKeySpecifier)[];
export type ReportingSourceEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RequestCheckoutEmailVerificationKeySpecifier = ('cooldownSeconds' | 'expiresAt' | 'sent' | RequestCheckoutEmailVerificationKeySpecifier)[];
export type RequestCheckoutEmailVerificationFieldPolicy = {
	cooldownSeconds?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RequestReporterEmailVerificationKeySpecifier = ('cooldownSeconds' | 'expiresAt' | 'sent' | RequestReporterEmailVerificationKeySpecifier)[];
export type RequestReporterEmailVerificationFieldPolicy = {
	cooldownSeconds?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireKeySpecifier = ('createdAt' | 'createdBy' | 'entries' | 'lastUpdatedBy' | 'name' | 'originalName' | 'sourcesUsed' | 'updatedAt' | 'uuid' | RespondQuestionnaireKeySpecifier)[];
export type RespondQuestionnaireFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	originalName?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RespondQuestionnaireConnectionKeySpecifier)[];
export type RespondQuestionnaireConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEdgeKeySpecifier = ('cursor' | 'node' | RespondQuestionnaireEdgeKeySpecifier)[];
export type RespondQuestionnaireEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEntryKeySpecifier = ('answer' | 'answerOptions' | 'category' | 'confidenceReason' | 'confidenceScore' | 'createdAt' | 'createdBy' | 'lastUpdatedBy' | 'question' | 'reasoning' | 'riskAreas' | 'rowId' | 'sourcesUsed' | 'updatedAt' | 'uuid' | 'validationArguments' | 'validationOperator' | 'validationType' | RespondQuestionnaireEntryKeySpecifier)[];
export type RespondQuestionnaireEntryFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answerOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceReason?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	rowId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	validationArguments?: FieldPolicy<any> | FieldReadFunction<any>,
	validationOperator?: FieldPolicy<any> | FieldReadFunction<any>,
	validationType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEntryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RespondQuestionnaireEntryConnectionKeySpecifier)[];
export type RespondQuestionnaireEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEntryEdgeKeySpecifier = ('cursor' | 'node' | RespondQuestionnaireEntryEdgeKeySpecifier)[];
export type RespondQuestionnaireEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireV2KeySpecifier = ('answeredEntriesCount' | 'conflictingEntriesCount' | 'createdAt' | 'createdBy' | 'entries' | 'entriesCount' | 'fileName' | 'filledFile' | 'hasConflictingEntries' | 'lastReviewedAt' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'name' | 'originalFile' | 'riskAreas' | 'sourcesUsed' | 'status' | 'totalConflictsCount' | 'uuid' | RespondQuestionnaireV2KeySpecifier)[];
export type RespondQuestionnaireV2FieldPolicy = {
	answeredEntriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	conflictingEntriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	entriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	filledFile?: FieldPolicy<any> | FieldReadFunction<any>,
	hasConflictingEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	lastReviewedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	originalFile?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalConflictsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireV2ConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RespondQuestionnaireV2ConnectionKeySpecifier)[];
export type RespondQuestionnaireV2ConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireV2EdgeKeySpecifier = ('cursor' | 'node' | RespondQuestionnaireV2EdgeKeySpecifier)[];
export type RespondQuestionnaireV2EdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RiskAreaKeySpecifier = ('category' | 'color' | 'customLabel' | 'fitness' | 'fitnessIndicators' | 'frameworkCategory' | 'groupTags' | 'groupedStatistics' | 'guidelineMain' | 'guidelines' | 'guidelinesCategories' | 'hasSomeIndustryEnabled' | 'history' | 'isEnabled' | 'isMigrated' | 'isShared' | 'lastActiveDate' | 'linkedTags' | 'materialInScope' | 'mergedRiskAreas' | 'name' | 'order' | 'repParentUuid' | 'riskAreas' | 'sectors' | 'statistics' | 'steps' | 'suiteMemberKind' | 'tags' | 'targetRiskArea' | 'type' | 'units' | 'uuid' | 'viewerHasSeat' | RiskAreaKeySpecifier)[];
export type RiskAreaFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	fitness?: FieldPolicy<any> | FieldReadFunction<any>,
	fitnessIndicators?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworkCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	groupedStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelineMain?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelines?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSomeIndustryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isMigrated?: FieldPolicy<any> | FieldReadFunction<any>,
	isShared?: FieldPolicy<any> | FieldReadFunction<any>,
	lastActiveDate?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	materialInScope?: FieldPolicy<any> | FieldReadFunction<any>,
	mergedRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	repParentUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	sectors?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	steps?: FieldPolicy<any> | FieldReadFunction<any>,
	suiteMemberKind?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	targetRiskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	viewerHasSeat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RiskAreasWithAnyQuestionsElementKeySpecifier = ('riskArea' | RiskAreasWithAnyQuestionsElementKeySpecifier)[];
export type RiskAreasWithAnyQuestionsElementFieldPolicy = {
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('description' | 'editMode' | 'isActive' | 'name' | 'permissions' | 'regions' | 'riskAreas' | 'users' | 'uuid' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	editMode?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RoleConnectionKeySpecifier)[];
export type RoleConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleEdgeKeySpecifier = ('cursor' | 'node' | RoleEdgeKeySpecifier)[];
export type RoleEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleRiskAreaKeySpecifier = ('permissions' | 'riskArea' | RoleRiskAreaKeySpecifier)[];
export type RoleRiskAreaFieldPolicy = {
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScopeFilterKeySpecifier = ('filter' | 'isFilterEnabled' | ScopeFilterKeySpecifier)[];
export type ScopeFilterFieldPolicy = {
	filter?: FieldPolicy<any> | FieldReadFunction<any>,
	isFilterEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeatRequestTypeKeySpecifier = ('createdAt' | 'resolvedAt' | 'resolvedBy' | 'riskAreaUuid' | 'status' | 'updatedAt' | 'userUuid' | 'uuid' | SeatRequestTypeKeySpecifier)[];
export type SeatRequestTypeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectorKeySpecifier = ('description' | 'isDefault' | 'isEnabled' | 'name' | 'order' | 'units' | 'uuid' | SectorKeySpecifier)[];
export type SectorFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectorConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | SectorConnectionKeySpecifier)[];
export type SectorConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectorEdgeKeySpecifier = ('cursor' | 'node' | SectorEdgeKeySpecifier)[];
export type SectorEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectKeySpecifier = ('key' | 'label' | 'value' | SelectKeySpecifier)[];
export type SelectFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServicePricingRequestResultKeySpecifier = ('requestUuid' | 'status' | ServicePricingRequestResultKeySpecifier)[];
export type ServicePricingRequestResultFieldPolicy = {
	requestUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionKeySpecifier = ('refreshToken' | 'sessionToken' | SessionKeySpecifier)[];
export type SessionFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionHandoffCodeKeySpecifier = ('code' | 'expiresAt' | SessionHandoffCodeKeySpecifier)[];
export type SessionHandoffCodeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionPayloadKeySpecifier = ('firebaseToken' | 'metadata' | 'mfa' | 'refreshToken' | 'sessionToken' | SessionPayloadKeySpecifier)[];
export type SessionPayloadFieldPolicy = {
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	mfa?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionWithOaExchangeKeySpecifier = ('metadata' | 'mobileApiToken' | 'oaExchangeToken' | 'refreshToken' | 'sessionToken' | SessionWithOaExchangeKeySpecifier)[];
export type SessionWithOaExchangeFieldPolicy = {
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileApiToken?: FieldPolicy<any> | FieldReadFunction<any>,
	oaExchangeToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetPriceQuoteKeySpecifier = ('additionalUsd' | 'annualUsd' | 'bespoke' | 'bespokeReason' | 'planId' | 'planName' | 'planReviews' | 'pricingVersion' | 'product' | 'productName' | 'standards' | 'termTotalUsd' | 'termYears' | SetPriceQuoteKeySpecifier)[];
export type SetPriceQuoteFieldPolicy = {
	additionalUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	annualUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	bespoke?: FieldPolicy<any> | FieldReadFunction<any>,
	bespokeReason?: FieldPolicy<any> | FieldReadFunction<any>,
	planId?: FieldPolicy<any> | FieldReadFunction<any>,
	planName?: FieldPolicy<any> | FieldReadFunction<any>,
	planReviews?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	termTotalUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	termYears?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetPriceRulesKeySpecifier = ('auditReadyAdditionalUsd' | 'auditReadyBaseUsd' | 'certificationProducts' | 'greenDeskPlans' | 'greenDeskTermYears' | 'speekiCertAloneUsd' | 'speekiCertStandards' | 'speekiCertTogetherUsd' | SetPriceRulesKeySpecifier)[];
export type SetPriceRulesFieldPolicy = {
	auditReadyAdditionalUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	auditReadyBaseUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	certificationProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	greenDeskPlans?: FieldPolicy<any> | FieldReadFunction<any>,
	greenDeskTermYears?: FieldPolicy<any> | FieldReadFunction<any>,
	speekiCertAloneUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	speekiCertStandards?: FieldPolicy<any> | FieldReadFunction<any>,
	speekiCertTogetherUsd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopApprovalRequestKeySpecifier = ('createdAt' | 'declineReason' | 'isMine' | 'kind' | 'lastRemindedAt' | 'message' | 'order' | 'orderUuid' | 'reminderCount' | 'requestedPlanId' | 'requestedStandardRef' | 'requesterEmail' | 'requesterUuid' | 'resolvedAt' | 'status' | 'uuid' | ShopApprovalRequestKeySpecifier)[];
export type ShopApprovalRequestFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	declineReason?: FieldPolicy<any> | FieldReadFunction<any>,
	isMine?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRemindedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	reminderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedPlanId?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedStandardRef?: FieldPolicy<any> | FieldReadFunction<any>,
	requesterEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	requesterUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	resolvedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopCatalogueKeySpecifier = ('categories' | 'plans' | 'products' | 'renewalDate' | ShopCatalogueKeySpecifier)[];
export type ShopCatalogueFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	plans?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillDraftAnswerKeySpecifier = ('confidence' | 'draftAnswer' | 'isAiDraft' | 'question' | 'sources' | 'status' | SmartFillDraftAnswerKeySpecifier)[];
export type SmartFillDraftAnswerFieldPolicy = {
	confidence?: FieldPolicy<any> | FieldReadFunction<any>,
	draftAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	isAiDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillJobKeySpecifier = ('createdAt' | 'drafts' | 'programme' | 'riskArea' | 'startedBy' | 'status' | 'unreadDocuments' | 'uuid' | SmartFillJobKeySpecifier)[];
export type SmartFillJobFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	drafts?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	startedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillSourceKeySpecifier = ('file' | 'page' | 'sectionOrExcerpt' | 'sheetName' | 'type' | SmartFillSourceKeySpecifier)[];
export type SmartFillSourceFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionOrExcerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	sheetName?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillUnreadDocumentKeySpecifier = ('fileUuid' | 'reasonKind' | 'retryable' | SmartFillUnreadDocumentKeySpecifier)[];
export type SmartFillUnreadDocumentFieldPolicy = {
	fileUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonKind?: FieldPolicy<any> | FieldReadFunction<any>,
	retryable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillUnreadableFileKeySpecifier = ('fileUuid' | 'reasonKind' | SmartFillUnreadableFileKeySpecifier)[];
export type SmartFillUnreadableFileFieldPolicy = {
	fileUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonKind?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpeekiCertStandardRuleKeySpecifier = ('id' | 'system' | SpeekiCertStandardRuleKeySpecifier)[];
export type SpeekiCertStandardRuleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpeekiPickKeySpecifier = ('endsAt' | 'live' | 'reason' | 'setAt' | 'setByUserUuid' | 'standardRef' | 'startsAt' | SpeekiPickKeySpecifier)[];
export type SpeekiPickFieldPolicy = {
	endsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	live?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	setAt?: FieldPolicy<any> | FieldReadFunction<any>,
	setByUserUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	standardRef?: FieldPolicy<any> | FieldReadFunction<any>,
	startsAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpkAssessmentDaysKeySpecifier = ('baseStage2' | 'highRiskAdjustment' | 'isoCredit' | 'isoCreditsApplied' | 'netStage2' | 'reporting' | 'reviewAdjustment' | 'reviewCount' | 'sectorAdjustment' | 'sectorTier' | 'setup' | 'stage1' | 'total' | SpkAssessmentDaysKeySpecifier)[];
export type SpkAssessmentDaysFieldPolicy = {
	baseStage2?: FieldPolicy<any> | FieldReadFunction<any>,
	highRiskAdjustment?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCredit?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCreditsApplied?: FieldPolicy<any> | FieldReadFunction<any>,
	netStage2?: FieldPolicy<any> | FieldReadFunction<any>,
	reporting?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewAdjustment?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorAdjustment?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorTier?: FieldPolicy<any> | FieldReadFunction<any>,
	setup?: FieldPolicy<any> | FieldReadFunction<any>,
	stage1?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpkCertificationPriceKeySpecifier = ('adjustments' | 'days' | 'fees' | 'product' | 'productName' | 'standard' | SpkCertificationPriceKeySpecifier)[];
export type SpkCertificationPriceFieldPolicy = {
	adjustments?: FieldPolicy<any> | FieldReadFunction<any>,
	days?: FieldPolicy<any> | FieldReadFunction<any>,
	fees?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpkCertificationRulesKeySpecifier = ('baseDaysMax' | 'baseDaysMin' | 'highRiskHigh' | 'highRiskLabel' | 'highRiskLow' | 'isoCreditCapDays' | 'isoCreditFirstDays' | 'isoCredits' | 'product' | 'productName' | 'reviewDaysEach' | 'reviewName' | 'sectorLabel' | 'sectorMaxAdjustmentDays' | 'sectorTierName' | 'sectors' | 'standard' | 'volumeLabel' | SpkCertificationRulesKeySpecifier)[];
export type SpkCertificationRulesFieldPolicy = {
	baseDaysMax?: FieldPolicy<any> | FieldReadFunction<any>,
	baseDaysMin?: FieldPolicy<any> | FieldReadFunction<any>,
	highRiskHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	highRiskLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	highRiskLow?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCreditCapDays?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCreditFirstDays?: FieldPolicy<any> | FieldReadFunction<any>,
	isoCredits?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewDaysEach?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorMaxAdjustmentDays?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorTierName?: FieldPolicy<any> | FieldReadFunction<any>,
	sectors?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeLabel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpkFeeScheduleKeySpecifier = ('assessorDays' | 'blendedRateUsd' | 'certificationIssuanceUsd' | 'leadAssessorFeeUsd' | 'leadAssessorRateUsd' | 'nicoleAiFeeUsd' | 'nicoleAiRateUsd' | 'perPeriodLabel' | 'perPeriodUsd' | 'rateCardYear1Usd' | 'threeYearUsd' | 'travelUsd' | 'year1Usd' | 'year2Usd' | 'year3Usd' | SpkFeeScheduleKeySpecifier)[];
export type SpkFeeScheduleFieldPolicy = {
	assessorDays?: FieldPolicy<any> | FieldReadFunction<any>,
	blendedRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	certificationIssuanceUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	leadAssessorFeeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	leadAssessorRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAiFeeUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAiRateUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	perPeriodLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	perPeriodUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	rateCardYear1Usd?: FieldPolicy<any> | FieldReadFunction<any>,
	threeYearUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	travelUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	year1Usd?: FieldPolicy<any> | FieldReadFunction<any>,
	year2Usd?: FieldPolicy<any> | FieldReadFunction<any>,
	year3Usd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpkIsoCreditKeySpecifier = ('days' | 'id' | 'label' | SpkIsoCreditKeySpecifier)[];
export type SpkIsoCreditFieldPolicy = {
	days?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpkPriceAdjustmentKeySpecifier = ('detail' | 'id' | 'label' | 'pct' | SpkPriceAdjustmentKeySpecifier)[];
export type SpkPriceAdjustmentFieldPolicy = {
	detail?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	pct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoAccountKeySpecifier = ('provider' | 'ssoUuid' | SsoAccountKeySpecifier)[];
export type SsoAccountFieldPolicy = {
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoAuthPayloadKeySpecifier = ('refreshToken' | 'sessionToken' | SsoAuthPayloadKeySpecifier)[];
export type SsoAuthPayloadFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoAzureTenantInformationKeySpecifier = ('azureTenantId' | 'canLogin' | 'enabled' | SsoAzureTenantInformationKeySpecifier)[];
export type SsoAzureTenantInformationFieldPolicy = {
	azureTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	canLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoProviderKeySpecifier = ('appId' | 'loginUrl' | 'provider' | 'providerId' | 'samlCertificate' | 'uuid' | SsoProviderKeySpecifier)[];
export type SsoProviderFieldPolicy = {
	appId?: FieldPolicy<any> | FieldReadFunction<any>,
	loginUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	samlCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoSamlTenantInformationKeySpecifier = ('canLogin' | 'enabled' | SsoSamlTenantInformationKeySpecifier)[];
export type SsoSamlTenantInformationFieldPolicy = {
	canLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoTenantInformationKeySpecifier = ('azure' | 'saml' | SsoTenantInformationKeySpecifier)[];
export type SsoTenantInformationFieldPolicy = {
	azure?: FieldPolicy<any> | FieldReadFunction<any>,
	saml?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffOrderScheduleDetailKeySpecifier = ('events' | 'markDeliveredYear' | 'schedule' | 'signedAt' | 'signerName' | 'stillToCollectUsd' | StaffOrderScheduleDetailKeySpecifier)[];
export type StaffOrderScheduleDetailFieldPolicy = {
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	markDeliveredYear?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	signedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	signerName?: FieldPolicy<any> | FieldReadFunction<any>,
	stillToCollectUsd?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffScheduleRowKeySpecifier = ('amountUsd' | 'emailStatus' | 'instalment' | 'invoiceNumber' | 'invoiceRaised' | 'label' | 'paymentStatus' | 'periodEnd' | 'periodStart' | 'prorated' | 'year' | StaffScheduleRowKeySpecifier)[];
export type StaffScheduleRowFieldPolicy = {
	amountUsd?: FieldPolicy<any> | FieldReadFunction<any>,
	emailStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	instalment?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRaised?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	periodEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	periodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	prorated?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StakeholderEngagementCommonDataKeySpecifier = ('audienceType' | 'canEdit' | 'countries' | 'createdAt' | 'description' | 'isAuthor' | 'json' | 'name' | 'relationships' | 'riskAreas' | 'updatedAt' | 'uuid' | StakeholderEngagementCommonDataKeySpecifier)[];
export type StakeholderEngagementCommonDataFieldPolicy = {
	audienceType?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relationships?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StakeholderEngagementConnectionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | StakeholderEngagementConnectionConnectionKeySpecifier)[];
export type StakeholderEngagementConnectionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StakeholderEngagementConnectionEdgeKeySpecifier = ('cursor' | 'node' | StakeholderEngagementConnectionEdgeKeySpecifier)[];
export type StakeholderEngagementConnectionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardAssignedRiskAreaEdgeKeySpecifier = ('cursor' | 'node' | StandardAssignedRiskAreaEdgeKeySpecifier)[];
export type StandardAssignedRiskAreaEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardAssignedRiskAreasConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | StandardAssignedRiskAreasConnectionKeySpecifier)[];
export type StandardAssignedRiskAreasConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionPlanKeySpecifier = ('features' | 'modules' | 'name' | 'uuid' | SubscriptionPlanKeySpecifier)[];
export type SubscriptionPlanFieldPolicy = {
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionTermKeySpecifier = ('canGiveNotice' | 'endsOn' | 'noticeGivenAt' | 'noticeGivenBy' | 'renewalTermYears' | 'renewsAutomatically' | SubscriptionTermKeySpecifier)[];
export type SubscriptionTermFieldPolicy = {
	canGiveNotice?: FieldPolicy<any> | FieldReadFunction<any>,
	endsOn?: FieldPolicy<any> | FieldReadFunction<any>,
	noticeGivenAt?: FieldPolicy<any> | FieldReadFunction<any>,
	noticeGivenBy?: FieldPolicy<any> | FieldReadFunction<any>,
	renewalTermYears?: FieldPolicy<any> | FieldReadFunction<any>,
	renewsAutomatically?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySiteKeySpecifier = ('admins' | 'caseOwnerExclusion' | 'isActive' | 'isHeadquarters' | 'name' | 'reportingGroup' | 'reportingLabel' | 'reportingSlug' | 'reportingUrl' | 'userCount' | 'users' | 'uuid' | SubsidiarySiteKeySpecifier)[];
export type SubsidiarySiteFieldPolicy = {
	admins?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isHeadquarters?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	userCount?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySiteEdgeKeySpecifier = ('cursor' | 'node' | SubsidiarySiteEdgeKeySpecifier)[];
export type SubsidiarySiteEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySiteReportingSettingsKeySpecifier = ('canEdit' | 'defaultCopy' | 'isEnabled' | 'subsidiarySelectionCopy' | 'useCustomCopy' | SubsidiarySiteReportingSettingsKeySpecifier)[];
export type SubsidiarySiteReportingSettingsFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySelectionCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	useCustomCopy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySitesConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | SubsidiarySitesConnectionKeySpecifier)[];
export type SubsidiarySitesConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupportedMobileAppVersionsKeySpecifier = ('android' | 'ios' | SupportedMobileAppVersionsKeySpecifier)[];
export type SupportedMobileAppVersionsFieldPolicy = {
	android?: FieldPolicy<any> | FieldReadFunction<any>,
	ios?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyKeySpecifier = ('audienceType' | 'canEdit' | 'countries' | 'createdAt' | 'createdBy' | 'createdByName' | 'daysValidity' | 'description' | 'emailTargets' | 'emailTargetsCount' | 'endDate' | 'isAuthor' | 'json' | 'lastUpdatedAt' | 'name' | 'relationships' | 'reminder' | 'respondersCountPerDay' | 'respondersTotalCount' | 'riskAreas' | 'startDate' | 'status' | 'updatedAt' | 'uuid' | SurveyKeySpecifier)[];
export type SurveyFieldPolicy = {
	audienceType?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	daysValidity?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTargetsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relationships?: FieldPolicy<any> | FieldReadFunction<any>,
	reminder?: FieldPolicy<any> | FieldReadFunction<any>,
	respondersCountPerDay?: FieldPolicy<any> | FieldReadFunction<any>,
	respondersTotalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | SurveyConnectionKeySpecifier)[];
export type SurveyConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyEdgeKeySpecifier = ('cursor' | 'node' | SurveyEdgeKeySpecifier)[];
export type SurveyEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyEmailTargetKeySpecifier = ('answered' | 'email' | 'sent' | 'surveyAnswer' | 'uuid' | SurveyEmailTargetKeySpecifier)[];
export type SurveyEmailTargetFieldPolicy = {
	answered?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	sent?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyPageKeySpecifier = ('edges' | 'info' | SurveyPageKeySpecifier)[];
export type SurveyPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyPaginatedKeySpecifier = ('page' | 'statistics' | 'totalCount' | SurveyPaginatedKeySpecifier)[];
export type SurveyPaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyReportUploadResponseKeySpecifier = ('s3Url' | SurveyReportUploadResponseKeySpecifier)[];
export type SurveyReportUploadResponseFieldPolicy = {
	s3Url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponseKeySpecifier = ('createdAt' | 'createdByName' | 'createdByUuid' | 'json' | 'source' | 'surveyUuid' | 'uuid' | SurveyResponseKeySpecifier)[];
export type SurveyResponseFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponseEdgeKeySpecifier = ('cursor' | 'node' | SurveyResponseEdgeKeySpecifier)[];
export type SurveyResponseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponsePageKeySpecifier = ('edges' | 'info' | SurveyResponsePageKeySpecifier)[];
export type SurveyResponsePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponsePaginatedKeySpecifier = ('page' | 'surveyData' | 'totalCount' | SurveyResponsePaginatedKeySpecifier)[];
export type SurveyResponsePaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyData?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyStatisticsKeySpecifier = ('completedCount' | 'ongoingCount' | 'scheduledCount' | SurveyStatisticsKeySpecifier)[];
export type SurveyStatisticsFieldPolicy = {
	completedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	ongoingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveySummaryKeySpecifier = ('url' | SurveySummaryKeySpecifier)[];
export type SurveySummaryFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplateKeySpecifier = ('canEdit' | 'createdAt' | 'createdByName' | 'isAuthor' | 'isPublic' | 'json' | 'lastUpdatedAt' | 'name' | 'type' | 'uuid' | SurveyTemplateKeySpecifier)[];
export type SurveyTemplateFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplateEdgeKeySpecifier = ('cursor' | 'node' | SurveyTemplateEdgeKeySpecifier)[];
export type SurveyTemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplatePageKeySpecifier = ('edges' | 'info' | SurveyTemplatePageKeySpecifier)[];
export type SurveyTemplatePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplatePaginatedKeySpecifier = ('page' | 'totalCount' | SurveyTemplatePaginatedKeySpecifier)[];
export type SurveyTemplatePaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplateTypeKeySpecifier = ('isOwner' | 'isStandardTemplate' | 'label' | SurveyTemplateTypeKeySpecifier)[];
export type SurveyTemplateTypeFieldPolicy = {
	isOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SymbolKeySpecifier = ('denotation' | 'isSeeded' | 'name' | 'uuid' | SymbolKeySpecifier)[];
export type SymbolFieldPolicy = {
	denotation?: FieldPolicy<any> | FieldReadFunction<any>,
	isSeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SymbolConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | SymbolConnectionKeySpecifier)[];
export type SymbolConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SymbolEdgeKeySpecifier = ('cursor' | 'node' | SymbolEdgeKeySpecifier)[];
export type SymbolEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagKeySpecifier = ('color' | 'createdAt' | 'createdBy' | 'description' | 'groupTag' | 'isPublic' | 'name' | 'tenant' | 'updatedAt' | 'updatedBy' | 'uuid' | TagKeySpecifier)[];
export type TagFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TagConnectionKeySpecifier)[];
export type TagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagEdgeKeySpecifier = ('cursor' | 'node' | TagEdgeKeySpecifier)[];
export type TagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagsSelectConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | TagsSelectConnectionKeySpecifier)[];
export type TagsSelectConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetKeySpecifier = ('baseYear' | 'createdBy' | 'description' | 'direction' | 'goals' | 'lastUpdatedBy' | 'metric' | 'name' | 'points' | 'targetData' | 'targetYear' | 'trackedCellAddress' | 'trackedDataRowId' | 'trackedDataSubRowId' | 'unit' | 'uuid' | TargetKeySpecifier)[];
export type TargetFieldPolicy = {
	baseYear?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	goals?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	points?: FieldPolicy<any> | FieldReadFunction<any>,
	targetData?: FieldPolicy<any> | FieldReadFunction<any>,
	targetYear?: FieldPolicy<any> | FieldReadFunction<any>,
	trackedCellAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	trackedDataRowId?: FieldPolicy<any> | FieldReadFunction<any>,
	trackedDataSubRowId?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TargetConnectionKeySpecifier)[];
export type TargetConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetDataKeySpecifier = ('currentValue' | 'isBaseYear' | 'predictedValue' | 'targetValue' | 'unit' | 'year' | TargetDataKeySpecifier)[];
export type TargetDataFieldPolicy = {
	currentValue?: FieldPolicy<any> | FieldReadFunction<any>,
	isBaseYear?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	targetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetEdgeKeySpecifier = ('cursor' | 'node' | TargetEdgeKeySpecifier)[];
export type TargetEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetGoalsKeySpecifier = ('uuid' | 'value' | 'year' | TargetGoalsKeySpecifier)[];
export type TargetGoalsFieldPolicy = {
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetRiskAreaKeySpecifier = ('customLabel' | 'name' | 'uuid' | TargetRiskAreaKeySpecifier)[];
export type TargetRiskAreaFieldPolicy = {
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('assignee' | 'assignor' | 'comments' | 'createdAt' | 'description' | 'dueDate' | 'expiryDate' | 'id' | 'isNew' | 'lastUpdatedAt' | 'metadata' | 'riskArea' | 'status' | 'title' | 'type' | 'uuid' | 'year' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	assignor?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isNew?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskCommentKeySpecifier = ('content' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'newStatus' | 'type' | 'uuid' | TaskCommentKeySpecifier)[];
export type TaskCommentFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	newStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | TaskConnectionKeySpecifier)[];
export type TaskConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskEdgeKeySpecifier = ('cursor' | 'node' | TaskEdgeKeySpecifier)[];
export type TaskEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskMetadataKeySpecifier = ('answer' | 'disabledReason' | 'programme' | 'question' | 'riskArea' | 'stage' | 'standard' | 'versionTag' | TaskMetadataKeySpecifier)[];
export type TaskMetadataFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	disabledReason?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	stage?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	versionTag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskNameHintKeySpecifier = ('title' | 'uuid' | TaskNameHintKeySpecifier)[];
export type TaskNameHintFieldPolicy = {
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskNameHintConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaskNameHintConnectionKeySpecifier)[];
export type TaskNameHintConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskNameHintEdgeKeySpecifier = ('cursor' | 'node' | TaskNameHintEdgeKeySpecifier)[];
export type TaskNameHintEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskStatisticsKeySpecifier = ('closedCount' | 'inProgressCount' | 'inProgressWithoutUpcomingAndOverdueCount' | 'newCount' | 'openedCount' | 'overDueAndUpcomingCount' | 'overdueCount' | 'totalCount' | 'upcomingCount' | TaskStatisticsKeySpecifier)[];
export type TaskStatisticsFieldPolicy = {
	closedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgressCount?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgressWithoutUpcomingAndOverdueCount?: FieldPolicy<any> | FieldReadFunction<any>,
	newCount?: FieldPolicy<any> | FieldReadFunction<any>,
	openedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	overDueAndUpcomingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	overdueCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	upcomingCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasksUserTypeEdgeKeySpecifier = ('cursor' | 'node' | TasksUserTypeEdgeKeySpecifier)[];
export type TasksUserTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyKeySpecifier = ('name' | 'uuid' | 'version' | TaxonomyKeySpecifier)[];
export type TaxonomyFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyComplexUnitKeySpecifier = ('denominator' | 'label' | 'numerator' | TaxonomyComplexUnitKeySpecifier)[];
export type TaxonomyComplexUnitFieldPolicy = {
	denominator?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	numerator?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptKeySpecifier = ('dimensionSets' | 'enumeration' | 'formats' | 'itemType' | 'label' | 'name' | 'periodType' | 'trees' | 'units' | 'uuid' | TaxonomyConceptKeySpecifier)[];
export type TaxonomyConceptFieldPolicy = {
	dimensionSets?: FieldPolicy<any> | FieldReadFunction<any>,
	enumeration?: FieldPolicy<any> | FieldReadFunction<any>,
	formats?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	periodType?: FieldPolicy<any> | FieldReadFunction<any>,
	trees?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyConceptConnectionKeySpecifier)[];
export type TaxonomyConceptConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyConceptEdgeKeySpecifier)[];
export type TaxonomyConceptEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyConnectionKeySpecifier)[];
export type TaxonomyConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyDimensionSetKeySpecifier = ('definition' | 'dimensions' | 'label' | 'name' | 'uuid' | TaxonomyDimensionSetKeySpecifier)[];
export type TaxonomyDimensionSetFieldPolicy = {
	definition?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensions?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyDomainKeySpecifier = ('default' | 'label' | 'members' | 'name' | TaxonomyDomainKeySpecifier)[];
export type TaxonomyDomainFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyEdgeKeySpecifier)[];
export type TaxonomyEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyEnumerationKeySpecifier = ('label' | 'name' | 'uuid' | 'values' | TaxonomyEnumerationKeySpecifier)[];
export type TaxonomyEnumerationFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyEnumerationValueKeySpecifier = ('label' | 'name' | 'value' | TaxonomyEnumerationValueKeySpecifier)[];
export type TaxonomyEnumerationValueFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyExplicitDimensionKeySpecifier = ('domains' | 'label' | 'name' | 'type' | TaxonomyExplicitDimensionKeySpecifier)[];
export type TaxonomyExplicitDimensionFieldPolicy = {
	domains?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyFormatKeySpecifier = ('label' | 'name' | TaxonomyFormatKeySpecifier)[];
export type TaxonomyFormatFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyMemberKeySpecifier = ('label' | 'name' | TaxonomyMemberKeySpecifier)[];
export type TaxonomyMemberFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportKeySpecifier = ('audits' | 'collaborators' | 'createdAt' | 'facts' | 'file' | 'filingId' | 'name' | 'pagesCount' | 'preparer' | 'statistics' | 'status' | 'updatedAt' | 'uuid' | TaxonomyReportKeySpecifier)[];
export type TaxonomyReportFieldPolicy = {
	audits?: FieldPolicy<any> | FieldReadFunction<any>,
	collaborators?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	facts?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	filingId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pagesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	preparer?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportAuditKeySpecifier = ('action' | 'changedAt' | 'changedBy' | 'uuid' | TaxonomyReportAuditKeySpecifier)[];
export type TaxonomyReportAuditFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	changedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	changedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportAuditConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyReportAuditConnectionKeySpecifier)[];
export type TaxonomyReportAuditConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportAuditEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyReportAuditEdgeKeySpecifier)[];
export type TaxonomyReportAuditEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyReportConnectionKeySpecifier)[];
export type TaxonomyReportConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyReportEdgeKeySpecifier)[];
export type TaxonomyReportEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactKeySpecifier = ('color' | 'concept' | 'conceptUuid' | 'dimensionSetUuid' | 'entityName' | 'hidden' | 'itemDecimals' | 'itemFormat' | 'itemType' | 'itemUnit' | 'itemValue' | 'lines' | 'page' | 'periodDuration' | 'periodInstant' | 'periodType' | 'report' | 'reportUuid' | 'scenarios' | 'uuid' | TaxonomyReportFactKeySpecifier)[];
export type TaxonomyReportFactFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	concept?: FieldPolicy<any> | FieldReadFunction<any>,
	conceptUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionSetUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	entityName?: FieldPolicy<any> | FieldReadFunction<any>,
	hidden?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDecimals?: FieldPolicy<any> | FieldReadFunction<any>,
	itemFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	itemValue?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	periodDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	periodInstant?: FieldPolicy<any> | FieldReadFunction<any>,
	periodType?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	reportUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	scenarios?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyReportFactConnectionKeySpecifier)[];
export type TaxonomyReportFactConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyReportFactEdgeKeySpecifier)[];
export type TaxonomyReportFactEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactLineKeySpecifier = ('end' | 'line' | 'start' | TaxonomyReportFactLineKeySpecifier)[];
export type TaxonomyReportFactLineFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	line?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactPeriodDurationKeySpecifier = ('end' | 'start' | TaxonomyReportFactPeriodDurationKeySpecifier)[];
export type TaxonomyReportFactPeriodDurationFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactScenarioKeySpecifier = ('dimension' | 'member' | TaxonomyReportFactScenarioKeySpecifier)[];
export type TaxonomyReportFactScenarioFieldPolicy = {
	dimension?: FieldPolicy<any> | FieldReadFunction<any>,
	member?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportPageKeySpecifier = ('html' | 'page' | 'report' | 'reportUuid' | 'screenshot' | 'text' | 'uuid' | TaxonomyReportPageKeySpecifier)[];
export type TaxonomyReportPageFieldPolicy = {
	html?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	reportUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	screenshot?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportStatisticsKeySpecifier = ('hiddenCount' | 'missingCount' | 'visibleCount' | TaxonomyReportStatisticsKeySpecifier)[];
export type TaxonomyReportStatisticsFieldPolicy = {
	hiddenCount?: FieldPolicy<any> | FieldReadFunction<any>,
	missingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomySimpleUnitKeySpecifier = ('label' | 'measure' | TaxonomySimpleUnitKeySpecifier)[];
export type TaxonomySimpleUnitFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	measure?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyTypedDimensionKeySpecifier = ('domain' | 'label' | 'name' | 'type' | TaxonomyTypedDimensionKeySpecifier)[];
export type TaxonomyTypedDimensionFieldPolicy = {
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateKeySpecifier = ('createdAt' | 'createdBy' | 'createdByName' | 'isPublic' | 'json' | 'lastUpdatedAt' | 'name' | 'riskAreas' | 'scope' | 'type' | 'uuid' | TemplateKeySpecifier)[];
export type TemplateFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TemplateConnectionKeySpecifier)[];
export type TemplateConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateEdgeKeySpecifier = ('cursor' | 'node' | TemplateEdgeKeySpecifier)[];
export type TemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateTypeKeySpecifier = ('isOwner' | 'isStandardTemplate' | 'label' | TemplateTypeKeySpecifier)[];
export type TemplateTypeFieldPolicy = {
	isOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantAccessRequestResultKeySpecifier = ('requestUuid' | 'status' | TenantAccessRequestResultKeySpecifier)[];
export type TenantAccessRequestResultFieldPolicy = {
	requestUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantBaseDataTypeKeySpecifier = ('activeYear' | 'assetSettings' | 'caseOwnerExclusion' | 'code' | 'defaultAnswerVersionLabel' | 'elineNumbers' | 'enforceMfa' | 'features' | 'forwardEarthUrl' | 'frameworks' | 'groupTags' | 'hasSomeIndustryEnabled' | 'headline' | 'headlineTranslated' | 'homeContent' | 'homeContentTranslated' | 'htmlBanner' | 'incidentTypes' | 'industryUnits' | 'lastRenewalRequestSentAt' | 'license' | 'logo' | 'modules' | 'name' | 'policiesContent' | 'policiesContentTranslated' | 'region' | 'regions' | 'reportSettings' | 'reportingGroup' | 'reportingGroups' | 'reportingPeriod' | 'reportingSlug' | 'reportingUrl' | 'ssoProviders' | 'ssoSamlRequestUrl' | 'standards' | 'subscriptionPlan' | 'subsidiarySite' | 'subsidiarySites' | 'tags' | 'users' | 'uuid' | 'years' | TenantBaseDataTypeKeySpecifier)[];
export type TenantBaseDataTypeFieldPolicy = {
	activeYear?: FieldPolicy<any> | FieldReadFunction<any>,
	assetSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAnswerVersionLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	enforceMfa?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	frameworks?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSomeIndustryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	headline?: FieldPolicy<any> | FieldReadFunction<any>,
	headlineTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	homeContent?: FieldPolicy<any> | FieldReadFunction<any>,
	homeContentTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	htmlBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	industryUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRenewalRequestSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	license?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	policiesContent?: FieldPolicy<any> | FieldReadFunction<any>,
	policiesContentTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoSamlRequestUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	years?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantDomainKeySpecifier = ('domain' | 'method' | 'status' | 'tenantUuid' | 'uuid' | 'verifiedAt' | 'verifiedByUuid' | TenantDomainKeySpecifier)[];
export type TenantDomainFieldPolicy = {
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	method?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	verifiedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	verifiedByUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantDomainBackfillClaimKeySpecifier = ('domain' | 'tenantUuid' | TenantDomainBackfillClaimKeySpecifier)[];
export type TenantDomainBackfillClaimFieldPolicy = {
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantDomainBackfillConflictKeySpecifier = ('domain' | 'reason' | 'tenants' | TenantDomainBackfillConflictKeySpecifier)[];
export type TenantDomainBackfillConflictFieldPolicy = {
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	tenants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantDomainBackfillReportKeySpecifier = ('claimed' | 'conflicts' | 'skipped' | TenantDomainBackfillReportKeySpecifier)[];
export type TenantDomainBackfillReportFieldPolicy = {
	claimed?: FieldPolicy<any> | FieldReadFunction<any>,
	conflicts?: FieldPolicy<any> | FieldReadFunction<any>,
	skipped?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantDomainBackfillTenantKeySpecifier = ('name' | 'uuid' | TenantDomainBackfillTenantKeySpecifier)[];
export type TenantDomainBackfillTenantFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantEntitlementsKeySpecifier = ('items' | 'legacyPlanName' | 'modules' | 'seats' | 'subscriptionEnd' | 'subscriptionStart' | 'tenantUuid' | 'tier' | TenantEntitlementsKeySpecifier)[];
export type TenantEntitlementsFieldPolicy = {
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyPlanName?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	seats?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionStart?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantModuleSettingsKeySpecifier = ('CARBON_LENS' | 'CASES' | 'DEMO' | 'DISCLOSURES' | 'DUE_DILIGENCE' | 'ESG' | 'INSIGHTS' | 'NICOLE_GPT' | 'SSO' | 'SUBSIDIARY_SITES' | 'SURVEYS' | 'TASKS' | 'TEAMS' | 'TRAININGS' | 'cases' | 'disclosures' | 'sso' | 'subsidiary_sites' | 'surveys' | 'teams' | 'teamsTenantId' | 'trainings' | TenantModuleSettingsKeySpecifier)[];
export type TenantModuleSettingsFieldPolicy = {
	CARBON_LENS?: FieldPolicy<any> | FieldReadFunction<any>,
	CASES?: FieldPolicy<any> | FieldReadFunction<any>,
	DEMO?: FieldPolicy<any> | FieldReadFunction<any>,
	DISCLOSURES?: FieldPolicy<any> | FieldReadFunction<any>,
	DUE_DILIGENCE?: FieldPolicy<any> | FieldReadFunction<any>,
	ESG?: FieldPolicy<any> | FieldReadFunction<any>,
	INSIGHTS?: FieldPolicy<any> | FieldReadFunction<any>,
	NICOLE_GPT?: FieldPolicy<any> | FieldReadFunction<any>,
	SSO?: FieldPolicy<any> | FieldReadFunction<any>,
	SUBSIDIARY_SITES?: FieldPolicy<any> | FieldReadFunction<any>,
	SURVEYS?: FieldPolicy<any> | FieldReadFunction<any>,
	TASKS?: FieldPolicy<any> | FieldReadFunction<any>,
	TEAMS?: FieldPolicy<any> | FieldReadFunction<any>,
	TRAININGS?: FieldPolicy<any> | FieldReadFunction<any>,
	cases?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	sso?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiary_sites?: FieldPolicy<any> | FieldReadFunction<any>,
	surveys?: FieldPolicy<any> | FieldReadFunction<any>,
	teams?: FieldPolicy<any> | FieldReadFunction<any>,
	teamsTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	trainings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantNonRenewalNoticeKeySpecifier = ('createdAt' | 'party' | 'reason' | TenantNonRenewalNoticeKeySpecifier)[];
export type TenantNonRenewalNoticeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	party?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantReportingPeriodKeySpecifier = ('isPeriodSet' | 'reportingPeriodStart' | 'tenantUuid' | TenantReportingPeriodKeySpecifier)[];
export type TenantReportingPeriodFieldPolicy = {
	isPeriodSet?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingPeriodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantRiskAreaSettingKeySpecifier = ('customLabel' | 'isEnabled' | 'name' | 'riskAreaUuid' | 'targetRiskArea' | TenantRiskAreaSettingKeySpecifier)[];
export type TenantRiskAreaSettingFieldPolicy = {
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	targetRiskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantRiskAreaSettingsKeySpecifier = ('riskAreaSettings' | 'tenantUuid' | TenantRiskAreaSettingsKeySpecifier)[];
export type TenantRiskAreaSettingsFieldPolicy = {
	riskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantSamlRequestDetailsKeySpecifier = ('samlRequestUrl' | TenantSamlRequestDetailsKeySpecifier)[];
export type TenantSamlRequestDetailsFieldPolicy = {
	samlRequestUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantSignupVerifiedDataKeySpecifier = ('apiUrl' | 'claimedDomain' | 'code' | 'name' | 'registerCode' | 'uuid' | TenantSignupVerifiedDataKeySpecifier)[];
export type TenantSignupVerifiedDataFieldPolicy = {
	apiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	claimedDomain?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	registerCode?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantSubscriptionKeySpecifier = ('daysToExpire' | 'endDate' | 'planName' | 'startDate' | TenantSubscriptionKeySpecifier)[];
export type TenantSubscriptionFieldPolicy = {
	daysToExpire?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	planName?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantSwitchOffPreviewKeySpecifier = ('name' | 'subscriptionExpire' | 'uuid' | TenantSwitchOffPreviewKeySpecifier)[];
export type TenantSwitchOffPreviewFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionExpire?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantYearDataStateKeySpecifier = ('hasAnswers' | 'hasTasks' | 'uuid' | TenantYearDataStateKeySpecifier)[];
export type TenantYearDataStateFieldPolicy = {
	hasAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	hasTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TriageScoreSettingKeySpecifier = ('canEdit' | 'isEnabled' | 'severityLabel' | 'severityWeight' | 'urgencyLabel' | 'urgencyWeight' | TriageScoreSettingKeySpecifier)[];
export type TriageScoreSettingFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	severityLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	severityWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	urgencyLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	urgencyWeight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnfinishedOrderKeySpecifier = ('canResend' | 'isMine' | 'order' | 'resendCapReached' | 'resendCooldownRemainingSeconds' | UnfinishedOrderKeySpecifier)[];
export type UnfinishedOrderFieldPolicy = {
	canResend?: FieldPolicy<any> | FieldReadFunction<any>,
	isMine?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	resendCapReached?: FieldPolicy<any> | FieldReadFunction<any>,
	resendCooldownRemainingSeconds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitKeySpecifier = ('description' | 'isEnabled' | 'name' | 'sector' | 'uuid' | 'volume' | UnitKeySpecifier)[];
export type UnitFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sector?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	volume?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitEdgeKeySpecifier = ('cursor' | 'node' | UnitEdgeKeySpecifier)[];
export type UnitEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnlinkMetricFromAnswerResultKeySpecifier = ('answerUuid' | 'metricUuid' | UnlinkMetricFromAnswerResultKeySpecifier)[];
export type UnlinkMetricFromAnswerResultFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnlinkQuestionFromMetricResultKeySpecifier = ('metricUuid' | 'questionUuid' | UnlinkQuestionFromMetricResultKeySpecifier)[];
export type UnlinkQuestionFromMetricResultFieldPolicy = {
	metricUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnmappedQuestionStandardStatisticsKeySpecifier = ('standard' | 'statistics' | UnmappedQuestionStandardStatisticsKeySpecifier)[];
export type UnmappedQuestionStandardStatisticsFieldPolicy = {
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnmappedQuestionStatisticsKeySpecifier = ('answeredCount' | 'standardsCount' | 'totalCount' | UnmappedQuestionStatisticsKeySpecifier)[];
export type UnmappedQuestionStatisticsFieldPolicy = {
	answeredCount?: FieldPolicy<any> | FieldReadFunction<any>,
	standardsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | UserConnectionKeySpecifier)[];
export type UserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDisclosureStatisticsKeySpecifier = ('availableDisclosures' | 'respondedDisclosures' | 'responsesCount' | UserDisclosureStatisticsKeySpecifier)[];
export type UserDisclosureStatisticsFieldPolicy = {
	availableDisclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	respondedDisclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	responsesCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserRoleKeySpecifier = ('permissions' | 'role' | 'subsidiarySite' | 'subsidiarySiteUuid' | 'user' | 'userUuid' | 'uuid' | UserRoleKeySpecifier)[];
export type UserRoleFieldPolicy = {
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSettingsKeySpecifier = ('tokens' | 'user' | UserSettingsKeySpecifier)[];
export type UserSettingsFieldPolicy = {
	tokens?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserTypeKeySpecifier = ('activeEntity' | 'activeRole' | 'assignedRole' | 'azureConnected' | 'biometricsDevices' | 'businessUnit' | 'canResendInvitation' | 'contactEmail' | 'country' | 'createdAt' | 'email' | 'enabledStandards' | 'entitlements' | 'esgSettings' | 'firebaseToken' | 'firstName' | 'fullName' | 'graphStorage' | 'hasUnreadReleaseNote' | 'hotspots' | 'invitation' | 'isBillingRole' | 'isFilterEnabled' | 'isGuest' | 'isLoggedIn' | 'isPersonalInfoCompleted' | 'language' | 'languageSelect' | 'lastName' | 'name' | 'navigableTaskRiskArea' | 'organizationEmail' | 'organizationName' | 'organizationRole' | 'ownedFrameworks' | 'permissions' | 'phoneCountryPrefix' | 'phoneNonPrefixed' | 'phoneNumber' | 'questionnaireFilters' | 'recoveryEmail' | 'regions' | 'relationship' | 'role' | 'roles' | 'ssoAccounts' | 'status' | 'tenant' | 'timeZone' | 'type' | 'unreadReleaseNote' | 'updatedAt' | 'uuid' | UserTypeKeySpecifier)[];
export type UserTypeFieldPolicy = {
	activeEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	activeRole?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedRole?: FieldPolicy<any> | FieldReadFunction<any>,
	azureConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	biometricsDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	canResendInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledStandards?: FieldPolicy<any> | FieldReadFunction<any>,
	entitlements?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	graphStorage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnreadReleaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspots?: FieldPolicy<any> | FieldReadFunction<any>,
	invitation?: FieldPolicy<any> | FieldReadFunction<any>,
	isBillingRole?: FieldPolicy<any> | FieldReadFunction<any>,
	isFilterEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	isLoggedIn?: FieldPolicy<any> | FieldReadFunction<any>,
	isPersonalInfoCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	languageSelect?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	navigableTaskRiskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	ownedFrameworks?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneCountryPrefix?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNonPrefixed?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	recoveryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadReleaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserTypeConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | UserTypeConnectionKeySpecifier)[];
export type UserTypeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserTypeEdgeKeySpecifier = ('cursor' | 'node' | UserTypeEdgeKeySpecifier)[];
export type UserTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2CaseExclusionOwnerEdgeKeySpecifier = ('cursor' | 'node' | V2CaseExclusionOwnerEdgeKeySpecifier)[];
export type V2CaseExclusionOwnerEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2DisclosureEdgeKeySpecifier = ('cursor' | 'node' | V2DisclosureEdgeKeySpecifier)[];
export type V2DisclosureEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2DisclosureResponseEdgeKeySpecifier = ('cursor' | 'node' | V2DisclosureResponseEdgeKeySpecifier)[];
export type V2DisclosureResponseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2SurveyEdgeKeySpecifier = ('cursor' | 'node' | V2SurveyEdgeKeySpecifier)[];
export type V2SurveyEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidationIssueObjectKeySpecifier = ('code' | 'level' | 'message' | ValidationIssueObjectKeySpecifier)[];
export type ValidationIssueObjectFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	level?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VerifyCheckoutSessionWithHubProofPayloadKeySpecifier = ('matchedOrganisationName' | 'verified' | VerifyCheckoutSessionWithHubProofPayloadKeySpecifier)[];
export type VerifyCheckoutSessionWithHubProofPayloadFieldPolicy = {
	matchedOrganisationName?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowKeySpecifier = ('esgArticles' | 'feed' | 'latestRelease' | 'supportArticle' | WebflowKeySpecifier)[];
export type WebflowFieldPolicy = {
	esgArticles?: FieldPolicy<any> | FieldReadFunction<any>,
	feed?: FieldPolicy<any> | FieldReadFunction<any>,
	latestRelease?: FieldPolicy<any> | FieldReadFunction<any>,
	supportArticle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowPostKeySpecifier = ('categories' | 'category' | 'description' | 'id' | 'publishedAt' | 'title' | 'url' | WebflowPostKeySpecifier)[];
export type WebflowPostFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowPostConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | WebflowPostConnectionKeySpecifier)[];
export type WebflowPostConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowPostEdgeKeySpecifier = ('cursor' | 'node' | WebflowPostEdgeKeySpecifier)[];
export type WebflowPostEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WhistleblowerCaseReportPdfResponseKeySpecifier = ('password' | 's3Url' | WhistleblowerCaseReportPdfResponseKeySpecifier)[];
export type WhistleblowerCaseReportPdfResponseFieldPolicy = {
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YearKeySpecifier = ('status' | 'uuid' | 'year' | 'yearDataStatus' | YearKeySpecifier)[];
export type YearFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>,
	yearDataStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YearConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | YearConnectionKeySpecifier)[];
export type YearConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YearEdgeKeySpecifier = ('cursor' | 'node' | YearEdgeKeySpecifier)[];
export type YearEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AdminContextTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminContextTokensKeySpecifier | (() => undefined | AdminContextTokensKeySpecifier),
		fields?: AdminContextTokensFieldPolicy,
	},
	AdminTenantData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantDataKeySpecifier | (() => undefined | AdminTenantDataKeySpecifier),
		fields?: AdminTenantDataFieldPolicy,
	},
	AdminTenantDataConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantDataConnectionKeySpecifier | (() => undefined | AdminTenantDataConnectionKeySpecifier),
		fields?: AdminTenantDataConnectionFieldPolicy,
	},
	AdminTenantDataEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantDataEdgeKeySpecifier | (() => undefined | AdminTenantDataEdgeKeySpecifier),
		fields?: AdminTenantDataEdgeFieldPolicy,
	},
	AdminTenantModuleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantModuleSettingsKeySpecifier | (() => undefined | AdminTenantModuleSettingsKeySpecifier),
		fields?: AdminTenantModuleSettingsFieldPolicy,
	},
	AdminTenantSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantSubscriptionKeySpecifier | (() => undefined | AdminTenantSubscriptionKeySpecifier),
		fields?: AdminTenantSubscriptionFieldPolicy,
	},
	AdminUserData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminUserDataKeySpecifier | (() => undefined | AdminUserDataKeySpecifier),
		fields?: AdminUserDataFieldPolicy,
	},
	AdminUserDataConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminUserDataConnectionKeySpecifier | (() => undefined | AdminUserDataConnectionKeySpecifier),
		fields?: AdminUserDataConnectionFieldPolicy,
	},
	AdminUserDataEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminUserDataEdgeKeySpecifier | (() => undefined | AdminUserDataEdgeKeySpecifier),
		fields?: AdminUserDataEdgeFieldPolicy,
	},
	AiReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AiReportKeySpecifier | (() => undefined | AiReportKeySpecifier),
		fields?: AiReportFieldPolicy,
	},
	AiReportTopic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AiReportTopicKeySpecifier | (() => undefined | AiReportTopicKeySpecifier),
		fields?: AiReportTopicFieldPolicy,
	},
	AmsAuditor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AmsAuditorKeySpecifier | (() => undefined | AmsAuditorKeySpecifier),
		fields?: AmsAuditorFieldPolicy,
	},
	AmsSessionTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AmsSessionTokensKeySpecifier | (() => undefined | AmsSessionTokensKeySpecifier),
		fields?: AmsSessionTokensFieldPolicy,
	},
	AssetSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetSettingsKeySpecifier | (() => undefined | AssetSettingsKeySpecifier),
		fields?: AssetSettingsFieldPolicy,
	},
	AssistantCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantCredentialsKeySpecifier | (() => undefined | AssistantCredentialsKeySpecifier),
		fields?: AssistantCredentialsFieldPolicy,
	},
	AssistantCredentialsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantCredentialsConnectionKeySpecifier | (() => undefined | AssistantCredentialsConnectionKeySpecifier),
		fields?: AssistantCredentialsConnectionFieldPolicy,
	},
	AssistantCredentialsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantCredentialsEdgeKeySpecifier | (() => undefined | AssistantCredentialsEdgeKeySpecifier),
		fields?: AssistantCredentialsEdgeFieldPolicy,
	},
	AssistantSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotKeySpecifier | (() => undefined | AssistantSlotKeySpecifier),
		fields?: AssistantSlotFieldPolicy,
	},
	AssistantSlotConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotConnectionKeySpecifier | (() => undefined | AssistantSlotConnectionKeySpecifier),
		fields?: AssistantSlotConnectionFieldPolicy,
	},
	AssistantSlotEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotEdgeKeySpecifier | (() => undefined | AssistantSlotEdgeKeySpecifier),
		fields?: AssistantSlotEdgeFieldPolicy,
	},
	AssistantSlotIdentifiers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotIdentifiersKeySpecifier | (() => undefined | AssistantSlotIdentifiersKeySpecifier),
		fields?: AssistantSlotIdentifiersFieldPolicy,
	},
	AuditEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventKeySpecifier | (() => undefined | AuditEventKeySpecifier),
		fields?: AuditEventFieldPolicy,
	},
	AuditEventConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventConnectionKeySpecifier | (() => undefined | AuditEventConnectionKeySpecifier),
		fields?: AuditEventConnectionFieldPolicy,
	},
	AuditEventEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventEdgeKeySpecifier | (() => undefined | AuditEventEdgeKeySpecifier),
		fields?: AuditEventEdgeFieldPolicy,
	},
	AuditRenewalBackfillResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditRenewalBackfillResultKeySpecifier | (() => undefined | AuditRenewalBackfillResultKeySpecifier),
		fields?: AuditRenewalBackfillResultFieldPolicy,
	},
	AuditRenewalBackfillTenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditRenewalBackfillTenantKeySpecifier | (() => undefined | AuditRenewalBackfillTenantKeySpecifier),
		fields?: AuditRenewalBackfillTenantFieldPolicy,
	},
	AutomaticDeletionSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticDeletionSettingsKeySpecifier | (() => undefined | AutomaticDeletionSettingsKeySpecifier),
		fields?: AutomaticDeletionSettingsFieldPolicy,
	},
	AvailableToAddSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvailableToAddSlotKeySpecifier | (() => undefined | AvailableToAddSlotKeySpecifier),
		fields?: AvailableToAddSlotFieldPolicy,
	},
	AvgDaysToCloseByIncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvgDaysToCloseByIncidentTypeKeySpecifier | (() => undefined | AvgDaysToCloseByIncidentTypeKeySpecifier),
		fields?: AvgDaysToCloseByIncidentTypeFieldPolicy,
	},
	AvgDaysToCloseByTimeInterval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvgDaysToCloseByTimeIntervalKeySpecifier | (() => undefined | AvgDaysToCloseByTimeIntervalKeySpecifier),
		fields?: AvgDaysToCloseByTimeIntervalFieldPolicy,
	},
	BackfillFrameworkSmartFillEntitlementsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BackfillFrameworkSmartFillEntitlementsResultKeySpecifier | (() => undefined | BackfillFrameworkSmartFillEntitlementsResultKeySpecifier),
		fields?: BackfillFrameworkSmartFillEntitlementsResultFieldPolicy,
	},
	BannedEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannedEmailKeySpecifier | (() => undefined | BannedEmailKeySpecifier),
		fields?: BannedEmailFieldPolicy,
	},
	BannedEmailConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannedEmailConnectionKeySpecifier | (() => undefined | BannedEmailConnectionKeySpecifier),
		fields?: BannedEmailConnectionFieldPolicy,
	},
	BannedEmailEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannedEmailEdgeKeySpecifier | (() => undefined | BannedEmailEdgeKeySpecifier),
		fields?: BannedEmailEdgeFieldPolicy,
	},
	BasicLicenceAcceptance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasicLicenceAcceptanceKeySpecifier | (() => undefined | BasicLicenceAcceptanceKeySpecifier),
		fields?: BasicLicenceAcceptanceFieldPolicy,
	},
	BasicLicenceTerms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasicLicenceTermsKeySpecifier | (() => undefined | BasicLicenceTermsKeySpecifier),
		fields?: BasicLicenceTermsFieldPolicy,
	},
	BeaconDomainRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BeaconDomainRuleKeySpecifier | (() => undefined | BeaconDomainRuleKeySpecifier),
		fields?: BeaconDomainRuleFieldPolicy,
	},
	BeaconRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BeaconRulesKeySpecifier | (() => undefined | BeaconRulesKeySpecifier),
		fields?: BeaconRulesFieldPolicy,
	},
	BillingIdentity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingIdentityKeySpecifier | (() => undefined | BillingIdentityKeySpecifier),
		fields?: BillingIdentityFieldPolicy,
	},
	BusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitKeySpecifier | (() => undefined | BusinessUnitKeySpecifier),
		fields?: BusinessUnitFieldPolicy,
	},
	BusinessUnitConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitConnectionKeySpecifier | (() => undefined | BusinessUnitConnectionKeySpecifier),
		fields?: BusinessUnitConnectionFieldPolicy,
	},
	BusinessUnitEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitEdgeKeySpecifier | (() => undefined | BusinessUnitEdgeKeySpecifier),
		fields?: BusinessUnitEdgeFieldPolicy,
	},
	CallsCase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CallsCaseKeySpecifier | (() => undefined | CallsCaseKeySpecifier),
		fields?: CallsCaseFieldPolicy,
	},
	CallsIncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CallsIncidentTypeKeySpecifier | (() => undefined | CallsIncidentTypeKeySpecifier),
		fields?: CallsIncidentTypeFieldPolicy,
	},
	Case?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseKeySpecifier | (() => undefined | CaseKeySpecifier),
		fields?: CaseFieldPolicy,
	},
	CaseActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityKeySpecifier | (() => undefined | CaseActivityKeySpecifier),
		fields?: CaseActivityFieldPolicy,
	},
	CaseActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityConnectionKeySpecifier | (() => undefined | CaseActivityConnectionKeySpecifier),
		fields?: CaseActivityConnectionFieldPolicy,
	},
	CaseActivityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityEdgeKeySpecifier | (() => undefined | CaseActivityEdgeKeySpecifier),
		fields?: CaseActivityEdgeFieldPolicy,
	},
	CaseActivityRelatedField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityRelatedFieldKeySpecifier | (() => undefined | CaseActivityRelatedFieldKeySpecifier),
		fields?: CaseActivityRelatedFieldFieldPolicy,
	},
	CaseActivitySettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsKeySpecifier | (() => undefined | CaseActivitySettingsKeySpecifier),
		fields?: CaseActivitySettingsFieldPolicy,
	},
	CaseActivitySettingsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsConnectionKeySpecifier | (() => undefined | CaseActivitySettingsConnectionKeySpecifier),
		fields?: CaseActivitySettingsConnectionFieldPolicy,
	},
	CaseActivitySettingsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsEdgeKeySpecifier | (() => undefined | CaseActivitySettingsEdgeKeySpecifier),
		fields?: CaseActivitySettingsEdgeFieldPolicy,
	},
	CaseActivitySettingsRelatedField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsRelatedFieldKeySpecifier | (() => undefined | CaseActivitySettingsRelatedFieldKeySpecifier),
		fields?: CaseActivitySettingsRelatedFieldFieldPolicy,
	},
	CaseAnalytics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAnalyticsKeySpecifier | (() => undefined | CaseAnalyticsKeySpecifier),
		fields?: CaseAnalyticsFieldPolicy,
	},
	CaseAnonymityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAnonymityConnectionKeySpecifier | (() => undefined | CaseAnonymityConnectionKeySpecifier),
		fields?: CaseAnonymityConnectionFieldPolicy,
	},
	CaseAnonymityRestrictions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAnonymityRestrictionsKeySpecifier | (() => undefined | CaseAnonymityRestrictionsKeySpecifier),
		fields?: CaseAnonymityRestrictionsFieldPolicy,
	},
	CaseAssignment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAssignmentKeySpecifier | (() => undefined | CaseAssignmentKeySpecifier),
		fields?: CaseAssignmentFieldPolicy,
	},
	CaseAssignmentConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAssignmentConnectionKeySpecifier | (() => undefined | CaseAssignmentConnectionKeySpecifier),
		fields?: CaseAssignmentConnectionFieldPolicy,
	},
	CaseAssignmentEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAssignmentEdgeKeySpecifier | (() => undefined | CaseAssignmentEdgeKeySpecifier),
		fields?: CaseAssignmentEdgeFieldPolicy,
	},
	CaseByCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByCountryKeySpecifier | (() => undefined | CaseByCountryKeySpecifier),
		fields?: CaseByCountryFieldPolicy,
	},
	CaseByReportSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByReportSourceKeySpecifier | (() => undefined | CaseByReportSourceKeySpecifier),
		fields?: CaseByReportSourceFieldPolicy,
	},
	CaseByStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByStatusKeySpecifier | (() => undefined | CaseByStatusKeySpecifier),
		fields?: CaseByStatusFieldPolicy,
	},
	CaseByStatusData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByStatusDataKeySpecifier | (() => undefined | CaseByStatusDataKeySpecifier),
		fields?: CaseByStatusDataFieldPolicy,
	},
	CaseCustomReminder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseCustomReminderKeySpecifier | (() => undefined | CaseCustomReminderKeySpecifier),
		fields?: CaseCustomReminderFieldPolicy,
	},
	CaseCustomReminderConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseCustomReminderConnectionKeySpecifier | (() => undefined | CaseCustomReminderConnectionKeySpecifier),
		fields?: CaseCustomReminderConnectionFieldPolicy,
	},
	CaseCustomReminderEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseCustomReminderEdgeKeySpecifier | (() => undefined | CaseCustomReminderEdgeKeySpecifier),
		fields?: CaseCustomReminderEdgeFieldPolicy,
	},
	CaseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseEdgeKeySpecifier | (() => undefined | CaseEdgeKeySpecifier),
		fields?: CaseEdgeFieldPolicy,
	},
	CaseExclusionOwner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerKeySpecifier | (() => undefined | CaseExclusionOwnerKeySpecifier),
		fields?: CaseExclusionOwnerFieldPolicy,
	},
	CaseExclusionOwnerEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerEdgeKeySpecifier | (() => undefined | CaseExclusionOwnerEdgeKeySpecifier),
		fields?: CaseExclusionOwnerEdgeFieldPolicy,
	},
	CaseExclusionOwnerListPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerListPaginatedKeySpecifier | (() => undefined | CaseExclusionOwnerListPaginatedKeySpecifier),
		fields?: CaseExclusionOwnerListPaginatedFieldPolicy,
	},
	CaseExclusionOwnerPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerPageKeySpecifier | (() => undefined | CaseExclusionOwnerPageKeySpecifier),
		fields?: CaseExclusionOwnerPageFieldPolicy,
	},
	CaseFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseFileKeySpecifier | (() => undefined | CaseFileKeySpecifier),
		fields?: CaseFileFieldPolicy,
	},
	CaseFileConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseFileConnectionKeySpecifier | (() => undefined | CaseFileConnectionKeySpecifier),
		fields?: CaseFileConnectionFieldPolicy,
	},
	CaseFileEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseFileEdgeKeySpecifier | (() => undefined | CaseFileEdgeKeySpecifier),
		fields?: CaseFileEdgeFieldPolicy,
	},
	CaseHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseHistoryKeySpecifier | (() => undefined | CaseHistoryKeySpecifier),
		fields?: CaseHistoryFieldPolicy,
	},
	CaseHistoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseHistoryConnectionKeySpecifier | (() => undefined | CaseHistoryConnectionKeySpecifier),
		fields?: CaseHistoryConnectionFieldPolicy,
	},
	CaseHistoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseHistoryEdgeKeySpecifier | (() => undefined | CaseHistoryEdgeKeySpecifier),
		fields?: CaseHistoryEdgeFieldPolicy,
	},
	CaseInvestigation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationKeySpecifier | (() => undefined | CaseInvestigationKeySpecifier),
		fields?: CaseInvestigationFieldPolicy,
	},
	CaseInvestigationConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationConnectionKeySpecifier | (() => undefined | CaseInvestigationConnectionKeySpecifier),
		fields?: CaseInvestigationConnectionFieldPolicy,
	},
	CaseInvestigationPdfReportGenerateResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationPdfReportGenerateResponseKeySpecifier | (() => undefined | CaseInvestigationPdfReportGenerateResponseKeySpecifier),
		fields?: CaseInvestigationPdfReportGenerateResponseFieldPolicy,
	},
	CaseInvestigationStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationStatisticsKeySpecifier | (() => undefined | CaseInvestigationStatisticsKeySpecifier),
		fields?: CaseInvestigationStatisticsFieldPolicy,
	},
	CaseInvestigators?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigatorsKeySpecifier | (() => undefined | CaseInvestigatorsKeySpecifier),
		fields?: CaseInvestigatorsFieldPolicy,
	},
	CaseOwnerExclusion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseOwnerExclusionKeySpecifier | (() => undefined | CaseOwnerExclusionKeySpecifier),
		fields?: CaseOwnerExclusionFieldPolicy,
	},
	CaseOwnerExclusionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseOwnerExclusionConnectionKeySpecifier | (() => undefined | CaseOwnerExclusionConnectionKeySpecifier),
		fields?: CaseOwnerExclusionConnectionFieldPolicy,
	},
	CaseOwnerExclusionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseOwnerExclusionEdgeKeySpecifier | (() => undefined | CaseOwnerExclusionEdgeKeySpecifier),
		fields?: CaseOwnerExclusionEdgeFieldPolicy,
	},
	CasePrintSections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CasePrintSectionsKeySpecifier | (() => undefined | CasePrintSectionsKeySpecifier),
		fields?: CasePrintSectionsFieldPolicy,
	},
	CasePrintSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CasePrintSettingsKeySpecifier | (() => undefined | CasePrintSettingsKeySpecifier),
		fields?: CasePrintSettingsFieldPolicy,
	},
	CaseReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportKeySpecifier | (() => undefined | CaseReportKeySpecifier),
		fields?: CaseReportFieldPolicy,
	},
	CaseReportConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportConnectionKeySpecifier | (() => undefined | CaseReportConnectionKeySpecifier),
		fields?: CaseReportConnectionFieldPolicy,
	},
	CaseReportEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportEdgeKeySpecifier | (() => undefined | CaseReportEdgeKeySpecifier),
		fields?: CaseReportEdgeFieldPolicy,
	},
	CaseReportStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportStatisticsKeySpecifier | (() => undefined | CaseReportStatisticsKeySpecifier),
		fields?: CaseReportStatisticsFieldPolicy,
	},
	CaseReportSubmit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportSubmitKeySpecifier | (() => undefined | CaseReportSubmitKeySpecifier),
		fields?: CaseReportSubmitFieldPolicy,
	},
	CaseReportSummaryResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportSummaryResponseKeySpecifier | (() => undefined | CaseReportSummaryResponseKeySpecifier),
		fields?: CaseReportSummaryResponseFieldPolicy,
	},
	CaseReporter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReporterKeySpecifier | (() => undefined | CaseReporterKeySpecifier),
		fields?: CaseReporterFieldPolicy,
	},
	CaseSettingAnonymity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseSettingAnonymityKeySpecifier | (() => undefined | CaseSettingAnonymityKeySpecifier),
		fields?: CaseSettingAnonymityFieldPolicy,
	},
	CaseSettingExclusion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseSettingExclusionKeySpecifier | (() => undefined | CaseSettingExclusionKeySpecifier),
		fields?: CaseSettingExclusionFieldPolicy,
	},
	CaseSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseSettingsKeySpecifier | (() => undefined | CaseSettingsKeySpecifier),
		fields?: CaseSettingsFieldPolicy,
	},
	CaseStatusByIncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseStatusByIncidentTypeKeySpecifier | (() => undefined | CaseStatusByIncidentTypeKeySpecifier),
		fields?: CaseStatusByIncidentTypeFieldPolicy,
	},
	CasesRolePermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CasesRolePermissionKeySpecifier | (() => undefined | CasesRolePermissionKeySpecifier),
		fields?: CasesRolePermissionFieldPolicy,
	},
	CatalogueCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CatalogueCategoryKeySpecifier | (() => undefined | CatalogueCategoryKeySpecifier),
		fields?: CatalogueCategoryFieldPolicy,
	},
	CataloguePlan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CataloguePlanKeySpecifier | (() => undefined | CataloguePlanKeySpecifier),
		fields?: CataloguePlanFieldPolicy,
	},
	CatalogueProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CatalogueProductKeySpecifier | (() => undefined | CatalogueProductKeySpecifier),
		fields?: CatalogueProductFieldPolicy,
	},
	Category?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryKeySpecifier | (() => undefined | CategoryKeySpecifier),
		fields?: CategoryFieldPolicy,
	},
	ChatRoom?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatRoomKeySpecifier | (() => undefined | ChatRoomKeySpecifier),
		fields?: ChatRoomFieldPolicy,
	},
	Chatbot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotKeySpecifier | (() => undefined | ChatbotKeySpecifier),
		fields?: ChatbotFieldPolicy,
	},
	ChatbotMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotMessageKeySpecifier | (() => undefined | ChatbotMessageKeySpecifier),
		fields?: ChatbotMessageFieldPolicy,
	},
	ChatbotMessageConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotMessageConnectionKeySpecifier | (() => undefined | ChatbotMessageConnectionKeySpecifier),
		fields?: ChatbotMessageConnectionFieldPolicy,
	},
	ChatbotMessageEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotMessageEdgeKeySpecifier | (() => undefined | ChatbotMessageEdgeKeySpecifier),
		fields?: ChatbotMessageEdgeFieldPolicy,
	},
	ChatsFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatsFileKeySpecifier | (() => undefined | ChatsFileKeySpecifier),
		fields?: ChatsFileFieldPolicy,
	},
	CheckoutSessionView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutSessionViewKeySpecifier | (() => undefined | CheckoutSessionViewKeySpecifier),
		fields?: CheckoutSessionViewFieldPolicy,
	},
	CheckoutTermOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutTermOptionKeySpecifier | (() => undefined | CheckoutTermOptionKeySpecifier),
		fields?: CheckoutTermOptionFieldPolicy,
	},
	CheckoutTermsContext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutTermsContextKeySpecifier | (() => undefined | CheckoutTermsContextKeySpecifier),
		fields?: CheckoutTermsContextFieldPolicy,
	},
	ClientSubsidiarySite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySiteKeySpecifier | (() => undefined | ClientSubsidiarySiteKeySpecifier),
		fields?: ClientSubsidiarySiteFieldPolicy,
	},
	ClientSubsidiarySiteAdmin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySiteAdminKeySpecifier | (() => undefined | ClientSubsidiarySiteAdminKeySpecifier),
		fields?: ClientSubsidiarySiteAdminFieldPolicy,
	},
	ClientSubsidiarySiteEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySiteEdgeKeySpecifier | (() => undefined | ClientSubsidiarySiteEdgeKeySpecifier),
		fields?: ClientSubsidiarySiteEdgeFieldPolicy,
	},
	ClientSubsidiarySitesConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySitesConnectionKeySpecifier | (() => undefined | ClientSubsidiarySitesConnectionKeySpecifier),
		fields?: ClientSubsidiarySitesConnectionFieldPolicy,
	},
	ClientUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientUserKeySpecifier | (() => undefined | ClientUserKeySpecifier),
		fields?: ClientUserFieldPolicy,
	},
	ConclusionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConclusionTypeKeySpecifier | (() => undefined | ConclusionTypeKeySpecifier),
		fields?: ConclusionTypeFieldPolicy,
	},
	ConclusionTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConclusionTypeConnectionKeySpecifier | (() => undefined | ConclusionTypeConnectionKeySpecifier),
		fields?: ConclusionTypeConnectionFieldPolicy,
	},
	ConclusionTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConclusionTypeEdgeKeySpecifier | (() => undefined | ConclusionTypeEdgeKeySpecifier),
		fields?: ConclusionTypeEdgeFieldPolicy,
	},
	ConfirmCheckoutEmailVerification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfirmCheckoutEmailVerificationKeySpecifier | (() => undefined | ConfirmCheckoutEmailVerificationKeySpecifier),
		fields?: ConfirmCheckoutEmailVerificationFieldPolicy,
	},
	ConfirmReporterEmailVerification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfirmReporterEmailVerificationKeySpecifier | (() => undefined | ConfirmReporterEmailVerificationKeySpecifier),
		fields?: ConfirmReporterEmailVerificationFieldPolicy,
	},
	ConversationActionSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationActionSlotKeySpecifier | (() => undefined | ConversationActionSlotKeySpecifier),
		fields?: ConversationActionSlotFieldPolicy,
	},
	ConversationAssistantResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationAssistantResponseKeySpecifier | (() => undefined | ConversationAssistantResponseKeySpecifier),
		fields?: ConversationAssistantResponseFieldPolicy,
	},
	ConversationEditingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationEditingSettingsKeySpecifier | (() => undefined | ConversationEditingSettingsKeySpecifier),
		fields?: ConversationEditingSettingsFieldPolicy,
	},
	ConversationMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationMessageKeySpecifier | (() => undefined | ConversationMessageKeySpecifier),
		fields?: ConversationMessageFieldPolicy,
	},
	ConversationProgress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationProgressKeySpecifier | (() => undefined | ConversationProgressKeySpecifier),
		fields?: ConversationProgressFieldPolicy,
	},
	CountryAnonymity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryAnonymityKeySpecifier | (() => undefined | CountryAnonymityKeySpecifier),
		fields?: CountryAnonymityFieldPolicy,
	},
	CountryAnonymityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryAnonymityEdgeKeySpecifier | (() => undefined | CountryAnonymityEdgeKeySpecifier),
		fields?: CountryAnonymityEdgeFieldPolicy,
	},
	CreateCheckoutSessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateCheckoutSessionPayloadKeySpecifier | (() => undefined | CreateCheckoutSessionPayloadKeySpecifier),
		fields?: CreateCheckoutSessionPayloadFieldPolicy,
	},
	CustomerAgreement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAgreementKeySpecifier | (() => undefined | CustomerAgreementKeySpecifier),
		fields?: CustomerAgreementFieldPolicy,
	},
	CustomerInvoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerInvoiceKeySpecifier | (() => undefined | CustomerInvoiceKeySpecifier),
		fields?: CustomerInvoiceFieldPolicy,
	},
	CustomerInvoiceHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerInvoiceHistoryKeySpecifier | (() => undefined | CustomerInvoiceHistoryKeySpecifier),
		fields?: CustomerInvoiceHistoryFieldPolicy,
	},
	CustomerInvoicePdf?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerInvoicePdfKeySpecifier | (() => undefined | CustomerInvoicePdfKeySpecifier),
		fields?: CustomerInvoicePdfFieldPolicy,
	},
	DataCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataCategoryKeySpecifier | (() => undefined | DataCategoryKeySpecifier),
		fields?: DataCategoryFieldPolicy,
	},
	DataCategoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataCategoryConnectionKeySpecifier | (() => undefined | DataCategoryConnectionKeySpecifier),
		fields?: DataCategoryConnectionFieldPolicy,
	},
	DataCategoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataCategoryEdgeKeySpecifier | (() => undefined | DataCategoryEdgeKeySpecifier),
		fields?: DataCategoryEdgeFieldPolicy,
	},
	Disclosure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureKeySpecifier | (() => undefined | DisclosureKeySpecifier),
		fields?: DisclosureFieldPolicy,
	},
	DisclosureChatNotificationExtra?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureChatNotificationExtraKeySpecifier | (() => undefined | DisclosureChatNotificationExtraKeySpecifier),
		fields?: DisclosureChatNotificationExtraFieldPolicy,
	},
	DisclosureCommentsPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureCommentsPaginatedKeySpecifier | (() => undefined | DisclosureCommentsPaginatedKeySpecifier),
		fields?: DisclosureCommentsPaginatedFieldPolicy,
	},
	DisclosureConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureConnectionKeySpecifier | (() => undefined | DisclosureConnectionKeySpecifier),
		fields?: DisclosureConnectionFieldPolicy,
	},
	DisclosureEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureEdgeKeySpecifier | (() => undefined | DisclosureEdgeKeySpecifier),
		fields?: DisclosureEdgeFieldPolicy,
	},
	DisclosureEmailTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureEmailTargetKeySpecifier | (() => undefined | DisclosureEmailTargetKeySpecifier),
		fields?: DisclosureEmailTargetFieldPolicy,
	},
	DisclosurePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosurePageKeySpecifier | (() => undefined | DisclosurePageKeySpecifier),
		fields?: DisclosurePageFieldPolicy,
	},
	DisclosurePaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosurePaginatedKeySpecifier | (() => undefined | DisclosurePaginatedKeySpecifier),
		fields?: DisclosurePaginatedFieldPolicy,
	},
	DisclosureResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseKeySpecifier | (() => undefined | DisclosureResponseKeySpecifier),
		fields?: DisclosureResponseFieldPolicy,
	},
	DisclosureResponseComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseCommentKeySpecifier | (() => undefined | DisclosureResponseCommentKeySpecifier),
		fields?: DisclosureResponseCommentFieldPolicy,
	},
	DisclosureResponseCommentEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseCommentEdgeKeySpecifier | (() => undefined | DisclosureResponseCommentEdgeKeySpecifier),
		fields?: DisclosureResponseCommentEdgeFieldPolicy,
	},
	DisclosureResponseCommentPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseCommentPageKeySpecifier | (() => undefined | DisclosureResponseCommentPageKeySpecifier),
		fields?: DisclosureResponseCommentPageFieldPolicy,
	},
	DisclosureResponseConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseConnectionKeySpecifier | (() => undefined | DisclosureResponseConnectionKeySpecifier),
		fields?: DisclosureResponseConnectionFieldPolicy,
	},
	DisclosureResponseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseEdgeKeySpecifier | (() => undefined | DisclosureResponseEdgeKeySpecifier),
		fields?: DisclosureResponseEdgeFieldPolicy,
	},
	DisclosureResponsePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponsePageKeySpecifier | (() => undefined | DisclosureResponsePageKeySpecifier),
		fields?: DisclosureResponsePageFieldPolicy,
	},
	DisclosureResponsesPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponsesPaginatedKeySpecifier | (() => undefined | DisclosureResponsesPaginatedKeySpecifier),
		fields?: DisclosureResponsesPaginatedFieldPolicy,
	},
	DisclosureStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureStatisticsKeySpecifier | (() => undefined | DisclosureStatisticsKeySpecifier),
		fields?: DisclosureStatisticsFieldPolicy,
	},
	DisclosureUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureUserKeySpecifier | (() => undefined | DisclosureUserKeySpecifier),
		fields?: DisclosureUserFieldPolicy,
	},
	DisclosureUserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureUserConnectionKeySpecifier | (() => undefined | DisclosureUserConnectionKeySpecifier),
		fields?: DisclosureUserConnectionFieldPolicy,
	},
	DisclosureUserEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureUserEdgeKeySpecifier | (() => undefined | DisclosureUserEdgeKeySpecifier),
		fields?: DisclosureUserEdgeFieldPolicy,
	},
	ESGGroupTagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ESGGroupTagEdgeKeySpecifier | (() => undefined | ESGGroupTagEdgeKeySpecifier),
		fields?: ESGGroupTagEdgeFieldPolicy,
	},
	ElineConversation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElineConversationKeySpecifier | (() => undefined | ElineConversationKeySpecifier),
		fields?: ElineConversationFieldPolicy,
	},
	ElineNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElineNumberKeySpecifier | (() => undefined | ElineNumberKeySpecifier),
		fields?: ElineNumberFieldPolicy,
	},
	ElinePhoneNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElinePhoneNumberKeySpecifier | (() => undefined | ElinePhoneNumberKeySpecifier),
		fields?: ElinePhoneNumberFieldPolicy,
	},
	EmailEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailEntryKeySpecifier | (() => undefined | EmailEntryKeySpecifier),
		fields?: EmailEntryFieldPolicy,
	},
	EmailEntryEditResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailEntryEditResultKeySpecifier | (() => undefined | EmailEntryEditResultKeySpecifier),
		fields?: EmailEntryEditResultFieldPolicy,
	},
	EmailList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailListKeySpecifier | (() => undefined | EmailListKeySpecifier),
		fields?: EmailListFieldPolicy,
	},
	EmailListConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailListConnectionKeySpecifier | (() => undefined | EmailListConnectionKeySpecifier),
		fields?: EmailListConnectionFieldPolicy,
	},
	EmailListEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailListEdgeKeySpecifier | (() => undefined | EmailListEdgeKeySpecifier),
		fields?: EmailListEdgeFieldPolicy,
	},
	EmailMessageParsedResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailMessageParsedResponseKeySpecifier | (() => undefined | EmailMessageParsedResponseKeySpecifier),
		fields?: EmailMessageParsedResponseFieldPolicy,
	},
	EmailTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailTemplateKeySpecifier | (() => undefined | EmailTemplateKeySpecifier),
		fields?: EmailTemplateFieldPolicy,
	},
	EmailTemplateRecipients?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailTemplateRecipientsKeySpecifier | (() => undefined | EmailTemplateRecipientsKeySpecifier),
		fields?: EmailTemplateRecipientsFieldPolicy,
	},
	EnabledSsoMethodsForTenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnabledSsoMethodsForTenantKeySpecifier | (() => undefined | EnabledSsoMethodsForTenantKeySpecifier),
		fields?: EnabledSsoMethodsForTenantFieldPolicy,
	},
	EngagementPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EngagementPriceKeySpecifier | (() => undefined | EngagementPriceKeySpecifier),
		fields?: EngagementPriceFieldPolicy,
	},
	EngagementPriceLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EngagementPriceLineKeySpecifier | (() => undefined | EngagementPriceLineKeySpecifier),
		fields?: EngagementPriceLineFieldPolicy,
	},
	EntitlementItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntitlementItemKeySpecifier | (() => undefined | EntitlementItemKeySpecifier),
		fields?: EntitlementItemFieldPolicy,
	},
	EntitlementModule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntitlementModuleKeySpecifier | (() => undefined | EntitlementModuleKeySpecifier),
		fields?: EntitlementModuleFieldPolicy,
	},
	EntitlementSeats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EntitlementSeatsKeySpecifier | (() => undefined | EntitlementSeatsKeySpecifier),
		fields?: EntitlementSeatsFieldPolicy,
	},
	EsgActivitiesForActivityReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgActivitiesForActivityReportKeySpecifier | (() => undefined | EsgActivitiesForActivityReportKeySpecifier),
		fields?: EsgActivitiesForActivityReportFieldPolicy,
	},
	EsgAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgAnswerKeySpecifier | (() => undefined | EsgAnswerKeySpecifier),
		fields?: EsgAnswerFieldPolicy,
	},
	EsgAnswerGenerateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgAnswerGenerateResultKeySpecifier | (() => undefined | EsgAnswerGenerateResultKeySpecifier),
		fields?: EsgAnswerGenerateResultFieldPolicy,
	},
	EsgAnswerTags?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgAnswerTagsKeySpecifier | (() => undefined | EsgAnswerTagsKeySpecifier),
		fields?: EsgAnswerTagsFieldPolicy,
	},
	EsgCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgCategoryKeySpecifier | (() => undefined | EsgCategoryKeySpecifier),
		fields?: EsgCategoryFieldPolicy,
	},
	EsgFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFileKeySpecifier | (() => undefined | EsgFileKeySpecifier),
		fields?: EsgFileFieldPolicy,
	},
	EsgFrameworkAudit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditKeySpecifier | (() => undefined | EsgFrameworkAuditKeySpecifier),
		fields?: EsgFrameworkAuditFieldPolicy,
	},
	EsgFrameworkAuditAdminEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditAdminEntryKeySpecifier | (() => undefined | EsgFrameworkAuditAdminEntryKeySpecifier),
		fields?: EsgFrameworkAuditAdminEntryFieldPolicy,
	},
	EsgFrameworkAuditAuditor?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditAuditorKeySpecifier | (() => undefined | EsgFrameworkAuditAuditorKeySpecifier),
		fields?: EsgFrameworkAuditAuditorFieldPolicy,
	},
	EsgFrameworkAuditEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditEntryKeySpecifier | (() => undefined | EsgFrameworkAuditEntryKeySpecifier),
		fields?: EsgFrameworkAuditEntryFieldPolicy,
	},
	EsgFrameworkAuditEntryAiJustification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditEntryAiJustificationKeySpecifier | (() => undefined | EsgFrameworkAuditEntryAiJustificationKeySpecifier),
		fields?: EsgFrameworkAuditEntryAiJustificationFieldPolicy,
	},
	EsgFrameworkAuditFindingMix?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditFindingMixKeySpecifier | (() => undefined | EsgFrameworkAuditFindingMixKeySpecifier),
		fields?: EsgFrameworkAuditFindingMixFieldPolicy,
	},
	EsgFrameworkAuditGapCitation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditGapCitationKeySpecifier | (() => undefined | EsgFrameworkAuditGapCitationKeySpecifier),
		fields?: EsgFrameworkAuditGapCitationFieldPolicy,
	},
	EsgFrameworkAuditGapRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditGapRunKeySpecifier | (() => undefined | EsgFrameworkAuditGapRunKeySpecifier),
		fields?: EsgFrameworkAuditGapRunFieldPolicy,
	},
	EsgFrameworkAuditGapSuggestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditGapSuggestionKeySpecifier | (() => undefined | EsgFrameworkAuditGapSuggestionKeySpecifier),
		fields?: EsgFrameworkAuditGapSuggestionFieldPolicy,
	},
	EsgFrameworkAuditQuestionReview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditQuestionReviewKeySpecifier | (() => undefined | EsgFrameworkAuditQuestionReviewKeySpecifier),
		fields?: EsgFrameworkAuditQuestionReviewFieldPolicy,
	},
	EsgFrameworkAuditSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkAuditSummaryKeySpecifier | (() => undefined | EsgFrameworkAuditSummaryKeySpecifier),
		fields?: EsgFrameworkAuditSummaryFieldPolicy,
	},
	EsgFrameworkDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkDocumentKeySpecifier | (() => undefined | EsgFrameworkDocumentKeySpecifier),
		fields?: EsgFrameworkDocumentFieldPolicy,
	},
	EsgFrameworkDocumentMutationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkDocumentMutationResultKeySpecifier | (() => undefined | EsgFrameworkDocumentMutationResultKeySpecifier),
		fields?: EsgFrameworkDocumentMutationResultFieldPolicy,
	},
	EsgFrameworkDocumentStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkDocumentStatsKeySpecifier | (() => undefined | EsgFrameworkDocumentStatsKeySpecifier),
		fields?: EsgFrameworkDocumentStatsFieldPolicy,
	},
	EsgFrameworkDocuments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFrameworkDocumentsKeySpecifier | (() => undefined | EsgFrameworkDocumentsKeySpecifier),
		fields?: EsgFrameworkDocumentsFieldPolicy,
	},
	EsgGapAnalysisBatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgGapAnalysisBatchKeySpecifier | (() => undefined | EsgGapAnalysisBatchKeySpecifier),
		fields?: EsgGapAnalysisBatchFieldPolicy,
	},
	EsgGapAnalysisJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgGapAnalysisJobKeySpecifier | (() => undefined | EsgGapAnalysisJobKeySpecifier),
		fields?: EsgGapAnalysisJobFieldPolicy,
	},
	EsgGroupTagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgGroupTagConnectionKeySpecifier | (() => undefined | EsgGroupTagConnectionKeySpecifier),
		fields?: EsgGroupTagConnectionFieldPolicy,
	},
	EsgGroupedStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgGroupedStatisticsKeySpecifier | (() => undefined | EsgGroupedStatisticsKeySpecifier),
		fields?: EsgGroupedStatisticsFieldPolicy,
	},
	EsgHistoryElement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgHistoryElementKeySpecifier | (() => undefined | EsgHistoryElementKeySpecifier),
		fields?: EsgHistoryElementFieldPolicy,
	},
	EsgQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionKeySpecifier | (() => undefined | EsgQuestionKeySpecifier),
		fields?: EsgQuestionFieldPolicy,
	},
	EsgQuestionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionConnectionKeySpecifier | (() => undefined | EsgQuestionConnectionKeySpecifier),
		fields?: EsgQuestionConnectionFieldPolicy,
	},
	EsgQuestionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionEdgeKeySpecifier | (() => undefined | EsgQuestionEdgeKeySpecifier),
		fields?: EsgQuestionEdgeFieldPolicy,
	},
	EsgQuestionMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionMetadataKeySpecifier | (() => undefined | EsgQuestionMetadataKeySpecifier),
		fields?: EsgQuestionMetadataFieldPolicy,
	},
	EsgQuestionRiskAreaMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionRiskAreaMetadataKeySpecifier | (() => undefined | EsgQuestionRiskAreaMetadataKeySpecifier),
		fields?: EsgQuestionRiskAreaMetadataFieldPolicy,
	},
	EsgQuestionSearchConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionSearchConnectionKeySpecifier | (() => undefined | EsgQuestionSearchConnectionKeySpecifier),
		fields?: EsgQuestionSearchConnectionFieldPolicy,
	},
	EsgQuestionTagMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionTagMetadataKeySpecifier | (() => undefined | EsgQuestionTagMetadataKeySpecifier),
		fields?: EsgQuestionTagMetadataFieldPolicy,
	},
	EsgQuestionTagsMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionTagsMetadataKeySpecifier | (() => undefined | EsgQuestionTagsMetadataKeySpecifier),
		fields?: EsgQuestionTagsMetadataFieldPolicy,
	},
	EsgRiskAreaSettingByProgram?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgRiskAreaSettingByProgramKeySpecifier | (() => undefined | EsgRiskAreaSettingByProgramKeySpecifier),
		fields?: EsgRiskAreaSettingByProgramFieldPolicy,
	},
	EsgRiskAreaSettingsByProgram?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgRiskAreaSettingsByProgramKeySpecifier | (() => undefined | EsgRiskAreaSettingsByProgramKeySpecifier),
		fields?: EsgRiskAreaSettingsByProgramFieldPolicy,
	},
	EsgRolePermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgRolePermissionKeySpecifier | (() => undefined | EsgRolePermissionKeySpecifier),
		fields?: EsgRolePermissionFieldPolicy,
	},
	EsgSmartFillApplyDraftsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillApplyDraftsPayloadKeySpecifier | (() => undefined | EsgSmartFillApplyDraftsPayloadKeySpecifier),
		fields?: EsgSmartFillApplyDraftsPayloadFieldPolicy,
	},
	EsgSmartFillCancelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillCancelPayloadKeySpecifier | (() => undefined | EsgSmartFillCancelPayloadKeySpecifier),
		fields?: EsgSmartFillCancelPayloadFieldPolicy,
	},
	EsgSmartFillDraftAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillDraftAnswerKeySpecifier | (() => undefined | EsgSmartFillDraftAnswerKeySpecifier),
		fields?: EsgSmartFillDraftAnswerFieldPolicy,
	},
	EsgSmartFillDraftCitation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillDraftCitationKeySpecifier | (() => undefined | EsgSmartFillDraftCitationKeySpecifier),
		fields?: EsgSmartFillDraftCitationFieldPolicy,
	},
	EsgSmartFillDraftMutationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillDraftMutationResultKeySpecifier | (() => undefined | EsgSmartFillDraftMutationResultKeySpecifier),
		fields?: EsgSmartFillDraftMutationResultFieldPolicy,
	},
	EsgSmartFillIngestResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillIngestResultKeySpecifier | (() => undefined | EsgSmartFillIngestResultKeySpecifier),
		fields?: EsgSmartFillIngestResultFieldPolicy,
	},
	EsgSmartFillJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillJobKeySpecifier | (() => undefined | EsgSmartFillJobKeySpecifier),
		fields?: EsgSmartFillJobFieldPolicy,
	},
	EsgSmartFillPendingDraft?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillPendingDraftKeySpecifier | (() => undefined | EsgSmartFillPendingDraftKeySpecifier),
		fields?: EsgSmartFillPendingDraftFieldPolicy,
	},
	EsgSmartFillResumePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillResumePayloadKeySpecifier | (() => undefined | EsgSmartFillResumePayloadKeySpecifier),
		fields?: EsgSmartFillResumePayloadFieldPolicy,
	},
	EsgSmartFillSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillSourceKeySpecifier | (() => undefined | EsgSmartFillSourceKeySpecifier),
		fields?: EsgSmartFillSourceFieldPolicy,
	},
	EsgStandard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStandardKeySpecifier | (() => undefined | EsgStandardKeySpecifier),
		fields?: EsgStandardFieldPolicy,
	},
	EsgStandardWithConnectedRiskAreas?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStandardWithConnectedRiskAreasKeySpecifier | (() => undefined | EsgStandardWithConnectedRiskAreasKeySpecifier),
		fields?: EsgStandardWithConnectedRiskAreasFieldPolicy,
	},
	EsgStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStatisticsKeySpecifier | (() => undefined | EsgStatisticsKeySpecifier),
		fields?: EsgStatisticsFieldPolicy,
	},
	EsgStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStepKeySpecifier | (() => undefined | EsgStepKeySpecifier),
		fields?: EsgStepFieldPolicy,
	},
	EsgSubcategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSubcategoryKeySpecifier | (() => undefined | EsgSubcategoryKeySpecifier),
		fields?: EsgSubcategoryFieldPolicy,
	},
	EsgTagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTagConnectionKeySpecifier | (() => undefined | EsgTagConnectionKeySpecifier),
		fields?: EsgTagConnectionFieldPolicy,
	},
	EsgTagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTagEdgeKeySpecifier | (() => undefined | EsgTagEdgeKeySpecifier),
		fields?: EsgTagEdgeFieldPolicy,
	},
	EsgTaskDisabledReason?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTaskDisabledReasonKeySpecifier | (() => undefined | EsgTaskDisabledReasonKeySpecifier),
		fields?: EsgTaskDisabledReasonFieldPolicy,
	},
	EsgTenantProgramSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTenantProgramSettingKeySpecifier | (() => undefined | EsgTenantProgramSettingKeySpecifier),
		fields?: EsgTenantProgramSettingFieldPolicy,
	},
	EsgTenantProgramSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTenantProgramSettingsKeySpecifier | (() => undefined | EsgTenantProgramSettingsKeySpecifier),
		fields?: EsgTenantProgramSettingsFieldPolicy,
	},
	EsgVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgVideoKeySpecifier | (() => undefined | EsgVideoKeySpecifier),
		fields?: EsgVideoFieldPolicy,
	},
	EsgVideoConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgVideoConnectionKeySpecifier | (() => undefined | EsgVideoConnectionKeySpecifier),
		fields?: EsgVideoConnectionFieldPolicy,
	},
	EsgVideoEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgVideoEdgeKeySpecifier | (() => undefined | EsgVideoEdgeKeySpecifier),
		fields?: EsgVideoEdgeFieldPolicy,
	},
	ExclusionAdminUserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExclusionAdminUserConnectionKeySpecifier | (() => undefined | ExclusionAdminUserConnectionKeySpecifier),
		fields?: ExclusionAdminUserConnectionFieldPolicy,
	},
	ExecEdCourse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExecEdCourseKeySpecifier | (() => undefined | ExecEdCourseKeySpecifier),
		fields?: ExecEdCourseFieldPolicy,
	},
	ExternalUserAvailableRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalUserAvailableRiskAreaKeySpecifier | (() => undefined | ExternalUserAvailableRiskAreaKeySpecifier),
		fields?: ExternalUserAvailableRiskAreaFieldPolicy,
	},
	FeatureSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureSettingKeySpecifier | (() => undefined | FeatureSettingKeySpecifier),
		fields?: FeatureSettingFieldPolicy,
	},
	FeeTablePrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeeTablePriceKeySpecifier | (() => undefined | FeeTablePriceKeySpecifier),
		fields?: FeeTablePriceFieldPolicy,
	},
	FirebaseResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FirebaseResponseKeySpecifier | (() => undefined | FirebaseResponseKeySpecifier),
		fields?: FirebaseResponseFieldPolicy,
	},
	FirebaseToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FirebaseTokenKeySpecifier | (() => undefined | FirebaseTokenKeySpecifier),
		fields?: FirebaseTokenFieldPolicy,
	},
	FirebaseTopicSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FirebaseTopicSubscriptionKeySpecifier | (() => undefined | FirebaseTopicSubscriptionKeySpecifier),
		fields?: FirebaseTopicSubscriptionFieldPolicy,
	},
	FitnessIndicator?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FitnessIndicatorKeySpecifier | (() => undefined | FitnessIndicatorKeySpecifier),
		fields?: FitnessIndicatorFieldPolicy,
	},
	FitnessVariable?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FitnessVariableKeySpecifier | (() => undefined | FitnessVariableKeySpecifier),
		fields?: FitnessVariableFieldPolicy,
	},
	ForwardEarthCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ForwardEarthCredentialsKeySpecifier | (() => undefined | ForwardEarthCredentialsKeySpecifier),
		fields?: ForwardEarthCredentialsFieldPolicy,
	},
	FrameworkImportCategoryObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FrameworkImportCategoryObjectKeySpecifier | (() => undefined | FrameworkImportCategoryObjectKeySpecifier),
		fields?: FrameworkImportCategoryObjectFieldPolicy,
	},
	FrameworkImportFrameworkObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FrameworkImportFrameworkObjectKeySpecifier | (() => undefined | FrameworkImportFrameworkObjectKeySpecifier),
		fields?: FrameworkImportFrameworkObjectFieldPolicy,
	},
	FrameworkImportResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FrameworkImportResultKeySpecifier | (() => undefined | FrameworkImportResultKeySpecifier),
		fields?: FrameworkImportResultFieldPolicy,
	},
	FrameworkSeatPoolOverview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FrameworkSeatPoolOverviewKeySpecifier | (() => undefined | FrameworkSeatPoolOverviewKeySpecifier),
		fields?: FrameworkSeatPoolOverviewFieldPolicy,
	},
	FrameworkSeatRoster?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FrameworkSeatRosterKeySpecifier | (() => undefined | FrameworkSeatRosterKeySpecifier),
		fields?: FrameworkSeatRosterFieldPolicy,
	},
	FrameworkSmartFillEntitlement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FrameworkSmartFillEntitlementKeySpecifier | (() => undefined | FrameworkSmartFillEntitlementKeySpecifier),
		fields?: FrameworkSmartFillEntitlementFieldPolicy,
	},
	GlobalTenantBaseData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalTenantBaseDataKeySpecifier | (() => undefined | GlobalTenantBaseDataKeySpecifier),
		fields?: GlobalTenantBaseDataFieldPolicy,
	},
	GlossaryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlossaryConnectionKeySpecifier | (() => undefined | GlossaryConnectionKeySpecifier),
		fields?: GlossaryConnectionFieldPolicy,
	},
	GlossaryEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlossaryEntryKeySpecifier | (() => undefined | GlossaryEntryKeySpecifier),
		fields?: GlossaryEntryFieldPolicy,
	},
	GlossaryEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlossaryEntryEdgeKeySpecifier | (() => undefined | GlossaryEntryEdgeKeySpecifier),
		fields?: GlossaryEntryEdgeFieldPolicy,
	},
	GreenDeskPlanRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GreenDeskPlanRuleKeySpecifier | (() => undefined | GreenDeskPlanRuleKeySpecifier),
		fields?: GreenDeskPlanRuleFieldPolicy,
	},
	GroupTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagKeySpecifier | (() => undefined | GroupTagKeySpecifier),
		fields?: GroupTagFieldPolicy,
	},
	GroupTagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagConnectionKeySpecifier | (() => undefined | GroupTagConnectionKeySpecifier),
		fields?: GroupTagConnectionFieldPolicy,
	},
	GroupTagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagEdgeKeySpecifier | (() => undefined | GroupTagEdgeKeySpecifier),
		fields?: GroupTagEdgeFieldPolicy,
	},
	GroupTagEsgMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagEsgMetadataKeySpecifier | (() => undefined | GroupTagEsgMetadataKeySpecifier),
		fields?: GroupTagEsgMetadataFieldPolicy,
	},
	GroupTagRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagRowKeySpecifier | (() => undefined | GroupTagRowKeySpecifier),
		fields?: GroupTagRowFieldPolicy,
	},
	GroupTagRowConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagRowConnectionKeySpecifier | (() => undefined | GroupTagRowConnectionKeySpecifier),
		fields?: GroupTagRowConnectionFieldPolicy,
	},
	GroupTagRowEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagRowEdgeKeySpecifier | (() => undefined | GroupTagRowEdgeKeySpecifier),
		fields?: GroupTagRowEdgeFieldPolicy,
	},
	Guideline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuidelineKeySpecifier | (() => undefined | GuidelineKeySpecifier),
		fields?: GuidelineFieldPolicy,
	},
	GuidelineConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuidelineConnectionKeySpecifier | (() => undefined | GuidelineConnectionKeySpecifier),
		fields?: GuidelineConnectionFieldPolicy,
	},
	GuidelineEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuidelineEdgeKeySpecifier | (() => undefined | GuidelineEdgeKeySpecifier),
		fields?: GuidelineEdgeFieldPolicy,
	},
	HeldQuote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeldQuoteKeySpecifier | (() => undefined | HeldQuoteKeySpecifier),
		fields?: HeldQuoteFieldPolicy,
	},
	ImportCountsObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImportCountsObjectKeySpecifier | (() => undefined | ImportCountsObjectKeySpecifier),
		fields?: ImportCountsObjectFieldPolicy,
	},
	IncidentAnonymityRestriction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentAnonymityRestrictionKeySpecifier | (() => undefined | IncidentAnonymityRestrictionKeySpecifier),
		fields?: IncidentAnonymityRestrictionFieldPolicy,
	},
	IncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeKeySpecifier | (() => undefined | IncidentTypeKeySpecifier),
		fields?: IncidentTypeFieldPolicy,
	},
	IncidentTypeAnonymity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeAnonymityKeySpecifier | (() => undefined | IncidentTypeAnonymityKeySpecifier),
		fields?: IncidentTypeAnonymityFieldPolicy,
	},
	IncidentTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeConnectionKeySpecifier | (() => undefined | IncidentTypeConnectionKeySpecifier),
		fields?: IncidentTypeConnectionFieldPolicy,
	},
	IncidentTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeEdgeKeySpecifier | (() => undefined | IncidentTypeEdgeKeySpecifier),
		fields?: IncidentTypeEdgeFieldPolicy,
	},
	IndividualInvolved?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndividualInvolvedKeySpecifier | (() => undefined | IndividualInvolvedKeySpecifier),
		fields?: IndividualInvolvedFieldPolicy,
	},
	IndividualInvolvedEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndividualInvolvedEmailKeySpecifier | (() => undefined | IndividualInvolvedEmailKeySpecifier),
		fields?: IndividualInvolvedEmailFieldPolicy,
	},
	IndustryUnitConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndustryUnitConnectionKeySpecifier | (() => undefined | IndustryUnitConnectionKeySpecifier),
		fields?: IndustryUnitConnectionFieldPolicy,
	},
	InsightsFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsightsFileKeySpecifier | (() => undefined | InsightsFileKeySpecifier),
		fields?: InsightsFileFieldPolicy,
	},
	IsoAssessmentDays?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IsoAssessmentDaysKeySpecifier | (() => undefined | IsoAssessmentDaysKeySpecifier),
		fields?: IsoAssessmentDaysFieldPolicy,
	},
	IsoCertificationPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IsoCertificationPriceKeySpecifier | (() => undefined | IsoCertificationPriceKeySpecifier),
		fields?: IsoCertificationPriceFieldPolicy,
	},
	IsoCertificationRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IsoCertificationRulesKeySpecifier | (() => undefined | IsoCertificationRulesKeySpecifier),
		fields?: IsoCertificationRulesFieldPolicy,
	},
	IsoFeeSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IsoFeeScheduleKeySpecifier | (() => undefined | IsoFeeScheduleKeySpecifier),
		fields?: IsoFeeScheduleFieldPolicy,
	},
	IsoReductionApplied?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IsoReductionAppliedKeySpecifier | (() => undefined | IsoReductionAppliedKeySpecifier),
		fields?: IsoReductionAppliedFieldPolicy,
	},
	KnowledgeLibraryAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryAssetsKeySpecifier | (() => undefined | KnowledgeLibraryAssetsKeySpecifier),
		fields?: KnowledgeLibraryAssetsFieldPolicy,
	},
	KnowledgeLibraryConnectionStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryConnectionStatisticsKeySpecifier | (() => undefined | KnowledgeLibraryConnectionStatisticsKeySpecifier),
		fields?: KnowledgeLibraryConnectionStatisticsFieldPolicy,
	},
	KnowledgeLibraryGeneratedAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryGeneratedAnswerKeySpecifier | (() => undefined | KnowledgeLibraryGeneratedAnswerKeySpecifier),
		fields?: KnowledgeLibraryGeneratedAnswerFieldPolicy,
	},
	KnowledgeLibraryOptionsQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryOptionsQuestionKeySpecifier | (() => undefined | KnowledgeLibraryOptionsQuestionKeySpecifier),
		fields?: KnowledgeLibraryOptionsQuestionFieldPolicy,
	},
	KnowledgeLibraryQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryQuestionKeySpecifier | (() => undefined | KnowledgeLibraryQuestionKeySpecifier),
		fields?: KnowledgeLibraryQuestionFieldPolicy,
	},
	KnowledgeLibraryQuestionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryQuestionConnectionKeySpecifier | (() => undefined | KnowledgeLibraryQuestionConnectionKeySpecifier),
		fields?: KnowledgeLibraryQuestionConnectionFieldPolicy,
	},
	KnowledgeLibraryQuestionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryQuestionEdgeKeySpecifier | (() => undefined | KnowledgeLibraryQuestionEdgeKeySpecifier),
		fields?: KnowledgeLibraryQuestionEdgeFieldPolicy,
	},
	KnowledgeLibraryScalarQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryScalarQuestionKeySpecifier | (() => undefined | KnowledgeLibraryScalarQuestionKeySpecifier),
		fields?: KnowledgeLibraryScalarQuestionFieldPolicy,
	},
	License?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LicenseKeySpecifier | (() => undefined | LicenseKeySpecifier),
		fields?: LicenseFieldPolicy,
	},
	LinkAnswersToMetricResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkAnswersToMetricResultKeySpecifier | (() => undefined | LinkAnswersToMetricResultKeySpecifier),
		fields?: LinkAnswersToMetricResultFieldPolicy,
	},
	LinkMetricsToAnswerResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkMetricsToAnswerResultKeySpecifier | (() => undefined | LinkMetricsToAnswerResultKeySpecifier),
		fields?: LinkMetricsToAnswerResultFieldPolicy,
	},
	MasterTermSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MasterTermSummaryKeySpecifier | (() => undefined | MasterTermSummaryKeySpecifier),
		fields?: MasterTermSummaryFieldPolicy,
	},
	Metadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetadataKeySpecifier | (() => undefined | MetadataKeySpecifier),
		fields?: MetadataFieldPolicy,
	},
	MethodType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MethodTypeKeySpecifier | (() => undefined | MethodTypeKeySpecifier),
		fields?: MethodTypeFieldPolicy,
	},
	Metric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricKeySpecifier | (() => undefined | MetricKeySpecifier),
		fields?: MetricFieldPolicy,
	},
	MetricConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricConnectionKeySpecifier | (() => undefined | MetricConnectionKeySpecifier),
		fields?: MetricConnectionFieldPolicy,
	},
	MetricData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataKeySpecifier | (() => undefined | MetricDataKeySpecifier),
		fields?: MetricDataFieldPolicy,
	},
	MetricDataColumnSelector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataColumnSelectorKeySpecifier | (() => undefined | MetricDataColumnSelectorKeySpecifier),
		fields?: MetricDataColumnSelectorFieldPolicy,
	},
	MetricDataSelector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataSelectorKeySpecifier | (() => undefined | MetricDataSelectorKeySpecifier),
		fields?: MetricDataSelectorFieldPolicy,
	},
	MetricDataYear?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataYearKeySpecifier | (() => undefined | MetricDataYearKeySpecifier),
		fields?: MetricDataYearFieldPolicy,
	},
	MetricEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricEdgeKeySpecifier | (() => undefined | MetricEdgeKeySpecifier),
		fields?: MetricEdgeFieldPolicy,
	},
	MetricLinkedQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricLinkedQuestionKeySpecifier | (() => undefined | MetricLinkedQuestionKeySpecifier),
		fields?: MetricLinkedQuestionFieldPolicy,
	},
	Mfa?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MfaKeySpecifier | (() => undefined | MfaKeySpecifier),
		fields?: MfaFieldPolicy,
	},
	MissedProvisioningEmit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MissedProvisioningEmitKeySpecifier | (() => undefined | MissedProvisioningEmitKeySpecifier),
		fields?: MissedProvisioningEmitFieldPolicy,
	},
	ModuleSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModuleSettingKeySpecifier | (() => undefined | ModuleSettingKeySpecifier),
		fields?: ModuleSettingFieldPolicy,
	},
	ModuleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModuleSettingsKeySpecifier | (() => undefined | ModuleSettingsKeySpecifier),
		fields?: ModuleSettingsFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	MySpeekiCompany?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MySpeekiCompanyKeySpecifier | (() => undefined | MySpeekiCompanyKeySpecifier),
		fields?: MySpeekiCompanyFieldPolicy,
	},
	MySpeekiProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MySpeekiProfileKeySpecifier | (() => undefined | MySpeekiProfileKeySpecifier),
		fields?: MySpeekiProfileFieldPolicy,
	},
	MySpeekiSignInResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MySpeekiSignInResultKeySpecifier | (() => undefined | MySpeekiSignInResultKeySpecifier),
		fields?: MySpeekiSignInResultFieldPolicy,
	},
	NicoleGptSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionKeySpecifier | (() => undefined | NicoleGptSessionKeySpecifier),
		fields?: NicoleGptSessionFieldPolicy,
	},
	NicoleGptSessionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionConnectionKeySpecifier | (() => undefined | NicoleGptSessionConnectionKeySpecifier),
		fields?: NicoleGptSessionConnectionFieldPolicy,
	},
	NicoleGptSessionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEdgeKeySpecifier | (() => undefined | NicoleGptSessionEdgeKeySpecifier),
		fields?: NicoleGptSessionEdgeFieldPolicy,
	},
	NicoleGptSessionEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEntryKeySpecifier | (() => undefined | NicoleGptSessionEntryKeySpecifier),
		fields?: NicoleGptSessionEntryFieldPolicy,
	},
	NicoleGptSessionEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEntryConnectionKeySpecifier | (() => undefined | NicoleGptSessionEntryConnectionKeySpecifier),
		fields?: NicoleGptSessionEntryConnectionFieldPolicy,
	},
	NicoleGptSessionEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEntryEdgeKeySpecifier | (() => undefined | NicoleGptSessionEntryEdgeKeySpecifier),
		fields?: NicoleGptSessionEntryEdgeFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationContentsKeySpecifier | (() => undefined | NotificationContentsKeySpecifier),
		fields?: NotificationContentsFieldPolicy,
	},
	NotificationData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationDataKeySpecifier | (() => undefined | NotificationDataKeySpecifier),
		fields?: NotificationDataFieldPolicy,
	},
	NotificationEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationEdgeKeySpecifier | (() => undefined | NotificationEdgeKeySpecifier),
		fields?: NotificationEdgeFieldPolicy,
	},
	NotificationPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationPageKeySpecifier | (() => undefined | NotificationPageKeySpecifier),
		fields?: NotificationPageFieldPolicy,
	},
	NotificationPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationPaginatedKeySpecifier | (() => undefined | NotificationPaginatedKeySpecifier),
		fields?: NotificationPaginatedFieldPolicy,
	},
	NotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationPayloadKeySpecifier | (() => undefined | NotificationPayloadKeySpecifier),
		fields?: NotificationPayloadFieldPolicy,
	},
	OAuthClient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OAuthClientKeySpecifier | (() => undefined | OAuthClientKeySpecifier),
		fields?: OAuthClientFieldPolicy,
	},
	OAuthClientConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OAuthClientConnectionKeySpecifier | (() => undefined | OAuthClientConnectionKeySpecifier),
		fields?: OAuthClientConnectionFieldPolicy,
	},
	OAuthClientEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OAuthClientEdgeKeySpecifier | (() => undefined | OAuthClientEdgeKeySpecifier),
		fields?: OAuthClientEdgeFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	OrderBillingStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderBillingStatusKeySpecifier | (() => undefined | OrderBillingStatusKeySpecifier),
		fields?: OrderBillingStatusFieldPolicy,
	},
	OrderCommitment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCommitmentKeySpecifier | (() => undefined | OrderCommitmentKeySpecifier),
		fields?: OrderCommitmentFieldPolicy,
	},
	OrderEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderEventKeySpecifier | (() => undefined | OrderEventKeySpecifier),
		fields?: OrderEventFieldPolicy,
	},
	OrderLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineKeySpecifier | (() => undefined | OrderLineKeySpecifier),
		fields?: OrderLineFieldPolicy,
	},
	OriginalReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OriginalReportKeySpecifier | (() => undefined | OriginalReportKeySpecifier),
		fields?: OriginalReportFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PageInfoV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoV2KeySpecifier | (() => undefined | PageInfoV2KeySpecifier),
		fields?: PageInfoV2FieldPolicy,
	},
	PartnerIntegrityDomainRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerIntegrityDomainRuleKeySpecifier | (() => undefined | PartnerIntegrityDomainRuleKeySpecifier),
		fields?: PartnerIntegrityDomainRuleFieldPolicy,
	},
	PartnerIntegrityReportLevelRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerIntegrityReportLevelRuleKeySpecifier | (() => undefined | PartnerIntegrityReportLevelRuleKeySpecifier),
		fields?: PartnerIntegrityReportLevelRuleFieldPolicy,
	},
	PartnerIntegrityRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerIntegrityRulesKeySpecifier | (() => undefined | PartnerIntegrityRulesKeySpecifier),
		fields?: PartnerIntegrityRulesFieldPolicy,
	},
	PaymentScheduleRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentScheduleRowKeySpecifier | (() => undefined | PaymentScheduleRowKeySpecifier),
		fields?: PaymentScheduleRowFieldPolicy,
	},
	PendingDowngrade?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingDowngradeKeySpecifier | (() => undefined | PendingDowngradeKeySpecifier),
		fields?: PendingDowngradeFieldPolicy,
	},
	PlanUpgradeCandidate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlanUpgradeCandidateKeySpecifier | (() => undefined | PlanUpgradeCandidateKeySpecifier),
		fields?: PlanUpgradeCandidateFieldPolicy,
	},
	PlanUpgradeContext?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlanUpgradeContextKeySpecifier | (() => undefined | PlanUpgradeContextKeySpecifier),
		fields?: PlanUpgradeContextFieldPolicy,
	},
	PlanUpgradeQuoteLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlanUpgradeQuoteLineKeySpecifier | (() => undefined | PlanUpgradeQuoteLineKeySpecifier),
		fields?: PlanUpgradeQuoteLineFieldPolicy,
	},
	PlanUpgradeStandardTier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlanUpgradeStandardTierKeySpecifier | (() => undefined | PlanUpgradeStandardTierKeySpecifier),
		fields?: PlanUpgradeStandardTierFieldPolicy,
	},
	PortalAccessRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PortalAccessRequestKeySpecifier | (() => undefined | PortalAccessRequestKeySpecifier),
		fields?: PortalAccessRequestFieldPolicy,
	},
	PortalDomainOffer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PortalDomainOfferKeySpecifier | (() => undefined | PortalDomainOfferKeySpecifier),
		fields?: PortalDomainOfferFieldPolicy,
	},
	PortalFramework?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PortalFrameworkKeySpecifier | (() => undefined | PortalFrameworkKeySpecifier),
		fields?: PortalFrameworkFieldPolicy,
	},
	PortalLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PortalLinkKeySpecifier | (() => undefined | PortalLinkKeySpecifier),
		fields?: PortalLinkFieldPolicy,
	},
	PresignedCaseFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PresignedCaseFileKeySpecifier | (() => undefined | PresignedCaseFileKeySpecifier),
		fields?: PresignedCaseFileFieldPolicy,
	},
	PrimaryContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrimaryContactKeySpecifier | (() => undefined | PrimaryContactKeySpecifier),
		fields?: PrimaryContactFieldPolicy,
	},
	ProductProvisioningHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductProvisioningHistoryKeySpecifier | (() => undefined | ProductProvisioningHistoryKeySpecifier),
		fields?: ProductProvisioningHistoryFieldPolicy,
	},
	ProductProvisioningHistoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductProvisioningHistoryConnectionKeySpecifier | (() => undefined | ProductProvisioningHistoryConnectionKeySpecifier),
		fields?: ProductProvisioningHistoryConnectionFieldPolicy,
	},
	ProductProvisioningHistoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductProvisioningHistoryEdgeKeySpecifier | (() => undefined | ProductProvisioningHistoryEdgeKeySpecifier),
		fields?: ProductProvisioningHistoryEdgeFieldPolicy,
	},
	Program?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProgramKeySpecifier | (() => undefined | ProgramKeySpecifier),
		fields?: ProgramFieldPolicy,
	},
	ProgramCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProgramCategoryKeySpecifier | (() => undefined | ProgramCategoryKeySpecifier),
		fields?: ProgramCategoryFieldPolicy,
	},
	ProgramSettingCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProgramSettingCategoryKeySpecifier | (() => undefined | ProgramSettingCategoryKeySpecifier),
		fields?: ProgramSettingCategoryFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	QuestionActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionActivityKeySpecifier | (() => undefined | QuestionActivityKeySpecifier),
		fields?: QuestionActivityFieldPolicy,
	},
	QuestionActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionActivityConnectionKeySpecifier | (() => undefined | QuestionActivityConnectionKeySpecifier),
		fields?: QuestionActivityConnectionFieldPolicy,
	},
	QuestionActivityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionActivityEdgeKeySpecifier | (() => undefined | QuestionActivityEdgeKeySpecifier),
		fields?: QuestionActivityEdgeFieldPolicy,
	},
	QuestionSearchLinkedCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionSearchLinkedCountKeySpecifier | (() => undefined | QuestionSearchLinkedCountKeySpecifier),
		fields?: QuestionSearchLinkedCountFieldPolicy,
	},
	QuestionSearchRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionSearchRiskAreaKeySpecifier | (() => undefined | QuestionSearchRiskAreaKeySpecifier),
		fields?: QuestionSearchRiskAreaFieldPolicy,
	},
	QuestionSearchStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionSearchStepKeySpecifier | (() => undefined | QuestionSearchStepKeySpecifier),
		fields?: QuestionSearchStepFieldPolicy,
	},
	QuestionnaireEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireEntryKeySpecifier | (() => undefined | QuestionnaireEntryKeySpecifier),
		fields?: QuestionnaireEntryFieldPolicy,
	},
	QuestionnaireEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireEntryConnectionKeySpecifier | (() => undefined | QuestionnaireEntryConnectionKeySpecifier),
		fields?: QuestionnaireEntryConnectionFieldPolicy,
	},
	QuestionnaireEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireEntryEdgeKeySpecifier | (() => undefined | QuestionnaireEntryEdgeKeySpecifier),
		fields?: QuestionnaireEntryEdgeFieldPolicy,
	},
	QuestionnaireFilter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireFilterKeySpecifier | (() => undefined | QuestionnaireFilterKeySpecifier),
		fields?: QuestionnaireFilterFieldPolicy,
	},
	QuestionnaireNavigation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationKeySpecifier | (() => undefined | QuestionnaireNavigationKeySpecifier),
		fields?: QuestionnaireNavigationFieldPolicy,
	},
	QuestionnaireNavigationCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationCategoryKeySpecifier | (() => undefined | QuestionnaireNavigationCategoryKeySpecifier),
		fields?: QuestionnaireNavigationCategoryFieldPolicy,
	},
	QuestionnaireNavigationRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationRiskAreaKeySpecifier | (() => undefined | QuestionnaireNavigationRiskAreaKeySpecifier),
		fields?: QuestionnaireNavigationRiskAreaFieldPolicy,
	},
	QuestionnaireNavigationStandard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationStandardKeySpecifier | (() => undefined | QuestionnaireNavigationStandardKeySpecifier),
		fields?: QuestionnaireNavigationStandardFieldPolicy,
	},
	QuestionnaireNavigationStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationStatisticsKeySpecifier | (() => undefined | QuestionnaireNavigationStatisticsKeySpecifier),
		fields?: QuestionnaireNavigationStatisticsFieldPolicy,
	},
	QuestionnaireNavigationStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationStepKeySpecifier | (() => undefined | QuestionnaireNavigationStepKeySpecifier),
		fields?: QuestionnaireNavigationStepFieldPolicy,
	},
	RatingsReadyMultiyearRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingsReadyMultiyearRuleKeySpecifier | (() => undefined | RatingsReadyMultiyearRuleKeySpecifier),
		fields?: RatingsReadyMultiyearRuleFieldPolicy,
	},
	RatingsReadyPlatformRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingsReadyPlatformRuleKeySpecifier | (() => undefined | RatingsReadyPlatformRuleKeySpecifier),
		fields?: RatingsReadyPlatformRuleFieldPolicy,
	},
	RatingsReadyRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingsReadyRulesKeySpecifier | (() => undefined | RatingsReadyRulesKeySpecifier),
		fields?: RatingsReadyRulesFieldPolicy,
	},
	RatingsReadySizeBandRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RatingsReadySizeBandRuleKeySpecifier | (() => undefined | RatingsReadySizeBandRuleKeySpecifier),
		fields?: RatingsReadySizeBandRuleFieldPolicy,
	},
	ReadNotification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReadNotificationKeySpecifier | (() => undefined | ReadNotificationKeySpecifier),
		fields?: ReadNotificationFieldPolicy,
	},
	Region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionKeySpecifier | (() => undefined | RegionKeySpecifier),
		fields?: RegionFieldPolicy,
	},
	RegionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionConnectionKeySpecifier | (() => undefined | RegionConnectionKeySpecifier),
		fields?: RegionConnectionFieldPolicy,
	},
	RegionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionEdgeKeySpecifier | (() => undefined | RegionEdgeKeySpecifier),
		fields?: RegionEdgeFieldPolicy,
	},
	RegularRolePermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegularRolePermissionKeySpecifier | (() => undefined | RegularRolePermissionKeySpecifier),
		fields?: RegularRolePermissionFieldPolicy,
	},
	ReleaseNote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReleaseNoteKeySpecifier | (() => undefined | ReleaseNoteKeySpecifier),
		fields?: ReleaseNoteFieldPolicy,
	},
	ReportAudience?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportAudienceKeySpecifier | (() => undefined | ReportAudienceKeySpecifier),
		fields?: ReportAudienceFieldPolicy,
	},
	ReportCaseFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportCaseFileKeySpecifier | (() => undefined | ReportCaseFileKeySpecifier),
		fields?: ReportCaseFileFieldPolicy,
	},
	ReportPromptTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportPromptTemplateKeySpecifier | (() => undefined | ReportPromptTemplateKeySpecifier),
		fields?: ReportPromptTemplateFieldPolicy,
	},
	ReportPromptTemplateConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportPromptTemplateConnectionKeySpecifier | (() => undefined | ReportPromptTemplateConnectionKeySpecifier),
		fields?: ReportPromptTemplateConnectionFieldPolicy,
	},
	ReportPromptTemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportPromptTemplateEdgeKeySpecifier | (() => undefined | ReportPromptTemplateEdgeKeySpecifier),
		fields?: ReportPromptTemplateEdgeFieldPolicy,
	},
	ReportResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportResponseKeySpecifier | (() => undefined | ReportResponseKeySpecifier),
		fields?: ReportResponseFieldPolicy,
	},
	ReportSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportSettingsKeySpecifier | (() => undefined | ReportSettingsKeySpecifier),
		fields?: ReportSettingsFieldPolicy,
	},
	ReportingGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingGroupKeySpecifier | (() => undefined | ReportingGroupKeySpecifier),
		fields?: ReportingGroupFieldPolicy,
	},
	ReportingGroupConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingGroupConnectionKeySpecifier | (() => undefined | ReportingGroupConnectionKeySpecifier),
		fields?: ReportingGroupConnectionFieldPolicy,
	},
	ReportingGroupEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingGroupEdgeKeySpecifier | (() => undefined | ReportingGroupEdgeKeySpecifier),
		fields?: ReportingGroupEdgeFieldPolicy,
	},
	ReportingSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingSourceKeySpecifier | (() => undefined | ReportingSourceKeySpecifier),
		fields?: ReportingSourceFieldPolicy,
	},
	ReportingSourceConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingSourceConnectionKeySpecifier | (() => undefined | ReportingSourceConnectionKeySpecifier),
		fields?: ReportingSourceConnectionFieldPolicy,
	},
	ReportingSourceEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingSourceEdgeKeySpecifier | (() => undefined | ReportingSourceEdgeKeySpecifier),
		fields?: ReportingSourceEdgeFieldPolicy,
	},
	RequestCheckoutEmailVerification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RequestCheckoutEmailVerificationKeySpecifier | (() => undefined | RequestCheckoutEmailVerificationKeySpecifier),
		fields?: RequestCheckoutEmailVerificationFieldPolicy,
	},
	RequestReporterEmailVerification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RequestReporterEmailVerificationKeySpecifier | (() => undefined | RequestReporterEmailVerificationKeySpecifier),
		fields?: RequestReporterEmailVerificationFieldPolicy,
	},
	RespondQuestionnaire?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireKeySpecifier | (() => undefined | RespondQuestionnaireKeySpecifier),
		fields?: RespondQuestionnaireFieldPolicy,
	},
	RespondQuestionnaireConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireConnectionKeySpecifier | (() => undefined | RespondQuestionnaireConnectionKeySpecifier),
		fields?: RespondQuestionnaireConnectionFieldPolicy,
	},
	RespondQuestionnaireEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEdgeKeySpecifier | (() => undefined | RespondQuestionnaireEdgeKeySpecifier),
		fields?: RespondQuestionnaireEdgeFieldPolicy,
	},
	RespondQuestionnaireEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEntryKeySpecifier | (() => undefined | RespondQuestionnaireEntryKeySpecifier),
		fields?: RespondQuestionnaireEntryFieldPolicy,
	},
	RespondQuestionnaireEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEntryConnectionKeySpecifier | (() => undefined | RespondQuestionnaireEntryConnectionKeySpecifier),
		fields?: RespondQuestionnaireEntryConnectionFieldPolicy,
	},
	RespondQuestionnaireEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEntryEdgeKeySpecifier | (() => undefined | RespondQuestionnaireEntryEdgeKeySpecifier),
		fields?: RespondQuestionnaireEntryEdgeFieldPolicy,
	},
	RespondQuestionnaireV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireV2KeySpecifier | (() => undefined | RespondQuestionnaireV2KeySpecifier),
		fields?: RespondQuestionnaireV2FieldPolicy,
	},
	RespondQuestionnaireV2Connection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireV2ConnectionKeySpecifier | (() => undefined | RespondQuestionnaireV2ConnectionKeySpecifier),
		fields?: RespondQuestionnaireV2ConnectionFieldPolicy,
	},
	RespondQuestionnaireV2Edge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireV2EdgeKeySpecifier | (() => undefined | RespondQuestionnaireV2EdgeKeySpecifier),
		fields?: RespondQuestionnaireV2EdgeFieldPolicy,
	},
	RiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RiskAreaKeySpecifier | (() => undefined | RiskAreaKeySpecifier),
		fields?: RiskAreaFieldPolicy,
	},
	RiskAreasWithAnyQuestionsElement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RiskAreasWithAnyQuestionsElementKeySpecifier | (() => undefined | RiskAreasWithAnyQuestionsElementKeySpecifier),
		fields?: RiskAreasWithAnyQuestionsElementFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	RoleConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleConnectionKeySpecifier | (() => undefined | RoleConnectionKeySpecifier),
		fields?: RoleConnectionFieldPolicy,
	},
	RoleEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleEdgeKeySpecifier | (() => undefined | RoleEdgeKeySpecifier),
		fields?: RoleEdgeFieldPolicy,
	},
	RoleRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleRiskAreaKeySpecifier | (() => undefined | RoleRiskAreaKeySpecifier),
		fields?: RoleRiskAreaFieldPolicy,
	},
	ScopeFilter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScopeFilterKeySpecifier | (() => undefined | ScopeFilterKeySpecifier),
		fields?: ScopeFilterFieldPolicy,
	},
	SeatRequestType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeatRequestTypeKeySpecifier | (() => undefined | SeatRequestTypeKeySpecifier),
		fields?: SeatRequestTypeFieldPolicy,
	},
	Sector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectorKeySpecifier | (() => undefined | SectorKeySpecifier),
		fields?: SectorFieldPolicy,
	},
	SectorConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectorConnectionKeySpecifier | (() => undefined | SectorConnectionKeySpecifier),
		fields?: SectorConnectionFieldPolicy,
	},
	SectorEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectorEdgeKeySpecifier | (() => undefined | SectorEdgeKeySpecifier),
		fields?: SectorEdgeFieldPolicy,
	},
	Select?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectKeySpecifier | (() => undefined | SelectKeySpecifier),
		fields?: SelectFieldPolicy,
	},
	ServicePricingRequestResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServicePricingRequestResultKeySpecifier | (() => undefined | ServicePricingRequestResultKeySpecifier),
		fields?: ServicePricingRequestResultFieldPolicy,
	},
	Session?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionKeySpecifier | (() => undefined | SessionKeySpecifier),
		fields?: SessionFieldPolicy,
	},
	SessionHandoffCode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionHandoffCodeKeySpecifier | (() => undefined | SessionHandoffCodeKeySpecifier),
		fields?: SessionHandoffCodeFieldPolicy,
	},
	SessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionPayloadKeySpecifier | (() => undefined | SessionPayloadKeySpecifier),
		fields?: SessionPayloadFieldPolicy,
	},
	SessionWithOaExchange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionWithOaExchangeKeySpecifier | (() => undefined | SessionWithOaExchangeKeySpecifier),
		fields?: SessionWithOaExchangeFieldPolicy,
	},
	SetPriceQuote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetPriceQuoteKeySpecifier | (() => undefined | SetPriceQuoteKeySpecifier),
		fields?: SetPriceQuoteFieldPolicy,
	},
	SetPriceRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetPriceRulesKeySpecifier | (() => undefined | SetPriceRulesKeySpecifier),
		fields?: SetPriceRulesFieldPolicy,
	},
	ShopApprovalRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopApprovalRequestKeySpecifier | (() => undefined | ShopApprovalRequestKeySpecifier),
		fields?: ShopApprovalRequestFieldPolicy,
	},
	ShopCatalogue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopCatalogueKeySpecifier | (() => undefined | ShopCatalogueKeySpecifier),
		fields?: ShopCatalogueFieldPolicy,
	},
	SmartFillDraftAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillDraftAnswerKeySpecifier | (() => undefined | SmartFillDraftAnswerKeySpecifier),
		fields?: SmartFillDraftAnswerFieldPolicy,
	},
	SmartFillJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillJobKeySpecifier | (() => undefined | SmartFillJobKeySpecifier),
		fields?: SmartFillJobFieldPolicy,
	},
	SmartFillSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillSourceKeySpecifier | (() => undefined | SmartFillSourceKeySpecifier),
		fields?: SmartFillSourceFieldPolicy,
	},
	SmartFillUnreadDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillUnreadDocumentKeySpecifier | (() => undefined | SmartFillUnreadDocumentKeySpecifier),
		fields?: SmartFillUnreadDocumentFieldPolicy,
	},
	SmartFillUnreadableFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillUnreadableFileKeySpecifier | (() => undefined | SmartFillUnreadableFileKeySpecifier),
		fields?: SmartFillUnreadableFileFieldPolicy,
	},
	SpeekiCertStandardRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpeekiCertStandardRuleKeySpecifier | (() => undefined | SpeekiCertStandardRuleKeySpecifier),
		fields?: SpeekiCertStandardRuleFieldPolicy,
	},
	SpeekiPick?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpeekiPickKeySpecifier | (() => undefined | SpeekiPickKeySpecifier),
		fields?: SpeekiPickFieldPolicy,
	},
	SpkAssessmentDays?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpkAssessmentDaysKeySpecifier | (() => undefined | SpkAssessmentDaysKeySpecifier),
		fields?: SpkAssessmentDaysFieldPolicy,
	},
	SpkCertificationPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpkCertificationPriceKeySpecifier | (() => undefined | SpkCertificationPriceKeySpecifier),
		fields?: SpkCertificationPriceFieldPolicy,
	},
	SpkCertificationRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpkCertificationRulesKeySpecifier | (() => undefined | SpkCertificationRulesKeySpecifier),
		fields?: SpkCertificationRulesFieldPolicy,
	},
	SpkFeeSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpkFeeScheduleKeySpecifier | (() => undefined | SpkFeeScheduleKeySpecifier),
		fields?: SpkFeeScheduleFieldPolicy,
	},
	SpkIsoCredit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpkIsoCreditKeySpecifier | (() => undefined | SpkIsoCreditKeySpecifier),
		fields?: SpkIsoCreditFieldPolicy,
	},
	SpkPriceAdjustment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpkPriceAdjustmentKeySpecifier | (() => undefined | SpkPriceAdjustmentKeySpecifier),
		fields?: SpkPriceAdjustmentFieldPolicy,
	},
	SsoAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoAccountKeySpecifier | (() => undefined | SsoAccountKeySpecifier),
		fields?: SsoAccountFieldPolicy,
	},
	SsoAuthPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoAuthPayloadKeySpecifier | (() => undefined | SsoAuthPayloadKeySpecifier),
		fields?: SsoAuthPayloadFieldPolicy,
	},
	SsoAzureTenantInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoAzureTenantInformationKeySpecifier | (() => undefined | SsoAzureTenantInformationKeySpecifier),
		fields?: SsoAzureTenantInformationFieldPolicy,
	},
	SsoProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoProviderKeySpecifier | (() => undefined | SsoProviderKeySpecifier),
		fields?: SsoProviderFieldPolicy,
	},
	SsoSamlTenantInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoSamlTenantInformationKeySpecifier | (() => undefined | SsoSamlTenantInformationKeySpecifier),
		fields?: SsoSamlTenantInformationFieldPolicy,
	},
	SsoTenantInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoTenantInformationKeySpecifier | (() => undefined | SsoTenantInformationKeySpecifier),
		fields?: SsoTenantInformationFieldPolicy,
	},
	StaffOrderScheduleDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffOrderScheduleDetailKeySpecifier | (() => undefined | StaffOrderScheduleDetailKeySpecifier),
		fields?: StaffOrderScheduleDetailFieldPolicy,
	},
	StaffScheduleRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffScheduleRowKeySpecifier | (() => undefined | StaffScheduleRowKeySpecifier),
		fields?: StaffScheduleRowFieldPolicy,
	},
	StakeholderEngagementCommonData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StakeholderEngagementCommonDataKeySpecifier | (() => undefined | StakeholderEngagementCommonDataKeySpecifier),
		fields?: StakeholderEngagementCommonDataFieldPolicy,
	},
	StakeholderEngagementConnectionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StakeholderEngagementConnectionConnectionKeySpecifier | (() => undefined | StakeholderEngagementConnectionConnectionKeySpecifier),
		fields?: StakeholderEngagementConnectionConnectionFieldPolicy,
	},
	StakeholderEngagementConnectionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StakeholderEngagementConnectionEdgeKeySpecifier | (() => undefined | StakeholderEngagementConnectionEdgeKeySpecifier),
		fields?: StakeholderEngagementConnectionEdgeFieldPolicy,
	},
	StandardAssignedRiskAreaEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardAssignedRiskAreaEdgeKeySpecifier | (() => undefined | StandardAssignedRiskAreaEdgeKeySpecifier),
		fields?: StandardAssignedRiskAreaEdgeFieldPolicy,
	},
	StandardAssignedRiskAreasConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardAssignedRiskAreasConnectionKeySpecifier | (() => undefined | StandardAssignedRiskAreasConnectionKeySpecifier),
		fields?: StandardAssignedRiskAreasConnectionFieldPolicy,
	},
	SubscriptionPlan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionPlanKeySpecifier | (() => undefined | SubscriptionPlanKeySpecifier),
		fields?: SubscriptionPlanFieldPolicy,
	},
	SubscriptionTerm?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionTermKeySpecifier | (() => undefined | SubscriptionTermKeySpecifier),
		fields?: SubscriptionTermFieldPolicy,
	},
	SubsidiarySite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySiteKeySpecifier | (() => undefined | SubsidiarySiteKeySpecifier),
		fields?: SubsidiarySiteFieldPolicy,
	},
	SubsidiarySiteEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySiteEdgeKeySpecifier | (() => undefined | SubsidiarySiteEdgeKeySpecifier),
		fields?: SubsidiarySiteEdgeFieldPolicy,
	},
	SubsidiarySiteReportingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySiteReportingSettingsKeySpecifier | (() => undefined | SubsidiarySiteReportingSettingsKeySpecifier),
		fields?: SubsidiarySiteReportingSettingsFieldPolicy,
	},
	SubsidiarySitesConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySitesConnectionKeySpecifier | (() => undefined | SubsidiarySitesConnectionKeySpecifier),
		fields?: SubsidiarySitesConnectionFieldPolicy,
	},
	SupportedMobileAppVersions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupportedMobileAppVersionsKeySpecifier | (() => undefined | SupportedMobileAppVersionsKeySpecifier),
		fields?: SupportedMobileAppVersionsFieldPolicy,
	},
	Survey?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyKeySpecifier | (() => undefined | SurveyKeySpecifier),
		fields?: SurveyFieldPolicy,
	},
	SurveyConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyConnectionKeySpecifier | (() => undefined | SurveyConnectionKeySpecifier),
		fields?: SurveyConnectionFieldPolicy,
	},
	SurveyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyEdgeKeySpecifier | (() => undefined | SurveyEdgeKeySpecifier),
		fields?: SurveyEdgeFieldPolicy,
	},
	SurveyEmailTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyEmailTargetKeySpecifier | (() => undefined | SurveyEmailTargetKeySpecifier),
		fields?: SurveyEmailTargetFieldPolicy,
	},
	SurveyPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyPageKeySpecifier | (() => undefined | SurveyPageKeySpecifier),
		fields?: SurveyPageFieldPolicy,
	},
	SurveyPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyPaginatedKeySpecifier | (() => undefined | SurveyPaginatedKeySpecifier),
		fields?: SurveyPaginatedFieldPolicy,
	},
	SurveyReportUploadResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyReportUploadResponseKeySpecifier | (() => undefined | SurveyReportUploadResponseKeySpecifier),
		fields?: SurveyReportUploadResponseFieldPolicy,
	},
	SurveyResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponseKeySpecifier | (() => undefined | SurveyResponseKeySpecifier),
		fields?: SurveyResponseFieldPolicy,
	},
	SurveyResponseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponseEdgeKeySpecifier | (() => undefined | SurveyResponseEdgeKeySpecifier),
		fields?: SurveyResponseEdgeFieldPolicy,
	},
	SurveyResponsePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponsePageKeySpecifier | (() => undefined | SurveyResponsePageKeySpecifier),
		fields?: SurveyResponsePageFieldPolicy,
	},
	SurveyResponsePaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponsePaginatedKeySpecifier | (() => undefined | SurveyResponsePaginatedKeySpecifier),
		fields?: SurveyResponsePaginatedFieldPolicy,
	},
	SurveyStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyStatisticsKeySpecifier | (() => undefined | SurveyStatisticsKeySpecifier),
		fields?: SurveyStatisticsFieldPolicy,
	},
	SurveySummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveySummaryKeySpecifier | (() => undefined | SurveySummaryKeySpecifier),
		fields?: SurveySummaryFieldPolicy,
	},
	SurveyTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplateKeySpecifier | (() => undefined | SurveyTemplateKeySpecifier),
		fields?: SurveyTemplateFieldPolicy,
	},
	SurveyTemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplateEdgeKeySpecifier | (() => undefined | SurveyTemplateEdgeKeySpecifier),
		fields?: SurveyTemplateEdgeFieldPolicy,
	},
	SurveyTemplatePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplatePageKeySpecifier | (() => undefined | SurveyTemplatePageKeySpecifier),
		fields?: SurveyTemplatePageFieldPolicy,
	},
	SurveyTemplatePaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplatePaginatedKeySpecifier | (() => undefined | SurveyTemplatePaginatedKeySpecifier),
		fields?: SurveyTemplatePaginatedFieldPolicy,
	},
	SurveyTemplateType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplateTypeKeySpecifier | (() => undefined | SurveyTemplateTypeKeySpecifier),
		fields?: SurveyTemplateTypeFieldPolicy,
	},
	Symbol?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SymbolKeySpecifier | (() => undefined | SymbolKeySpecifier),
		fields?: SymbolFieldPolicy,
	},
	SymbolConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SymbolConnectionKeySpecifier | (() => undefined | SymbolConnectionKeySpecifier),
		fields?: SymbolConnectionFieldPolicy,
	},
	SymbolEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SymbolEdgeKeySpecifier | (() => undefined | SymbolEdgeKeySpecifier),
		fields?: SymbolEdgeFieldPolicy,
	},
	Tag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagKeySpecifier | (() => undefined | TagKeySpecifier),
		fields?: TagFieldPolicy,
	},
	TagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagConnectionKeySpecifier | (() => undefined | TagConnectionKeySpecifier),
		fields?: TagConnectionFieldPolicy,
	},
	TagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagEdgeKeySpecifier | (() => undefined | TagEdgeKeySpecifier),
		fields?: TagEdgeFieldPolicy,
	},
	TagsSelectConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagsSelectConnectionKeySpecifier | (() => undefined | TagsSelectConnectionKeySpecifier),
		fields?: TagsSelectConnectionFieldPolicy,
	},
	Target?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetKeySpecifier | (() => undefined | TargetKeySpecifier),
		fields?: TargetFieldPolicy,
	},
	TargetConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetConnectionKeySpecifier | (() => undefined | TargetConnectionKeySpecifier),
		fields?: TargetConnectionFieldPolicy,
	},
	TargetData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetDataKeySpecifier | (() => undefined | TargetDataKeySpecifier),
		fields?: TargetDataFieldPolicy,
	},
	TargetEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetEdgeKeySpecifier | (() => undefined | TargetEdgeKeySpecifier),
		fields?: TargetEdgeFieldPolicy,
	},
	TargetGoals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetGoalsKeySpecifier | (() => undefined | TargetGoalsKeySpecifier),
		fields?: TargetGoalsFieldPolicy,
	},
	TargetRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetRiskAreaKeySpecifier | (() => undefined | TargetRiskAreaKeySpecifier),
		fields?: TargetRiskAreaFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskCommentKeySpecifier | (() => undefined | TaskCommentKeySpecifier),
		fields?: TaskCommentFieldPolicy,
	},
	TaskConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskConnectionKeySpecifier | (() => undefined | TaskConnectionKeySpecifier),
		fields?: TaskConnectionFieldPolicy,
	},
	TaskEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskEdgeKeySpecifier | (() => undefined | TaskEdgeKeySpecifier),
		fields?: TaskEdgeFieldPolicy,
	},
	TaskMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskMetadataKeySpecifier | (() => undefined | TaskMetadataKeySpecifier),
		fields?: TaskMetadataFieldPolicy,
	},
	TaskNameHint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskNameHintKeySpecifier | (() => undefined | TaskNameHintKeySpecifier),
		fields?: TaskNameHintFieldPolicy,
	},
	TaskNameHintConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskNameHintConnectionKeySpecifier | (() => undefined | TaskNameHintConnectionKeySpecifier),
		fields?: TaskNameHintConnectionFieldPolicy,
	},
	TaskNameHintEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskNameHintEdgeKeySpecifier | (() => undefined | TaskNameHintEdgeKeySpecifier),
		fields?: TaskNameHintEdgeFieldPolicy,
	},
	TaskStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskStatisticsKeySpecifier | (() => undefined | TaskStatisticsKeySpecifier),
		fields?: TaskStatisticsFieldPolicy,
	},
	TasksUserTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasksUserTypeEdgeKeySpecifier | (() => undefined | TasksUserTypeEdgeKeySpecifier),
		fields?: TasksUserTypeEdgeFieldPolicy,
	},
	Taxonomy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyKeySpecifier | (() => undefined | TaxonomyKeySpecifier),
		fields?: TaxonomyFieldPolicy,
	},
	TaxonomyComplexUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyComplexUnitKeySpecifier | (() => undefined | TaxonomyComplexUnitKeySpecifier),
		fields?: TaxonomyComplexUnitFieldPolicy,
	},
	TaxonomyConcept?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptKeySpecifier | (() => undefined | TaxonomyConceptKeySpecifier),
		fields?: TaxonomyConceptFieldPolicy,
	},
	TaxonomyConceptConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptConnectionKeySpecifier | (() => undefined | TaxonomyConceptConnectionKeySpecifier),
		fields?: TaxonomyConceptConnectionFieldPolicy,
	},
	TaxonomyConceptEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptEdgeKeySpecifier | (() => undefined | TaxonomyConceptEdgeKeySpecifier),
		fields?: TaxonomyConceptEdgeFieldPolicy,
	},
	TaxonomyConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConnectionKeySpecifier | (() => undefined | TaxonomyConnectionKeySpecifier),
		fields?: TaxonomyConnectionFieldPolicy,
	},
	TaxonomyDimensionSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyDimensionSetKeySpecifier | (() => undefined | TaxonomyDimensionSetKeySpecifier),
		fields?: TaxonomyDimensionSetFieldPolicy,
	},
	TaxonomyDomain?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyDomainKeySpecifier | (() => undefined | TaxonomyDomainKeySpecifier),
		fields?: TaxonomyDomainFieldPolicy,
	},
	TaxonomyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyEdgeKeySpecifier | (() => undefined | TaxonomyEdgeKeySpecifier),
		fields?: TaxonomyEdgeFieldPolicy,
	},
	TaxonomyEnumeration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyEnumerationKeySpecifier | (() => undefined | TaxonomyEnumerationKeySpecifier),
		fields?: TaxonomyEnumerationFieldPolicy,
	},
	TaxonomyEnumerationValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyEnumerationValueKeySpecifier | (() => undefined | TaxonomyEnumerationValueKeySpecifier),
		fields?: TaxonomyEnumerationValueFieldPolicy,
	},
	TaxonomyExplicitDimension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyExplicitDimensionKeySpecifier | (() => undefined | TaxonomyExplicitDimensionKeySpecifier),
		fields?: TaxonomyExplicitDimensionFieldPolicy,
	},
	TaxonomyFormat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyFormatKeySpecifier | (() => undefined | TaxonomyFormatKeySpecifier),
		fields?: TaxonomyFormatFieldPolicy,
	},
	TaxonomyMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyMemberKeySpecifier | (() => undefined | TaxonomyMemberKeySpecifier),
		fields?: TaxonomyMemberFieldPolicy,
	},
	TaxonomyReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportKeySpecifier | (() => undefined | TaxonomyReportKeySpecifier),
		fields?: TaxonomyReportFieldPolicy,
	},
	TaxonomyReportAudit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportAuditKeySpecifier | (() => undefined | TaxonomyReportAuditKeySpecifier),
		fields?: TaxonomyReportAuditFieldPolicy,
	},
	TaxonomyReportAuditConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportAuditConnectionKeySpecifier | (() => undefined | TaxonomyReportAuditConnectionKeySpecifier),
		fields?: TaxonomyReportAuditConnectionFieldPolicy,
	},
	TaxonomyReportAuditEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportAuditEdgeKeySpecifier | (() => undefined | TaxonomyReportAuditEdgeKeySpecifier),
		fields?: TaxonomyReportAuditEdgeFieldPolicy,
	},
	TaxonomyReportConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportConnectionKeySpecifier | (() => undefined | TaxonomyReportConnectionKeySpecifier),
		fields?: TaxonomyReportConnectionFieldPolicy,
	},
	TaxonomyReportEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportEdgeKeySpecifier | (() => undefined | TaxonomyReportEdgeKeySpecifier),
		fields?: TaxonomyReportEdgeFieldPolicy,
	},
	TaxonomyReportFact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactKeySpecifier | (() => undefined | TaxonomyReportFactKeySpecifier),
		fields?: TaxonomyReportFactFieldPolicy,
	},
	TaxonomyReportFactConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactConnectionKeySpecifier | (() => undefined | TaxonomyReportFactConnectionKeySpecifier),
		fields?: TaxonomyReportFactConnectionFieldPolicy,
	},
	TaxonomyReportFactEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactEdgeKeySpecifier | (() => undefined | TaxonomyReportFactEdgeKeySpecifier),
		fields?: TaxonomyReportFactEdgeFieldPolicy,
	},
	TaxonomyReportFactLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactLineKeySpecifier | (() => undefined | TaxonomyReportFactLineKeySpecifier),
		fields?: TaxonomyReportFactLineFieldPolicy,
	},
	TaxonomyReportFactPeriodDuration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactPeriodDurationKeySpecifier | (() => undefined | TaxonomyReportFactPeriodDurationKeySpecifier),
		fields?: TaxonomyReportFactPeriodDurationFieldPolicy,
	},
	TaxonomyReportFactScenario?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactScenarioKeySpecifier | (() => undefined | TaxonomyReportFactScenarioKeySpecifier),
		fields?: TaxonomyReportFactScenarioFieldPolicy,
	},
	TaxonomyReportPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportPageKeySpecifier | (() => undefined | TaxonomyReportPageKeySpecifier),
		fields?: TaxonomyReportPageFieldPolicy,
	},
	TaxonomyReportStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportStatisticsKeySpecifier | (() => undefined | TaxonomyReportStatisticsKeySpecifier),
		fields?: TaxonomyReportStatisticsFieldPolicy,
	},
	TaxonomySimpleUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomySimpleUnitKeySpecifier | (() => undefined | TaxonomySimpleUnitKeySpecifier),
		fields?: TaxonomySimpleUnitFieldPolicy,
	},
	TaxonomyTypedDimension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyTypedDimensionKeySpecifier | (() => undefined | TaxonomyTypedDimensionKeySpecifier),
		fields?: TaxonomyTypedDimensionFieldPolicy,
	},
	Template?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateKeySpecifier | (() => undefined | TemplateKeySpecifier),
		fields?: TemplateFieldPolicy,
	},
	TemplateConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateConnectionKeySpecifier | (() => undefined | TemplateConnectionKeySpecifier),
		fields?: TemplateConnectionFieldPolicy,
	},
	TemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateEdgeKeySpecifier | (() => undefined | TemplateEdgeKeySpecifier),
		fields?: TemplateEdgeFieldPolicy,
	},
	TemplateType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateTypeKeySpecifier | (() => undefined | TemplateTypeKeySpecifier),
		fields?: TemplateTypeFieldPolicy,
	},
	TenantAccessRequestResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantAccessRequestResultKeySpecifier | (() => undefined | TenantAccessRequestResultKeySpecifier),
		fields?: TenantAccessRequestResultFieldPolicy,
	},
	TenantBaseDataType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantBaseDataTypeKeySpecifier | (() => undefined | TenantBaseDataTypeKeySpecifier),
		fields?: TenantBaseDataTypeFieldPolicy,
	},
	TenantDomain?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantDomainKeySpecifier | (() => undefined | TenantDomainKeySpecifier),
		fields?: TenantDomainFieldPolicy,
	},
	TenantDomainBackfillClaim?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantDomainBackfillClaimKeySpecifier | (() => undefined | TenantDomainBackfillClaimKeySpecifier),
		fields?: TenantDomainBackfillClaimFieldPolicy,
	},
	TenantDomainBackfillConflict?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantDomainBackfillConflictKeySpecifier | (() => undefined | TenantDomainBackfillConflictKeySpecifier),
		fields?: TenantDomainBackfillConflictFieldPolicy,
	},
	TenantDomainBackfillReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantDomainBackfillReportKeySpecifier | (() => undefined | TenantDomainBackfillReportKeySpecifier),
		fields?: TenantDomainBackfillReportFieldPolicy,
	},
	TenantDomainBackfillTenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantDomainBackfillTenantKeySpecifier | (() => undefined | TenantDomainBackfillTenantKeySpecifier),
		fields?: TenantDomainBackfillTenantFieldPolicy,
	},
	TenantEntitlements?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantEntitlementsKeySpecifier | (() => undefined | TenantEntitlementsKeySpecifier),
		fields?: TenantEntitlementsFieldPolicy,
	},
	TenantModuleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantModuleSettingsKeySpecifier | (() => undefined | TenantModuleSettingsKeySpecifier),
		fields?: TenantModuleSettingsFieldPolicy,
	},
	TenantNonRenewalNotice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantNonRenewalNoticeKeySpecifier | (() => undefined | TenantNonRenewalNoticeKeySpecifier),
		fields?: TenantNonRenewalNoticeFieldPolicy,
	},
	TenantReportingPeriod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantReportingPeriodKeySpecifier | (() => undefined | TenantReportingPeriodKeySpecifier),
		fields?: TenantReportingPeriodFieldPolicy,
	},
	TenantRiskAreaSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantRiskAreaSettingKeySpecifier | (() => undefined | TenantRiskAreaSettingKeySpecifier),
		fields?: TenantRiskAreaSettingFieldPolicy,
	},
	TenantRiskAreaSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantRiskAreaSettingsKeySpecifier | (() => undefined | TenantRiskAreaSettingsKeySpecifier),
		fields?: TenantRiskAreaSettingsFieldPolicy,
	},
	TenantSamlRequestDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantSamlRequestDetailsKeySpecifier | (() => undefined | TenantSamlRequestDetailsKeySpecifier),
		fields?: TenantSamlRequestDetailsFieldPolicy,
	},
	TenantSignupVerifiedData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantSignupVerifiedDataKeySpecifier | (() => undefined | TenantSignupVerifiedDataKeySpecifier),
		fields?: TenantSignupVerifiedDataFieldPolicy,
	},
	TenantSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantSubscriptionKeySpecifier | (() => undefined | TenantSubscriptionKeySpecifier),
		fields?: TenantSubscriptionFieldPolicy,
	},
	TenantSwitchOffPreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantSwitchOffPreviewKeySpecifier | (() => undefined | TenantSwitchOffPreviewKeySpecifier),
		fields?: TenantSwitchOffPreviewFieldPolicy,
	},
	TenantYearDataState?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantYearDataStateKeySpecifier | (() => undefined | TenantYearDataStateKeySpecifier),
		fields?: TenantYearDataStateFieldPolicy,
	},
	TriageScoreSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TriageScoreSettingKeySpecifier | (() => undefined | TriageScoreSettingKeySpecifier),
		fields?: TriageScoreSettingFieldPolicy,
	},
	UnfinishedOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnfinishedOrderKeySpecifier | (() => undefined | UnfinishedOrderKeySpecifier),
		fields?: UnfinishedOrderFieldPolicy,
	},
	Unit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitKeySpecifier | (() => undefined | UnitKeySpecifier),
		fields?: UnitFieldPolicy,
	},
	UnitEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitEdgeKeySpecifier | (() => undefined | UnitEdgeKeySpecifier),
		fields?: UnitEdgeFieldPolicy,
	},
	UnlinkMetricFromAnswerResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnlinkMetricFromAnswerResultKeySpecifier | (() => undefined | UnlinkMetricFromAnswerResultKeySpecifier),
		fields?: UnlinkMetricFromAnswerResultFieldPolicy,
	},
	UnlinkQuestionFromMetricResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnlinkQuestionFromMetricResultKeySpecifier | (() => undefined | UnlinkQuestionFromMetricResultKeySpecifier),
		fields?: UnlinkQuestionFromMetricResultFieldPolicy,
	},
	UnmappedQuestionStandardStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnmappedQuestionStandardStatisticsKeySpecifier | (() => undefined | UnmappedQuestionStandardStatisticsKeySpecifier),
		fields?: UnmappedQuestionStandardStatisticsFieldPolicy,
	},
	UnmappedQuestionStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnmappedQuestionStatisticsKeySpecifier | (() => undefined | UnmappedQuestionStatisticsKeySpecifier),
		fields?: UnmappedQuestionStatisticsFieldPolicy,
	},
	UserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserConnectionKeySpecifier | (() => undefined | UserConnectionKeySpecifier),
		fields?: UserConnectionFieldPolicy,
	},
	UserDisclosureStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDisclosureStatisticsKeySpecifier | (() => undefined | UserDisclosureStatisticsKeySpecifier),
		fields?: UserDisclosureStatisticsFieldPolicy,
	},
	UserRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserRoleKeySpecifier | (() => undefined | UserRoleKeySpecifier),
		fields?: UserRoleFieldPolicy,
	},
	UserSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSettingsKeySpecifier | (() => undefined | UserSettingsKeySpecifier),
		fields?: UserSettingsFieldPolicy,
	},
	UserType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserTypeKeySpecifier | (() => undefined | UserTypeKeySpecifier),
		fields?: UserTypeFieldPolicy,
	},
	UserTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserTypeConnectionKeySpecifier | (() => undefined | UserTypeConnectionKeySpecifier),
		fields?: UserTypeConnectionFieldPolicy,
	},
	UserTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserTypeEdgeKeySpecifier | (() => undefined | UserTypeEdgeKeySpecifier),
		fields?: UserTypeEdgeFieldPolicy,
	},
	V2CaseExclusionOwnerEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2CaseExclusionOwnerEdgeKeySpecifier | (() => undefined | V2CaseExclusionOwnerEdgeKeySpecifier),
		fields?: V2CaseExclusionOwnerEdgeFieldPolicy,
	},
	V2DisclosureEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2DisclosureEdgeKeySpecifier | (() => undefined | V2DisclosureEdgeKeySpecifier),
		fields?: V2DisclosureEdgeFieldPolicy,
	},
	V2DisclosureResponseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2DisclosureResponseEdgeKeySpecifier | (() => undefined | V2DisclosureResponseEdgeKeySpecifier),
		fields?: V2DisclosureResponseEdgeFieldPolicy,
	},
	V2SurveyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2SurveyEdgeKeySpecifier | (() => undefined | V2SurveyEdgeKeySpecifier),
		fields?: V2SurveyEdgeFieldPolicy,
	},
	ValidationIssueObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidationIssueObjectKeySpecifier | (() => undefined | ValidationIssueObjectKeySpecifier),
		fields?: ValidationIssueObjectFieldPolicy,
	},
	VerifyCheckoutSessionWithHubProofPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VerifyCheckoutSessionWithHubProofPayloadKeySpecifier | (() => undefined | VerifyCheckoutSessionWithHubProofPayloadKeySpecifier),
		fields?: VerifyCheckoutSessionWithHubProofPayloadFieldPolicy,
	},
	Webflow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowKeySpecifier | (() => undefined | WebflowKeySpecifier),
		fields?: WebflowFieldPolicy,
	},
	WebflowPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowPostKeySpecifier | (() => undefined | WebflowPostKeySpecifier),
		fields?: WebflowPostFieldPolicy,
	},
	WebflowPostConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowPostConnectionKeySpecifier | (() => undefined | WebflowPostConnectionKeySpecifier),
		fields?: WebflowPostConnectionFieldPolicy,
	},
	WebflowPostEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowPostEdgeKeySpecifier | (() => undefined | WebflowPostEdgeKeySpecifier),
		fields?: WebflowPostEdgeFieldPolicy,
	},
	WhistleblowerCaseReportPdfResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WhistleblowerCaseReportPdfResponseKeySpecifier | (() => undefined | WhistleblowerCaseReportPdfResponseKeySpecifier),
		fields?: WhistleblowerCaseReportPdfResponseFieldPolicy,
	},
	Year?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YearKeySpecifier | (() => undefined | YearKeySpecifier),
		fields?: YearFieldPolicy,
	},
	YearConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YearConnectionKeySpecifier | (() => undefined | YearConnectionKeySpecifier),
		fields?: YearConnectionFieldPolicy,
	},
	YearEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YearEdgeKeySpecifier | (() => undefined | YearEdgeKeySpecifier),
		fields?: YearEdgeFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;